
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("icqFF", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");

const $ae3c6a4bb713dccb$export$ef7af5d8bc5d5ac1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    registerKeyboardEnabled: undefined,
    unregisterKeyboardEnabled: undefined,
    getSelectedIndex: undefined,
    highlightComponentAt: undefined,
    unhighlightComponentAt: undefined,
    unhighlightAll: undefined,
    keyboardNavComponents: []
});
const $ae3c6a4bb713dccb$export$4da28cf324280418 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (options)=>{
    const $ = (0, $frIzR.c)(19);
    const [ref, setRef] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(null);
    const registrationId = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    const navigationTrackingId = options?.navigationTrackingId ?? null;
    const { registerKeyboardEnabled: registerKeyboardEnabled, unregisterKeyboardEnabled: unregisterKeyboardEnabled } = (0, $42omo.useContext)($ae3c6a4bb713dccb$export$ef7af5d8bc5d5ac1) ?? {};
    const [isHighlighted, setIsHighlighted] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    const onKeydownCallback = options?.onKeydownCallback;
    const onHighlightedCallback = options?.onHighlightedCallback;
    let t0;
    if ($[0] !== unregisterKeyboardEnabled) {
        t0 = ()=>{
            if (registrationId.current && unregisterKeyboardEnabled) unregisterKeyboardEnabled(registrationId.current);
        };
        $[0] = unregisterKeyboardEnabled;
        $[1] = t0;
    } else t0 = $[1];
    const unregister = t0;
    let t1;
    let t2;
    if ($[2] !== unregister) {
        t1 = ()=>()=>unregister();
        t2 = [
            unregister
        ];
        $[2] = unregister;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    let t4;
    if ($[5] !== ref || $[6] !== unregister) {
        t3 = ()=>{
            !ref && unregister();
        };
        t4 = [
            ref,
            unregister
        ];
        $[5] = ref;
        $[6] = unregister;
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    let t6;
    if ($[9] !== navigationTrackingId || $[10] !== onHighlightedCallback || $[11] !== onKeydownCallback || $[12] !== ref || $[13] !== registerKeyboardEnabled || $[14] !== unregisterKeyboardEnabled) {
        t5 = ()=>{
            if (!registerKeyboardEnabled || !unregisterKeyboardEnabled) return;
            if (!ref) return;
            if (ref) {
                if (!ref.compareDocumentPosition || !ref.addEventListener || !ref.removeEventListener) {
                    console.error("It is expected that any keyboard highlighting enabled component also passes the ref all the way to the DOM node.", "It appears that the `ref` is not fowarded all the way to the DOM node, please use `React.forwardRef to ensure this is so`", "Falling back to using ReactDOM.findDOMNode, this is not recommended and this fallback may be removed in the future");
                    return;
                }
                registrationId.current = registerKeyboardEnabled(registrationId.current, ref, setIsHighlighted, onKeydownCallback, navigationTrackingId, onHighlightedCallback);
            }
        };
        t6 = [
            ref,
            setIsHighlighted,
            onKeydownCallback,
            registerKeyboardEnabled,
            unregisterKeyboardEnabled,
            navigationTrackingId,
            onHighlightedCallback
        ];
        $[9] = navigationTrackingId;
        $[10] = onHighlightedCallback;
        $[11] = onKeydownCallback;
        $[12] = ref;
        $[13] = registerKeyboardEnabled;
        $[14] = unregisterKeyboardEnabled;
        $[15] = t5;
        $[16] = t6;
    } else {
        t5 = $[15];
        t6 = $[16];
    }
    (0, $42omo.useEffect)(t5, t6);
    let t7;
    if ($[17] !== isHighlighted) {
        t7 = [
            isHighlighted,
            setRef
        ];
        $[17] = isHighlighted;
        $[18] = t7;
    } else t7 = $[18];
    return t7;
} : (options)=>{
    const [ref, setRef] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(null);
    const registrationId = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    const navigationTrackingId = options?.navigationTrackingId ?? null;
    const { registerKeyboardEnabled: registerKeyboardEnabled, unregisterKeyboardEnabled: unregisterKeyboardEnabled } = (0, $42omo.useContext)($ae3c6a4bb713dccb$export$ef7af5d8bc5d5ac1) ?? {};
    const [isHighlighted, setIsHighlighted] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    const onKeydownCallback = options?.onKeydownCallback;
    const onHighlightedCallback = options?.onHighlightedCallback;
    const unregister = (0, $42omo.useCallback)(()=>{
        if (registrationId.current && unregisterKeyboardEnabled) // If the ref got removed or changed we unregister the current ref
        unregisterKeyboardEnabled(registrationId.current);
    }, [
        unregisterKeyboardEnabled
    ]);
    // Will unmount effect
    (0, $42omo.useEffect)(()=>()=>unregister(), [
        unregister
    ]);
    // Ref change to null
    (0, $42omo.useEffect)(()=>{
        !ref && unregister();
    }, [
        ref,
        unregister
    ]);
    // Everything else
    (0, $42omo.useEffect)(()=>{
        if (!registerKeyboardEnabled || !unregisterKeyboardEnabled) return;
        if (!ref) return;
        // Then we register the new ref
        if (ref) {
            // Another check here to ensure that the ref we get is actually a DOM node, there's probably better
            // ways to make this check but it doesn't matter too much.
            // If what we get is NOT a DOM node we will log a warning and default back to use React.findDOMNode
            if (!ref.compareDocumentPosition || !ref.addEventListener || !ref.removeEventListener) {
                // eslint-disable-next-line
                console.error('It is expected that any keyboard highlighting enabled component also passes the ref all the way to the DOM node.', 'It appears that the `ref` is not fowarded all the way to the DOM node, please use `React.forwardRef to ensure this is so`', 'Falling back to using ReactDOM.findDOMNode, this is not recommended and this fallback may be removed in the future');
                return;
            }
            registrationId.current = registerKeyboardEnabled(registrationId.current, ref, setIsHighlighted, onKeydownCallback, navigationTrackingId, onHighlightedCallback);
        }
    }, [
        ref,
        setIsHighlighted,
        onKeydownCallback,
        registerKeyboardEnabled,
        unregisterKeyboardEnabled,
        navigationTrackingId,
        onHighlightedCallback
    ]);
    return [
        isHighlighted,
        setRef
    ];
};
/**
 * Legacy class implementation. Retained behind the
 * `search_refactor_keyboard_highlight_provider` feature gate while the
 * function-component replacement is rolled out. The exported
 * {@link KeyboardHighlightProvider} switches between the two.
 */ class $ae3c6a4bb713dccb$var$KeyboardHighlightProviderClass extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidMount() {
        this.attach(this.props.listenerNode);
    }
    componentDidUpdate(prevProps) {
        if (prevProps.listenerNode !== this.props.listenerNode) {
            this.detach(prevProps.listenerNode);
            this.attach(this.props.listenerNode);
        }
    }
    componentWillUnmount() {
        this.detach(this.props.listenerNode);
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ae3c6a4bb713dccb$export$ef7af5d8bc5d5ac1.Provider, {
            value: {
                registerKeyboardEnabled: this.registerKeyboardEnabled,
                unregisterKeyboardEnabled: this.unregisterKeyboardEnabled,
                getSelectedIndex: this.getSelectedIndex,
                highlightComponentAt: this.highlightComponentAt,
                unhighlightComponentAt: this.unhighlightComponentAt,
                unhighlightAll: this.unhighlightAll,
                keyboardNavComponents: this.keyboardNavComponents
            }
        }, this.props.children);
    }
    constructor(...args){
        super(...args);
        this.currentlySelected = undefined;
        this.currentSelectedTrackingId = null;
        this.keyboardNavComponents = [];
        this.registerKeyboardEnabled = (currentId, domRef, onHighlightChanged, onKeyDownWhenHighlighted, navigationTrackingId, onHighlightedCallback)=>{
            const indexAt = this.keyboardNavComponents.findIndex(({ id: id })=>id === currentId);
            // If the currentId is null or we can't find any records of the id we will create a new entry
            const isNew = currentId === null || currentId === undefined || indexAt === -1;
            const id = isNew ? Math.max(...this.keyboardNavComponents.map((component)=>component.id), 0) + 1 : this.keyboardNavComponents[indexAt].id;
            if (isNew) this.keyboardNavComponents.push({
                id: id,
                domRef: domRef,
                onHighlightChanged: onHighlightChanged,
                onKeyDownWhenHighlighted: onKeyDownWhenHighlighted,
                navigationTrackingId: navigationTrackingId,
                onHighlightedCallback: onHighlightedCallback
            });
            else // Otherwise we will update the current entry
            this.keyboardNavComponents[indexAt] = {
                id: id,
                domRef: domRef,
                onHighlightChanged: onHighlightChanged,
                onKeyDownWhenHighlighted: onKeyDownWhenHighlighted,
                navigationTrackingId: navigationTrackingId,
                onHighlightedCallback: onHighlightedCallback
            };
            this.keyboardNavComponents = this.keyboardNavComponents.sort((c1, c2)=>{
                const result = c1.domRef.compareDocumentPosition(c2.domRef);
                if (result & Node.DOCUMENT_POSITION_FOLLOWING || result & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
                else if (result & Node.DOCUMENT_POSITION_PRECEDING || result & Node.DOCUMENT_POSITION_CONTAINS) return 1;
                return 0;
            });
            const indexToHighlight = this.getSearchIdIndex(this.currentSelectedTrackingId);
            if (indexToHighlight !== undefined && indexToHighlight >= 0) {
                this.unhighlightAll();
                this.highlightComponentAt(indexToHighlight);
            }
            return id;
        };
        this.unregisterKeyboardEnabled = (unregisterRef)=>{
            if (this.currentlySelected === unregisterRef) this.currentlySelected = undefined;
            this.keyboardNavComponents = this.keyboardNavComponents.filter(({ id: ref })=>ref !== unregisterRef);
            // Reset currentSelectedTrackingId when all components are unregistered
            if (this.keyboardNavComponents.length === 0) this.currentSelectedTrackingId = null;
        };
        this.onKeyDownCallbackAt = (index, e)=>{
            if (typeof index !== 'undefined' && index >= 0 && index < this.keyboardNavComponents.length) {
                const onKeyDown = this.keyboardNavComponents[index].onKeyDownWhenHighlighted;
                onKeyDown && onKeyDown(e, this.keyboardNavComponents[index].domRef);
            }
        };
        this.onHighlightedCallback = (index)=>{
            if (typeof index !== 'undefined' && index >= 0 && index < this.keyboardNavComponents.length) {
                const callback = this.keyboardNavComponents[index].onHighlightedCallback;
                callback && callback(index);
            }
        };
        this.unhighlightComponentAt = (index)=>{
            if (typeof index !== 'undefined' && index >= 0 && index < this.keyboardNavComponents.length) this.keyboardNavComponents[index].onHighlightChanged(false);
        };
        this.highlightComponentAt = (index)=>{
            if (index >= 0 && index < this.keyboardNavComponents.length) {
                const { id: id, navigationTrackingId: navigationTrackingId } = this.keyboardNavComponents[index];
                this.currentlySelected = id;
                this.currentSelectedTrackingId = navigationTrackingId;
                this.keyboardNavComponents[index].onHighlightChanged(true);
            }
        };
        this.unhighlightAll = ()=>{
            this.currentSelectedTrackingId = null;
            this.currentlySelected = undefined;
            this.keyboardNavComponents.forEach((component)=>component.onHighlightChanged(false));
        };
        this.getSelectedIndex = ()=>{
            if (!this.currentlySelected) return undefined;
            return this.keyboardNavComponents.findIndex(({ id: id })=>id === this.currentlySelected);
        };
        this.getSearchIdIndex = (searchId)=>searchId === null ? undefined : this.keyboardNavComponents.findIndex(({ navigationTrackingId: navigationTrackingId })=>navigationTrackingId === searchId);
        this.onKeyDown = (e)=>{
            if (this.keyboardNavComponents.length === 0) return;
            if (e.isComposing || e.keyCode === 229) return;
            let currentIndex = this.getSelectedIndex();
            const prevIndex = currentIndex;
            if (e.code === 'ArrowDown' || e.keyCode === 40) {
                if (!e.shiftKey) {
                    if (typeof currentIndex === 'undefined') currentIndex = 0;
                    else currentIndex = (currentIndex + 1) % this.keyboardNavComponents.length;
                    e.preventDefault();
                }
            } else if (e.code === 'ArrowUp' || e.keyCode === 38) {
                if (!e.shiftKey) {
                    if (typeof currentIndex === 'undefined') currentIndex = this.keyboardNavComponents.length - 1;
                    else {
                        currentIndex -= 1;
                        if (currentIndex < 0) currentIndex = this.keyboardNavComponents.length - Math.abs(currentIndex);
                    }
                    e.preventDefault();
                }
            } else {
                if (typeof currentIndex !== 'undefined') this.onKeyDownCallbackAt(currentIndex, e);
                return;
            }
            if (prevIndex !== currentIndex && currentIndex !== undefined) {
                this.unhighlightComponentAt(prevIndex);
                this.highlightComponentAt(currentIndex);
                this.onHighlightedCallback(currentIndex);
            }
        };
        this.attach = (listenerNode)=>{
            if (listenerNode) listenerNode.addEventListener('keydown', this.onKeyDown);
        };
        this.detach = (listenerNode)=>{
            if (listenerNode) listenerNode.removeEventListener('keydown', this.onKeyDown);
        };
    }
}
/**
 * Function-component implementation of `KeyboardHighlightProvider`.
 */ const $ae3c6a4bb713dccb$var$KeyboardHighlightProviderFn = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ children: children, listenerNode: listenerNode }, ref)=>{
    const currentlySelectedRef = (0, $42omo.useRef)(undefined);
    const currentSelectedTrackingIdRef = (0, $42omo.useRef)(null);
    const keyboardNavComponentsRef = (0, $42omo.useRef)([]);
    const getSelectedIndex = (0, $42omo.useCallback)(()=>{
        const currentlySelected = currentlySelectedRef.current;
        if (!currentlySelected) return undefined;
        return keyboardNavComponentsRef.current.findIndex(({ id: id })=>id === currentlySelected);
    }, []);
    const getSearchIdIndex = (0, $42omo.useCallback)((searchId)=>searchId === null ? undefined : keyboardNavComponentsRef.current.findIndex(({ navigationTrackingId: navigationTrackingId })=>navigationTrackingId === searchId), []);
    const unhighlightComponentAt = (0, $42omo.useCallback)((index)=>{
        const components = keyboardNavComponentsRef.current;
        if (typeof index !== 'undefined' && index >= 0 && index < components.length) components[index].onHighlightChanged(false);
    }, []);
    const highlightComponentAt = (0, $42omo.useCallback)((index_0)=>{
        const components_0 = keyboardNavComponentsRef.current;
        if (index_0 >= 0 && index_0 < components_0.length) {
            const { id: id_0, navigationTrackingId: navigationTrackingId_0 } = components_0[index_0];
            currentlySelectedRef.current = id_0;
            currentSelectedTrackingIdRef.current = navigationTrackingId_0;
            components_0[index_0].onHighlightChanged(true);
        }
    }, []);
    const unhighlightAll = (0, $42omo.useCallback)(()=>{
        currentSelectedTrackingIdRef.current = null;
        currentlySelectedRef.current = undefined;
        keyboardNavComponentsRef.current.forEach((component)=>component.onHighlightChanged(false));
    }, []);
    const onHighlightedCallback = (0, $42omo.useCallback)((index_1)=>{
        const components_1 = keyboardNavComponentsRef.current;
        if (typeof index_1 !== 'undefined' && index_1 >= 0 && index_1 < components_1.length) {
            const callback = components_1[index_1].onHighlightedCallback;
            callback && callback(index_1);
        }
    }, []);
    const onKeyDownCallbackAt = (0, $42omo.useCallback)((index_2, e)=>{
        const components_2 = keyboardNavComponentsRef.current;
        if (typeof index_2 !== 'undefined' && index_2 >= 0 && index_2 < components_2.length) {
            const onKeyDown = components_2[index_2].onKeyDownWhenHighlighted;
            onKeyDown && onKeyDown(e, components_2[index_2].domRef);
        }
    }, []);
    const registerKeyboardEnabled = (0, $42omo.useCallback)((currentId, domRef, onHighlightChanged, onKeyDownWhenHighlighted, navigationTrackingId_1, onHighlightedCb)=>{
        const components_3 = keyboardNavComponentsRef.current;
        const indexAt = components_3.findIndex(({ id: id_1 })=>id_1 === currentId);
        // If the currentId is null or we can't find any records of the id we will create a new entry
        const isNew = currentId === null || currentId === undefined || indexAt === -1;
        const id_2 = isNew ? Math.max(...components_3.map((component_0)=>component_0.id), 0) + 1 : components_3[indexAt].id;
        if (isNew) components_3.push({
            id: id_2,
            domRef: domRef,
            onHighlightChanged: onHighlightChanged,
            onKeyDownWhenHighlighted: onKeyDownWhenHighlighted,
            navigationTrackingId: navigationTrackingId_1,
            onHighlightedCallback: onHighlightedCb
        });
        else // Otherwise we will update the current entry
        components_3[indexAt] = {
            id: id_2,
            domRef: domRef,
            onHighlightChanged: onHighlightChanged,
            onKeyDownWhenHighlighted: onKeyDownWhenHighlighted,
            navigationTrackingId: navigationTrackingId_1,
            onHighlightedCallback: onHighlightedCb
        };
        keyboardNavComponentsRef.current = components_3.sort((c1, c2)=>{
            const result = c1.domRef.compareDocumentPosition(c2.domRef);
            if (result & Node.DOCUMENT_POSITION_FOLLOWING || result & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
            else if (result & Node.DOCUMENT_POSITION_PRECEDING || result & Node.DOCUMENT_POSITION_CONTAINS) return 1;
            return 0;
        });
        const indexToHighlight = getSearchIdIndex(currentSelectedTrackingIdRef.current);
        if (indexToHighlight !== undefined && indexToHighlight >= 0) {
            unhighlightAll();
            highlightComponentAt(indexToHighlight);
        }
        return id_2;
    }, [
        getSearchIdIndex,
        highlightComponentAt,
        unhighlightAll
    ]);
    const unregisterKeyboardEnabled = (0, $42omo.useCallback)((unregisterRef)=>{
        if (currentlySelectedRef.current === unregisterRef) currentlySelectedRef.current = undefined;
        keyboardNavComponentsRef.current = keyboardNavComponentsRef.current.filter(({ id: ref_0 })=>ref_0 !== unregisterRef);
        // Reset currentSelectedTrackingId when all components are unregistered
        if (keyboardNavComponentsRef.current.length === 0) currentSelectedTrackingIdRef.current = null;
    }, []);
    const onKeyDown_0 = (0, $42omo.useCallback)((e_0)=>{
        const components_4 = keyboardNavComponentsRef.current;
        if (components_4.length === 0) return;
        if (e_0.isComposing || e_0.keyCode === 229) return;
        let currentIndex = getSelectedIndex();
        const prevIndex = currentIndex;
        if (e_0.code === 'ArrowDown' || e_0.keyCode === 40) {
            if (!e_0.shiftKey) {
                if (typeof currentIndex === 'undefined') currentIndex = 0;
                else currentIndex = (currentIndex + 1) % components_4.length;
                e_0.preventDefault();
            }
        } else if (e_0.code === 'ArrowUp' || e_0.keyCode === 38) {
            if (!e_0.shiftKey) {
                if (typeof currentIndex === 'undefined') currentIndex = components_4.length - 1;
                else {
                    currentIndex -= 1;
                    if (currentIndex < 0) currentIndex = components_4.length - Math.abs(currentIndex);
                }
                e_0.preventDefault();
            }
        } else {
            if (typeof currentIndex !== 'undefined') onKeyDownCallbackAt(currentIndex, e_0);
            return;
        }
        if (prevIndex !== currentIndex && currentIndex !== undefined) {
            unhighlightComponentAt(prevIndex);
            highlightComponentAt(currentIndex);
            onHighlightedCallback(currentIndex);
        }
    }, [
        getSelectedIndex,
        onKeyDownCallbackAt,
        unhighlightComponentAt,
        highlightComponentAt,
        onHighlightedCallback
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!listenerNode) return;
        listenerNode.addEventListener('keydown', onKeyDown_0);
        return ()=>{
            listenerNode.removeEventListener('keydown', onKeyDown_0);
        };
    }, [
        listenerNode,
        onKeyDown_0
    ]);
    const contextValue = (0, $42omo.useMemo)(()=>({
            registerKeyboardEnabled: registerKeyboardEnabled,
            unregisterKeyboardEnabled: unregisterKeyboardEnabled,
            getSelectedIndex: getSelectedIndex,
            highlightComponentAt: highlightComponentAt,
            unhighlightComponentAt: unhighlightComponentAt,
            unhighlightAll: unhighlightAll,
            get keyboardNavComponents () {
                // Always read the latest registry from the ref so consumers that
                // destructure `keyboardNavComponents` from the context still see
                // up-to-date data without forcing a re-render of the provider.
                return keyboardNavComponentsRef.current;
            }
        }), [
        registerKeyboardEnabled,
        unregisterKeyboardEnabled,
        getSelectedIndex,
        highlightComponentAt,
        unhighlightComponentAt,
        unhighlightAll
    ]);
    (0, $42omo.useImperativeHandle)(ref, ()=>({
            highlightComponentAt: highlightComponentAt,
            unhighlightComponentAt: unhighlightComponentAt,
            unhighlightAll: unhighlightAll,
            getSelectedIndex: getSelectedIndex
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ae3c6a4bb713dccb$export$ef7af5d8bc5d5ac1.Provider, {
        value: contextValue
    }, children);
});
const $ae3c6a4bb713dccb$export$c8551b32665b42b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((0, $4pOgL.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $frIzR.c)(5);
    if ((0, $dh538.fg)("search_refactor_keyboard_highlight_provider")) {
        let t0;
        if ($[0] !== props || $[1] !== ref) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ae3c6a4bb713dccb$var$KeyboardHighlightProviderFn, {
                ...props,
                ref: ref
            });
            $[0] = props;
            $[1] = ref;
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    }
    let t0;
    if ($[3] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ae3c6a4bb713dccb$var$KeyboardHighlightProviderClass, props);
        $[3] = props;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
} : (props, ref)=>{
    if ((0, $dh538.fg)('search_refactor_keyboard_highlight_provider')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ae3c6a4bb713dccb$var$KeyboardHighlightProviderFn, {
        ...props,
        ref: ref
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ae3c6a4bb713dccb$var$KeyboardHighlightProviderClass, props);
});
const $ae3c6a4bb713dccb$export$cbeda0f7f7a8026c = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $42omo.useContext)($ae3c6a4bb713dccb$export$ef7af5d8bc5d5ac1);
} : ()=>{
    return (0, $42omo.useContext)($ae3c6a4bb713dccb$export$ef7af5d8bc5d5ac1);
};
module.exports["useKeyboardNavigation"] = $ae3c6a4bb713dccb$export$4da28cf324280418;
module.exports["KeyboardHighlightProvider"] = $ae3c6a4bb713dccb$export$c8551b32665b42b;
module.exports["useKeyboardHighlightProvider"] = $ae3c6a4bb713dccb$export$cbeda0f7f7a8026c;

});

parcelRegister("1yEFx", function(module, exports) {
$parcel$export(module.exports, "ProductKeys", () => (parcelRequire("b4tvS")).ProductKeys);
$parcel$export(module.exports, "all3pProductKeys", () => (parcelRequire("b4tvS")).all3pProductKeys);

var $42omo = parcelRequire("42omo");


var $lAFHW = parcelRequire("lAFHW");

var $4Nwes = parcelRequire("4Nwes");


var $a5RR2 = parcelRequire("a5RR2");


var $9yyKc = parcelRequire("9yyKc");




const $d52b37ba90dc95d4$export$24d355ce80de5803 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        height: "100%",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "var(--tile-color,#ffc716)",
        d: "M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "var(--icon-color, #101214)",
        fillRule: "evenodd",
        d: "M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "var(--icon-color, #101214)",
        d: "M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z"
    }));





const $a167bd50b2e4c9cb$export$b0a52366c3fb9b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_2230_18710)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip1_2230_18710)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip2_2230_18710)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M34.4312 30.4727L21.2001 4.01056C20.9397 3.43756 20.6792 3.33337 20.3667 3.33337C20.1062 3.33337 19.7937 3.43756 19.4811 3.95846C17.6058 6.92764 16.7724 10.3656 16.7724 13.9599C16.7724 18.9606 19.3248 23.6488 23.0754 31.202C23.4921 32.0354 23.8047 32.1917 24.5339 32.1917H33.7019C34.3791 32.1917 34.7437 31.9313 34.7437 31.4103C34.7437 31.1499 34.6916 30.9936 34.4312 30.4727ZM15.2097 17.9709C14.1679 16.4082 13.8553 16.304 13.5949 16.304C13.3344 16.304 13.1781 16.4082 12.7093 17.3458L6.09377 30.5769C5.8854 30.9936 5.83331 31.1499 5.83331 31.3583C5.83331 31.775 6.19795 32.1917 6.97931 32.1917H16.3036C16.9287 32.1917 17.3975 31.6708 17.6579 30.6811C17.9705 29.4309 18.0747 28.337 18.0747 27.0347C18.0747 23.3884 16.4598 19.8462 15.2097 17.9709Z",
        fill: "#1868DB"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_2230_18710"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip1_2230_18710"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip2_2230_18710"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "28.9104",
        height: "28.8583",
        fill: "white",
        transform: "translate(5.83331 3.33337)"
    }))));





const $e108be1bca7d778f$export$4b1b9db11d699ccb = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_2230_18698)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip1_2230_18698)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M19.5833 19.3159V26.7434H12.1417V19.3159H19.5833V11.8934H6.00833C5.28333 11.8984 4.7 12.4801 4.705 13.1934C4.705 13.1993 4.705 13.2051 4.705 13.2109V32.8876C4.69 33.6009 5.26583 34.1901 5.99 34.2051C5.99583 34.2051 6.0025 34.2051 6.00833 34.2051H25.7033C26.4283 34.2001 27.0117 33.6184 27.0067 32.9051C27.0067 32.8993 27.0067 32.8934 27.0067 32.8876V19.3159H19.5833Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M19.5833 4.46666V11.8933H27.0425V19.3158H34.4616V5.76666C34.4766 5.05332 33.9008 4.46416 33.1766 4.44916C33.1708 4.44916 33.1641 4.44916 33.1583 4.44916L19.5833 4.46666Z",
        fill: "#1868DB"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_2230_18698"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip1_2230_18698"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    }))));





const $25d6378a84ef5509$export$93ca83db1787dea = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_2230_18702)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip1_2230_18702)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip2_2230_18702)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M32.2106 25.0334C23.981 21.0541 21.5768 20.4595 18.1093 20.4595C14.0407 20.4595 10.5731 22.1519 7.47546 26.9087L6.96689 27.6863C6.55078 28.3267 6.45831 28.5553 6.45831 28.8298C6.45831 29.1042 6.59701 29.3329 7.10559 29.6531L12.33 32.9006C12.6074 33.0835 12.8386 33.175 13.0698 33.175C13.3472 33.175 13.5321 33.0378 13.8095 32.6261L14.6417 31.3454C15.9363 29.3787 17.0921 28.7383 18.5716 28.7383C19.8662 28.7383 21.3919 29.1042 23.2875 30.019L28.7431 32.5804C29.2979 32.8548 29.8989 32.7176 30.1763 32.0773L32.7654 26.4056C33.0428 25.7653 32.8579 25.3536 32.2106 25.0334ZM8.2152 15.0166C16.4448 18.9959 18.849 19.5905 22.3166 19.5905C26.3851 19.5905 29.8527 17.8981 32.9504 13.1413L33.4589 12.3637C33.875 11.7233 33.9675 11.4947 33.9675 11.2202C33.9675 10.9458 33.8288 10.7171 33.3202 10.3969L28.0958 7.14943C27.8184 6.96648 27.5872 6.875 27.3561 6.875C27.0787 6.875 26.8937 7.01222 26.6163 7.42387L25.7841 8.70457C24.4896 10.6713 23.3337 11.3117 21.8542 11.3117C20.5597 11.3117 19.0339 10.9458 17.1384 10.031L11.6827 7.46961C11.1279 7.19517 10.5269 7.33239 10.2495 7.97274L7.6604 13.6444C7.38299 14.2847 7.56793 14.6964 8.2152 15.0166Z",
        fill: "#1868DB"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_2230_18702"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip1_2230_18702"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip2_2230_18702"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "27.5092",
        height: "26.3",
        fill: "white",
        transform: "translate(6.45831 6.875)"
    }))));





const $506871dc04f0c8db$export$4d0238652f4b6bc4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_2230_18694)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip1_2230_18694)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M37.8564 20.4181C34.509 17.0708 29.0684 17.1063 25.7566 20.4181L22.9696 23.2051C21.4309 24.7439 18.9314 24.7439 17.3927 23.2051L15.0771 20.8895L9.02573 26.9409L11.3413 29.2565C16.2215 34.1367 24.1378 34.1367 29.018 29.2565L37.8564 20.4181ZM2.5 19.5848C5.84737 22.9322 11.2198 22.9648 14.5671 19.6174L17.3897 16.7948C18.9285 15.256 21.4279 15.256 22.9667 16.7948L25.2823 19.1104L31.3336 13.0591L29.018 10.7435C24.1378 5.86326 16.2215 5.86326 11.3413 10.7435L2.50296 19.5818L2.5 19.5848Z",
        fill: "#1868DB"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_2230_18694"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip1_2230_18694"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    }))));





const $b412ffda38aeedd7$export$1afe31d4b2891d7a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_2230_18700)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip1_2230_18700)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip2_2230_18700)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M22.0686 7.09728C25.7026 8.16332 29.3723 8.16332 33.0063 7.09728C33.3269 7.02621 33.5407 7.23942 33.4694 7.55923C32.4362 11.2904 32.4362 14.7372 33.4694 18.4683C33.5407 18.7526 33.3269 19.0014 33.0063 18.8948C29.3723 17.8998 25.7026 17.8998 22.0686 18.8948C21.7836 19.0014 21.5342 18.7526 21.6411 18.4683C22.603 14.7372 22.603 11.2904 21.6411 7.55923C21.5342 7.23942 21.7836 7.02621 22.0686 7.09728ZM23.5294 20.3161V20.9202C23.5294 23.7275 21.5698 25.7885 19.1472 25.7885C16.7245 25.7885 14.8006 23.8341 14.8006 21.4177C14.8006 19.0014 16.7601 17.0825 19.5034 17.0825H20.216V8.58973C19.8597 8.5542 19.5034 8.5542 19.1472 8.5542C12.0217 8.5542 6.25 14.3108 6.25 21.4532C6.25 28.5957 12.0217 34.3168 19.1472 34.3168C26.2727 34.3168 32.08 28.5602 32.08 21.4532V20.3161H23.5294Z",
        fill: "#1868DB"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_2230_18700"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip1_2230_18700"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip2_2230_18700"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "27.2333",
        height: "27.2333",
        fill: "white",
        transform: "translate(6.25 7.08334)"
    }))));





const $8beafb504c666551$export$f68d29dbb4f2da82 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_2230_18716)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip1_2230_18716)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip2_2230_18716)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M13.7923 27.2286H11.0183C6.83464 27.2286 3.83331 24.666 3.83331 20.9137H18.749C19.5221 20.9137 20.0223 21.4628 20.0223 22.2407V37.25C16.2934 37.25 13.7923 34.2299 13.7923 30.0199V27.2286ZM21.1592 19.7697H18.3852C14.2015 19.7697 11.2002 17.2529 11.2002 13.5006H26.1159C26.889 13.5006 27.4347 14.0039 27.4347 14.7819V29.7911C23.7058 29.7911 21.1592 26.771 21.1592 22.5611V19.7697ZM28.5715 12.3566H25.7976C21.6139 12.3566 18.6126 9.79401 18.6126 6.04169H33.5283C34.3014 6.04169 34.8016 6.59081 34.8016 7.32297V22.3323C31.0727 22.3323 28.5715 19.3121 28.5715 15.1022V12.3566Z",
        fill: "#1868DB"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_2230_18716"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip1_2230_18716"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip2_2230_18716"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "30.9683",
        height: "31.2083",
        fill: "white",
        transform: "translate(3.83331 6.04169)"
    }))));





const $dfcfcba5660e06b1$export$ceeb1de9ca56c2f7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_2230_18708)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip1_2230_18708)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip2_2230_18708)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M23.4886 16.3121H32.6441C34.0191 16.3121 34.4886 17.62 33.6502 18.6596L19.3301 36.3334C14.702 32.6444 15.138 26.809 18.5252 22.5499L23.4886 16.3121ZM16.4124 23.3547H7.2569C5.8819 23.3547 5.41238 22.0468 6.2508 21.0072L20.5709 3.3334C25.199 7.02243 24.6959 12.7907 21.3423 17.0834L16.4124 23.3547Z",
        fill: "#0C66E4"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_2230_18708"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip1_2230_18708"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip2_2230_18708"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "28.2341",
        height: "33",
        fill: "white",
        transform: "translate(5.83331 3.33334)"
    }))));



var $brMqq = parcelRequire("brMqq");




const $c190735ed0251a79$export$7221b4e3b691d1b3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_2230_18718)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip1_2230_18718)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M30.3575 6.41167H9.64252C7.85835 6.41167 6.41168 7.85833 6.41168 9.6425V30.3575C6.41168 32.1417 7.85835 33.5883 9.64252 33.5883H30.3575C32.1417 33.5883 33.5884 32.1417 33.5884 30.3575V9.6425C33.5884 7.85833 32.1417 6.41167 30.3575 6.41167ZM18.1184 25.9858C18.1184 26.5792 17.6375 27.0592 17.045 27.0592H12.5025C11.9092 27.0592 11.4292 26.5783 11.4292 25.9858V12.5025C11.4292 11.9092 11.91 11.4292 12.5025 11.4292H17.045C17.6383 11.4292 18.1184 11.91 18.1184 12.5025V25.9858ZM28.5709 19.7958C28.5709 20.3892 28.09 20.8692 27.4975 20.8692H22.955C22.3617 20.8692 21.8817 20.3883 21.8817 19.7958V12.5025C21.8817 11.9092 22.3625 11.4292 22.955 11.4292H27.4975C28.0909 11.4292 28.5709 11.91 28.5709 12.5025V19.7958Z",
        fill: "#1868DB"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_2230_18718"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip1_2230_18718"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    }))));



var $6Gsan = parcelRequire("6Gsan");


var $b4tvS = parcelRequire("b4tvS");



const $2acca743010e8c82$export$2e51523f0c1b4542 = {
    [(0, $b4tvS.ProductKeys).Confluence]: {
        displayName: 'Confluence',
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $lAFHW.ConfluenceIcon), 'Confluence'),
        SearchResultIcon: (0, $9yyKc.get3PLogo)((0, $25d6378a84ef5509$export$93ca83db1787dea), 'Confluence', 'large')
    },
    [(0, $b4tvS.ProductKeys).Atlas]: {
        displayName: 'Home',
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $4Nwes.AtlassianIcon), 'Home'),
        SearchResultIcon: (0, $9yyKc.get3PLogo)((0, $a167bd50b2e4c9cb$export$b0a52366c3fb9b), 'Home', 'large')
    },
    [(0, $b4tvS.ProductKeys).Jira]: {
        displayName: 'Jira',
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $lAFHW.JiraIcon), 'Jira'),
        SearchResultIcon: (0, $9yyKc.get3PLogo)((0, $8beafb504c666551$export$f68d29dbb4f2da82), 'Jira', 'large')
    },
    [(0, $b4tvS.ProductKeys).JiraProductDiscovery]: {
        displayName: 'Jira Product Discovery',
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $lAFHW.JiraProductDiscoveryIcon), 'Jira Product Discovery'),
        SearchResultIcon: (0, $9yyKc.get3PLogo)((0, $b412ffda38aeedd7$export$1afe31d4b2891d7a), 'Jira Product Discovery', 'large')
    },
    [(0, $b4tvS.ProductKeys).JiraServiceManagement]: {
        displayName: 'Jira Service Management',
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $lAFHW.JiraServiceManagementIcon), 'Jira Service Management'),
        SearchResultIcon: (0, $9yyKc.get3PLogo)((0, $dfcfcba5660e06b1$export$ceeb1de9ca56c2f7), 'Jira Service Management', 'large')
    },
    [(0, $b4tvS.ProductKeys).Bitbucket]: {
        displayName: 'Bitbucket',
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $lAFHW.BitbucketIcon), 'Bitbucket'),
        SearchResultIcon: (0, $9yyKc.RovoLogoFromLogo)((0, $lAFHW.BitbucketIcon), 'large')
    },
    [(0, $b4tvS.ProductKeys).Trello]: {
        displayName: 'Trello',
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $lAFHW.TrelloIcon), 'Trello'),
        SearchResultIcon: (0, $9yyKc.get3PLogo)((0, $c190735ed0251a79$export$7221b4e3b691d1b3), 'Trello', 'large')
    },
    [(0, $b4tvS.ProductKeys).Compass]: {
        displayName: 'Compass',
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $lAFHW.CompassIcon), 'Compass'),
        SearchResultIcon: (0, $9yyKc.get3PLogo)((0, $e108be1bca7d778f$export$4b1b9db11d699ccb), 'Compass', 'large')
    },
    [(0, $b4tvS.ProductKeys).Focus]: {
        displayName: 'Focus',
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $lAFHW.FocusIcon), 'Focus'),
        SearchResultIcon: (0, $9yyKc.get3PLogo)((0, $506871dc04f0c8db$export$4d0238652f4b6bc4), 'Focus', 'large')
    },
    [(0, $b4tvS.ProductKeys).Assets]: {
        displayName: 'Assets',
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $lAFHW.AssetsIcon), 'Assets'),
        SearchResultIcon: (0, $9yyKc.get3PLogo)((0, $d52b37ba90dc95d4$export$24d355ce80de5803), 'Assets', 'large')
    },
    [(0, $b4tvS.ProductKeys).Talent]: {
        displayName: 'Talent',
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $lAFHW.TalentIcon), 'Talent'),
        SearchResultIcon: (0, $9yyKc.get3PLogo)((0, $brMqq.TalentSearchResultIcon), 'Talent', 'large')
    }
};
const $2acca743010e8c82$var$getProducts3PFromConfig = ()=>{
    // The use of Partial, the if (config) and the cast here are intentional TS gymnastics
    // We KNOW that this returns a config for all the ProductKeys3P, so we cast that
    // The TS compiler can't know that, and we'd be forced to write UI code like:
    //
    // const Icon = configs[productKey].Icon
    // return Icon && <Icon />
    //
    // Because TS can't prove productKey can be guaranteed to index into configs. But we know it can!
    const thirdPartyProducts = (0, $a5RR2.ThirdPartyConfigsSync);
    const configs = {};
    (0, $b4tvS.all3pProductKeys).map((productKey3P)=>{
        const config = thirdPartyProducts.get(productKey3P);
        if (config) configs[productKey3P] = {
            displayName: config.displayName,
            Icon: config.icon,
            IconBorderless: config.iconBorderless,
            is3P: true,
            ...config.searchResultIcon && {
                SearchResultIcon: config.searchResultIcon
            }
        };
    });
    return configs;
};
const $2acca743010e8c82$export$e2c1afe0b1afaf49 = ()=>{
    return (0, $42omo.useMemo)(()=>{
        const thirdPartyProducts = $2acca743010e8c82$var$getProducts3PFromConfig();
        return {
            ...$2acca743010e8c82$export$2e51523f0c1b4542,
            ...thirdPartyProducts
        };
    }, []);
};
const $2acca743010e8c82$export$ede9abe489c9321b = (productKey)=>{
    return $2acca743010e8c82$export$e2c1afe0b1afaf49()[productKey];
};
// Used by SAIN to detrermine knowledge source filtering
var $2acca743010e8c82$var$KnowledgeSourceTypeValues = /*#__PURE__*/ function(KnowledgeSourceTypeValues) {
    KnowledgeSourceTypeValues["GITHUB"] = "github";
    KnowledgeSourceTypeValues["CONFLUENCE"] = "confluence";
    KnowledgeSourceTypeValues["JIRA"] = "jira";
    KnowledgeSourceTypeValues["ATLAS"] = "atlas";
    KnowledgeSourceTypeValues["HELP_AGGREGATOR"] = "help_aggregator";
    KnowledgeSourceTypeValues["GOOGLE_DRIVE"] = "google_drive";
    KnowledgeSourceTypeValues["MICROSOFT_SHAREPOINT"] = "microsoft_sharepoint";
    KnowledgeSourceTypeValues["SLACK"] = "slack";
    KnowledgeSourceTypeValues["MICROSOFT_TEAMS"] = "teams";
    KnowledgeSourceTypeValues["FIGMA"] = "figma";
    KnowledgeSourceTypeValues["CONFLUENCE_DC"] = "confluence-dc";
    KnowledgeSourceTypeValues["ATLASSIAN_WEB_CRAWLER"] = "atlassian-web-crawler";
    KnowledgeSourceTypeValues["LOOM"] = "loom";
    KnowledgeSourceTypeValues["GOOGLE_CALENDAR"] = "google_calendar";
    KnowledgeSourceTypeValues["ASSETS"] = "cmdb";
    KnowledgeSourceTypeValues["SALESFORCE"] = "salesforce";
    KnowledgeSourceTypeValues["ZENDESK"] = "zendesk";
    KnowledgeSourceTypeValues["SERVICENOW"] = "servicenow";
    return KnowledgeSourceTypeValues;
}($2acca743010e8c82$var$KnowledgeSourceTypeValues || {});
const $2acca743010e8c82$export$4fbc006e529fd6c0 = {
    [(0, $b4tvS.ProductKeys).Confluence]: "confluence",
    [(0, $b4tvS.ProductKeys).Github]: "github",
    [(0, $b4tvS.ProductKeys).Jira]: "jira",
    [(0, $b4tvS.ProductKeys).Atlas]: "atlas",
    [(0, $b4tvS.ProductKeys).GoogleDrive]: "google_drive",
    [(0, $b4tvS.ProductKeys).Sharepoint]: "microsoft_sharepoint",
    [(0, $b4tvS.ProductKeys).Slack]: "slack",
    [(0, $b4tvS.ProductKeys).Teams]: "teams",
    [(0, $b4tvS.ProductKeys).Figma]: "figma",
    [(0, $b4tvS.ProductKeys).ConfluenceDC]: "confluence-dc",
    [(0, $b4tvS.ProductKeys).AtlassianWebCrawler]: "atlassian-web-crawler",
    [(0, $b4tvS.ProductKeys).Loom]: "loom",
    [(0, $b4tvS.ProductKeys).GoogleCalendar]: "google_calendar",
    [(0, $b4tvS.ProductKeys).Assets]: "cmdb",
    [(0, $b4tvS.ProductKeys).Salesforce]: "salesforce",
    [(0, $b4tvS.ProductKeys).Zendesk]: "zendesk",
    [(0, $b4tvS.ProductKeys).ServiceNow]: "servicenow"
};
module.exports["products1P"] = $2acca743010e8c82$export$2e51523f0c1b4542;
module.exports["useProductConfigs"] = $2acca743010e8c82$export$e2c1afe0b1afaf49;
module.exports["useProductConfig"] = $2acca743010e8c82$export$ede9abe489c9321b;
module.exports["MapProductToKnowledgeSources"] = $2acca743010e8c82$export$4fbc006e529fd6c0;

});

parcelRegister("9yyKc", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * A RovoLogo is a subset API that works for both @atlaskit/logo and @atlaskit/icon
 * We use one or the other depending on 1P or 3P and need a consistent API internall
 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");





var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

const $b9faf8c762554e25$var$t25IconContainerStyles = {
    small: (0, $ecnYn.xcss)({
        width: '16px',
        height: '16px'
    }),
    medium: (0, $ecnYn.xcss)({
        width: '24px',
        height: '24px'
    }),
    large: (0, $ecnYn.xcss)({
        width: '32px',
        height: '32px'
    }),
    //t25 tile icons do not get bumped up to 40/48px to avoid additional padding
    xlarge: (0, $ecnYn.xcss)({
        width: '32x',
        height: '32px'
    })
};
const $b9faf8c762554e25$var$iconStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $b9faf8c762554e25$export$1776e6671850176d = ({ glyph: SVG, label: label, size: size })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $b9faf8c762554e25$var$t25IconContainerStyles[size],
            $b9faf8c762554e25$var$iconStyles
        ],
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(SVG, null));
};


const $a72f5a493e80638f$var$isCorrectableRovoSize = (size)=>{
    return [
        'xxsmall',
        'xsmall',
        'small',
        'medium',
        'large'
    ].includes(size);
};
const $a72f5a493e80638f$var$correctedSize = {
    xxsmall: 'small',
    xsmall: 'small',
    small: 'medium',
    medium: 'large',
    large: 'xlarge'
};
const $a72f5a493e80638f$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
}; /**
    * A wrapper for providing an internal \@atlaskit/icon - alike experience for working with custom Rovo Icons
    *
    * Internally uses <Icon glyph={glyph} ... />
    *
    * @param {} glyph function returning an SVG as JSX
    * @param defaultLabel an accessible label for the logo
    */ 
const $a72f5a493e80638f$export$7b66a86355afbb91 = (Glyph, defaultLabel = '', defaultSize = 'medium')=>{
    return ({ size: size = defaultSize, label: label = defaultLabel, testId: testId })=>{
        const mappedSize = size && $a72f5a493e80638f$var$isCorrectableRovoSize(size) ? $a72f5a493e80638f$var$correctedSize[size] : defaultSize;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            "aria-label": label || undefined,
            "data-testid": testId,
            role: label ? 'img' : 'presentation',
            className: (0, $gMc0m.default)([
                $a72f5a493e80638f$var$sizeStyles[mappedSize]
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Glyph, null));
    };
}; /**
    * A wrapper for rendering 3P svg illustrations in a similar way for atlaskit icon components
    *
    * @param {} glyph function returning an SVG as JSX
    * @param defaultLabel an accessible label for the logo
    */ 
const $a72f5a493e80638f$export$dae027fade2c6d1d = (glyph, defaultLabel = '', defaultSize)=>{
    return ({ label: label = defaultLabel, size: size = defaultSize, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b9faf8c762554e25$export$1776e6671850176d), {
            label: label,
            glyph: glyph,
            size: size && $a72f5a493e80638f$var$isCorrectableRovoSize(size) ? $a72f5a493e80638f$var$correctedSize[size] : 'medium'
        });
}; /**
    * A wrapper for providing an internal \@atlaskit/icon - alike experience for working with \@atlaskit/logo
    *
    * Internally uses <LogoComponent ... />
    *
    * @param {} LogoComponent an import from \@atlaskit/logo
    * @param defaultLabel an accessible label for the logo
    */ 
const $a72f5a493e80638f$export$32db889b380fa03c = (LogoComponent, defaultLabel = '')=>{
    return ({ size: size, label: label, testId: testId })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LogoComponent, {
            label: label || defaultLabel,
            testId: testId,
            size: size || 'medium',
            appearance: "brand",
            shouldUseNewLogoDesign: true
        });
    };
}; /**
    * Takes a logo component and returns a new logo component that uses the new logo design.
    */ 
function $a72f5a493e80638f$export$a34cd1871c6541c9(Icon) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            ...props,
            shouldUseNewLogoDesign: true
        });
}
function $a72f5a493e80638f$export$fab9faef3411dc6c(iconGlyph, iconLabel, size) {
    return $a72f5a493e80638f$export$dae027fade2c6d1d(iconGlyph, iconLabel, size);
}
const $a72f5a493e80638f$var$imageStyles = null; /**
                           * Helper function to convert an image URL into a glyph function
                           *
                           * @param imageUrl URL string pointing to the image
                           * @returns A glyph function that returns an img element
                           */ 
const $a72f5a493e80638f$export$f9f7178f66750cba = (imageUrl)=>{
    return ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
            src: imageUrl,
            alt: "",
            className: (0, $gMc0m.default)([
                "_1bsb1osq _4t3i1osq _5ral1f51"
            ])
        });
    };
}; /**
    * Creates a RovoLogo from a URL. Useful for Forge connectors that provide icon URLs.
    * Uses the existing RovoLogoFromSVG infrastructure for consistent handling.
    */ 
function $a72f5a493e80638f$export$97ac28be52c9e29f(iconUrl, iconLabel, size) {
    return $a72f5a493e80638f$export$dae027fade2c6d1d($a72f5a493e80638f$export$f9f7178f66750cba(iconUrl), iconLabel, size);
}
module.exports["RovoLogoFromLogo"] = $a72f5a493e80638f$export$32db889b380fa03c;
module.exports["get3PLogo"] = $a72f5a493e80638f$export$fab9faef3411dc6c;
module.exports["get3PLogoFromURL"] = $a72f5a493e80638f$export$97ac28be52c9e29f;

});

parcelRegister("fuGkE", function(module, exports) {
// Pure product key constants imported from product-keys.ts (source of truth).
// Re-exported below so existing consumers continue to work.

var $b4tvS = parcelRequire("b4tvS");

const $abb7ab79dbd0cf75$export$ee811373b5708646 = (key)=>!Object.values((0, $b4tvS.ProductKeys1PForAnalytics)).includes(key);
module.exports["is3pProductKeyForAnalytics"] = $abb7ab79dbd0cf75$export$ee811373b5708646;

});

parcelRegister("9rRKJ", function(module, exports) {
const $b8ac34854d5d5114$export$81f65d0c79fe28b4 = {
    QUICK_FIND: 'quick-find',
    SEARCH_PAGE: 'search-page'
};
module.exports["SearchExperience"] = $b8ac34854d5d5114$export$81f65d0c79fe28b4;

});

parcelRegister("7WbA8", function(module, exports) {

var $42omo = parcelRequire("42omo");

// This function is used to override the values of an object with the values of another object.
// Unless the value is null or undefined, the value from the source object will be used.
function $0776efa54b822e10$export$8b58be045bf06082(target, source) {
    const result = {
        ...target
    };
    for(const key in source)if (source[key] !== null && source[key] !== undefined) result[key] = source[key];
    return result;
}



var $aN48i = parcelRequire("aN48i");


var $iXZ54 = parcelRequire("iXZ54");

const $801eb453cbafb488$export$554c849e7e3a0f1 = {
    mapUserIdToProfileUrl: ()=>null,
    generateSearchUrl: (0, $aN48i.defaultGenerateSearchUrl),
    getFeatureGate: ()=>false,
    getFrontendExperiment: ()=>({
            abTestId: '',
            cohort: '',
            serveExperiment: false
        }),
    queryParams: {},
    onNavigate: (0, $iXZ54.defaultOnNavigate),
    isNav4Enabled: false,
    isAdminHubAIEnabled: false,
    isRovoLLMEnabled: false
};
/**
 * Provides information about the host application that can't be stored in a state store,
 * e.g. a function.
 */ const $801eb453cbafb488$var$AppContext = /*#__PURE__*/ (0, $42omo.createContext)($801eb453cbafb488$export$554c849e7e3a0f1);
const $801eb453cbafb488$export$fdc397e486fa83e7 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($801eb453cbafb488$var$AppContext);
const $801eb453cbafb488$export$20d2b7652facc723 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($801eb453cbafb488$var$AppContext.Provider, {
        value: (0, $0776efa54b822e10$export$8b58be045bf06082)($801eb453cbafb488$export$554c849e7e3a0f1, props)
    }, children);
module.exports["useAppContext"] = $801eb453cbafb488$export$fdc397e486fa83e7;
module.exports["AppContextProvider"] = $801eb453cbafb488$export$20d2b7652facc723;

});

parcelRegister("aN48i", function(module, exports) {
function $774faa0859b100e2$export$3c0cdf0037f37eca(queryParams) {
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams();
    Object.entries(queryParams).forEach(([key, value])=>{
        if (value !== undefined && value !== null) searchParams.set(key, String(value));
        else searchParams.delete(key);
    });
    url.search = searchParams.toString();
    return url.href;
}
module.exports["defaultGenerateSearchUrl"] = $774faa0859b100e2$export$3c0cdf0037f37eca;

});

parcelRegister("iXZ54", function(module, exports) {
const $821d0deb1923daa8$export$bd386de500a3324b = {
    callback: (url)=>{
        window.location.href = url;
    },
    options: {
        alwaysUseOnLinkClick: false
    }
};
module.exports["defaultOnNavigate"] = $821d0deb1923daa8$export$bd386de500a3324b;

});

parcelRegister("2lmJQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $hcty8 = parcelRequire("hcty8");






























const $3c2ea2bb832e7694$export$8d1690c334cb6ec1 = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("6JMMA"));
        case 'da':
            return (parcelRequire("7SFxt"));
        case 'de':
            return (parcelRequire("iG4FS"));
        case 'en':
            return (parcelRequire("10hdm"));
        case 'en_GB':
            return (parcelRequire("hqwTK"));
        case 'en_ZZ':
            return (parcelRequire("48gEg"));
        case 'es':
            return (parcelRequire("3ggR2"));
        case 'fi':
            return (parcelRequire("9kNdt"));
        case 'fr':
            return (parcelRequire("6of6C"));
        case 'hr':
            return (parcelRequire("gFJ5o"));
        case 'hu':
            return (parcelRequire("k9sQX"));
        case 'it':
            return (parcelRequire("7AG2g"));
        case 'ja':
            return (parcelRequire("17jtA"));
        case 'ko':
            return (parcelRequire("3sG8V"));
        case 'nb':
            return (parcelRequire("3wwJC"));
        case 'nl':
            return (parcelRequire("115hq"));
        case 'pl':
            return (parcelRequire("chAaE"));
        case 'pt_BR':
            return (parcelRequire("7yG1I"));
        case 'ru':
            return (parcelRequire("15Txp"));
        case 'sl':
            return (parcelRequire("8fmsn"));
        case 'sr_RS':
            return (parcelRequire("cGi9X"));
        case 'sr_YR':
            return (parcelRequire("95rIQ"));
        case 'sv':
            return (parcelRequire("6IgfV"));
        case 'th':
            return (parcelRequire("5cgH8"));
        case 'tr':
            return (parcelRequire("kZgWD"));
        case 'uk':
            return (parcelRequire("a9O5n"));
        case 'vi':
            return (parcelRequire("1Yvyf"));
        case 'zh':
            return (parcelRequire("bKS5F"));
        case 'zh_TW':
            return (parcelRequire("38PKm"));
    }
};































const $6b58d18b8a9fe990$export$8d1690c334cb6ec1 = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("1uiyk"));
        case 'da':
            return (parcelRequire("dwWyj"));
        case 'de':
            return (parcelRequire("7ahd4"));
        case 'en':
            return (parcelRequire("6dBQl"));
        case 'en_GB':
            return (parcelRequire("2v8Gz"));
        case 'en_ZZ':
            return (parcelRequire("g7B9r"));
        case 'es':
            return (parcelRequire("kQel5"));
        case 'fi':
            return (parcelRequire("jfXoT"));
        case 'fr':
            return (parcelRequire("1RWPz"));
        case 'hr':
            return (parcelRequire("hnggZ"));
        case 'hu':
            return (parcelRequire("bpipP"));
        case 'it':
            return (parcelRequire("1nlci"));
        case 'ja':
            return (parcelRequire("7xBft"));
        case 'ko':
            return (parcelRequire("bVHQO"));
        case 'nb':
            return (parcelRequire("3kdAT"));
        case 'nl':
            return (parcelRequire("hgkdN"));
        case 'pl':
            return (parcelRequire("cHN0H"));
        case 'pt_BR':
            return (parcelRequire("5oUTu"));
        case 'ru':
            return (parcelRequire("agank"));
        case 'sl':
            return (parcelRequire("kqPpj"));
        case 'sr_RS':
            return (parcelRequire("1glw4"));
        case 'sr_YR':
            return (parcelRequire("bXCJU"));
        case 'sv':
            return (parcelRequire("inmxY"));
        case 'th':
            return (parcelRequire("8AA5B"));
        case 'tr':
            return (parcelRequire("l8rBv"));
        case 'uk':
            return (parcelRequire("9VCF3"));
        case 'vi':
            return (parcelRequire("aMD9S"));
        case 'zh':
            return (parcelRequire("jyIFt"));
        case 'zh_TW':
            return (parcelRequire("jq2Ox"));
    }
};































const $649ceacdb34b6a63$export$8d1690c334cb6ec1 = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("b0Quq"));
        case 'da':
            return (parcelRequire("gHqSP"));
        case 'de':
            return (parcelRequire("kDZ63"));
        case 'en':
            return (parcelRequire("2ZJxd"));
        case 'en_GB':
            return (parcelRequire("lIvrR"));
        case 'en_ZZ':
            return (parcelRequire("1kUhq"));
        case 'es':
            return (parcelRequire("59IhA"));
        case 'fi':
            return (parcelRequire("kkRV8"));
        case 'fr':
            return (parcelRequire("5dGG6"));
        case 'hr':
            return (parcelRequire("67rtf"));
        case 'hu':
            return (parcelRequire("bbmuy"));
        case 'it':
            return (parcelRequire("5pwE4"));
        case 'ja':
            return (parcelRequire("lb7B1"));
        case 'ko':
            return (parcelRequire("2ahus"));
        case 'nb':
            return (parcelRequire("a9LHZ"));
        case 'nl':
            return (parcelRequire("2K8Ox"));
        case 'pl':
            return (parcelRequire("huUQh"));
        case 'pt_BR':
            return (parcelRequire("85sK0"));
        case 'ru':
            return (parcelRequire("7cPnf"));
        case 'sl':
            return (parcelRequire("574v7"));
        case 'sr_RS':
            return (parcelRequire("iR7QZ"));
        case 'sr_YR':
            return (parcelRequire("5tHnM"));
        case 'sv':
            return (parcelRequire("eqt1i"));
        case 'th':
            return (parcelRequire("hAHoU"));
        case 'tr':
            return (parcelRequire("4LhxM"));
        case 'uk':
            return (parcelRequire("fz4HK"));
        case 'vi':
            return (parcelRequire("36F2C"));
        case 'zh':
            return (parcelRequire("1swrg"));
        case 'zh_TW':
            return (parcelRequire("ezqXT"));
    }
};
































const $a9027c6ac5c6310c$export$417b577dd0ae3221 = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("9dO3Q"));
        case 'da':
            return (parcelRequire("22YHR"));
        case 'de':
            return (parcelRequire("5Meno"));
        case 'en':
            return Promise.resolve((parcelRequire("hcty8")));
        case 'en_GB':
            return (parcelRequire("6qVkf"));
        case 'en_ZZ':
            return (parcelRequire("73KJL"));
        case 'es':
            return (parcelRequire("eqUDU"));
        case 'fi':
            return (parcelRequire("7qIaH"));
        case 'fr':
            return (parcelRequire("cqTPI"));
        case 'hr':
            return (parcelRequire("emO7i"));
        case 'hu':
            return (parcelRequire("aFdnn"));
        case 'it':
            return (parcelRequire("a5l2v"));
        case 'ja':
            return (parcelRequire("8rhoO"));
        case 'ko':
            return (parcelRequire("eqZ4Q"));
        case 'nb':
            return (parcelRequire("bAo9R"));
        case 'nl':
            return (parcelRequire("10owv"));
        case 'pl':
            return (parcelRequire("k4VqY"));
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("geYJd"));
        case 'ru':
            return (parcelRequire("1zmTJ"));
        case 'sl':
            return (parcelRequire("4CvUL"));
        case 'sr_RS':
            return (parcelRequire("5hr1F"));
        case 'sr_YR':
            return (parcelRequire("6lyxH"));
        case 'sv':
            return (parcelRequire("bUrkL"));
        case 'th':
            return (parcelRequire("1ZvsH"));
        case 'tr':
            return (parcelRequire("1t44X"));
        case 'uk':
            return (parcelRequire("f9p83"));
        case 'vi':
            return (parcelRequire("lxyXQ"));
        case 'zh_TW':
            return (parcelRequire("eqEPm"));
        case 'zh':
            return (parcelRequire("89Znr"));
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $a9027c6ac5c6310c$export$417b577dd0ae3221(fragments[0]);
                else return Promise.resolve((parcelRequire("hcty8")));
            }
    }
};
const $a9027c6ac5c6310c$export$bb2dfe5d62b737e9 = async (locale)=>{
    switch(locale){
        case 'cs':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('cs');
        case 'da':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('da');
        case 'de':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('de');
        case 'en':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('en');
        case 'en_GB':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('en_GB');
        case 'en_ZZ':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('en_ZZ');
        case 'es':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('es');
        case 'fi':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('fi');
        case 'fr':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('fr');
        case 'hr':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('hr');
        case 'hu':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('hu');
        case 'it':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('it');
        case 'ja':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('ja');
        case 'ko':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('ko');
        case 'nb':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('nb');
        case 'nl':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('nl');
        case 'pl':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('pl');
        case 'pt_BR':
        case 'pt-BR':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('pt_BR');
        case 'ru':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('ru');
        case 'sl':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('sl');
        case 'sr_RS':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('sr_RS');
        case 'sr_YR':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('sr_YR');
        case 'sv':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('sv');
        case 'th':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('th');
        case 'tr':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('tr');
        case 'uk':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('uk');
        case 'vi':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('vi');
        case 'zh_TW':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('zh_TW');
        case 'zh':
            return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('zh');
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $a9027c6ac5c6310c$export$bb2dfe5d62b737e9(fragments[0]);
                else return (0, $6b58d18b8a9fe990$export$8d1690c334cb6ec1)('en');
            }
    }
};
const $a9027c6ac5c6310c$export$622f604e3a034452 = async (locale)=>{
    switch(locale){
        case 'cs':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('cs');
        case 'da':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('da');
        case 'de':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('de');
        case 'en':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('en');
        case 'en_GB':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('en_GB');
        case 'en_ZZ':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('en_ZZ');
        case 'es':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('es');
        case 'fi':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('fi');
        case 'fr':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('fr');
        case 'hr':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('hr');
        case 'hu':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('hu');
        case 'it':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('it');
        case 'ja':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('ja');
        case 'ko':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('ko');
        case 'nb':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('nb');
        case 'nl':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('nl');
        case 'pl':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('pl');
        case 'pt_BR':
        case 'pt-BR':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('pt_BR');
        case 'ru':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('ru');
        case 'sl':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('sl');
        case 'sr_RS':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('sr_RS');
        case 'sr_YR':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('sr_YR');
        case 'sv':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('sv');
        case 'th':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('th');
        case 'tr':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('tr');
        case 'uk':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('uk');
        case 'vi':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('vi');
        case 'zh_TW':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('zh_TW');
        case 'zh':
            return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('zh');
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $a9027c6ac5c6310c$export$622f604e3a034452(fragments[0]);
                else return (0, $649ceacdb34b6a63$export$8d1690c334cb6ec1)('en');
            }
    }
};
const $a9027c6ac5c6310c$export$97d82de8c43f5d55 = async (locale)=>{
    switch(locale){
        case 'cs':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('cs');
        case 'da':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('da');
        case 'de':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('de');
        case 'en':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('en');
        case 'en_GB':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('en_GB');
        case 'en_ZZ':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('en_ZZ');
        case 'es':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('es');
        case 'fi':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('fi');
        case 'fr':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('fr');
        case 'hr':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('hr');
        case 'hu':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('hu');
        case 'it':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('it');
        case 'ja':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('ja');
        case 'ko':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('ko');
        case 'nb':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('nb');
        case 'nl':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('nl');
        case 'pl':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('pl');
        case 'pt_BR':
        case 'pt-BR':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('pt_BR');
        case 'ru':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('ru');
        case 'sl':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('sl');
        case 'sr_RS':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('sr_RS');
        case 'sr_YR':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('sr_YR');
        case 'sv':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('sv');
        case 'th':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('th');
        case 'tr':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('tr');
        case 'uk':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('uk');
        case 'vi':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('vi');
        case 'zh_TW':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('zh_TW');
        case 'zh':
            return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('zh');
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $a9027c6ac5c6310c$export$97d82de8c43f5d55(fragments[0]);
                else return (0, $3c2ea2bb832e7694$export$8d1690c334cb6ec1)('en');
            }
    }
};
function $a9027c6ac5c6310c$export$6e4716e192dd76c5(locale) {
    return Promise.allSettled([
        $a9027c6ac5c6310c$export$417b577dd0ae3221(locale),
        $a9027c6ac5c6310c$export$bb2dfe5d62b737e9(locale),
        $a9027c6ac5c6310c$export$622f604e3a034452(locale),
        $a9027c6ac5c6310c$export$97d82de8c43f5d55(locale)
    ]).then((results)=>{
        const accumulatedMessages = results.reduce((acc, result)=>{
            if (result.status === 'fulfilled') return {
                ...acc,
                ...result.value.default
            };
            return acc;
        }, {});
        return accumulatedMessages;
    });
}


const $7ba69f2ba95f1501$var$useI18n = (locale, source)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState((0, $hcty8.default));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        let aborted = false;
        setMessages((0, $hcty8.default));
        (0, $a9027c6ac5c6310c$export$6e4716e192dd76c5)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'error',
                    actionSubject: 'i18n_messages_load_error',
                    source: source,
                    attributes: {
                        locale: locale,
                        error: error.message
                    }
                }
            }).fire();
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale,
        source,
        createAnalyticsEvent
    ]);
    return messages;
};
const $7ba69f2ba95f1501$var$MessagesIntlProvider = (props)=>{
    const { children: children } = props;
    const intl = (0, $aXWIB.useIntl)();
    const messages = $7ba69f2ba95f1501$var$useI18n(intl.locale, props.experience);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.IntlProvider), {
        ...intl,
        messages: messages
    }, children);
};
var $7ba69f2ba95f1501$export$2e2bcd8739ae039 = $7ba69f2ba95f1501$var$MessagesIntlProvider;
module.exports["default"] = $7ba69f2ba95f1501$export$2e2bcd8739ae039;

});

parcelRegister("hcty8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $6b9649fc867121cb$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $3c312875d27f019c$export$2e2bcd8739ae039 = {
    '3p-result-labeling.knowledge_article.label': 'Knowledge article',
    '3p-result-labeling.news_article.label': 'News article',
    'advanced-search.labels.filter.no.text': 'Start typing to search for a label',
    'ai-summary-label': 'Summarize',
    'archive.label': 'Archive',
    'assets-app-message-banner-available-soon': '<bold>Assets will be available here soon</bold>. For now, try <assetsSearchLink>Assets search</assetsSearchLink>.',
    'assets-app-message-banner-dismiss-message': 'Dismiss',
    attachment_type: 'Attachment',
    'audio.label': 'Audio',
    avatar: 'Avatar',
    'blogpost.label': 'Blogpost',
    blogpost_type: 'Blogpost',
    'branch.label': 'Branch',
    'channel.label': 'Channel',
    'code.label': 'Code',
    'comment-result.label': 'Comment',
    comment_type: 'Comment',
    'commit.label': 'Commit',
    connect_third_party_product_description: 'Connect your account to see missing results',
    connect_third_party_product_title: 'Your admin has added {product}!',
    connect_third_party_product_title_alternate: '{product} is now available!',
    'copied-link-tooltip-label': 'Copied!',
    'copy-content-link-label': 'Copy link',
    'copy-link-button-label': 'Copy Link',
    'copy-link-success-icon-label': 'Success icon',
    'copy-link-tooltip-label': 'Copy link',
    createdNewest: 'Created (newest)',
    createdOldest: 'Created (oldest)',
    'customer-org.label': 'Customer Org',
    'dashboard.label': 'Dashboard',
    'database.label': 'Database',
    'date.filter.after.label': 'after',
    'date.filter.any.time': 'Anytime',
    'date.filter.before.label': 'before',
    'date.filter.custom': 'Custom',
    'date.filter.custom.invalid.after.end': 'The From date has to be before the To date',
    'date.filter.custom.invalid.after.today': "The From date can\u2019t be in the future",
    'date.filter.custom.invalid.to.after.today': "The To date can\u2019t be in the future",
    'date.filter.from.label': 'Choose start date to filter',
    'date.filter.from.title': 'From',
    'date.filter.input.placeholder': 'Choose a date',
    'date.filter.last.month': 'Past 30 days',
    'date.filter.last.week': 'Past 7 days',
    'date.filter.last.year': 'Past year',
    'date.filter.title': 'Last updated',
    'date.filter.to.label': 'Choose end date to filter',
    'date.filter.to.range': 'to',
    'date.filter.to.title': 'To',
    'date.filter.today': 'Today',
    'date.filter.update.button': 'Update',
    'date.filter.yesterday': 'Yesterday',
    'deal.label': 'Deal',
    'design-search-result.label': 'Design',
    'design.label': 'Design',
    'document-search-result.google-docs-label': 'Docs',
    'document-search-result.google-sheets-label': 'Sheets',
    'document-search-result.google-slides-label': 'Slides',
    'document-search-result.ms-excel-label': 'Excel',
    'document-search-result.ms-powerpoint-label': 'PowerPoint',
    'document-search-result.ms-word-label': 'Word',
    'document.label': 'Document',
    draft_label: 'Draft',
    dropdown_generate_answer: 'Generate answer',
    dropdown_recent_icon_label: 'Recent',
    dropdown_search: 'Search',
    dropdown_search_icon_label: 'Search',
    'error-boundary.code': 'The code associated with this error: {code}',
    'error-boundary.description': 'The issue should resolve on its own, but if it keeps happening, ask your admin to contact {atlassianSupportLink} and give them:',
    'error-boundary.description.support-link': 'Atlassian Support',
    'error-boundary.reload-page': 'Refresh page',
    'error-boundary.support-link-text': 'our support team',
    'error-boundary.title': "We've hit a snag",
    'error-boundary.url': 'The URL of this page',
    error_primary: "We're having trouble searching",
    error_secondary: 'It might just be a hiccup. The best thing to do is to <btn>try again</btn>.',
    externalPeopleLabel: 'External people #{channelName}',
    externalPersonLabel: 'External person',
    'file.label': 'File',
    filter: 'Filter icon',
    give_feedback_text: 'Give feedback',
    'image.label': 'Image',
    'inline-app-selector.1p-3p-app-tooltip': 'Open a full page search for this term filtered by {productName} results',
    'inline-app-selector.additional-products': '+ {count}',
    'inline-app-selector.all-apps-tooltip': 'Open a full page search for this term searching all apps',
    'inline-product-filters.external-link-icon.label': 'External Link Icon',
    'inline-product-filters.more-filters.label': 'More',
    'inline-product-filters.more-filters.tooltip': 'Open a full page search with more filter options for {product}',
    input_aria_label: 'Search, press enter to navigate to advanced search with your text query',
    input_clear_icon_label: 'Clear search',
    input_copy_link_icon_label: 'Copy link',
    input_placeholder: 'Search',
    input_placeholder_default: 'Search for anything',
    input_placeholder_ghost_text_kpi_acronym: 'Search any acronym, like "KPI"',
    input_placeholder_ghost_text_mention_teammates: '@mention a teammate to see their work',
    input_placeholder_ghost_text_search_across: 'Search across {products}, and more',
    input_placeholder_ghost_text_search_teammate: 'Search the name of a teammate',
    input_placeholder_ghost_text_submit_expense: 'Ask a question like "How do I submit an expense?"',
    input_placeholder_nav3: 'Search',
    input_placeholder_with_atlassian_intelligence: 'Search or ask anything',
    input_placeholder_with_rovo: 'Search or ask Rovo',
    input_search_icon_label: 'Search',
    'invoice.label': 'Invoice',
    'issue.label': 'Issue',
    issue_type: 'Work item',
    jira_advanced_search: 'Search Jira for work items',
    jira_single_site_boards: 'Boards',
    jira_single_site_filters: 'Filters',
    jira_single_site_label: 'Go to all:',
    jira_single_site_people: 'Teams',
    jira_single_site_plans: 'Plans',
    jira_single_site_projects: 'Projects',
    jira_single_site_spaces: 'Spaces',
    jira_single_site_work_items_jql: 'Work items (JQL)',
    landing_primary: 'Seek and you shall find',
    landing_secondary: "Search for what you're looking for in your Atlassian and connected apps",
    landing_secondary_rovo: "Search or ask Rovo what you're looking for in your Atlassian and connected apps",
    landing_secondary_unified_with_sain: 'Search or ask anything across your Atlassian apps',
    landing_secondary_unified_without_sain: 'Search for anything across your Atlassian apps',
    landing_secondary_with_atlassian_intelligence: "Search or ask what you're looking for in your Atlassian and connected apps",
    'leap-query.title.related-search': 'Related searches',
    'leap-query.title.teammates-also-ask': 'Your teammates also ask',
    'link-attachments.button.label': '{count, plural, one {# link} other {# links}}',
    live_doc_type: 'Live Doc',
    'more-actions-label': 'More Actions',
    'more-label': 'More',
    'new-product-message-banner-dismiss-message-button': 'Dismiss',
    'new-product-message-banner-text': "{product} was only recently added and we're still tweaking the results.",
    noOptions: 'No options',
    no_results_clear_filters: 'Clear filters',
    no_results_content_cleared_by_space_change: 'No results - the selected folder may have been moved or deleted.',
    no_results_primary: "We couldn't find anything matching your search",
    no_results_search_all_drives: 'Search all Drives',
    no_results_search_all_sites: 'Search all Sites',
    no_results_secondary_no_filters: 'Try again with a different term.',
    no_results_secondary_some_filters_applied: 'Looks like you have some filters applied. You could try clearing them.',
    'oauth-banner.acknowledgement.success-flag-action': 'Understood',
    'oauth-banner.authorization-fail': 'Failed to connect to {product}.',
    'oauth-banner.authorization-success': 'Account connected to {product}.',
    'oauth-banner.oauth-social-proof-message.connect': 'Connect to {product}',
    'oauth-banner.oauth-social-proof-message.dismiss': 'Dismiss',
    'oauth-banner.oauth-social-proof-message.github.description': 'Expand your search results to include GitHub PRs, issues, and repos.',
    'oauth-banner.oauth-social-proof-message.github.success-flag-description': 'You can now find and action on PRs, commits, and repos in Rovo Search and Chat.',
    'oauth-banner.oauth-social-proof-message.github.success-flag-title': '{product} connected',
    'oauth-banner.oauth-social-proof-message.image-alt': 'Animated preview of {product} search results',
    'oauth-banner.oauth-social-proof-message.title-high-adoption': '{percentage}% of your team has connected apps like {product}',
    'oauth-banner.oauth-social-proof-message.title-low-adoption': 'Your team connected {product}',
    'oauth-message-connect': 'Connect',
    'oauth-message-dismiss': 'Dismiss',
    'other.label': 'Other',
    'page.label': 'Page',
    page_type: 'Page',
    'pdf.label': 'PDF',
    'presentation.label': 'Presentation',
    'project.label': 'Project',
    'pull-request.label': 'Pull Request',
    'quick-find-filters.filter-by-icon-label': 'Filter by Icon',
    'quick-find.assets.filter.assets-schema.icon.label': 'Assets schema filter',
    'quick-find.assets.filter.assets-schema.label.selected': 'Selected',
    'quick-find.assets.filter.assets-schema.label.unselected': 'Suggested',
    'quick-find.assets.filter.assets-schema.placeholder': 'Find schemas',
    'quick-find.assets.filter.assets-type.icon.label': 'Object type filter',
    'quick-find.assets.filter.assets-type.label.selected': 'Selected',
    'quick-find.assets.filter.assets-type.label.unselected': 'Suggested',
    'quick-find.assets.filter.assets-type.placeholder': 'Find object types',
    'quick-find.confluence.filter.contributor.placeholder': 'Find people',
    'quick-find.confluence.filter.label.selected': 'Selected',
    'quick-find.confluence.filter.label.unselected': 'Suggested',
    'quick-find.filter.type.label.selected': 'Selected',
    'quick-find.filter.type.label.unselected': 'Available',
    'quick-find.filter.type.placeholder': 'Find type',
    'quick-find.filters.clear-filters-button-label': 'Clear filters',
    'quick-find.filters.names.assets-schema': 'Schema',
    'quick-find.filters.names.assets-type': 'Object type',
    'quick-find.filters.names.assignee': 'Assignee',
    'quick-find.filters.names.contributor': 'Contributor',
    'quick-find.filters.names.project': 'Project',
    'quick-find.filters.names.spaces': 'Space',
    'quick-find.filters.names.type': 'Type',
    'quick-find.ghost-text.3p-multiple': 'Search {firstPartyApp}, {thirdPartyApp1}, {thirdPartyApp2} and other apps',
    'quick-find.ghost-text.3p.github': 'Search your GitHub repos, commits and PRs',
    'quick-find.ghost-text.3p.google-drive': 'Search your Google Drive Docs, Sheets and Slides',
    'quick-find.ghost-text.3p.onedrive': 'Search your OneDrive documents and files',
    'quick-find.ghost-text.3p.sharepoint': 'Search your SharePoint documents and files',
    'quick-find.ghost-text.3p.slack': 'Search your Slack DMs and messages',
    'quick-find.ghost-text.3p.teams': 'Search your Microsoft Teams chats and messages',
    'quick-find.ghost-text.control': 'Search',
    'quick-find.ghost-text.default-3p': 'Search across all your apps',
    'quick-find.ghost-text.mixed-apps': 'Search {currentApp}, {otherFirstPartyApp}, {thirdPartyApp} and other apps',
    'quick-find.ghost-text.sain': 'Ask me anything or search...',
    'quick-find.ghost-text.sain.benefits': 'Try any question, like "Where can I see my benefits?"',
    'quick-find.ghost-text.sain.it-support': 'Try any question, like "How do I contact IT support?"',
    'quick-find.ghost-text.sain.meeting-room': 'Try any question, like "How do I book a meeting room?"',
    'quick-find.ghost-text.sain.notifications': 'Try any question, like "How do I change my notification settings?"',
    'quick-find.ghost-text.sain.reset-password': 'Try any question, like "How do I reset my password?"',
    'quick-find.ghost-text.sain.time-off': 'Try any question, like "How do I request time off?"',
    'quick-find.ghost-text.two-apps': 'Search {firstPartyApp}, {thirdPartyApp1} and other apps',
    'quick-find.github.code.type': 'Code',
    'quick-find.jira.filter.assignee.placeholder': 'Find people',
    'quick-find.jira.filter.assignee.selected': 'Selected',
    'quick-find.jira.filter.assignee.unselected': 'Suggested',
    'quick-find.jira.filter.project.placeholder': 'Find projects',
    'quick-find.jira.filter.project.selected': 'Selected',
    'quick-find.jira.filter.project.unselected': 'Suggested',
    'quick-find.jira.filter.spaces.placeholder': 'Find spaces',
    'quick-find.jira.filter.spaces.selected': 'Selected',
    'quick-find.jira.filter.spaces.unselected': 'Suggested',
    'quick-find.mercury.focus-area-status-update.title': 'Update for {focusAreaName}',
    'quick-find.talent.position.external-position-key': 'External key {positionKey}',
    'quick-find.talent.position.title': '{preferredName, select, undefined {{positionKey}} other {{positionKey}: {preferredName}}}',
    quick_find_connect_apps_button_aria_label: 'Open app connections',
    quick_find_connect_apps_label: 'Connect apps',
    'recentWork.eventTypeMessage.absolute.commented': 'You commented on {absoluteTime}',
    'recentWork.eventTypeMessage.absolute.created': 'You created on {absoluteTime}',
    'recentWork.eventTypeMessage.absolute.edited': 'You edited on {absoluteTime}',
    'recentWork.eventTypeMessage.absolute.published': 'You published on {absoluteTime}',
    'recentWork.eventTypeMessage.absolute.updated': 'You updated on {absoluteTime}',
    'recentWork.eventTypeMessage.absolute.viewed': 'You viewed on {absoluteTime}',
    'recentWork.eventTypeMessage.absolute.workedOn': 'You worked on {absoluteTime}',
    'recentWork.eventTypeMessage.commented': 'You commented',
    'recentWork.eventTypeMessage.created': 'You created',
    'recentWork.eventTypeMessage.edited': 'You edited',
    'recentWork.eventTypeMessage.multi.absolute.commented': 'Commented on {absoluteTime}',
    'recentWork.eventTypeMessage.multi.absolute.created': 'Created on {absoluteTime}',
    'recentWork.eventTypeMessage.multi.absolute.edited': 'Edited on {absoluteTime}',
    'recentWork.eventTypeMessage.multi.absolute.published': 'Published on {absoluteTime}',
    'recentWork.eventTypeMessage.multi.absolute.updated': 'Updated on {absoluteTime}',
    'recentWork.eventTypeMessage.multi.absolute.viewed': 'Viewed on {absoluteTime}',
    'recentWork.eventTypeMessage.multi.absolute.workedOn': 'Worked on {absoluteTime}',
    'recentWork.eventTypeMessage.multi.commented': 'Commented',
    'recentWork.eventTypeMessage.multi.created': 'Created',
    'recentWork.eventTypeMessage.multi.dateTime.workedOn': 'Worked on {relativeTime}',
    'recentWork.eventTypeMessage.multi.edited': 'Edited',
    'recentWork.eventTypeMessage.multi.published': 'Published',
    'recentWork.eventTypeMessage.multi.relative.commented': 'Commented {relativeTime}',
    'recentWork.eventTypeMessage.multi.relative.created': 'Created {relativeTime}',
    'recentWork.eventTypeMessage.multi.relative.edited': 'Edited {relativeTime}',
    'recentWork.eventTypeMessage.multi.relative.published': 'Published {relativeTime}',
    'recentWork.eventTypeMessage.multi.relative.updated': 'Updated {relativeTime}',
    'recentWork.eventTypeMessage.multi.relative.viewed': 'Viewed {relativeTime}',
    'recentWork.eventTypeMessage.multi.updated': 'Updated',
    'recentWork.eventTypeMessage.multi.viewed': 'Viewed',
    'recentWork.eventTypeMessage.multi.workedOn': 'Worked on',
    'recentWork.eventTypeMessage.published': 'You published',
    'recentWork.eventTypeMessage.relative.commented': 'You commented {relativeTime}',
    'recentWork.eventTypeMessage.relative.created': 'You created {relativeTime}',
    'recentWork.eventTypeMessage.relative.edited': 'You edited {relativeTime}',
    'recentWork.eventTypeMessage.relative.published': 'You published {relativeTime}',
    'recentWork.eventTypeMessage.relative.updated': 'You updated {relativeTime}',
    'recentWork.eventTypeMessage.relative.viewed': 'You viewed {relativeTime}',
    'recentWork.eventTypeMessage.relative.workedOn': 'You worked on {relativeTime}',
    'recentWork.eventTypeMessage.updated': 'You updated',
    'recentWork.eventTypeMessage.viewed': 'You viewed',
    'recentWork.eventTypeMessage.workedOn': 'You worked on',
    recents_heading: 'Search Results',
    'recommended.collaborator': 'Collaborator',
    'recommended.eventTypeMessage.absolute.clicked': '{collaborator} clicked on {absoluteTime}',
    'recommended.eventTypeMessage.absolute.commented': '{collaborator} commented on {absoluteTime}',
    'recommended.eventTypeMessage.absolute.created': '{collaborator} created on {absoluteTime}',
    'recommended.eventTypeMessage.absolute.edited': '{collaborator} edited on {absoluteTime}',
    'recommended.eventTypeMessage.absolute.interacted': '{collaborator} interacted on {absoluteTime}',
    'recommended.eventTypeMessage.absolute.reacted': '{collaborator} reacted on {absoluteTime}',
    'recommended.eventTypeMessage.absolute.read': '{collaborator} read on {absoluteTime}',
    'recommended.eventTypeMessage.absolute.shared': '{collaborator} shared on {absoluteTime}',
    'recommended.eventTypeMessage.absolute.viewed': '{collaborator} viewed on {absoluteTime}',
    'recommended.eventTypeMessage.absolute.wereMentioned': '{collaborator} were mentioned on {absoluteTime}',
    'recommended.eventTypeMessage.clicked': '{collaborator} clicked',
    'recommended.eventTypeMessage.commented': '{collaborator} commented',
    'recommended.eventTypeMessage.created': '{collaborator} created',
    'recommended.eventTypeMessage.edited': '{collaborator} edited',
    'recommended.eventTypeMessage.icu.absolute.clicked': '{actor, select, you {You clicked on {absoluteTime}} collaborator {Collaborator clicked on {absoluteTime}} other {{username} clicked on {absoluteTime}}}',
    'recommended.eventTypeMessage.icu.absolute.commented': '{actor, select, you {You commented on {absoluteTime}} collaborator {Collaborator commented on {absoluteTime}} other {{username} commented on {absoluteTime}}}',
    'recommended.eventTypeMessage.icu.absolute.created': '{actor, select, you {You created on {absoluteTime}} collaborator {Collaborator created on {absoluteTime}} other {{username} created on {absoluteTime}}}',
    'recommended.eventTypeMessage.icu.absolute.edited': '{actor, select, you {You edited on {absoluteTime}} collaborator {Collaborator edited on {absoluteTime}} other {{username} edited on {absoluteTime}}}',
    'recommended.eventTypeMessage.icu.absolute.interacted': '{actor, select, you {You interacted on {absoluteTime}} collaborator {Collaborator interacted on {absoluteTime}} other {{username} interacted on {absoluteTime}}}',
    'recommended.eventTypeMessage.icu.absolute.mentioned': '{actor, select, you {You were mentioned on {absoluteTime}} collaborator {Collaborator was mentioned on {absoluteTime}} other {{username} was mentioned on {absoluteTime}}}',
    'recommended.eventTypeMessage.icu.absolute.reacted': '{actor, select, you {You reacted on {absoluteTime}} collaborator {Collaborator reacted on {absoluteTime}} other {{username} reacted on {absoluteTime}}}',
    'recommended.eventTypeMessage.icu.absolute.read': '{actor, select, you {You read on {absoluteTime}} collaborator {Collaborator read on {absoluteTime}} other {{username} read on {absoluteTime}}}',
    'recommended.eventTypeMessage.icu.absolute.shared': '{actor, select, you {You shared on {absoluteTime}} collaborator {Collaborator shared on {absoluteTime}} other {{username} shared on {absoluteTime}}}',
    'recommended.eventTypeMessage.icu.absolute.viewed': '{actor, select, you {You viewed on {absoluteTime}} collaborator {Collaborator viewed on {absoluteTime}} other {{username} viewed on {absoluteTime}}}',
    'recommended.eventTypeMessage.icu.clicked': '{actor, select, you {You clicked} collaborator {Collaborator clicked} other {{username} clicked}}',
    'recommended.eventTypeMessage.icu.commented': '{actor, select, you {You commented} collaborator {Collaborator commented} other {{username} commented}}',
    'recommended.eventTypeMessage.icu.created': '{actor, select, you {You created} collaborator {Collaborator created} other {{username} created}}',
    'recommended.eventTypeMessage.icu.edited': '{actor, select, you {You edited} collaborator {Collaborator edited} other {{username} edited}}',
    'recommended.eventTypeMessage.icu.interacted': '{actor, select, you {You interacted} collaborator {Collaborator interacted} other {{username} interacted}}',
    'recommended.eventTypeMessage.icu.mentioned': '{actor, select, you {You were mentioned} collaborator {Collaborator was mentioned} other {{username} was mentioned}}',
    'recommended.eventTypeMessage.icu.reacted': '{actor, select, you {You reacted} collaborator {Collaborator reacted} other {{username} reacted}}',
    'recommended.eventTypeMessage.icu.read': '{actor, select, you {You read} collaborator {Collaborator read} other {{username} read}}',
    'recommended.eventTypeMessage.icu.relative.clicked': '{actor, select, you {You clicked {relativeTime}} collaborator {Collaborator clicked {relativeTime}} other {{username} clicked {relativeTime}}}',
    'recommended.eventTypeMessage.icu.relative.commented': '{actor, select, you {You commented {relativeTime}} collaborator {Collaborator commented {relativeTime}} other {{username} commented {relativeTime}}}',
    'recommended.eventTypeMessage.icu.relative.created': '{actor, select, you {You created {relativeTime}} collaborator {Collaborator created {relativeTime}} other {{username} created {relativeTime}}}',
    'recommended.eventTypeMessage.icu.relative.edited': '{actor, select, you {You edited {relativeTime}} collaborator {Collaborator edited {relativeTime}} other {{username} edited {relativeTime}}}',
    'recommended.eventTypeMessage.icu.relative.interacted': '{actor, select, you {You interacted {relativeTime}} collaborator {Collaborator interacted {relativeTime}} other {{username} interacted {relativeTime}}}',
    'recommended.eventTypeMessage.icu.relative.mentioned': '{actor, select, you {You were mentioned {relativeTime}} collaborator {Collaborator was mentioned {relativeTime}} other {{username} was mentioned {relativeTime}}}',
    'recommended.eventTypeMessage.icu.relative.reacted': '{actor, select, you {You reacted {relativeTime}} collaborator {Collaborator reacted {relativeTime}} other {{username} reacted {relativeTime}}}',
    'recommended.eventTypeMessage.icu.relative.read': '{actor, select, you {You read {relativeTime}} collaborator {Collaborator read {relativeTime}} other {{username} read {relativeTime}}}',
    'recommended.eventTypeMessage.icu.relative.shared': '{actor, select, you {You shared {relativeTime}} collaborator {Collaborator shared {relativeTime}} other {{username} shared {relativeTime}}}',
    'recommended.eventTypeMessage.icu.relative.viewed': '{actor, select, you {You viewed {relativeTime}} collaborator {Collaborator viewed {relativeTime}} other {{username} viewed {relativeTime}}}',
    'recommended.eventTypeMessage.icu.shared': '{actor, select, you {You shared} collaborator {Collaborator shared} other {{username} shared}}',
    'recommended.eventTypeMessage.icu.viewed': '{actor, select, you {You viewed} collaborator {Collaborator viewed} other {{username} viewed}}',
    'recommended.eventTypeMessage.interacted': '{collaborator} interacted',
    'recommended.eventTypeMessage.reacted': '{collaborator} reacted',
    'recommended.eventTypeMessage.read': '{collaborator} read',
    'recommended.eventTypeMessage.relative.clicked': '{collaborator} clicked {relativeTime}',
    'recommended.eventTypeMessage.relative.commented': '{collaborator} commented {relativeTime}',
    'recommended.eventTypeMessage.relative.created': '{collaborator} created {relativeTime}',
    'recommended.eventTypeMessage.relative.edited': '{collaborator} edited {relativeTime}',
    'recommended.eventTypeMessage.relative.interacted': '{collaborator} interacted {relativeTime}',
    'recommended.eventTypeMessage.relative.reacted': '{collaborator} reacted {relativeTime}',
    'recommended.eventTypeMessage.relative.read': '{collaborator} read {relativeTime}',
    'recommended.eventTypeMessage.relative.shared': '{collaborator} shared {relativeTime}',
    'recommended.eventTypeMessage.relative.viewed': '{collaborator} viewed {relativeTime}',
    'recommended.eventTypeMessage.relative.wereMentioned': '{collaborator} were mentioned {relativeTime}',
    'recommended.eventTypeMessage.shared': '{collaborator} shared',
    'recommended.eventTypeMessage.viewed': '{collaborator} viewed',
    'recommended.eventTypeMessage.wereMentioned': '{collaborator} were mentioned',
    'recommended.you': 'You',
    'relay.jira-dc-work-item.issue-label': 'Issue',
    'relay.jira-dc-work-item.work-item.work-item-label': 'Work item',
    'relay.jira-dc.comment-result.label': 'Comment',
    'relay.jira-dc.issue-result.label': 'Work item',
    'relay.jira-dc.project-result.label': 'Project',
    'relay.jira-dc.space-result.label': 'Space',
    'relay.jira-dc.work-item-assignee.assigned': '{isAssigned, select, internal {{firstName} is assigned} other {External person is assigned}}',
    'relay.jira-dc.work-item-creator.created': '{created, select, internal {{firstName} created} other {External person created}}',
    'relay.jira-dc.work-item-status.for': '{statusLozenge} for {dateLozenge}',
    'relay.search-page.results.product-results.third-party.conversation-search-result.tabs-label': 'Tabs',
    'relay.search-page.results.product-results.third-party.message-search-result.file-attachments-expand-button-label': '{count, plural, one {# attachment} other {# attachments}}',
    'relay.search-page.results.product-results.third-party.message-search-result.member-count': '{count, plural, one {# member} other {# members}}',
    'relay.search-page.results.product-results.third-party.message-search-result.smartlink-attachments-expand-button-label': '{count, plural, one {# link} other {# links}}',
    'relay.search-result.attachment-label': 'Attachment',
    'relay.search-result.attachments.attached-date.label': 'Attached {formattedDate}',
    'relay.search-result.attachments.audio-label': 'Audio',
    'relay.search-result.attachments.expand.label': 'Expand',
    'relay.search-result.attachments.image-label': 'Image',
    'relay.search-result.attachments.pdf-label': 'PDF',
    'relay.search-result.attachments.video-label': 'Video',
    'relay.search-result.message-last-active': 'Last active {formattedDate}',
    'relay.search-result.message-type-label': 'Message',
    'relay.search-result.private-channel-label': 'Private Channel',
    'relay.search-result.thread-type-label': 'Thread',
    relevance: 'Relevance',
    'repository.label': 'Repository',
    'results-sort.createdDate.selected': 'Sort by created (newest)',
    'results-sort.createdDateASC': 'Created (oldest)',
    'results-sort.createdDateASCSelected.selected': 'Sort by created (oldest)',
    'results-sort.createdDateDESC': 'Created (newest)',
    'results-sort.latestModifiedDateASC': 'Updated (oldest)',
    'results-sort.latestModifiedDateASC.selected': 'Sort by updated (oldest)',
    'results-sort.latestModifiedDateDESC': 'Updated (newest)',
    'results-sort.latestModifiedDateDESC.selected': 'Sort by updated (newest)',
    'results-sort.relevanceDESC': 'Relevance',
    'results-sort.relevanceDESC.selected': 'Sort by relevance',
    'results-sort.sort-options.label': 'Change list sorting',
    'rovo-onboarding-got-it': 'Got it',
    'rovo-onboarding-step-1-description': 'Choose an app to get more relevant results and filters. For example, filter by Space in Confluence.',
    'rovo-onboarding-step-1-heading': 'Search across company apps',
    'rovo-search.assets.filter.icon.label': 'Assets filter',
    'rovo-search.confluence.filter.icon.label': 'Confluence filter',
    'rovo-search.jira.filter.icon.label': 'Jira filter',
    'rovo-search.talent.filter.icon.label': 'Talent filter',
    'rovo.search.quick-find-3p.connect': 'Connect {connectorName}',
    'rovo.search.quick-find-3p.dismiss': 'Dismiss',
    'rovo.search.quick-find-3p.full-connector.admin-blessed-missing-results.body': 'Connect to see missing results',
    'rovo.search.quick-find-3p.full-connector.admin-blessed-missing-results.heading-v2': 'Your admin added {connectorName}.',
    'rovo.search.quick-find-3p.full-connector.social-proof-high.heading-v2': '{teamConnectAppPercentage}% of your team have connected apps',
    'rovo.search.quick-find-3p.smart-link-connector.social-proof-high.heading-v3': '{teamConnectAppPercentage}% of your team have connected apps',
    'rovo.search.quick-find-3p.smart-link-connector.social-proof-low.body': 'Connect your account to see missing results',
    'rovo.search.quick-find-3p.smart-link-connector.social-proof-low.heading-v2': '{connectorName} is now available!',
    'rovo.search.quick-find-authorization-fail': 'Failed to connect to {product}.',
    'rovo.search.quick-find.authorization-success': 'Account connected to {product}.',
    'seaech-page.townsquare.api.goal-state.archived': 'Archived',
    'seaech-page.townsquare.api.goal-state.at-risk': 'At risk',
    'seaech-page.townsquare.api.goal-state.cancelled': 'Canceled',
    'seaech-page.townsquare.api.goal-state.completed': 'Completed',
    'seaech-page.townsquare.api.goal-state.off-track': 'Off track',
    'seaech-page.townsquare.api.goal-state.on-track': 'On track',
    'seaech-page.townsquare.api.goal-state.paused': 'Paused',
    'seaech-page.townsquare.api.goal-state.pending': 'Pending',
    'search-branch-result.label': 'Branch',
    'search-commit-result.committed': 'Committed {formattedDate}',
    'search-commit-result.label': 'Commit',
    'search-federated-result.email.label': 'Email',
    'search-federated-result.external-person.label': 'External person',
    'search-federated-result.forwarded.label': '{person} forwarded',
    'search-federated-result.inbox.label': 'Inbox',
    'search-federated-result.sent.label': '{person} sent',
    'search-federated-result.timestamp.label': '{formattedDate}',
    'search-filters.filter-by-icon': 'Filter by icon',
    'search-filters.names.contributor': 'Contributor',
    'search-filters.names.type': 'Type',
    'search-git-build-status.failed': '{failed} of {total} failed',
    'search-git-build-status.failed-generic': 'Build failed',
    'search-git-build-status.icon-label': 'Build status',
    'search-git-build-status.passed': '{passed} of {total} passed',
    'search-git-build-status.passed-generic': 'Build passed',
    'search-git-build-status.paused': 'Build paused',
    'search-git-build-status.pending': 'Build pending',
    'search-git-build-status.running': 'Build in progress',
    'search-git-build-status.stopped': 'Build stopped',
    'search-git-build-status.unknown': 'Build status unknown',
    'search-graph-calendar.calendar-label': 'Calendar',
    'search-graph-calendar.created.placeholder': '{person} created',
    'search-graph-calendar.external-person': 'External person',
    'search-graph-calendar.join-meeting-link': 'Join meeting',
    'search-graph-calendar.meeting-link': 'Meeting link',
    'search-graph-calendar.meeting-link-icon': 'Join meeting',
    'search-graph-calendar.past-events-button': 'Past events',
    'search-graph-calendar.recurring-event-icon': 'Recurring event',
    'search-graph-calendar.recurring-event-label': 'Recurring',
    'search-graph-calendar.upcoming-events-button': 'Upcoming events',
    'search-graph-campaign.campaign-label': 'Campaign',
    'search-graph-campaign.ended-on': 'Ended on {date}',
    'search-graph-campaign.ends-on': 'Ends on {date}',
    'search-graph-case.case-label': 'Case',
    'search-graph-case.closed-on': 'Closed on {date}',
    'search-graph-case.closes-on': 'Closes on {date}',
    'search-graph-confluence-dc.document.attachmentLabel': 'Attachment',
    'search-graph-confluence-dc.document.blogpostLabel': 'Blog Post',
    'search-graph-confluence-dc.document.commentLabel': 'Comment',
    'search-graph-confluence-dc.document.pageLabel': 'Page',
    'search-graph-confluence-dc.document.spaceLabel': 'Space',
    'search-graph-customer-contact.customer-contact-label': 'Customer Contact',
    'search-graph-customer-org.customer-org-label': 'Customer Organization',
    'search-graph-dashboard.dashboard-label': 'Dashboard',
    'search-graph-data-table.data-table-label': 'Data table',
    'search-graph-deal.closed-on': 'Closed on {date}',
    'search-graph-deal.closes-on': 'Closes on {date}',
    'search-graph-deal.deal-label': 'Deal',
    'search-graph-default.dashboard.label': 'Dashboard',
    'search-graph-default.deal.label': 'Deal',
    'search-graph-default.design.label': 'Design',
    'search-graph-default.invoice.label': 'Invoice',
    'search-graph-default.task.label': 'Task',
    'search-graph-jira-dc.comment-result.label': 'Comment',
    'search-graph-jira-dc.issue-result.label': 'Work item',
    'search-graph-jira-dc.project-result.label': 'Project',
    'search-graph-jira-dc.space-result.label': 'Space',
    'search-graph-video.dropdown-message': '{chapterCount, plural, one {# chapter in this video} other {# chapters in this video}}',
    'search-graph-video.duration.hours': '{hours} hour {minutes} min',
    'search-graph-video.duration.minutes': '{minutes} min',
    'search-graph-video.duration.seconds': '{seconds} sec',
    'search-graph-video.past-meetings': 'Past meetings',
    'search-graph-video.past-meetings-updated': 'Updated {relativeTime}',
    'search-graph-video.see-all': 'See all',
    'search-graph-video.video-icon-label': 'video icon',
    'search-graph-video.video-thumbnail-alt-text': 'Video thumbnail',
    'search-graph-video.video-type': 'Video',
    'search-graph-work-item.approval': 'Approval',
    'search-graph-work-item.bug.label': 'Bug',
    'search-graph-work-item.catalog_item': 'Catalog item',
    'search-graph-work-item.epic.label': 'Epic',
    'search-graph-work-item.incident': 'Incident',
    'search-graph-work-item.issue': 'Issue',
    'search-graph-work-item.label': 'Work item',
    'search-graph-work-item.milestone.label': 'Milestone',
    'search-graph-work-item.problem': 'Problem',
    'search-graph-work-item.question': 'Question',
    'search-graph-work-item.requested_item': 'Requested item',
    'search-graph-work-item.section': 'Section',
    'search-graph-work-item.story.label': 'Story',
    'search-graph-work-item.task.label': 'Task',
    'search-graph-work-item.ticket': 'Ticket',
    'search-page-relay.filters.product-filters.slack-channel.label': 'Channel',
    'search-page-relay.filters.product-filters.slack-channel.placeholder': 'Filter by channel',
    'search-page-relay.filters.product-filters.slack-channel.selected-label': 'Selected',
    'search-page-relay.filters.product-filters.slack-channel.suggested-label': 'Channels',
    'search-page-relay.results.product-results.third-party.conversation-search-result.label': 'Channel',
    'search-page-relay.results.product-results.third-party.conversation-search-result.member-count': '{count, plural, one {# member} other {# members}}',
    'search-page-relay.results.product-results.third-party.conversation-search-result.private-channel': 'Private channel',
    'search-page-relay.results.product-results.third-party.conversation-search-result.time-since-label': 'Last active {formattedDate}',
    'search-page-relay.results.product-results.third-party.conversation-search-result.unknown-channel': 'unknown-channel',
    'search-page.ai-mode.ai-mode': 'AI Mode',
    'search-page.ai-mode.results': 'Results',
    'search-page.app-filter-sidebar.all': 'All',
    'search-page.app-filter-sidebar.connect-apps-description': 'Get better answers and more results across Search and Chat.',
    'search-page.app-filter-sidebar.connect-apps-header': 'Connect apps',
    'search-page.app-filter-sidebar.connected-apps-header': 'Filter results',
    'search-page.app-filter-sidebar.filter-menu.menu-item.hide': 'Hide app',
    'search-page.app-filter-sidebar.filter-menu.trigger': 'Show more options',
    'search-page.app-filter-sidebar.group': 'Filter search by app',
    'search-page.app-filter-sidebar.improve-search': 'Improve search',
    'search-page.app-filter-sidebar.no-matching-results-tooltip': 'No matching results in {product}',
    'search-page.app-filter-sidebar.product-timeout-button-text': 'See only {product} results',
    'search-page.app-filter-sidebar.product-timeout-primary-text': '{product} results took too long to show',
    'search-page.app-filter-sidebar.product-timeout-secondary-text': 'Try again by filtering just for {product}.',
    'search-page.app-filter-sidebar.product-timeout-tooltip': '{product} results were too slow to show',
    'search-page.app-filter-sidebar.show-all-apps.button.label': 'Show all apps',
    'search-page.app-filter-sidebar.show-more.button.label': 'Show more',
    'search-page.app-filter-sidebar.show-more.filter.placeholder': 'Find apps',
    'search-page.assets.filter.assets-schema.icon.label': 'Assets schema filter',
    'search-page.assets.filter.assets-schema.label.selected': 'Selected',
    'search-page.assets.filter.assets-schema.label.unselected': 'Suggested',
    'search-page.assets.filter.assets-schema.placeholder': 'Find schemas',
    'search-page.assets.filter.assets-type.icon.label': 'Object type filter',
    'search-page.assets.filter.assets-type.label.selected': 'Selected',
    'search-page.assets.filter.assets-type.label.unselected': 'Suggested',
    'search-page.assets.filter.assets-type.placeholder': 'Find object types',
    'search-page.atlas.for': 'for',
    'search-page.atlas.goal.for': 'for',
    'search-page.auto-correction.did-you-mean': 'Did you mean {suggestedQuery}',
    'search-page.auto-correction.search-instead-for': 'Search instead for {originalQuery}',
    'search-page.auto-correction.showing-results-for': 'Showing results for {replacementQuery}',
    'search-page.browser-extension-banner.close-button-label': 'Close browser extension banner',
    'search-page.browser-extension-banner.link-text': 'Get the browser extension',
    'search-page.browser-extension-banner.title': 'Use Rovo wherever you are',
    'search-page.close-date-filter.date-label': 'Select date',
    'search-page.close-date-filter.date-placeholder': 'Select a date',
    'search-page.close-date-filter.label': 'Close date',
    'search-page.close-date-filter.update-button': 'Apply',
    'search-page.comment-icon-label': 'Comment',
    'search-page.common.graph-work-item-status.closed': 'Closed',
    'search-page.common.graph-work-item-status.open': 'Open',
    'search-page.common.status-target-date-display.for': 'for',
    'search-page.common.ui.clear-filter-button.label': 'Clear filter',
    'search-page.common.ui.quick-find.search-dialog-announcer.availableOptions': '{count} options available',
    'search-page.confluence.filter.content.placeholder': 'Find content',
    'search-page.confluence.filter.content.selected': 'Selected',
    'search-page.confluence.filter.content.unselected': 'Suggested',
    'search-page.confluence.filter.contributor.label.selected': 'Selected',
    'search-page.confluence.filter.contributor.label.unselected': 'Suggested',
    'search-page.confluence.filter.contributor.placeholder': 'Find people',
    'search-page.confluence.filter.creator.placeholder': 'Find people',
    'search-page.confluence.filter.creator.selected': 'Selected',
    'search-page.confluence.filter.creator.unselected': 'Suggested',
    'search-page.confluence.filter.icon.label': 'Confluence filter',
    'search-page.confluence.filter.label.selected': 'Selected',
    'search-page.confluence.filter.label.unselected': 'Suggested',
    'search-page.confluence.filter.labels.placeholder': 'Find labels',
    'search-page.confluence.filter.space.icon': 'Space Icon',
    'search-page.confluence.filter.space.placeholder': 'Find spaces',
    'search-page.dropdown.search-suggestions': 'Search Suggestions Dropdown',
    'search-page.embedded-comments.comment-header-prefix': 'Re: {label}',
    'search-page.filter.app-select.all': 'All',
    'search-page.filter.app-select.label.selected': 'Selected',
    'search-page.filter.app-select.label.unselected': 'Suggested',
    'search-page.filter.app-select.placeholder': 'Find app',
    'search-page.filter.app-select.tooltip.redirect': 'Open a full page search filtered by {appLabel} results',
    'search-page.filter.clear.filter.label': 'Clear filter',
    'search-page.filter.close.date.anytime': 'Anytime',
    'search-page.filter.close.date.custom': 'Specific date',
    'search-page.filter.close.date.last30days': 'Last 30 days',
    'search-page.filter.close.date.last365days': 'Last 365 days',
    'search-page.filter.close.date.last7days': 'Last 7 days',
    'search-page.filter.close.date.last90days': 'Last 90 days',
    'search-page.filter.close.date.next30days': 'Next 30 days',
    'search-page.filter.close.date.next365days': 'Next 365 days',
    'search-page.filter.close.date.next7days': 'Next 7 days',
    'search-page.filter.close.date.next90days': 'Next 90 days',
    'search-page.filter.close.date.today': 'Today',
    'search-page.filter.last.updated.anytime': 'Anytime',
    'search-page.filter.last.updated.custom': 'Custom',
    'search-page.filter.last.updated.past30Days': 'Past 30 days',
    'search-page.filter.last.updated.past7Days': 'Past 7 days',
    'search-page.filter.last.updated.pastYear': 'Past year',
    'search-page.filter.last.updated.today': 'Today',
    'search-page.filter.last.updated.yesterday': 'Yesterday',
    'search-page.filter.opportunityStatus.all': 'Any',
    'search-page.filter.opportunityStatus.closed': 'Closed',
    'search-page.filter.opportunityStatus.open': 'Open',
    'search-page.filter.pageStatus.all': 'All',
    'search-page.filter.pageStatus.inProgress': 'In progress',
    'search-page.filter.pageStatus.readyForReview': 'Ready for review',
    'search-page.filter.pageStatus.roughDraft': 'Rough draft',
    'search-page.filter.pageStatus.verified': 'Verified',
    'search-page.filter.pull-request-status.declined': 'Declined',
    'search-page.filter.pull-request-status.draft': 'Draft',
    'search-page.filter.pull-request-status.merged': 'Merged',
    'search-page.filter.pull-request-status.open': 'Open',
    'search-page.filter.pull-request-status.unknown': 'Unknown',
    'search-page.filter.status.done': 'Done',
    'search-page.filter.status.indeterminate': 'In Progress (Open)',
    'search-page.filter.status.new': 'To Do (Open)',
    'search-page.filter.status.open': 'Open',
    'search-page.filter.status.undefined': 'Other',
    'search-page.filter.suggested.options.section': 'Suggested',
    'search-page.filter.type.Story': 'Story',
    'search-page.filter.type.all': 'All',
    'search-page.filter.type.answer': 'Answers',
    'search-page.filter.type.archive': 'Archive',
    'search-page.filter.type.article': 'Articles',
    'search-page.filter.type.ask': 'Asks',
    'search-page.filter.type.attachment': 'Attachments',
    'search-page.filter.type.audio': 'Audio',
    'search-page.filter.type.blogpost': 'Blog posts',
    'search-page.filter.type.board': 'Boards',
    'search-page.filter.type.branch': 'Branches',
    'search-page.filter.type.bug': 'Bug',
    'search-page.filter.type.calendar': 'Calendars',
    'search-page.filter.type.campaign': 'Campaigns',
    'search-page.filter.type.card': 'Cards',
    'search-page.filter.type.case': 'Cases',
    'search-page.filter.type.catalog-item': 'Catalog items',
    'search-page.filter.type.code': 'Code',
    'search-page.filter.type.comment': 'Comments',
    'search-page.filter.type.commit': 'Commits',
    'search-page.filter.type.component': 'Components',
    'search-page.filter.type.conversation': 'Channels',
    'search-page.filter.type.customer-contact': 'Customer Contacts',
    'search-page.filter.type.customer-org': 'Customer Organizations',
    'search-page.filter.type.dashboard': 'Dashboards',
    'search-page.filter.type.data-table': 'Data tables',
    'search-page.filter.type.database': 'Databases',
    'search-page.filter.type.deal': 'Deals',
    'search-page.filter.type.demand': 'Demands',
    'search-page.filter.type.design': 'Designs',
    'search-page.filter.type.devops-work-item': 'Issues',
    'search-page.filter.type.documents': 'Documents',
    'search-page.filter.type.embed': 'Smart Links',
    'search-page.filter.type.epic': 'Epic',
    'search-page.filter.type.filter': 'Filters',
    'search-page.filter.type.focus-area': 'Focus areas',
    'search-page.filter.type.folder': 'Folders',
    'search-page.filter.type.form': 'Form',
    'search-page.filter.type.gliffy': 'Gliffy Diagrams',
    'search-page.filter.type.goal': 'Goals',
    'search-page.filter.type.image': 'Images',
    'search-page.filter.type.incident': 'Incidents',
    'search-page.filter.type.invoice': 'Invoices',
    'search-page.filter.type.jira-work-item': 'Work items',
    'search-page.filter.type.knowledge-article': 'Knowledge articles',
    'search-page.filter.type.message': 'Messages',
    'search-page.filter.type.notebook': 'Notebook',
    'search-page.filter.type.object': 'Objects',
    'search-page.filter.type.other': 'Other',
    'search-page.filter.type.page': 'Pages',
    'search-page.filter.type.pageAndLiveDoc': 'Pages and Live Docs',
    'search-page.filter.type.pdf': 'PDF',
    'search-page.filter.type.placeholder': 'Find type',
    'search-page.filter.type.plan': 'Plans',
    'search-page.filter.type.position': 'Positions',
    'search-page.filter.type.post': 'Posts',
    'search-page.filter.type.presentation': 'Presentations',
    'search-page.filter.type.project': 'Projects',
    'search-page.filter.type.pull-request': 'Pull requests',
    'search-page.filter.type.question': 'Questions',
    'search-page.filter.type.repository': 'Repositories',
    'search-page.filter.type.requested-item': 'Requested items',
    'search-page.filter.type.schema': 'Schemas',
    'search-page.filter.type.shortcut': 'Shortcut',
    'search-page.filter.type.slide': 'Slides',
    'search-page.filter.type.space': 'Spaces',
    'search-page.filter.type.space-calendar': 'Space calendars',
    'search-page.filter.type.spreadsheet': 'Spreadsheets',
    'search-page.filter.type.subtask': 'Subtask',
    'search-page.filter.type.tag': 'Tags',
    'search-page.filter.type.task': 'Task',
    'search-page.filter.type.ticket': 'Tickets',
    'search-page.filter.type.type': 'Object types',
    'search-page.filter.type.video': 'Videos',
    'search-page.filter.type.web-page': 'Web pages',
    'search-page.filter.type.whiteboard': 'Whiteboards',
    'search-page.filter.type.work-item': 'Tasks',
    'search-page.filters.clear-filters-button-label': 'Clear filters',
    'search-page.filters.dropdown.button': 'More filters',
    'search-page.filters.dropdown.clear-filters': 'Clear filters',
    'search-page.filters.names.app-select': 'App',
    'search-page.filters.names.archived': 'Show archived content',
    'search-page.filters.names.archivedAndPendingComponents': 'Show archived/pending components',
    'search-page.filters.names.assets-schema': 'Schema',
    'search-page.filters.names.assets-type': 'Object type',
    'search-page.filters.names.assignee': 'Assignee',
    'search-page.filters.names.closeDate': 'Close date',
    'search-page.filters.names.content': 'Content under',
    'search-page.filters.names.contributor': 'Contributor',
    'search-page.filters.names.createdBy': 'Created by',
    'search-page.filters.names.drive': 'Drive',
    'search-page.filters.names.focusAreaType': 'Focus area type',
    'search-page.filters.names.focusAreaUnder': 'Focus area under',
    'search-page.filters.names.has-attachment': 'Has attachment',
    'search-page.filters.names.labels': 'Label',
    'search-page.filters.names.lastUpdated': 'Last updated',
    'search-page.filters.names.lastUpdatedBy': 'Last updated by',
    'search-page.filters.names.owner': 'Owner',
    'search-page.filters.names.pageStatus': 'Status',
    'search-page.filters.names.position-status-filter': 'Filled status',
    'search-page.filters.names.positionEmploymentType': 'Employment type',
    'search-page.filters.names.positionFocusArea': 'Focus area',
    'search-page.filters.names.positionJobFamily': 'Job family',
    'search-page.filters.names.positionTeam': 'Team',
    'search-page.filters.names.project': 'Project',
    'search-page.filters.names.pull-request-status': 'PR status',
    'search-page.filters.names.reporter': 'Reporter',
    'search-page.filters.names.repository': 'Repository',
    'search-page.filters.names.repository.no-options': 'No repositories available',
    'search-page.filters.names.site': 'Site',
    'search-page.filters.names.space': 'Space',
    'search-page.filters.names.spaces': 'Space',
    'search-page.filters.names.status': 'Status',
    'search-page.filters.names.titleMatchOnly': 'Search title only',
    'search-page.filters.names.type': 'Type',
    'search-page.filters.names.verified': 'Verified',
    'search-page.filters.names.work-commented-on': "Work I've commented on",
    'search-page.filters.names.work-watching': "Work I\u2019m watching",
    'search-page.filters.suggested-filters-section-label': 'Suggested',
    'search-page.google-drive.filter.drive.placeholder': 'Find drives',
    'search-page.jira-assignee.assignee': 'Assignee: {assigneeName}',
    'search-page.jira-assignee.unassigned': 'Unassigned',
    'search-page.jira.filter.assignee.placeholder': 'Find people',
    'search-page.jira.filter.assignee.selected': 'Selected',
    'search-page.jira.filter.assignee.unselected': 'Suggested',
    'search-page.jira.filter.project.placeholder': 'Find projects',
    'search-page.jira.filter.project.selected': 'Selected',
    'search-page.jira.filter.project.unselected': 'Suggested',
    'search-page.jira.filter.reporter.placeholder': 'Find people',
    'search-page.jira.filter.reporter.selected': 'Selected',
    'search-page.jira.filter.reporter.unselected': 'Suggested',
    'search-page.jira.filter.spaces.placeholder': 'Find spaces',
    'search-page.jira.filter.spaces.selected': 'Selected',
    'search-page.jira.filter.spaces.unselected': 'Suggested',
    'search-page.linked-pull-requests.expand-label': '{count}{hasMore, select, true {+} other {}} {count, plural, one {Pull request} other {Pull requests}}',
    'search-page.linked-pull-requests.last-updated': 'Updated {relativeTime}',
    'search-page.linked-pull-requests.metadata-label': 'Pull Request',
    'search-page.linked-pull-requests.pull-request-id': 'ID# {prId}',
    'search-page.linked-pull-requests.reviewer-count': '{count, plural, =0 {No reviewers} one {# reviewer} other {# reviewers}}',
    'search-page.linked-pull-requests.status-declined': 'Declined',
    'search-page.linked-pull-requests.status-draft': 'Draft',
    'search-page.linked-pull-requests.status-merged': 'Merged',
    'search-page.linked-pull-requests.status-open': 'Open',
    'search-page.linked-pull-requests.status-unknown': 'Unknown',
    'search-page.linked-results.comments': 'Comments',
    'search-page.linked-results.external-link': 'External link',
    'search-page.linked-results.found-in': 'Found in',
    'search-page.linked-results.mentioned-in': 'Mentioned in',
    'search-page.linked-results.related': 'Related links',
    'search-page.linked-results.related-pages': 'Related pages',
    'search-page.linked-results.see-all': 'See all',
    'search-page.linked-results.show-more': 'Show {count} more',
    'search-page.linked-results.similar': '{count} similar',
    'search-page.mercury.filter.content.placeholder': 'Find focus areas',
    'search-page.mercury.filter.content.selected': 'Selected',
    'search-page.mercury.filter.content.unselected': 'Suggested',
    'search-page.mercury.filter.focusAreaType.label.selected': 'Selected',
    'search-page.mercury.filter.focusAreaType.label.unselected': 'Suggested',
    'search-page.mercury.filter.focusAreaType.placeholder': 'Find focus area types',
    'search-page.mercury.focus-area-update.title': 'Update for {focusAreaName}',
    'search-page.navigation.search.work-items': 'Search work items',
    'search-page.nouns.goal': 'Goal',
    'search-page.nouns.goals': 'Goals',
    'search-page.nouns.project': 'Project',
    'search-page.nouns.projects': 'Projects',
    'search-page.nouns.tag': 'Tag',
    'search-page.nouns.tags': 'Tags',
    'search-page.products.custom-website': 'Web page',
    'search-page.products.custom-websites': 'Web pages',
    'search-page.profile-avatar.label': 'Person Avatar',
    'search-page.quick-find.dialog.banners.github-tip.dismissBannerLabel': 'Dismiss GitHub tip',
    'search-page.quick-find.dialog.banners.github-tip.oauthFailFlagTitle': 'Could not connect to GitHub',
    'search-page.quick-find.dialog.banners.github-tip.oauthSuccessFlagDescription': 'You can now find and action on PRs, commits, and repos in Rovo Search and Chat.',
    'search-page.quick-find.dialog.banners.github-tip.oauthSuccessFlagTitle': 'GitHub connected',
    'search-page.quick-find.dialog.banners.github-tip.tipBanner': '<b>Tip:</b> <connectLink>Connect GitHub</connectLink> to find and action on PRs, issues, and repos in your search results.',
    'search-page.quick-find.filters.product-filters.loom-space.loomFilterLabelSelected': 'Selected',
    'search-page.quick-find.filters.product-filters.loom-space.loomFilterLabelUnselected': 'Suggested',
    'search-page.quick-find.filters.product-filters.loom-space.loomFilterSpaceIcon': 'Space Icon',
    'search-page.quick-find.filters.product-filters.loom-space.loomFilterSpacePlaceholder': 'Find spaces',
    'search-page.quick-find.filters.product-filters.loom-space.loomSpace': 'Space',
    'search-page.relay.compass.owner-name': 'Owned by {ownerName}',
    'search-page.relay.compass.tier': 'Tier {tier}',
    'search-page.results.private-result-label': 'Private',
    'search-page.results.private-result-tooltip': 'Only visible to you',
    'search-page.results.product-results.third-party.channel-member-count': '{memberCount, plural, one {# member} other {# members}}',
    'search-page.results.product-results.third-party.channel-type-label': 'Channel',
    'search-page.results.product-results.third-party.external-people-label': 'External people',
    'search-page.results.product-results.third-party.external-person-label': 'External person',
    'search-page.results.product-results.third-party.last-active': 'Last active {relativeDate}',
    'search-page.results.product-results.third-party.message-search-result.message-result-lock-icon-tooltip': 'Restricted - Only specific people can see this result',
    'search-page.results.product-results.third-party.message-type-label': 'Message',
    'search-page.results.product-results.third-party.no-contributors-label': 'External people in #{channelName}',
    'search-page.results.product-results.third-party.private-conversation-text': '{users} in a private conversation',
    'search-page.results.product-results.third-party.thread-type-label': 'Thread',
    'search-page.results.product-results.third-party.title-and-channel-name': '{title} in #{channelName}',
    'search-page.results.product-results.third-party.title-with-remaining-contributors': '{title} and {remainingContributorsCount} {remainingContributorsCount, plural, one {other} other {others}}',
    'search-page.results.restricted-result-label': 'Restricted',
    'search-page.results.restricted-result-tooltip': 'Only visible to specific people',
    'search-page.salesforce.filter.campaignStatus': 'Campaign status',
    'search-page.salesforce.filter.campaignStatus.no-options': 'No statuses available',
    'search-page.salesforce.filter.caseStatus': 'Case status',
    'search-page.salesforce.filter.caseStatus.no-options': 'No statuses available',
    'search-page.salesforce.filter.dealStatus': 'Deal status',
    'search-page.salesforce.filter.stage': 'Deal stage',
    'search-page.salesforce.filter.stage.closed-lost-send-survey': 'Closed Lost (Send Survey)',
    'search-page.salesforce.filter.stage.closed-won': 'Closed Won',
    'search-page.salesforce.filter.stage.closed-won-auto-linked': 'Closed Won (Auto Linked)',
    'search-page.salesforce.filter.stage.develop-opportunity': 'Develop Opportunity',
    'search-page.salesforce.filter.stage.invalid-opp': 'Invalid Opp',
    'search-page.salesforce.filter.stage.lost': 'Lost',
    'search-page.salesforce.filter.stage.new': 'New',
    'search-page.salesforce.filter.stage.no-opportunity': 'No Opportunity',
    'search-page.salesforce.filter.stage.no-options': 'No stages available',
    'search-page.salesforce.filter.stage.qualify-opportunity': 'Qualify Opportunity',
    'search-page.search-link.label': 'Search Link',
    'search-page.search-page-header.search-results': 'Search results',
    'search-page.search-page-relay.search-results.search-result.search-result-renderer.search-graph-code.code': 'Code',
    'search-page.sharepoint.filter.site.placeholder': 'Find sites',
    'search-page.show-more-breadcrumbs-button-label': 'Show more breadcrumbs',
    'search-page.tab-filter.accessible-more-dropdown-label': 'Filter by more apps',
    'search-page.tab-filter.all-filter-accessible-label': 'Filter by all apps',
    'search-page.tab-filter.all-filter-visual-label': 'All',
    'search-page.tab-filter.more-dropdown-label': 'More',
    'search-page.talent.filter.focus-area.content.placeholder': 'Find focus areas',
    'search-page.talent.filter.focus-area.content.selected': 'Selected',
    'search-page.talent.filter.focus-area.content.unselected': 'Suggested',
    'search-page.talent.filter.position-employment-type.content.placeholder': 'Find employment types',
    'search-page.talent.filter.position-employment-type.content.selected': 'Selected',
    'search-page.talent.filter.position-employment-type.content.unselected': 'Suggested',
    'search-page.talent.filter.position-job-family.content.placeholder': 'Find job families',
    'search-page.talent.filter.position-job-family.content.selected': 'Selected',
    'search-page.talent.filter.position-job-family.content.unselected': 'Suggested',
    'search-page.talent.filter.position-status-filter.content.placeholder': 'Find filled status',
    'search-page.talent.filter.position-status-filter.content.selected': 'Selected',
    'search-page.talent.filter.position-status-filter.content.unselected': 'Suggested',
    'search-page.talent.filter.position-team.content.placeholder': 'Find teams',
    'search-page.talent.filter.position-team.content.selected': 'Selected',
    'search-page.talent.filter.position-team.content.unselected': 'Suggested',
    'search-page.verified-icon-label': 'Verified',
    'search-page.verified-icon-tooltip-message': 'This page has been verified by an owner or admin.',
    'search-pull-request-result.comments-label': '{count} {count, plural, one {comment} other {comments}}',
    'search-pull-request-result.label': 'Pull request',
    'search-pull-request-result.status.declined': 'Declined',
    'search-pull-request-result.status.draft': 'Draft',
    'search-pull-request-result.status.merged': 'Merged',
    'search-pull-request-result.status.open': 'Open',
    'search-pull-request-result.status.unknown': 'Unknown',
    'search-respository-result.label': 'Repository',
    'search-result.direct-message-single-user': '{name1} and 1 other',
    'search-result.direct-message-two-users': '{name1} and {name2}',
    'search-result.federated-group-direct-message': '{knownNamesCount, plural, =1 {{name1}} =2 {{name1} and {name2}} =3 {{name1}, {name2}, and {name3}} =4 {{name1}, {name2}, {name3}, and {name4}} other {{name1}, {name2}, {name3}, and {name4}} }',
    'search-result.federated-group-direct-message-with-multiple-others': '{knownNamesCount, plural, =1 {{name1} and {totalOthersCount} others} =2 {{name1}, {name2}, and {totalOthersCount} others} =3 {{name1}, {name2}, {name3}, and {totalOthersCount} others} =4 {{name1}, {name2}, {name3}, {name4}, and {totalOthersCount} others} other {{name1}, {name2}, {name3}, {name4}, and {totalOthersCount} others} }',
    'search-result.federated-group-direct-message-with-one-other': '{knownNamesCount, plural, =1 {{name1} and {totalOthersCount} other} =2 {{name1}, {name2}, and {totalOthersCount} other} =3 {{name1}, {name2}, {name3}, and {totalOthersCount} other} =4 {{name1}, {name2}, {name3}, {name4}, and {totalOthersCount} other} other {{name1}, {name2}, {name3}, {name4}, and {totalOthersCount} other} }',
    'search-result.group-chat-title': '{contributorCount, plural, =0 {Group message with external users} =1 {{name1}} =2 {{name1} and {name2}} =3 {{name1}, {name2}, and {name3}} =4 {{name1}, {name2}, {name3}, and {overflowContributorCount} other} other {{name1}, {name2}, {name3}, and {overflowContributorCount} others} }',
    'search-result.group-direct-message-unknown-names': '{totalPeopleCount} people',
    'search-result.group-meeting-title': '{contributorCount, plural, =0 {} =1 {{name1} in } =2 {{name1} and {name2} in } =3 {{name1}, {name2}, and {name3} in } =4 {{name1}, {name2}, {name3}, and {overflowContributorCount} other in } other {{name1}, {name2}, {name3}, and {overflowContributorCount} others in } }{channelName}',
    'search-result.last-modified': 'Updated {formattedDate}',
    'search-result.private-channel-label': 'Private Channel',
    'search-result.remove-recent-search': 'Remove recent search icon',
    'search-result.remove-recent-search-result-subheading': 'Recent search',
    'search-result.thread-title-with-others-and-channel-name': '{contributorCount, plural, =0 {} =1 {{name1} in } =2 {{name1} and {name2} in } =3 {{name1}, {name2}, and {name3} in } =4 {{name1}, {name2}, {name3}, and {overflowContributorCount} other in } other {{name1}, {name2}, {name3}, and {overflowContributorCount} others in } }#{channelName}',
    'search-result.unknown-channel-in-thread': 'unknown-channel',
    'search-result.user-mention.external-person': 'External person',
    'search.quickFind.intentRouter.allApps': 'All apps',
    'search.quickFind.intentRouter.jiraWorkItemsJql': 'Jira work items (JQL)',
    'search.quickFind.intentRouter.searchForAllApps': 'Search for all apps',
    'search.quickFind.intentRouter.searchForJiraWorkItems': 'Search for Jira work items',
    'searchDialog.apply.suggested.filter': 'Apply filter',
    'searchDialog.suggested.filter': 'Suggested filter',
    'searchDialog.suggestedFilter.filterName.assignee': 'assignee',
    'searchDialog.suggestedFilter.filterName.product': 'app',
    'searchDialog.suggestedFilter.filterName.project': 'project',
    'searchDialog.suggestedFilter.icon.label': 'Suggestion search',
    search_dialog_aria_label: 'Search Dialog',
    search_dialog_assets_unavailable_message: '<bold>Assets</bold> will be available here soon. For now, try <searchLink>Assets search</searchLink>.',
    search_dialog_autocomplete_suggestion: 'Suggestion',
    search_dialog_dismiss_banner_label: 'Dismiss banner',
    search_dialog_error_search_body: 'It might just be a hiccup. Please try refreshing the page or <button>try again</button>.',
    search_dialog_error_search_heading: "We're having trouble loading your recently viewed content.",
    search_dialog_feedback_footer: 'Help us improve search',
    search_dialog_no_content_body: "Search for what you're looking for in your Atlassian and integrated apps",
    search_dialog_no_content_body_default: 'Search for anything across your Atlassian apps',
    search_dialog_no_content_body_with_ai: "Search or ask what you're looking for in your Atlassian and integrated apps",
    search_dialog_no_content_body_with_atlassian_intelligence: 'Search or ask anything across your Atlassian apps',
    search_dialog_no_content_body_with_rovo: "Search or ask Rovo what you're looking for in your Atlassian and integrated apps",
    search_dialog_no_content_heading: 'Seek and you shall find',
    search_dialog_no_results_heading: "We couldn't find any results with that title",
    search_dialog_no_results_search_body: '<link>Search all content across your organization</link> or try again with a different term.',
    search_dialog_recent_search: 'Recent search',
    search_dialog_recents_heading: 'Recent',
    search_dialog_recommendations_heading: 'Recommendations',
    search_dialog_recommended_heading: 'Recommended',
    search_dialog_remove_recent_search_label: 'Remove recent search',
    search_dialog_rovo_banner_message: "Enter a question like \u201CWhat\u2019s the vacation policy?\u201D and Rovo will find the answer",
    search_dialog_rovo_tip: 'Rovo tip:',
    search_dialog_search_across_products: 'Search all apps',
    'search_dialog_search_across_products.more': 'more',
    'search_dialog_search_across_products.more-apps': '+ {more}',
    'search_dialog_search_across_products.more-apps-count': '+{count}',
    search_dialog_search_change_message: 'Why has search changed?',
    search_dialog_team: 'Team',
    search_dialog_zero_query: 'Suggestion',
    search_dialog_zero_query_collaborator_profile_suggestion: "{personAvatar} {name}'s profile",
    search_dialog_zero_query_confluence_pages_created_30_days_suggestion: '{productIcon} Confluence pages I created in the {dateIcon} last 30 days',
    search_dialog_zero_query_confluence_pages_created_7_days_suggestion: '{productIcon} Confluence pages I created in the {dateIcon} last 7 days',
    search_dialog_zero_query_confluence_pages_created_collaborator_7_days_suggestion: '{productIcon} Confluence pages created by {personAvatar} {name} in the {dateIcon} last 7 days',
    search_dialog_zero_query_confluence_pages_created_collaborator_last_30_days_suggestion: '{productIcon} Confluence pages created by {personAvatar} {name} in the {dateIcon} last 30 days',
    search_dialog_zero_query_confluence_pages_created_collaborator_suggestion: '{productIcon} Confluence pages created by {personAvatar} {name}',
    search_dialog_zero_query_confluence_pages_created_suggestion: '{productIcon} Confluence pages I created',
    search_dialog_zero_query_icon_label: 'Suggestion search',
    search_dialog_zero_query_issues_assigned_to_me_in_the_past_7_days_suggestion: 'Issues assigned to me in the past 7 days',
    search_dialog_zero_query_issues_i_created_in_the_last_month_suggestion: 'Issues I created in the last month',
    search_dialog_zero_query_jira_my_work_items_suggestion: 'Show my {productIcon} work items',
    search_dialog_zero_query_jira_nlq_collaborator_suggestion: 'Recent open items assigned to {name}',
    search_dialog_zero_query_jira_nlq_progress_for_epics_created_by_me_suggestion: 'Progress for epics created by me',
    search_dialog_zero_query_jira_tickets_assigned_collaborator_suggestion: '{productIcon} tickets assigned to {personAvatar} {name}',
    search_dialog_zero_query_jira_tickets_assigned_suggestion: '{productIcon} Jira tickets assigned to me',
    search_dialog_zero_query_jira_tickets_created_collaborator_suggestion: '{productIcon} Jira tickets created by {personAvatar} {name}',
    search_dialog_zero_query_jira_tickets_created_suggestion: '{productIcon} Jira tickets I created',
    search_dialog_zero_query_recent_tickets_created_by_me_suggestion: 'Recent tickets created by me',
    search_dialog_zero_query_show_all_the_bugs_assigned_to_me_suggestion: 'Show all the bugs assigned to me',
    search_dialog_zero_query_show_high_priority_tickets_assigned_to_me_suggestion: 'Show high priority tickets assigned to me',
    search_dialog_zero_query_show_me_all_of_my_in_progress_work_items_suggestion: 'Show me all of my in-progress work items',
    search_dialog_zero_query_show_tickets_due_this_week_suggestion: 'Show tickets due this week',
    search_dialog_zero_query_third_party_google_collaborator_docs_suggestion: '{productIcon} Google docs from {personAvatar} {name}',
    search_dialog_zero_query_third_party_google_my_docs_suggestion: 'My {productIcon} Google Drive docs',
    search_dialog_zero_query_third_party_sharepoint_collaborator_docs_suggestion: '{productIcon} SharePoint docs from {personAvatar} {name}',
    search_dialog_zero_query_third_party_sharepoint_my_docs_suggestion: 'My {productIcon} SharePoint documents',
    search_dialog_zero_query_third_party_slack_collaborator_messages_suggestion: '{productIcon} Slack messages from {personAvatar} {name}',
    search_dialog_zero_query_third_party_slack_my_messages_suggestion: 'My {productIcon} Slack messages',
    search_dialog_zero_query_what_are_my_open_tickets_suggestion: 'What are my open tickets?',
    search_dialog_zero_query_who_is_suggestion: 'Who is {name}?',
    'search_filters.more': 'more',
    'search_filters.more-apps-search': 'Open full page search for this term searching all apps',
    'search_page.lite_app_filter_bar.all': 'All',
    'search_page.lite_app_filter_bar.all_apps': 'All apps',
    'search_page.lite_app_filter_bar.connect': 'Connect',
    'search_page.lite_app_filter_bar.connect_app_aria': 'Connect {app}',
    'search_page.lite_app_filter_bar.connect_apps': 'Connect apps',
    'search_page.lite_header.feedback_button_label': 'Feedback',
    search_result_skeleton_loading_result: 'Loading result',
    search_result_type_answer: 'Answer',
    search_result_type_ask: 'Ask',
    search_result_type_attachment: 'Attachment',
    search_result_type_blogpost: 'Blog Post',
    search_result_type_board: 'Board',
    search_result_type_branch: 'Branch',
    search_result_type_bug: 'Bug',
    search_result_type_calendar: 'Calendar',
    search_result_type_card: 'Card',
    search_result_type_change: 'Change',
    search_result_type_channel: 'Channel',
    search_result_type_comment: 'Comment',
    search_result_type_commit: 'Commit',
    search_result_type_component: 'Component',
    search_result_type_customer_contact: 'Customer contact',
    search_result_type_customer_org: 'Customer Organization',
    search_result_type_dashboard: 'Dashboard',
    search_result_type_data_table: 'Data table',
    search_result_type_database: 'Database',
    search_result_type_deal: 'Deal',
    search_result_type_document: 'Document',
    search_result_type_email: 'Email',
    search_result_type_embed: 'Smart Link',
    search_result_type_epic: 'Epic',
    search_result_type_file: 'File',
    search_result_type_filter: 'Filter',
    search_result_type_focus_area: 'Focus area',
    search_result_type_focus_area_status_update: 'Focus area update',
    search_result_type_folder: 'Folder',
    search_result_type_gliffy: 'Gliffy Diagram',
    search_result_type_goal: 'Goal',
    search_result_type_improvement: 'Improvement',
    search_result_type_incident: 'Incident',
    search_result_type_issue: 'Work item',
    search_result_type_learning: 'Learning',
    search_result_type_message: 'Message',
    search_result_type_new_feature: 'New feature',
    search_result_type_object: 'Object',
    search_result_type_page: 'Page',
    search_result_type_plan: 'Plan',
    search_result_type_position: 'Position',
    search_result_type_presentation: 'Presentation',
    search_result_type_problem: 'Problem',
    search_result_type_project: 'Project',
    search_result_type_pull_request: 'Pull Request',
    search_result_type_question: 'Question',
    search_result_type_repository: 'Repository',
    search_result_type_schema: 'Schema',
    search_result_type_service_request: 'Service request',
    search_result_type_sharepoint_document: 'Sharepoint Document',
    search_result_type_slide: 'Slides',
    search_result_type_space: 'Space',
    search_result_type_space_calendar: 'Space calendar',
    search_result_type_spreadsheet: 'Spreadsheet',
    search_result_type_story: 'Story',
    search_result_type_sub_task: 'Sub-task',
    search_result_type_subtask: 'Sub-task',
    search_result_type_tag: 'Tag',
    search_result_type_task: 'Task',
    search_result_type_type: 'Object type',
    search_result_type_unrecognised: 'Unrecognised',
    search_result_type_video: 'Video',
    search_result_type_whiteboard: 'Whiteboard',
    search_result_type_work_item: 'Work Item',
    search_results_lite_issue_table_header_assignee: 'Assignee',
    search_results_lite_issue_table_header_labels: 'Labels',
    search_results_lite_issue_table_header_priority: 'Priority',
    search_results_lite_issue_table_header_status: 'Status',
    search_results_lite_issue_table_header_work: 'Work',
    search_results_lite_project_table_header_category: 'Category',
    search_results_lite_project_table_header_key: 'Key',
    search_results_lite_project_table_header_lead: 'Lead',
    search_results_lite_project_table_header_spaceUrl: 'Space URL',
    search_results_lite_project_table_header_spaces: 'Spaces',
    search_results_lite_project_table_header_type: 'Type',
    'search_talent_position.external_position_key': 'External key {positionExternalKey}',
    'search_talent_position.position_title': '{preferredName, select, undefined {{positionKey}} other {{positionKey}: {preferredName}}}',
    'sidebar-authorize_connect_third_party_product': 'Your admin has added <strong>{product}!</strong>{br} Connect your account to see missing results, including documents only you have access to.',
    'sidebar-authorize_connect_third_party_product_alternate_msg': '<strong>{product} is now available!</strong>{br} Connect your account to see missing results, including content only you have access to.',
    'sidebar-oauth-warning-authorize': 'Authorize',
    'sidebar-oauth-warning-dismiss': 'Dismiss',
    'sidebar-oauth-warning.app-filter-tooltip-content': 'Connect your account to see missing results, including documents only you have access to.',
    'sidebar-oauth-warning.app-filter-tooltip-content-alternate': 'Connect your account to see missing results, including content only you have access to.',
    'sidebar-oauth-warning.authorization-fail': 'Failed to connect to {product}.',
    'sidebar-oauth-warning.authorization-success': 'Successfully connected to {product}.',
    'sidebar-oauth-warning.connect': 'Connect',
    'sidebar-oauth-warning.not-now': 'Not now',
    'space.label': 'Space',
    'spreadsheet.label': 'Spreadsheet',
    suggestion: 'See all results for "{inputQuery}" across apps',
    'summarize-in-chat-button-text': 'Summarize',
    'summarize-in-chat-label': 'Summarize',
    'task.label': 'Task',
    team: 'Team',
    'third-party-query-suggestion.dismiss': 'Dismiss',
    'third-party-query-suggestion.title': 'Do smarter searches with {product}',
    updatedNewest: 'Updated (newest)',
    updatedOldest: 'Updated (oldest)',
    'video.label': 'Video',
    'web-page.label': 'Web Page',
    whiteboard_type: 'Whiteboard',
    'work-item-assignee.assigned': '{isAssigned, select, internal {{firstName} is assigned} other {External person is assigned}}',
    'work-item-creator.created': '{created, select, internal {{firstName} created} other {External person created}}',
    'work-item-status.for': '{statusLozenge} for {dateLozenge}',
    'work-item.label': 'Work Item',
    work_item: 'Work item',
    your_recent_results_heading: 'Your recent results'
};


var $6b9649fc867121cb$export$2e2bcd8739ae039 = (0, $3c312875d27f019c$export$2e2bcd8739ae039);

});

parcelRegister("6JMMA", function(module, exports) {

let $4e7cc93dda848f3b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4e7cc93dda848f3b$var$load("ipx3Q").then(()=>parcelRequire('eYbiR'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("7SFxt", function(module, exports) {

let $5bcdcc4a9d15718a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5bcdcc4a9d15718a$var$load("jXMUM").then(()=>parcelRequire('gaER3'));

});

parcelRegister("iG4FS", function(module, exports) {

let $d98fc67ba6d57d84$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d98fc67ba6d57d84$var$load("idV8v").then(()=>parcelRequire('53G40'));

});

parcelRegister("10hdm", function(module, exports) {

let $0bb324f86a9053f2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0bb324f86a9053f2$var$load("kBQ9k").then(()=>parcelRequire('lba8D'));

});

parcelRegister("hqwTK", function(module, exports) {

let $03462ae01f1d9d22$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $03462ae01f1d9d22$var$load("birQa").then(()=>parcelRequire('jShwN'));

});

parcelRegister("48gEg", function(module, exports) {

let $3024d2cd3b4a7121$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3024d2cd3b4a7121$var$load("01Ull").then(()=>parcelRequire('bQ8q0'));

});

parcelRegister("3ggR2", function(module, exports) {

let $25fff0b07fb99e67$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $25fff0b07fb99e67$var$load("iyrsM").then(()=>parcelRequire('duFs7'));

});

parcelRegister("9kNdt", function(module, exports) {

let $6cbc28a4e9b946ca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6cbc28a4e9b946ca$var$load("hPFdF").then(()=>parcelRequire('6lV5D'));

});

parcelRegister("6of6C", function(module, exports) {

let $4a70b3a51fda55ea$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4a70b3a51fda55ea$var$load("k7AqX").then(()=>parcelRequire('2Ktmn'));

});

parcelRegister("gFJ5o", function(module, exports) {

let $c23372d38e32e554$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c23372d38e32e554$var$load("8sFBs").then(()=>parcelRequire('aBN5I'));

});

parcelRegister("k9sQX", function(module, exports) {

let $eabb0786d5dc9459$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $eabb0786d5dc9459$var$load("iULA4").then(()=>parcelRequire('eLHIJ'));

});

parcelRegister("7AG2g", function(module, exports) {

let $586c8095331e2971$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $586c8095331e2971$var$load("gJ4Zj").then(()=>parcelRequire('7jApd'));

});

parcelRegister("17jtA", function(module, exports) {

let $0d058d763f852b42$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0d058d763f852b42$var$load("fvcGb").then(()=>parcelRequire('kAnOM'));

});

parcelRegister("3sG8V", function(module, exports) {

let $2854ad562d0c406c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2854ad562d0c406c$var$load("30u08").then(()=>parcelRequire('bTqAy'));

});

parcelRegister("3wwJC", function(module, exports) {

let $290dc0b22e8edaa1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $290dc0b22e8edaa1$var$load("bEohT").then(()=>parcelRequire('1KXQd'));

});

parcelRegister("115hq", function(module, exports) {

let $0bd9faeee4f22628$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0bd9faeee4f22628$var$load("4TfaY").then(()=>parcelRequire('fICFY'));

});

parcelRegister("chAaE", function(module, exports) {

let $8f132150cfa01d05$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8f132150cfa01d05$var$load("7TRKR").then(()=>parcelRequire('feBfk'));

});

parcelRegister("7yG1I", function(module, exports) {

let $580c4f05ef6bb8b6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $580c4f05ef6bb8b6$var$load("gfmgP").then(()=>parcelRequire('8NaIX'));

});

parcelRegister("15Txp", function(module, exports) {

let $0cc156bf565075f6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0cc156bf565075f6$var$load("8rjqC").then(()=>parcelRequire('4Lyyx'));

});

parcelRegister("8fmsn", function(module, exports) {

let $601124dea6226b2f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $601124dea6226b2f$var$load("c1meM").then(()=>parcelRequire('76EPm'));

});

parcelRegister("cGi9X", function(module, exports) {

let $93b77e6824d5d3d6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $93b77e6824d5d3d6$var$load("hnoAT").then(()=>parcelRequire('6ZHgv'));

});

parcelRegister("95rIQ", function(module, exports) {

let $69da15bd4d10a1f3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $69da15bd4d10a1f3$var$load("h2yiB").then(()=>parcelRequire('ffVcI'));

});

parcelRegister("6IgfV", function(module, exports) {

let $4e3376305010918c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4e3376305010918c$var$load("7t9jv").then(()=>parcelRequire('9Cgjy'));

});

parcelRegister("5cgH8", function(module, exports) {

let $3c8b05f7461dc730$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3c8b05f7461dc730$var$load("02wkF").then(()=>parcelRequire('k3N88'));

});

parcelRegister("kZgWD", function(module, exports) {

let $f476a601f5a5179c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f476a601f5a5179c$var$load("f9I75").then(()=>parcelRequire('gVxyq'));

});

parcelRegister("a9O5n", function(module, exports) {

let $7651989b8976896d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7651989b8976896d$var$load("2ArFg").then(()=>parcelRequire('bEtBH'));

});

parcelRegister("1Yvyf", function(module, exports) {

let $1703de806dc28a72$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1703de806dc28a72$var$load("a0qFU").then(()=>parcelRequire('4qCpI'));

});

parcelRegister("bKS5F", function(module, exports) {

let $88edf2ca5ce08964$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $88edf2ca5ce08964$var$load("3aliZ").then(()=>parcelRequire('121eu'));

});

parcelRegister("38PKm", function(module, exports) {

let $249a4243d610f87b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $249a4243d610f87b$var$load("k4Fbc").then(()=>parcelRequire('4mIHV'));

});

parcelRegister("1uiyk", function(module, exports) {

let $1156fbf5734fffc0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1156fbf5734fffc0$var$load("aMWDh").then(()=>parcelRequire('8pfQd'));

});

parcelRegister("dwWyj", function(module, exports) {

let $9d9baecb2c2e214a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9d9baecb2c2e214a$var$load("2Nhk7").then(()=>parcelRequire('frmvq'));

});

parcelRegister("7ahd4", function(module, exports) {

let $5376d113c4c6d637$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5376d113c4c6d637$var$load("5GgLt").then(()=>parcelRequire('l1TrV'));

});

parcelRegister("6dBQl", function(module, exports) {

let $48714fdaf6e1f7d8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $48714fdaf6e1f7d8$var$load("aeBaj").then(()=>parcelRequire('98mG9'));

});

parcelRegister("2v8Gz", function(module, exports) {

let $1d2536ca680228a6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1d2536ca680228a6$var$load("icI5m").then(()=>parcelRequire('3Fipj'));

});

parcelRegister("g7B9r", function(module, exports) {

let $bbca1e42fd1786af$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bbca1e42fd1786af$var$load("56ebG").then(()=>parcelRequire('ZePYR'));

});

parcelRegister("kQel5", function(module, exports) {

let $f2c3c96681b53a0e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f2c3c96681b53a0e$var$load("bpm6H").then(()=>parcelRequire('56K08'));

});

parcelRegister("jfXoT", function(module, exports) {

let $e04d7ec2c3f45686$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e04d7ec2c3f45686$var$load("lQBW4").then(()=>parcelRequire('dhb2r'));

});

parcelRegister("1RWPz", function(module, exports) {

let $15c860455cb64527$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $15c860455cb64527$var$load("d3Pby").then(()=>parcelRequire('3jBpL'));

});

parcelRegister("hnggZ", function(module, exports) {

let $ca61351d725fb4d7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ca61351d725fb4d7$var$load("i3KTR").then(()=>parcelRequire('3lSRV'));

});

parcelRegister("bpipP", function(module, exports) {

let $84e05076b6a9ac37$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $84e05076b6a9ac37$var$load("jQsR5").then(()=>parcelRequire('hkrs8'));

});

parcelRegister("1nlci", function(module, exports) {

let $100861ccafaf2cfd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $100861ccafaf2cfd$var$load("buYUs").then(()=>parcelRequire('kjY3o'));

});

parcelRegister("7xBft", function(module, exports) {

let $57d88247e0753c55$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $57d88247e0753c55$var$load("6JyvA").then(()=>parcelRequire('3iKYt'));

});

parcelRegister("bVHQO", function(module, exports) {

let $023dca7582168c9a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $023dca7582168c9a$var$load("6j4E0").then(()=>parcelRequire('7TbNk'));

});

parcelRegister("3kdAT", function(module, exports) {

let $26bdc8d9155a2afa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $26bdc8d9155a2afa$var$load("dx2gW").then(()=>parcelRequire('1a2R6'));

});

parcelRegister("hgkdN", function(module, exports) {

let $c9139dd72d99548e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c9139dd72d99548e$var$load("kRxC0").then(()=>parcelRequire('5aoCz'));

});

parcelRegister("cHN0H", function(module, exports) {

let $93ff849fb6339afb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $93ff849fb6339afb$var$load("6VYUF").then(()=>parcelRequire('jRotk'));

});

parcelRegister("5oUTu", function(module, exports) {

let $3eeb5399523d2931$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3eeb5399523d2931$var$load("iTCSz").then(()=>parcelRequire('1AIxH'));

});

parcelRegister("agank", function(module, exports) {

let $7783724eb6b1ebb9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7783724eb6b1ebb9$var$load("9vlOp").then(()=>parcelRequire('19wre'));

});

parcelRegister("kqPpj", function(module, exports) {

let $edfe1cca38752f3f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $edfe1cca38752f3f$var$load("9fdZA").then(()=>parcelRequire('aoQCd'));

});

parcelRegister("1glw4", function(module, exports) {

let $0eb7f9b9f0893ad0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0eb7f9b9f0893ad0$var$load("c1Rfq").then(()=>parcelRequire('9xJII'));

});

parcelRegister("bXCJU", function(module, exports) {

let $023f473ef8848a36$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $023f473ef8848a36$var$load("b4t5O").then(()=>parcelRequire('ix8pw'));

});

parcelRegister("inmxY", function(module, exports) {

let $d60bdd5bc04d8548$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d60bdd5bc04d8548$var$load("lPFUB").then(()=>parcelRequire('lFkoK'));

});

parcelRegister("8AA5B", function(module, exports) {

let $640dae1818e8ec84$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $640dae1818e8ec84$var$load("cCO7Q").then(()=>parcelRequire('bN4cF'));

});

parcelRegister("l8rBv", function(module, exports) {

let $f62fc1e6ddfe9861$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f62fc1e6ddfe9861$var$load("eGYFX").then(()=>parcelRequire('2F5a9'));

});

parcelRegister("9VCF3", function(module, exports) {

let $73a76d3b9572851f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $73a76d3b9572851f$var$load("e0Zpf").then(()=>parcelRequire('kmRRg'));

});

parcelRegister("aMD9S", function(module, exports) {

let $7d9cc316e842b8df$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7d9cc316e842b8df$var$load("3mO4w").then(()=>parcelRequire('kebSA'));

});

parcelRegister("jyIFt", function(module, exports) {

let $e3d3d769f429c96f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e3d3d769f429c96f$var$load("fJV8L").then(()=>parcelRequire('hn9Es'));

});

parcelRegister("jq2Ox", function(module, exports) {

let $e232a0ddfbbf4bbf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e232a0ddfbbf4bbf$var$load("aFaOB").then(()=>parcelRequire('3bY7C'));

});

parcelRegister("b0Quq", function(module, exports) {

let $8048692bb880fc15$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8048692bb880fc15$var$load("c243Q").then(()=>parcelRequire('amfAy'));

});

parcelRegister("gHqSP", function(module, exports) {

let $c28583faa68729fc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c28583faa68729fc$var$load("9pwoj").then(()=>parcelRequire('jE8NI'));

});

parcelRegister("kDZ63", function(module, exports) {

let $f076d7ab8746cca8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f076d7ab8746cca8$var$load("jbmlj").then(()=>parcelRequire('gQzYt'));

});

parcelRegister("2ZJxd", function(module, exports) {

let $22e49988b987c520$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $22e49988b987c520$var$load("2YMwz").then(()=>parcelRequire('eXryL'));

});

parcelRegister("lIvrR", function(module, exports) {

let $fcf61a0388512b69$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fcf61a0388512b69$var$load("apc1e").then(()=>parcelRequire('032ju'));

});

parcelRegister("1kUhq", function(module, exports) {

let $0f9350ba6478536c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0f9350ba6478536c$var$load("hSszq").then(()=>parcelRequire('3Zq6F'));

});

parcelRegister("59IhA", function(module, exports) {

let $3c1024a4be3cc7dd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3c1024a4be3cc7dd$var$load("hMErM").then(()=>parcelRequire('ly2jc'));

});

parcelRegister("kkRV8", function(module, exports) {

let $ecdf8068510ccdc3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ecdf8068510ccdc3$var$load("4mauf").then(()=>parcelRequire('9UaNh'));

});

parcelRegister("5dGG6", function(module, exports) {

let $3ccf459a424bedfb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3ccf459a424bedfb$var$load("cV78a").then(()=>parcelRequire('6jtTg'));

});

parcelRegister("67rtf", function(module, exports) {

let $0126557e69c77c6d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0126557e69c77c6d$var$load("a5JUA").then(()=>parcelRequire('cB3yu'));

});

parcelRegister("bbmuy", function(module, exports) {

let $82422b366a4f84a3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $82422b366a4f84a3$var$load("1MwbL").then(()=>parcelRequire('3omfl'));

});

parcelRegister("5pwE4", function(module, exports) {

let $3f089c336808afdd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3f089c336808afdd$var$load("4ep0R").then(()=>parcelRequire('BiK8L'));

});

parcelRegister("lb7B1", function(module, exports) {

let $f6b0847aa0adc9db$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f6b0847aa0adc9db$var$load("6cdZj").then(()=>parcelRequire('hwGtw'));

});

parcelRegister("2ahus", function(module, exports) {

let $193a151fd8c3b175$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $193a151fd8c3b175$var$load("aUGH0").then(()=>parcelRequire('duV9U'));

});

parcelRegister("a9LHZ", function(module, exports) {

let $764fc08cf8699a36$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $764fc08cf8699a36$var$load("bc9H8").then(()=>parcelRequire('lXbGR'));

});

parcelRegister("2K8Ox", function(module, exports) {

let $1ff6b6f3c319048d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1ff6b6f3c319048d$var$load("jiPaz").then(()=>parcelRequire('g4jIK'));

});

parcelRegister("huUQh", function(module, exports) {

let $cbd154b05f4fc884$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cbd154b05f4fc884$var$load("7LXV4").then(()=>parcelRequire('jkFMn'));

});

parcelRegister("85sK0", function(module, exports) {

let $5e3515bf476a32ce$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5e3515bf476a32ce$var$load("dIeeW").then(()=>parcelRequire('6i9PT'));

});

parcelRegister("7cPnf", function(module, exports) {

let $53f181353a07194b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $53f181353a07194b$var$load("1NSIC").then(()=>parcelRequire('3QONf'));

});

parcelRegister("574v7", function(module, exports) {

let $3b9118feb49cdcc9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3b9118feb49cdcc9$var$load("iNY4f").then(()=>parcelRequire('lHPaj'));

});

parcelRegister("iR7QZ", function(module, exports) {

let $dba344d4c10a5bd2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dba344d4c10a5bd2$var$load("isQJH").then(()=>parcelRequire('ctZZ9'));

});

parcelRegister("5tHnM", function(module, exports) {

let $3fd1500fefe9f586$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3fd1500fefe9f586$var$load("a60ql").then(()=>parcelRequire('aNi5L'));

});

parcelRegister("eqt1i", function(module, exports) {

let $a80a01292bb8166c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a80a01292bb8166c$var$load("4V1qv").then(()=>parcelRequire('1ziCa'));

});

parcelRegister("hAHoU", function(module, exports) {

let $cce776f44b968fda$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cce776f44b968fda$var$load("8vbSC").then(()=>parcelRequire('hdYZj'));

});

parcelRegister("4LhxM", function(module, exports) {

let $3779290c3d413b4c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3779290c3d413b4c$var$load("iwJOJ").then(()=>parcelRequire('jRbUf'));

});

parcelRegister("fz4HK", function(module, exports) {

let $b54dc628a13e9d66$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b54dc628a13e9d66$var$load("dlPIZ").then(()=>parcelRequire('flBBu'));

});

parcelRegister("36F2C", function(module, exports) {

let $2431c48ee3929286$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2431c48ee3929286$var$load("4Gbtc").then(()=>parcelRequire('8Dj2h'));

});

parcelRegister("1swrg", function(module, exports) {

let $1101919db5f57e5e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1101919db5f57e5e$var$load("eqiYF").then(()=>parcelRequire('MvF9E'));

});

parcelRegister("ezqXT", function(module, exports) {

let $a9b94040894180c2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a9b94040894180c2$var$load("43BOc").then(()=>parcelRequire('gHeq1'));

});

parcelRegister("9dO3Q", function(module, exports) {

let $6b6c2903bbce7646$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6b6c2903bbce7646$var$load("gD9D1").then(()=>parcelRequire('fwLkx'));

});

parcelRegister("22YHR", function(module, exports) {

let $17dadbb881b57b56$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $17dadbb881b57b56$var$load("lpFHz").then(()=>parcelRequire('cZQvj'));

});

parcelRegister("5Meno", function(module, exports) {

let $434c964261df2cff$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $434c964261df2cff$var$load("fYKge").then(()=>parcelRequire('iukR2'));

});

parcelRegister("6qVkf", function(module, exports) {

let $4af1a37610892460$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4af1a37610892460$var$load("4Wlui").then(()=>parcelRequire('2RrDc'));

});

parcelRegister("73KJL", function(module, exports) {

let $523d1142fc2fd996$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $523d1142fc2fd996$var$load("69mwC").then(()=>parcelRequire('i7ntw'));

});

parcelRegister("eqUDU", function(module, exports) {

let $a81f6e6e9982805f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a81f6e6e9982805f$var$load("7rN2h").then(()=>parcelRequire('l4eWW'));

});

parcelRegister("7qIaH", function(module, exports) {

let $568d39ac4f240296$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $568d39ac4f240296$var$load("9Y8tZ").then(()=>parcelRequire('dsm1a'));

});

parcelRegister("cqTPI", function(module, exports) {

let $0255fcca73e09e98$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0255fcca73e09e98$var$load("jjh1v").then(()=>parcelRequire('2TL59'));

});

parcelRegister("emO7i", function(module, exports) {

let $a759fee81567df29$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a759fee81567df29$var$load("23sVT").then(()=>parcelRequire('8Sn5a'));

});

parcelRegister("aFdnn", function(module, exports) {

let $7c381beae7bb8a37$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7c381beae7bb8a37$var$load("eO6VH").then(()=>parcelRequire('9Refg'));

});

parcelRegister("a5l2v", function(module, exports) {

let $757ab10100b5bd1e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $757ab10100b5bd1e$var$load("8rFvt").then(()=>parcelRequire('82BKR'));

});

parcelRegister("8rhoO", function(module, exports) {

let $624e57784acd019c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $624e57784acd019c$var$load("lK8aI").then(()=>parcelRequire('5O8im'));

});

parcelRegister("eqZ4Q", function(module, exports) {

let $a822df0f4e1a857f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a822df0f4e1a857f$var$load("5j4Hn").then(()=>parcelRequire('cw0UK'));

});

parcelRegister("bAo9R", function(module, exports) {

let $86f5cbce63fed6b9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $86f5cbce63fed6b9$var$load("2Jfx0").then(()=>parcelRequire('5QYDh'));

});

parcelRegister("10owv", function(module, exports) {

let $0bb8d056e87483a6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0bb8d056e87483a6$var$load("c119j").then(()=>parcelRequire('aRdOD'));

});

parcelRegister("k4VqY", function(module, exports) {

let $e9e0bb96113f4f57$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e9e0bb96113f4f57$var$load("lgdNv").then(()=>parcelRequire('e9ZyH'));

});

parcelRegister("geYJd", function(module, exports) {

let $bd2d0f845fa6b4ae$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bd2d0f845fa6b4ae$var$load("dKIhk").then(()=>parcelRequire('78gTm'));

});

parcelRegister("1zmTJ", function(module, exports) {

let $124ad25e9404f30a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $124ad25e9404f30a$var$load("dwqTf").then(()=>parcelRequire('5VFOo'));

});

parcelRegister("4CvUL", function(module, exports) {

let $35d37798f8551259$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $35d37798f8551259$var$load("fbezn").then(()=>parcelRequire('iLiRR'));

});

parcelRegister("5hr1F", function(module, exports) {

let $3d83811519289e1d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3d83811519289e1d$var$load("3HAPT").then(()=>parcelRequire('7BQ4p'));

});

parcelRegister("6lyxH", function(module, exports) {

let $49ef7fa67851e99b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $49ef7fa67851e99b$var$load("2GH4w").then(()=>parcelRequire('ieueA'));

});

parcelRegister("bUrkL", function(module, exports) {

let $8aba20977b41a025$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8aba20977b41a025$var$load("7Qzqz").then(()=>parcelRequire('bYC4R'));

});

parcelRegister("1ZvsH", function(module, exports) {

let $1733e4a262526709$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1733e4a262526709$var$load("gt8Kd").then(()=>parcelRequire('dpTRJ'));

});

parcelRegister("1t44X", function(module, exports) {

let $111ba9daa7801166$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $111ba9daa7801166$var$load("eVDdh").then(()=>parcelRequire('kBAV5'));

});

parcelRegister("f9p83", function(module, exports) {

let $b07b305c14ee1d6b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b07b305c14ee1d6b$var$load("hLIwJ").then(()=>parcelRequire('jjmz0'));

});

parcelRegister("lxyXQ", function(module, exports) {

let $fae7cd35fac1b26d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fae7cd35fac1b26d$var$load("wnH66").then(()=>parcelRequire('gj4bv'));

});

parcelRegister("eqEPm", function(module, exports) {

let $a81329da9bcd8516$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a81329da9bcd8516$var$load("5oeby").then(()=>parcelRequire('Yq9bP'));

});

parcelRegister("89Znr", function(module, exports) {

let $5f0ec633d8bea23b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5f0ec633d8bea23b$var$load("2shw0").then(()=>parcelRequire('26Elb'));

});

parcelRegister("86ob4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $c34df63e628fa432$var$WidthObserverContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $c34df63e628fa432$export$75f7910544138d14 = ({ children: children })=>{
    const [elements, setElements] = (0, $42omo.useState)({});
    const [callbacks, setCallbacks] = (0, $42omo.useState)({});
    (0, $42omo.useEffect)(()=>{
        const handleResize = (entries)=>{
            entries.forEach((entry)=>{
                const id = entry.target.getAttribute('data-width-observer-id');
                if (id && callbacks[id]) {
                    const width = entry.contentRect.width;
                    callbacks[id].forEach((callback)=>callback(width));
                }
            });
        };
        const observer = new ResizeObserver(handleResize);
        Object.values(elements).forEach((element)=>observer.observe(element));
        return ()=>{
            observer.disconnect();
        };
    }, [
        elements,
        callbacks
    ]);
    const registerElement = (0, $42omo.useCallback)((id, element)=>{
        setElements((prev)=>({
                ...prev,
                [id]: element
            }));
    }, [
        setElements
    ]);
    const unregisterElement = (0, $42omo.useCallback)((id)=>{
        setElements((prev)=>{
            const newElements = {
                ...prev
            };
            delete newElements[id];
            return newElements;
        });
    }, [
        setElements
    ]);
    const subscribe = (0, $42omo.useCallback)((id, callback)=>{
        setCallbacks((prev)=>({
                ...prev,
                [id]: [
                    ...prev[id] || [],
                    callback
                ]
            }));
        return ()=>{
            setCallbacks((prev)=>({
                    ...prev,
                    [id]: (prev[id] || []).filter((cb)=>cb !== callback)
                }));
        };
    }, [
        setCallbacks
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c34df63e628fa432$var$WidthObserverContext.Provider, {
        value: {
            registerElement: registerElement,
            unregisterElement: unregisterElement,
            subscribe: subscribe
        }
    }, children);
};
const $c34df63e628fa432$export$b78842cb7cd02769 = ()=>{
    const context = (0, $42omo.useContext)($c34df63e628fa432$var$WidthObserverContext);
    if (!context) throw new Error('useWidthObserver must be used within a WidthObserverProvider');
    return context;
};
const $c34df63e628fa432$export$ad8c32a8eb05ab3d = (id, ref)=>{
    const { registerElement: registerElement, unregisterElement: unregisterElement } = $c34df63e628fa432$export$b78842cb7cd02769();
    (0, $42omo.useEffect)(()=>{
        const element = ref.current;
        if (element) {
            element.setAttribute('data-width-observer-id', id);
            registerElement(id, element);
        }
        return ()=>{
            unregisterElement(id);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        id,
        ref,
        ref.current,
        // This is required as the useEffect is not triggered when ref.current becomes defined
        registerElement,
        unregisterElement
    ]);
};
const $c34df63e628fa432$export$f8586f54f6b8f867 = ({ id: id, children: children })=>{
    const elementRef = (0, $42omo.useRef)(null);
    $c34df63e628fa432$export$ad8c32a8eb05ab3d(id, elementRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        ref: elementRef
    }, children);
};
const $c34df63e628fa432$export$1217913212f99c7 = (id)=>{
    const { subscribe: subscribe } = $c34df63e628fa432$export$b78842cb7cd02769();
    const [width, setWidth] = (0, $42omo.useState)(0);
    (0, $42omo.useEffect)(()=>{
        const unsubscribe = subscribe(id, setWidth);
        return ()=>{
            unsubscribe();
        };
    }, [
        id,
        subscribe
    ]);
    return width;
};
const $c34df63e628fa432$export$f29cb180c1a7eb72 = ({ target: id, children: children })=>{
    const width = $c34df63e628fa432$export$1217913212f99c7(id);
    if (width === 0) return null;
    return children(width);
};
const $c34df63e628fa432$var$breakpoints = {
    xxs: 0,
    xs: 480,
    sm: 768,
    md: 1024,
    lg: 1440,
    xl: 1768
};
const $c34df63e628fa432$export$c44b7f69e7aa026 = ({ width: width, above: above, below: below })=>{
    return above && width > $c34df63e628fa432$var$breakpoints[above] || below && width < $c34df63e628fa432$var$breakpoints[below] || false;
};
const $c34df63e628fa432$export$f6a3d19be20f5819 = ({ target: target, above: above, below: below, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c34df63e628fa432$export$f29cb180c1a7eb72, {
        target: target
    }, (width)=>{
        if ($c34df63e628fa432$export$c44b7f69e7aa026({
            width: width,
            above: above,
            below: below
        })) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
    });
};
const $c34df63e628fa432$export$bed28288a051538 = ({ target: target, above: above, below: below, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c34df63e628fa432$export$f29cb180c1a7eb72, {
        target: target
    }, (width)=>{
        if ($c34df63e628fa432$export$c44b7f69e7aa026({
            width: width,
            above: above,
            below: below
        })) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
    });
};
module.exports["WidthObserverProvider"] = $c34df63e628fa432$export$75f7910544138d14;
module.exports["useWidthObserverRegistration"] = $c34df63e628fa432$export$ad8c32a8eb05ab3d;
module.exports["WidthObserverElement"] = $c34df63e628fa432$export$f8586f54f6b8f867;
module.exports["useElementWidth"] = $c34df63e628fa432$export$1217913212f99c7;
module.exports["Hide"] = $c34df63e628fa432$export$bed28288a051538;

});

parcelRegister("26jni", function(module, exports) {
/*
 * Minimize imports in this entrypoint to avoid increasing the product bundle size.
 */ 
var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");


var $iA4lt = parcelRequire("iA4lt");


var $55aR8 = parcelRequire("55aR8");

const $955db7dbc0f43185$var$JIRA_PRODUCT_NAME = 'jira';
// This is referencing KnowledgeDiscoveryJiraIntentDetectionModel.GNIN_HEURISTIC from @atlassian/search-client package
// Do not import @atlassian/search-client package as it will increase the NIN bundle size. A unit test is associated to this reference.
// Update DEFAULT_MODEL_ID if the default model ID for intent detection changes
const $955db7dbc0f43185$var$DEFAULT_MODEL_ID = 'GNIN_HEURISTIC';
const $955db7dbc0f43185$var$navigationCtaVariants = [
    'control',
    'tabs',
    'button',
    'icons'
];
const $955db7dbc0f43185$export$2e05ac0a6fbb40c7 = (cohortValue)=>{
    return Boolean($955db7dbc0f43185$var$navigationCtaVariants.find((variant)=>cohortValue === variant));
};
const $955db7dbc0f43185$var$isEnglishLocale = (locale)=>{
    // English locale or starts with 'en-', `en-US`, `en-GB`, etc.
    return Boolean(locale?.toLowerCase().startsWith('en'));
};
const $955db7dbc0f43185$export$f2e8952d10c578ba = ({ primaryProduct: primaryProduct, fireLayerExposure: fireLayerExposure = true, locale: locale } = {})=>{
    if (primaryProduct !== $955db7dbc0f43185$var$JIRA_PRODUCT_NAME) return undefined;
    // cohortForIntentDetectionExperiment AKA Experiment 2
    const intentDetectionExperiment = $955db7dbc0f43185$export$678dc8b37f93853d({
        primaryProduct: primaryProduct,
        fireLayerExposure: false,
        locale: // Exposure should only be fired when intent detection has occured on Quick Find
        locale
    });
    const cohortForIntentDetectionExperiment = intentDetectionExperiment?.uiFeatures.navigationCTA;
    // Intent detection experiment takes priority on what CTA is used.
    // For example: If the Jira NIN FPS navigation experiment is decided and we start experiment 2, we still want to be able to set
    // different navigation CTAs in case we want to test different CTA variants in experiment 2.
    if (cohortForIntentDetectionExperiment) return {
        cohort: cohortForIntentDetectionExperiment,
        hideNavigationCTAOnGNIN: intentDetectionExperiment?.uiFeatures?.hideNavigationCTAOnGNIN,
        showQueryInHeader: intentDetectionExperiment?.uiFeatures?.showQueryInHeader
    };
    // This gate is used to ensure that certain audiences (i.e. CentralAI) are included in the Jira UI experiment.
    // Without it, some users might be excluded due to layer allocation opting out potential candidates.
    // The gate guarantees participation of the targeted audience during the initial experimentation phase.
    if (!(0, $dh538.fg)('rovo_jira_ui_experience_audience_gate')) return undefined;
    const layer = (0, $iA4lt.getMutuallyExclusiveUIExperiment)('rovo_jira_nin_fps_navigation_exp', 'rovo_jira_ui_experience_layer', {
        fireLayerExposure: fireLayerExposure
    });
    // cohortForNinFpsExperiment AKA Experiment 1
    const cohortForNinFpsExperiment = layer?.get('cohort', undefined, $955db7dbc0f43185$export$2e05ac0a6fbb40c7);
    return {
        cohort: cohortForNinFpsExperiment,
        hideNavigationCTAOnGNIN: undefined,
        showQueryInHeader: undefined
    };
};
const $955db7dbc0f43185$export$cd09c61ec4486079 = {
    navigationCTA: 'button',
    hideFilterSuggestions: true,
    hideNavigationCTAOnGNIN: false,
    showMatchingWorkItem: true,
    showQueryInHeader: true,
    maxRecentQueryCountWhenNoSuggestions: 1
};
const $955db7dbc0f43185$var$variants = [
    'control',
    'test'
];
const $955db7dbc0f43185$var$serveJiraNINFpsNLQNavigationUserBased = ({ primaryProduct: primaryProduct, locale: locale } = {})=>{
    if (primaryProduct !== $955db7dbc0f43185$var$JIRA_PRODUCT_NAME) return undefined;
    // This gate is used to ensure that certain audiences (i.e. CentralAI) are included in the Jira UI experiment.
    // Without it, some users might be excluded due to layer allocation opting out potential candidates.
    // The gate guarantees participation of the targeted audience during the initial experimentation phase.
    if (!(0, $dh538.fg)('rovo_jira_intent_detection_audience_gate')) return undefined;
    if ($955db7dbc0f43185$var$isEnglishLocale(locale)) return {
        cohort: 'test',
        uiFeatures: $955db7dbc0f43185$export$cd09c61ec4486079,
        modelId: $955db7dbc0f43185$var$DEFAULT_MODEL_ID
    };
    // If not an english user, do not show intent detection
    return;
};
const $955db7dbc0f43185$var$serveMultiLangIntentDetection = ({ primaryProduct: primaryProduct, fireLayerExposure: fireLayerExposure = true, locale: locale } = {})=>{
    if (primaryProduct !== $955db7dbc0f43185$var$JIRA_PRODUCT_NAME) return undefined;
    // This gate is used to ensure that certain audiences (i.e. CentralAI) are included in the Jira UI experiment.
    // Without it, some users might be excluded due to layer allocation opting out potential candidates.
    // The gate guarantees participation of the targeted audience during the initial experimentation phase.
    if (!(0, $dh538.fg)('jira_fps_intent_classifier_fg') || $955db7dbc0f43185$var$isEnglishLocale(locale)) return;
    const experiment = (0, $c6GJD.default).getExperiment('rovo_jira_nin_fps_nlq_navigation_non_english_exp', {
        fireExperimentExposure: fireLayerExposure
    });
    const cohort = experiment?.get('cohort', undefined, (cohortValue)=>{
        return Boolean($955db7dbc0f43185$var$variants.find((variant)=>cohortValue === variant));
    });
    const uiFeaturesFromStatsig = experiment?.get('uiFeatures', {}, (uiFeaturesValue)=>{
        if (!uiFeaturesValue || typeof uiFeaturesValue !== 'object') return false;
        const isEnableControlIntentDetectionAnalyticsValid = 'enableControlIntentDetectionAnalytics' in uiFeaturesValue ? (0, $55aR8.jiraNINFpsNLQBooleanValidator)(uiFeaturesValue.enableControlIntentDetectionAnalytics) : true; // Undefined values are valid
        return isEnableControlIntentDetectionAnalyticsValid;
    }) ?? {};
    const modelId = experiment?.get('modelId', $955db7dbc0f43185$var$DEFAULT_MODEL_ID, (modelIdValue)=>typeof modelIdValue === 'string' && modelIdValue.length > 0) ?? $955db7dbc0f43185$var$DEFAULT_MODEL_ID;
    const uiFeaturesWithDefaults = {
        ...uiFeaturesFromStatsig,
        ...$955db7dbc0f43185$export$cd09c61ec4486079
    };
    return {
        cohort: cohort,
        uiFeatures: uiFeaturesWithDefaults,
        modelId: modelId
    };
};
const $955db7dbc0f43185$export$678dc8b37f93853d = (props = {})=>{
    // Holdout gate for the Carillon release (Jira's 3x/year rollout). Users in this holdout group
    // are opted out of intent detection, allowing different models to be tested against the holdout.
    if ((0, $dh538.fg)('rovo_jira_intent_detection_holdout')) // This is where the future intent detection experiments will live
    return undefined;
    const serveUserBasedExp = $955db7dbc0f43185$var$serveJiraNINFpsNLQNavigationUserBased(props);
    if (serveUserBasedExp) return serveUserBasedExp;
    return $955db7dbc0f43185$var$serveMultiLangIntentDetection(props);
};
const $955db7dbc0f43185$export$bf4748641fc251b9 = (primaryProduct, locale)=>{
    const experiment = $955db7dbc0f43185$export$678dc8b37f93853d({
        primaryProduct: primaryProduct,
        fireLayerExposure: false,
        locale: locale
    });
    return experiment?.cohort === 'test' || experiment?.cohort === 'control' && (experiment?.uiFeatures.enableControlIntentDetectionAnalytics ?? false);
};
module.exports["serveJiraNinFpsNavigation"] = $955db7dbc0f43185$export$f2e8952d10c578ba;
module.exports["serveJiraNINFpsNLQNavigation"] = $955db7dbc0f43185$export$678dc8b37f93853d;
module.exports["isIntentDetectionTriggeredForExperiment"] = $955db7dbc0f43185$export$bf4748641fc251b9;

});

parcelRegister("RWXHe", function(module, exports) {

var $42omo = parcelRequire("42omo");

/**
 * Shares a detached DOM node that the placement is portaled into.
 * PlacementSlot moves this node into the results list when it mounts.
 */ const $9d66e2ee6cb60186$var$PlacementPortalContainerContext = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $9d66e2ee6cb60186$export$a1158697c36e3e9e = ()=>(0, $42omo.useContext)($9d66e2ee6cb60186$var$PlacementPortalContainerContext);
const $9d66e2ee6cb60186$export$bdd60c847fd6f319 = $9d66e2ee6cb60186$var$PlacementPortalContainerContext.Provider;
const $9d66e2ee6cb60186$export$e2f7832e35c3b25 = ({ trackImpressionOnMount: trackImpressionOnMount } = {})=>{
    const slotRef = (0, $42omo.useRef)(null);
    const placementContainer = $9d66e2ee6cb60186$export$a1158697c36e3e9e();
    const trackImpression = $9d66e2ee6cb60186$export$28e9482e7fdec750();
    (0, $42omo.useLayoutEffect)(()=>{
        const slot = slotRef.current;
        if (slot && placementContainer) {
            placementContainer.style.display = '';
            slot.appendChild(placementContainer);
        }
        return ()=>{
            if (placementContainer) {
                placementContainer.style.display = 'none';
                placementContainer.remove();
            }
        };
    }, [
        placementContainer
    ]);
    (0, $42omo.useEffect)(()=>{
        if (trackImpressionOnMount) trackImpression?.();
    }, [
        trackImpressionOnMount,
        trackImpression
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: slotRef
    });
};
/**
 * Shares the trackImpression callback captured from the PostOffice placement's onMessageViewed.
 * This allows OAuthContainer to trigger the "viewed" event when the banner becomes visible.
 */ const $9d66e2ee6cb60186$var$TrackImpressionContext = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $9d66e2ee6cb60186$export$28e9482e7fdec750 = ()=>(0, $42omo.useContext)($9d66e2ee6cb60186$var$TrackImpressionContext);
const $9d66e2ee6cb60186$export$4a7d74782d15578 = $9d66e2ee6cb60186$var$TrackImpressionContext.Provider;
module.exports["usePlacementPortalContainer"] = $9d66e2ee6cb60186$export$a1158697c36e3e9e;
module.exports["PlacementPortalContainerProvider"] = $9d66e2ee6cb60186$export$bdd60c847fd6f319;
module.exports["PlacementSlot"] = $9d66e2ee6cb60186$export$e2f7832e35c3b25;
module.exports["TrackImpressionProvider"] = $9d66e2ee6cb60186$export$4a7d74782d15578;

});

parcelRegister("def8z", function(module, exports) {

var $b4tvS = parcelRequire("b4tvS");


var $9d9t8 = parcelRequire("9d9t8");

const $7151e4ce5e9c0a19$export$a3e2d74740ffbb74 = (productKey, thirdPartyConfigs)=>{
    if (!productKey) return true;
    const productConfig = thirdPartyConfigs[productKey];
    if (!productConfig) return true;
    return productConfig.datasources?.some((ds)=>!ds?.userNeedsOAuth) ?? false;
};
const $7151e4ce5e9c0a19$export$edde6dcae8734ece = ({ productKey: productKey, thirdPartyConfigs: thirdPartyConfigs })=>{
    const product3PConfig = productKey && (0, $b4tvS.is3pProductKey)(productKey) ? thirdPartyConfigs[productKey] : null;
    return product3PConfig?.connectorSources?.length === 1 && product3PConfig.connectorSources[0] === (0, $9d9t8.SMARTLINKS_CONNECTOR_SOURCE);
};
const $7151e4ce5e9c0a19$export$e531e035689745ad = (thirdPartyConfigs)=>{
    if (!thirdPartyConfigs) return false;
    return Object.values(thirdPartyConfigs).some((config)=>!!config && !config.userNeedsOAuth && (config.connectorSources?.includes((0, $9d9t8.SMARTLINKS_CONNECTOR_SOURCE)) ?? false));
};
module.exports["isProductConnected"] = $7151e4ce5e9c0a19$export$a3e2d74740ffbb74;
module.exports["isProductSmartlink"] = $7151e4ce5e9c0a19$export$edde6dcae8734ece;
module.exports["hasAuthorisedSmartLinkConnector"] = $7151e4ce5e9c0a19$export$e531e035689745ad;

});

parcelRegister("gGFxq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $dpPtd = parcelRequire("dpPtd");


var $cvXh8 = parcelRequire("cvXh8");


var $a3fRD = parcelRequire("a3fRD");


var $3uVVG = parcelRequire("3uVVG");


var $dh538 = parcelRequire("dh538");


var $7GE7t = parcelRequire("7GE7t");


var $johDC = parcelRequire("johDC");


var $flR86 = parcelRequire("flR86");


var $7YExv = parcelRequire("7YExv");


var $b4tvS = parcelRequire("b4tvS");


var $9d9t8 = parcelRequire("9d9t8");


var $7WbA8 = parcelRequire("7WbA8");


var $1ks6T = parcelRequire("1ks6T");


var $dnIVK = parcelRequire("dnIVK");


var $j4ply = parcelRequire("j4ply");


var $4VmlX = parcelRequire("4VmlX");


var $djVCD = parcelRequire("djVCD");




const $68cc9d8799ebe4b1$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    understoodAction: {
        id: "oauth-banner.acknowledgement.success-flag-action",
        defaultMessage: "Understood"
    }
});


/**
 * Updates the in-memory bootstrap configs synchronously (for immediate UI feedback)
 * and asynchronously updates the combined-config promiseCache so that both the
 * in-memory cache and localStorage stay consistent for subsequent page loads.
 *
 * This always produces updated configs with userNeedsOAuth=false.
 */ const $b53784fc0aedebc4$var$refreshCombinedOAuthCache = (product, userId, cloudId, thirdPartyConfigs, datasourceId)=>{
    const newThirdPartyConfigs = {
        ...thirdPartyConfigs
    };
    const productKey = product;
    const existingConfig = newThirdPartyConfigs[productKey];
    if (existingConfig) {
        if (datasourceId) newThirdPartyConfigs[productKey] = {
            ...existingConfig,
            datasources: existingConfig.datasources?.map((ds)=>ds.datasourceId === datasourceId ? {
                    ...ds,
                    userNeedsOAuth: false
                } : ds)
        };
        else newThirdPartyConfigs[productKey] = {
            ...existingConfig,
            userNeedsOAuth: false
        };
    }
    const thirdPartyTypes = (0, $1ks6T.getThirdPartyTypes)();
    (0, $7GE7t.updateCombinedConfigCacheEntry)(userId, cloudId, (config)=>({
            ...config,
            thirdPartyProducts: config.thirdPartyProducts?.map((entry)=>{
                if (datasourceId) {
                    if (entry.datasourceId === datasourceId) return {
                        ...entry,
                        isUserOAuthed: true
                    };
                } else if (thirdPartyTypes[entry.name] === product) return {
                    ...entry,
                    isUserOAuthed: true
                };
                return entry;
            })
        }));
    return newThirdPartyConfigs;
};
const $b53784fc0aedebc4$export$4de3515a937b03f6 = ({ product: product, connectorSource: connectorSource, successFlagTitle: successFlagTitle, successFlagDescription: successFlagDescription, showUnderstoodButton: showUnderstoodButton = false, failFlagTitle: failFlagTitle, outboundAuthUrl: outboundAuthUrl, onCompletedAction: onCompletedAction = ()=>{}, onDismissAction: onDismissAction = ()=>{}, onFailAction: onFailAction = ()=>{}, isOnSearchDialog: isOnSearchDialog, isBulkConnect: isBulkConnect, query: query = '', datasourceId: datasourceId, extraAttributes: extraAttributes })=>{
    const [cloudId] = (0, $j4ply.useCloudId)();
    const [user] = (0, $j4ply.useUser)();
    const [thirdPartyConfigs] = (0, $j4ply.useThirdPartyConfigs)();
    const setThirdPartyConfigs = (0, $j4ply.useSetThirdPartyConfigs)();
    const onOAuthSuccess = (0, $j4ply.useOnOAuthSuccess)();
    // Keep a ref to the latest thirdPartyConfigs so that the onSuccess closure
    // (which fires asynchronously after the auth popup closes) always reads the
    // current store value instead of a stale captured snapshot.
    const thirdPartyConfigsRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(thirdPartyConfigs);
    thirdPartyConfigsRef.current = thirdPartyConfigs;
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const userId = user?.id;
    const { retrySearch: retrySearch } = (0, $djVCD.useSearchActions)();
    const { showFlag: showFlag, hideFlag: hideFlag } = (0, $dpPtd.useFlags)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const oAuthAnalyticsProps = {
        product: product || '',
        connectorSource: connectorSource,
        cloudId: cloudId || '',
        isOnSearchDialog: isOnSearchDialog,
        thirdPartyConfigs: thirdPartyConfigs,
        extraAttributes: extraAttributes
    };
    const fireOAuthStartedEvent = (0, $dnIVK.useFireOAuthStarted)(oAuthAnalyticsProps);
    const fireOAuthCompletedEvent = (0, $dnIVK.useFireOAuthCompleted)(oAuthAnalyticsProps);
    const fireOAuthFailedEvent = (0, $dnIVK.useFireOAuthFailed)(oAuthAnalyticsProps);
    const onSuccess = (oAuthSource)=>{
        fireOAuthCompletedEvent(oAuthSource);
        if (product === 'slack') (0, $flR86.sendSlackAuthSuccessRequest)({
            cloudId: cloudId
        });
        if (product === 'teams' && (0, $dh538.fg)('ai_3p_is_teams_platform_connector_enabled')) (0, $7YExv.sendTeamsAuthSuccessRequest)({
            cloudId: cloudId
        });
        onCompletedAction();
        const successFlagId = `oauth-success-flag-${product ?? 'unknown'}-${Date.now()}`;
        showFlag({
            id: successFlagId,
            title: successFlagTitle,
            ...successFlagDescription !== undefined && {
                description: successFlagDescription
            },
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
                spacing: "spacious",
                label: "",
                color: "var(--ds-icon-success, #6A9A23)"
            }),
            isAutoDismiss: true,
            ...showUnderstoodButton && {
                actions: [
                    {
                        content: formatMessage((0, $68cc9d8799ebe4b1$export$defe85febe8b728c).understoodAction),
                        onClick: ()=>hideFlag(successFlagId)
                    }
                ]
            }
        });
        if (onOAuthSuccess && (0, $dh538.fg)('rovo_fps_use_rovo_config')) onOAuthSuccess({
            product: product,
            datasourceId: datasourceId
        });
        else {
            const newOutboundAuthConfigs = $b53784fc0aedebc4$var$refreshCombinedOAuthCache(product, userId || '', cloudId || '', // Read from ref to get the latest store value, not the stale closure snapshot.
            thirdPartyConfigsRef.current || {}, datasourceId);
            setThirdPartyConfigs(newOutboundAuthConfigs);
        }
        (0, $johDC.searchPageQueryCache).clear();
        retrySearch();
        if (!isBulkConnect && isOnSearchDialog) {
            setQuickFindOpen(false);
            /* TODO: use onNavigate callback once bootstrap store is lifted. Details in https://hello.atlassian.net/wiki/spaces/CASE/pages/4670854655/3P+Discoverability+Bug
      const onNavigateCallback =
      	typeof onNavigate === 'function' ? onNavigate : onNavigate.callback;
      onNavigateCallback(
      	generateSearchUrl({
      		...queryParams,
      		text: query,
      		product: product,
      	}),
      	'push',
      );
      */ const searchUrl = generateSearchUrl({
                ...queryParams,
                text: query,
                product: product
            });
            window.location.href = searchUrl;
        }
    };
    //eslint-disable-next-line @typescript-eslint/no-unused-vars
    const onFail = (oAuthSource, error)=>{
        fireOAuthFailedEvent(oAuthSource);
        onFailAction();
        showFlag({
            title: failFlagTitle,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                spacing: "spacious",
                label: "",
                color: "var(--ds-icon-danger, #C9372C)"
            }),
            isAutoDismiss: true
        });
    };
    const onAuthorize = (oAuthSource)=>{
        fireOAuthStartedEvent(oAuthSource);
        (0, $3uVVG.auth)(outboundAuthUrl).then(()=>onSuccess(oAuthSource)).catch((error)=>onFail(oAuthSource, error));
    };
    const onDismiss = ()=>{
        onDismissAction();
    };
    return {
        onAuthorize: onAuthorize,
        onDismiss: onDismiss,
        onSuccess: onSuccess,
        onFail: onFail
    };
};
const $b53784fc0aedebc4$export$e90b3746b95097c9 = (productKey, selectedDatasourceId)=>{
    const [thirdPartyConfigsValue] = (0, $j4ply.useThirdPartyConfigs)();
    return $b53784fc0aedebc4$export$3515cf7f98d16dad(productKey, thirdPartyConfigsValue, selectedDatasourceId);
};
const $b53784fc0aedebc4$export$3515cf7f98d16dad = (productKey, thirdPartyConfigs, selectedDatasourceId)=>{
    let userNeedsOAuth, outboundAuthUrl;
    // Handle Forge connectors first (they're not in is3pProductKey)
    if (productKey && (0, $9d9t8.isForgeConnectorProductKey)(productKey)) {
        const productOutboundAuthConfig = thirdPartyConfigs[productKey];
        if (!productOutboundAuthConfig) return {
            userNeedsOAuth: userNeedsOAuth,
            outboundAuthUrl: outboundAuthUrl
        };
        userNeedsOAuth = productOutboundAuthConfig.userNeedsOAuth;
        outboundAuthUrl = productOutboundAuthConfig.outboundAuthUrl;
        return {
            userNeedsOAuth: userNeedsOAuth,
            outboundAuthUrl: outboundAuthUrl
        };
    }
    if (!productKey || !(0, $b4tvS.is3pProductKey)(productKey)) return {
        userNeedsOAuth: userNeedsOAuth,
        outboundAuthUrl: outboundAuthUrl
    };
    // If datasource is provided, check specific datasource config
    if (selectedDatasourceId) {
        const datasourceOutboundAuthConfig = thirdPartyConfigs[productKey]?.datasources?.find((datasource)=>datasource.datasourceId === selectedDatasourceId);
        if (!datasourceOutboundAuthConfig) return {
            userNeedsOAuth: userNeedsOAuth,
            outboundAuthUrl: outboundAuthUrl
        };
        userNeedsOAuth = datasourceOutboundAuthConfig.userNeedsOAuth;
        outboundAuthUrl = datasourceOutboundAuthConfig.outboundAuthUrl;
        return {
            userNeedsOAuth: userNeedsOAuth,
            outboundAuthUrl: outboundAuthUrl
        };
    }
    // If no datasource provided, check base product config
    const productOutboundAuthConfig = thirdPartyConfigs[productKey];
    if (!productOutboundAuthConfig) return {
        userNeedsOAuth: userNeedsOAuth,
        outboundAuthUrl: outboundAuthUrl
    };
    userNeedsOAuth = productOutboundAuthConfig.userNeedsOAuth;
    outboundAuthUrl = productOutboundAuthConfig.outboundAuthUrl;
    return {
        userNeedsOAuth: userNeedsOAuth,
        outboundAuthUrl: outboundAuthUrl
    };
};
module.exports["useOAuthHandlers"] = $b53784fc0aedebc4$export$4de3515a937b03f6;
module.exports["useIsUserOAuthed"] = $b53784fc0aedebc4$export$e90b3746b95097c9;
module.exports["isUserOAuthed"] = $b53784fc0aedebc4$export$3515cf7f98d16dad;

});

parcelRegister("flR86", function(module, exports) {
const $d6887d0799a850df$export$e5c324cf2a7795e0 = ({ absoluteUrl: absoluteUrl = '', cloudId: cloudId })=>{
    const relativeSlackUrl = `/gateway/api/third-party-user-auth/slack/user-authed`;
    const baseUrl = absoluteUrl || relativeSlackUrl;
    const url = `${baseUrl}/${cloudId}`;
    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        }
    });
};
module.exports["sendSlackAuthSuccessRequest"] = $d6887d0799a850df$export$e5c324cf2a7795e0;

});

parcelRegister("7YExv", function(module, exports) {

var $2qzBQ = parcelRequire("2qzBQ");


var $hw4j5 = parcelRequire("hw4j5");

const $4d0ef623e71fa6bc$var$TEAMS_BULK_REST_API_URL = '/gateway/api/v4/teams/withMembers/bulk';
const $4d0ef623e71fa6bc$var$cache = (0, $hw4j5.inMemoryCache)();
const $4d0ef623e71fa6bc$export$a4f9b7f788f9e71f = (request)=>{
    const keyObj = {
        teamIds: request.teamIds.sort()
    };
    return (0, $2qzBQ.generateHashFromVariables)(keyObj);
};
const $4d0ef623e71fa6bc$export$eb16261a2bb165d4 = async (request, onError)=>{
    return $4d0ef623e71fa6bc$var$cache.inMemoryDecorator($4d0ef623e71fa6bc$export$a4f9b7f788f9e71f(request), ()=>fetch($4d0ef623e71fa6bc$var$TEAMS_BULK_REST_API_URL, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(request)
        }).then((response)=>{
            if (response.ok) return response.json();
            const errorMessage = `Unable to fetch ${$4d0ef623e71fa6bc$var$TEAMS_BULK_REST_API_URL}. ${response.statusText}`;
            onError?.(errorMessage);
            return Promise.reject({
                teams: [],
                failures: [
                    {
                        teamIds: request.teamIds,
                        description: errorMessage,
                        typeId: 'FETCH_ERROR'
                    }
                ]
            });
        }).catch((error)=>{
            const errorMessage = `Unable to fetch ${$4d0ef623e71fa6bc$var$TEAMS_BULK_REST_API_URL}. ${error.message}`;
            onError?.(errorMessage);
            return {
                teams: [],
                failures: [
                    {
                        teamIds: request.teamIds,
                        description: errorMessage,
                        typeId: 'FETCH_ERROR'
                    }
                ]
            };
        }));
};
const $4d0ef623e71fa6bc$export$5a635a8efc086412 = ({ absoluteUrl: absoluteUrl = '', cloudId: cloudId })=>{
    const relativeTeamsUrl = `/gateway/api/third-party-user-auth/teams/user-authed`;
    const baseUrl = absoluteUrl || relativeTeamsUrl;
    const url = `${baseUrl}/${cloudId}`;
    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        }
    });
};
module.exports["fetchTeamsBulk"] = $4d0ef623e71fa6bc$export$eb16261a2bb165d4;
module.exports["sendTeamsAuthSuccessRequest"] = $4d0ef623e71fa6bc$export$5a635a8efc086412;

});

parcelRegister("ckkm9", function(module, exports) {

var $6yNqK = parcelRequire("6yNqK");

const $07e03f86f3cec1e3$export$caa1a4a1a0abbf91 = {
    quickFindFilter: 'quick-find-filter',
    quickFindOAuthBanner: 'quick-find-oauth-banner',
    quickFindBulkConnect: 'quick-find-bulk-connect',
    quickFindGithubTipBanner: 'quick-find-github-tip-banner',
    searchPageFilter: 'search-page-filter',
    searchPageOAuthBanner: 'search-page-oauth-banner',
    searchPageBulkConnect: 'search-page-bulk-connect',
    sainThirdPartyBanner: 'sain-third-party-banner'
};
const $07e03f86f3cec1e3$export$54863d2084195ac7 = ({ cloudId: cloudId, product: product, connectorSource: connectorSource, commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, isOnSearchDialog: isOnSearchDialog, oAuthSource: oAuthSource, isImpersonated: isImpersonated, extraAttributes: extraAttributes })=>{
    return {
        source: isOnSearchDialog ? (0, $6yNqK.SEARCH_DIALOG_EVENT_SOURCE) : (0, $6yNqK.EVENT_SOURCE),
        action: 'clicked',
        actionSubject: 'thirdPartyOAuth',
        attributes: {
            additionalAttributes: {
                ...extraAttributes,
                cloudId: cloudId,
                product: product,
                connectorSource: connectorSource,
                oAuthSource: oAuthSource,
                isImpersonated: isImpersonated
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes,
        eventType: 'track'
    };
};
const $07e03f86f3cec1e3$export$1caeb8956b6720dc = ({ cloudId: cloudId, product: product, connectorSource: connectorSource, commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, isOnSearchDialog: isOnSearchDialog, oAuthSource: oAuthSource, isImpersonated: isImpersonated, extraAttributes: extraAttributes })=>{
    return {
        source: isOnSearchDialog ? (0, $6yNqK.SEARCH_DIALOG_EVENT_SOURCE) : (0, $6yNqK.EVENT_SOURCE),
        action: 'completed',
        actionSubject: 'thirdPartyOAuth',
        attributes: {
            additionalAttributes: {
                ...extraAttributes,
                cloudId: cloudId,
                product: product,
                connectorSource: connectorSource,
                oAuthSource: oAuthSource,
                isImpersonated: isImpersonated
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes,
        eventType: 'track'
    };
};
const $07e03f86f3cec1e3$export$50898fe380812840 = ({ cloudId: cloudId, product: product, connectorSource: connectorSource, commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, isOnSearchDialog: isOnSearchDialog, oAuthSource: oAuthSource, isImpersonated: isImpersonated, extraAttributes: extraAttributes })=>{
    return {
        source: isOnSearchDialog ? (0, $6yNqK.SEARCH_DIALOG_EVENT_SOURCE) : (0, $6yNqK.EVENT_SOURCE),
        action: 'failed',
        actionSubject: 'thirdPartyOAuth',
        attributes: {
            additionalAttributes: {
                ...extraAttributes,
                cloudId: cloudId,
                product: product,
                connectorSource: connectorSource,
                oAuthSource: oAuthSource,
                isImpersonated: isImpersonated
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes,
        eventType: 'track'
    };
};
const $07e03f86f3cec1e3$export$b6f5ff07ced3e735 = ({ cloudId: cloudId, product: product, connectorSource: connectorSource, commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, isOnSearchDialog: isOnSearchDialog, oAuthSource: oAuthSource, isImpersonated: isImpersonated, extraAttributes: extraAttributes })=>{
    return {
        source: isOnSearchDialog ? (0, $6yNqK.SEARCH_DIALOG_EVENT_SOURCE) : (0, $6yNqK.EVENT_SOURCE),
        action: 'hovered',
        actionSubject: 'thirdPartyOAuth',
        actionSubjectId: 'thirdPartyOAuthConnectButton',
        attributes: {
            additionalAttributes: {
                ...extraAttributes,
                cloudId: cloudId,
                product: product,
                connectorSource: connectorSource,
                oAuthSource: oAuthSource,
                isImpersonated: isImpersonated
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes,
        eventType: 'ui'
    };
};
module.exports["OAuthSource"] = $07e03f86f3cec1e3$export$caa1a4a1a0abbf91;
module.exports["onOAuthStarted"] = $07e03f86f3cec1e3$export$54863d2084195ac7;
module.exports["onOAuthCompleted"] = $07e03f86f3cec1e3$export$1caeb8956b6720dc;
module.exports["onOAuthFailed"] = $07e03f86f3cec1e3$export$50898fe380812840;
module.exports["onOAuthConnectHovered"] = $07e03f86f3cec1e3$export$b6f5ff07ced3e735;

});

parcelRegister("6yNqK", function(module, exports) {
const $f8b501d0c94c20b2$export$e8d1ded05852e864 = {
    source: 'source'
};
const $f8b501d0c94c20b2$export$d1fe2a1199482e6d = {
    release: 'release',
    product: 'product',
    cloudId: 'cloudId',
    userId: 'userId',
    primaryProduct: 'primaryProduct',
    primaryProductFilterString: 'primaryProductFilterString',
    experimentId: 'experimentId',
    experimentLayers: 'experimentLayers',
    frontendExperiments: 'frontendExperiments',
    abTestId: 'abTestId',
    isHello: 'isHello',
    version: 'version',
    mode: 'mode',
    requestId: 'requestId',
    traceId: 'traceId'
};
const $f8b501d0c94c20b2$export$ed78826c06dd24e3 = 'fabric-elements';
const $f8b501d0c94c20b2$export$ad44d4a0591d8dba = 'advancedSearchScreen';
const $f8b501d0c94c20b2$export$1111f6e73bd7b1d8 = 'searchDialog';
const $f8b501d0c94c20b2$export$98bd2afc08f981ef = 'searchPage';
var $f8b501d0c94c20b2$export$1118b8908e5d0501 = /*#__PURE__*/ function(OptionIds) {
    OptionIds["TITLE"] = "title";
    OptionIds["ARCHIVED"] = "archived";
    OptionIds["ANCESTOR"] = "ancestor";
    OptionIds["TO"] = "to";
    OptionIds["FROM"] = "from";
    OptionIds["LAST_MODIFIED"] = "lastModified";
    return OptionIds;
}({});
const $f8b501d0c94c20b2$export$eed19b551669af14 = 'CURRENT';
const $f8b501d0c94c20b2$export$c936349447a77fe0 = 'ARCHIVED';
const $f8b501d0c94c20b2$export$a4c5cde0daa9b961 = 'crossProductSearch';
const $f8b501d0c94c20b2$export$2be5c31192ba8783 = 'all';
const $f8b501d0c94c20b2$export$cabdc1d3c523c88 = 'fullPageSearchErrorScreen';
var $f8b501d0c94c20b2$export$15029b2eda44c6a7 = /*#__PURE__*/ function(QueryState) {
    QueryState["POSTQUERY"] = "PostQuery";
    QueryState["PREQUERY"] = "PreQuery";
    return QueryState;
}({});
module.exports["DEFAULT_GAS_CHANNEL"] = $f8b501d0c94c20b2$export$ed78826c06dd24e3;
module.exports["EVENT_SOURCE"] = $f8b501d0c94c20b2$export$ad44d4a0591d8dba;
module.exports["SEARCH_DIALOG_EVENT_SOURCE"] = $f8b501d0c94c20b2$export$1111f6e73bd7b1d8;
module.exports["ACTION_SUBJECT_PREFIX"] = $f8b501d0c94c20b2$export$98bd2afc08f981ef;
module.exports["OptionIds"] = $f8b501d0c94c20b2$export$1118b8908e5d0501;
module.exports["CURRENT"] = $f8b501d0c94c20b2$export$eed19b551669af14;
module.exports["ARCHIVED"] = $f8b501d0c94c20b2$export$c936349447a77fe0;
module.exports["CROSSPRODUCT_SEARCH_API"] = $f8b501d0c94c20b2$export$a4c5cde0daa9b961;
module.exports["ALL_PRODUCTS_STRING"] = $f8b501d0c94c20b2$export$2be5c31192ba8783;
module.exports["ERROR_SCREEN_NAME"] = $f8b501d0c94c20b2$export$cabdc1d3c523c88;
module.exports["QueryState"] = $f8b501d0c94c20b2$export$15029b2eda44c6a7;

});

parcelRegister("gRvZB", function(module, exports) {

var $b4tvS = parcelRequire("b4tvS");

const $3f5a7948fe0e6fa1$export$b4d0899ce57e542f = (product, thirdPartyConfigs)=>{
    return !!(product && (0, $b4tvS.is3pProductKey)(product) ? thirdPartyConfigs[product]?.impersonationEnabled : false);
};
module.exports["isProductImpersonated"] = $3f5a7948fe0e6fa1$export$b4d0899ce57e542f;

});

parcelRegister("1ymk3", function(module, exports) {

var $4xBBd = parcelRequire("4xBBd");


var $6jKOp = parcelRequire("6jKOp");


var $gZjCQ = parcelRequire("gZjCQ");


var $atY36 = parcelRequire("atY36");


var $20r3r = parcelRequire("20r3r");

/**
 * Extracts the gateway object from the latest captured Relay extensions
 * for the given query type.
 */ const $42635ff5f86f7d1d$var$getLatestGateway = (isCQL)=>{
    const extensions = (0, $4xBBd.getExtensions)(isCQL ? (0, $atY36.default).operation.name : (0, $gZjCQ.default).operation.name)?.slice(-1)[0];
    return extensions?.gateway;
};
function $42635ff5f86f7d1d$export$4fff3ed4eba4f4ee(isCQL) {
    const gateway = $42635ff5f86f7d1d$var$getLatestGateway(isCQL);
    const traceId = gateway?.['trace_id'];
    const queryUpdatedAgo = (0, $20r3r.getQueryUpdatedTime)();
    return {
        traceId: traceId,
        queryUpdatedAgo: queryUpdatedAgo
    };
}
function $42635ff5f86f7d1d$export$7a619f7611b5a09e(isCQL) {
    const gateway = $42635ff5f86f7d1d$var$getLatestGateway(isCQL);
    if (!gateway) return undefined;
    return (0, $6jKOp.extractTraceInfoFromResponse)({
        extensions: {
            gateway: gateway
        }
    });
}
module.exports["getExtensionData"] = $42635ff5f86f7d1d$export$4fff3ed4eba4f4ee;
module.exports["getRelayNetworkTraceInfo"] = $42635ff5f86f7d1d$export$7a619f7611b5a09e;

});

parcelRegister("gZjCQ", function(module, exports) {
/**
 * @generated SignedSource<<0f5628367c9a2b5e4e19300b1cfdcfd8>>
 * @relayHash edc48be39e5ae224ea96b4eeddc9b7ff
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 775f0a93339c95953a5c0a13e0c4fdc7f2e0bf7797a295f530fc8132b9d0f625

var $5SuoG = parcelRequire("5SuoG");


var $aqtD4 = parcelRequire("aqtD4");


var $4PNBt = parcelRequire("4PNBt");


var $iLuVY = parcelRequire("iLuVY");

const $b96117069722906e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "assetsFilters"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudIdARI"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commonFilters"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "compassFilters"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "confluenceFilters"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "disableQueryReplacement"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "enableHighlighting"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entities"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "expectResult"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experience"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experimentId"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experimentLayers"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fanoutExperimentCohort"
    }, v14 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeGithubCode"
    }, v15 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeIconUrl"
    }, v16 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeJiraLiteModeFields"
    }, v17 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeNavBoostScore"
    }, v18 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includePassionfruitAsk"
    }, v19 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includePositions"
    }, v20 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeReactionsAndCommentCount"
    }, v21 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeRisk"
    }, v22 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeThirdPartyId"
    }, v23 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraFilters"
    }, v24 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v25 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "matchingLayerExperimentsMetadata"
    }, v26 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "mercuryFilters"
    }, v27 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "query"
    }, v28 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryVersion"
    }, v29 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchSessionId"
    }, v30 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sessionId"
    }, v31 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shadowExperimentId"
    }, v32 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sort"
    }, v33 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sourceProduct"
    }, v34 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "talentFilters"
    }, v35 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "tenantId"
    }, v36 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "thirdPartyFilters"
    }, v37 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "queryVersion",
                    "variableName": "queryVersion"
                },
                {
                    "kind": "Variable",
                    "name": "searchSessionId",
                    "variableName": "searchSessionId"
                },
                {
                    "kind": "Variable",
                    "name": "sessionId",
                    "variableName": "sessionId"
                },
                {
                    "kind": "Variable",
                    "name": "sourceProduct",
                    "variableName": "sourceProduct"
                }
            ],
            "kind": "ObjectValue",
            "name": "analytics"
        },
        {
            "kind": "Variable",
            "name": "disableQueryReplacement",
            "variableName": "disableQueryReplacement"
        },
        {
            "kind": "Variable",
            "name": "enableHighlighting",
            "variableName": "enableHighlighting"
        },
        {
            "kind": "Variable",
            "name": "expectResult",
            "variableName": "expectResult"
        },
        {
            "kind": "Variable",
            "name": "experience",
            "variableName": "experience"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "experimentId",
                    "variableName": "experimentId"
                },
                {
                    "kind": "Variable",
                    "name": "experimentLayers",
                    "variableName": "experimentLayers"
                },
                {
                    "kind": "Variable",
                    "name": "shadowExperimentId",
                    "variableName": "shadowExperimentId"
                }
            ],
            "kind": "ObjectValue",
            "name": "experimentContext"
        },
        {
            "kind": "Variable",
            "name": "fanoutExperimentCohort",
            "variableName": "fanoutExperimentCohort"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "assetsFilters",
                    "variableName": "assetsFilters"
                },
                {
                    "kind": "Variable",
                    "name": "commonFilters",
                    "variableName": "commonFilters"
                },
                {
                    "kind": "Variable",
                    "name": "compassFilters",
                    "variableName": "compassFilters"
                },
                {
                    "kind": "Variable",
                    "name": "confluenceFilters",
                    "variableName": "confluenceFilters"
                },
                {
                    "kind": "Variable",
                    "name": "entities",
                    "variableName": "entities"
                },
                {
                    "kind": "Variable",
                    "name": "jiraFilters",
                    "variableName": "jiraFilters"
                },
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "locations.0",
                            "variableName": "cloudIdARI"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "locations"
                },
                {
                    "kind": "Variable",
                    "name": "mercuryFilters",
                    "variableName": "mercuryFilters"
                },
                {
                    "kind": "Variable",
                    "name": "talentFilters",
                    "variableName": "talentFilters"
                },
                {
                    "kind": "Variable",
                    "name": "thirdPartyFilters",
                    "variableName": "thirdPartyFilters"
                }
            ],
            "kind": "ObjectValue",
            "name": "filters"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "limit"
        },
        {
            "kind": "Variable",
            "name": "matchingLayerExperimentsMetadata",
            "variableName": "matchingLayerExperimentsMetadata"
        },
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "query"
        },
        {
            "kind": "Variable",
            "name": "sort",
            "variableName": "sort"
        }
    ], v38 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v39 = {
        "kind": "ScalarField",
        "name": "id"
    }, v40 = {
        "kind": "ScalarField",
        "name": "description"
    }, v41 = {
        "kind": "ScalarField",
        "name": "connectorType"
    }, v42 = {
        "kind": "ScalarField",
        "name": "title"
    }, v43 = {
        "kind": "ScalarField",
        "name": "url"
    }, v44 = {
        "kind": "ScalarField",
        "name": "type"
    }, v45 = {
        "kind": "ScalarField",
        "name": "lastModifiedDate"
    }, v46 = {
        "kind": "ScalarField",
        "name": "subtype"
    }, v47 = {
        "kind": "ScalarField",
        "name": "integrationId"
    }, v48 = {
        "kind": "ScalarField",
        "name": "providerId"
    }, v49 = {
        "kind": "ScalarField",
        "name": "value"
    }, v50 = {
        "kind": "ScalarField",
        "name": "label"
    }, v51 = [
        v50 /*: any*/ 
    ], v52 = {
        "kind": "ScalarField",
        "name": "key"
    }, v53 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v54 = [
        v53 /*: any*/ 
    ], v55 = {
        "condition": "includeIconUrl",
        "kind": "Condition",
        "passingValue": true,
        "selections": v54 /*: any*/ 
    }, v56 = {
        "kind": "ScalarField",
        "name": "name"
    }, v57 = [
        v56 /*: any*/ 
    ], v58 = {
        "kind": "ScalarField",
        "name": "lastModified"
    }, v59 = {
        "kind": "ScalarField",
        "name": "total"
    }, v60 = {
        "kind": "ScalarField",
        "name": "count"
    }, v61 = [
        v39 /*: any*/ 
    ], v62 = {
        "kind": "InlineFragment",
        "selections": v61 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v63 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v64 = {
        "kind": "ScalarField",
        "name": "email"
    }, v65 = [
        {
            "kind": "ScalarField",
            "name": "jobTitle"
        }
    ], v66 = {
        "args": [
            {
                "kind": "Variable",
                "name": "tenantId",
                "variableName": "tenantId"
            }
        ],
        "concreteType": "SocialSignalSearch",
        "kind": "LinkedField",
        "name": "socialSignal",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "signal"
            },
            {
                "kind": "ScalarField",
                "name": "timestamp"
            },
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    v38 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v56 /*: any*/ ,
                    v63 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v64 /*: any*/ ,
                            {
                                "concreteType": "AtlassianAccountUserExtendedProfile",
                                "kind": "LinkedField",
                                "name": "extendedProfile",
                                "plural": false,
                                "selections": v65 /*: any*/ 
                            }
                        ],
                        "type": "AtlassianAccountUser"
                    },
                    v39 /*: any*/ 
                ]
            }
        ]
    }, v67 = {
        "kind": "LinkedField",
        "name": "container",
        "plural": false,
        "selections": [
            v38 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": v57 /*: any*/ ,
                "type": "ExternalRepository"
            },
            v62 /*: any*/ 
        ]
    }, v68 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v69 = {
        "kind": "LinkedField",
        "name": "container",
        "plural": false,
        "selections": [
            v38 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    v68 /*: any*/ ,
                    v43 /*: any*/ ,
                    v46 /*: any*/ 
                ],
                "type": "ExternalSpace"
            },
            v62 /*: any*/ 
        ]
    }, v70 = [
        {
            "kind": "ScalarField",
            "name": "reactionType"
        },
        v59 /*: any*/ 
    ], v71 = {
        "kind": "ScalarField",
        "name": "externalId"
    }, v72 = {
        "concreteType": "ThirdPartyUserExtendedProfile",
        "kind": "LinkedField",
        "name": "extendedProfile",
        "plural": false,
        "selections": v65 /*: any*/ 
    }, v73 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": [
            {
                "concreteType": "ThirdPartyUser",
                "kind": "LinkedField",
                "name": "thirdPartyUser",
                "plural": false,
                "selections": [
                    v56 /*: any*/ ,
                    v64 /*: any*/ ,
                    v63 /*: any*/ ,
                    v71 /*: any*/ ,
                    v72 /*: any*/ ,
                    v39 /*: any*/ 
                ]
            }
        ]
    }, v74 = [
        v38 /*: any*/ ,
        v56 /*: any*/ ,
        v63 /*: any*/ ,
        v39 /*: any*/ 
    ], v75 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": v74 /*: any*/ 
    }, v76 = {
        "kind": "ScalarField",
        "name": "nickname"
    }, v77 = {
        "concreteType": "ExternalAssociationConnection",
        "kind": "LinkedField",
        "name": "associatedWith",
        "plural": false,
        "selections": [
            {
                "concreteType": "ExternalAssociationEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "ExternalAssociation",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "entity",
                                "plural": false,
                                "selections": [
                                    v38 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v71 /*: any*/ ,
                                            v56 /*: any*/ ,
                                            v76 /*: any*/ ,
                                            v64 /*: any*/ ,
                                            v63 /*: any*/ ,
                                            v72 /*: any*/ ,
                                            v39 /*: any*/ 
                                        ],
                                        "type": "ThirdPartyUser"
                                    },
                                    v62 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "alias": "channelId",
                                                "kind": "ScalarField",
                                                "name": "externalId"
                                            },
                                            v68 /*: any*/ 
                                        ],
                                        "type": "ExternalConversation"
                                    }
                                ]
                            },
                            v39 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v78 = {
        "kind": "ScalarField",
        "name": "thumbnailUrl"
    }, v79 = [
        v39 /*: any*/ ,
        v56 /*: any*/ ,
        v64 /*: any*/ ,
        v63 /*: any*/ ,
        v71 /*: any*/ ,
        v72 /*: any*/ 
    ], v80 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": [
            {
                "concreteType": "ThirdPartyUser",
                "kind": "LinkedField",
                "name": "thirdPartyUser",
                "plural": false,
                "selections": v79 /*: any*/ 
            },
            {
                "concreteType": "GraphStoreSimplifiedUserLinkedThirdPartyUserInverseConnection",
                "kind": "LinkedField",
                "name": "linkedUsers",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "GraphStoreSimplifiedUserLinkedThirdPartyUserInverseEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v38 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v56 /*: any*/ ,
                                            v63 /*: any*/ ,
                                            v39 /*: any*/ 
                                        ],
                                        "type": "AtlassianAccountUser"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": v61 /*: any*/ ,
                                        "type": "AppUser"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": v61 /*: any*/ ,
                                        "type": "CustomerUser"
                                    }
                                ]
                            },
                            v39 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v81 = [
        v39 /*: any*/ ,
        v56 /*: any*/ 
    ], v82 = {
        "concreteType": "ThirdPartyUser",
        "kind": "LinkedField",
        "name": "thirdPartyUser",
        "plural": false,
        "selections": v81 /*: any*/ 
    }, v83 = [
        v82 /*: any*/ 
    ], v84 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "members",
        "plural": true,
        "selections": v83 /*: any*/ 
    }, v85 = {
        "kind": "ScalarField",
        "name": "memberCount"
    }, v86 = {
        "kind": "ScalarField",
        "name": "status"
    }, v87 = {
        "kind": "ScalarField",
        "name": "lastUpdated"
    }, v88 = [
        v56 /*: any*/ ,
        v39 /*: any*/ 
    ], v89 = {
        "concreteType": "ThirdPartyUser",
        "kind": "LinkedField",
        "name": "thirdPartyUser",
        "plural": false,
        "selections": v88 /*: any*/ 
    }, v90 = [
        v89 /*: any*/ 
    ], v91 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "owners",
        "plural": true,
        "selections": v90 /*: any*/ 
    }, v92 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": v90 /*: any*/ 
    }, v93 = [
        v38 /*: any*/ ,
        v56 /*: any*/ ,
        v39 /*: any*/ 
    ], v94 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": v93 /*: any*/ 
    }, v95 = [
        v38 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v39 /*: any*/ ,
                v68 /*: any*/ 
            ],
            "type": "ExternalCustomerOrg"
        },
        v62 /*: any*/ 
    ], v96 = [
        v91 /*: any*/ 
    ], v97 = {
        "kind": "LinkedField",
        "name": "parent",
        "plural": false,
        "selections": v95 /*: any*/ 
    }, v98 = [
        {
            "kind": "ScalarField",
            "name": "lastActivityAt"
        },
        {
            "kind": "ScalarField",
            "name": "event"
        }
    ], v99 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "assignee",
        "plural": false,
        "selections": v83 /*: any*/ 
    }, v100 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": v83 /*: any*/ 
    }, v101 = {
        "kind": "ScalarField",
        "name": "dueDate"
    }, v102 = {
        "kind": "ScalarField",
        "name": "workspaceName"
    }, v103 = {
        "kind": "ScalarField",
        "name": "excerpt"
    }, v104 = {
        "kind": "ScalarField",
        "name": "eventEndTime"
    }, v105 = {
        "kind": "ScalarField",
        "name": "eventStartTime"
    }, v106 = {
        "kind": "ScalarField",
        "name": "videoMeetingUrl"
    }, v107 = {
        "concreteType": "ThirdPartyUser",
        "kind": "LinkedField",
        "name": "allContributors",
        "plural": true,
        "selections": [
            v56 /*: any*/ ,
            v76 /*: any*/ ,
            v64 /*: any*/ ,
            v63 /*: any*/ ,
            v71 /*: any*/ ,
            v72 /*: any*/ ,
            v39 /*: any*/ 
        ]
    }, v108 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v109 = [
        v45 /*: any*/ ,
        v53 /*: any*/ 
    ], v110 = [
        v52 /*: any*/ ,
        v68 /*: any*/ ,
        v39 /*: any*/ 
    ], v111 = [
        {
            "kind": "ScalarField",
            "name": "targetDate"
        },
        {
            "kind": "ScalarField",
            "name": "targetDateType"
        }
    ], v112 = [
        v45 /*: any*/ 
    ], v113 = {
        "concreteType": "AssetsLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "web"
            }
        ]
    }, v114 = {
        "concreteType": "AssetsSchema",
        "kind": "LinkedField",
        "name": "objectSchemaEntity",
        "plural": false,
        "selections": v88 /*: any*/ 
    }, v115 = [
        {
            "kind": "ScalarField",
            "name": "url48"
        }
    ], v116 = [
        v52 /*: any*/ ,
        v39 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v21 /*: any*/ ,
                v22 /*: any*/ ,
                v23 /*: any*/ ,
                v24 /*: any*/ ,
                v25 /*: any*/ ,
                v26 /*: any*/ ,
                v27 /*: any*/ ,
                v28 /*: any*/ ,
                v29 /*: any*/ ,
                v30 /*: any*/ ,
                v31 /*: any*/ ,
                v32 /*: any*/ ,
                v33 /*: any*/ ,
                v34 /*: any*/ ,
                v35 /*: any*/ ,
                v36 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "searchResultsAsyncQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "includeGithubCode",
                            "variableName": "includeGithubCode"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeIconUrl",
                            "variableName": "includeIconUrl"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeJiraLiteModeFields",
                            "variableName": "includeJiraLiteModeFields"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeNavBoostScore",
                            "variableName": "includeNavBoostScore"
                        },
                        {
                            "kind": "Variable",
                            "name": "includePassionfruitAsk",
                            "variableName": "includePassionfruitAsk"
                        },
                        {
                            "kind": "Variable",
                            "name": "includePositions",
                            "variableName": "includePositions"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeReactionsAndCommentCount",
                            "variableName": "includeReactionsAndCommentCount"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeRisk",
                            "variableName": "includeRisk"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeThirdPartyId",
                            "variableName": "includeThirdPartyId"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "searchResults_AtlassianSearchPage_SearchResultsAsyncInner_queryData"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v27 /*: any*/ ,
                v2 /*: any*/ ,
                v35 /*: any*/ ,
                v24 /*: any*/ ,
                v8 /*: any*/ ,
                v28 /*: any*/ ,
                v29 /*: any*/ ,
                v30 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v23 /*: any*/ ,
                v1 /*: any*/ ,
                v26 /*: any*/ ,
                v34 /*: any*/ ,
                v4 /*: any*/ ,
                v36 /*: any*/ ,
                v32 /*: any*/ ,
                v33 /*: any*/ ,
                v11 /*: any*/ ,
                v31 /*: any*/ ,
                v12 /*: any*/ ,
                v25 /*: any*/ ,
                v0 /*: any*/ ,
                v6 /*: any*/ ,
                v10 /*: any*/ ,
                v7 /*: any*/ ,
                v13 /*: any*/ ,
                v9 /*: any*/ ,
                v15 /*: any*/ ,
                v19 /*: any*/ ,
                v22 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v21 /*: any*/ ,
                v16 /*: any*/ ,
                v14 /*: any*/ ,
                v20 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__isassetsenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__iscustomerorgownersenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__isdealownersenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__isslacktopreactionenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "searchResultsAsyncQuery",
            "selections": [
                {
                    "concreteType": "SearchQueryAPI",
                    "kind": "LinkedField",
                    "name": "search",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "search",
                            "args": v37 /*: any*/ ,
                            "concreteType": "SearchItemConnection",
                            "kind": "LinkedField",
                            "name": "asyncSearch",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isCachedResult"
                                },
                                {
                                    "concreteType": "SearchResultItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v38 /*: any*/ ,
                                                v39 /*: any*/ ,
                                                v40 /*: any*/ ,
                                                {
                                                    "concreteType": "SearchLinkedResult",
                                                    "kind": "LinkedField",
                                                    "name": "linkedResults",
                                                    "plural": true,
                                                    "selections": [
                                                        v39 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "category"
                                                        },
                                                        v41 /*: any*/ ,
                                                        v42 /*: any*/ ,
                                                        v43 /*: any*/ ,
                                                        v44 /*: any*/ ,
                                                        v40 /*: any*/ ,
                                                        v45 /*: any*/ ,
                                                        v46 /*: any*/ ,
                                                        v47 /*: any*/ ,
                                                        v48 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isSearchResult"
                                                },
                                                v42 /*: any*/ ,
                                                v44 /*: any*/ ,
                                                v43 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareGoal",
                                                            "kind": "LinkedField",
                                                            "name": "goal",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareLocalizationField",
                                                                            "kind": "LinkedField",
                                                                            "name": "localizedLabel",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "messageId"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v49 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "score"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "TownsquareTargetDate",
                                                                    "kind": "LinkedField",
                                                                    "name": "targetDate",
                                                                    "plural": false,
                                                                    "selections": v51 /*: any*/ 
                                                                },
                                                                v39 /*: any*/ ,
                                                                v52 /*: any*/ ,
                                                                v40 /*: any*/ 
                                                            ]
                                                        },
                                                        v55 /*: any*/ 
                                                    ],
                                                    "type": "SearchResultAtlasGoal"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareProject",
                                                            "kind": "LinkedField",
                                                            "name": "project",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isPrivate"
                                                                },
                                                                {
                                                                    "concreteType": "TownsquareTargetDate",
                                                                    "kind": "LinkedField",
                                                                    "name": "dueDate",
                                                                    "plural": false,
                                                                    "selections": v51 /*: any*/ 
                                                                },
                                                                {
                                                                    "concreteType": "TownsquareProjectState",
                                                                    "kind": "LinkedField",
                                                                    "name": "state",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v50 /*: any*/ ,
                                                                        v49 /*: any*/ 
                                                                    ]
                                                                },
                                                                v39 /*: any*/ ,
                                                                v52 /*: any*/ 
                                                            ]
                                                        },
                                                        v55 /*: any*/ 
                                                    ],
                                                    "type": "SearchResultAtlasProject"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v45 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "entity",
                                                            "plural": false,
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "SearchFederatedEmailUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "sender",
                                                                            "plural": false,
                                                                            "selections": v57 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "SearchFederatedEmailEntity"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchResultFederated"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v45 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "tier"
                                                        },
                                                        {
                                                            "concreteType": "CompassComponent",
                                                            "kind": "LinkedField",
                                                            "name": "component",
                                                            "plural": false,
                                                            "selections": [
                                                                v40 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "state"
                                                                },
                                                                v39 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "ownerId"
                                                        }
                                                    ],
                                                    "type": "SearchResultCompassComponent"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v58 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isVerified"
                                                        },
                                                        {
                                                            "concreteType": "SearchConfluenceResultSpace",
                                                            "kind": "LinkedField",
                                                            "name": "space",
                                                            "plural": false,
                                                            "selections": [
                                                                v39 /*: any*/ ,
                                                                v56 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "webUiLink"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "confluenceEntity",
                                                            "plural": false,
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v46 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ConfluenceCommentCountSummary",
                                                                            "kind": "LinkedField",
                                                                            "name": "commentCountSummary",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v59 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "ConfluenceLikesSummary",
                                                                            "kind": "LinkedField",
                                                                            "name": "likesSummary",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v60 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "ConfluencePage"
                                                                },
                                                                v62 /*: any*/ 
                                                            ]
                                                        },
                                                        v66 /*: any*/ ,
                                                        v55 /*: any*/ ,
                                                        {
                                                            "condition": "includeNavBoostScore",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "navBoostScore"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchConfluencePageBlogAttachment"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v58 /*: any*/ ,
                                                        v55 /*: any*/ 
                                                    ],
                                                    "type": "SearchConfluenceSpace"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v48 /*: any*/ ,
                                                        v41 /*: any*/ ,
                                                        v47 /*: any*/ ,
                                                        v46 /*: any*/ ,
                                                        v45 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "permissionLevel"
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "entity",
                                                            "plural": false,
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v56 /*: any*/ ,
                                                                        v67 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalBranch"
                                                                },
                                                                v62 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v69 /*: any*/ ,
                                                                        {
                                                                            "condition": "includeReactionsAndCommentCount",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "ExternalReaction",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "reactionsV2",
                                                                                    "plural": true,
                                                                                    "selections": v70 /*: any*/ 
                                                                                }
                                                                            ]
                                                                        },
                                                                        v73 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalComment"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "ExternalUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "author",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v75 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v67 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalCommit"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "container",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v38 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v68 /*: any*/ ,
                                                                                        v43 /*: any*/ 
                                                                                    ],
                                                                                    "type": "ExternalSpace"
                                                                                },
                                                                                v62 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalReaction",
                                                                            "kind": "LinkedField",
                                                                            "name": "reactions",
                                                                            "plural": true,
                                                                            "selections": v70 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalDocumentType",
                                                                            "kind": "LinkedField",
                                                                            "name": "type",
                                                                            "plural": false,
                                                                            "selections": v54 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalLargeContent",
                                                                            "kind": "LinkedField",
                                                                            "name": "nonIndexableContent",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "mediaThumbnailUrl"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "parent",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v38 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v68 /*: any*/ 
                                                                                    ],
                                                                                    "type": "ExternalDocument"
                                                                                },
                                                                                v62 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "includeThirdPartyId",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "thirdPartyId"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "includeReactionsAndCommentCount",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "commentCount"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "ExternalDocument"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v71 /*: any*/ ,
                                                                        v77 /*: any*/ ,
                                                                        v40 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ExternalAttachment",
                                                                            "kind": "LinkedField",
                                                                            "name": "attachments",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v42 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "mimeType"
                                                                                },
                                                                                v43 /*: any*/ ,
                                                                                v78 /*: any*/ ,
                                                                                v38 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v80 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "container",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v38 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v68 /*: any*/ ,
                                                                                        v84 /*: any*/ ,
                                                                                        v44 /*: any*/ ,
                                                                                        v39 /*: any*/ ,
                                                                                        v85 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "membershipType"
                                                                                        }
                                                                                    ],
                                                                                    "type": "ExternalConversation"
                                                                                },
                                                                                v62 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "lastActive"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "reactionCount"
                                                                        }
                                                                    ],
                                                                    "type": "ExternalMessage"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v40 /*: any*/ ,
                                                                        v68 /*: any*/ ,
                                                                        v85 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ExternalUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "members",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v38 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "ExternalConversation"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v86 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "endDate"
                                                                        },
                                                                        v87 /*: any*/ ,
                                                                        v91 /*: any*/ ,
                                                                        v92 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalCampaign"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "displayNumber"
                                                                        },
                                                                        v86 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "closedAt"
                                                                        },
                                                                        v87 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ExternalUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "owners",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v89 /*: any*/ ,
                                                                                v94 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v92 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "container",
                                                                            "plural": false,
                                                                            "selections": v95 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "ExternalCase"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v68 /*: any*/ ,
                                                                        {
                                                                            "condition": "__relay_internal__pv__iscustomerorgownersenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "ExternalUser",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "contributors",
                                                                                    "plural": true,
                                                                                    "selections": v83 /*: any*/ 
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__iscustomerorgownersenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": v96 /*: any*/ 
                                                                        },
                                                                        v97 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ExternalCustomerOrgLastActivity",
                                                                            "kind": "LinkedField",
                                                                            "name": "customerOrgLastActivity",
                                                                            "plural": false,
                                                                            "selections": v98 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "ExternalCustomerOrg"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "stage"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "dealClosedAt"
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalDealLastActivity",
                                                                            "kind": "LinkedField",
                                                                            "name": "lastActivity",
                                                                            "plural": false,
                                                                            "selections": v98 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__isdealownersenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": v96 /*: any*/ 
                                                                        },
                                                                        v97 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalDeal"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v69 /*: any*/ ,
                                                                        v99 /*: any*/ ,
                                                                        v100 /*: any*/ ,
                                                                        v101 /*: any*/ ,
                                                                        v52 /*: any*/ ,
                                                                        v86 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalProject"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v69 /*: any*/ ,
                                                                        v99 /*: any*/ ,
                                                                        v100 /*: any*/ ,
                                                                        v101 /*: any*/ ,
                                                                        v86 /*: any*/ ,
                                                                        v46 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "team"
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalWorkItemProject",
                                                                            "kind": "LinkedField",
                                                                            "name": "workItemProject",
                                                                            "plural": false,
                                                                            "selections": v81 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalProvider",
                                                                            "kind": "LinkedField",
                                                                            "name": "provider",
                                                                            "plural": false,
                                                                            "selections": v57 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "ExternalWorkItem"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v42 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "lastUpdate"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "pullRequestId"
                                                                        },
                                                                        {
                                                                            "alias": "pullRequestStatus",
                                                                            "kind": "ScalarField",
                                                                            "name": "status"
                                                                        },
                                                                        v67 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalPullRequest"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "durationInSeconds"
                                                                        },
                                                                        v78 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ExternalChapter",
                                                                            "kind": "LinkedField",
                                                                            "name": "chapters",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v42 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "startTimeInSeconds"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "createdBy",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v82 /*: any*/ ,
                                                                                v94 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "ExternalVideo"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v39 /*: any*/ ,
                                                                        v43 /*: any*/ ,
                                                                        v102 /*: any*/ ,
                                                                        v91 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalDashboard"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v39 /*: any*/ ,
                                                                        v43 /*: any*/ ,
                                                                        {
                                                                            "alias": "dataTableType",
                                                                            "kind": "ScalarField",
                                                                            "name": "type"
                                                                        },
                                                                        v102 /*: any*/ ,
                                                                        v91 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalDataTable"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "accountName"
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "contactUser",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "ThirdPartyUser",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "thirdPartyUser",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v56 /*: any*/ ,
                                                                                        v72 /*: any*/ ,
                                                                                        v39 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "ExternalCustomerContact"
                                                                }
                                                            ]
                                                        },
                                                        v103 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "entity",
                                                            "plural": false,
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v100 /*: any*/ ,
                                                                        v104 /*: any*/ ,
                                                                        v105 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "recurringEventId"
                                                                        },
                                                                        v106 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalCalendarEvent"
                                                                },
                                                                v62 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "ExternalThumbnail",
                                                                            "kind": "LinkedField",
                                                                            "name": "thumbnail",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "externalUrl"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "ExternalDesign"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "SearchResultGraphDocument",
                                                            "kind": "LinkedField",
                                                            "name": "linkedEntities",
                                                            "plural": true,
                                                            "selections": [
                                                                v39 /*: any*/ ,
                                                                v42 /*: any*/ ,
                                                                v43 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "entity",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v38 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v105 /*: any*/ ,
                                                                                v104 /*: any*/ ,
                                                                                v106 /*: any*/ 
                                                                            ],
                                                                            "type": "ExternalCalendarEvent"
                                                                        },
                                                                        v62 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v68 /*: any*/ ,
                                                                                v73 /*: any*/ 
                                                                            ],
                                                                            "type": "ExternalComment"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v80 /*: any*/ ,
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "container",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v38 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v84 /*: any*/ ,
                                                                                                v44 /*: any*/ 
                                                                                            ],
                                                                                            "type": "ExternalConversation"
                                                                                        },
                                                                                        v62 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v71 /*: any*/ ,
                                                                                v77 /*: any*/ ,
                                                                                v40 /*: any*/ 
                                                                            ],
                                                                            "type": "ExternalMessage"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v40 /*: any*/ 
                                                                            ],
                                                                            "type": "ExternalConversation"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "parentId"
                                                                },
                                                                v103 /*: any*/ ,
                                                                {
                                                                    "concreteType": "ThirdPartyUser",
                                                                    "kind": "LinkedField",
                                                                    "name": "initialContributors",
                                                                    "plural": true,
                                                                    "selections": v79 /*: any*/ 
                                                                },
                                                                v47 /*: any*/ ,
                                                                v107 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "ThirdPartyUser",
                                                            "kind": "LinkedField",
                                                            "name": "initialContributors",
                                                            "plural": true,
                                                            "selections": [
                                                                v56 /*: any*/ ,
                                                                v63 /*: any*/ ,
                                                                v39 /*: any*/ ,
                                                                v64 /*: any*/ ,
                                                                v71 /*: any*/ ,
                                                                v72 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "SearchResultGraphTab",
                                                            "kind": "LinkedField",
                                                            "name": "tabs",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "tabId"
                                                                },
                                                                v42 /*: any*/ ,
                                                                v43 /*: any*/ ,
                                                                v38 /*: any*/ 
                                                            ]
                                                        },
                                                        v102 /*: any*/ ,
                                                        {
                                                            "concreteType": "SearchResultGraphAttachment",
                                                            "kind": "LinkedField",
                                                            "name": "attachments",
                                                            "plural": true,
                                                            "selections": [
                                                                v42 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "fileType"
                                                                },
                                                                v43 /*: any*/ ,
                                                                v38 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "containerName"
                                                        },
                                                        {
                                                            "concreteType": "ThirdPartyUser",
                                                            "kind": "LinkedField",
                                                            "name": "allContributors",
                                                            "plural": true,
                                                            "selections": v81 /*: any*/ 
                                                        },
                                                        v107 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "links"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "linkedEntitiesType"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "connectorId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "connectorProduct"
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__isslacktopreactionenabledrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "SearchSlackReaction",
                                                                    "kind": "LinkedField",
                                                                    "name": "topReaction",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "emojiName"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "emojiUrl"
                                                                        },
                                                                        v60 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchResultGraphDocument"
                                                },
                                                {
                                                    "condition": "includeGithubCode",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "path"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "language"
                                                                },
                                                                v45 /*: any*/ ,
                                                                {
                                                                    "concreteType": "SearchResultCodeRepository",
                                                                    "kind": "LinkedField",
                                                                    "name": "repository",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v56 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "namespace"
                                                                        },
                                                                        v43 /*: any*/ ,
                                                                        v39 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "SearchResultGraphCode"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v45 /*: any*/ ,
                                                        v53 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssue",
                                                            "kind": "LinkedField",
                                                            "name": "issue",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "issueTypeAvatarUrl"
                                                                },
                                                                v108 /*: any*/ ,
                                                                v52 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueTypeField",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypeField",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueType",
                                                                            "kind": "LinkedField",
                                                                            "name": "issueType",
                                                                            "plural": false,
                                                                            "selections": v88 /*: any*/ 
                                                                        },
                                                                        v39 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "ids",
                                                                            "value": [
                                                                                "project"
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldsById",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v38 /*: any*/ ,
                                                                                        v56 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraProject",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "project",
                                                                                                    "plural": false,
                                                                                                    "selections": v81 /*: any*/ 
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraProjectField"
                                                                                        },
                                                                                        v39 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": "fieldsById(ids:[\"project\"])"
                                                                },
                                                                {
                                                                    "concreteType": "JiraSingleSelectUserPickerField",
                                                                    "kind": "LinkedField",
                                                                    "name": "assigneeField",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v75 /*: any*/ ,
                                                                        v39 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "includeJiraLiteModeFields",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraPriorityField",
                                                                            "kind": "LinkedField",
                                                                            "name": "priorityField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraPriority",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "priority",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v53 /*: any*/ ,
                                                                                        v56 /*: any*/ ,
                                                                                        v39 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v39 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraLabelsField",
                                                                            "kind": "LinkedField",
                                                                            "name": "labelsField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "args": [
                                                                                        {
                                                                                            "kind": "Literal",
                                                                                            "name": "first",
                                                                                            "value": 5
                                                                                        }
                                                                                    ],
                                                                                    "concreteType": "JiraLabelConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "selectedLabelsConnection",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraLabelEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraLabel",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": v57 /*: any*/ 
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": "selectedLabelsConnection(first:5)"
                                                                                },
                                                                                v39 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v39 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchResultJiraIssue"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectKey"
                                                        },
                                                        v45 /*: any*/ ,
                                                        v53 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraProject",
                                                            "kind": "LinkedField",
                                                            "name": "project",
                                                            "plural": false,
                                                            "selections": [
                                                                v108 /*: any*/ ,
                                                                {
                                                                    "condition": "includeJiraLiteModeFields",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "lead",
                                                                            "plural": false,
                                                                            "selections": v74 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraAvatar",
                                                                            "kind": "LinkedField",
                                                                            "name": "avatar",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "small"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "projectStyle"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "projectType"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraProjectCategory",
                                                                            "kind": "LinkedField",
                                                                            "name": "category",
                                                                            "plural": false,
                                                                            "selections": v88 /*: any*/ 
                                                                        }
                                                                    ]
                                                                },
                                                                v39 /*: any*/ 
                                                            ]
                                                        },
                                                        v66 /*: any*/ 
                                                    ],
                                                    "type": "SearchResultJiraProject"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v109 /*: any*/ ,
                                                    "type": "SearchResultJiraPlan"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v45 /*: any*/ ,
                                                        v53 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraBoard",
                                                            "kind": "LinkedField",
                                                            "name": "board",
                                                            "plural": false,
                                                            "selections": [
                                                                v53 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "boardFrontendUrl"
                                                                },
                                                                v39 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchResultJiraBoard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v109 /*: any*/ ,
                                                    "type": "SearchResultJiraDashboard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v109 /*: any*/ ,
                                                    "type": "SearchResultJiraFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "MercuryFocusArea",
                                                            "kind": "LinkedField",
                                                            "name": "focusArea",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "MercuryFocusAreaStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": v110 /*: any*/ 
                                                                },
                                                                {
                                                                    "concreteType": "MercuryFocusAreaHealth",
                                                                    "kind": "LinkedField",
                                                                    "name": "health",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v52 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "color"
                                                                        },
                                                                        v68 /*: any*/ ,
                                                                        v39 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "MercuryTargetDate",
                                                                    "kind": "LinkedField",
                                                                    "name": "targetDate",
                                                                    "plural": false,
                                                                    "selections": v111 /*: any*/ 
                                                                },
                                                                v39 /*: any*/ ,
                                                                v56 /*: any*/ ,
                                                                {
                                                                    "concreteType": "MercuryFocusAreaType",
                                                                    "kind": "LinkedField",
                                                                    "name": "focusAreaType",
                                                                    "plural": false,
                                                                    "selections": v81 /*: any*/ 
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "owner",
                                                                    "plural": false,
                                                                    "selections": v93 /*: any*/ 
                                                                }
                                                            ]
                                                        },
                                                        v45 /*: any*/ 
                                                    ],
                                                    "type": "SearchResultMercuryFocusArea"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v45 /*: any*/ ,
                                                        {
                                                            "concreteType": "MercuryFocusArea",
                                                            "kind": "LinkedField",
                                                            "name": "focusArea",
                                                            "plural": false,
                                                            "selections": v88 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "SearchResultMercuryFocusAreaStatusUpdate"
                                                },
                                                {
                                                    "condition": "includeRisk",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v45 /*: any*/ ,
                                                                {
                                                                    "concreteType": "MercuryRisk",
                                                                    "kind": "LinkedField",
                                                                    "name": "risk",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "MercuryRiskStatus",
                                                                            "kind": "LinkedField",
                                                                            "name": "status",
                                                                            "plural": false,
                                                                            "selections": v110 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "concreteType": "MercuryRiskTargetDate",
                                                                            "kind": "LinkedField",
                                                                            "name": "targetDate",
                                                                            "plural": false,
                                                                            "selections": v111 /*: any*/ 
                                                                        },
                                                                        v39 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "SearchResultMercuryRisk"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "includePassionfruitAsk",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "SpfAsk",
                                                                    "kind": "LinkedField",
                                                                    "name": "ask",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v86 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "SpfAskTargetDate",
                                                                            "kind": "LinkedField",
                                                                            "name": "targetDate",
                                                                            "plural": false,
                                                                            "selections": v111 /*: any*/ 
                                                                        },
                                                                        v39 /*: any*/ 
                                                                    ]
                                                                },
                                                                v45 /*: any*/ 
                                                            ],
                                                            "type": "SearchResultSpfAsk"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v112 /*: any*/ ,
                                                    "type": "SearchResultTrelloBoard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v112 /*: any*/ ,
                                                    "type": "SearchResultTrelloCard"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__isassetsenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v45 /*: any*/ ,
                                                                {
                                                                    "concreteType": "AssetsSchema",
                                                                    "kind": "LinkedField",
                                                                    "name": "objectSchemaEntity",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v113 /*: any*/ ,
                                                                        v39 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "SearchResultAssetsObjectSchema"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v45 /*: any*/ ,
                                                                v114 /*: any*/ ,
                                                                {
                                                                    "concreteType": "AssetsObjectType",
                                                                    "kind": "LinkedField",
                                                                    "name": "objectTypeEntity",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "AssetsIcon",
                                                                            "kind": "LinkedField",
                                                                            "name": "icon",
                                                                            "plural": false,
                                                                            "selections": v115 /*: any*/ 
                                                                        },
                                                                        v113 /*: any*/ ,
                                                                        v39 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "SearchResultAssetsObjectType"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v45 /*: any*/ ,
                                                                v114 /*: any*/ ,
                                                                {
                                                                    "concreteType": "AssetsObject",
                                                                    "kind": "LinkedField",
                                                                    "name": "objectEntity",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "AssetsAvatar",
                                                                            "kind": "LinkedField",
                                                                            "name": "avatar",
                                                                            "plural": false,
                                                                            "selections": v115 /*: any*/ 
                                                                        },
                                                                        v113 /*: any*/ ,
                                                                        v39 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "SearchResultAssetsObject"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "includePositions",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "RadarPosition",
                                                                    "kind": "LinkedField",
                                                                    "name": "position",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v38 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "RadarWorker",
                                                                            "kind": "LinkedField",
                                                                            "name": "worker",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "preferredName"
                                                                                },
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "user",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v38 /*: any*/ ,
                                                                                        v63 /*: any*/ ,
                                                                                        v39 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v39 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "fieldIdIsIn",
                                                                                    "value": [
                                                                                        "positionId",
                                                                                        "positionStatus",
                                                                                        "positionJobTitle",
                                                                                        "positionPositionTitle",
                                                                                        "positionKey",
                                                                                        "positionExternalPositionKey",
                                                                                        "positionWorker",
                                                                                        "focusArea"
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "concreteType": "RadarFieldValueIdPair",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldValues",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "fieldId"
                                                                                },
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fieldValue",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v38 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": "stringValue",
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "value"
                                                                                                }
                                                                                            ],
                                                                                            "type": "RadarStringFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "value",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v38 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v56 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "MercuryFocusAreaStatus",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "status",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v116 /*: any*/ 
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "MercuryFocusAreaHealth",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "health",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v116 /*: any*/ 
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "MercuryFocusArea"
                                                                                                        },
                                                                                                        v62 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "RadarAriFieldValue"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": "fieldValues(fieldIdIsIn:[\"positionId\",\"positionStatus\",\"positionJobTitle\",\"positionPositionTitle\",\"positionKey\",\"positionExternalPositionKey\",\"positionWorker\",\"focusArea\"])"
                                                                        },
                                                                        v39 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "SearchResultTalentPosition"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "SearchQueryInfo",
                                    "kind": "LinkedField",
                                    "name": "queryInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "originalQuery"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "replacementQuery"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "suggestedQuery"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "originalQueryType"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "confidenceScore"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "shouldTriggerAutocorrectionExperience"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "traceId"
                                },
                                {
                                    "concreteType": "SearchError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "statusCode"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "product"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "integration"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "search",
                            "args": v37 /*: any*/ ,
                            "filters": [
                                "experience",
                                "enableHighlighting",
                                "query",
                                "sort",
                                "disableQueryReplacement",
                                "fanoutExperimentCohort",
                                "expectResult",
                                "filters",
                                "analytics",
                                "experimentContext",
                                "matchingLayerExperimentsMetadata"
                            ],
                            "handle": "connection",
                            "key": "SearchResultsAsyncPagination__search",
                            "kind": "LinkedHandle",
                            "name": "asyncSearch"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "775f0a93339c95953a5c0a13e0c4fdc7f2e0bf7797a295f530fc8132b9d0f625",
            "metadata": {},
            "name": "searchResultsAsyncQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__isassetsenabledrelayprovider": (0, $5SuoG.default),
                "__relay_internal__pv__iscustomerorgownersenabledrelayprovider": (0, $aqtD4.default),
                "__relay_internal__pv__isdealownersenabledrelayprovider": (0, $4PNBt.default),
                "__relay_internal__pv__isslacktopreactionenabledrelayprovider": (0, $iLuVY.default)
            }
        }
    };
}();
$b96117069722906e$var$node.hash = "2861f5f7d03ad42a01f40d03e504a63f";
var $b96117069722906e$export$2e2bcd8739ae039 = $b96117069722906e$var$node;
module.exports["default"] = $b96117069722906e$export$2e2bcd8739ae039;

});

parcelRegister("5SuoG", function(module, exports) {
$parcel$export(module.exports, "default", () => $a80efe5f48387681$export$2e2bcd8739ae039);

var $dh538 = parcelRequire("dh538");

var $a80efe5f48387681$export$2e2bcd8739ae039 = {
    get () {
        return (0, $dh538.fg)('assets_rovo_search_all');
    }
};

});

parcelRegister("aqtD4", function(module, exports) {
$parcel$export(module.exports, "default", () => $f237de69fbda33b3$export$2e2bcd8739ae039);

var $dh538 = parcelRequire("dh538");

var // https://switcheroo.atlassian.com/ui/gates/6eab30ba-7a4d-456d-988a-2cd59bb9f4b1/key/is_customer_org_owners_enabled_in_ui
$f237de69fbda33b3$export$2e2bcd8739ae039 = {
    get () {
        return (0, $dh538.fg)('is_customer_org_owners_enabled_in_ui');
    }
};

});

parcelRegister("4PNBt", function(module, exports) {
$parcel$export(module.exports, "default", () => $3cc92f2b68d213c5$export$2e2bcd8739ae039);

var $dh538 = parcelRequire("dh538");

var //https://switcheroo.atlassian.com/ui/gates/30d75a94-370c-43aa-8931-79253af61396/key/is_deal_owners_enabled_in_ui
$3cc92f2b68d213c5$export$2e2bcd8739ae039 = {
    get () {
        return (0, $dh538.fg)('is_deal_owners_enabled_in_ui');
    }
};

});

parcelRegister("iLuVY", function(module, exports) {
$parcel$export(module.exports, "default", () => $d1e92f0dfdeab4f2$export$2e2bcd8739ae039);
// eslint-disable-next-line  @atlassian/tangerine/import/no-parent-imports

var $2OtFZ = parcelRequire("2OtFZ");

var $d1e92f0dfdeab4f2$export$2e2bcd8739ae039 = {
    get () {
        return (0, $2OtFZ.serveSlackTopReactionInSearchExperiment)({
            fireExperimentExposure: false
        });
    }
};

});

parcelRegister("atY36", function(module, exports) {
/**
 * @generated SignedSource<<403f147e916912fe0c48265692200865>>
 * @relayHash 68a75d183b7539fe986ed18773f1120a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b5a34acb4d7d17f7799133361703a90caebf20808095b5e29e02fc3b4e0d6a76
const $e7a5cc53246246d5$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cql"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    }, v4 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v5 = [
        v3 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "cql",
            "variableName": "cql"
        },
        v4 /*: any*/ 
    ], v6 = {
        "kind": "ScalarField",
        "name": "ari"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "searchResultsCqlQuery",
            "selections": [
                {
                    "args": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "searchResultsCql_AtlassianSearchPage"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "searchResultsCqlQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "ConfluenceSearchConnection",
                    "kind": "LinkedField",
                    "name": "confluence_search",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSearchResponseEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "ConfluenceSearchResponse",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "url"
                                        },
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "content",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "type"
                                                },
                                                {
                                                    "concreteType": "Space",
                                                    "kind": "LinkedField",
                                                    "name": "space",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                                                            "kind": "LinkedField",
                                                            "name": "links",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "webui"
                                                                }
                                                            ]
                                                        },
                                                        v7 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "title"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "excerpt"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "lastModified"
                                        },
                                        {
                                            "concreteType": "LinksContextBase",
                                            "kind": "LinkedField",
                                            "name": "links",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "base"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                }
                            ]
                        },
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v5 /*: any*/ ,
                    "filters": [
                        "cql"
                    ],
                    "handle": "connection",
                    "key": "SearchResultsCQLPagination__confluence_search",
                    "kind": "LinkedHandle",
                    "name": "confluence_search"
                }
            ]
        },
        "params": {
            "id": "b5a34acb4d7d17f7799133361703a90caebf20808095b5e29e02fc3b4e0d6a76",
            "metadata": {},
            "name": "searchResultsCqlQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e7a5cc53246246d5$var$node.hash = "8714af4459ffedbd0699977be49d7cf7";
var $e7a5cc53246246d5$export$2e2bcd8739ae039 = $e7a5cc53246246d5$var$node;
module.exports["default"] = $e7a5cc53246246d5$export$2e2bcd8739ae039;

});

parcelRegister("20r3r", function(module, exports) {

var $fXT59 = parcelRequire("fXT59");

const $4566ff69e3b9602b$export$fa81019546daea36 = (0, $fXT59.disposableValue)();
const $4566ff69e3b9602b$export$821c81800cc5b1e1 = ()=>{
    return $4566ff69e3b9602b$export$fa81019546daea36.value() || undefined;
};
const $4566ff69e3b9602b$export$c3c881dbbb056bcd = ()=>{
    $4566ff69e3b9602b$export$fa81019546daea36.update(Date.now());
};
const $4566ff69e3b9602b$export$99f330c261037d6f = ()=>{
    $4566ff69e3b9602b$export$fa81019546daea36.dispose();
};
module.exports["getQueryUpdatedTime"] = $4566ff69e3b9602b$export$821c81800cc5b1e1;
module.exports["setQueryUpdatedTime"] = $4566ff69e3b9602b$export$c3c881dbbb056bcd;
module.exports["disposeQueryUpdatedTime"] = $4566ff69e3b9602b$export$99f330c261037d6f;

});

parcelRegister("3CshZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $6yNqK = parcelRequire("6yNqK");


var $9rRKJ = parcelRequire("9rRKJ");


var $7WbA8 = parcelRequire("7WbA8");


var $j4ply = parcelRequire("j4ply");


var $djVCD = parcelRequire("djVCD");





var $b4tvS = parcelRequire("b4tvS");


var $731W9 = parcelRequire("731W9");

const $727cf3a51c81de07$export$fe94072fee8a6976 = ({ searchSessionId: searchSessionId, requestId: requestId, searchQuery: searchQuery, inputQuery: inputQuery, filters: filters, queryUpdatedTime: queryUpdatedTime, productSelected: productSelected, availableProducts: availableProducts, sort: sort, experimentConfig: experimentConfig, applicationMode: applicationMode, productEdition: productEdition, isCQL: isCQL, isLiteMode: isLiteMode })=>{
    const { filterSelections: filterSelections, filters: filterCategories } = filters;
    const has3pProducts = !!availableProducts.find((product)=>(0, $b4tvS.is3pProductKey)(product));
    const { frontendExperiments: frontendExperiments = {} } = experimentConfig;
    const is3pSearch = !!(has3pProducts && !productSelected || productSelected && (0, $b4tvS.is3pProductKey)(productSelected));
    const archivedStatus = filterSelections.some((selection)=>selection.value === (0, $6yNqK.OptionIds).ARCHIVED) ? [
        (0, $6yNqK.CURRENT),
        (0, $6yNqK.ARCHIVED)
    ] : [
        (0, $6yNqK.CURRENT)
    ];
    const commonAttributes = {
        searchSessionId: searchSessionId,
        traceId: requestId,
        productSelected: productSelected || (0, $6yNqK.ALL_PRODUCTS_STRING),
        availableProducts: availableProducts,
        mode: applicationMode,
        has3pProducts: has3pProducts,
        is3pSearch: is3pSearch,
        numberOfTerms: (searchQuery.match(/\w+/g) || []).length,
        queryLength: searchQuery.length,
        inputQueryLength: inputQuery.length,
        queryHash: (0, $731W9.sha256Hash)(searchQuery),
        filters: filterCategories,
        filterSelections: filterSelections,
        containerStatuses: archivedStatus,
        contentStatuses: archivedStatus,
        productEdition: productEdition,
        frontendExperiments: {
            activeExperiments: Object.keys(frontendExperiments).filter((experiment)=>frontendExperiments[experiment]?.serveExperiment),
            ...frontendExperiments
        },
        combinedExperiment: experimentConfig.combinedExperiment,
        version: 2,
        api: (0, $6yNqK.CROSSPRODUCT_SEARCH_API),
        wordCount: (searchQuery.match(/\w+/g) || []).length,
        isCQL: isCQL ?? false,
        queryUpdatedAgo: queryUpdatedTime ? Date.now() - queryUpdatedTime : undefined,
        sort: sort,
        isSearchPageRelay: true,
        isLiteMode: isLiteMode ?? false
    };
    const nonPrivacySafeAttributes = {
        query: searchQuery,
        inputQuery: inputQuery
    };
    return {
        commonAttributes: commonAttributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    };
};


const $484f7910e7f707a3$export$e955abb82869dc84 = (props = {})=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    // analytics attributes passed in from the product
    const [analyticsAttributes] = (0, $j4ply.useAnalyticsAttributes)();
    const [searchExperience] = (0, $djVCD.useSearchExperience)();
    const experiencePayload = (0, $42omo.useMemo)(()=>{
        // determine experience payload for analytics attributes, defaulting to store value if not provided
        const experience = props.experience || searchExperience;
        const isQuickFind = experience === (0, $9rRKJ.SearchExperience).QUICK_FIND;
        const isFullPageSearch = experience === (0, $9rRKJ.SearchExperience).SEARCH_PAGE;
        return {
            isFullPageSearch: isFullPageSearch,
            isQuickFind: isQuickFind
        };
    }, [
        props.experience,
        searchExperience
    ]);
    // use this hook to fire UI, track, and operational event types
    const fireAnalyticsEvent = (0, $42omo.useCallback)((payload)=>{
        createAnalyticsEvent({
            ...payload,
            source: payload.source || (0, $6yNqK.EVENT_SOURCE),
            attributes: {
                ...payload.attributes.commonAttributes,
                ...payload.attributes.additionalAttributes,
                ...analyticsAttributes,
                ...experiencePayload
            }
        }).fire((0, $6yNqK.DEFAULT_GAS_CHANNEL));
    }, [
        analyticsAttributes,
        createAnalyticsEvent,
        experiencePayload
    ]);
    // use this hook to fire screen event types
    const fireAnalyticsScreenEvent = (0, $42omo.useCallback)((payload)=>{
        createAnalyticsEvent({
            ...payload,
            eventType: 'screen',
            source: (0, $6yNqK.EVENT_SOURCE),
            attributes: {
                ...payload.attributes.commonAttributes,
                ...payload.attributes.additionalAttributes,
                ...analyticsAttributes,
                ...experiencePayload
            }
        }).fire((0, $6yNqK.DEFAULT_GAS_CHANNEL));
    }, [
        analyticsAttributes,
        createAnalyticsEvent,
        experiencePayload
    ]);
    return {
        fireAnalyticsEvent: fireAnalyticsEvent,
        fireAnalyticsScreenEvent: fireAnalyticsScreenEvent
    };
};
const $484f7910e7f707a3$export$58bac47385d8e8f4 = ()=>{
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [requestId] = (0, $djVCD.useResultsRequestId)();
    const [searchQuery] = (0, $djVCD.useSearchQuery)();
    const [inputQuery] = (0, $djVCD.useInputQuery)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [queryUpdatedTime] = (0, $djVCD.useQueryUpdatedTime)();
    const [productSelected] = (0, $djVCD.useSelectedProduct)();
    const availableProducts = (0, $j4ply.useAvailableProducts)();
    const [sort] = (0, $djVCD.useResultsSort)();
    const [experimentConfig] = (0, $j4ply.useExperimentConfig)();
    const filters = (0, $djVCD.useFilterAttributesForTracking)();
    const applicationMode = (0, $j4ply.useApplicationMode)();
    const [productEdition] = (0, $j4ply.useProductEdition)();
    const cqlState = (0, $djVCD.useCQL)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const [features] = (0, $j4ply.useFeatures)();
    const isLiteMode = features?.lite?.enabled ?? false;
    return (0, $727cf3a51c81de07$export$fe94072fee8a6976)({
        searchSessionId: searchSessionId,
        requestId: requestId,
        searchQuery: searchQuery,
        inputQuery: inputQuery,
        filters: filters,
        queryUpdatedTime: queryUpdatedTime,
        productSelected: productSelected,
        availableProducts: availableProducts,
        sort: sort,
        experimentConfig: experimentConfig,
        applicationMode: applicationMode,
        productEdition: productEdition,
        isCQL: !!cqlState,
        isLiteMode: isLiteMode,
        primaryProduct: primaryProduct,
        queryParams: queryParams
    });
};
module.exports["useAnalytics"] = $484f7910e7f707a3$export$e955abb82869dc84;
module.exports["useCommonAndPrivateAttributes"] = $484f7910e7f707a3$export$58bac47385d8e8f4;

});

parcelRegister("j4ply", function(module, exports) {
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required */ 
var $5d9b4 = parcelRequire("5d9b4");


var $9zUhf = parcelRequire("9zUhf");

var $FOT9i = parcelRequire("FOT9i");

var $cclHy = parcelRequire("cclHy");

var $1P1Tu = parcelRequire("1P1Tu");


var $cUcZ5 = parcelRequire("cUcZ5");


var $hm6w9 = parcelRequire("hm6w9");


var $9vOy1 = parcelRequire("9vOy1");


var $aaNIP = parcelRequire("aaNIP");


var $4cq9O = parcelRequire("4cq9O");


var $2Znam = parcelRequire("2Znam");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $8l0cM = parcelRequire("8l0cM");


var $2OtFZ = parcelRequire("2OtFZ");


var $c2HNo = parcelRequire("c2HNo");


var $2x777 = parcelRequire("2x777");


var $5XpfZ = parcelRequire("5XpfZ");


var $lIbf3 = parcelRequire("lIbf3");


var $42omo = parcelRequire("42omo");


var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");










parcelRequire("1yEFx");












var $lgPOO = parcelRequire("lgPOO");


var $32Kiv = parcelRequire("32Kiv");

const $66b8e22ddb9e6b9d$export$a607044ff61ed35a = ()=>{
    const staticContext = (0, $42omo.useContext)((0, $lgPOO.StaticBootstrapContext));
    const dynamicContext = (0, $42omo.useContext)((0, $lgPOO.DynamicBootstrapContext));
    // Unused, clean up when removing rovo-search-remove-rss-bootstrap-fg
    // Here due to type strictness on BootstrapState
    const unusedProps = {
        prevQueryParams: {},
        initialSpaceARIs: []
    };
    // `dynamicContext.thirdPartyConfigs` is only populated when
    // `rovo_fps_use_rovo_config` is ON. When the gate is OFF the dynamic
    // context value is `undefined`, and a naive `{ ...dynamicContext }` spread
    // would overwrite the populated `thirdPartyConfigs` coming from the
    // static context — breaking every consumer that destructures it from
    // `useBootstrap()` (e.g. universal-type filter resolution in the search
    // pipeline). Pick the dynamic value only when it's actually defined.
    // Remove this when rovo_fps_use_rovo_config is cleaned up
    const { thirdPartyConfigs: dynamicThirdPartyConfigs, ...dynamicContextRest } = dynamicContext;
    const mergedThirdPartyConfigs = dynamicThirdPartyConfigs ?? staticContext.thirdPartyConfigs;
    return [
        {
            ...unusedProps,
            ...staticContext,
            ...dynamicContextRest,
            thirdPartyConfigs: mergedThirdPartyConfigs
        }
    ];
};
const $66b8e22ddb9e6b9d$export$3129106711858d9e = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.applicationMode);
const $66b8e22ddb9e6b9d$export$8d72fbb40ea96b11 = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.linkedCloudARIs);
const $66b8e22ddb9e6b9d$export$42159b7c323c1456 = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.initialTextQueryParam);
const $66b8e22ddb9e6b9d$export$8b362261a7637697 = ()=>{
    const dynamicContext = (0, $42omo.useContext)((0, $lgPOO.DynamicBootstrapContext));
    return dynamicContext.referrer;
};
const $66b8e22ddb9e6b9d$export$f84f93bb6857e6bf = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>{
        const primaryProduct = ctx.primaryProduct;
        if (!primaryProduct) return false;
        return primaryProduct === (0, $b4tvS.ProductKeys).Confluence || primaryProduct === (0, $b4tvS.ProductKeys).Jira || primaryProduct === (0, $b4tvS.ProductKeys).Atlas;
    });
/**
 * Retrieve third party configs from the static bootstrap store (legacy path).
 *
 * Used by `useThirdPartyConfigsContext` when `rovo_fps_use_rovo_config` is OFF.
 * On the FG-OFF path the value is seeded from `useFetchConfigLegacy` and only
 * mutated by `setThirdPartyConfigs` from the legacy OAuth handler.
 */ const $66b8e22ddb9e6b9d$var$useThirdPartyConfigsFromStaticContext = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.thirdPartyConfigs);
/**
 * Retrieve third party configs from the dynamic bootstrap context (FG-ON path).
 *
 * Under `rovo_fps_use_rovo_config`, `BootstrapContextProvider` routes
 * `thirdPartyConfigs` into dynamic context so reference changes from
 * `useRovoConfig.onOAuthSuccess` propagate via React's normal context
 * broadcast. Falls back to the static-context default if (somehow) the
 * dynamic value is undefined.
 */ const $66b8e22ddb9e6b9d$var$useThirdPartyConfigsFromDynamicContext = ()=>{
    const dynamic = (0, $42omo.useContext)((0, $lgPOO.DynamicBootstrapContext));
    return dynamic?.thirdPartyConfigs ?? $66b8e22ddb9e6b9d$var$defaultStaticContextThirdPartyConfigs;
};
const $66b8e22ddb9e6b9d$var$defaultStaticContextThirdPartyConfigs = {};
const $66b8e22ddb9e6b9d$export$e2860ebe87e62f0d = ()=>{
    // The dispatch below intentionally calls one of two hooks based on a
    // stable feature-gate value. Per `rovo_fps_use_rovo_config` rollout
    // semantics the gate result does not flip within a session, so the
    // hook call order is stable across renders for a given user — but
    // the react-hooks rule cannot statically prove this, so we disable
    // `rules-of-hooks` for both call sites in the ternary.
    /* eslint-disable react-hooks/rules-of-hooks */ return (0, $dh538.fg)('rovo_fps_use_rovo_config') ? $66b8e22ddb9e6b9d$var$useThirdPartyConfigsFromDynamicContext() : $66b8e22ddb9e6b9d$var$useThirdPartyConfigsFromStaticContext();
/* eslint-enable react-hooks/rules-of-hooks */ };
const $66b8e22ddb9e6b9d$export$682b612810461522 = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.productEdition);
const $66b8e22ddb9e6b9d$export$b238e8fc41384c76 = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>!!ctx.rovoFeatures?.scas);
const $66b8e22ddb9e6b9d$export$120ac1729f38deb6 = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.intercomHmac);
const $66b8e22ddb9e6b9d$export$db066d8e499b7f58 = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.experimentConfig);
const $66b8e22ddb9e6b9d$export$414e9503f60ee463 = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.multiSiteSearchInRovo);
const $66b8e22ddb9e6b9d$export$a20db2e6915ac3c5 = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.isHello);
const $66b8e22ddb9e6b9d$export$c3427a530f474eaf = ()=>{
    const dynamicContext = (0, $42omo.useContext)((0, $lgPOO.DynamicBootstrapContext));
    return dynamicContext.searchSessionId;
};
const $66b8e22ddb9e6b9d$export$5abfe064a9321e1 = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.nouns);
const $66b8e22ddb9e6b9d$export$aa1a270414bf62e1 = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.products);
const $66b8e22ddb9e6b9d$export$da4da5285a2fd344 = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.analyticsAttributes);
const $66b8e22ddb9e6b9d$export$f1c90440d6c09079 = ()=>{
    const dynamicContext = (0, $42omo.useContext)((0, $lgPOO.DynamicBootstrapContext));
    return dynamicContext.smartLinkUsage;
};
const $66b8e22ddb9e6b9d$export$cf6799908f05fea7 = ()=>{
    const dynamicContext = (0, $42omo.useContext)((0, $lgPOO.DynamicBootstrapContext));
    return dynamicContext.smartLinkUsageAndTopApps;
};
const $66b8e22ddb9e6b9d$export$4c06a80ce19ae7c8 = ()=>{
    const staticContext = (0, $42omo.useContext)((0, $lgPOO.StaticBootstrapContext));
    return staticContext.isConfigLoaded;
};
const $66b8e22ddb9e6b9d$export$b79f482a36aed45 = ()=>{
    const staticContext = (0, $42omo.useContext)((0, $lgPOO.StaticBootstrapContext));
    return (0, $42omo.useMemo)(()=>{
        return staticContext.products != null && staticContext.products.length > 0;
    }, [
        staticContext.products
    ]);
};
const $66b8e22ddb9e6b9d$export$c8d3ac176f5c521c = ()=>{
    const staticContext = (0, $42omo.useContext)((0, $lgPOO.StaticBootstrapContext));
    return staticContext.experimentConfig.frontendExperiments;
};
const $66b8e22ddb9e6b9d$export$284401669662f77b = (args)=>{
    const staticContext = (0, $42omo.useContext)((0, $lgPOO.StaticBootstrapContext));
    const { experimentConfig: experimentConfig, productEdition: productEdition, productDataRegions: productDataRegions, experience: experience, cloudId: cloudId, isJiraIssueIndexed: isJiraIssueIndexed, isHello: isHello } = staticContext;
    return (0, $42omo.useMemo)(()=>{
        return (0, $hm6w9.getBackendExperiment)({
            experimentConfig: experimentConfig,
            entities: args.entities,
            productEdition: productEdition,
            isHello: isHello,
            productDataRegions: productDataRegions,
            experience: experience,
            tenantId: cloudId,
            isJiraIssueIndexed: isJiraIssueIndexed,
            thirdPartyFilters: args.thirdPartyFilters
        });
    }, [
        experimentConfig,
        productEdition,
        cloudId,
        productDataRegions,
        experience,
        isJiraIssueIndexed,
        args.entities,
        args.thirdPartyFilters,
        isHello
    ]);
};
const $66b8e22ddb9e6b9d$export$ce2438226fe8a866 = ()=>{
    const { onSearchCompleted: onSearchCompleted } = (0, $42omo.useContext)((0, $lgPOO.StaticBootstrapContext));
    return onSearchCompleted;
};
const $66b8e22ddb9e6b9d$export$de591553328a258f = ()=>{
    const { onOAuthSuccess: onOAuthSuccess } = (0, $42omo.useContext)((0, $lgPOO.StaticBootstrapContext));
    return onOAuthSuccess;
};
/**
 * Retrieve BootstrapVariables (with applied callback) from context.
 * Merges static and dynamic context, then applies the callback transformation.
 */ const $66b8e22ddb9e6b9d$var$_useBootstrapStateContextWithSelector = (cb)=>{
    const dynamicContext = (0, $42omo.useContext)((0, $lgPOO.DynamicBootstrapContext));
    const store = (0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext));
    // Select each field individually so Object.is comparison works on primitives/stable refs.
    // This ensures we only re-render when a field useQueryPlan reads actually changes.
    const cloudId = (0, $32Kiv.useStaticBootstrapSelector)(store, (s)=>s.cloudId);
    const primaryProduct = (0, $32Kiv.useStaticBootstrapSelector)(store, (s)=>s.primaryProduct);
    const primarySubProduct = (0, $32Kiv.useStaticBootstrapSelector)(store, (s)=>s.primarySubProduct);
    // Under `rovo_fps_use_rovo_config`, `thirdPartyConfigs` is routed through
    // dynamic context (see `BootstrapContextProvider`). Pick the appropriate
    // source so that downstream consumers (e.g. useQueryPlan, analytics) see
    // post-OAuth reference changes without depending on the static-lock hack.
    const thirdPartyConfigsFromStatic = (0, $32Kiv.useStaticBootstrapSelector)(store, (s)=>s.thirdPartyConfigs);
    const thirdPartyConfigs = (0, $dh538.fg)('rovo_fps_use_rovo_config') ? dynamicContext?.thirdPartyConfigs ?? $66b8e22ddb9e6b9d$var$defaultStaticContextThirdPartyConfigs : thirdPartyConfigsFromStatic;
    const experimentConfig = (0, $32Kiv.useStaticBootstrapSelector)(store, (s)=>s.experimentConfig);
    const experimentLayers = (0, $32Kiv.useStaticBootstrapSelector)(store, (s)=>s.experimentLayers);
    const products = (0, $32Kiv.useStaticBootstrapSelector)(store, (s)=>s.products);
    const allFilterExcludedProducts = (0, $32Kiv.useStaticBootstrapSelector)(store, (s)=>s.allFilterExcludedProducts);
    const productEdition = (0, $32Kiv.useStaticBootstrapSelector)(store, (s)=>s.productEdition);
    const productDataRegions = (0, $32Kiv.useStaticBootstrapSelector)(store, (s)=>s.productDataRegions);
    const isJiraIssueIndexed = (0, $32Kiv.useStaticBootstrapSelector)(store, (s)=>s.isJiraIssueIndexed);
    const isRovoEnabled = (0, $32Kiv.useStaticBootstrapSelector)(store, (s)=>s.isRovoEnabled);
    const user = (0, $32Kiv.useStaticBootstrapSelector)(store, (s)=>s.user);
    const nouns = (0, $32Kiv.useStaticBootstrapSelector)(store, (s)=>s.nouns);
    const overrides = (0, $32Kiv.useStaticBootstrapSelector)(store, (s)=>s.overrides);
    const enableRovoSearchOverrides = Boolean(// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $c6GJD.default).getExperimentValue('enable-rovo_search_overrides', 'value', false));
    const context = (0, $42omo.useMemo)(()=>{
        return cb({
            cloudId: cloudId,
            primaryProduct: primaryProduct,
            primarySubProduct: primarySubProduct,
            thirdPartyConfigs: thirdPartyConfigs,
            searchSessionId: dynamicContext?.searchSessionId,
            experimentConfig: experimentConfig,
            experimentLayers: experimentLayers,
            products: products,
            allFilterExcludedProducts: allFilterExcludedProducts,
            productEdition: productEdition,
            productDataRegions: productDataRegions,
            isJiraIssueIndexed: isJiraIssueIndexed,
            isRovoEnabled: isRovoEnabled,
            user: user,
            nouns: nouns,
            referrer: dynamicContext?.referrer,
            ...enableRovoSearchOverrides && {
                overrides: overrides
            }
        });
    }, [
        cloudId,
        primaryProduct,
        primarySubProduct,
        thirdPartyConfigs,
        experimentConfig,
        experimentLayers,
        products,
        allFilterExcludedProducts,
        productEdition,
        productDataRegions,
        isJiraIssueIndexed,
        isRovoEnabled,
        user,
        nouns,
        overrides,
        enableRovoSearchOverrides,
        dynamicContext?.searchSessionId,
        dynamicContext?.referrer,
        cb
    ]);
    return context;
};
const $66b8e22ddb9e6b9d$export$f58a6d0fc9e4868e = $66b8e22ddb9e6b9d$var$_useBootstrapStateContextWithSelector;
const $66b8e22ddb9e6b9d$export$38c566c0640fb69a = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.features);
const $66b8e22ddb9e6b9d$export$4fcccae6c9e96003 = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.cloudId);
const $66b8e22ddb9e6b9d$export$76d8dfaa701293d9 = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.orgId);
const $66b8e22ddb9e6b9d$export$742cda9929e8b50c = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.primaryProduct);
const $66b8e22ddb9e6b9d$export$e0c045bdef566c47 = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.primarySubProduct);
const $66b8e22ddb9e6b9d$export$8bff48fd870f30 = ()=>{
    return []; // no longer used, remove when cleaning up fg rovo-search-remove-rss-bootstrap-fg
};
const $66b8e22ddb9e6b9d$export$87c54b525b914dab = ()=>(0, $2x777.getUser)((0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.user));
const $66b8e22ddb9e6b9d$export$c7a275b1a627c5f0 = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.SAINHostName);
const $66b8e22ddb9e6b9d$export$6f099dbd230ba66f = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.hasEditOrViewPlanPermission ?? false);
const $66b8e22ddb9e6b9d$export$9df89e94884205e9 = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.isRovoEnabled ?? false);
const $66b8e22ddb9e6b9d$export$803daaa2f0fbbc6e = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.experimentLayers ?? []);
const $66b8e22ddb9e6b9d$export$eac498b27b856e7c = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.user?.id);
const $66b8e22ddb9e6b9d$export$b69f9d68446c9dad = ()=>{
    const staticContext = (0, $42omo.useContext)((0, $lgPOO.StaticBootstrapContext));
    const dynamicContext = (0, $42omo.useContext)((0, $lgPOO.DynamicBootstrapContext));
    const { products: products, primaryProduct: primaryProduct, isRovoEnabled: isRovoEnabled } = staticContext;
    const { product: currentSelectedProduct, cql: currentCql } = dynamicContext.queryParams;
    const applicationMode = (0, $c2HNo.getApplicationMode)({
        isRovoEnabled: isRovoEnabled
    });
    const primaryProductToSelect = (0, $8l0cM.productKeySchema).safeParse(primaryProduct);
    const shouldAutoSelectPrimaryProduct = !currentSelectedProduct && !currentCql && products && products.length > 0 && applicationMode === (0, $9vOy1.ApplicationModes).Unified && primaryProductToSelect.success && primaryProductToSelect.data !== (0, $b4tvS.ProductKeys).Atlas;
    if (shouldAutoSelectPrimaryProduct) return primaryProductToSelect.data;
    else return null;
};
const $66b8e22ddb9e6b9d$export$e3421d27ae244aa = ()=>{
    const dynamicContext = (0, $42omo.useContext)((0, $lgPOO.DynamicBootstrapContext));
    return dynamicContext.queryParams?.type === (0, $2Znam.TypeFilterValueKey).Incident;
};
const $66b8e22ddb9e6b9d$export$25662b49e6b8f72d = ()=>{
    const dynamicContext = (0, $42omo.useContext)((0, $lgPOO.DynamicBootstrapContext));
    return dynamicContext.queryParams;
};
const $66b8e22ddb9e6b9d$export$7061561fd19f7ef1 = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.aggregatorHostName);
const $66b8e22ddb9e6b9d$export$5ff79b6adc9830a0 = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.aggAbsoluteUrl);
const $66b8e22ddb9e6b9d$export$bc37b6cf798ce4a = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.allFilterExcludedProducts);
const $66b8e22ddb9e6b9d$export$b3275ad39f44e473 = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.productDataRegions);
const $66b8e22ddb9e6b9d$export$7b21d1d3f4e52ac8 = ()=>(0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.isJiraIssueIndexed);














const $952088699c3cc644$export$ae43642c556804c9 = (queryParams)=>{
    const hostProductSetQueryParamsCallback = (0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.queryParamsCallback);
    const setQueryParamsCallback = (0, $42omo.useCallback)((newParams)=>{
        const areEqualQueryParams = (0, $lIbf3.areAllEqualQueryParams)(newParams, queryParams ?? {});
        if (areEqualQueryParams) return;
        const rawQueryParams = (0, $lIbf3.toQueryParamsRaw)(newParams);
        hostProductSetQueryParamsCallback(rawQueryParams);
    }, [
        queryParams,
        hostProductSetQueryParamsCallback
    ]);
    return setQueryParamsCallback;
};
const $952088699c3cc644$export$8eb026c9237da68b = ()=>{
    const refreshSearchSessionId = (0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.refreshSearchSessionId);
    return refreshSearchSessionId;
};
const $952088699c3cc644$export$6372fdd1070e00df = ()=>{
    const clearReferrer = (0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.clearReferrer);
    return clearReferrer;
};
const $952088699c3cc644$export$b2cdbc1165101e18 = ()=>{
    const setThirdPartyConfigs = (0, $32Kiv.useStaticBootstrapSelector)((0, $42omo.useContext)((0, $lgPOO.StaticBootstrapStoreContext)), (ctx)=>ctx.setThirdPartyConfigs);
    return setThirdPartyConfigs;
};



var $gSaNw = parcelRequire("gSaNw");

const $ee8d6df68f0b570c$export$e324594224ef24da = {
    /**
   * @deprecated
   * Do not import directly! https://hello.atlassian.net/wiki/x/bKRdZAE
   * Instead use `const setThirdPartyConfigs = useSetThirdPartyConfigs()`
   */ setThirdPartyConfigs: (configs)=>({ setState: setState })=>{
            setState({
                thirdPartyConfigs: configs
            });
        },
    /**
   * @deprecated
   * Do not import directly! https://hello.atlassian.net/wiki/x/bKRdZAE
   * Instead use `const setQueryParams = useSetQueryParams()`
   */ setQueryParams: (queryParam)=>({}, { queryParams: queryParams, queryParamsCallback: queryParamsCallback = ()=>{} })=>{
            const areEqualQueryParams = (0, $lIbf3.areAllEqualQueryParams)(queryParam, (0, $lIbf3.parseQueryParams)(queryParams ?? {}));
            if (areEqualQueryParams) return;
            queryParamsCallback((0, $lIbf3.toQueryParamsRaw)(queryParam));
        },
    /**
   * @deprecated
   * Do not import directly! https://hello.atlassian.net/wiki/x/bKRdZAE
   *
   * You should not ever need to call this directly. Open a thread in #help-search-plex and tag @rwasher, @sogrady, @jquach, if you find you need to!
   */ syncQueryParams: ()=>({ setState: setState, getState: getState }, { queryParams: queryParams, queryParamsCallback: queryParamsCallback = ()=>{} })=>{
            // queryParams is the query params coming from the URL or React Router in this case
            const { prevQueryParams: prevQueryParams, // Previously saved query params - this is to prevent infinitely updating queryParams
            queryParams: diffQueryParamsState // The 'internal' query params state
             } = getState();
            const queryParamsURL = (0, $lIbf3.parseQueryParams)(queryParams ?? {});
            const prevQueryParamsString = (0, $lIbf3.toQueryString)(prevQueryParams);
            const diffQueryParamsURLString = (0, $lIbf3.toQueryString)(queryParamsURL);
            const diffQueryParamsStateString = (0, $lIbf3.toQueryString)(diffQueryParamsState);
            const allQueryParamsAreEqual = (0, $lIbf3.areAllEqualQueryParams)(queryParamsURL, prevQueryParams, diffQueryParamsState);
            if (allQueryParamsAreEqual) return;
            // Any changes from the url takes the highest precedence
            const hasURLQueryParams = !!queryParams;
            if (hasURLQueryParams && prevQueryParamsString !== diffQueryParamsURLString) {
                setState({
                    prevQueryParams: queryParamsURL,
                    queryParams: queryParamsURL
                });
                return;
            }
            if (prevQueryParamsString !== diffQueryParamsStateString) {
                //  NOTE: If you are running the callback and you don't see the query params being updated,
                //  the callback might be sanitising the query parameters. This is the case for Confluence.
                queryParamsCallback((0, $lIbf3.toQueryParamsRaw)(diffQueryParamsState));
                setState({
                    prevQueryParams: diffQueryParamsState,
                    queryParams: diffQueryParamsState
                });
                return;
            }
        },
    /**
   * @deprecated
   * Do not import directly! https://hello.atlassian.net/wiki/x/bKRdZAE
   * Instead use `const refreshSearchSessionId = useRefreshSearchSessionId()`
   */ refreshSearchSessionId: ()=>({ setState: setState })=>{
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            setState({
                searchSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))()
            });
        },
    /**
   * @deprecated
   * Do not import directly! https://hello.atlassian.net/wiki/x/bKRdZAE
   * Instead use `const clearReferrer = useClearReferrer()`
   */ clearReferrer: ()=>({ setState: setState })=>{
            setState({
                referrer: undefined
            });
        }
};
const $ee8d6df68f0b570c$var$buildProducts = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((a, b)=>{
    return [
        ...new Set([
            ...a,
            ...b
        ])
    ];
}, (a, b)=>a.join('') + b.join(''));
// Keep store private and use hooks to access state and actions
const $ee8d6df68f0b570c$var$Store = (0, $1P1Tu.createStore)({
    initialState: $aaNIP.initialState,
    actions: $ee8d6df68f0b570c$export$e324594224ef24da,
    name: 'bootstrap'
});
const $ee8d6df68f0b570c$export$543309f9b943a423 = {
    onInit: ()=>({ getState: getState, setState: setState }, { initialProps: initialProps, onSearchCompleted: onSearchCompleted, onOAuthSuccess: onOAuthSuccess, queryParams: queryParams })=>{
            const parsedQueryParams = queryParams && (0, $lIbf3.parseQueryParams)(queryParams);
            setState({
                ...getState(),
                ...initialProps,
                ...queryParams && {
                    queryParams: parsedQueryParams
                },
                referrer: parsedQueryParams?.referrer,
                initialTextQueryParam: parsedQueryParams?.text,
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                searchSessionId: initialProps.searchSessionId || (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))(),
                onSearchCompleted: onSearchCompleted,
                onOAuthSuccess: onOAuthSuccess
            });
        },
    onUpdate: ()=>({ setState: setState, getState: getState, dispatch: dispatch }, { initialProps: initialProps, onSearchCompleted: onSearchCompleted, onOAuthSuccess: onOAuthSuccess, queryParams: queryParams })=>{
            const parsedQueryParams = queryParams && (0, $lIbf3.parseQueryParams)(queryParams);
            const currentState = getState();
            const products = $ee8d6df68f0b570c$var$buildProducts(currentState.products, initialProps?.products ?? []);
            // Merge thirdPartyConfigs so that OAuth-updated entries (set via
            // setThirdPartyConfigs with userNeedsOAuth: false) are not
            // overwritten by the stale consumer-provided value on re-renders,
            // while still picking up new/updated entries from the host app.
            //
            // IMPORTANT: We only create a new object when an actual override is
            // needed. If nothing changed, we preserve the incoming reference to
            // avoid unnecessary re-renders in RSS store subscribers (e.g.
            // useFetchResultsProps depends on thirdPartyConfigs by reference).
            const incomingThirdPartyConfigs = initialProps?.thirdPartyConfigs;
            const currentThirdPartyConfigs = currentState.thirdPartyConfigs;
            let mergedThirdPartyConfigs = incomingThirdPartyConfigs;
            if (incomingThirdPartyConfigs && currentThirdPartyConfigs) {
                // Check whether any entries need to be preserved from the current store
                let hasOverrides = false;
                for (const key of Object.keys(currentThirdPartyConfigs)){
                    const currentEntry = currentThirdPartyConfigs[key];
                    const incomingEntry = incomingThirdPartyConfigs[key];
                    if (currentEntry && incomingEntry && currentEntry.userNeedsOAuth === false && incomingEntry.userNeedsOAuth === true) {
                        hasOverrides = true;
                        break;
                    }
                }
                // Only create a new object if we actually need to override something
                if (hasOverrides) {
                    mergedThirdPartyConfigs = {
                        ...incomingThirdPartyConfigs
                    };
                    for (const key of Object.keys(currentThirdPartyConfigs)){
                        const currentEntry = currentThirdPartyConfigs[key];
                        const incomingEntry = mergedThirdPartyConfigs[key];
                        if (currentEntry && incomingEntry && currentEntry.userNeedsOAuth === false && incomingEntry.userNeedsOAuth === true) mergedThirdPartyConfigs[key] = currentEntry;
                    }
                }
            }
            setState({
                ...currentState,
                ...initialProps,
                ...mergedThirdPartyConfigs !== undefined && {
                    thirdPartyConfigs: mergedThirdPartyConfigs
                },
                onSearchCompleted: onSearchCompleted,
                onOAuthSuccess: onOAuthSuccess,
                products: products,
                referrer: parsedQueryParams?.referrer
            });
            dispatch($ee8d6df68f0b570c$export$e324594224ef24da.syncQueryParams());
        }
};
const $ee8d6df68f0b570c$export$557bf45c8d0f5bd = (0, $FOT9i.createContainer)($ee8d6df68f0b570c$var$Store, $ee8d6df68f0b570c$export$543309f9b943a423);
const $ee8d6df68f0b570c$export$cf715ed8590c209b = (0, $9zUhf.createActionsHook)($ee8d6df68f0b570c$var$Store);
/**
 * @deprecated
 * Do not import directly! https://hello.atlassian.net/wiki/x/bKRdZAE
 * This is being actively migrated away from in QS-9194
 *
 * Instead use specific per-value accessors from this file, including for actions if they are present
 *
 * e.g. const [{ useCloudId, useQueryParams }, { useSetQueryParams }] = useBootstrap()
 * -> const [cloudId] = useCloudId();
 * -> const [queryParams] = useQueryParams();
 * -> const setQueryParams = useSetQueryParams();
 */ const $ee8d6df68f0b570c$var$useBootstrapStore = (0, $9zUhf.createHook)($ee8d6df68f0b570c$var$Store);
const $ee8d6df68f0b570c$export$9ba1f1f28043c5bf = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $66b8e22ddb9e6b9d$export$a607044ff61ed35a)() : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$var$useBootstrapStore()[0]
    ];
};
const $ee8d6df68f0b570c$export$9ec3accb60f929bc = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state, cb)=>cb(state)
});
const $ee8d6df68f0b570c$export$610b442bd2bdbce2 = (cb)=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $66b8e22ddb9e6b9d$export$f58a6d0fc9e4868e)(cb) : $ee8d6df68f0b570c$export$9ec3accb60f929bc(cb);
};
const $ee8d6df68f0b570c$export$9d56bc2341757114 = (0, $9zUhf.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.analyticsAttributes
});
const $ee8d6df68f0b570c$export$1fd8522aeddaccda = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$da4da5285a2fd344)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$9d56bc2341757114()[0]
    ];
};
const $ee8d6df68f0b570c$export$7ea98f64fcaf4bba = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.products
});
const $ee8d6df68f0b570c$export$5afbfe6edea8e998 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $66b8e22ddb9e6b9d$export$aa1a270414bf62e1)() : $ee8d6df68f0b570c$export$7ea98f64fcaf4bba();
};
const $ee8d6df68f0b570c$export$eac7f1ebb1342f3d = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.nouns
});
const $ee8d6df68f0b570c$export$6019aa9111ebc3a2 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $66b8e22ddb9e6b9d$export$5abfe064a9321e1)() : $ee8d6df68f0b570c$export$eac7f1ebb1342f3d();
};
const $ee8d6df68f0b570c$export$5668414148ce6645 = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.products && state.products.length > 0
});
const $ee8d6df68f0b570c$export$9e9836415b9aa240 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $66b8e22ddb9e6b9d$export$b79f482a36aed45)() : $ee8d6df68f0b570c$export$5668414148ce6645();
};
const $ee8d6df68f0b570c$export$38f7f3dced53e226 = (0, $9zUhf.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.products.length === 0
});
const $ee8d6df68f0b570c$export$f7c6299b3492081c = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        !(0, $66b8e22ddb9e6b9d$export$b79f482a36aed45)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$38f7f3dced53e226()[0]
    ];
};
const $ee8d6df68f0b570c$export$740fb20e7075dfd2 = (0, $9zUhf.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.primaryProduct
});
const $ee8d6df68f0b570c$export$92c6f3c7c09f3247 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$742cda9929e8b50c)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$740fb20e7075dfd2()[0]
    ];
};
/**
 * @deprecated
 * Do not import directly! https://hello.atlassian.net/wiki/x/bKRdZAE
 * Instead use usePrimarySubProduct in bootstrap/index.tsx
 */ const $ee8d6df68f0b570c$var$usePrimarySubProductStore = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.primarySubProduct
});
const $ee8d6df68f0b570c$export$baffb23dea1bbe6d = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$e0c045bdef566c47)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$var$usePrimarySubProductStore()
    ];
};
const $ee8d6df68f0b570c$export$85911a18814719bc = (0, $9zUhf.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.searchSessionId
});
const $ee8d6df68f0b570c$export$e1e7a4797df1a656 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$c3427a530f474eaf)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$85911a18814719bc()[0]
    ];
};
const $ee8d6df68f0b570c$export$ecbe89dec8c82f9a = (0, $9zUhf.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>(0, $5XpfZ.isHello)(state.cloudId)
});
const $ee8d6df68f0b570c$export$1a0be923fb1117e4 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$a20db2e6915ac3c5)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$ecbe89dec8c82f9a()[0]
    ];
};
const $ee8d6df68f0b570c$export$ecc663167952d044 = (0, $9zUhf.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.features
});
const $ee8d6df68f0b570c$export$4a39035bacc4ed76 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$38c566c0640fb69a)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$ecc663167952d044()[0]
    ];
};
const $ee8d6df68f0b570c$export$766d82ac8f8b178e = (0, $9zUhf.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state, args)=>{
        return (0, $hm6w9.getBackendExperiment)({
            experimentConfig: state.experimentConfig,
            entities: args.entities,
            productEdition: state.productEdition,
            isHello: (0, $5XpfZ.isHello)(state.cloudId),
            productDataRegions: state.productDataRegions,
            experience: (0, $4cq9O.SEARCH_PAGE),
            tenantId: state.cloudId,
            isJiraIssueIndexed: state.isJiraIssueIndexed,
            thirdPartyFilters: args.thirdPartyFilters
        });
    }
});
const $ee8d6df68f0b570c$export$9e89c81d9ff2c758 = (args)=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$284401669662f77b)(args)
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$766d82ac8f8b178e(args)[0]
    ];
};
const $ee8d6df68f0b570c$export$76b3461be06c4ce4 = (0, $9zUhf.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.experimentConfig.frontendExperiments
});
const $ee8d6df68f0b570c$export$d2c28b106f1bf70b = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$c8d3ac176f5c521c)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$76b3461be06c4ce4()[0]
    ];
};
const $ee8d6df68f0b570c$export$3e826cc2f34e3f9f = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.smartLinkUsage
});
const $ee8d6df68f0b570c$export$61c62393cc326189 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $66b8e22ddb9e6b9d$export$f1c90440d6c09079)() : $ee8d6df68f0b570c$export$3e826cc2f34e3f9f();
};
const $ee8d6df68f0b570c$export$c0ee253dbeb5b16e = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.smartLinkUsageAndTopApps
});
const $ee8d6df68f0b570c$export$88d4bb46312ff031 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $66b8e22ddb9e6b9d$export$cf6799908f05fea7)() : $ee8d6df68f0b570c$export$c0ee253dbeb5b16e();
};
const $ee8d6df68f0b570c$export$89824387636c5038 = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>(0, $2OtFZ.getMultiSiteSearchInRovo)(state.experimentConfig)
});
const $ee8d6df68f0b570c$export$1e668811222ead9b = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $66b8e22ddb9e6b9d$export$414e9503f60ee463)() : $ee8d6df68f0b570c$export$89824387636c5038();
};
const $ee8d6df68f0b570c$export$5ecdff6d23ea5c41 = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.user?.id
});
const $ee8d6df68f0b570c$export$761b9f1acd811a4 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $66b8e22ddb9e6b9d$export$eac498b27b856e7c)() : $ee8d6df68f0b570c$export$5ecdff6d23ea5c41();
};
const $ee8d6df68f0b570c$export$7bafc36c74b1b9af = (0, $9zUhf.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.experimentConfig
});
const $ee8d6df68f0b570c$export$b9e6179ff71a6122 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$db066d8e499b7f58)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$7bafc36c74b1b9af()[0]
    ];
};
const $ee8d6df68f0b570c$export$f0fa22420f7c521e = (0, $9zUhf.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.intercomHmac
});
const $ee8d6df68f0b570c$export$8ab143228c6f49a2 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$120ac1729f38deb6)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$f0fa22420f7c521e()[0]
    ];
};
/**
 * @deprecated
 * https://hello.atlassian.net/wiki/x/bKRdZAE
 */ const $ee8d6df68f0b570c$var$useApplicationModeStore = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (0, $cclHy.createSelector)([
        (state)=>state.isRovoEnabled
    ], (isRovoEnabled)=>(0, $c2HNo.getApplicationMode)({
            isRovoEnabled: isRovoEnabled
        }))
});
const $ee8d6df68f0b570c$export$150d84149ef86e81 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $66b8e22ddb9e6b9d$export$3129106711858d9e)() : $ee8d6df68f0b570c$var$useApplicationModeStore();
};
const $ee8d6df68f0b570c$export$ac142617c8f07aa9 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? [
        (0, $66b8e22ddb9e6b9d$export$8d72fbb40ea96b11)()
    ] : [
        $ee8d6df68f0b570c$export$6fa68bea98f6275f()[0]
    ];
};
const $ee8d6df68f0b570c$export$84529f276bb721c4 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $66b8e22ddb9e6b9d$export$42159b7c323c1456)() : $ee8d6df68f0b570c$export$5b08efe445210431();
};
const $ee8d6df68f0b570c$export$e99d08753f6dce85 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? [
        (0, $66b8e22ddb9e6b9d$export$8b362261a7637697)()
    ] : [
        $ee8d6df68f0b570c$export$956b416c80bdc23b()[0]
    ];
};
const $ee8d6df68f0b570c$export$cc885caaa8b7ab4e = (0, $9zUhf.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>{
        const user = state.user;
        return (0, $2x777.getUser)(user);
    }
});
const $ee8d6df68f0b570c$export$23bbbc4533528f03 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$87c54b525b914dab)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$cc885caaa8b7ab4e()[0]
    ];
};
const $ee8d6df68f0b570c$export$956b416c80bdc23b = (0, $9zUhf.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.referrer
});
const $ee8d6df68f0b570c$export$5b08efe445210431 = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.initialTextQueryParam
});
const $ee8d6df68f0b570c$export$aef5773142a94889 = (0, $9zUhf.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.orgId
});
const $ee8d6df68f0b570c$export$52a03a3207af3687 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$76d8dfaa701293d9)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$aef5773142a94889()[0]
    ];
};
const $ee8d6df68f0b570c$export$d875bd9731f2aec2 = (0, $9zUhf.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (0, $cclHy.createSelector)([
        (state)=>state.cloudId
    ], (cloudId)=>cloudId)
});
const $ee8d6df68f0b570c$export$9da0f7c65f28ed16 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$4fcccae6c9e96003)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$d875bd9731f2aec2()[0]
    ];
};
const $ee8d6df68f0b570c$export$6fa68bea98f6275f = (0, $9zUhf.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.linkedCloudARIs
});
const $ee8d6df68f0b570c$export$4e035a5c2351d2e5 = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (0, $cclHy.createSelector)([
        (state)=>state.products,
        (state)=>state.primaryProduct,
        (state)=>state.isRovoEnabled,
        (state)=>state.queryParams.product,
        (state)=>state.queryParams.cql
    ], (products, primaryProduct, isRovoEnabled, currentSelectedProduct, currentCql)=>{
        const applicationMode = (0, $c2HNo.getApplicationMode)({
            isRovoEnabled: isRovoEnabled
        });
        const primaryProductToSelect = (0, $8l0cM.productKeySchema).safeParse(primaryProduct);
        const shouldAutoSelectPrimaryProduct = !currentSelectedProduct && !currentCql && products && products.length > 0 && applicationMode === (0, $9vOy1.ApplicationModes).Unified && primaryProductToSelect.success && primaryProductToSelect.data !== (0, $b4tvS.ProductKeys).Atlas;
        if (shouldAutoSelectPrimaryProduct) return primaryProductToSelect.data;
        else return null;
    })
});
const $ee8d6df68f0b570c$export$c7f4a8f2f4902c5b = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $66b8e22ddb9e6b9d$export$b69f9d68446c9dad)() : $ee8d6df68f0b570c$export$4e035a5c2351d2e5();
};
const $ee8d6df68f0b570c$export$cfec170a04b8b09e = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (0, $cclHy.createSelector)([
        (state)=>state.isConfigLoaded
    ], (isConfigLoaded)=>isConfigLoaded)
});
const $ee8d6df68f0b570c$export$dfc6af34d0b0a7e1 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $66b8e22ddb9e6b9d$export$4c06a80ce19ae7c8)() : $ee8d6df68f0b570c$export$cfec170a04b8b09e();
};
const $ee8d6df68f0b570c$export$826527619b7a782d = (0, $9zUhf.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>!!state.rovoFeatures?.scas
});
const $ee8d6df68f0b570c$export$27738d748ac05943 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$b238e8fc41384c76)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$826527619b7a782d()[0]
    ];
};
const $ee8d6df68f0b570c$export$479cadf76e337ced = (0, $9zUhf.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.productEdition
});
const $ee8d6df68f0b570c$export$83e4de12d3240f53 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$682b612810461522)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$479cadf76e337ced()[0]
    ];
};
const $ee8d6df68f0b570c$export$7c7bef429afbfd0f = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.queryParams?.type === (0, $2Znam.TypeFilterValueKey).Incident
});
const $ee8d6df68f0b570c$export$98a75a8d27d2d106 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $66b8e22ddb9e6b9d$export$e3421d27ae244aa)() : $ee8d6df68f0b570c$export$7c7bef429afbfd0f();
};
const $ee8d6df68f0b570c$export$d37ccf8bdc15c61 = (0, $9zUhf.createHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.thirdPartyConfigs
});
const $ee8d6df68f0b570c$export$a66178d9c618d6dc = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$e2860ebe87e62f0d)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$d37ccf8bdc15c61()[0]
    ];
};
const $ee8d6df68f0b570c$export$4470b3b80d2a1efd = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>{
        const primaryProduct = state.primaryProduct;
        if (!primaryProduct) return false;
        return primaryProduct === (0, $b4tvS.ProductKeys).Confluence || primaryProduct === (0, $b4tvS.ProductKeys).Jira || primaryProduct === (0, $b4tvS.ProductKeys).Atlas;
    }
});
const $ee8d6df68f0b570c$export$12942aa91b162c95 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $66b8e22ddb9e6b9d$export$f84f93bb6857e6bf)() : // eslint-disable-next-line react-hooks/rules-of-hooks
    $ee8d6df68f0b570c$export$4470b3b80d2a1efd();
};
const $ee8d6df68f0b570c$export$fa705064035366ce = (queryParams)=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    const { setQueryParams: setQueryParamsStore } = $ee8d6df68f0b570c$export$cf715ed8590c209b();
    const setQueryParamsContext = (0, $952088699c3cc644$export$ae43642c556804c9)(queryParams);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    setQueryParamsContext : // eslint-disable-next-line react-hooks/rules-of-hooks
    setQueryParamsStore;
};
const $ee8d6df68f0b570c$export$3b183e08127f60ee = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    const { refreshSearchSessionId: refreshSearchSessionIdStore } = $ee8d6df68f0b570c$export$cf715ed8590c209b();
    const refreshSearchSessionIdContext = (0, $952088699c3cc644$export$8eb026c9237da68b)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    refreshSearchSessionIdContext : // eslint-disable-next-line react-hooks/rules-of-hooks
    refreshSearchSessionIdStore;
};
const $ee8d6df68f0b570c$export$c6dd687c49bf782b = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    const { clearReferrer: clearReferrerStore } = $ee8d6df68f0b570c$export$cf715ed8590c209b();
    const clearReferrerContext = (0, $952088699c3cc644$export$6372fdd1070e00df)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    clearReferrerContext : // eslint-disable-next-line react-hooks/rules-of-hooks
    clearReferrerStore;
};
const $ee8d6df68f0b570c$export$556790c5329d7a06 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    const { setThirdPartyConfigs: setThirdPartyConfigsStore } = $ee8d6df68f0b570c$export$cf715ed8590c209b();
    const setThirdPartyConfigsContext = (0, $952088699c3cc644$export$b2cdbc1165101e18)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    setThirdPartyConfigsContext : // eslint-disable-next-line react-hooks/rules-of-hooks
    setThirdPartyConfigsStore;
};
const $ee8d6df68f0b570c$export$9145e6ed5e8754d7 = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.onSearchCompleted
});
const $ee8d6df68f0b570c$export$b9665757e0cd2a7 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    const onSearchCompletedStore = $ee8d6df68f0b570c$export$9145e6ed5e8754d7();
    const onSearchCompletedContext = (0, $66b8e22ddb9e6b9d$export$ce2438226fe8a866)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    onSearchCompletedContext : // eslint-disable-next-line react-hooks/rules-of-hooks
    onSearchCompletedStore ?? (()=>{});
};
const $ee8d6df68f0b570c$export$8dbc380ce96047bb = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.onOAuthSuccess
});
const $ee8d6df68f0b570c$export$d5e98fc55a6be8ab = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    const onOAuthSuccessStore = $ee8d6df68f0b570c$export$8dbc380ce96047bb();
    const onOAuthSuccessContext = (0, $66b8e22ddb9e6b9d$export$de591553328a258f)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    onOAuthSuccessContext : // eslint-disable-next-line react-hooks/rules-of-hooks
    onOAuthSuccessStore;
};
const $ee8d6df68f0b570c$export$94c4fbf6686bd545 = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.queryParams
});
const $ee8d6df68f0b570c$export$b37ee0d76c6d2fbc = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$25662b49e6b8f72d)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$94c4fbf6686bd545()
    ];
};
const $ee8d6df68f0b570c$export$6a2137557a0d64b6 = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.aggregatorHostName
});
const $ee8d6df68f0b570c$export$ee782f3c04c9ae8b = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$7061561fd19f7ef1)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$6a2137557a0d64b6()
    ];
};
const $ee8d6df68f0b570c$export$c9561269f12847d9 = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.aggAbsoluteUrl
});
const $ee8d6df68f0b570c$export$c61c0a9ee44eb20d = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$5ff79b6adc9830a0)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$c9561269f12847d9()
    ];
};
const $ee8d6df68f0b570c$export$a622d298cd701527 = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.allFilterExcludedProducts
});
const $ee8d6df68f0b570c$export$5f38673942a99ffe = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$bc37b6cf798ce4a)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$a622d298cd701527()
    ];
};
const $ee8d6df68f0b570c$export$46b088d1cfd71b45 = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.productDataRegions
});
const $ee8d6df68f0b570c$export$7b2a84178d2593d6 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$b3275ad39f44e473)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$46b088d1cfd71b45()
    ];
};
const $ee8d6df68f0b570c$export$34ca8c3e8a50a02f = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.isJiraIssueIndexed
});
const $ee8d6df68f0b570c$export$fbf3e851fc33b7ac = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$7b21d1d3f4e52ac8)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$34ca8c3e8a50a02f()
    ];
};
const $ee8d6df68f0b570c$export$81f625b5a645837d = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.initialSpaceARIs
});
const $ee8d6df68f0b570c$export$dbfb675a6b71c171 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$8bff48fd870f30)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$81f625b5a645837d()
    ];
};
const $ee8d6df68f0b570c$export$9f206c50663dec0 = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.SAINHostName
});
const $ee8d6df68f0b570c$export$3a6ef70862d81412 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$c7a275b1a627c5f0)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$9f206c50663dec0()
    ];
};
const $ee8d6df68f0b570c$export$9f9ac629bd95fe42 = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.hasEditOrViewPlanPermission
});
const $ee8d6df68f0b570c$export$ef5d8e24d9af554f = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$6f099dbd230ba66f)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$export$9f9ac629bd95fe42() ?? false
    ];
};
const $ee8d6df68f0b570c$var$useIsRovoEnabledStore = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.isRovoEnabled
});
const $ee8d6df68f0b570c$export$1deffd91058f2ec4 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$9df89e94884205e9)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$var$useIsRovoEnabledStore()
    ];
};
const $ee8d6df68f0b570c$var$useExperimentLayersStore = (0, $9zUhf.createStateHook)($ee8d6df68f0b570c$var$Store, {
    selector: (state)=>state.experimentLayers
});
const $ee8d6df68f0b570c$export$e157d3c129f2f296 = ()=>{
    const serveContext = (0, $gSaNw.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $66b8e22ddb9e6b9d$export$803daaa2f0fbbc6e)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $ee8d6df68f0b570c$var$useExperimentLayersStore()
    ];
};
module.exports["BootstrapStoreContainer"] = $ee8d6df68f0b570c$export$557bf45c8d0f5bd;
module.exports["useBootstrap"] = $ee8d6df68f0b570c$export$9ba1f1f28043c5bf;
module.exports["useBootstrapState"] = $ee8d6df68f0b570c$export$610b442bd2bdbce2;
module.exports["useAnalyticsAttributes"] = $ee8d6df68f0b570c$export$1fd8522aeddaccda;
module.exports["useAvailableProducts"] = $ee8d6df68f0b570c$export$5afbfe6edea8e998;
module.exports["useAvailableNouns"] = $ee8d6df68f0b570c$export$6019aa9111ebc3a2;
module.exports["useBootstrapLoading"] = $ee8d6df68f0b570c$export$f7c6299b3492081c;
module.exports["usePrimaryProduct"] = $ee8d6df68f0b570c$export$92c6f3c7c09f3247;
module.exports["usePrimarySubProduct"] = $ee8d6df68f0b570c$export$baffb23dea1bbe6d;
module.exports["useSearchSessionId"] = $ee8d6df68f0b570c$export$e1e7a4797df1a656;
module.exports["useIsHello"] = $ee8d6df68f0b570c$export$1a0be923fb1117e4;
module.exports["useFeatures"] = $ee8d6df68f0b570c$export$4a39035bacc4ed76;
module.exports["useSmartLinkUsage"] = $ee8d6df68f0b570c$export$61c62393cc326189;
module.exports["useSmartLinkUsageAndTopApps"] = $ee8d6df68f0b570c$export$88d4bb46312ff031;
module.exports["useCurrentUserId"] = $ee8d6df68f0b570c$export$761b9f1acd811a4;
module.exports["useExperimentConfig"] = $ee8d6df68f0b570c$export$b9e6179ff71a6122;
module.exports["useIntercomHmac"] = $ee8d6df68f0b570c$export$8ab143228c6f49a2;
module.exports["useApplicationMode"] = $ee8d6df68f0b570c$export$150d84149ef86e81;
module.exports["useReferrer"] = $ee8d6df68f0b570c$export$e99d08753f6dce85;
module.exports["useUser"] = $ee8d6df68f0b570c$export$23bbbc4533528f03;
module.exports["useOrgId"] = $ee8d6df68f0b570c$export$52a03a3207af3687;
module.exports["useCloudId"] = $ee8d6df68f0b570c$export$9da0f7c65f28ed16;
module.exports["useAutoSelectPrimaryProduct"] = $ee8d6df68f0b570c$export$c7f4a8f2f4902c5b;
module.exports["useIsConfigLoaded"] = $ee8d6df68f0b570c$export$dfc6af34d0b0a7e1;
module.exports["useProductEdition"] = $ee8d6df68f0b570c$export$83e4de12d3240f53;
module.exports["useIsTypeFilteredToIncident"] = $ee8d6df68f0b570c$export$98a75a8d27d2d106;
module.exports["useThirdPartyConfigs"] = $ee8d6df68f0b570c$export$a66178d9c618d6dc;
module.exports["useFiltersDiscoverability2Enabled"] = $ee8d6df68f0b570c$export$12942aa91b162c95;
module.exports["useSetQueryParams"] = $ee8d6df68f0b570c$export$fa705064035366ce;
module.exports["useRefreshSearchSessionId"] = $ee8d6df68f0b570c$export$3b183e08127f60ee;
module.exports["useClearReferrer"] = $ee8d6df68f0b570c$export$c6dd687c49bf782b;
module.exports["useSetThirdPartyConfigs"] = $ee8d6df68f0b570c$export$556790c5329d7a06;
module.exports["useOnSearchCompleted"] = $ee8d6df68f0b570c$export$b9665757e0cd2a7;
module.exports["useOnOAuthSuccess"] = $ee8d6df68f0b570c$export$d5e98fc55a6be8ab;
module.exports["useQueryParams"] = $ee8d6df68f0b570c$export$b37ee0d76c6d2fbc;
module.exports["useAggAbsoluteUrl"] = $ee8d6df68f0b570c$export$c61c0a9ee44eb20d;
module.exports["useAllFilterExcludedProducts"] = $ee8d6df68f0b570c$export$5f38673942a99ffe;
module.exports["useProductDataRegions"] = $ee8d6df68f0b570c$export$7b2a84178d2593d6;
module.exports["useIsJiraIssueIndexed"] = $ee8d6df68f0b570c$export$fbf3e851fc33b7ac;
module.exports["useInitialSpaceARIs"] = $ee8d6df68f0b570c$export$dbfb675a6b71c171;
module.exports["useExperimentLayers"] = $ee8d6df68f0b570c$export$e157d3c129f2f296;

});

parcelRegister("9vOy1", function(module, exports) {
const $b77a737dcc9ce237$export$f1263520d5e0f007 = {
    Unified: 'unified',
    Rovo: 'rovo'
};
module.exports["ApplicationModes"] = $b77a737dcc9ce237$export$f1263520d5e0f007;

});

parcelRegister("aaNIP", function(module, exports) {
const $30eb242a9c2a82fe$export$d4c72bab9d6cc13a = {
    products: [],
    nouns: [],
    allFilterExcludedProducts: [],
    thirdPartyConfigs: {},
    searchSessionId: '',
    queryParams: {},
    prevQueryParams: {},
    overrides: undefined,
    initialSpaceARIs: [],
    experimentConfig: {
        backendExperiment: undefined,
        frontendExperiments: undefined,
        dynamicExperiments: undefined,
        combinedExperiment: undefined
    },
    experimentLayers: [],
    isRovoEnabled: false,
    isConfigLoaded: false,
    rovoFeatures: {},
    isJiraIssueIndexed: false,
    productEdition: undefined,
    productDataRegions: undefined,
    linkedCloudARIs: undefined,
    analyticsAttributes: undefined,
    aggAbsoluteUrl: undefined,
    cloudId: undefined,
    aggregatorHostName: undefined,
    SAINHostName: undefined,
    user: undefined,
    primaryProduct: undefined,
    primarySubProduct: undefined,
    orgId: undefined,
    intercomHmac: undefined,
    referrer: undefined,
    initialTextQueryParam: undefined,
    features: undefined,
    hasEditOrViewPlanPermission: false,
    onSearchCompleted: undefined,
    onOAuthSuccess: undefined,
    smartLinkUsage: undefined,
    smartLinkUsageAndTopApps: undefined
};
module.exports["initialState"] = $30eb242a9c2a82fe$export$d4c72bab9d6cc13a;

});

parcelRegister("4cq9O", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ const $9acf3b09df50dcf8$export$944168d706dc6466 = 'search-page';
module.exports["SEARCH_PAGE"] = $9acf3b09df50dcf8$export$944168d706dc6466;

});

parcelRegister("2Znam", function(module, exports) {
const $1bd00f711ef18555$export$49f6cbb853d30562 = {
    Document: 'document',
    Spreadsheet: 'spreadsheet',
    Presentation: 'presentation',
    Repository: 'repository',
    PullRequest: 'pull-request',
    Branch: 'branch',
    Commit: 'commit',
    DevopsWorkItem: 'devops-work-item',
    WebPage: 'web-page',
    Conversation: 'conversation',
    Message: 'message',
    Video: 'video',
    Design: 'design',
    Page: 'page',
    Blogpost: 'blogpost',
    Attachment: 'attachment',
    Space: 'space',
    Whiteboard: 'whiteboard',
    Slide: 'slide',
    Comment: 'comment',
    Database: 'database',
    Embed: 'embed',
    Folder: 'folder',
    Calendar: 'calendar',
    SpaceCalendar: 'space-calendar',
    Question: 'question',
    Answer: 'answer',
    Issue: 'issue',
    Epic: 'epic',
    Bug: 'bug',
    Story: 'story',
    Task: 'task',
    Subtask: 'subtask',
    Project: 'project',
    Incident: 'incident',
    Filter: 'filter',
    Plan: 'plan',
    Board: 'board',
    Component: 'component',
    Card: 'card',
    Goal: 'goal',
    Tag: 'tag',
    WorkItem: 'work-item',
    FocusArea: 'focus-area',
    Organization: 'organization',
    Ask: 'ask',
    Risk: 'risk',
    Dashboard: 'dashboard',
    Invoice: 'invoice',
    Deal: 'deal',
    Gliffy: 'gliffy',
    CustomerContact: 'customer-contact',
    CustomerOrg: 'customer-org',
    DataTable: 'data-table',
    AssetsObject: 'object',
    Type: 'type',
    Schema: 'schema',
    Position: 'position',
    Image: 'image',
    Audio: 'audio',
    Pdf: 'pdf',
    Shortcut: 'shortcut',
    Code: 'code',
    Archive: 'archive',
    Other: 'other',
    Notebook: 'notebook',
    Form: 'form',
    Article: 'article',
    Post: 'post',
    Ticket: 'ticket',
    Campaign: 'campaign',
    Case: 'case',
    CatalogItem: 'catalog-item',
    RequestedItem: 'requested-item',
    Demand: 'demand',
    KnowledgeArticle: 'knowledge-article',
    NewsArticle: 'news-article'
};
const $1bd00f711ef18555$export$e01073b80ff953d5 = Object.values($1bd00f711ef18555$export$49f6cbb853d30562);
const $1bd00f711ef18555$export$1f2db89e0caa00c9 = {
    Document: 'document',
    Spreadsheet: 'spreadsheet',
    Presentation: 'presentation',
    File: 'file',
    Database: 'database',
    WebPage: 'web-page',
    Page: 'page',
    Blogpost: 'blogpost',
    Article: 'article',
    Post: 'post',
    Dashboard: 'dashboard',
    Invoice: 'invoice',
    Design: 'design',
    Deal: 'deal',
    Video: 'video',
    Task: 'task',
    Issue: 'issue',
    Space: 'space',
    Project: 'project',
    Repository: 'repository',
    CustomerContact: 'customer-contact',
    CustomerOrg: 'customer-org',
    Image: 'image',
    Archive: 'archive',
    Audio: 'audio',
    Code: 'code',
    Pdf: 'pdf',
    Other: 'other',
    Software: 'software',
    ServiceDesk: 'service_desk',
    Business: 'business',
    DataTable: 'data-table',
    AssetsObject: 'object',
    Schema: 'schema',
    Type: 'type',
    Folder: 'folder',
    Notebook: 'notebook',
    Form: 'form',
    Shortcut: 'shortcut',
    Site: 'site',
    Subsite: 'subsite',
    Drive: 'drive',
    Comment: 'comment',
    Incident: 'incident',
    CatalogItem: 'catalog_item',
    RequestedItem: 'requested_item',
    KnowledgeArticle: 'knowledge_article',
    Demand: 'demand',
    NewsArticle: 'news_article',
    Epic: 'epic'
};
module.exports["TypeFilterValueKey"] = $1bd00f711ef18555$export$49f6cbb853d30562;
module.exports["allTypeFilterValueKeys"] = $1bd00f711ef18555$export$e01073b80ff953d5;
module.exports["NounSubtypeKey"] = $1bd00f711ef18555$export$1f2db89e0caa00c9;

});

parcelRegister("c2HNo", function(module, exports) {

var $9vOy1 = parcelRequire("9vOy1");

const $756ce5dc2839a0b3$export$daea4e28213a211a = ({ isRovoEnabled: isRovoEnabled })=>{
    if (isRovoEnabled) return (0, $9vOy1.ApplicationModes).Rovo;
    return (0, $9vOy1.ApplicationModes).Unified;
};
module.exports["getApplicationMode"] = $756ce5dc2839a0b3$export$daea4e28213a211a;

});

parcelRegister("2x777", function(module, exports) {

var $lwP5K = parcelRequire("lwP5K");

const $5f9d799009d34522$export$7cbf767827cd68ba = (user)=>{
    if (!user || !user.id) return {
        status: (0, $lwP5K.UserStatus).Unauthenticated,
        id: null,
        name: null,
        email: null
    };
    if (user.id === 'unidentified') return {
        status: (0, $lwP5K.UserStatus).Anonymous,
        ...user
    };
    return {
        status: (0, $lwP5K.UserStatus).Authenticated,
        ...user
    };
};
module.exports["getUser"] = $5f9d799009d34522$export$7cbf767827cd68ba;

});

parcelRegister("lwP5K", function(module, exports) {
var $049f30ab6612ce17$export$a82073022ded66e8 = /*#__PURE__*/ function(UserStatus) {
    UserStatus["Unauthenticated"] = "unauthenticated";
    UserStatus["Anonymous"] = "anonymous";
    UserStatus["Authenticated"] = "authenticated";
    return UserStatus;
}({});
var $049f30ab6612ce17$export$b259bb7f1faab8ee = /*#__PURE__*/ function(LinkDocContentType) {
    LinkDocContentType["extractedLink"] = "extractedLink";
    LinkDocContentType["boostedLink"] = "boostedLink";
    return LinkDocContentType;
}({});
module.exports["UserStatus"] = $049f30ab6612ce17$export$a82073022ded66e8;
module.exports["LinkDocContentType"] = $049f30ab6612ce17$export$b259bb7f1faab8ee;

});

parcelRegister("5XpfZ", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ const $26280c05cdeea98c$export$cbfae22cc278acfc = 'a436116f-02ce-4520-8fbb-7301462a1674';
const $26280c05cdeea98c$export$8e3fc93123f96c19 = (cloudId)=>cloudId === $26280c05cdeea98c$export$cbfae22cc278acfc;
module.exports["isHello"] = $26280c05cdeea98c$export$8e3fc93123f96c19;

});

parcelRegister("gkXKl", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");


var $dbl1i = parcelRequire("dbl1i");


var $4OGlb = parcelRequire("4OGlb");


var $hm6w9 = parcelRequire("hm6w9");


var $iA4lt = parcelRequire("iA4lt");

const $ddee69ce44809421$export$fd4704975f80304e = (layerName, onErrorFn, shouldNotGetBackendExperiment = false, getLayerValuesFn)=>{
    try {
        if (!layerName) return {
            frontendExperiment: undefined,
            backendExperiment: (0, $hm6w9.getBackendExperimentConfig)(onErrorFn, shouldNotGetBackendExperiment, getLayerValuesFn)
        };
        const layer = (0, $c6GJD.default).getLayer(layerName, {
            fireLayerExposure: false
        });
        const frontendExperimentName = layer.get('frontendExperimentName', '');
        if (frontendExperimentName) return {
            frontendExperiment: (0, $iA4lt.getFrontendExperiment)({
                abTestId: frontendExperimentName,
                onError: (error)=>onErrorFn?.(error)
            }),
            backendExperiment: (0, $4OGlb.DEFAULT_STATSIG_EXPERIMENT_CONFIG)
        };
        return {
            frontendExperiment: undefined,
            backendExperiment: (0, $hm6w9.getBackendExperimentConfig)(onErrorFn, shouldNotGetBackendExperiment, getLayerValuesFn)
        };
    } catch (error) {
        onErrorFn?.(error);
    }
    return {
        frontendExperiment: undefined,
        backendExperiment: (0, $4OGlb.DEFAULT_STATSIG_EXPERIMENT_CONFIG)
    };
};
const $ddee69ce44809421$export$42e21c9a86f72c4f = (overrides, layerName, onErrorFn, shouldNotGetBackendExperiment = false, getLayerValuesFn)=>{
    // We should only evaluate the backend experiment here if we are using search experiment overrides functionality
    // backend experiments outside of rovo v rovo are evaluated at request time instead
    const shouldUseSearchExperimentOverrides = (0, $dh538.fg)('search-experiment-overrides-backend');
    const shouldNotGetBackendExperimentsForOverrides = shouldUseSearchExperimentOverrides ? false : shouldNotGetBackendExperiment;
    // If the feature gate is enabled or no overrides are provided, return the default experiment.
    if (!shouldUseSearchExperimentOverrides || !overrides || overrides.length === 0) return $ddee69ce44809421$export$fd4704975f80304e(layerName, onErrorFn, shouldNotGetBackendExperimentsForOverrides, getLayerValuesFn);
    // Filter for backend experiment from the overrides. only allowing them for now
    const backendOverrideExperiments = overrides.filter((override)=>override.location === 'backend' && override.type === 'experiment');
    if (!backendOverrideExperiments.length) return $ddee69ce44809421$export$fd4704975f80304e(layerName, onErrorFn, shouldNotGetBackendExperimentsForOverrides, getLayerValuesFn);
    // Get the base user's experiments from layers.
    const { backendExperiment: backendExperiment, frontendExperiment: frontendExperiment } = $ddee69ce44809421$export$fd4704975f80304e(layerName, onErrorFn, shouldNotGetBackendExperimentsForOverrides, getLayerValuesFn);
    if (backendExperiment && 'experimentLayers' in backendExperiment) backendExperiment.experimentLayers = backendExperiment?.experimentLayers.map((layer)=>{
        const layerToOverride = backendOverrideExperiments.find((exp)=>{
            return exp.layer && layer.name?.includes(exp.layer === 'qr' ? 'query_expansion' : exp.layer);
        });
        if (!layerToOverride) {
            const { testId: _, ...rest } = layer;
            return rest;
        }
        const statsigOverrideExperiment = (0, $c6GJD.default).getExperiment(layerToOverride?.name);
        // handle case where experiment didnt add testId - for older experiments should be on new ones
        if (!statsigOverrideExperiment.get('testId', null)) {
            const { testId: _, ...rest } = layer;
            return rest;
        }
        return {
            name: layer.name,
            layerId: statsigOverrideExperiment.get('testId', null),
            shadowId: statsigOverrideExperiment.get('shadowId', null),
            // The below values might not be sent to the backend, but we can still track them in the frontend.
            controlId: statsigOverrideExperiment.get('controlId', null),
            abTestId: statsigOverrideExperiment.get('abTestId', null)
        };
    });
    return {
        backendExperiment: backendExperiment,
        frontendExperiment: frontendExperiment
    };
};
const $ddee69ce44809421$export$dd0548ef3fdfe45a = ({ combinedExperimentLayer: combinedExperimentLayer, experimentLayers: experimentLayers, primaryProduct: primaryProduct, sideBySideExperiment: sideBySideExperiment, statsigLayer: statsigLayer, onError: onError, getLayerValuesFn: getLayerValuesFn })=>{
    // If combinedExperimentLayer isn't explicitly provided, derive it from primaryProduct.
    // This avoids callers having to duplicate the product-to-layer mapping logic.
    const resolvedLayer = combinedExperimentLayer ?? (primaryProduct === 'jira' ? [
        (0, $4OGlb.STATSIG_SEARCH_PLATFORM_JIRA_LAYER_TENANTS_BASED),
        (0, $4OGlb.STATSIG_SEARCH_PLATFORM_JIRA_LAYER)
    ] : undefined);
    let combinedExperiment;
    if (Array.isArray(resolvedLayer)) // Check layers in sequence and stop at the first enabled layer.
    // This ensures we only expose to the layer that's actually needed.
    for (const layer of resolvedLayer){
        const layerData = (0, $hm6w9.getCombinedLayerValues)(layer, onError);
        if (layerData?.enabled) {
            combinedExperiment = layerData;
            break;
        }
    }
    else if (resolvedLayer) combinedExperiment = (0, $hm6w9.getCombinedLayerValues)(resolvedLayer, onError);
    const { frontendExperiment: frontendExperiment, backendExperiment: backendExperiment } = $ddee69ce44809421$export$42e21c9a86f72c4f(sideBySideExperiment, statsigLayer, onError, true, getLayerValuesFn);
    // This experiment can be alternated between mutually exclusive or not.
    const multiSiteSearchInRovoExperiment = (0, $iA4lt.getFrontendExperiment)({
        abTestId: 'multi_site_search_in_rovo',
        onError: onError
    });
    return {
        backendExperiment: backendExperiment,
        combinedExperiment: combinedExperiment,
        frontendExperiments: {
            // the frontend experiment that's mutually exclusive to other BE and FE experiments
            ...frontendExperiment?.abTestId && {
                [frontendExperiment.abTestId]: frontendExperiment
            },
            // add other frontend experiments that can be run alongside backend experiments here
            // NOTE: these aren't mutually exclusive to other BE or FE experiments
            [multiSiteSearchInRovoExperiment.abTestId]: multiSiteSearchInRovoExperiment
        },
        dynamicExperiments: (0, $dbl1i.dynamicExperimentsSchema).safeParse(experimentLayers ?? []).data
    };
};
const $ddee69ce44809421$export$b9e6179ff71a6122 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { combinedExperimentLayer: combinedExperimentLayer, experimentLayers: experimentLayers, sideBySideExperiment: sideBySideExperiment, statsigLayer: statsigLayer, onError: onError } = t0;
    let t1;
    if ($[0] !== combinedExperimentLayer || $[1] !== experimentLayers || $[2] !== onError || $[3] !== sideBySideExperiment || $[4] !== statsigLayer) {
        t1 = $ddee69ce44809421$export$dd0548ef3fdfe45a({
            combinedExperimentLayer: combinedExperimentLayer,
            experimentLayers: experimentLayers,
            sideBySideExperiment: sideBySideExperiment,
            statsigLayer: statsigLayer,
            onError: onError
        });
        $[0] = combinedExperimentLayer;
        $[1] = experimentLayers;
        $[2] = onError;
        $[3] = sideBySideExperiment;
        $[4] = statsigLayer;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
} : ({ combinedExperimentLayer: combinedExperimentLayer, experimentLayers: experimentLayers, sideBySideExperiment: sideBySideExperiment, statsigLayer: statsigLayer, onError: onError })=>{
    return (0, $42omo.useMemo)(()=>$ddee69ce44809421$export$dd0548ef3fdfe45a({
            combinedExperimentLayer: combinedExperimentLayer,
            experimentLayers: experimentLayers,
            sideBySideExperiment: sideBySideExperiment,
            statsigLayer: statsigLayer,
            onError: onError
        }), [
        experimentLayers,
        sideBySideExperiment,
        onError,
        statsigLayer,
        combinedExperimentLayer
    ]);
};
module.exports["getMutuallyExclusiveExperiment"] = $ddee69ce44809421$export$fd4704975f80304e;
module.exports["getExperimentConfig"] = $ddee69ce44809421$export$dd0548ef3fdfe45a;
module.exports["useExperimentConfig"] = $ddee69ce44809421$export$b9e6179ff71a6122;

});

parcelRegister("5iakG", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $b4tvS = parcelRequire("b4tvS");

const $6a0cb6a98d99c2c1$export$62fed45313a13eff = 'universalTypeFilter';
const $6a0cb6a98d99c2c1$export$64f2f70bb9f8e772 = [
    'lastUpdated',
    $6a0cb6a98d99c2c1$export$62fed45313a13eff,
    'contributor',
    'space',
    'createdBy',
    'lastUpdatedBy',
    'owner',
    'opportunityStatus',
    'campaignStatus',
    'caseStatus',
    'closeDate',
    'focusAreaType',
    'focusAreaUnder',
    'assignee',
    'reporter',
    'project',
    'content',
    'label',
    'pageStatus',
    'verified',
    'onlyTitleMatch',
    'archived',
    'statusFilter',
    'compassArchived',
    'assetsSchema',
    'assetsType',
    'watchedByMe',
    'positionFocusArea',
    'positionStatus',
    'positionJobFamily',
    'positionTeam',
    'commentedByMe',
    'positionEmploymentType',
    'salesforceStage',
    'repository',
    'pullRequestStatus',
    'slackChannel',
    'workspaceName',
    'hasAttachment'
];
const $6a0cb6a98d99c2c1$export$1fd3303b0f1dd4fb = ()=>{
    return $6a0cb6a98d99c2c1$export$64f2f70bb9f8e772.filter((filterId)=>{
        if (filterId === 'repository' && !(0, $dh538.fg)('rovo_fps_show_repository_filter')) return false;
        if (filterId === 'hasAttachment' && !(0, $dh538.fg)('rovo_fps_show_has_attachment_filter')) return false;
        if (filterId === 'workspaceName' && !(0, $dh538.fg)('rovo_fps_show_workspace_name_filter')) return false;
        return true;
    });
};
const $6a0cb6a98d99c2c1$export$2c1f2e526d05c6ca = 'search-page-hidden-filters-v2';
const $6a0cb6a98d99c2c1$export$b6072f70c84313e0 = ()=>{
    return $6a0cb6a98d99c2c1$export$2c1f2e526d05c6ca;
};
const $6a0cb6a98d99c2c1$export$657c4ea1fb8d25dd = [
    (0, $b4tvS.ProductKeys).Trello,
    (0, $b4tvS.ProductKeys).Gmail,
    (0, $b4tvS.ProductKeys).OutlookMail
];
module.exports["universalTypeFilterId"] = $6a0cb6a98d99c2c1$export$62fed45313a13eff;
module.exports["getFilterIdOrdering"] = $6a0cb6a98d99c2c1$export$1fd3303b0f1dd4fb;
module.exports["getSearchPageFilterConfigKey"] = $6a0cb6a98d99c2c1$export$b6072f70c84313e0;
module.exports["ALL_FILTER_EXCLUDED_PRODUCTS"] = $6a0cb6a98d99c2c1$export$657c4ea1fb8d25dd;

});

parcelRegister("7Evbj", function(module, exports) {

var $4JgC8 = parcelRequire("4JgC8");


var $bXE8w = parcelRequire("bXE8w");

const $1fcda106a24f1974$export$f86b2a1a2ce291b3 = async (error, userId, primaryProduct)=>{
    try {
        const SentryClient = await (0, $bXE8w.getSentryClient)();
        if (!SentryClient) return;
        SentryClient.withScope((scope)=>{
            for (const [key, value] of Object.entries((0, $4JgC8.COMMON_TAGS)))scope.setTag(key, value);
            scope.setUser({
                id: userId || (0, $4JgC8.UNKNOWN_TAG)
            });
            scope.setTag('product', primaryProduct || (0, $4JgC8.UNKNOWN_TAG));
            SentryClient.captureException(error, scope);
        });
    } catch (error) {
        // When there was an error with Sentry, just output to console
        // eslint-disable-next-line no-console
        console.error(error);
    }
};
module.exports["logException"] = $1fcda106a24f1974$export$f86b2a1a2ce291b3;

});

parcelRegister("djVCD", function(module, exports) {

var $hL7bb = parcelRequire("hL7bb");


var $9zUhf = parcelRequire("9zUhf");

var $FOT9i = parcelRequire("FOT9i");

var $cclHy = parcelRequire("cclHy");

var $1P1Tu = parcelRequire("1P1Tu");


var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");


var $b8N8h = parcelRequire("b8N8h");


var $8LSUr = parcelRequire("8LSUr");


var $2zuvB = parcelRequire("2zuvB");


var $6yNqK = parcelRequire("6yNqK");


var $5iakG = parcelRequire("5iakG");


var $2Znam = parcelRequire("2Znam");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $fZ3l2 = parcelRequire("fZ3l2");


var $9d9t8 = parcelRequire("9d9t8");


var $9rRKJ = parcelRequire("9rRKJ");


var $2OtFZ = parcelRequire("2OtFZ");


var $4JaUT = parcelRequire("4JaUT");

class $ff3b77c829810981$export$8ba86dff7c04c14c extends (0, $4JaUT.ResultsFetchError) {
    constructor(){
        super('No entities provided to fetch results');
        this.name = 'EmptyEntitiesError';
    }
}



var $78z3f = parcelRequire("78z3f");




const $68751eb12091b8db$export$94d61914de4d5edf = [
    {
        selectedProduct: (0, $78z3f.ProductKeys3P).Slack,
        selectedFilters: [
            [
                'universalTypeFilter',
                (0, $2Znam.TypeFilterValueKey).Conversation
            ]
        ],
        hiddenFilters: [
            'lastUpdated',
            'contributor'
        ]
    }
];








const $26dc42aea9abee59$export$5a7e3222966d6cdd = [
    {
        selectedProduct: (0, $78z3f.ProductKeys3P).Salesforce,
        selectedFilters: [
            [
                'universalTypeFilter',
                (0, $2Znam.TypeFilterValueKey).Deal
            ]
        ],
        shownFilters: [
            'salesforceStage',
            'opportunityStatus'
        ]
    },
    {
        selectedProduct: (0, $78z3f.ProductKeys3P).Salesforce,
        selectedFilters: [
            [
                'universalTypeFilter',
                (0, $2Znam.TypeFilterValueKey).Case
            ]
        ],
        shownFilters: [
            'caseStatus'
        ]
    },
    {
        selectedProduct: (0, $78z3f.ProductKeys3P).Salesforce,
        selectedFilters: [
            [
                'universalTypeFilter',
                (0, $2Znam.TypeFilterValueKey).Campaign
            ]
        ],
        shownFilters: [
            'campaignStatus'
        ]
    }
];


/**
 * Extracts the selected values for a given filter from the store's filters map.
 * Select filters store values as `value: string[]`; boolean and other filter
 * types are not expected to appear in rules and return an empty array.
 */ const $08c2ec3bf9b8f8f3$var$getFilterValues = (filters, filterId)=>{
    const filter = filters[filterId];
    if (filter && 'value' in filter && Array.isArray(filter.value)) return filter.value;
    return [];
};
const $08c2ec3bf9b8f8f3$export$8848759bd942e213 = (selectedProduct, filters, exclusionRules = (0, $68751eb12091b8db$export$94d61914de4d5edf), inclusionRules = (0, $26dc42aea9abee59$export$5a7e3222966d6cdd))=>{
    const excluded = new Set();
    // ── Exclusion rules: hide filters when conditions ARE met ──
    for (const rule of exclusionRules){
        // Check product condition (if specified)
        if (rule.selectedProduct !== undefined && rule.selectedProduct !== selectedProduct) continue;
        // Check all filter selection conditions (AND logic — all must match)
        const allFiltersMatch = rule.selectedFilters.every(([filterId, requiredValue])=>{
            const currentValues = $08c2ec3bf9b8f8f3$var$getFilterValues(filters, filterId);
            return currentValues.includes(requiredValue);
        });
        if (allFiltersMatch) rule.hiddenFilters.forEach((f)=>{
            // Never hide a filter that currently has active selections — the user
            // may have chosen a value before the exclusion rule activated and the
            // selection is still valid.
            const filterValues = $08c2ec3bf9b8f8f3$var$getFilterValues(filters, f);
            if (filterValues.length === 0) excluded.add(f);
        });
    }
    // ── Inclusion rules: hide filters when conditions are NOT met ──
    // Step 1: Collect all filter IDs managed by inclusion rules and track which
    // condition filter IDs each managed filter depends on.
    const managedFilters = new Set();
    const satisfiedFilters = new Set();
    const conditionFiltersPerManaged = new Map();
    for (const rule of inclusionRules){
        // Check product condition first — skip rules for other products entirely
        if (rule.selectedProduct !== undefined && rule.selectedProduct !== selectedProduct) continue;
        rule.shownFilters.forEach((f)=>{
            managedFilters.add(f);
            if (!conditionFiltersPerManaged.has(f)) conditionFiltersPerManaged.set(f, new Set());
            rule.selectedFilters.forEach(([filterId])=>conditionFiltersPerManaged.get(f).add(filterId));
        });
        // Check if this rule's conditions are all met
        const allConditionsMet = rule.selectedFilters.every(([filterId, requiredValue])=>{
            const currentValues = $08c2ec3bf9b8f8f3$var$getFilterValues(filters, filterId);
            return currentValues.includes(requiredValue);
        });
        if (allConditionsMet) rule.shownFilters.forEach((f)=>satisfiedFilters.add(f));
    }
    // Step 2: For each inclusion-managed filter, hide it if:
    // - No inclusion rule matched (filter not satisfied), AND
    // - At least one condition filter has an active selection (the user has made
    //   a choice that makes the filter irrelevant). If no condition filter has a
    //   value yet (e.g. "All" mode), leave the filter visible — don't hide it
    //   prematurely before the user has picked a type.
    for (const filterId of managedFilters)if (!satisfiedFilters.has(filterId)) {
        const conditionFilterIds = conditionFiltersPerManaged.get(filterId) ?? new Set();
        const anyConditionFilterHasValue = [
            ...conditionFilterIds
        ].some((cfId)=>$08c2ec3bf9b8f8f3$var$getFilterValues(filters, cfId).length > 0);
        if (anyConditionFilterHasValue) // A condition filter has a selection but it doesn't match any rule —
        // hide the managed filter. Unlike exclusion rules, inclusion rules hide
        // even when the managed filter has active selections — the store-level
        // `setSearchStoreState` will clear those selections separately so the
        // store stays in sync with what is applied.
        excluded.add(filterId);
    }
    return excluded;
};



var $b4tDU = parcelRequire("b4tDU");


var $lIbf3 = parcelRequire("lIbf3");


var $fUcm0 = parcelRequire("fUcm0");


var $d151M = parcelRequire("d151M");


var $133ZR = parcelRequire("133ZR");


var $6l1Qf = parcelRequire("6l1Qf");


var $jyecU = parcelRequire("jyecU");

const $674906c2a738886a$export$d4c72bab9d6cc13a = {
    abTest: undefined,
    cql: undefined,
    autoCorrection: undefined,
    product: undefined,
    requestId: undefined,
    traceId: undefined,
    // Search Input states
    inputQuery: '',
    searchQuery: '',
    originalQuery: undefined,
    // Product States
    primaryProduct: null,
    // Filter States
    filters: {},
    filterSelectionOrder: [],
    selectedProducts: [],
    selectedDatasource: undefined,
    availableProducts: [],
    allFilterExcludedProducts: [],
    jsmIncidentFilterIds: [],
    // Rest of store states
    resultsSort: {
        field: 'relevance',
        order: 'DESC'
    },
    retryCount: 0,
    queryVersion: 0,
    queryUpdatedTime: undefined,
    isLoading: false,
    isJiraHydrationLoading: false,
    isCompassTeamsLoading: false,
    shownCount: 0,
    results: undefined,
    resultError: undefined,
    productResultCountMap: null,
    paginationTokens: [],
    isLoadingMore: false,
    leapQuery: {
        loading: false,
        candidates: [],
        titleIndex: 0
    },
    requestedBackendExperiments: undefined,
    filterDropdownOpenByQueryParam: false,
    experience: (0, $9rRKJ.SearchExperience).SEARCH_PAGE,
    wasContentClearedBySpaceChange: false
};
const $674906c2a738886a$var$getUpdatedFilterSelectionOrder = (previousOrder, newFilterId, selected)=>{
    let filterSelectionOrder = new Set([
        ...previousOrder,
        newFilterId
    ]);
    if (!selected) filterSelectionOrder.delete(newFilterId);
    return [
        ...filterSelectionOrder
    ];
};
const $674906c2a738886a$var$isFiltersDiscoverability2Enabled = (primaryProduct)=>{
    if (!primaryProduct) return false;
    return primaryProduct === (0, $b4tvS.ProductKeys).Confluence || primaryProduct === (0, $b4tvS.ProductKeys).Jira;
};
/**
 * Only these keys can get set before the updateQueryParams loop when updateQueryParams=true in setSearchStoreState
 */ const $674906c2a738886a$var$safeStateKeys = [
    'filterSelectionOrder',
    'resultsSort',
    'retryCount',
    'selectedDatasource',
    'wasContentClearedBySpaceChange'
];
/**
 * Please use setSearchStoreState instead of setState within the Search Store controller.
 *
 * This is because we treat the URL as the source of truth for some state. Filter value states are set in the URL directly and then we listen to URL state changs to represent them in our state.
 *
 * @param newState - state properties to set
 * @param {boolean} options.updateQueryParams - [false] Whether a setState call should trigger an URL update
 *
 * Notes on updateQueryParams:
 *
 * When false, this function acts like a standard setState
 * When true, this function will allow only the {safeStateKeys} to be set and will then use the provided query/filter etc state to set the URL directly, relying on the URL observer to complete the loop
 *
 * Non-url updates should NEVER trigger the setQueryParams callback. Otherwise, this will cause infinite loops or extra render cycles.
 **/ const $674906c2a738886a$var$setSearchStoreState = (newState, options)=>({ getState: getState, setState: setState }, { setQueryParams: setQueryParams, allFilters: allFilters, config: config, availableProducts: availableProducts, primaryProduct: primaryProduct, queryParams: currentQueryParams })=>{
        // TODO future refactoring: we should instead query the newState object for any URL-state changes, then clean up the setState we perform, then update the URL. Then a consumer of this function will not need to care about any of this and can simply pass `newState` as expected
        if (!options?.updateQueryParams) {
            setState({
                ...newState,
                availableProducts: availableProducts
            });
            return;
        }
        // We still want to set variables in state that do NOT participate in the URL
        // Initially we'll allow-list this set, as the set of filters (the disallow set) will grow over time
        const safeNewState = Object.fromEntries(Object.entries(newState).filter(([key])=>$674906c2a738886a$var$safeStateKeys.includes(key)));
        if (Object.keys(safeNewState).length > 0) setState(safeNewState);
        const { searchQuery: newSearchQuery, inputQuery: newInputQuery, filterDropdownOpenByQueryParam: filterDropdownOpenByQueryParam } = newState;
        const { inputQuery: oldInputQuery } = getState();
        const { selectedProducts: selectedProducts, selectedDatasource: selectedDatasource, filters: allFilterStates } = {
            ...getState(),
            ...newState
        };
        // Compute excluded filters via FILTER_EXCLUSION_RULES + FILTER_INCLUSION_RULES (e.g.
        // salesforceStage when type≠deal). Excluded filters do NOT contribute to URL params
        // or the GraphQL query. This is the single source of truth for filter visibility;
        // UI selectors (useFiltersToDisplay, useSelectedFilterCount) apply the same exclusion.
        const excludedFilterIds = (0, $08c2ec3bf9b8f8f3$export$8848759bd942e213)(selectedProducts[0], allFilterStates);
        const staticFilters = Object.values(allFilters).filter((f)=>{
            if (excludedFilterIds.has(f.id)) return false;
            const filterState = f.getInitialState(config).getState();
            const isSuggestedFilter = f.isSuggestedFilter?.(primaryProduct);
            return (0, $b4tDU.isAllProductSearch)(selectedProducts) ? filterState.universal || isSuggestedFilter // When there are no selected products, only universal and suggested filters are persisted in state
             : // Forge connectors are registered dynamically and not in filterState.products, so check them separately
            filterState.universal && selectedProducts.some((0, $9d9t8.isForgeConnectorProductKey)) || filterState.products.some((product)=>selectedProducts.includes(product));
        });
        const filterQueryParamValues = staticFilters.map((staticFilter)=>{
            const filterState = allFilterStates[staticFilter.id];
            if (!staticFilter.isCompatible(filterState?.id)) return {};
            return staticFilter.withState(filterState, config).queryParams.get();
        });
        const filterQueryParams = Object.assign({}, ...filterQueryParamValues);
        const text = [
            newSearchQuery,
            newInputQuery,
            oldInputQuery
        ].find(Boolean);
        const enableRovoSearchOverrides = Boolean(// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        (0, $c6GJD.default).getExperimentValue('enable-rovo_search_overrides', 'value', false));
        // If overrides is already an object (parsed), convert it back to JSON string for parseQueryParams
        const overridesToPreserve = currentQueryParams?.overrides && enableRovoSearchOverrides ? typeof currentQueryParams.overrides === 'string' ? currentQueryParams.overrides : encodeURIComponent(JSON.stringify(currentQueryParams.overrides)) : undefined;
        const paramsToPassToParse = {
            product: selectedProducts[0],
            datasource: selectedDatasource?.datasourceId,
            text: text !== '' ? text : undefined,
            ...$674906c2a738886a$var$isFiltersDiscoverability2Enabled(primaryProduct) && {
                filterDropdownOpen: filterDropdownOpenByQueryParam || undefined
            },
            ...filterQueryParams,
            // Preserve overrides from current query params if enable-rovo_search_overrides is enabled
            ...overridesToPreserve && {
                overrides: overridesToPreserve
            }
        };
        const parsedQueryParams = (0, $lIbf3.parseQueryParams)(paramsToPassToParse, {
            commaSeparatedValues: true
        });
        setQueryParams(parsedQueryParams);
    };
const $674906c2a738886a$export$f14fed79ef571627 = $674906c2a738886a$var$setSearchStoreState;
const $674906c2a738886a$var$privateStoreActions = {
    initialiseStore: ()=>async ({ dispatch: dispatch }, { allFilters: allFilters, queryParams: queryParams, config: config, setQueryParams: setQueryParams, availableProducts: availableProducts, allFilterExcludedProducts: allFilterExcludedProducts, primaryProduct: primaryProduct, thirdPartyConfigs: thirdPartyConfigs, experience: experience })=>{
            const { getSelectedProducts: getSelectedProducts, filtersByProduct: filtersByProduct, isMissingProductSelection: isMissingProductSelection } = (0, $6l1Qf.FilterUtils)(allFilters, {});
            const selectedProducts = getSelectedProducts(queryParams);
            const cql = queryParams.cql?.toString();
            if (isMissingProductSelection(queryParams)) {
                setQueryParams({
                    ...queryParams,
                    product: selectedProducts[0]
                });
                return;
            }
            const { staticFilterValues: staticFiltersByProduct } = filtersByProduct(selectedProducts, experience, primaryProduct);
            const resolvedQueryParams = await Promise.allSettled(staticFiltersByProduct.map((staticFilter)=>{
                const queryParamsKeys = [
                    staticFilter.queryParams.key
                ];
                if (staticFilter.isSupportCustomValue && staticFilter.customValueFields) queryParamsKeys.push(...staticFilter.customValueFields);
                return staticFilter.getInitialState(config).queryParams.set((0, $lIbf3.convertQueryParamsToStringArray)(queryParams, queryParamsKeys));
            }));
            const filterStatesByProduct = resolvedQueryParams.flatMap((promise)=>{
                switch(promise.status){
                    case 'fulfilled':
                        return [
                            promise.value.getState()
                        ];
                    case 'rejected':
                        return [];
                }
            });
            const { filterStates: filterStates } = (0, $6l1Qf.FilterUtils)(staticFiltersByProduct, filterStatesByProduct);
            dispatch($674906c2a738886a$var$setSearchStoreState({
                filters: filterStates,
                selectedProducts: selectedProducts,
                selectedDatasource: (0, $lIbf3.getDatasourceFromId)(queryParams.datasource?.toString(), selectedProducts[0], thirdPartyConfigs),
                inputQuery: String(queryParams.text ?? ''),
                searchQuery: String(queryParams.text ?? ''),
                originalQuery: String(queryParams.originalQuery ?? ''),
                ...$674906c2a738886a$var$isFiltersDiscoverability2Enabled(primaryProduct) && {
                    filterDropdownOpenByQueryParam: Boolean(queryParams.filterDropdownOpen)
                },
                availableProducts: availableProducts,
                allFilterExcludedProducts: allFilterExcludedProducts,
                cql: cql,
                primaryProduct: primaryProduct,
                experience: experience
            }, {
                updateQueryParams: false // onInit should not update the query params
            }));
        },
    updateStore: ()=>async ({ dispatch: dispatch, getState: getState }, { allFilters: allFilters, queryParams: queryParams, config: config, availableProducts: availableProducts, primaryProduct: primaryProduct, thirdPartyConfigs: thirdPartyConfigs, experience: experience })=>{
            const { filters: filterStates } = getState();
            const { getSelectedProducts: getSelectedProducts, filtersByProduct: filtersByProduct } = (0, $6l1Qf.FilterUtils)(allFilters, filterStates);
            const selectedProducts = getSelectedProducts(queryParams);
            const cql = queryParams.cql?.toString();
            const { staticFilterValues: staticFiltersByProduct, filterStates: filterStatesByProduct } = filtersByProduct(selectedProducts, experience, primaryProduct);
            const resolvedQueryParams = await Promise.allSettled(staticFiltersByProduct.map((staticFilter)=>{
                const filterState = filterStatesByProduct[staticFilter.id];
                const queryParamsKeys = [
                    staticFilter.queryParams.key
                ];
                if (staticFilter.isSupportCustomValue && staticFilter.customValueFields) queryParamsKeys.push(...staticFilter.customValueFields);
                const queryParamStringArray = (0, $lIbf3.convertQueryParamsToStringArray)(queryParams, queryParamsKeys);
                if (!staticFilter.isCompatible(filterState?.id)) return staticFilter.getInitialState(config).queryParams.set(queryParamStringArray);
                return staticFilter.withState(filterState, config).queryParams.set(queryParamStringArray);
            }));
            const fullfilledFilterStates = resolvedQueryParams.flatMap((promise)=>{
                switch(promise.status){
                    case 'fulfilled':
                        return [
                            promise.value.getState()
                        ];
                    case 'rejected':
                        return [];
                }
            });
            const { filterStates: resolvedFilterStates } = (0, $6l1Qf.FilterUtils)(staticFiltersByProduct, fullfilledFilterStates);
            // In order, ensure all filters with values are added to selection
            // Ensures filters enter selection order from resume-from-url
            // TODO: this should be done with the global ordering, but we don't have that in constants yet
            let { filterSelectionOrder: filterSelectionOrder } = getState();
            const { getFiltersWithSelection: getFiltersWithSelection } = (0, $6l1Qf.FilterUtils)(staticFiltersByProduct, resolvedFilterStates);
            getFiltersWithSelection().forEach((filterId)=>{
                filterSelectionOrder = $674906c2a738886a$var$getUpdatedFilterSelectionOrder(filterSelectionOrder, filterId, resolvedFilterStates[filterId]?.hasSelection);
            });
            const querySelectedProducts = getSelectedProducts(queryParams);
            const selectedDatasource = (0, $lIbf3.getDatasourceFromId)(queryParams.datasource?.toString(), querySelectedProducts[0], thirdPartyConfigs);
            const nextStateSync = {
                filters: resolvedFilterStates,
                selectedProducts: querySelectedProducts,
                selectedDatasource: selectedDatasource,
                filterSelectionOrder: filterSelectionOrder,
                inputQuery: String(queryParams.text ?? ''),
                searchQuery: String(queryParams.text ?? ''),
                originalQuery: String(queryParams.originalQuery ?? ''),
                ...$674906c2a738886a$var$isFiltersDiscoverability2Enabled(primaryProduct) && {
                    filterDropdownOpenByQueryParam: Boolean(queryParams.filterDropdownOpen)
                },
                availableProducts: availableProducts,
                paginationTokens: [],
                cql: cql,
                primaryProduct: primaryProduct,
                experience: experience
            };
            const stateBeforeSync = getState();
            const prevStateSyncComparable = {
                filters: stateBeforeSync.filters,
                selectedProducts: stateBeforeSync.selectedProducts,
                selectedDatasource: stateBeforeSync.selectedDatasource,
                filterSelectionOrder: stateBeforeSync.filterSelectionOrder,
                inputQuery: stateBeforeSync.inputQuery,
                searchQuery: stateBeforeSync.searchQuery,
                originalQuery: stateBeforeSync.originalQuery,
                ...$674906c2a738886a$var$isFiltersDiscoverability2Enabled(primaryProduct) && {
                    filterDropdownOpenByQueryParam: stateBeforeSync.filterDropdownOpenByQueryParam
                },
                availableProducts: stateBeforeSync.availableProducts,
                paginationTokens: stateBeforeSync.paginationTokens,
                cql: stateBeforeSync.cql,
                primaryProduct: stateBeforeSync.primaryProduct,
                experience: stateBeforeSync.experience
            };
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($hL7bb)))(prevStateSyncComparable, nextStateSync)) dispatch($674906c2a738886a$var$setSearchStoreState(nextStateSync, {
                updateQueryParams: false
            } // onUpdate lifecycle should never update the query params
            ));
        },
    setFilter: (state, options)=>async ({ dispatch: dispatch, getState: getState }, { allFilters: allFilters, config: config })=>{
            // Get the static filter definition
            const staticFilter = allFilters[state.id];
            const { filters: allFiltersState } = getState();
            if (!staticFilter.isCompatible(staticFilter.id)) return;
            const filterWithState = staticFilter.withState(state, config).getState();
            dispatch($674906c2a738886a$var$setSearchStoreState({
                filters: {
                    ...allFiltersState,
                    [staticFilter.id]: filterWithState
                },
                ...options?.setSelectedProduct ? {
                    selectedProducts: [
                        options?.setSelectedProduct
                    ]
                } : {}
            }, {
                updateQueryParams: options?.shouldSetQueryParams
            }));
        },
    updateFilterSelectionOrder: (filterId, selected)=>async ({ dispatch: dispatch, getState: getState })=>{
            const { filterSelectionOrder: oldSelectionOrder } = getState();
            const newFilterSelectionOrder = $674906c2a738886a$var$getUpdatedFilterSelectionOrder(oldSelectionOrder, filterId, selected);
            dispatch($674906c2a738886a$var$setSearchStoreState({
                filterSelectionOrder: newFilterSelectionOrder
            }));
        },
    setNewFilterStates: (newFilterStates, setSelectedProduct, filterSelectionOrder)=>async ({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                filters: newFilterStates,
                ...setSelectedProduct !== undefined && {
                    selectedProducts: [
                        setSelectedProduct
                    ]
                },
                ...filterSelectionOrder && {
                    filterSelectionOrder: filterSelectionOrder
                }
            }, {
                updateQueryParams: false
            }));
            dispatch($674906c2a738886a$var$setSearchStoreState({}, {
                updateQueryParams: true
            }));
        }
};
function $674906c2a738886a$var$hasLoadInitialOptions(filter) {
    return typeof filter === 'object' && filter !== null && 'loadInitialOptions' in filter && typeof filter.loadInitialOptions === 'function' && 'getState' in filter && typeof filter.getState === 'function';
}
const $674906c2a738886a$export$e324594224ef24da = {
    loadInitialSelectFilterOptions: (props)=>async ({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config, thirdPartyConfigs: thirdPartyConfigs })=>{
            const staticSelectFilter = allFilters[props.filterId];
            const allFiltersState = getState().filters;
            const filterState = allFiltersState[props.filterId];
            const { selectedDatasource: stateSelectedDatasource, selectedProducts: selectedProducts } = getState();
            // When selectedDatasource is not set (e.g. no `datasource=` URL param was present),
            // derive it from thirdPartyConfigs using the selected product. This allows filters
            // that need a datasourceId (e.g. salesforceStage dynamic stage options) to fetch
            // correctly even when the datasource was not explicitly set via URL.
            //
            // Some dynamic 3P filters (those declaring `requiresTopLevel3PDatasource: true` —
            // today: salesforceStage, campaignStatus, caseStatus) read from the top-level
            // thirdPartyConfigs entry directly because it always carries a datasourceId, whereas
            // .datasources?.[0] may only be populated in multi-domain configurations.
            const shouldUseTopLevel3PDatasource = 'requiresTopLevel3PDatasource' in staticSelectFilter && !!staticSelectFilter.requiresTopLevel3PDatasource;
            const selectedDatasource = stateSelectedDatasource ?? (selectedProducts[0] ? shouldUseTopLevel3PDatasource ? thirdPartyConfigs?.[selectedProducts[0]] : thirdPartyConfigs?.[selectedProducts[0]]?.datasources?.[0] : undefined);
            if (!staticSelectFilter.isCompatible(filterState?.id) || !(0, $d151M.isSelectFilter)(staticSelectFilter.type)) return;
            // Race-condition guard: dynamic 3P filters require a resolved datasource to
            // fetch their option list. If the bootstrap config hasn't loaded yet,
            // `thirdPartyConfigs` is empty and `selectedDatasource` is undefined — in
            // which case calling `loadInitialOptions` would set `didMount = true` with
            // an empty result and the filter would never retry. Skip the call so the
            // caller (UI effect) can re-trigger once the datasource arrives.
            // Eagerly evaluate the gate so test runners (ffTest) can detect that it
            // was consulted, even when the && chain below short-circuits.
            const shouldRetryOnConfigLoad = (0, $dh538.fg)('rovo-fps-3p-ux-sf-retry-on-config-load');
            if (shouldUseTopLevel3PDatasource && !selectedDatasource && shouldRetryOnConfigLoad) return;
            const selectedSpaceAris = Array.isArray(allFiltersState?.space?.value) ? allFiltersState.space.value : config.initialSpaceARIs;
            const selectedContributorAccountIds = Array.isArray(allFiltersState?.contributor?.value) ? allFiltersState.contributor.value : config.contributorAccountIds;
            const extendedConfig = {
                ...config,
                // overriding the intl in config to fix a race condition with initial options and outdated translation messages
                intl: props.intl,
                selectedDatasource: selectedDatasource,
                initialSpaceARIs: selectedSpaceAris,
                contributorAccountIds: selectedContributorAccountIds
            };
            const newFilter = staticSelectFilter.withState(filterState, extendedConfig);
            if ($674906c2a738886a$var$hasLoadInitialOptions(newFilter)) await newFilter.loadInitialOptions((stateChange)=>{
                dispatch($674906c2a738886a$var$privateStoreActions.setFilter(stateChange));
            });
        },
    clearSelectFilterOptions: (props)=>async ({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const staticSelectFilter = allFilters[props.filterId];
            const allFiltersState = getState().filters;
            const filterState = allFiltersState[props.filterId];
            if (!staticSelectFilter.isCompatible(filterState?.id) || !(0, $d151M.isSelectFilter)(staticSelectFilter.type)) return;
            const newFilterState = staticSelectFilter.withState(filterState, config).clear().getState();
            dispatch($674906c2a738886a$var$privateStoreActions.setFilter(newFilterState, {
                shouldSetQueryParams: true
            }));
            dispatch($674906c2a738886a$var$privateStoreActions.updateFilterSelectionOrder(props.filterId, newFilterState.hasSelection));
            dispatch($674906c2a738886a$var$setSearchStoreState({
                productResultCountMap: null
            }));
        },
    /**
   * Sets a select filter option.
   *
   * @param validateDependentFilterId - If provided, validates if the dependent filter's containerARI
   *                                    is still in the new selection values and clears it if not.
   */ setSelectFilterOption: (props)=>async ({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const staticSelectFilter = allFilters[props.filterId];
            const allFiltersState = getState().filters;
            const filterState = allFiltersState[props.filterId];
            if (!staticSelectFilter.isCompatible(filterState?.id) || !(0, $d151M.isSelectFilter)(staticSelectFilter.type)) return;
            const filterWithState = staticSelectFilter.withState(filterState, config);
            if (!('setOption' in filterWithState)) return;
            const newFilterState = filterWithState.setOption(props.optionChange, props.options?.customValue).getState();
            if ((0, $2OtFZ.serveWebPagesInTypeFilter)() && props.filterId === (0, $5iakG.universalTypeFilterId)) {
                const { selectedProducts: selectedProducts } = getState();
                const hasWebPageSelected = newFilterState.hasSelection && newFilterState.value?.includes((0, $2Znam.TypeFilterValueKey).WebPage);
                if (hasWebPageSelected) {
                    // When web-page type is selected, use the same logic as clicking the noun in the right panel to select the product = AtlassianWebCrawler
                    dispatch($674906c2a738886a$export$e324594224ef24da.unsafe_setWebPageType());
                    return;
                }
                if (!newFilterState.hasSelection && selectedProducts?.includes((0, $b4tvS.ProductKeys).AtlassianWebCrawler)) {
                    // Clear the product since type filter has been cleared. This will also clear the type filter
                    // and update filter selection order through selectProductFilter's existing logic
                    dispatch($674906c2a738886a$var$setSearchStoreState({
                        productResultCountMap: null
                    }));
                    dispatch($674906c2a738886a$export$e324594224ef24da.selectProductFilter());
                    return;
                }
            }
            // When the contributor selection changes, the cached `initialOptions` (suggested values
            // shown when a dependent dropdown is opened without typing) on contributor-scoped
            // filters becomes stale: the base select filter short-circuits `loadInitialOptions`
            // when `state.didMount` is `true`, so the dropdown keeps showing pre-contributor
            // suggestions until the user actually types. Reset `didMount` /
            // `didMountPerProducts` and clear `initialOptions.options` on each contributor-scoped
            // dependent filter so the next dropdown open re-fetches with the new contributor
            // scope. Behind the same FG that controls the rest of the contributor scoping logic.
            if (props.filterId === 'contributor' && (0, $dh538.fg)('rovo_fps_scope_3p_typeahead_by_contributor')) {
                const previousValue = Array.isArray(filterState?.value) ? filterState.value : [];
                const nextValue = Array.isArray(newFilterState.value) ? newFilterState.value : [];
                const contributorSelectionChanged = !(0, (/*@__PURE__*/$parcel$interopDefault($hL7bb)))([
                    ...previousValue
                ].sort(), [
                    ...nextValue
                ].sort());
                if (contributorSelectionChanged) {
                    const contributorScopedDependents = [
                        'content'
                    ];
                    contributorScopedDependents.forEach((dependentId)=>{
                        const dependentStaticFilter = allFilters[dependentId];
                        const dependentFilterState = allFiltersState[dependentId];
                        if (!dependentStaticFilter || !dependentStaticFilter.isCompatible(dependentFilterState?.id) || !(0, $d151M.isSelectFilter)(dependentStaticFilter.type)) return;
                        const dependentSelectFilterState = dependentFilterState;
                        if (!dependentSelectFilterState) return;
                        const resetDependentState = {
                            ...dependentSelectFilterState,
                            didMount: false,
                            didMountPerProducts: {},
                            initialOptions: {
                                ...dependentSelectFilterState.initialOptions,
                                options: [],
                                isLoading: false
                            }
                        };
                        dispatch($674906c2a738886a$var$privateStoreActions.setFilter(resetDependentState, {
                            shouldSetQueryParams: false
                        }));
                    });
                }
            }
            // Validate dependent filter if specified (e.g., clear content filter when space changes)
            const dependentFilterId = props.options?.validateDependentFilterId;
            let wasContentCleared = false;
            if (dependentFilterId) {
                const dependentStaticFilter = allFilters[dependentFilterId];
                const dependentFilterState = allFiltersState[dependentFilterId];
                if (dependentStaticFilter?.isCompatible(dependentFilterState?.id) && (0, $d151M.isSelectFilter)(dependentStaticFilter.type)) {
                    // Get new values from the updated filter state
                    const newValues = Array.isArray(newFilterState.value) ? newFilterState.value : [];
                    const { selectedProducts: selectedProducts } = getState();
                    const shouldResetLoomFolderWhenSpaceCleared = dependentFilterId === (0, $133ZR.folderFilterId) && selectedProducts[0] === (0, $b4tvS.ProductKeys).Loom && newValues.length === 0 && (0, $dh538.fg)('loom-rovo-search');
                    // Clear the dependent filter whenever the primary filter is explicitly set to a
                    // non-empty selection. Reset didMount and clear cached initialOptions so the next
                    // dropdown open re-fetches dependent suggestions scoped to the new primary selection
                    // instead of showing stale options from the previous selection.
                    // Loom: also reset folder when all spaces are deselected (Drive→content keeps
                    // content when space is empty).
                    if (newValues.length > 0 || shouldResetLoomFolderWhenSpaceCleared) {
                        const clearedDependentState = dependentStaticFilter.withState(dependentFilterState, config).clear().getState();
                        const dependentSelectFilterState = dependentFilterState;
                        const resetDependentState = dependentSelectFilterState ? {
                            ...clearedDependentState,
                            didMount: false,
                            didMountPerProducts: {},
                            initialOptions: {
                                ...dependentSelectFilterState.initialOptions,
                                options: [],
                                isLoading: false
                            },
                            // Reset lookup so stale typeahead results (from typing in the
                            // filter dropdown before space change) don't persist alongside
                            // new space-scoped suggestions when the content dropdown reopens.
                            lookup: {
                                ...dependentSelectFilterState.lookup,
                                options: [],
                                lookupResultOptions: [],
                                input: '',
                                isLoading: false,
                                isActive: false
                            }
                        } : clearedDependentState;
                        dispatch($674906c2a738886a$var$privateStoreActions.setFilter(resetDependentState, {
                            shouldSetQueryParams: false
                        }));
                        dispatch($674906c2a738886a$var$privateStoreActions.updateFilterSelectionOrder(dependentFilterId, false));
                        wasContentCleared = true;
                    }
                }
            }
            dispatch($674906c2a738886a$var$privateStoreActions.setFilter(newFilterState, {
                shouldSetQueryParams: true,
                setSelectedProduct: props.options?.setSelectedProduct
            }));
            dispatch($674906c2a738886a$var$privateStoreActions.updateFilterSelectionOrder(props.filterId, newFilterState.hasSelection));
            // NOTE: Inclusion-rule-driven filters (e.g. salesforceStage when type≠deal) are
            // handled as a derived projection in setSearchStoreState (URL/GraphQL builder),
            // useFiltersToDisplay (UI), and useSelectedFilterCount (badge). Stale selections
            // for excluded filters are cleared by setSearchStoreState in the same write so
            // the store stays in sync with what is visible/applied. No imperative clear is
            // needed here.
            dispatch($674906c2a738886a$var$setSearchStoreState({
                productResultCountMap: null,
                wasContentClearedBySpaceChange: wasContentCleared
            }));
        },
    setAutoFilters: (filters)=>async ({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const { filters: allFilterStates } = getState();
            const newFilterStates = {};
            await Promise.all(filters.map(async (filterConfig)=>{
                const staticSelectFilter = allFilters[filterConfig.filterId];
                const filterState = allFilterStates[filterConfig.filterId];
                // We should not automatically apply the filter if it has already been selected
                if (filterState?.hasSelection) return;
                if (!staticSelectFilter.isCompatible(filterState?.id) || !(0, $d151M.isSelectFilter)(staticSelectFilter.type)) return;
                const filterWithState = staticSelectFilter.withState(filterState, config);
                if (!('setOption' in filterWithState)) return;
                const optionsToChange = Array.isArray(filterConfig.optionChange) ? filterConfig.optionChange : [
                    filterConfig.optionChange
                ];
                const selectedOptions = optionsToChange.filter((o)=>o.isSelected);
                if (selectedOptions.length === 0) return;
                // Build query params object with the filter's key
                const queryParamsKey = staticSelectFilter.queryParams.key;
                const queryParams = {
                    [queryParamsKey]: selectedOptions.map((o)=>o.value)
                };
                // Add custom value fields if provided
                if (filterConfig.options?.customValue) Object.entries(filterConfig.options.customValue).forEach(([key, value])=>{
                    queryParams[key] = [
                        value
                    ];
                });
                // Use queryParams.set which handles option hydration via fetcher
                const hydratedFilter = await filterWithState.queryParams.set(queryParams);
                newFilterStates[filterConfig.filterId] = hydratedFilter.getState();
            }));
            if (Object.keys(newFilterStates).length > 0) {
                const { filterSelectionOrder: currentOrder } = getState();
                // Add new auto-applied filters to the order
                const updatedOrder = Object.keys(newFilterStates).reduce((order, filterId)=>$674906c2a738886a$var$getUpdatedFilterSelectionOrder(order, filterId, newFilterStates[filterId]?.hasSelection), currentOrder);
                dispatch($674906c2a738886a$var$privateStoreActions.setNewFilterStates({
                    ...allFilterStates,
                    ...newFilterStates
                }, undefined, updatedOrder));
            }
        },
    setSelectFilterLookupInput: (props)=>async ({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const staticSelectFilter = allFilters[props.filterId];
            const allFiltersState = getState().filters;
            const filterState = allFiltersState[props.filterId];
            const { selectedDatasource: selectedDatasource } = getState();
            if (!staticSelectFilter.isCompatible(filterState?.id) || !(0, $d151M.isSelectFilter)(staticSelectFilter.type)) return;
            const selectedSpaceAris = Array.isArray(allFiltersState?.space?.value) ? allFiltersState.space.value : config.initialSpaceARIs;
            const selectedContributorAccountIds = Array.isArray(allFiltersState?.contributor?.value) ? allFiltersState.contributor.value : config.contributorAccountIds;
            const extendedConfig = {
                ...config,
                selectedDatasource: selectedDatasource,
                initialSpaceARIs: selectedSpaceAris,
                contributorAccountIds: selectedContributorAccountIds
            };
            const filterWithState = staticSelectFilter.withState(filterState, extendedConfig);
            if ('setLookupInput' in filterWithState) await filterWithState.setLookupInput(props.query, (stateChange)=>{
                dispatch($674906c2a738886a$var$privateStoreActions.setFilter(stateChange));
            });
        },
    setBooleanFilterValue: (props, privateActions = $674906c2a738886a$var$privateStoreActions)=>({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const staticBooleanFilter = allFilters[props.filterId];
            const allFiltersState = getState().filters;
            const filterState = allFiltersState[props.filterId];
            if (!staticBooleanFilter.isCompatible(filterState?.id)) return;
            if (staticBooleanFilter.type !== 'boolean') return;
            const newBooleanFilterState = staticBooleanFilter.withState(filterState, config).setValue(props.value).getState();
            dispatch(privateActions.setFilter(newBooleanFilterState, {
                shouldSetQueryParams: true,
                setSelectedProduct: props.options?.setSelectedProduct
            }));
            dispatch(privateActions.updateFilterSelectionOrder(props.filterId, newBooleanFilterState.hasSelection));
            dispatch($674906c2a738886a$var$setSearchStoreState({
                productResultCountMap: null
            }));
        },
    clearAllFilters: ()=>({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const { filters: allFilterStates } = getState();
            const staticFilters = Object.values(allFilters);
            const clearedFilters = $674906c2a738886a$var$clearFilters(allFilterStates, staticFilters, config);
            dispatch($674906c2a738886a$var$setSearchStoreState({
                filters: clearedFilters,
                selectedProducts: [],
                filterSelectionOrder: [],
                wasContentClearedBySpaceChange: false
            }, {
                updateQueryParams: true
            }));
        },
    clearAllAvailableFilters: ()=>({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const staticFilters = Object.values(allFilters);
            const { filters: allFilterStates } = getState();
            dispatch($674906c2a738886a$var$setSearchStoreState({
                filters: $674906c2a738886a$var$clearFilters(allFilterStates, staticFilters, config),
                filterSelectionOrder: [],
                wasContentClearedBySpaceChange: false
            }, {
                updateQueryParams: true
            }));
        },
    // Product filter actions
    selectProductFilter: (productKey, datasource)=>({ getState: getState, dispatch: dispatch }, { thirdPartyConfigs: thirdPartyConfigs, allFilters: allFilters, config: config })=>{
            const { selectedProducts: selectedProducts, selectedDatasource: selectedDatasource, filters: filters, filterSelectionOrder: filterSelectionOrder } = getState();
            // Convert string datasource to object if needed for consistency
            const datasourceObject = typeof datasource === 'string' ? (0, $lIbf3.getDatasourceFromId)(datasource, productKey, thirdPartyConfigs) : datasource;
            // Only return early if both product and datasource are the same
            if (productKey && selectedProducts.includes(productKey) && datasourceObject?.datasourceId === selectedDatasource?.datasourceId) return;
            const persistedFilters = {};
            // Persist selected universal filters if they are relevant to the selected product
            for (const [id, filter] of Object.entries(filters)){
                if (!filter) continue;
                if (filter.universal && filter.hasSelection && (!productKey || productKey && filter.products.includes(productKey) || // Universal filters should always be persisted for forge connectors
                productKey && (0, $9d9t8.isForgeConnectorProductKey)(productKey))) persistedFilters[id] = filter;
            }
            // Type is a universal filter, but type needs to be cleared if we're filtering away from Atlas
            // This is because selecting a global noun sets product AND type values
            if (selectedProducts.includes((0, $b4tvS.ProductKeys).Atlas)) delete persistedFilters[0, $5iakG.universalTypeFilterId];
            const newSelectedProducts = productKey ? [
                productKey
            ] : [];
            // Clear web-page type filter when navigating away from Web Pages
            if ((0, $2OtFZ.serveWebPagesInTypeFilter)()) {
                const currentTypeFilter = filters[0, $5iakG.universalTypeFilterId];
                const isWebPageTypeSelected = currentTypeFilter?.type === 'single-select' && currentTypeFilter?.value?.includes((0, $2Znam.TypeFilterValueKey).WebPage);
                if (isWebPageTypeSelected) // When user clicks "All" or selects any product, clear the web-page type
                delete persistedFilters[0, $5iakG.universalTypeFilterId];
            }
            // Universal filters being persisted also retain their ordering
            const newFilterSelectionOrder = filterSelectionOrder.filter((f)=>{
                return Object.keys(persistedFilters).includes(f);
            });
            dispatch($674906c2a738886a$var$setSearchStoreState({
                selectedProducts: newSelectedProducts,
                selectedDatasource: datasourceObject,
                filterSelectionOrder: newFilterSelectionOrder,
                filters: persistedFilters,
                resultsSort: $674906c2a738886a$export$d4c72bab9d6cc13a.resultsSort,
                wasContentClearedBySpaceChange: false
            }, {
                updateQueryParams: true
            }));
        },
    unselectProductFilter: ()=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$export$e324594224ef24da.selectProductFilter(undefined));
        },
    // Search Input Actions
    setInputQuery: (inputQuery)=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                inputQuery: inputQuery.trim()
            }));
        },
    setSearchQuery: (searchQuery)=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                searchQuery: searchQuery.trim()
            }, {
                updateQueryParams: true
            }));
        },
    triggerSearch: ()=>({ getState: getState, dispatch: dispatch })=>{
            const { inputQuery: inputQuery, searchQuery: searchQuery, retryCount: retryCount, productResultCountMap: productResultCountMap } = getState();
            dispatch($674906c2a738886a$var$setSearchStoreState({
                productResultCountMap: searchQuery === inputQuery ? productResultCountMap : null,
                wasContentClearedBySpaceChange: false
            }));
            dispatch($674906c2a738886a$var$setSearchStoreState({
                searchQuery: inputQuery,
                retryCount: searchQuery === inputQuery ? retryCount + 1 : 0
            }, {
                updateQueryParams: true
            }));
        },
    retrySearch: ()=>({ dispatch: dispatch, getState: getState })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                retryCount: getState().retryCount + 1
            }));
        },
    // Sorting actions
    setSortField: (sortField)=>({ dispatch: dispatch, getState: getState })=>{
            const { resultsSort: resultsSort } = getState();
            dispatch($674906c2a738886a$var$setSearchStoreState({
                resultsSort: {
                    ...resultsSort,
                    field: sortField
                },
                paginationTokens: []
            }));
        },
    setSortOrder: (sortOrder)=>({ dispatch: dispatch, getState: getState })=>{
            const { resultsSort: resultsSort } = getState();
            dispatch($674906c2a738886a$var$setSearchStoreState({
                resultsSort: {
                    ...resultsSort,
                    order: sortOrder
                },
                paginationTokens: []
            }));
        },
    resetSort: ()=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                resultsSort: $674906c2a738886a$export$d4c72bab9d6cc13a.resultsSort,
                paginationTokens: []
            }));
        },
    // Rest of Search Actions
    setQueryUpdatedTime: ()=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                queryUpdatedTime: Date.now()
            }));
        },
    resetQueryVersion: ()=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                queryVersion: 0
            }));
        },
    incrementQueryVersion: ()=>({ getState: getState, setState: setState })=>{
            const { queryVersion: queryVersion } = getState();
            setState({
                queryVersion: queryVersion + 1
            });
        },
    setIsLoading: (isLoading)=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                isLoading: isLoading
            }));
        },
    // Results actions
    setResults: (results, error, requestId, traceId)=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                isLoading: false,
                results: results,
                resultError: error,
                requestId: requestId,
                traceId: traceId,
                wasContentClearedBySpaceChange: false
            }));
        },
    appendMoreResults: (results)=>({ dispatch: dispatch, getState: getState })=>{
            const { results: currentResults } = getState();
            if (!currentResults || !results) return;
            const currentEdges = currentResults.edges;
            const newEdges = results.edges;
            const newResults = {
                ...currentResults,
                edges: currentEdges.concat(newEdges),
                pageInfo: results?.pageInfo
            };
            dispatch($674906c2a738886a$var$setSearchStoreState({
                results: newResults,
                isLoadingMore: false
            }));
        },
    setFetchFromCursor: (cursor)=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                paginationTokens: [
                    {
                        cursor: cursor
                    }
                ]
            }));
        },
    setIsLoadingMore: (isLoadingMore)=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                isLoadingMore: isLoadingMore
            }));
        },
    setJiraIssueFieldsLoading: (isLoading)=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                isJiraHydrationLoading: isLoading
            }));
        },
    setJiraIssueDetails: (issueData)=>({ dispatch: dispatch, getState: getState })=>{
            const { results: results } = getState();
            let hydratedResults = [];
            if (results?.edges && results.edges.length > 0 && issueData.length > 0) {
                // TODO: fix colorName being passed twice with inconsistent values, see the unit test for context
                hydratedResults = [
                    ...results.edges
                ].map((edge)=>{
                    if ((0, $8LSUr.isSearchResultJiraIssue)(edge.node)) {
                        const id = edge.node.id;
                        const hydratedIssue = issueData.find((issue)=>issue.id === id);
                        if (edge.node.status && hydratedIssue) {
                            edge.node.status.name = hydratedIssue.statusField.status.name;
                            edge.node.status.colorName = hydratedIssue.statusField.status.statusCategory?.colorName;
                        }
                    }
                    return edge;
                });
                dispatch($674906c2a738886a$var$setSearchStoreState({
                    results: {
                        ...results,
                        edges: hydratedResults
                    }
                }));
            }
        },
    setCompassTeamsLoading: (isLoading)=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                isCompassTeamsLoading: isLoading
            }));
        },
    setCompassTeams: (teamData)=>({ dispatch: dispatch, getState: getState })=>{
            const { results: results } = getState();
            let resultsWithTeamNames = [];
            if (results?.edges && results.edges.length > 0 && teamData.length > 0) {
                resultsWithTeamNames = [
                    ...results.edges
                ].map((edge)=>{
                    if ((0, $b8N8h.isSearchCompassPartial)(edge.node)) {
                        const teamId = (0, $fUcm0.getTeamId)(edge.node.ownerId);
                        const team = teamData.find((team)=>team.id === teamId);
                        edge.node.ownerName = team?.displayName;
                    }
                    return edge;
                });
                dispatch($674906c2a738886a$var$setSearchStoreState({
                    results: {
                        ...results,
                        edges: resultsWithTeamNames
                    }
                }));
            }
        },
    resetResults: ()=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                isLoading: false,
                shownCount: 0,
                results: undefined,
                resultError: undefined,
                requestId: undefined,
                wasContentClearedBySpaceChange: false
            }));
        },
    setAutoCorrection: (autoCorrection)=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                autoCorrection: autoCorrection
            }));
        },
    setLeapQuery: ({ candidates: candidates, titleIndex: titleIndex, loading: loading })=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                leapQuery: {
                    loading: loading,
                    candidates: candidates,
                    titleIndex: titleIndex
                }
            }));
        },
    setProductResultCount: (totalCounts)=>({ dispatch: dispatch, getState: getState })=>{
            if (totalCounts === undefined) {
                dispatch($674906c2a738886a$var$setSearchStoreState({
                    productResultCountMap: null
                }));
                return;
            }
            const { filters: filterStates, availableProducts: availableProducts, productResultCountMap: oldProductResultCountMap } = getState();
            const filtersWithSelection = Object.values(filterStates).filter((filter)=>filter?.hasSelection);
            const productsCorrespondingToAllSelectedFilters = filtersWithSelection.length ? availableProducts.filter((product)=>filtersWithSelection.every((filter)=>filter?.products?.includes(product))) : availableProducts;
            const resultsCountsAdjustedForSelectedFilters = totalCounts.map((resultCount)=>{
                if (productsCorrespondingToAllSelectedFilters.includes(resultCount.product)) return resultCount;
                else return {
                    ...resultCount,
                    count: 0
                };
            });
            const productResultCountMap = resultsCountsAdjustedForSelectedFilters.reduce((acc, { product: product, count: count })=>{
                if (product) acc[product] = count;
                return acc;
            }, {});
            dispatch($674906c2a738886a$var$setSearchStoreState({
                productResultCountMap: {
                    ...oldProductResultCountMap,
                    ...productResultCountMap
                }
            }));
        },
    // For backwards compatibility
    clearHybridFilters: ()=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$export$e324594224ef24da.clearAllFilters());
        },
    /**
   * TODO: QS-9329: Persist auto-applied filters when selecting
   * * Projects (type=project & product=townsquare)
   * * Goals (type=goal & product=townsquare)
   * in the right rail.
   *
   * More information: https://product-fabric.atlassian.net/browse/QS-9329
   *
   * Considered unsafe since it's using queryParams to change the state.
   * Ideally we should set it directly in the state, but that requires introducing a new action.
   * This is because the cooresponding "Type" filter that this selects isn't available or easy to set from outside
   * The product=townsquare&type=project will correctly hydrate the filter from the URL after params are set though!
   *
   * We hope to improve Atlassian Home / global noun handling after GA
   *
   * The last modified and contributors filters are explicitly kept in the query params because they are universal.
   * Type is also a universal filter, but we couple the type with the product to determine which Townsquare results to show.
   *
   * @param value: a noun to be set
   */ unsafe_setAtlasNouns: (value)=>({ dispatch: dispatch }, { queryParams: queryParams, setQueryParams: setQueryParams })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                productResultCountMap: null
            }));
            if (!value) {
                const { product: _, type: __, ...queryParamsWithResetNounFilter } = queryParams;
                setQueryParams({
                    ...queryParamsWithResetNounFilter
                });
            } else {
                const { text: text, originalQuery: originalQuery, lastModified: lastModified, contributors: contributors } = queryParams;
                // We explicitly only keep text, last modified and contributors
                setQueryParams({
                    product: (0, $b4tvS.ProductKeys).Atlas,
                    type: value,
                    text: text,
                    originalQuery: originalQuery,
                    lastModified: lastModified,
                    contributors: contributors
                });
            }
        },
    /**
   * * TODO: QS-9329: Persist auto-applied filters when selecting
   * Web Pages (type=web-page & product=atlassian-web-crawler) in the right rail
   * or type=web-page in horizontal filters.
   *
   * More information: https://product-fabric.atlassian.net/browse/QS-9329
   *
   * Similar to unsafe_setAtlasNouns, this directly manipulates URL query params
   * to set the Type filter to "web-page".
   */ unsafe_setWebPageType: ()=>({ dispatch: dispatch }, { queryParams: queryParams, setQueryParams: setQueryParams })=>{
            if (!(0, $2OtFZ.serveWebPagesInTypeFilter)()) {
                // Control cohort: use the old behavior by selecting AtlassianWebCrawler product
                dispatch($674906c2a738886a$export$e324594224ef24da.selectProductFilter((0, $b4tvS.ProductKeys).AtlassianWebCrawler));
                return;
            }
            // Test cohort: use the new behavior by setting type = 'web-page' in the URL
            dispatch($674906c2a738886a$var$setSearchStoreState({
                productResultCountMap: null
            }));
            const { text: text, originalQuery: originalQuery, lastModified: lastModified, contributors: contributors } = queryParams;
            setQueryParams({
                product: (0, $b4tvS.ProductKeys).AtlassianWebCrawler,
                type: (0, $2Znam.TypeFilterValueKey).WebPage,
                text: text,
                originalQuery: originalQuery,
                lastModified: lastModified,
                contributors: contributors
            });
        },
    setRequestedBackendExperiments: (requestedBackendExperiments)=>({ setState: setState })=>{
            const experimentLayers = requestedBackendExperiments?.experimentLayers?.map((layer)=>{
                const { analyticsDefinitions: analyticsDefinitions, ...rest } = layer;
                return {
                    ...rest,
                    definitions: analyticsDefinitions
                };
            });
            setState({
                requestedBackendExperiments: {
                    experimentLayers: experimentLayers
                }
            });
        },
    setJsmIncidentFilterIds: (jsmIncidentFilterIds)=>({ getState: getState, setState: setState })=>{
            if (getState().jsmIncidentFilterIds === jsmIncidentFilterIds) return;
            setState({
                jsmIncidentFilterIds: jsmIncidentFilterIds
            });
        },
    /*
   * This action is only triggered by QF but the value of filterDropdownOpen is only used by FPS
   * This means we need to update query param to make it available to FPS
   * That's why updateQueryParams is set to 'true'
   *
   * We only call it for clearing and the "set" value would be handled by onNavigate
   * */ unsetFilterDropdownOpen: ()=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$setSearchStoreState({
                filterDropdownOpenByQueryParam: false
            }, {
                updateQueryParams: true
            }));
        }
};
const $674906c2a738886a$var$clearFilters = (allFilterStates, filters, config)=>{
    const clearedFilters = filters.map((filter)=>{
        const filterState = allFilterStates[filter.id];
        if (!filter.isCompatible(filterState?.id)) return [];
        return [
            filter.id,
            filter.withState(filterState, config).clear().getState()
        ];
    });
    return Object.fromEntries(clearedFilters);
};
// Keep store private and use hooks to access state and actions
const $674906c2a738886a$var$Store = (0, $1P1Tu.createStore)({
    initialState: $674906c2a738886a$export$d4c72bab9d6cc13a,
    actions: $674906c2a738886a$export$e324594224ef24da,
    name: 'search'
});
const $674906c2a738886a$export$b8f9c0e048639dd4 = (0, $9zUhf.createActionsHook)($674906c2a738886a$var$Store);
const $674906c2a738886a$export$bf072992274c9fb = (0, $FOT9i.createContainer)($674906c2a738886a$var$Store, {
    onInit: ()=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$privateStoreActions.initialiseStore());
        },
    onUpdate: ()=>({ dispatch: dispatch })=>{
            dispatch($674906c2a738886a$var$privateStoreActions.updateStore());
        },
    onCleanup: ()=>({ setState: setState })=>{
            setState($674906c2a738886a$export$d4c72bab9d6cc13a);
        }
});
const $674906c2a738886a$export$bd221a7c56b93941 = (0, $9zUhf.createHook)($674906c2a738886a$var$Store);
const $674906c2a738886a$export$c5a5afdff2ff0385 = (0, $9zUhf.createActionsHook)($674906c2a738886a$var$Store);
const $674906c2a738886a$export$5fd14fa624074d55 = (0, $9zUhf.createStateHook)($674906c2a738886a$var$Store, {
    selector: (state, cb)=>cb(state)
});
const $674906c2a738886a$export$973ca22476b0e05f = (0, $9zUhf.createStateHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.filters
});
const $674906c2a738886a$export$da992673b1309795 = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.inputQuery
});
const $674906c2a738886a$export$59d1399255ff1d16 = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.experience
});
const $674906c2a738886a$export$e985158d10c27e34 = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.searchQuery
});
const $674906c2a738886a$export$c2380c4d76e63cc4 = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.originalQuery
});
const $674906c2a738886a$export$ba2ad669c5b27bca = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.autoCorrection
});
const $674906c2a738886a$export$140d37088821fcb1 = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.retryCount
});
const $674906c2a738886a$export$275c72361969d62c = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.productResultCountMap
});
const $674906c2a738886a$export$14279a3fbdb52451 = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.results?.abTest
});
const $674906c2a738886a$export$34418e307d9100b4 = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.results?.queryInfo
});
const $674906c2a738886a$export$8a4c65ea4f241b48 = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.searchQuery ? (0, $6yNqK.QueryState).POSTQUERY : (0, $6yNqK.QueryState).PREQUERY
});
const $674906c2a738886a$export$a2b38489a4538322 = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.queryUpdatedTime
});
const $674906c2a738886a$export$bda9ac73817ceec3 = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.results
});
const $674906c2a738886a$export$1c9622ace43d770d = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.resultError
});
const $674906c2a738886a$export$49f5dec896c355cd = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.requestId
});
const $674906c2a738886a$export$944245f24d4ef0b6 = (0, $9zUhf.createStateHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.traceId
});
const $674906c2a738886a$export$4dface15d86304a4 = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.isLoading
});
const $674906c2a738886a$export$f59185497e80e274 = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.resultsSort
});
const $674906c2a738886a$export$e2d0c00df99a687c = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.queryVersion
});
const $674906c2a738886a$export$5f38673942a99ffe = (0, $9zUhf.createStateHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.allFilterExcludedProducts
});
const $674906c2a738886a$export$3bc2682926916b14 = (0, $9zUhf.createStateHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.wasContentClearedBySpaceChange
});
const $674906c2a738886a$export$1e51d2073b60bd88 = (0, $9zUhf.createStateHook)($674906c2a738886a$var$Store, {
    selector: (0, $cclHy.createSelector)([
        (state)=>state.results,
        (state)=>state.isLoading,
        (state)=>state.resultError
    ], (results, isLoading, resultError)=>$674906c2a738886a$export$71923aa45c7aa566({
            results: results,
            isLoading: isLoading,
            resultError: resultError
        }))
});
const $674906c2a738886a$export$71923aa45c7aa566 = ({ results: results, isLoading: isLoading, resultError: resultError })=>{
    if (isLoading) return (0, $fZ3l2.ResultsStates).IS_LOADING;
    if (results && results.edges && results.edges.length > 0) return (0, $fZ3l2.ResultsStates).RESULTS;
    // If there are no entities for a query, an error will throw
    // when no entities for query is equivalent to no results
    if (resultError instanceof (0, $ff3b77c829810981$export$8ba86dff7c04c14c) || results && (results.edges ?? []).length === 0) return (0, $fZ3l2.ResultsStates).NO_RESULTS;
    if (resultError) return (0, $fZ3l2.ResultsStates).ERROR;
    if (!results) return (0, $fZ3l2.ResultsStates).INITIAL;
    return (0, $fZ3l2.ResultsStates).ERROR;
};
const $674906c2a738886a$export$826bdf756a8bf13a = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.selectedProducts
});
const $674906c2a738886a$export$387e1da2bc9c93cc = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.selectedProducts[0]
});
const $674906c2a738886a$export$e87eda20cc6e50c2 = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.selectedDatasource
});
const $674906c2a738886a$export$8c11ef422551818 = (0, $9zUhf.createStateHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.isJiraHydrationLoading
});
const $674906c2a738886a$export$795623048d841bf2 = (0, $9zUhf.createStateHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.isCompassTeamsLoading
});
const $674906c2a738886a$export$8dc083eb9766b48 = (0, $9zUhf.createStateHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.availableProducts && state.availableProducts.length > 0
});
const $674906c2a738886a$export$e80788222dba30a3 = (0, $9zUhf.createStateHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.results?.pageInfo?.endCursor
});
const $674906c2a738886a$export$bedf78a7ab879711 = (0, $9zUhf.createStateHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.paginationTokens[0]?.cursor
});
const $674906c2a738886a$export$f258398dab7c75ba = (0, $9zUhf.createStateHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.isLoadingMore
});
const $674906c2a738886a$export$964e8498268f0fe3 = (0, $9zUhf.createStateHook)($674906c2a738886a$var$Store, {
    selector: (0, $cclHy.createSelector)([
        (state)=>state.selectedProducts,
        (state)=>state.availableProducts
    ], (selectedProducts, availableProducts)=>{
        return {
            selectedProduct: selectedProducts[0],
            filteredProducts: selectedProducts[0] ? [
                selectedProducts[0]
            ] : availableProducts,
            availableProducts: availableProducts
        };
    })
});
const $674906c2a738886a$export$59086fbf0d8f8d2a = (0, $9zUhf.createStateHook)($674906c2a738886a$var$Store, {
    selector: (0, $cclHy.createSelector)([
        (state)=>state.availableProducts,
        (state)=>state.selectedProducts,
        (state)=>state.allFilterExcludedProducts,
        (state)=>state.filters[0, $5iakG.universalTypeFilterId],
        (_, props)=>props
    ], (availableProducts, selectedProducts, allFilterExcludedProducts, typeFilter, props)=>{
        const { thirdPartyConfigs: thirdPartyConfigs } = props;
        // Filter out excluded products from "All" filter
        const allFilterIncludedProducts = availableProducts.filter((product)=>!allFilterExcludedProducts.includes(product));
        const productsToSearch = selectedProducts[0] ? [
            selectedProducts[0]
        ] : allFilterIncludedProducts;
        return (0, $jyecU.getUniversalTypeEntities)(productsToSearch, typeFilter, thirdPartyConfigs, availableProducts, selectedProducts);
    })
});
const $674906c2a738886a$export$aad641f503e4b4a8 = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state, props)=>{
        const filter = state.filters[props.filterId];
        if (filter === undefined) return undefined;
        if (!(filter.type === 'multi-select' || filter.type === 'single-select')) throw new Error('Not a select filter');
        return {
            ...filter,
            selectedProducts: state.selectedProducts,
            availableProducts: state.availableProducts,
            allFilterExcludedProducts: state.allFilterExcludedProducts,
            primaryProduct: state.primaryProduct,
            experience: state.experience
        };
    }
});
const $674906c2a738886a$export$c724ec2cbd2fedce = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state, props)=>{
        const filter = state.filters[props.filterId];
        if (filter === undefined) return undefined;
        if (filter?.type !== 'boolean') throw new Error('Not a boolean filter');
        return {
            ...filter,
            selectedProducts: state.selectedProducts,
            primaryProduct: state.primaryProduct
        };
    }
});
const $674906c2a738886a$export$1c5018e1c1ce99ae = (filters)=>{
    const filterIdOrdering = (0, $5iakG.getFilterIdOrdering)();
    return filterIdOrdering.flatMap((f)=>{
        const filter = filters[f];
        return filter && filter.universal ? [
            filter
        ] : [];
    });
};
const $674906c2a738886a$export$546f6564ce5d0a17 = (filters, primaryProduct)=>{
    const filterIdOrdering = (0, $5iakG.getFilterIdOrdering)();
    return filterIdOrdering.flatMap((f)=>{
        const filter = filters[f];
        return filter && filter.products.find((relevantProductFilter)=>relevantProductFilter === primaryProduct) ? [
            filter
        ] : [];
    });
};
const $674906c2a738886a$export$a8734449e402b6ca = (filters, selectedProducts)=>{
    const filterIdOrdering = (0, $5iakG.getFilterIdOrdering)();
    return filterIdOrdering.flatMap((f)=>{
        const filter = filters[f];
        // Universal filters should always be shown for forge connectors
        // This is needed because forge connectors are dynamically loaded and not in the static products list
        if (filter && filter.universal && selectedProducts.some((0, $9d9t8.isForgeConnectorProductKey))) return [
            filter
        ];
        if (filter && f === 'content' && selectedProducts.includes((0, $b4tvS.ProductKeys).ConfluenceDC)) return (0, $dh538.fg)('confluence-dc-content-filter') ? [
            filter
        ] : [];
        else return filter && selectedProducts.some((product)=>filter?.products.includes(product)) ? [
            filter
        ] : [];
    });
};
/**
 * All available filters in the initial ordering
 * Configurable based on the primary product - this is the case for QF filters
 */ const $674906c2a738886a$var$getAllAvailableFilters = (filters, selectedProducts, config)=>{
    if (config?.basedOnPrimaryProduct && config?.primaryProduct) return (0, $b4tDU.isAllProductSearch)(selectedProducts) ? $674906c2a738886a$export$546f6564ce5d0a17(filters, config?.primaryProduct) : $674906c2a738886a$export$a8734449e402b6ca(filters, selectedProducts);
    return (0, $b4tDU.isAllProductSearch)(selectedProducts) ? $674906c2a738886a$export$1c5018e1c1ce99ae(filters) : $674906c2a738886a$export$a8734449e402b6ca(filters, selectedProducts);
};
/**
 * All available filters are always returned for inline, but the ordering depends on selection
 * The caller UI is responsible for deciding how many can be rendered by available width
 */ const $674906c2a738886a$var$getFilterIdsForInline = (filters, selectedProducts, filterSelectionOrder, config)=>{
    const allAvailableFilterIds = $674906c2a738886a$var$getAllAvailableFilters(filters, selectedProducts, config).map((a)=>a.id);
    // using the selection order, filter from the available (removes any invalid filters to show)
    const filtersForInline = filterSelectionOrder.filter((f)=>allAvailableFilterIds.includes(f));
    // Filters with no selections can also be prioritised based on the props
    const filtersPrioritised = config?.prioritisedFilterIds?.filter((f)=>allAvailableFilterIds.includes(f)) ?? [];
    // then simply add the rest back (with a set for deduplication)
    return [
        ...new Set([
            ...filtersForInline,
            ...filtersPrioritised,
            ...allAvailableFilterIds
        ])
    ];
};
const $674906c2a738886a$export$94c94f88577d66b2 = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: ({ filters: filters, selectedProducts: selectedProducts, filterSelectionOrder: filterSelectionOrder }, config)=>{
        // Apply exclusion + inclusion rules (single source of truth for filter visibility):
        // excluded filters are hidden from both the inline filter row and the dropdown list.
        // setSearchStoreState clears their underlying selection in the same write so the store
        // stays in sync with what is visible/applied to URL/GraphQL/badge count.
        const excludedFilterIds = (0, $08c2ec3bf9b8f8f3$export$8848759bd942e213)(selectedProducts[0], filters);
        const isExcluded = (id)=>excludedFilterIds.has(id);
        // All filters always show in the dropdown, in order (minus excluded)
        const filtersInDropdown = $674906c2a738886a$var$getAllAvailableFilters(filters, selectedProducts, config).map((f)=>f.id).filter((id)=>!isExcluded(id));
        const filtersInLine = $674906c2a738886a$var$getFilterIdsForInline(filters, selectedProducts, filterSelectionOrder, config).filter((id)=>!isExcluded(id));
        return {
            filtersInDropdown: filtersInDropdown,
            filtersInLine: filtersInLine,
            filterSelectionOrder: filterSelectionOrder
        };
    }
});
const $674906c2a738886a$export$754cc306c2d9241e = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: ({ selectedProducts: selectedProducts, filters: filters, resultsSort: resultsSort })=>{
        // Apply exclusion + inclusion rules (single source of truth for filter visibility):
        // excluded filters do not contribute to the badge count. setSearchStoreState
        // clears their underlying selection so the store stays in sync.
        const excludedFilterIds = (0, $08c2ec3bf9b8f8f3$export$8848759bd942e213)(selectedProducts[0], filters);
        const selectedFilters = Object.values(filters).filter((filter)=>filter?.hasSelection).filter((filter)=>filter && !excludedFilterIds.has(filter.id)).filter((filter)=>{
            const isAtlasSelected = selectedProducts.includes((0, $b4tvS.ProductKeys).Atlas);
            const isTypeFilter = filter?.id === (0, $5iakG.universalTypeFilterId);
            if ((0, $2OtFZ.serveWebPagesInTypeFilter)()) // Subtract 1 from selectedFilterCount when Atlas OR WebCrawler is selected as one of the
            // filters won't be displayed to the user
            return !isTypeFilter ? true : !selectedProducts.includes((0, $b4tvS.ProductKeys).Atlas) && !selectedProducts.includes((0, $b4tvS.ProductKeys).AtlassianWebCrawler);
            return isAtlasSelected ? !isTypeFilter : true;
        });
        const { field: field } = resultsSort;
        const isNotSortedByDefault = field !== (0, $2zuvB.SORT_FIELD_KEY).RELEVANCE;
        return {
            selectedFilterCount: selectedFilters.length + (isNotSortedByDefault ? 1 : 0)
        };
    }
});
const $674906c2a738886a$export$a63314038bf0cbf9 = (0, $9zUhf.createStateHook)($674906c2a738886a$var$Store, {
    selector: ({ filters: filters })=>{
        const filterAttributes = Object.values(filters).flatMap((filter)=>{
            return filter ? [
                filter
            ] : [];
        }).map((filter)=>{
            const filterType = filter.type;
            switch(filterType){
                case 'boolean':
                    return {
                        filters: [
                            filter.id
                        ],
                        filterSelections: filter.value ? [
                            {
                                value: String(filter.value),
                                isSmartDefault: false,
                                filterId: filter.id
                            }
                        ] : []
                    };
                case 'multi-select':
                case 'single-select':
                    return {
                        filters: [
                            filter.id
                        ],
                        filterSelections: filter.options.filter((filterOption)=>filterOption.isSelected).map((filterOption)=>({
                                value: filterOption.trackingKey || filterOption.value,
                                isSmartDefault: filterOption.isSuggested,
                                filterId: filter.id
                            }))
                    };
                default:
                    return filterType;
            }
        }).filter((attributes)=>attributes.filterSelections.length).reduce((acc, curr)=>{
            return {
                filters: [
                    ...acc.filters,
                    ...curr.filters
                ],
                filterSelections: [
                    ...acc.filterSelections,
                    ...curr.filterSelections
                ]
            };
        }, {
            filters: [],
            filterSelections: []
        });
        return filterAttributes;
    }
});
const $674906c2a738886a$export$33ca33de08a5b6bb = (0, $9zUhf.createStateHook)($674906c2a738886a$var$Store, {
    selector: ({ cql: cql })=>cql
});
const $674906c2a738886a$export$210935c1afa2c65c = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: ({ selectedProducts: selectedProducts, filters: filters }, props = {
        includeSelectedProduct: true
    })=>{
        const hasSelectedProduct = selectedProducts[0];
        if (hasSelectedProduct && props.includeSelectedProduct) return true;
        return Object.values(filters).some((filter)=>filter?.hasSelection);
    }
});
const $674906c2a738886a$export$1f88edaa1bb97b87 = (0, $9zUhf.createStateHook)($674906c2a738886a$var$Store, {
    selector: ({ leapQuery: leapQuery })=>leapQuery
});
const $674906c2a738886a$export$64ea42df9468ccc0 = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>({
            backendExperiments: state.requestedBackendExperiments
        })
});
const $674906c2a738886a$export$5ce42807c47ad171 = (0, $9zUhf.createStateHook)($674906c2a738886a$var$Store, {
    selector: (state)=>state.jsmIncidentFilterIds
});
const $674906c2a738886a$export$fce7b0e4e0dda8ee = (0, $9zUhf.createHook)($674906c2a738886a$var$Store, {
    selector: (state)=>{
        return state.filterDropdownOpenByQueryParam;
    }
});
module.exports["initialState"] = $674906c2a738886a$export$d4c72bab9d6cc13a;
module.exports["SearchStoreContainer"] = $674906c2a738886a$export$bf072992274c9fb;
module.exports["useSearch"] = $674906c2a738886a$export$bd221a7c56b93941;
module.exports["useSearchActions"] = $674906c2a738886a$export$c5a5afdff2ff0385;
module.exports["useSearchState"] = $674906c2a738886a$export$5fd14fa624074d55;
module.exports["useFilters"] = $674906c2a738886a$export$973ca22476b0e05f;
module.exports["useInputQuery"] = $674906c2a738886a$export$da992673b1309795;
module.exports["useSearchExperience"] = $674906c2a738886a$export$59d1399255ff1d16;
module.exports["useSearchQuery"] = $674906c2a738886a$export$e985158d10c27e34;
module.exports["useRetryCount"] = $674906c2a738886a$export$140d37088821fcb1;
module.exports["useQueryUpdatedTime"] = $674906c2a738886a$export$a2b38489a4538322;
module.exports["useResults"] = $674906c2a738886a$export$bda9ac73817ceec3;
module.exports["useResultsError"] = $674906c2a738886a$export$1c9622ace43d770d;
module.exports["useResultsRequestId"] = $674906c2a738886a$export$49f5dec896c355cd;
module.exports["useIsLoading"] = $674906c2a738886a$export$4dface15d86304a4;
module.exports["useResultsSort"] = $674906c2a738886a$export$f59185497e80e274;
module.exports["useQueryVersion"] = $674906c2a738886a$export$e2d0c00df99a687c;
module.exports["useWasContentClearedBySpaceChange"] = $674906c2a738886a$export$3bc2682926916b14;
module.exports["useResultsState"] = $674906c2a738886a$export$1e51d2073b60bd88;
module.exports["useSelectedProducts"] = $674906c2a738886a$export$826bdf756a8bf13a;
module.exports["useSelectedProduct"] = $674906c2a738886a$export$387e1da2bc9c93cc;
module.exports["useSelectedDatasource"] = $674906c2a738886a$export$e87eda20cc6e50c2;
module.exports["useIsJiraHydrationLoading"] = $674906c2a738886a$export$8c11ef422551818;
module.exports["useIsSearchReady"] = $674906c2a738886a$export$8dc083eb9766b48;
module.exports["useTypeEntities"] = $674906c2a738886a$export$59086fbf0d8f8d2a;
module.exports["useSelectFilterStore"] = $674906c2a738886a$export$aad641f503e4b4a8;
module.exports["useBooleanFilterStore"] = $674906c2a738886a$export$c724ec2cbd2fedce;
module.exports["useFiltersToDisplay"] = $674906c2a738886a$export$94c94f88577d66b2;
module.exports["useSelectedFilterCount"] = $674906c2a738886a$export$754cc306c2d9241e;
module.exports["useFilterAttributesForTracking"] = $674906c2a738886a$export$a63314038bf0cbf9;
module.exports["useCQL"] = $674906c2a738886a$export$33ca33de08a5b6bb;
module.exports["useAnyFilterSelected"] = $674906c2a738886a$export$210935c1afa2c65c;
module.exports["useRequestedBackendExperiments"] = $674906c2a738886a$export$64ea42df9468ccc0;
module.exports["useJsmIncidentFilterIds"] = $674906c2a738886a$export$5ce42807c47ad171;
module.exports["useFilterDropdownOpenByQueryParam"] = $674906c2a738886a$export$fce7b0e4e0dda8ee;

});

parcelRegister("2zuvB", function(module, exports) {
const $46c1a866454c924b$export$fdf34174678f07b6 = {
    RELEVANCE: 'relevance',
    LAST_MODIFIED_DATE: 'latestModifiedDate',
    CREATED_DATE: 'createdDate'
};
const $46c1a866454c924b$export$d33cb9b119034d29 = {
    ASC: 'ASC',
    DESC: 'DESC'
};
const $46c1a866454c924b$var$SORT_FIELD_KEY_RELEVANCE_DESC = `${$46c1a866454c924b$export$fdf34174678f07b6.RELEVANCE}${$46c1a866454c924b$export$d33cb9b119034d29.DESC}`;
const $46c1a866454c924b$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_DESC = `${$46c1a866454c924b$export$fdf34174678f07b6.LAST_MODIFIED_DATE}${$46c1a866454c924b$export$d33cb9b119034d29.DESC}`;
const $46c1a866454c924b$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_ASC = `${$46c1a866454c924b$export$fdf34174678f07b6.LAST_MODIFIED_DATE}${$46c1a866454c924b$export$d33cb9b119034d29.ASC}`;
const $46c1a866454c924b$var$SORT_FIELD_KEY_CREATED_DATE_DESC = `${$46c1a866454c924b$export$fdf34174678f07b6.CREATED_DATE}${$46c1a866454c924b$export$d33cb9b119034d29.DESC}`;
const $46c1a866454c924b$var$SORT_FIELD_KEY_CREATED_DATE_ASC = `${$46c1a866454c924b$export$fdf34174678f07b6.CREATED_DATE}${$46c1a866454c924b$export$d33cb9b119034d29.ASC}`;
const $46c1a866454c924b$export$6b492fdcc7e8d1f4 = {
    [$46c1a866454c924b$var$SORT_FIELD_KEY_RELEVANCE_DESC]: {
        field: $46c1a866454c924b$export$fdf34174678f07b6.RELEVANCE,
        order: $46c1a866454c924b$export$d33cb9b119034d29.DESC,
        labelKey: $46c1a866454c924b$var$SORT_FIELD_KEY_RELEVANCE_DESC,
        selectedLabelKey: `${$46c1a866454c924b$var$SORT_FIELD_KEY_RELEVANCE_DESC}Selected`,
        drawerOrder: 0
    },
    [$46c1a866454c924b$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_DESC]: {
        field: $46c1a866454c924b$export$fdf34174678f07b6.LAST_MODIFIED_DATE,
        order: $46c1a866454c924b$export$d33cb9b119034d29.DESC,
        labelKey: $46c1a866454c924b$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_DESC,
        selectedLabelKey: `${$46c1a866454c924b$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_DESC}Selected`,
        drawerOrder: 1
    },
    [$46c1a866454c924b$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_ASC]: {
        field: $46c1a866454c924b$export$fdf34174678f07b6.LAST_MODIFIED_DATE,
        order: $46c1a866454c924b$export$d33cb9b119034d29.ASC,
        labelKey: $46c1a866454c924b$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_ASC,
        selectedLabelKey: `${$46c1a866454c924b$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_ASC}Selected`,
        drawerOrder: 2
    },
    [$46c1a866454c924b$var$SORT_FIELD_KEY_CREATED_DATE_DESC]: {
        field: $46c1a866454c924b$export$fdf34174678f07b6.CREATED_DATE,
        order: $46c1a866454c924b$export$d33cb9b119034d29.DESC,
        labelKey: $46c1a866454c924b$var$SORT_FIELD_KEY_CREATED_DATE_DESC,
        selectedLabelKey: `${$46c1a866454c924b$var$SORT_FIELD_KEY_CREATED_DATE_DESC}Selected`,
        drawerOrder: 3
    },
    [$46c1a866454c924b$var$SORT_FIELD_KEY_CREATED_DATE_ASC]: {
        field: $46c1a866454c924b$export$fdf34174678f07b6.CREATED_DATE,
        order: $46c1a866454c924b$export$d33cb9b119034d29.ASC,
        labelKey: $46c1a866454c924b$var$SORT_FIELD_KEY_CREATED_DATE_ASC,
        selectedLabelKey: `${$46c1a866454c924b$var$SORT_FIELD_KEY_CREATED_DATE_ASC}Selected`,
        drawerOrder: 4
    }
};
const $46c1a866454c924b$export$76673e1b214c1378 = Object.values($46c1a866454c924b$export$6b492fdcc7e8d1f4).sort((a, b)=>a.drawerOrder - b.drawerOrder);
const $46c1a866454c924b$export$d3cbda30e53df6f6 = (field, order)=>`${field}${order}`;
module.exports["SORT_FIELD_KEY"] = $46c1a866454c924b$export$fdf34174678f07b6;
module.exports["SORT_ORDER"] = $46c1a866454c924b$export$d33cb9b119034d29;
module.exports["RESULTS_SORT_FIELDS"] = $46c1a866454c924b$export$6b492fdcc7e8d1f4;

});

parcelRegister("fZ3l2", function(module, exports) {
const $c3268331ff3eb240$export$cdcda2a8fcb980fa = {
    NO_RESULTS: 'noResults',
    INITIAL: 'initial',
    RESULTS: 'results',
    ERROR: 'error',
    IS_LOADING: 'isLoading'
};
module.exports["ResultsStates"] = $c3268331ff3eb240$export$cdcda2a8fcb980fa;

});

parcelRegister("fUcm0", function(module, exports) {

var $eMqrF = parcelRequire("eMqrF");


var $iBY5n = parcelRequire("iBY5n");

const $5c084a67f28eba8a$export$e8eac31981efe1fb = (ari)=>{
    let teamId = null;
    if (!ari) return teamId;
    const isTeamsAri = (0, $iBY5n.TeamsTeamAri).check(ari);
    const isIdentityTeamsAri = (0, $eMqrF.IdentityTeamAri).check(ari);
    if (isTeamsAri) teamId = (0, $iBY5n.TeamsTeamAri).parse(ari).teamId;
    else if (isIdentityTeamsAri) teamId = (0, $eMqrF.IdentityTeamAri).parse(ari).teamId;
    if (teamId === 'unidentified') teamId = null;
    return teamId;
};
module.exports["getTeamId"] = $5c084a67f28eba8a$export$e8eac31981efe1fb;

});

parcelRegister("dOOW1", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $dh538 = parcelRequire("dh538");


var $dcbm4 = parcelRequire("dcbm4");


var $2Znam = parcelRequire("2Znam");


var $b4tvS = parcelRequire("b4tvS");


var $9d9t8 = parcelRequire("9d9t8");


var $7oQyb = parcelRequire("7oQyb");


var $2OtFZ = parcelRequire("2OtFZ");

/**
 * Gets 3P products that support a given filter, using the consolidated
 * ThirdPartyConfigs from rovo-connectors-config.
 *
 * This is intentionally in a separate file from filters/index.ts to avoid
 * pulling the 3P configs (and their icon-laden config files) into the
 * generateSearchInputs bundle. This file is only imported by UI filter
 * components, not by the generateSearchInputs call path.
 */ 
var $a5RR2 = parcelRequire("a5RR2");

const $779a23dd67a96bae$export$ef6dfb919b1d7267 = (filterId)=>{
    const productsForFilter = [];
    (0, $a5RR2.ThirdPartyConfigsSync).forEach((config, productKey3P)=>{
        if (config.filters?.includes(filterId)) productsForFilter.push(productKey3P);
    });
    return productsForFilter;
};


/**
 * Static integration ARI mapping extracted for SSR bundle isolation.
 * No icon, config, or React imports — just pure string constants.
 *
 * This replaces the dynamic getIntegrationARIsFromConfig() function which
 * iterated ThirdPartyConfigs (pulling in 66 icon-laden config files).
 *
 * The baseIntegrationARIs map is the single source of truth for
 * ProductKey → integration ARI mappings. filters/index.ts imports and
 * re-exports from here.
 */ 


// 3P Integration ARIs
const $62eb2e94deff5767$var$GOOGLE_INTEGRATION_ARI = 'ari:cloud:platform::integration/google';
const $62eb2e94deff5767$var$MICROSOFT_INTEGRATION_ARI = 'ari:cloud:platform::integration/microsoft';
const $62eb2e94deff5767$var$WEB_CRAWLER_INTEGRATION_ARI = 'ari:cloud:platform::integration/atlassian-web-crawler';
const $62eb2e94deff5767$var$GITHUB_INTEGRATION_ARI = 'ari:cloud:platform::integration/github';
const $62eb2e94deff5767$var$FIGMA_INTEGRATION_ARI = 'ari:cloud:platform::integration/figma';
const $62eb2e94deff5767$var$LOOM_INTEGRATION_ARI = 'ari:cloud:platform::integration/loom';
const $62eb2e94deff5767$var$DROPBOX_INTEGRATION_ARI = 'ari:cloud:platform::integration/dropbox';
const $62eb2e94deff5767$var$AIRTABLE_INTEGRATION_ARI = 'ari:cloud:platform::integration/airtable';
const $62eb2e94deff5767$var$SMARTSHEET_INTEGRATION_ARI = 'ari:cloud:platform::integration/smartsheet';
const $62eb2e94deff5767$var$BITBUCKET_INTEGRATION_ARI = 'ari:cloud:platform::integration/bitbucket';
const $62eb2e94deff5767$var$NOTION_INTEGRATION_ARI = 'ari:cloud:platform::integration/notion';
const $62eb2e94deff5767$var$MIRO_INTEGRATION_ARI = 'ari:cloud:platform::integration/miro';
const $62eb2e94deff5767$var$ZENDESK_INTEGRATION_ARI = 'ari:cloud:platform::integration/zendesk';
const $62eb2e94deff5767$var$DOCUSIGN_INTEGRATION_ARI = 'ari:cloud:platform::integration/docusign';
const $62eb2e94deff5767$var$LUCID_INTEGRATION_ARI = 'ari:cloud:platform::integration/lucid';
const $62eb2e94deff5767$var$MONDAY_INTEGRATION_ARI = 'ari:cloud:platform::integration/monday';
const $62eb2e94deff5767$var$AZURE_DEVOPS_INTEGRATION_ARI = 'ari:cloud:platform::integration/azure-devops';
const $62eb2e94deff5767$var$GITLAB_INTEGRATION_ARI = 'ari:cloud:platform::integration/gitlab';
const $62eb2e94deff5767$var$CONFLUENCE_DC_INTEGRATION_ARI = 'ari:cloud:platform::integration/confluence-dc';
const $62eb2e94deff5767$var$CANVA_INTEGRATION_ARI = 'ari:cloud:platform::integration/canva';
const $62eb2e94deff5767$var$ASANA_INTEGRATION_ARI = 'ari:cloud:platform::integration/asana';
const $62eb2e94deff5767$var$BOX_INTEGRATION_ARI = 'ari:cloud:platform::integration/box';
const $62eb2e94deff5767$var$ZEPLIN_INTEGRATION_ARI = 'ari:cloud:platform::integration/zeplin';
const $62eb2e94deff5767$var$SERVICENOW_INTEGRATION_ARI = 'ari:cloud:platform::integration/servicenow';
const $62eb2e94deff5767$var$FRESHSERVICE_INTEGRATION_ARI = 'ari:cloud:platform::integration/freshservice';
const $62eb2e94deff5767$var$CLICKUP_INTEGRATION_ARI = 'ari:cloud:platform::integration/clickup';
const $62eb2e94deff5767$var$AMPLITUDE_INTEGRATION_ARI = 'ari:cloud:platform::integration/amplitude';
const $62eb2e94deff5767$var$STRIPE_INTEGRATION_ARI = 'ari:cloud:platform::integration/stripe';
const $62eb2e94deff5767$var$ADOBE_INTEGRATION_ARI = 'ari:cloud:platform::integration/adobe';
const $62eb2e94deff5767$var$AHA_INTEGRATION_ARI = 'ari:cloud:platform::integration/aha';
const $62eb2e94deff5767$var$MURAL_INTEGRATION_ARI = 'ari:cloud:platform::integration/mural';
const $62eb2e94deff5767$var$WEBEX_INTEGRATION_ARI = 'ari:cloud:platform::integration/cisco';
const $62eb2e94deff5767$var$TODOIST_INTEGRATION_ARI = 'ari:cloud:platform::integration/todoist';
const $62eb2e94deff5767$var$PAGERDUTY_INTEGRATION_ARI = 'ari:cloud:platform::integration/pagerduty';
const $62eb2e94deff5767$var$PIPEDRIVE_INTEGRATION_ARI = 'ari:cloud:platform::integration/pipedrive';
const $62eb2e94deff5767$var$HUBSPOT_INTEGRATION_ARI = 'ari:cloud:platform::integration/hubspot';
const $62eb2e94deff5767$var$DOVETAIL_INTEGRATION_ARI = 'ari:cloud:platform::integration/dovetail';
const $62eb2e94deff5767$var$LAUNCHDARKLY_INTEGRATION_ARI = 'ari:cloud:platform::integration/launchdarkly';
const $62eb2e94deff5767$var$SALESFORCE_INTEGRATION_ARI = 'ari:cloud:platform::integration/salesforce';
const $62eb2e94deff5767$var$SENTRY_INTEGRATION_ARI = 'ari:cloud:platform::integration/sentry';
const $62eb2e94deff5767$var$JIRA_DC_INTEGRATION_ARI = 'ari:cloud:platform::integration/jira-dc';
const $62eb2e94deff5767$var$GITBOOK_INTEGRATION_ARI = 'ari:cloud:platform::integration/graph-test-app';
const $62eb2e94deff5767$var$DATABRICKS_INTEGRATION_ARI = 'ari:cloud:platform::integration/databricks';
// Forge Integration ARIs
const $62eb2e94deff5767$var$FORGE_ADAM_VITAREQ_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/dAkghOClvWGokDftTTaIgNoD6pnNt74z';
const $62eb2e94deff5767$var$FORGE_ADAM_VITAREQ_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93';
const $62eb2e94deff5767$var$FORGE_K15T_SCROLL_SITES_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/h1n3NRFAn84v7ECSONVidlCS88qZh8cy';
const $62eb2e94deff5767$var$FORGE_K15T_SCROLL_SITES_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/ofe9zXccOCQ3U4t4kDVywSyJUoZjb1sO';
const $62eb2e94deff5767$var$FORGE_PIO_AWS_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/HaxJprV0zzjjvwLhGkAN2gDPhHZwXNiL';
const $62eb2e94deff5767$var$FORGE_PIO_AWS_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/mRcqWRwqkUd4JwapGkvGHUViyySX9MVy';
const $62eb2e94deff5767$var$FORGE_PIO_CLICKUP_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY';
const $62eb2e94deff5767$var$FORGE_PIO_CLICKUP_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K';
const $62eb2e94deff5767$var$FORGE_PIO_GITBOOK_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi';
const $62eb2e94deff5767$var$FORGE_PIO_GITBOOK_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u';
const $62eb2e94deff5767$var$FORGE_PIO_GITHUB_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/3QYYBgeNDilQB3Jc7uGMCchNgUGvCi7j';
const $62eb2e94deff5767$var$FORGE_PIO_GITHUB_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/0Sw5Yr860fgfx5sYS7kEUoxnGhEvrhhI';
const $62eb2e94deff5767$var$FORGE_PIO_GITLAB_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/psr1wBkasRuKCwsvwi4aTJNhjmlVFebC';
const $62eb2e94deff5767$var$FORGE_PIO_GITLAB_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/QLK5Xf8nBqejSZTulw5s3Cl6fIS24MwL';
const $62eb2e94deff5767$var$FORGE_PIO_GOOGLE_DRIVE_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq';
const $62eb2e94deff5767$var$FORGE_PIO_GOOGLE_DRIVE_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/pcIwW04B398CSnilRIyzPJ5v5GevlCCo';
const $62eb2e94deff5767$var$FORGE_PIO_GURU_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5';
const $62eb2e94deff5767$var$FORGE_PIO_GURU_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29';
const $62eb2e94deff5767$var$FORGE_PIO_HELPJUICE_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC';
const $62eb2e94deff5767$var$FORGE_PIO_HELPJUICE_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/8durapLyclxZeEexKkwxw6ZpCRpBz4dP';
const $62eb2e94deff5767$var$FORGE_PIO_HUBSPOT_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF';
const $62eb2e94deff5767$var$FORGE_PIO_HUBSPOT_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J';
const $62eb2e94deff5767$var$FORGE_PIO_SALESFORCE_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/50BYkfgS4GXtr6iO8qUeBFbbHHbuFleo';
const $62eb2e94deff5767$var$FORGE_PIO_SALESFORCE_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/nn5lJU1KJxJsUNML5GWV3blDYHMT6nAb';
const $62eb2e94deff5767$var$FORGE_PIO_SHAREPOINT_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/cl5i3J8L463hTuQiDt7f1mK4vZllsAo0';
const $62eb2e94deff5767$var$FORGE_PIO_SHAREPOINT_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/7yrzYPlAOcZAif2tIymeDXBUNUAxI95G';
const $62eb2e94deff5767$var$FORGE_PIO_STACK_OVERFLOW_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3';
const $62eb2e94deff5767$var$FORGE_PIO_STACK_OVERFLOW_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS';
const $62eb2e94deff5767$var$FORGE_UTOOLITY_GITBOOK_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5';
const $62eb2e94deff5767$var$FORGE_UTOOLITY_GITBOOK_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS';
const $62eb2e94deff5767$var$FORGE_GDRIVE_EUGENE_TEST_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/s7M8FnmJVPQh9FtRqvqwSL3QFtqMijua';
const $62eb2e94deff5767$var$FORGE_GDRIVE_EUGENE_TEST_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/bkRlqLiPfviKrVtbA6Q0QGN22x6b37mf';
const $62eb2e94deff5767$export$d82a82f2333502ad = {
    [(0, $7oQyb.ProductKey).GoogleDrive]: $62eb2e94deff5767$var$GOOGLE_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Sharepoint]: $62eb2e94deff5767$var$MICROSOFT_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).AtlassianWebCrawler]: $62eb2e94deff5767$var$WEB_CRAWLER_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Teams]: $62eb2e94deff5767$var$MICROSOFT_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Figma]: $62eb2e94deff5767$var$FIGMA_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Gitbook]: $62eb2e94deff5767$var$GITBOOK_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Loom]: $62eb2e94deff5767$var$LOOM_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).OneDrive]: $62eb2e94deff5767$var$MICROSOFT_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Github]: $62eb2e94deff5767$var$GITHUB_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Bitbucket]: $62eb2e94deff5767$var$BITBUCKET_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Airtable]: $62eb2e94deff5767$var$AIRTABLE_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Smartsheet]: $62eb2e94deff5767$var$SMARTSHEET_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Notion]: $62eb2e94deff5767$var$NOTION_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Miro]: $62eb2e94deff5767$var$MIRO_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Zendesk]: $62eb2e94deff5767$var$ZENDESK_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Docusign]: $62eb2e94deff5767$var$DOCUSIGN_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Lucid]: $62eb2e94deff5767$var$LUCID_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Monday]: $62eb2e94deff5767$var$MONDAY_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).AzureDevops]: $62eb2e94deff5767$var$AZURE_DEVOPS_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Gitlab]: $62eb2e94deff5767$var$GITLAB_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ConfluenceDC]: $62eb2e94deff5767$var$CONFLUENCE_DC_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Canva]: $62eb2e94deff5767$var$CANVA_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).OutlookCalendar]: $62eb2e94deff5767$var$MICROSOFT_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Asana]: $62eb2e94deff5767$var$ASANA_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Zeplin]: $62eb2e94deff5767$var$ZEPLIN_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ServiceNow]: $62eb2e94deff5767$var$SERVICENOW_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Freshservice]: $62eb2e94deff5767$var$FRESHSERVICE_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).PowerBI]: $62eb2e94deff5767$var$MICROSOFT_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ClickUp]: $62eb2e94deff5767$var$CLICKUP_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Amplitude]: $62eb2e94deff5767$var$AMPLITUDE_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Stripe]: $62eb2e94deff5767$var$STRIPE_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).AdobeXD]: $62eb2e94deff5767$var$ADOBE_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Aha]: $62eb2e94deff5767$var$AHA_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).AdobeSign]: $62eb2e94deff5767$var$ADOBE_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Mural]: $62eb2e94deff5767$var$MURAL_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Webex]: $62eb2e94deff5767$var$WEBEX_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Todoist]: $62eb2e94deff5767$var$TODOIST_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).PagerDuty]: $62eb2e94deff5767$var$PAGERDUTY_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Pipedrive]: $62eb2e94deff5767$var$PIPEDRIVE_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Hubspot]: $62eb2e94deff5767$var$HUBSPOT_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Dovetail]: $62eb2e94deff5767$var$DOVETAIL_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).LaunchDarkly]: $62eb2e94deff5767$var$LAUNCHDARKLY_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Salesforce]: $62eb2e94deff5767$var$SALESFORCE_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Sentry]: $62eb2e94deff5767$var$SENTRY_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).JiraDC]: $62eb2e94deff5767$var$JIRA_DC_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).JsmDC]: $62eb2e94deff5767$var$JIRA_DC_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Box]: $62eb2e94deff5767$var$BOX_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Dropbox]: $62eb2e94deff5767$var$DROPBOX_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).GoogleCalendar]: $62eb2e94deff5767$var$GOOGLE_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Gmail]: $62eb2e94deff5767$var$GOOGLE_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Databricks]: $62eb2e94deff5767$var$DATABRICKS_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).AWSS3]: $62eb2e94deff5767$var$GITBOOK_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).OutlookMail]: $62eb2e94deff5767$var$MICROSOFT_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).Slack]: 'ari:cloud:platform::integration/slack',
    // Forge Products - Dev and Prod versions
    [(0, $7oQyb.ProductKey).ForgeAdamVitareqDev]: $62eb2e94deff5767$var$FORGE_ADAM_VITAREQ_DEV_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgeAdamVitareqProd]: $62eb2e94deff5767$var$FORGE_ADAM_VITAREQ_PROD_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgeK15tScrollSitesDev]: $62eb2e94deff5767$var$FORGE_K15T_SCROLL_SITES_DEV_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgeK15tScrollSitesProd]: $62eb2e94deff5767$var$FORGE_K15T_SCROLL_SITES_PROD_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioAwsDev]: $62eb2e94deff5767$var$FORGE_PIO_AWS_DEV_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioAwsProd]: $62eb2e94deff5767$var$FORGE_PIO_AWS_PROD_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioClickupDev]: $62eb2e94deff5767$var$FORGE_PIO_CLICKUP_DEV_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioClickupProd]: $62eb2e94deff5767$var$FORGE_PIO_CLICKUP_PROD_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioGitbookDev]: $62eb2e94deff5767$var$FORGE_PIO_GITBOOK_DEV_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioGitbookProd]: $62eb2e94deff5767$var$FORGE_PIO_GITBOOK_PROD_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioGithubDev]: $62eb2e94deff5767$var$FORGE_PIO_GITHUB_DEV_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioGithubProd]: $62eb2e94deff5767$var$FORGE_PIO_GITHUB_PROD_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioGitlabDev]: $62eb2e94deff5767$var$FORGE_PIO_GITLAB_DEV_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioGitlabProd]: $62eb2e94deff5767$var$FORGE_PIO_GITLAB_PROD_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioGoogleDriveDev]: $62eb2e94deff5767$var$FORGE_PIO_GOOGLE_DRIVE_DEV_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioGoogleDriveProd]: $62eb2e94deff5767$var$FORGE_PIO_GOOGLE_DRIVE_PROD_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioGuruDev]: $62eb2e94deff5767$var$FORGE_PIO_GURU_DEV_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioGuruProd]: $62eb2e94deff5767$var$FORGE_PIO_GURU_PROD_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioHelpjuiceDev]: $62eb2e94deff5767$var$FORGE_PIO_HELPJUICE_DEV_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioHelpjuiceProd]: $62eb2e94deff5767$var$FORGE_PIO_HELPJUICE_PROD_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioHubspotDev]: $62eb2e94deff5767$var$FORGE_PIO_HUBSPOT_DEV_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioHubspotProd]: $62eb2e94deff5767$var$FORGE_PIO_HUBSPOT_PROD_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioSalesforceDev]: $62eb2e94deff5767$var$FORGE_PIO_SALESFORCE_DEV_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioSalesforceProd]: $62eb2e94deff5767$var$FORGE_PIO_SALESFORCE_PROD_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioSharepointDev]: $62eb2e94deff5767$var$FORGE_PIO_SHAREPOINT_DEV_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioSharepointProd]: $62eb2e94deff5767$var$FORGE_PIO_SHAREPOINT_PROD_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioStackOverflowDev]: $62eb2e94deff5767$var$FORGE_PIO_STACK_OVERFLOW_DEV_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgePioStackOverflowProd]: $62eb2e94deff5767$var$FORGE_PIO_STACK_OVERFLOW_PROD_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgeUtoolityGitbookDev]: $62eb2e94deff5767$var$FORGE_UTOOLITY_GITBOOK_DEV_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgeUtoolityGitbookProd]: $62eb2e94deff5767$var$FORGE_UTOOLITY_GITBOOK_PROD_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgeGdriveEugeneTestDev]: $62eb2e94deff5767$var$FORGE_GDRIVE_EUGENE_TEST_DEV_INTEGRATION_ARI,
    [(0, $7oQyb.ProductKey).ForgeGdriveEugeneTestProd]: $62eb2e94deff5767$var$FORGE_GDRIVE_EUGENE_TEST_PROD_INTEGRATION_ARI
};
const $62eb2e94deff5767$var$FORGE_CONNECTOR_PREFIX = 'forge-connector-';
const $62eb2e94deff5767$export$530d1d49b6479256 = (productKey)=>{
    if (!productKey.startsWith($62eb2e94deff5767$var$FORGE_CONNECTOR_PREFIX)) return undefined;
    const withoutPrefix = productKey.slice($62eb2e94deff5767$var$FORGE_CONNECTOR_PREFIX.length);
    // Hash is everything before the first hyphen after the prefix
    const hyphenIndex = withoutPrefix.indexOf('-');
    if (hyphenIndex === -1) return undefined;
    const hash = withoutPrefix.slice(0, hyphenIndex);
    return `ari:cloud:platform::integration/${hash}`;
};
const $62eb2e94deff5767$export$3be99390ed5e95e2 = (productKey)=>{
    // Check static mapping first
    const staticAri = $62eb2e94deff5767$export$d82a82f2333502ad[productKey];
    if (staticAri !== undefined) return staticAri;
    // Fall back to Forge connector derivation
    return $62eb2e94deff5767$export$530d1d49b6479256(productKey);
};






const $a113941c76257cbc$var$DEFAULT_ENTITY_SUBTYPES = {
    [(0, $2Znam.TypeFilterValueKey).Document]: [
        (0, $2Znam.NounSubtypeKey).Document,
        (0, $2Znam.NounSubtypeKey).Pdf
    ],
    [(0, $2Znam.TypeFilterValueKey).Spreadsheet]: [
        (0, $2Znam.NounSubtypeKey).Spreadsheet
    ],
    [(0, $2Znam.TypeFilterValueKey).Presentation]: [
        (0, $2Znam.NounSubtypeKey).Presentation
    ],
    [(0, $2Znam.TypeFilterValueKey).Video]: [
        (0, $2Znam.NounSubtypeKey).Video
    ],
    [(0, $2Znam.TypeFilterValueKey).Design]: [
        (0, $2Znam.NounSubtypeKey).Design
    ],
    [(0, $2Znam.TypeFilterValueKey).Conversation]: [],
    [(0, $2Znam.TypeFilterValueKey).Message]: [],
    // Comment filter should map to the comment subtype to avoid returning unrelated results
    // (e.g. web pages) for products that don't have an explicit typeFilterConfig for comments
    [(0, $2Znam.TypeFilterValueKey).Comment]: [
        (0, $2Znam.NounSubtypeKey).Comment
    ],
    [(0, $2Znam.TypeFilterValueKey).Image]: [
        (0, $2Znam.NounSubtypeKey).Image
    ],
    [(0, $2Znam.TypeFilterValueKey).Audio]: [
        (0, $2Znam.NounSubtypeKey).Audio
    ],
    [(0, $2Znam.TypeFilterValueKey).Pdf]: [
        (0, $2Znam.NounSubtypeKey).Pdf
    ],
    [(0, $2Znam.TypeFilterValueKey).Code]: [
        (0, $2Znam.NounSubtypeKey).Code
    ],
    [(0, $2Znam.TypeFilterValueKey).Archive]: [
        (0, $2Znam.NounSubtypeKey).Archive
    ],
    [(0, $2Znam.TypeFilterValueKey).Folder]: [
        (0, $2Znam.NounSubtypeKey).Folder
    ],
    [(0, $2Znam.TypeFilterValueKey).Shortcut]: [
        (0, $2Znam.NounSubtypeKey).Shortcut
    ],
    [(0, $2Znam.TypeFilterValueKey).Form]: [
        (0, $2Znam.NounSubtypeKey).Form
    ],
    [(0, $2Znam.TypeFilterValueKey).Notebook]: [
        (0, $2Znam.NounSubtypeKey).Notebook
    ],
    [(0, $2Znam.TypeFilterValueKey).Other]: [
        (0, $2Znam.NounSubtypeKey).Other
    ],
    [(0, $2Znam.TypeFilterValueKey).WebPage]: [
        (0, $2Znam.NounSubtypeKey).WebPage
    ],
    [(0, $2Znam.TypeFilterValueKey).Dashboard]: [
        (0, $2Znam.NounSubtypeKey).Dashboard
    ],
    [(0, $2Znam.TypeFilterValueKey).Database]: [
        (0, $2Znam.NounSubtypeKey).Database
    ]
};
const $a113941c76257cbc$export$b7b676578c62639d = ()=>({
        commonFilters: {},
        confluenceFilters: {
            spacesFilter: [],
            contributorsFilter: [],
            ancestorIdsFilter: [],
            range: [],
            owners: [],
            labelsFilter: [],
            titleMatchOnly: false,
            contentStatuses: [],
            containerStatus: []
        },
        assetsFilters: {
            objectSchemaFilter: {
                schemaARIs: []
            },
            objectTypeFilter: {
                typeARIs: []
            }
        },
        jiraFilters: {
            issueFilter: {
                assigneeARIs: [],
                reporterARIs: [],
                commenterARIs: [],
                projectARIs: [],
                issueTypeIDs: [],
                issueLabels: [],
                issueTypes: [],
                statusCategories: [],
                watcherARIs: []
            }
        },
        mercuryFilters: {
            owners: [],
            focusAreaTypeIds: [],
            ancestorIds: []
        },
        talentFilters: {
            owners: [],
            employmentTypes: [],
            focusAreas: [],
            jobFamilies: [],
            statuses: [],
            teams: []
        },
        compassFilters: {
            componentFilter: {
                componentStates: []
            }
        },
        thirdPartyFilters: {
            titleMatchOnly: false,
            subtypes: [],
            integrations: [],
            createdBy: [],
            lastUpdatedBy: [],
            assignees: [],
            labels: []
        },
        sortFilters: []
    });
const $a113941c76257cbc$var$DATE_RANGE_PRESETS = [
    {
        name: 'today',
        fromOffset: 0,
        toOffset: 0
    },
    {
        name: 'yesterday',
        fromOffset: 1,
        toOffset: 1
    },
    {
        name: 'past7Days',
        fromOffset: 7,
        toOffset: 0
    },
    {
        name: 'past30Days',
        fromOffset: 30,
        toOffset: 0
    },
    {
        name: 'pastYear',
        fromOffset: 365,
        toOffset: 0
    }
];
/**
 * Gets a UTC date string (YYYY-MM-DD) for a given number of days ago.
 * Uses UTC timezone to match backend date calculations.
 */ const $a113941c76257cbc$var$getUTCDateString = (daysAgo)=>{
    const now = new Date();
    const utcDate = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() - daysAgo));
    return utcDate.toISOString().split('T')[0];
};
const $a113941c76257cbc$export$64e54565c5bfc685 = (dateRange)=>{
    if (!dateRange || !dateRange.gt && !dateRange.lt) return 'anytime';
    if (!dateRange.gt) return 'custom';
    const inputGtDate = dateRange.gt.split('T')[0];
    const inputLtDate = dateRange.lt?.split('T')[0];
    for (const preset of $a113941c76257cbc$var$DATE_RANGE_PRESETS){
        const presetGtDate = $a113941c76257cbc$var$getUTCDateString(preset.fromOffset);
        const presetLtDate = $a113941c76257cbc$var$getUTCDateString(preset.toOffset);
        if (inputGtDate === presetGtDate) {
            // If BE has also provided lt, it must match the preset's lt for this to be the preset.
            // E.g. gt='2026-02-01', lt='2026-02-03' is a custom range (Feb 1–3), not past7Days
            if (inputLtDate != null && inputLtDate !== presetLtDate) continue;
            return preset.name;
        }
    }
    return 'custom';
};
const $a113941c76257cbc$var$isSupportedParticipant = (participant)=>{
    const { users: users, combination: combination, type: type } = participant;
    if (type !== 'PRESENCE') return false;
    if (users.length > 1 && combination === 'AND') return false;
    return true;
};
const $a113941c76257cbc$export$ae993d8ff9dd28 = (participants)=>{
    const { items: items, combination: combination } = participants;
    if (items.length > 1 && combination === 'AND') return [];
    if (!items.every($a113941c76257cbc$var$isSupportedParticipant)) return [];
    return Array.from(new Set(items.flatMap(({ users: users })=>users)));
};
const $a113941c76257cbc$export$2703353a19002efe = ()=>{
    return {
        ...(0, $62eb2e94deff5767$export$d82a82f2333502ad)
    };
};
/**
 * Checks the product-specific feature gate for video noun filtering.
 * - Google Drive: controlled by 'rovo_fps_enable_video_noun_filter'
 * - SharePoint: controlled by 'rovo_fps_sharepoint_enable_video_noun_filter'
 * - Other products: returns false (not supported)
 */ const $a113941c76257cbc$var$isVideoNounFilterEnabled = (product)=>{
    if (product === (0, $7oQyb.ProductKey).GoogleDrive) return (0, $dh538.fg)('rovo_fps_enable_video_noun_filter');
    if (product === (0, $7oQyb.ProductKey).Sharepoint) return (0, $dh538.fg)('rovo_fps_sharepoint_enable_video_noun_filter');
    return false;
};
const $a113941c76257cbc$var$buildGitFilters = (pullRequestStatus, repoName)=>{
    if (!pullRequestStatus?.length && !repoName?.length) return undefined;
    return {
        gitFilters: {
            ...pullRequestStatus?.length && {
                pullRequestStatus: pullRequestStatus
            },
            ...repoName?.length && {
                repoName: repoName
            }
        }
    };
};
/**
 * Build MS Teams (`teamsFilters`) wire payload.
 * - `hasAttachment` (boolean): scopes Teams results to messages with attachments.
 * - `workspaceName` (string[]): `teamsFilters.workspaceName` — filters by workspace (team) name.
 *   Gated behind `rovo_fps_show_workspace_name_filter` on the frontend and
 *   `xpsearch-aggregator_teams_workspace_name_filter` on the backend.
 * Returns `undefined` when no Teams filter is set so the caller can spread without sending an empty object.
 */ const $a113941c76257cbc$var$buildTeamsFilters = (hasAttachment, workspaceName)=>{
    if (!hasAttachment && !workspaceName?.length) return undefined;
    return {
        teamsFilters: {
            ...hasAttachment && {
                hasAttachment: true
            },
            ...workspaceName?.length && {
                workspaceName: workspaceName
            }
        }
    };
};
const $a113941c76257cbc$var$filterConnectorSources = (product, isAllProductSearch, thirdPartyConfigs, connectorSources)=>{
    if (product === (0, $7oQyb.ProductKey).Slack && (0, $2OtFZ.removeFedSlackFromAllProductSearch)(thirdPartyConfigs, isAllProductSearch)) // When a federated Slack connector exists in all-product search,
    // exclude both 'federated' and 'smartlinks' connector sources so that
    // only the federated connector serves results in that context.
    return connectorSources?.filter((s)=>s !== (0, $9d9t8.FEDERATED_CONNECTOR_SOURCE) && (!(0, $dh538.fg)('ai_3p_slack_smartlinks_federated_connector_enabled') || s !== (0, $9d9t8.SMARTLINKS_CONNECTOR_SOURCE)));
    return connectorSources;
};
const $a113941c76257cbc$var$hasConnectorSources = (product, isAllProductSearch, thirdPartyConfigs)=>{
    const connectorSources = thirdPartyConfigs[product]?.connectorSources;
    const filteredConnectorSources = $a113941c76257cbc$var$filterConnectorSources(product, isAllProductSearch, thirdPartyConfigs, connectorSources);
    return (filteredConnectorSources?.length ?? 0) > 0;
};
const $a113941c76257cbc$export$3766c9ce0c94452 = (products, titleMatchValue, // entities is the frontend filtered, already selected values
entities, thirdPartyConfigs, isAllProductSearch = true, range, assignees, containerAris, createdBy, lastUpdatedBy, ancestorAris, labels, additionalTexts, selectedDatasource, salesforceOwners, salesforceStage, salesforceCloseDate, opportunityStatus, pullRequestStatus, repoName, campaignStatuses, caseStatuses, slackChannels, hasAttachment, workspaceName)=>{
    if (!products.length || products.some((p)=>(0, $b4tvS.is3pProductKey)(p) || (0, $9d9t8.isForgeConnectorProductKey)(p) || p === (0, $7oQyb.ProductKey).Bitbucket)) {
        // Conditionally create the dynamic integration ARIs based on the config
        const integrationARIsFromConfig = $a113941c76257cbc$export$2703353a19002efe();
        // Combine static and dynamic integration ARIs
        let productToIntegrationARIMap = integrationARIsFromConfig;
        // Add Forge connector integration ARIs from thirdPartyConfigs
        products.forEach((product)=>{
            if ((0, $9d9t8.isForgeConnectorProductKey)(product) && thirdPartyConfigs[product]) {
                const integrationAri = thirdPartyConfigs[product]?.integrationAri;
                productToIntegrationARIMap[product] = integrationAri;
            }
        });
        // Note: Bitbucket integration ARI is already included in baseIntegrationARIs
        // get the subtypes by looking at each type's subcategories
        let allSubtypes = [];
        let allContainerTypes = [];
        let thirdPartyProducts = [];
        const filteredProducts = products.filter((product)=>((0, $b4tvS.is3pProductKey)(product) || (0, $9d9t8.isForgeConnectorProductKey)(product)) && thirdPartyConfigs[product] !== undefined && (!thirdPartyConfigs[product]?.userNeedsOAuth || $a113941c76257cbc$export$9c38ca92ec6e6d40(product, thirdPartyConfigs)) && !thirdPartyConfigs[product]?.isFederated && $a113941c76257cbc$var$hasConnectorSources(product, isAllProductSearch, thirdPartyConfigs)).filter((product)=>{
            return thirdPartyConfigs[product]?.isEnabled?.();
        });
        // Products that support embedded comments (comments are returned as linkedEntities within documents)
        const productsWithEmbeddedComments = [
            (0, $7oQyb.ProductKey).GoogleDrive,
            (0, $7oQyb.ProductKey).Sharepoint
        ];
        // Skip code search (Document entity) unless GitHub is the only selected product. Aligned
        // with `includeGithubCode` in services/search-query-generator/index.ts so the entities payload
        // and the Relay `@include(if: $includeGithubCode)` directive can't diverge.
        const isOnlyGithubSelected = products.length === 1 && (0, $b4tvS.GITHUB_PRODUCT_KEYS).includes(products[0]);
        for (let product of filteredProducts){
            const thirdPartyConfig = thirdPartyConfigs[product];
            if (!thirdPartyConfig) continue;
            const isGithubProduct = (0, $b4tvS.GITHUB_PRODUCT_KEYS).includes(product);
            const shouldSkipDocumentForGithub = isGithubProduct && !isOnlyGithubSelected;
            let localSubtypes = [];
            let productEntities = [];
            let connectionIds;
            let linkedEntityGranularity;
            // Check if Comment filter is selected for a product that supports embedded comments.
            // Each product is gated behind its own feature flag so support can be toggled
            // independently:
            //   - Google Drive: enable_3p_embedded_comments_search
            //   - SharePoint:   rovo_fps_sharepoint_embedded_comments
            const isCommentFilterSelected = entities.includes((0, $2Znam.TypeFilterValueKey).Comment);
            const isEmbeddedCommentsEnabledForProduct = product === (0, $7oQyb.ProductKey).GoogleDrive && (0, $dh538.fg)('enable_3p_embedded_comments_search') || product === (0, $7oQyb.ProductKey).Sharepoint && (0, $dh538.fg)('rovo_fps_sharepoint_embedded_comments');
            const supportsEmbeddedComments = productsWithEmbeddedComments.includes(product);
            if (isCommentFilterSelected && supportsEmbeddedComments && isEmbeddedCommentsEnabledForProduct) // Use ONLY_LINKED_ENTITIES to force match only on comments.
            // Note: linkedEntities input is deprecated and ignored by the aggregator —
            // linkedEntityGranularity alone controls this behaviour.
            linkedEntityGranularity = 'ONLY_LINKED_ENTITIES';
            // Check if the product has specific typeFilterConfig for the requested entities
            let hasMatchingTypeConfig = false;
            thirdPartyConfig.typeFilterConfig?.forEach((entitiesConfig, entityValue)=>{
                if (entities.includes(entityValue)) {
                    localSubtypes = [
                        ...localSubtypes,
                        ...entitiesConfig.subTypes3P
                    ];
                    hasMatchingTypeConfig = true;
                }
            });
            if ((0, $dh538.fg)('rovo-search-dynamic-forge-config')) {
                // Extract all entities from typeFilterConfig for this product
                if (thirdPartyConfig.typeFilterConfig) {
                    thirdPartyConfig.typeFilterConfig.forEach((entitiesConfig, entityValue)=>{
                        if (isCommentFilterSelected && supportsEmbeddedComments && isEmbeddedCommentsEnabledForProduct && entityValue === (0, $2Znam.TypeFilterValueKey).Comment) return;
                        if (shouldSkipDocumentForGithub && entityValue === (0, $2Znam.TypeFilterValueKey).Document) return;
                        const shouldFilterByType = $a113941c76257cbc$var$isVideoNounFilterEnabled(product) && // entities.length > 0 ensures we only filter when specific types are selected;
                        // when "All" is selected, entities is empty and we fall through to the else branch
                        entities.length > 0;
                        if (shouldFilterByType) {
                            if (entities.includes(entityValue)) productEntities = [
                                ...productEntities,
                                ...entitiesConfig.entities3P
                            ];
                        } else // When entities is empty (All selected), include all entities from the config
                        productEntities = [
                            ...productEntities,
                            ...entitiesConfig.entities3P
                        ];
                    });
                    productEntities = [
                        ...new Set(productEntities)
                    ];
                }
                // Capture connectionId when present (dynamic Forge connectors)
                if (thirdPartyConfig.connectionId) connectionIds = [
                    thirdPartyConfig.connectionId
                ];
            } else if (thirdPartyConfig.typeFilterConfig && $a113941c76257cbc$var$isVideoNounFilterEnabled(product)) {
                // For Google Drive and SharePoint: only include entities from type filter configs that match selected entities
                // This ensures entity ATI is only included when the corresponding type is selected
                thirdPartyConfig.typeFilterConfig.forEach((entitiesConfig, entityValue)=>{
                    if (isCommentFilterSelected && supportsEmbeddedComments && isEmbeddedCommentsEnabledForProduct && entityValue === (0, $2Znam.TypeFilterValueKey).Comment) return;
                    if (shouldSkipDocumentForGithub && entityValue === (0, $2Znam.TypeFilterValueKey).Document) return;
                    // Only include entities from type filter configs that match the selected entities
                    if (entities.includes(entityValue)) productEntities = [
                        ...productEntities,
                        ...entitiesConfig.entities3P
                    ];
                });
                productEntities = [
                    ...new Set(productEntities)
                ];
            }
            // If no specific typeFilterConfig matched, use default subtypes for the entities
            if (!hasMatchingTypeConfig && entities.length > 0) entities.forEach((entity)=>{
                const defaultSubtypes = $a113941c76257cbc$var$DEFAULT_ENTITY_SUBTYPES[entity] ?? [];
                if (defaultSubtypes.length > 0) localSubtypes = [
                    ...localSubtypes,
                    ...defaultSubtypes
                ];
            });
            // Add local subtypes to the global subtypes array and remove duplicates
            allSubtypes = [
                ...new Set([
                    ...allSubtypes,
                    ...localSubtypes
                ])
            ];
            const integrationId = thirdPartyConfig.integrationAri;
            const providerId = thirdPartyConfig.providerId;
            const connectorSources = $a113941c76257cbc$var$filterConnectorSources(product, isAllProductSearch, thirdPartyConfigs, thirdPartyConfig.connectorSources);
            // Impersonation logging: surface, per connector source, which sources are served via
            // impersonation (user NOT OAuthed AND impersonation enabled for that source) so the
            // aggregator can observe impersonated request success/failure during rollout. Resolved
            // per connector source because a product can expose multiple sources where impersonation
            // is only enabled for some of them. Gated behind `weaklink-logging-fg`.
            const connectorSourcesImpersonationEnabled = $a113941c76257cbc$export$9c38ca92ec6e6d40(product, thirdPartyConfigs) && (0, $dh538.fg)('weaklink-logging-fg') ? $a113941c76257cbc$var$getImpersonatedConnectorSources(thirdPartyConfig, connectorSources) : undefined;
            product = product === (0, $7oQyb.ProductKey).JsmDC ? (0, $7oQyb.ProductKey).JiraDC : product;
            // Only fan out per-datasource when a specific datasource is selected, OR when
            // getFiltersForSelectedDatasources affects thirdPartyProduct routing (e.g. Jira DC
            // sets a per-instance integrationId/providerId). For webcrawler, when "All" is
            // selected, all datasource entries would be identical (same integrationId, same
            // filters) — causing N duplicate requests to the search backend. Instead, fall
            // through to the single-entry else branch below.
            const shouldFanOut = thirdPartyConfig.datasources && thirdPartyConfig.fanOutConnectorSources && (!!selectedDatasource || product !== (0, $b4tvS.ProductKeys).AtlassianWebCrawler);
            if (shouldFanOut && thirdPartyConfig.datasources) {
                const datasourcesForQuery = selectedDatasource ? thirdPartyConfig.datasources.filter((ds)=>ds.datasourceId === selectedDatasource) : thirdPartyConfig.datasources;
                for (const datasourceConfig of datasourcesForQuery){
                    const datasourceContainerTypes = datasourceConfig.containerTypes || [];
                    allContainerTypes = [
                        ...new Set([
                            ...allContainerTypes,
                            ...datasourceContainerTypes
                        ])
                    ];
                    const thirdPartyProductFilterForThisProduct = {
                        integrationId: integrationId,
                        subtypes: localSubtypes,
                        providerId: providerId,
                        product: product,
                        connectorSources: connectorSources,
                        ...connectorSourcesImpersonationEnabled && {
                            connectorSourcesImpersonationEnabled: connectorSourcesImpersonationEnabled
                        },
                        ...productEntities.length > 0 && {
                            entities: productEntities
                        },
                        ...connectionIds && {
                            connectionIds: connectionIds
                        },
                        ...linkedEntityGranularity && {
                            linkedEntityGranularity: linkedEntityGranularity
                        }
                    };
                    // For webcrawler (flag ON), getFiltersForSelectedDatasources returns only { additionalTexts }
                    // with no thirdPartyProduct key, so allFilters?.thirdPartyProduct is always undefined for
                    // webcrawler — the else branch always runs and additionalTexts is discarded here.
                    // The webcrawler's additionalTexts is correctly accumulated in the datasourceFilters loop below,
                    // making this call a no-op for webcrawler. Only thirdPartyProduct is consumed in this code path.
                    const allFilters = product !== (0, $b4tvS.ProductKeys).AtlassianWebCrawler || (0, $dh538.fg)('webcrawler-fanout-ui-sidebar-enabled') ? thirdPartyConfig.getFiltersForSelectedDatasources?.(datasourceConfig, {}) : undefined;
                    if (allFilters?.thirdPartyProduct) thirdPartyProducts.push({
                        ...thirdPartyProductFilterForThisProduct,
                        ...allFilters.thirdPartyProduct
                    });
                    else thirdPartyProducts.push(thirdPartyProductFilterForThisProduct);
                }
            } else thirdPartyProducts.push({
                integrationId: integrationId,
                subtypes: localSubtypes,
                providerId: providerId,
                product: product,
                connectorSources: connectorSources,
                ...connectorSourcesImpersonationEnabled && {
                    connectorSourcesImpersonationEnabled: connectorSourcesImpersonationEnabled
                },
                ...productEntities.length > 0 && {
                    entities: productEntities
                },
                ...connectionIds && {
                    connectionIds: connectionIds
                },
                ...linkedEntityGranularity && {
                    linkedEntityGranularity: linkedEntityGranularity
                }
            });
        }
        if (thirdPartyProducts) {
            // Add Loom and Bitbucket to the thirdPartyProducts filter
            const firstPartyProductsFor3pFilters = [
                (0, $7oQyb.ProductKey).Loom,
                (0, $7oQyb.ProductKey).Bitbucket
            ];
            const result = firstPartyProductsFor3pFilters.filter((product)=>products.includes(product) && !thirdPartyProducts?.some((p)=>p.product === product)).map((product)=>({
                    integrationId: productToIntegrationARIMap[product] || '',
                    subtypes: allSubtypes,
                    product: product,
                    connectorSources: [
                        (0, $9d9t8.FULL_CONNECTOR_SOURCE)
                    ]
                }));
            thirdPartyProducts = thirdPartyProducts.concat(result);
        }
        // Slack channels filter — Slack is a federated product, so it is excluded from the
        // `filteredProducts` loop above (federated products are filtered out). To pass selected
        // Slack channels to the aggregator, we attach them to a Slack `thirdPartyProducts` entry
        // here, either by mutating an existing entry (non-federated case) or by adding a new entry.
        if (slackChannels?.length) {
            const slackConfig = thirdPartyConfigs[(0, $7oQyb.ProductKey).Slack];
            if (slackConfig) {
                const existingSlackEntry = thirdPartyProducts.find((p)=>p.product === (0, $7oQyb.ProductKey).Slack);
                if (existingSlackEntry) existingSlackEntry.channels = slackChannels;
                else thirdPartyProducts.push({
                    integrationId: slackConfig.integrationAri || '',
                    subtypes: [],
                    providerId: slackConfig.providerId,
                    product: (0, $7oQyb.ProductKey).Slack,
                    connectorSources: $a113941c76257cbc$var$filterConnectorSources((0, $7oQyb.ProductKey).Slack, isAllProductSearch, thirdPartyConfigs, slackConfig.connectorSources || []),
                    channels: slackChannels
                });
            }
        }
        const createdByFilterField = {
            createdBy: createdBy || []
        };
        const lastUpdatedByFilterField = {
            lastUpdatedBy: lastUpdatedBy || []
        };
        // Labels filter is only applicable to Confluence (incl. Confluence DC).
        const isConfluenceProduct = products.includes((0, $b4tvS.ProductKeys).Confluence) || products.includes((0, $b4tvS.ProductKeys).ConfluenceDC);
        const labelsFilterField = isConfluenceProduct ? {
            labels: labels || []
        } : {};
        const containerTypes = thirdPartyProducts.length !== 1 ? [] : allContainerTypes;
        const excludeSubtypes = [];
        const isTeamsProduct = products.includes((0, $b4tvS.ProductKeys).Teams);
        const isAttachmentTypeSelected = entities.includes((0, $2Znam.TypeFilterValueKey).Attachment);
        const teamsFilters = $a113941c76257cbc$var$buildTeamsFilters(isTeamsProduct && (isAttachmentTypeSelected || hasAttachment), isTeamsProduct ? workspaceName : undefined)?.teamsFilters;
        let datasourceFilters = {
            additionalTexts: additionalTexts || []
        };
        if (selectedDatasource) for (const product of filteredProducts){
            const thirdPartyConfig = thirdPartyConfigs[product];
            if (!thirdPartyConfig?.getFiltersForSelectedDatasources || !thirdPartyConfig.fanOutConnectorSources) continue;
            if (thirdPartyConfig.datasources) {
                const datasourceForQuery = thirdPartyConfig.datasources.find((ds)=>ds.datasourceId === selectedDatasource);
                if (datasourceForQuery) {
                    if (product !== (0, $b4tvS.ProductKeys).AtlassianWebCrawler || (0, $dh538.fg)('webcrawler-fanout-ui-sidebar-enabled')) datasourceFilters = thirdPartyConfig.getFiltersForSelectedDatasources(datasourceForQuery, datasourceFilters) ?? datasourceFilters;
                }
            }
        }
        const { additionalTexts: mergedAdditionalTexts = [], ...otherDatasourceFilters } = datasourceFilters;
        if (Object.keys(productToIntegrationARIMap).length !== 0) {
            const integrationARIs = products.filter((product)=>// Non-3P products pass through
                !(0, $b4tvS.is3pProductKey)(product) && !(0, $9d9t8.isForgeConnectorProductKey)(product) || // 3P products must be enabled and not require OAuth (or have impersonation)
                thirdPartyConfigs[product]?.isEnabled?.() !== false && (!thirdPartyConfigs[product]?.userNeedsOAuth || $a113941c76257cbc$export$9c38ca92ec6e6d40(product, thirdPartyConfigs))).map((product)=>productToIntegrationARIMap[product]).filter((ari)=>!!ari)// remove duplicates (eg sharepoint, teams)
            .filter((ari, pos, arr)=>{
                return arr.indexOf(ari) === pos;
            })// Include Slack integration ARI only when Slack has at least one connector source (after filtering)
            .filter((ari)=>ari !== productToIntegrationARIMap[(0, $7oQyb.ProductKey).Slack] || $a113941c76257cbc$var$hasConnectorSources((0, $7oQyb.ProductKey).Slack, isAllProductSearch, thirdPartyConfigs));
            // Build salesforceFilters if applicable
            const salesforceIsClosedValue = opportunityStatus ? (0, $dcbm4.OpportunityStatusFilterValue)[opportunityStatus] : undefined;
            const salesforceFilters = salesforceOwners?.length || salesforceStage?.length || salesforceCloseDate || opportunityStatus || campaignStatuses?.length || caseStatuses?.length ? {
                ...salesforceOwners?.length && {
                    owners: salesforceOwners
                },
                ...salesforceStage?.length && {
                    stage: salesforceStage
                },
                ...salesforceCloseDate ? {
                    closeDate: salesforceCloseDate
                } : {},
                ...salesforceIsClosedValue !== undefined ? {
                    isClosed: salesforceIsClosedValue
                } : {},
                ...campaignStatuses?.length && {
                    campaignStatuses: campaignStatuses
                },
                ...caseStatuses?.length && {
                    caseStatuses: caseStatuses
                }
            } : undefined;
            return {
                range: range,
                titleMatchOnly: titleMatchValue,
                subtypes: allSubtypes,
                integrations: integrationARIs,
                thirdPartyProducts: thirdPartyProducts,
                assignees: assignees,
                containerAris: containerAris || [],
                ...createdByFilterField,
                ...lastUpdatedByFilterField,
                ancestorAris: ancestorAris || [],
                ...labelsFilterField,
                additionalTexts: mergedAdditionalTexts.length > 0 ? mergedAdditionalTexts : additionalTexts || [],
                containerTypes: containerTypes,
                ...excludeSubtypes.length > 0 && {
                    excludeSubtypes: excludeSubtypes
                },
                ...salesforceFilters && {
                    salesforceFilters: salesforceFilters
                },
                ...$a113941c76257cbc$var$buildGitFilters(pullRequestStatus, repoName),
                ...teamsFilters && {
                    teamsFilters: teamsFilters
                },
                ...otherDatasourceFilters
            };
        } else {
            // Build salesforceFilters if applicable
            const salesforceIsClosedValue = opportunityStatus ? (0, $dcbm4.OpportunityStatusFilterValue)[opportunityStatus] : undefined;
            const salesforceFilters = salesforceOwners?.length || salesforceStage?.length || salesforceCloseDate || opportunityStatus || campaignStatuses?.length || caseStatuses?.length ? {
                ...salesforceOwners?.length && {
                    owners: salesforceOwners
                },
                ...salesforceStage?.length && {
                    stage: salesforceStage
                },
                ...salesforceCloseDate ? {
                    closeDate: salesforceCloseDate
                } : {},
                ...salesforceIsClosedValue !== undefined ? {
                    isClosed: salesforceIsClosedValue
                } : {},
                ...campaignStatuses?.length && {
                    campaignStatuses: campaignStatuses
                },
                ...caseStatuses?.length && {
                    caseStatuses: caseStatuses
                }
            } : undefined;
            return {
                range: range,
                titleMatchOnly: titleMatchValue,
                subtypes: allSubtypes,
                integrations: [],
                thirdPartyProducts: thirdPartyProducts,
                assignees: assignees,
                containerAris: containerAris || [],
                ...createdByFilterField,
                ...lastUpdatedByFilterField,
                ancestorAris: ancestorAris || [],
                ...labelsFilterField,
                additionalTexts: mergedAdditionalTexts.length > 0 ? mergedAdditionalTexts : additionalTexts || [],
                containerTypes: containerTypes,
                ...excludeSubtypes.length > 0 && {
                    excludeSubtypes: excludeSubtypes
                },
                ...salesforceFilters && {
                    salesforceFilters: salesforceFilters
                },
                ...$a113941c76257cbc$var$buildGitFilters(pullRequestStatus, repoName),
                ...teamsFilters && {
                    teamsFilters: teamsFilters
                },
                ...otherDatasourceFilters
            };
        }
    }
    return {
        titleMatchOnly: false,
        subtypes: [],
        integrations: []
    };
};
var $a113941c76257cbc$export$b367612b2293421c = /*#__PURE__*/ function(DateRangeError) {
    DateRangeError["FROM_AFTER_TO_ERROR"] = "fromAfterToError";
    DateRangeError["FROM_IN_FUTURE_ERROR"] = "fromInFutureError";
    DateRangeError["TO_IN_FUTURE_ERROR"] = "toInFutureError";
    return DateRangeError;
}({});
const $a113941c76257cbc$export$d3eb8baea7b2ff96 = (from, to)=>{
    if (!from && !to) return null;
    const dateFrom = new Date(`${from}${from ? 'T00:00:00' : ''}`);
    const dateTo = new Date(`${to}${to ? 'T00:00:00' : ''}`);
    const now = new Date();
    if (dateFrom > now) return "fromInFutureError";
    if (dateFrom > dateTo) return "fromAfterToError";
    if (dateTo > now) return "toInFutureError";
    return null;
};
const $a113941c76257cbc$export$ef6dfb919b1d7267 = (0, $779a23dd67a96bae$export$ef6dfb919b1d7267);
const $a113941c76257cbc$export$b29ea735dcfba3c1 = (value)=>{
    return value !== null && value !== undefined;
};
const $a113941c76257cbc$export$9c38ca92ec6e6d40 = (product, thirdPartyConfigs)=>{
    const impersonationEnabled = thirdPartyConfigs[product]?.impersonationEnabled;
    return !!(impersonationEnabled && (product === (0, $7oQyb.ProductKey).GoogleDrive && (0, $2OtFZ.serveWeakLinkExpWithoutExposure)() || product === (0, $7oQyb.ProductKey).Github && (0, $dh538.fg)('weaklink-github-fg')));
};
/**
 * Derives the single connector source backing a datasource config, mirroring the resolution used
 * when building the product's `connectorSources` list (smartlinks / lite / federated / full).
 */ const $a113941c76257cbc$var$getDatasourceConnectorSource = (datasource)=>{
    const resourceType = datasource.resourceType;
    // Without a resourceType the backing connector source cannot be determined, so contribute
    // nothing rather than guessing. This mirrors rovo-connectors-config's `getConnectorSources`,
    // which early-returns `[]` for this case, keeping both FPS/QF and agent-studio builders in sync.
    if (!resourceType) return undefined;
    if (resourceType.startsWith((0, $9d9t8.SMARTLINKS_RESOURCE_TYPE_PREFIX))) return 0, $9d9t8.SMARTLINKS_CONNECTOR_SOURCE;
    if (resourceType.startsWith((0, $9d9t8.LITE_CONNECTOR_SOURCE_PREFIX))) return 0, $9d9t8.LITE_CONNECTOR_SOURCE;
    // Slack federated status is driven by `connectorSyncType` rather than the static `isFederated`
    // flag. Mirror the canonical derivation in controllers/config/utils/third-party-products.ts so a
    // federated Slack datasource resolves to FEDERATED (not FULL). `connectorSyncType` is present on
    // the datasource at runtime (spread from the raw resource) but not on the typed config shape.
    if (datasource.id === (0, $b4tvS.ProductKeys).Slack && (0, $dh538.fg)('ai_3p_slack_connector_status_transition_enabled')) {
        const connectorSyncType = datasource.connectorSyncType;
        return connectorSyncType === 'federated' ? (0, $9d9t8.FEDERATED_CONNECTOR_SOURCE) : (0, $9d9t8.FULL_CONNECTOR_SOURCE);
    }
    if (datasource.isFederated) return 0, $9d9t8.FEDERATED_CONNECTOR_SOURCE;
    return 0, $9d9t8.FULL_CONNECTOR_SOURCE;
};
/**
 * Returns the subset of `connectorSources` that are served via impersonation for this product.
 *
 * Impersonation is resolved per connector source (each backing datasource maps to a single
 * connector source) rather than at the product level, because a product can expose multiple
 * connector sources (e.g. `smartlinks` + `full-connector`) where impersonation is only enabled
 * for some of them. A connector source is considered impersonated when its datasource has the
 * user NOT OAuthed (`userNeedsOAuth === true`) AND impersonation enabled (`impersonationEnabled`).
 *
 * The result is restricted to sources actually present in the product's `connectorSources` and is
 * deduped while preserving the order of `connectorSources`. Returns `undefined` when no connector
 * source is impersonated.
 */ const $a113941c76257cbc$var$getImpersonatedConnectorSources = (thirdPartyConfig, connectorSources)=>{
    if (!connectorSources?.length) return undefined;
    const impersonatedSources = new Set();
    const datasources = thirdPartyConfig.datasources?.length ? thirdPartyConfig.datasources : [
        thirdPartyConfig
    ];
    for (const datasource of datasources)if (datasource.userNeedsOAuth && datasource.impersonationEnabled) {
        const source = $a113941c76257cbc$var$getDatasourceConnectorSource(datasource);
        if (source) impersonatedSources.add(source);
    }
    if (!impersonatedSources.size) return undefined;
    const result = connectorSources.filter((source)=>impersonatedSources.has(source));
    return result.length ? result : undefined;
};
module.exports["getEmptySelectedFilters"] = $a113941c76257cbc$export$b7b676578c62639d;
module.exports["getThirdPartyFilters"] = $a113941c76257cbc$export$3766c9ce0c94452;
module.exports["isImpersonationEnabled"] = $a113941c76257cbc$export$9c38ca92ec6e6d40;
module.exports["DateRangeError"] = $a113941c76257cbc$export$b367612b2293421c;
module.exports["getInvalidDateRange"] = $a113941c76257cbc$export$d3eb8baea7b2ff96;
module.exports["getProducts3PFromConfigForFilter"] = $a113941c76257cbc$export$ef6dfb919b1d7267;
module.exports["notEmpty"] = $a113941c76257cbc$export$b29ea735dcfba3c1;

});

parcelRegister("3JX0d", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");


var $efKMM = parcelRequire("efKMM");


var $2Znam = parcelRequire("2Znam");


var $b4tvS = parcelRequire("b4tvS");


var $fKv9F = parcelRequire("fKv9F");


var $dOOW1 = parcelRequire("dOOW1");


var $1xk5k = parcelRequire("1xk5k");


var $21S1F = parcelRequire("21S1F");


var $66big = parcelRequire("66big");


var $3fLdC = parcelRequire("3fLdC");


var $jN0EV = parcelRequire("jN0EV");


var $7jUYs = parcelRequire("7jUYs");

/** Slides type filter + slide ATI require env rollout and cc-mui-slides-experiment (same as Quick Find supported entities). */ function $17f4c3b31de02ed7$var$isSlideTypeFilterEnabled() {
    return (0, $efKMM.isContentTypeEnabledInCurrentEnv)('slide') && (0, $c6GJD.default).getExperimentValue('cc-mui-slides-experiment', 'isEnabled', false, {
        fireExperimentExposure: true
    }) === true;
}
const $17f4c3b31de02ed7$export$860193da8e7fe3cd = ()=>(0, $2Znam.allTypeFilterValueKeys).filter((key)=>key !== (0, $2Znam.TypeFilterValueKey).Slide || $17f4c3b31de02ed7$var$isSlideTypeFilterEnabled());
const $17f4c3b31de02ed7$export$cf63d35399eb18ae = (query, config)=>{
    const allOptions = $17f4c3b31de02ed7$export$b220eb3fbdd854af(config);
    const matchingOptions = allOptions.filter((option)=>(0, $jN0EV.lookupMatches)(query, option.label)).map((option)=>({
            label: option.label,
            trackingKey: option.value,
            value: option.value,
            queryParamValue: option.queryParamValue,
            isDefault: option.isDefault,
            product: config.product
        }));
    return matchingOptions;
};
const $17f4c3b31de02ed7$var$combineEntitiesForResultsCountQuery = (selectedEntities, unselectedEntities)=>{
    const entitiesToExclude = [
        'ati:cloud:trello:card',
        ...(0, $1xk5k.CONFLUENCE_COMMENTS_AND_ATTACHMENTS_ENTITIES)
    ];
    return Array.from([
        ...new Set([
            ...selectedEntities,
            ...unselectedEntities
        ])
    ]).filter((entity)=>!entitiesToExclude.includes(entity)).sort();
};
const $17f4c3b31de02ed7$export$e085e94f90daa6c8 = (products, selectedTypes, thirdPartyConfigs, availableProducts, selectedProducts)=>{
    const selectedTypesFiltered = selectedTypes.filter((t)=>t !== (0, $2Znam.TypeFilterValueKey).Slide || $17f4c3b31de02ed7$var$isSlideTypeFilterEnabled());
    if ((0, $dh538.fg)('confluence_performance_improve_search_query')) return $17f4c3b31de02ed7$export$d9f0dc47e74a61d2({
        products: products,
        selectedTypes: selectedTypesFiltered,
        thirdPartyConfigs: thirdPartyConfigs,
        availableProducts: availableProducts,
        selectedProducts: selectedProducts
    });
    const selectedEntities = new Set();
    const unselectedEntities = new Set();
    // Expand types to include all when:
    // 1. No types are selected (show all results), OR
    // 2. Bug fix is enabled AND specific noun product+type combos are selected:
    //    - Atlas + (project OR goal)
    //    - WebCrawler + web-page
    // because despite type being selected (which would usually mean only showing result counts for that type),
    // we want to show all result counts on the right panel to make nouns more consistent with other apps.
    const shouldIncludeAllTypes = selectedTypesFiltered.length === 0 || selectedTypesFiltered.includes((0, $2Znam.TypeFilterValueKey).Project) && selectedProducts?.includes((0, $b4tvS.ProductKeys).Atlas) || selectedTypesFiltered.includes((0, $2Znam.TypeFilterValueKey).Goal) && selectedProducts?.includes((0, $b4tvS.ProductKeys).Atlas) || selectedTypesFiltered.includes((0, $2Znam.TypeFilterValueKey).WebPage) && selectedProducts?.includes((0, $b4tvS.ProductKeys).AtlassianWebCrawler);
    const types = shouldIncludeAllTypes ? $17f4c3b31de02ed7$export$860193da8e7fe3cd() : selectedTypesFiltered;
    const typeMapping = (0, $1xk5k.getTypeMapping)();
    const otherProducts = availableProducts.filter((product)=>!products.includes(product));
    types.forEach((type)=>{
        const productToEntityMap = typeMapping[type].entities;
        products.forEach((product)=>{
            if ((0, $3fLdC.isProductEntitiesIncluded)(products, product, thirdPartyConfigs)) productToEntityMap[product]?.forEach((ati)=>{
                // Logic specific to Atlas product to ensure projects and goals are not shown together
                // in the search query results since they both belong to the same product, Townsquare
                if (product === (0, $b4tvS.ProductKeys).Atlas && selectedTypesFiltered.length > 0 && !selectedTypesFiltered.includes(type)) {
                    // Add other entities under the same product to unselected so they appear in right panel counts
                    unselectedEntities.add(ati);
                    return;
                }
                if ((0, $66big.isEntityEnabled)(ati, selectedTypesFiltered, selectedProducts)) selectedEntities.add(ati);
            });
        });
        // collect unselected entities
        otherProducts.forEach((product)=>{
            if ((0, $3fLdC.isProductEntitiesIncluded)(otherProducts, product, thirdPartyConfigs)) productToEntityMap[product]?.forEach((ati)=>{
                if (!selectedEntities.has(ati)) unselectedEntities.add(ati);
            });
        });
    });
    /// result count wants all entities for selected type
    const entitiesForResultsCountQuery = $17f4c3b31de02ed7$var$combineEntitiesForResultsCountQuery(selectedEntities, unselectedEntities);
    // Do not show Atlas goal and tag results when no product is selected
    if (types.includes('project') && products.length > 1) {
        selectedEntities.delete('ati:cloud:townsquare:goal');
        selectedEntities.delete('ati:cloud:townsquare:tag');
    }
    if (types.includes('customer-contact') && !(0, $dh538.fg)('afm_customer_contact_search_type')) selectedEntities.delete('ati:cloud:graph:customer-contact');
    if (!$17f4c3b31de02ed7$var$isSlideTypeFilterEnabled()) selectedEntities.delete('ati:cloud:confluence:slide');
    // Sorting helps a ton in testing
    const entitiesForQuery = Array.from(selectedEntities).sort();
    return {
        entitiesForQuery: entitiesForQuery,
        entitiesForResultsCountQuery: entitiesForResultsCountQuery
    };
};
const $17f4c3b31de02ed7$var$isProductEntitiesIncludedSimplified = (availableProducts, product, thirdPartyConfigs)=>{
    // Main change from the original code
    if ((0, $b4tvS.is3pProductKey)(product)) return availableProducts.includes(product) && (!thirdPartyConfigs[product]?.userNeedsOAuth || (0, $dOOW1.isImpersonationEnabled)(product, thirdPartyConfigs));
    return availableProducts.includes(product);
};
const $17f4c3b31de02ed7$var$getProductsWithEntities = (products, thirdPartyConfigs)=>{
    return products.reduce((acc, product)=>{
        if ($17f4c3b31de02ed7$var$isProductEntitiesIncludedSimplified(products, product, thirdPartyConfigs)) acc.push(product);
        return acc;
    }, []);
};
const $17f4c3b31de02ed7$export$d9f0dc47e74a61d2 = ({ products: products, selectedTypes: selectedTypes, thirdPartyConfigs: thirdPartyConfigs, availableProducts: availableProducts, selectedProducts: selectedProducts })=>{
    const selectedTypesFiltered = selectedTypes.filter((t)=>t !== (0, $2Znam.TypeFilterValueKey).Slide || $17f4c3b31de02ed7$var$isSlideTypeFilterEnabled());
    const otherProducts = availableProducts.filter((product)=>!products.includes(product));
    const productsWithEntities = $17f4c3b31de02ed7$var$getProductsWithEntities(products, thirdPartyConfigs);
    const otherProductsWithEntities = otherProducts.reduce((acc, otherProduct)=>{
        if ((0, $3fLdC.isProductEntitiesIncluded)(otherProducts, otherProduct, thirdPartyConfigs)) acc.push(otherProduct);
        return acc;
    }, []);
    // Stuff that we can't be cached that easy
    const selectedEntities = new Set();
    const unselectedEntities = new Set();
    // Expand types to include all when:
    // 1. No types are selected (show all results), OR
    // 2. Bug fix is enabled AND specific noun product+type combos are selected:
    //    - Atlas + (project OR goal)
    //    - WebCrawler + web-page
    // because despite type being selected (which would usually mean only showing result counts for that type),
    // we want to show all result counts on the right panel to make nouns more consistent with other apps.
    const shouldIncludeAllTypes = selectedTypesFiltered.length === 0 || selectedTypesFiltered.includes((0, $2Znam.TypeFilterValueKey).Project) && selectedProducts?.includes((0, $b4tvS.ProductKeys).Atlas) || selectedTypesFiltered.includes((0, $2Znam.TypeFilterValueKey).Goal) && selectedProducts?.includes((0, $b4tvS.ProductKeys).Atlas) || selectedTypesFiltered.includes((0, $2Znam.TypeFilterValueKey).WebPage) && selectedProducts?.includes((0, $b4tvS.ProductKeys).AtlassianWebCrawler);
    const types = shouldIncludeAllTypes ? $17f4c3b31de02ed7$export$860193da8e7fe3cd() : selectedTypesFiltered;
    const typeMapping = (0, $1xk5k.getTypeMapping)();
    // Using normal-loop to reduce overhead and improve performance
    for(let i = 0; i < types.length; i++){
        const type = types[i];
        const productToEntityMap = typeMapping[type].entities;
        for(let h = 0; h < productsWithEntities.length; h++){
            const product = productsWithEntities[h];
            const arr = productToEntityMap[product];
            if (!arr || !Array.isArray(arr)) continue;
            for(let w = 0; w < arr.length; w++){
                const ati = arr[w];
                // Logic specific to Atlas product to ensure projects and goals are not shown together
                // in the search query results since they both belong to the same product, Townsquare
                if (product === (0, $b4tvS.ProductKeys).Atlas && selectedTypesFiltered.length > 0 && !selectedTypesFiltered.includes(type)) {
                    // Add other entities under the same product to unselected so they appear in right panel counts
                    unselectedEntities.add(ati);
                    continue;
                }
                if ((0, $66big.isEntityEnabled)(ati, selectedTypesFiltered, selectedProducts)) selectedEntities.add(ati);
            }
        }
        for(let j = 0; j < otherProductsWithEntities.length; j++){
            const product = otherProductsWithEntities[j];
            const arr = productToEntityMap[product];
            if (!arr || !Array.isArray(arr)) continue;
            for(let w = 0; w < arr.length; w++){
                const ati = arr[w];
                if (!selectedEntities.has(ati)) unselectedEntities.add(ati);
            }
        }
    }
    /// result count wants all entities for selected type
    const entitiesForResultsCountQuery = $17f4c3b31de02ed7$var$combineEntitiesForResultsCountQuery(selectedEntities, unselectedEntities);
    // Do not show Atlas goal and tag results when no product is selected
    if (types.includes('project') && products.length > 1) {
        selectedEntities.delete('ati:cloud:townsquare:goal');
        selectedEntities.delete('ati:cloud:townsquare:tag');
    }
    if (!$17f4c3b31de02ed7$var$isSlideTypeFilterEnabled()) selectedEntities.delete('ati:cloud:confluence:slide');
    // Sorting helps a ton in testing
    const entitiesForQuery = Array.from(selectedEntities).sort();
    return {
        entitiesForQuery: entitiesForQuery,
        entitiesForResultsCountQuery: entitiesForResultsCountQuery
    };
};
const $17f4c3b31de02ed7$export$b220eb3fbdd854af = (config)=>{
    const typeMapping = (0, $1xk5k.getTypeMapping)();
    const allOption = {
        products: [],
        label: config.intl?.formatMessage((0, $7jUYs.typeLabels)['all']) || '',
        value: 'all',
        trackingKey: 'all',
        queryParamValue: (0, $fKv9F.ContentType)['All'],
        isDefault: true,
        product: config.product
    };
    const typeOptions = $17f4c3b31de02ed7$export$860193da8e7fe3cd().filter((type)=>type !== 'customer-contact' || type === 'customer-contact' && (0, $dh538.fg)('afm_customer_contact_search_type')).map((type)=>{
        let messageKey = (0, $21S1F.getTypeOptionMessageKey)(type);
        return {
            products: typeMapping[type].products,
            value: type,
            trackingKey: type,
            queryParamValue: type,
            isDefault: false,
            label: config.intl?.formatMessage((0, $7jUYs.typeLabels)[messageKey]) || '',
            product: config.product
        };
    });
    return [
        allOption,
        ...typeOptions
    ];
};
module.exports["getAllTypeFilterKeysForSearch"] = $17f4c3b31de02ed7$export$860193da8e7fe3cd;
module.exports["lookupOptions"] = $17f4c3b31de02ed7$export$cf63d35399eb18ae;
module.exports["getAllTypeOptions"] = $17f4c3b31de02ed7$export$b220eb3fbdd854af;
module.exports["getEntitiesForQuery"] = $17f4c3b31de02ed7$export$e085e94f90daa6c8;

});

parcelRegister("1xk5k", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $a5RR2 = parcelRequire("a5RR2");


var $idpYy = parcelRequire("idpYy");


var $2Znam = parcelRequire("2Znam");


var $b4tvS = parcelRequire("b4tvS");

/**
 * A mapping between 1P Products
 * - ProductKey1P e.g. 'confluence'
 *
 * UI values for the type filter
 * - TypeFilterKey e.g. 'Spreadsheet'
 *
 * and entities to request from Aggregator
 *
 * - ATIString[] e.g. ['ati:cloud:confluence:blogpost']
 */ const $b7f1b9f5c8cf1139$var$typeFilter1PMapping = new Map([
    [
        (0, $b4tvS.ProductKeys).Confluence,
        new Map([
            [
                (0, $2Znam.TypeFilterValueKey).Document,
                [
                    'ati:cloud:confluence:blogpost',
                    'ati:cloud:confluence:page',
                    'ati:cloud:confluence:attachment'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Page,
                [
                    'ati:cloud:confluence:page'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Blogpost,
                [
                    'ati:cloud:confluence:blogpost'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Attachment,
                [
                    'ati:cloud:confluence:attachment'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Space,
                [
                    'ati:cloud:confluence:space'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Comment,
                [
                    'ati:cloud:confluence:comment'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Whiteboard,
                [
                    'ati:cloud:confluence:whiteboard'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Slide,
                [
                    'ati:cloud:confluence:slide'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Database,
                [
                    'ati:cloud:confluence:database'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Embed,
                [
                    'ati:cloud:confluence:embed'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Folder,
                [
                    'ati:cloud:confluence:folder'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Calendar,
                [
                    (0, $idpYy.CONFLUENCE_CALENDAR_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).SpaceCalendar,
                [
                    (0, $idpYy.CONFLUENCE_SPACE_CALENDAR_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Question,
                [
                    (0, $idpYy.CONFLUENCE_QUESTION_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Answer,
                [
                    (0, $idpYy.CONFLUENCE_ANSWER_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Gliffy,
                [
                    (0, $idpYy.CONFLUENCE_GLIFFY_ENTITY_ATI)
                ]
            ]
        ])
    ],
    [
        (0, $b4tvS.ProductKeys).Jira,
        new Map([
            [
                (0, $2Znam.TypeFilterValueKey).Issue,
                [
                    (0, $idpYy.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Epic,
                [
                    (0, $idpYy.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Bug,
                [
                    (0, $idpYy.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Story,
                [
                    (0, $idpYy.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Task,
                [
                    (0, $idpYy.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Subtask,
                [
                    (0, $idpYy.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Space,
                [
                    (0, $idpYy.JIRA_PROJECT_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Filter,
                [
                    (0, $idpYy.JIRA_FILTER_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Plan,
                [
                    (0, $idpYy.JIRA_PLAN_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Board,
                [
                    (0, $idpYy.JIRA_BOARD_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Dashboard,
                [
                    (0, $idpYy.JIRA_DASHBOARD_ENTITY_ATI)
                ]
            ]
        ])
    ],
    [
        (0, $b4tvS.ProductKeys).JiraProductDiscovery,
        new Map([
            [
                (0, $2Znam.TypeFilterValueKey).Issue,
                [
                    (0, $idpYy.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Space,
                [
                    (0, $idpYy.JIRA_PROJECT_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Filter,
                [
                    (0, $idpYy.JIRA_FILTER_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Plan,
                [
                    (0, $idpYy.JIRA_PLAN_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Board,
                [
                    (0, $idpYy.JIRA_BOARD_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Dashboard,
                [
                    (0, $idpYy.JIRA_DASHBOARD_ENTITY_ATI)
                ]
            ]
        ])
    ],
    [
        (0, $b4tvS.ProductKeys).JiraServiceManagement,
        new Map([
            [
                (0, $2Znam.TypeFilterValueKey).Issue,
                [
                    (0, $idpYy.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Incident,
                [
                    (0, $idpYy.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Space,
                [
                    (0, $idpYy.JIRA_PROJECT_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Filter,
                [
                    (0, $idpYy.JIRA_FILTER_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Plan,
                [
                    (0, $idpYy.JIRA_PLAN_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Board,
                [
                    (0, $idpYy.JIRA_BOARD_ENTITY_ATI)
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Dashboard,
                [
                    (0, $idpYy.JIRA_DASHBOARD_ENTITY_ATI)
                ]
            ]
        ])
    ],
    [
        (0, $b4tvS.ProductKeys).Compass,
        new Map([
            [
                (0, $2Znam.TypeFilterValueKey).Component,
                [
                    'ati:cloud:compass:component'
                ]
            ]
        ])
    ],
    [
        (0, $b4tvS.ProductKeys).Focus,
        new Map([
            [
                (0, $2Znam.TypeFilterValueKey).FocusArea,
                [
                    'ati:cloud:mercury:focus-area',
                    'ati:cloud:mercury:focus-area-status-update'
                ]
            ]
        ])
    ],
    [
        (0, $b4tvS.ProductKeys).Talent,
        new Map([
            [
                (0, $2Znam.TypeFilterValueKey).Position,
                [
                    'ati:cloud:radar:position'
                ]
            ]
        ])
    ],
    [
        (0, $b4tvS.ProductKeys).Trello,
        new Map([
            [
                (0, $2Znam.TypeFilterValueKey).Card,
                [
                    'ati:cloud:trello:card'
                ]
            ]
        ])
    ],
    [
        (0, $b4tvS.ProductKeys).Atlas,
        new Map([
            [
                (0, $2Znam.TypeFilterValueKey).Project,
                [
                    'ati:cloud:townsquare:project'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Goal,
                [
                    'ati:cloud:townsquare:goal'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Tag,
                [
                    'ati:cloud:townsquare:tag'
                ]
            ]
        ])
    ],
    [
        (0, $b4tvS.ProductKeys).Bitbucket,
        new Map([
            [
                (0, $2Znam.TypeFilterValueKey).Commit,
                [
                    'ati:cloud:graph:commit'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).PullRequest,
                [
                    'ati:cloud:graph:pull-request'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Repository,
                [
                    'ati:cloud:graph:repository'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Branch,
                [
                    'ati:cloud:graph:branch'
                ]
            ]
        ])
    ],
    [
        (0, $b4tvS.ProductKeys).Assets,
        new Map([
            [
                (0, $2Znam.TypeFilterValueKey).AssetsObject,
                [
                    'ati:cloud:cmdb:object'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Schema,
                [
                    'ati:cloud:cmdb:schema'
                ]
            ],
            [
                (0, $2Znam.TypeFilterValueKey).Type,
                [
                    'ati:cloud:cmdb:type'
                ]
            ]
        ])
    ]
]);
const $b7f1b9f5c8cf1139$export$a185da63aca613f3 = [
    'ati:cloud:confluence:comment',
    'ati:cloud:confluence:attachment'
];
const $b7f1b9f5c8cf1139$export$598e74d591895feb = ()=>[
        ...$b7f1b9f5c8cf1139$export$a185da63aca613f3
    ];
let $b7f1b9f5c8cf1139$export$1a2d7de20763c66f;
const $b7f1b9f5c8cf1139$export$4b1ab8c60d2ecbf1 = ()=>{
    $b7f1b9f5c8cf1139$export$1a2d7de20763c66f = undefined; // Reset cache
};
const $b7f1b9f5c8cf1139$export$a7663ee59d66492f = ()=>{
    if ($b7f1b9f5c8cf1139$export$1a2d7de20763c66f) return $b7f1b9f5c8cf1139$export$1a2d7de20763c66f;
    const mappings = Object.fromEntries((0, $2Znam.allTypeFilterValueKeys).map((TypeFilterValueKey)=>{
        const baseMapping = {
            entities: {},
            products: [],
            subCategories: []
        };
        return [
            TypeFilterValueKey,
            baseMapping
        ];
    }));
    // Add all the 1P products
    $b7f1b9f5c8cf1139$var$typeFilter1PMapping.forEach((_, productKey1P)=>{
        $b7f1b9f5c8cf1139$var$typeFilter1PMapping.get(productKey1P)?.forEach((_, typeFilterValueKey)=>{
            mappings[typeFilterValueKey].products.push(productKey1P);
            mappings[typeFilterValueKey].entities[productKey1P] = $b7f1b9f5c8cf1139$var$typeFilter1PMapping.get(productKey1P)?.get(typeFilterValueKey);
        });
    });
    // Conditionally add passionfruit Ask type for Focus product
    if ((0, $dh538.fg)('platform_passionfruit_search_onboarding_enabled')) {
        mappings[(0, $2Znam.TypeFilterValueKey).Ask].products.push((0, $b4tvS.ProductKeys).Focus);
        mappings[(0, $2Znam.TypeFilterValueKey).Ask].entities[(0, $b4tvS.ProductKeys).Focus] = [
            'ati:cloud:passionfruit:ask'
        ];
    }
    // Conditionally add Mercury Risk type for Focus product so risk entities are only
    // requested from the backend when the risk search UI is enabled.
    if ((0, $dh538.fg)('platform_mercury_risk_search_ui_enabled')) {
        mappings[(0, $2Znam.TypeFilterValueKey).Risk].products.push((0, $b4tvS.ProductKeys).Focus);
        mappings[(0, $2Znam.TypeFilterValueKey).Risk].entities[(0, $b4tvS.ProductKeys).Focus] = [
            'ati:cloud:mercury:risk'
        ];
    }
    // Add all the 3P products
    (0, $a5RR2.ThirdPartyConfigsSync).forEach((thirdPartyConfig, productKey3P)=>{
        const typeFilterConfigs = thirdPartyConfig?.typeFilterConfig;
        if (!typeFilterConfigs) return;
        typeFilterConfigs.forEach((typeFilterValue3PEntities, typeFilterValueKey)=>{
            mappings[typeFilterValueKey].products.push(productKey3P);
            mappings[typeFilterValueKey].entities[productKey3P] = typeFilterValue3PEntities.entities3P;
            mappings[typeFilterValueKey].subCategories = [
                ...mappings[typeFilterValueKey].subCategories,
                ...typeFilterValue3PEntities.subTypes3P
            ];
            mappings[typeFilterValueKey].subCategories = [
                ...new Set(mappings[typeFilterValueKey].subCategories)
            ]; // dedupe
        });
    });
    $b7f1b9f5c8cf1139$export$1a2d7de20763c66f = mappings;
    return mappings;
};
const $b7f1b9f5c8cf1139$export$525857063443efa8 = (productKey, typeFilterConfig)=>{
    // Ensure cache is initialized before updating it
    if (!$b7f1b9f5c8cf1139$export$1a2d7de20763c66f) $b7f1b9f5c8cf1139$export$a7663ee59d66492f();
    if (!typeFilterConfig || typeFilterConfig.size === 0) return;
    typeFilterConfig.forEach((typeFilterValue3PEntities, typeFilterValueKey)=>{
        // Type guard: only process if it's a valid TypeFilterValueKey in our mapping
        if (!(typeFilterValueKey in $b7f1b9f5c8cf1139$export$1a2d7de20763c66f)) return;
        // Only add if not already present
        if (!$b7f1b9f5c8cf1139$export$1a2d7de20763c66f[typeFilterValueKey].products.includes(productKey)) $b7f1b9f5c8cf1139$export$1a2d7de20763c66f[typeFilterValueKey].products.push(productKey);
        $b7f1b9f5c8cf1139$export$1a2d7de20763c66f[typeFilterValueKey].entities[productKey] = typeFilterValue3PEntities.entities3P;
        $b7f1b9f5c8cf1139$export$1a2d7de20763c66f[typeFilterValueKey].subCategories = [
            ...$b7f1b9f5c8cf1139$export$1a2d7de20763c66f[typeFilterValueKey].subCategories,
            ...typeFilterValue3PEntities.subTypes3P
        ];
        $b7f1b9f5c8cf1139$export$1a2d7de20763c66f[typeFilterValueKey].subCategories = [
            ...new Set($b7f1b9f5c8cf1139$export$1a2d7de20763c66f[typeFilterValueKey].subCategories)
        ]; // dedupe
    });
};
module.exports["CONFLUENCE_COMMENTS_AND_ATTACHMENTS_ENTITIES"] = $b7f1b9f5c8cf1139$export$a185da63aca613f3;
module.exports["notRequestedATIsInAllSearch"] = $b7f1b9f5c8cf1139$export$598e74d591895feb;
module.exports["getTypeMapping"] = $b7f1b9f5c8cf1139$export$a7663ee59d66492f;
module.exports["registerForgeConnectorTypeMapping"] = $b7f1b9f5c8cf1139$export$525857063443efa8;

});

parcelRegister("idpYy", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $1OY0Y = parcelRequire("1OY0Y");


var $hCmMX = parcelRequire("hCmMX");


var $6PclE = parcelRequire("6PclE");


var $kO4OQ = parcelRequire("kO4OQ");

























const $d26db4dd231f5f64$export$a2818d866ea09b15 = 'ati:cloud:passionfruit:ask';
const $d26db4dd231f5f64$export$2d73983fb684eaa8 = 'ati:cloud:mercury:risk';
const $d26db4dd231f5f64$export$98b8a39f6a9e8fb2 = 'ati:cloud:mercury:organization';
const $d26db4dd231f5f64$export$db327a40079b14ba = 'ati:cloud:mercury:organization-status-update';
const $d26db4dd231f5f64$export$e105364f000374dd = ()=>[
        ...(0, $6PclE.DEFAULT_MERCURY_ENTITY_ATI),
        ...(0, $dh538.fg)('platform_passionfruit_search_onboarding_enabled') ? [
            $d26db4dd231f5f64$export$a2818d866ea09b15
        ] : [],
        ...(0, $dh538.fg)('platform_mercury_risk_search_ui_enabled') ? [
            $d26db4dd231f5f64$export$2d73983fb684eaa8
        ] : [],
        ...(0, $dh538.fg)('platform_organization_search_onboarding_enabled') ? [
            $d26db4dd231f5f64$export$98b8a39f6a9e8fb2,
            $d26db4dd231f5f64$export$db327a40079b14ba
        ] : []
    ];
const $d26db4dd231f5f64$export$2113db8105db1e2f = 'ati:cloud:confluence:';
const $d26db4dd231f5f64$export$fd9583608bfd5225 = 'confluence.com.atlassian.confluence.extra.team-calendars:calendar-content-type';
const $d26db4dd231f5f64$export$842fc5f4c9a103cc = 'confluence.com.atlassian.confluence.extra.team-calendars:space-calendars-view-content-type';
const $d26db4dd231f5f64$export$85fae06d428ca65d = 'confluence.ac:com.atlassian.confluence.plugins.confluence-questions:answer';
const $d26db4dd231f5f64$export$de533c0a50cfcba1 = 'confluence.ac:com.atlassian.confluence.plugins.confluence-questions:question';
const $d26db4dd231f5f64$export$bcdd6265f8049b41 = 'confluence.ac:com.gliffy.integration.confluence:gliffy-diagram';
const $d26db4dd231f5f64$export$4fb210ecd60bcccb = 'ati:cloud:jira:issue';
const $d26db4dd231f5f64$export$2d84b48cf0a2eca6 = 'ati:cloud:jira:project';
const $d26db4dd231f5f64$export$68f33db8fcc8984d = 'ati:cloud:jira:filter';
const $d26db4dd231f5f64$export$1f91fc8e40b54c58 = 'ati:cloud:jira:dashboard';
const $d26db4dd231f5f64$export$b1c20fb509d2d550 = 'ati:cloud:jira:board';
const $d26db4dd231f5f64$export$fdd5ab530ffed95b = 'ati:cloud:jira:plan';
const $d26db4dd231f5f64$export$b4a7e1c18385196d = [
    $d26db4dd231f5f64$export$2d84b48cf0a2eca6,
    $d26db4dd231f5f64$export$4fb210ecd60bcccb,
    $d26db4dd231f5f64$export$68f33db8fcc8984d,
    $d26db4dd231f5f64$export$1f91fc8e40b54c58,
    $d26db4dd231f5f64$export$b1c20fb509d2d550,
    $d26db4dd231f5f64$export$fdd5ab530ffed95b
];
const $d26db4dd231f5f64$export$6ec0530ffade9ab0 = 'ati:third-party:google:email';
const $d26db4dd231f5f64$export$dfd3b612305212b4 = 'ati:third-party:microsoft:email';
const $d26db4dd231f5f64$export$50adf3273cb5cdeb = [
    $d26db4dd231f5f64$export$6ec0530ffade9ab0,
    $d26db4dd231f5f64$export$dfd3b612305212b4
];
const $d26db4dd231f5f64$export$46827d4f79048f80 = ()=>[
        ...(0, $1OY0Y.DEFAULT_ATLAS_ENTITY_ATI),
        ...(0, $hCmMX.DEFAULT_CONFLUENCE_ENTITY_ATI),
        ...$d26db4dd231f5f64$export$b4a7e1c18385196d,
        ...$d26db4dd231f5f64$export$e105364f000374dd(),
        ...(0, $kO4OQ.DEFAULT_TALENT_ENTITY_ATI)
    ];
const $d26db4dd231f5f64$export$423da9b1dcd76b7 = 15;
const $d26db4dd231f5f64$export$405ff9c6ee9ee7de = 30;
module.exports["CONFLUENCE_CALENDAR_ENTITY_ATI"] = $d26db4dd231f5f64$export$fd9583608bfd5225;
module.exports["CONFLUENCE_SPACE_CALENDAR_ENTITY_ATI"] = $d26db4dd231f5f64$export$842fc5f4c9a103cc;
module.exports["CONFLUENCE_ANSWER_ENTITY_ATI"] = $d26db4dd231f5f64$export$85fae06d428ca65d;
module.exports["CONFLUENCE_QUESTION_ENTITY_ATI"] = $d26db4dd231f5f64$export$de533c0a50cfcba1;
module.exports["CONFLUENCE_GLIFFY_ENTITY_ATI"] = $d26db4dd231f5f64$export$bcdd6265f8049b41;
module.exports["JIRA_ISSUE_ENTITY_ATI"] = $d26db4dd231f5f64$export$4fb210ecd60bcccb;
module.exports["JIRA_PROJECT_ENTITY_ATI"] = $d26db4dd231f5f64$export$2d84b48cf0a2eca6;
module.exports["JIRA_FILTER_ENTITY_ATI"] = $d26db4dd231f5f64$export$68f33db8fcc8984d;
module.exports["JIRA_DASHBOARD_ENTITY_ATI"] = $d26db4dd231f5f64$export$1f91fc8e40b54c58;
module.exports["JIRA_BOARD_ENTITY_ATI"] = $d26db4dd231f5f64$export$b1c20fb509d2d550;
module.exports["JIRA_PLAN_ENTITY_ATI"] = $d26db4dd231f5f64$export$fdd5ab530ffed95b;
module.exports["getDefaultEntityAti"] = $d26db4dd231f5f64$export$46827d4f79048f80;
module.exports["RESULT_LIMIT_FOR_MULTIPLE_PRODUCTS"] = $d26db4dd231f5f64$export$423da9b1dcd76b7;
module.exports["RESULT_LIMIT_FOR_SINGLE_PRODUCT"] = $d26db4dd231f5f64$export$405ff9c6ee9ee7de;

});

parcelRegister("7YJRT", function(module, exports) {
const $d5857497b441ad7f$export$c28231fcae6448eb = [
    'ati:cloud:graph:repository'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI"] = $d5857497b441ad7f$export$c28231fcae6448eb;

});

parcelRegister("731W9", function(module, exports) {

var $7azCD = parcelRequire("7azCD");

const $f17e6b432d346cfd$export$e9131c78c1110376 = (str)=>(0, $7azCD.sha256)(str);
module.exports["sha256Hash"] = $f17e6b432d346cfd$export$e9131c78c1110376;

});

parcelRegister("4VmlX", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $9zUhf = parcelRequire("9zUhf");

var $FOT9i = parcelRequire("FOT9i");

var $1P1Tu = parcelRequire("1P1Tu");

const $3dbdec4d6deb14f5$export$d4c72bab9d6cc13a = {
    quickFindOpen: false,
    quickFindQuery: '',
    isFeedbackModalOpen: false,
    retryCount: 0,
    updateRecentQueries: undefined,
    updateZeroQueries: undefined,
    selectedQueryFilters: [],
    openHoverCardId: null,
    searchErrors: []
};
const $3dbdec4d6deb14f5$var$actions = {
    setQuickFindOpen: (quickFindOpen)=>({ setState: setState })=>{
            setState({
                quickFindOpen: quickFindOpen
            });
        },
    setQuickFindQuery: (quickFindQuery)=>({ setState: setState })=>{
            setState({
                quickFindQuery: quickFindQuery
            });
        },
    setContent: (content)=>({ setState: setState })=>{
            setState({
                content: content
            });
        },
    setIsFeedbackModalOpen: (isFeedbackModalOpen)=>({ setState: setState })=>{
            setState({
                isFeedbackModalOpen: isFeedbackModalOpen
            });
        },
    setRetryCount: (retryCount)=>({ setState: setState })=>{
            setState({
                retryCount: retryCount
            });
        },
    setFetchSpacesRequestId: (fetchSpacesRequestId)=>({ setState: setState })=>{
            setState({
                fetchSpacesRequestId: fetchSpacesRequestId
            });
        },
    setFetchEntitiesRequestId: (fetchEntitiesRequestId)=>({ setState: setState })=>{
            setState({
                fetchEntitiesRequestId: fetchEntitiesRequestId
            });
        },
    setFetchEntitiesTraceId: (fetchEntitiesTraceId)=>({ setState: setState })=>{
            setState({
                fetchEntitiesTraceId: fetchEntitiesTraceId
            });
        },
    setSearchErrors: (searchErrors)=>({ setState: setState })=>{
            setState({
                searchErrors: searchErrors
            });
        },
    setUpdateRecentQueries: (updateRecentQueries)=>({ setState: setState })=>{
            setState({
                updateRecentQueries: updateRecentQueries
            });
        },
    setUpdateZeroQueries: (updateZeroQueries)=>({ setState: setState })=>{
            setState({
                updateZeroQueries: updateZeroQueries
            });
        },
    addSelectedQueryFilter: (queryFilter)=>({ setState: setState, getState: getState })=>{
            const { selectedQueryFilters: selectedQueryFilters } = getState();
            const duplicate = selectedQueryFilters.find((currentQueryFilter)=>(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(JSON.stringify(currentQueryFilter), JSON.stringify(queryFilter)));
            if (!duplicate) setState({
                selectedQueryFilters: [
                    ...selectedQueryFilters,
                    queryFilter
                ]
            });
        },
    deleteSelectedQueryFilter: (queryFilter)=>({ setState: setState, getState: getState })=>{
            const { selectedQueryFilters: selectedQueryFilters } = getState();
            const newSelectedQueryFilters = selectedQueryFilters.filter((currentQueryFilter)=>!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(JSON.stringify(currentQueryFilter), JSON.stringify(queryFilter)));
            setState({
                selectedQueryFilters: newSelectedQueryFilters
            });
        },
    resetSelectedQueryFilters: ()=>({ setState: setState })=>{
            setState({
                selectedQueryFilters: []
            });
        },
    setCurrentQueryFilter: (currentQueryFilter)=>({ setState: setState })=>{
            setState({
                currentQueryFilter: currentQueryFilter
            });
        },
    setHoverCardOpen: (itemId, isOpen)=>({ setState: setState, getState: getState })=>{
            const { openHoverCardId: openHoverCardId } = getState();
            if (isOpen) setState({
                openHoverCardId: itemId
            });
            else if (openHoverCardId === itemId) setState({
                openHoverCardId: null
            });
        }
};
const $3dbdec4d6deb14f5$var$Store = (0, $1P1Tu.createStore)({
    initialState: $3dbdec4d6deb14f5$export$d4c72bab9d6cc13a,
    actions: $3dbdec4d6deb14f5$var$actions,
    name: 'quick-find'
});
const $3dbdec4d6deb14f5$export$5125bb5a97b0c344 = (0, $9zUhf.createActionsHook)($3dbdec4d6deb14f5$var$Store);
const $3dbdec4d6deb14f5$export$6f7ec6ed84e85154 = (0, $9zUhf.createStateHook)($3dbdec4d6deb14f5$var$Store, {
    selector: (state)=>state.quickFindOpen
});
const $3dbdec4d6deb14f5$export$db9af4f90ab0e536 = (0, $9zUhf.createStateHook)($3dbdec4d6deb14f5$var$Store, {
    selector: (state)=>state.quickFindQuery
});
const $3dbdec4d6deb14f5$export$ee83783e2ce4cc63 = (0, $9zUhf.createStateHook)($3dbdec4d6deb14f5$var$Store, {
    selector: (state)=>state.content
});
const $3dbdec4d6deb14f5$export$5bdbafc4abc135c7 = (0, $9zUhf.createHook)($3dbdec4d6deb14f5$var$Store, {
    selector: (state)=>state.isFeedbackModalOpen
});
const $3dbdec4d6deb14f5$export$140d37088821fcb1 = (0, $9zUhf.createStateHook)($3dbdec4d6deb14f5$var$Store, {
    selector: (state)=>state.retryCount
});
const $3dbdec4d6deb14f5$export$e260c85752b77e7c = (0, $9zUhf.createStateHook)($3dbdec4d6deb14f5$var$Store, {
    selector: (state)=>state.fetchSpacesRequestId
});
const $3dbdec4d6deb14f5$export$8d6bc416cb50c4b8 = (0, $9zUhf.createStateHook)($3dbdec4d6deb14f5$var$Store, {
    selector: (state)=>state.fetchEntitiesRequestId
});
const $3dbdec4d6deb14f5$export$83bd9ae2aed68ab4 = (0, $9zUhf.createStateHook)($3dbdec4d6deb14f5$var$Store, {
    selector: (state)=>state.fetchEntitiesTraceId
});
const $3dbdec4d6deb14f5$export$65391f387dac24a5 = (0, $9zUhf.createStateHook)($3dbdec4d6deb14f5$var$Store, {
    selector: (state)=>state.updateRecentQueries
});
const $3dbdec4d6deb14f5$export$4c5c5c3d8a37ed5d = (0, $9zUhf.createStateHook)($3dbdec4d6deb14f5$var$Store, {
    selector: (state)=>state.updateZeroQueries
});
const $3dbdec4d6deb14f5$export$285abcbc8aa402a2 = (0, $9zUhf.createStateHook)($3dbdec4d6deb14f5$var$Store, {
    selector: (state)=>state.selectedQueryFilters
});
const $3dbdec4d6deb14f5$export$31b21a5d8580f4a9 = (0, $9zUhf.createStateHook)($3dbdec4d6deb14f5$var$Store, {
    selector: (state)=>state.currentQueryFilter
});
const $3dbdec4d6deb14f5$export$d25011725d5aa3a6 = (0, $9zUhf.createStateHook)($3dbdec4d6deb14f5$var$Store, {
    selector: (state)=>state.searchErrors || []
});
const $3dbdec4d6deb14f5$export$3e5bb5570cf53089 = (0, $FOT9i.createContainer)($3dbdec4d6deb14f5$var$Store);
module.exports["useQuickFindActions"] = $3dbdec4d6deb14f5$export$5125bb5a97b0c344;
module.exports["useQuickFindOpen"] = $3dbdec4d6deb14f5$export$6f7ec6ed84e85154;
module.exports["useQuickFindQuery"] = $3dbdec4d6deb14f5$export$db9af4f90ab0e536;
module.exports["useContent"] = $3dbdec4d6deb14f5$export$ee83783e2ce4cc63;
module.exports["useIsFeedbackModalOpen"] = $3dbdec4d6deb14f5$export$5bdbafc4abc135c7;
module.exports["useFetchSpacesRequestId"] = $3dbdec4d6deb14f5$export$e260c85752b77e7c;
module.exports["useFetchEntitiesRequestId"] = $3dbdec4d6deb14f5$export$8d6bc416cb50c4b8;
module.exports["useFetchEntitiesTraceId"] = $3dbdec4d6deb14f5$export$83bd9ae2aed68ab4;
module.exports["useUpdateRecentQueries"] = $3dbdec4d6deb14f5$export$65391f387dac24a5;
module.exports["useUpdateZeroQueries"] = $3dbdec4d6deb14f5$export$4c5c5c3d8a37ed5d;
module.exports["useSelectedQueryFilters"] = $3dbdec4d6deb14f5$export$285abcbc8aa402a2;
module.exports["useCurrentQueryFilter"] = $3dbdec4d6deb14f5$export$31b21a5d8580f4a9;
module.exports["useSearchErrors"] = $3dbdec4d6deb14f5$export$d25011725d5aa3a6;
module.exports["QuickFindStoreContainer"] = $3dbdec4d6deb14f5$export$3e5bb5570cf53089;

});

parcelRegister("6RGiC", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dZJhp = parcelRequire("dZJhp");


var $2OtFZ = parcelRequire("2OtFZ");

function $14c4c6592d363aae$export$865a2f088c837665() {
    const { canAnimate: canAnimate } = (0, $dZJhp.useConnectAppsCooldown)();
    const isConnectAppsPillEnabled = (0, $2OtFZ.serveSearchSettingsModalExperiment)({
        fireExperimentExposure: false
    });
    const suppressAtMount = (0, $42omo.useRef)(isConnectAppsPillEnabled && canAnimate());
    return suppressAtMount.current;
}
module.exports["useShouldSuppressBannerForAnimation"] = $14c4c6592d363aae$export$865a2f088c837665;

});

parcelRegister("eO6NY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $dQN1U = parcelRequire("dQN1U");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $9d9t8 = parcelRequire("9d9t8");


var $5A2fk = parcelRequire("5A2fk");


var $6yNqK = parcelRequire("6yNqK");


var $9rRKJ = parcelRequire("9rRKJ");

const $6bc35c1d306bd8b4$export$6244fd8f3fa9025d = ({ cloudId: cloudId, experience: experience, productCount: productCount, usages: usages })=>{
    return {
        action: 'taskSuccess',
        actionSubject: 'smartLinkUsageFetch',
        eventType: 'operational',
        source: experience === (0, $9rRKJ.SearchExperience).QUICK_FIND ? (0, $6yNqK.SEARCH_DIALOG_EVENT_SOURCE) : (0, $6yNqK.EVENT_SOURCE),
        attributes: {
            additionalAttributes: {
                cloudId: cloudId,
                productCount: productCount,
                usages: usages ? JSON.stringify(usages) : undefined
            }
        }
    };
};
const $6bc35c1d306bd8b4$export$973cdfe8c0b26a2b = ({ cloudId: cloudId, experience: experience, reason: reason })=>{
    return {
        action: 'taskFail',
        actionSubject: 'smartLinkUsageFetch',
        eventType: 'operational',
        source: experience === (0, $9rRKJ.SearchExperience).QUICK_FIND ? (0, $6yNqK.SEARCH_DIALOG_EVENT_SOURCE) : (0, $6yNqK.EVENT_SOURCE),
        attributes: {
            additionalAttributes: {
                cloudId: cloudId,
                reason: reason
            }
        }
    };
};



var $2OtFZ = parcelRequire("2OtFZ");


var $a5RR2 = parcelRequire("a5RR2");


var $78z3f = parcelRequire("78z3f");







const $852be0f093bb3acb$export$98ca9e3e34f377b = ({ isOnSearchDialog: isOnSearchDialog, thirdPartyConfigs: thirdPartyConfigs, availableProducts: availableProducts })=>{
    let productOrder = [];
    if (isOnSearchDialog) // TODO: we should consolidate the behaviour of banners between FPS and QF (both order and what products are shown).
    // See https://atlassian.slack.com/archives/C0A8GKLU6PQ/p1770850523754429
    productOrder = [
        (0, $78z3f.ProductKeys3P).GoogleDrive,
        (0, $78z3f.ProductKeys3P).Sharepoint,
        (0, $78z3f.ProductKeys3P).Slack,
        (0, $78z3f.ProductKeys3P).Teams,
        (0, $78z3f.ProductKeys3P).Github,
        (0, $78z3f.ProductKeys3P).Figma,
        (0, $78z3f.ProductKeys3P).Gitbook
    ];
    else {
        const requiredProducts = [];
        (0, $a5RR2.ThirdPartyConfigsSync).forEach((_, productKey3P)=>{
            if ((0, $a5RR2.ThirdPartyConfigsSync).get(productKey3P)?.requiresOauth) requiredProducts.push(productKey3P);
        });
        // Filter and order static products based on PRODUCTS_ORDER
        const staticProducts = (0, $b4tvS.PRODUCTS_ORDER).filter((product)=>requiredProducts.includes(product));
        // Add Forge connectors that need OAuth (ordered after static products)
        const forgeConnectors = availableProducts.filter((product)=>(0, $9d9t8.isForgeConnectorProductKey)(product) && thirdPartyConfigs[product]?.userNeedsOAuth && thirdPartyConfigs[product]?.outboundAuthUrl);
        productOrder = [
            ...staticProducts,
            ...forgeConnectors
        ];
    }
    return productOrder.filter((product)=>availableProducts.includes(product));
};



var $3CshZ = parcelRequire("3CshZ");


var $j4ply = parcelRequire("j4ply");




const $77eea1065ff0fa88$export$ce0553f0f2dae7c8 = {
    'widely-adopted': 25,
    'mid-adoption': 15,
    niche: 10
};
const $77eea1065ff0fa88$export$b64145217f45680a = {
    'widely-adopted': new Set([
        (0, $78z3f.ProductKeys3P).GoogleDrive,
        (0, $78z3f.ProductKeys3P).Slack,
        (0, $78z3f.ProductKeys3P).Github,
        (0, $78z3f.ProductKeys3P).Figma,
        (0, $78z3f.ProductKeys3P).OneDrive,
        (0, $78z3f.ProductKeys3P).Gitlab,
        (0, $78z3f.ProductKeys3P).AzureDevops,
        (0, $78z3f.ProductKeys3P).Sentry,
        (0, $78z3f.ProductKeys3P).Miro,
        (0, $78z3f.ProductKeys3P).Salesforce,
        (0, $78z3f.ProductKeys3P).Notion,
        (0, $78z3f.ProductKeys3P).Sharepoint
    ]),
    'mid-adoption': new Set([
        (0, $78z3f.ProductKeys3P).Pipedrive,
        (0, $78z3f.ProductKeys3P).Box,
        (0, $78z3f.ProductKeys3P).ClickUp,
        (0, $78z3f.ProductKeys3P).Hubspot,
        (0, $78z3f.ProductKeys3P).Asana
    ]),
    niche: new Set([
        (0, $78z3f.ProductKeys3P).Todoist,
        (0, $78z3f.ProductKeys3P).Zeplin,
        (0, $78z3f.ProductKeys3P).Dropbox,
        (0, $78z3f.ProductKeys3P).Lucid,
        (0, $78z3f.ProductKeys3P).Amplitude,
        (0, $78z3f.ProductKeys3P).Mural,
        (0, $78z3f.ProductKeys3P).Airtable,
        (0, $78z3f.ProductKeys3P).LaunchDarkly,
        (0, $78z3f.ProductKeys3P).Stripe,
        (0, $78z3f.ProductKeys3P).Smartsheet,
        (0, $78z3f.ProductKeys3P).Docusign,
        (0, $78z3f.ProductKeys3P).PagerDuty,
        (0, $78z3f.ProductKeys3P).Teams,
        (0, $78z3f.ProductKeys3P).Dovetail,
        (0, $78z3f.ProductKeys3P).Webex
    ])
};
// Reverse lookup for quicker/easier product → tier resolution.
const $77eea1065ff0fa88$var$CONNECTOR_TO_TIER = new Map(Object.entries($77eea1065ff0fa88$export$b64145217f45680a).flatMap(([tier, products])=>[
        ...products
    ].map((product)=>[
            product,
            tier
        ])));
const $77eea1065ff0fa88$export$bcc396963ce06343 = (product)=>{
    return $77eea1065ff0fa88$var$CONNECTOR_TO_TIER.get(product) ?? 'niche';
};
const $77eea1065ff0fa88$export$fb50a930cc5288bf = (product)=>{
    return $77eea1065ff0fa88$export$ce0553f0f2dae7c8[$77eea1065ff0fa88$export$bcc396963ce06343(product)];
};
const $77eea1065ff0fa88$export$835ec42bc9d6e801 = (product, usagePercent)=>{
    if (usagePercent === undefined) return true;
    const threshold = $77eea1065ff0fa88$export$fb50a930cc5288bf(product);
    return usagePercent >= threshold;
};


const $70a27aa1b7fe8948$export$8e364fc6aecba9a9 = (experience, cloudId)=>{
    const [smartLinkUsage, setSmartLinkUsage] = (0, $42omo.useState)(undefined);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)({
        experience: experience
    });
    // NO EXPOSURE! Allocate to short-circuit the hook if the experiment is disabled.
    const bannerTargetingCohort = (0, $2OtFZ.serveImproveBannerTargetingExperiment)({
        fireExperimentExposure: false
    });
    (0, $42omo.useEffect)(()=>{
        if (bannerTargetingCohort === 'usage-threshold' && cloudId) (0, $dQN1U.getTenantSmartlinkUsage)({
            siteId: cloudId
        }).then((usageData)=>{
            setSmartLinkUsage(usageData);
            fireAnalyticsEvent((0, $6bc35c1d306bd8b4$export$6244fd8f3fa9025d)({
                cloudId: cloudId,
                experience: experience,
                productCount: Object.keys(usageData).length,
                usages: usageData
            }));
        }).catch((error)=>{
            fireAnalyticsEvent((0, $6bc35c1d306bd8b4$export$973cdfe8c0b26a2b)({
                cloudId: cloudId,
                experience: experience,
                reason: error instanceof Error ? error.message : String(error)
            }));
        });
    }, [
        bannerTargetingCohort,
        cloudId,
        experience,
        fireAnalyticsEvent
    ]);
    return smartLinkUsage;
};
const $70a27aa1b7fe8948$export$7e6da2e188a2a79d = ({ products: products, thirdPartyConfigs: thirdPartyConfigs })=>{
    // NO EXPOSURE! Allocate to short-circuit the hook if the experiment is disabled.
    const cohort = (0, $2OtFZ.serveImproveBannerTargetingExperiment)({
        fireExperimentExposure: false
    });
    const isUsageThresholdCohort = cohort === 'usage-threshold';
    const isBannerOptedOut = (0, $dh538.fg)('rovo_search_3p_banner_opt_out');
    const isActive = isUsageThresholdCohort && !isBannerOptedOut;
    const usageData = (0, $j4ply.useSmartLinkUsage)();
    return (0, $42omo.useMemo)(()=>{
        if (!isActive || !usageData) return products;
        return products.filter((product)=>{
            const config = thirdPartyConfigs[product];
            const isSmartlinksOnly = config?.connectorSources?.includes((0, $9d9t8.SMARTLINKS_CONNECTOR_SOURCE)) && !config?.connectorSources?.includes((0, $9d9t8.FULL_CONNECTOR_SOURCE));
            // The logic to hide banners based on usage is only applicable to smart-link connectors
            // and only if there's no full-connector for the same product.
            if (!isSmartlinksOnly) return true;
            return (0, $77eea1065ff0fa88$export$835ec42bc9d6e801)(product, usageData[product]);
        });
    }, [
        isActive,
        usageData,
        products,
        thirdPartyConfigs
    ]);
};
const $70a27aa1b7fe8948$export$51f63d7c1c9ec5d4 = ({ isOnSearchDialog: isOnSearchDialog, thirdPartyConfigs: thirdPartyConfigs, availableProducts: availableProducts })=>{
    const bannerTargetingCohort = (0, $2OtFZ.serveImproveBannerTargetingExperiment)();
    const orderedAvailableProducts = (0, $42omo.useMemo)(()=>(0, $852be0f093bb3acb$export$98ca9e3e34f377b)({
            isOnSearchDialog: isOnSearchDialog,
            thirdPartyConfigs: thirdPartyConfigs,
            availableProducts: availableProducts
        }), [
        isOnSearchDialog,
        thirdPartyConfigs,
        availableProducts
    ]);
    const productsWithSufficientUsage = $70a27aa1b7fe8948$export$7e6da2e188a2a79d({
        products: orderedAvailableProducts,
        thirdPartyConfigs: thirdPartyConfigs
    });
    const orderedAvailableProductsAfterUsageFilter = (0, $42omo.useMemo)(()=>{
        if (bannerTargetingCohort === 'usage-threshold' && productsWithSufficientUsage?.length) return orderedAvailableProducts.filter((p)=>productsWithSufficientUsage.includes(p));
        return orderedAvailableProducts;
    }, [
        orderedAvailableProducts,
        bannerTargetingCohort,
        productsWithSufficientUsage
    ]);
    if (!isOnSearchDialog && availableProducts.includes((0, $b4tvS.ProductKeys).Github) && (0, $2OtFZ.serveFPSGitHubAuthBannerPromo)({
        thirdPartyConfigs: thirdPartyConfigs
    })) return (0, $5A2fk.isProductSnoozed)((0, $b4tvS.ProductKeys).Github) ? [] : [
        (0, $b4tvS.ProductKeys).Github
    ];
    const enforceMaxDismissals = true;
    return orderedAvailableProductsAfterUsageFilter.filter((product)=>(0, $5A2fk.shouldShowOAuthBanner)(product, enforceMaxDismissals));
};
module.exports["useFetchSmartLinkUsage"] = $70a27aa1b7fe8948$export$8e364fc6aecba9a9;
module.exports["useBannerEligibleProductsOrder"] = $70a27aa1b7fe8948$export$51f63d7c1c9ec5d4;

});

parcelRegister("dQN1U", function(module, exports) {

var $2qzBQ = parcelRequire("2qzBQ");


var $jnPv4 = parcelRequire("jnPv4");


var $3Tbc2 = parcelRequire("3Tbc2");


var $i1nCm = parcelRequire("i1nCm");


var $78yNl = parcelRequire("78yNl");

const { refreshOnAccessDecorator: $3ce7a2ca8bed97b9$var$refreshOnAccessDecoratorSmartlink, get: $3ce7a2ca8bed97b9$var$getSmartlinkCache, clear: $3ce7a2ca8bed97b9$var$clearSmartlinkCache } = (0, $jnPv4.promiseCache)({
    name: (0, $i1nCm.SEARCH_PERSONALIZATION_SMARTLINK_SITE_CACHE_KEY),
    expiration: (0, $i1nCm.SEVEN_DAY_MS_TTL)
});
const $3ce7a2ca8bed97b9$var$fetchSiteSmartlinkService = async (siteId)=>{
    const requestUrl = (0, $78yNl.getSmartlinkSiteTraitsUrl)(siteId);
    const requestOptions = {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return fetch(requestUrl, requestOptions).then((response)=>{
        if (response.ok) return response.json();
        return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
    });
};
const $3ce7a2ca8bed97b9$var$fetchSmartlinkProductUsageRate = async ({ siteId: siteId, analyticsCallback: analyticsCallback, cacheKeySuffix: cacheKeySuffix, degradationCallback: degradationCallback = ()=>{} })=>{
    const key = (0, $2qzBQ.generateHash)(`${(0, $i1nCm.SEARCH_PERSONALIZATION_SMARTLINK_SITE_CACHE_KEY)}|${siteId}|${cacheKeySuffix}`);
    const supplier = async ()=>{
        const fetchPromise = $3ce7a2ca8bed97b9$var$fetchSiteSmartlinkService(siteId).then((data)=>{
            const { attributes: attributes } = data;
            return attributes?.find((t)=>t.name === (0, $i1nCm.SMARTLINK_APP_EXPOSURE_RATE_TRAIT));
        }).catch(()=>undefined); // treat non-200 as empty and avoid caching a rejected promise
        const degrader = new (0, $3Tbc2.DegradablePromise)(fetchPromise, degradationCallback, 1000); // 1s degrade threshold
        return degrader.promise().catch(async (e)=>{
            // On degrade/timeout, re-set cache entry to resolved undefined with ONE_HOUR_TTL
            // so callers won't hammer the service for the next hour, but will retry after.
            // Since we're in supplier, we can't directly set here without re-entrant complexity.
            // Instead, throw and let refreshOnAccessDecorator store this rejecting promise; after this call,
            // callers should rely on our external code path to clear or retry as needed.
            throw e;
        });
    };
    const existing = $3ce7a2ca8bed97b9$var$getSmartlinkCache(key.toString());
    // Choose TTL based on outcome:
    // - success (non-empty trait): default SEVEN_DAY_TTL
    // - empty (undefined): ONE_DAY_TTL
    // - degraded (timeout/reject): ONE_HOUR_TTL
    // We cannot know the outcome until supplier resolves/rejects; so we approximate:
    //   if no existing value, we assume empty path (ONE_HOUR_MS_TTL) to avoid hammering
    //   then, within supplier, we adjust by re-setting the cache on rejection with ONE_HOUR_TTL
    const effectiveExpiration = !existing?.storedValue ? (0, $i1nCm.ONE_HOUR_MS_TTL) : undefined;
    const effectiveOnlyRefreshIfExpired = true;
    // Helper to re-write the cached value with a specific TTL without re-fetching
    const writeBackWithTTL = (value, ttl)=>{
        $3ce7a2ca8bed97b9$var$refreshOnAccessDecoratorSmartlink({
            key: key.toString(),
            supplier: async ()=>value,
            returnExpired: false,
            onlyRefreshIfExpired: false,
            // force refresh to apply new TTL
            expiration: ttl
        });
    };
    return $3ce7a2ca8bed97b9$var$refreshOnAccessDecoratorSmartlink({
        key: key.toString(),
        supplier: async ()=>{
            try {
                const result = await supplier(); // Trait | undefined (no degrade)
                if (result) writeBackWithTTL(result, (0, $i1nCm.SEVEN_DAY_MS_TTL));
                else writeBackWithTTL(undefined, (0, $i1nCm.ONE_DAY_MS_TTL));
                return result;
            } catch  {
                // On degrade/timeout, return undefined so promiseCache stores an "empty" value
                // and then write back a short TTL to avoid hammering
                writeBackWithTTL(undefined, (0, $i1nCm.ONE_HOUR_MS_TTL));
                return undefined;
            }
        },
        onlyRefreshIfExpired: effectiveOnlyRefreshIfExpired,
        expiration: effectiveExpiration,
        analyticsCallback: analyticsCallback
    });
};
const $3ce7a2ca8bed97b9$export$a618d8f3094322c9 = (key)=>$3ce7a2ca8bed97b9$var$clearSmartlinkCache(key);
const $3ce7a2ca8bed97b9$export$f0ea64eab9ebcb2f = (trait)=>{
    if (trait?.name === (0, $i1nCm.SMARTLINK_APP_EXPOSURE_RATE_TRAIT) && typeof trait?.value === 'string') {
        const result = {};
        const pairs = trait.value.split(',').map((s)=>s.trim());
        for (const pair of pairs){
            const [app, rateStr] = pair.split(':').map((s)=>s.trim());
            if (app && rateStr) {
                const rate = parseInt(rateStr, 10);
                if (!isNaN(rate)) result[app] = rate;
            }
        }
        return result;
    }
    return {};
};
const $3ce7a2ca8bed97b9$export$b95bec45d0bca567 = async ({ siteId: siteId, analyticsCallback: analyticsCallback, degradationCallback: degradationCallback })=>{
    if (!siteId) return {};
    const trait = await $3ce7a2ca8bed97b9$var$fetchSmartlinkProductUsageRate({
        siteId: siteId,
        analyticsCallback: analyticsCallback,
        degradationCallback: degradationCallback,
        cacheKeySuffix: 'rovo-search-smartlink-usage'
    });
    return $3ce7a2ca8bed97b9$export$f0ea64eab9ebcb2f(trait);
};
module.exports["getTenantSmartlinkUsage"] = $3ce7a2ca8bed97b9$export$b95bec45d0bca567;

});

parcelRegister("i1nCm", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ const $8a8890853317d663$export$34e8837a1913e572 = 'search-personalization-site-user';
const $8a8890853317d663$export$f80bd7d8a13f050a = 604800000; // 7 days
const $8a8890853317d663$export$18406d9c8318a338 = 86400000; // 1 day
const $8a8890853317d663$export$2383b9b3bc711073 = 3600000; // 1 hour
const $8a8890853317d663$export$d0bbd8e7f2e797 = 'search_user_3p_recommendations_right_panel_v1';
const $8a8890853317d663$export$330c7df40d69ab27 = 'search-personalization-smartlink-site';
const $8a8890853317d663$export$15fc832cc21ada61 = 'smartlink_app_exposure_rate';
const $8a8890853317d663$export$c25c73d04a24471b = 'search-personalization-smartlink-usage-and-top-apps-site';
const $8a8890853317d663$export$7b7ea824b946adee = 'rovo_nudge_end_user_rendered_smartlinks_percent_and_most_used_apps';
module.exports["SEARCH_PERSONALIZATION_BY_SITE_USER_CACHE_KEY"] = $8a8890853317d663$export$34e8837a1913e572;
module.exports["SEVEN_DAY_MS_TTL"] = $8a8890853317d663$export$f80bd7d8a13f050a;
module.exports["ONE_DAY_MS_TTL"] = $8a8890853317d663$export$18406d9c8318a338;
module.exports["ONE_HOUR_MS_TTL"] = $8a8890853317d663$export$2383b9b3bc711073;
module.exports["RIGHT_PANEL_TRAIT"] = $8a8890853317d663$export$d0bbd8e7f2e797;
module.exports["SEARCH_PERSONALIZATION_SMARTLINK_SITE_CACHE_KEY"] = $8a8890853317d663$export$330c7df40d69ab27;
module.exports["SMARTLINK_APP_EXPOSURE_RATE_TRAIT"] = $8a8890853317d663$export$15fc832cc21ada61;
module.exports["SEARCH_PERSONALIZATION_SMARTLINK_USAGE_AND_TOP_APPS_SITE_CACHE_KEY"] = $8a8890853317d663$export$c25c73d04a24471b;
module.exports["SMARTLINK_USAGE_AND_TOP_APPS_TRAIT"] = $8a8890853317d663$export$7b7ea824b946adee;

});

parcelRegister("jwO5V", function(module, exports) {
function $ed96d079e7dec7ba$export$2066b2fdce449999({ atlWorkspaceId: atlWorkspaceId, tenantId: tenantId, product: product }) {
    const atlAttributionHeader = {
        atlWorkspaceId: atlWorkspaceId,
        tenantId: tenantId,
        product: product
    };
    return JSON.stringify(atlAttributionHeader);
}
function $ed96d079e7dec7ba$export$dbbc0a36865f0300({ cloudId: cloudId, product: product = 'platform', activationId: activationId }) {
    if (!cloudId) return undefined;
    const atlWorkspaceId = activationId ? `ari:cloud:${product}:${cloudId}:workspace/${activationId}` : undefined;
    const headerValue = $ed96d079e7dec7ba$export$2066b2fdce449999({
        ...atlWorkspaceId ? {
            atlWorkspaceId: atlWorkspaceId
        } : {},
        tenantId: cloudId,
        product: product
    });
    return {
        'atl-attribution': headerValue
    };
}
module.exports["createAtlAttributionHeaderValue"] = $ed96d079e7dec7ba$export$2066b2fdce449999;
module.exports["buildAtlAttributionHeaders"] = $ed96d079e7dec7ba$export$dbbc0a36865f0300;

});

parcelRegister("czt8s", function(module, exports) {
$parcel$export(module.exports, "CancelError", () => (parcelRequire("4bi4T")).CancelError);

var $4bi4T = parcelRequire("4bi4T");

const $2bc9549dae34d364$var$CANCEL_ERROR = new (0, $4bi4T.CancelError)('Promise is cancelled');
class $2bc9549dae34d364$export$5782acf08706f13d {
    static from(promise) {
        return new $2bc9549dae34d364$export$5782acf08706f13d(promise);
    }
    constructor(promise){
        this.cancellablePromiseInternal = void 0;
        this.cancelInternal = ()=>{
            // Default throws an error as this should never happen
            throw new Error('Programming error, cancelling promise is not properly rejected');
        };
        this.promise = ()=>this.cancellablePromiseInternal;
        this.cancel = ()=>this.cancelInternal();
        this.cancellablePromiseInternal = Promise.race([
            promise,
            new Promise((_, reject)=>{
                this.cancelInternal = ()=>reject($2bc9549dae34d364$var$CANCEL_ERROR);
            })
        ]);
    }
}
module.exports["CancellablePromise"] = $2bc9549dae34d364$export$5782acf08706f13d;

});

parcelRegister("4bi4T", function(module, exports) {
class $664df2097e831b6a$export$d7f5e52d091a66db extends Error {
    constructor(...args){
        super(...args);
        this.isCancelled = true;
    }
}
module.exports["CancelError"] = $664df2097e831b6a$export$d7f5e52d091a66db;

});

parcelRegister("dmTG5", function(module, exports) {
const $8edbe48163a779a2$export$e98932ab9e22c265 = ({ dependency: dependency, searchSessionId: searchSessionId, reason: reason, source: source })=>{
    return {
        source: source,
        action: 'degradedDependency',
        actionSubject: 'searchPage',
        eventType: 'track',
        attributes: {
            additionalAttributes: {
                degradedDependency: dependency,
                reason: reason,
                searchSessionId: searchSessionId
            }
        }
    };
};
module.exports["onDegradedDependency"] = $8edbe48163a779a2$export$e98932ab9e22c265;

});

parcelRegister("cFN1h", function(module, exports) {
const $d17b2d1acf87bd34$export$7199f2d13e6ae9f7 = ({ dependency: dependency, searchSessionId: searchSessionId, source: source, moreContext: moreContext })=>{
    return {
        source: source,
        action: 'failedDependency',
        actionSubject: 'searchPage',
        eventType: 'track',
        attributes: {
            additionalAttributes: {
                failedDependency: dependency,
                searchSessionId: searchSessionId,
                ...moreContext || {}
            }
        }
    };
};
module.exports["onFailedDependency"] = $d17b2d1acf87bd34$export$7199f2d13e6ae9f7;

});

parcelRegister("PVo4u", function(module, exports) {

var $5G9KX = parcelRequire("5G9KX");

const $051fa6ddf2f4f010$export$ad9e8f9d9536c33d = ()=>{
    // The key is defined in packages/atlassian-analytics-pipeline/analytics-web-client/src/sessionTracking.ts.
    const LOCAL_STORAGE_KEY = 'awc.session.id';
    try {
        return (0, $5G9KX.getLocalStorageItemAsString)(LOCAL_STORAGE_KEY) ?? undefined;
    } catch (error) {
        return undefined;
    }
};
module.exports["getSessionIdFromLocalStorage"] = $051fa6ddf2f4f010$export$ad9e8f9d9536c33d;

});

parcelRegister("3htW4", function(module, exports) {
const $5c6286f004754d19$export$786813d6840571a0 = ({ requestName: requestName, searchSessionId: searchSessionId, cacheHit: cacheHit, refreshTriggered: refreshTriggered, source: source })=>{
    return {
        source: source,
        action: 'requestCacheAccess',
        actionSubject: 'searchPage',
        eventType: 'track',
        attributes: {
            additionalAttributes: {
                requestName: requestName,
                cacheHit: cacheHit,
                refreshTriggered: refreshTriggered,
                searchSessionId: searchSessionId
            }
        }
    };
};
module.exports["onRequestCacheAccess"] = $5c6286f004754d19$export$786813d6840571a0;

});

parcelRegister("31eSD", function(module, exports) {
const $7ee20f32daead583$export$5e8268eaa81797f5 = {
    SEARCH_PAGE_FIRST_PARTY_CONFIG_UX: 'search-page/first-party-config-ux',
    SEARCH_PAGE_FIRST_PARTY_CONFIG_NETWORK: 'search-page/first-party-config-network',
    SEARCH_PAGE_THIRD_PARTY_CONFIG_UX: 'search-page/third-party-config-ux',
    SEARCH_PAGE_THIRD_PARTY_CONFIG_NETWORK: 'search-page/third-party-config-network',
    SEARCH_PAGE_COMBINED_CONFIG_UX: 'search-page/combined-config-ux',
    SEARCH_PAGE_COMBINED_CONFIG_NETWORK: 'search-page/combined-config-network',
    SEARCH_PAGE_FULL_PAGE_SEARCH_RESULTS_UX: 'search-page/full-page-search-results-ux',
    SEARCH_PAGE_FULL_PAGE_SEARCH_RESULTS_NETWORK: 'search-page/full-page-search-results-network',
    SEARCH_PAGE_FULL_PAGE_SEARCH_ASYNC_SEARCH_RESULTS: 'search-page/full-page-search-async-search-results',
    QUICK_FIND_RECENT_ACTIVITIES_UX: 'quick-find/recent-activities-ux',
    QUICK_FIND_RECENT_ACTIVITIES_NETWORK: 'quick-find/recent-activities-network',
    QUICK_FIND_PRE_QUERY_RESULTS: 'quick-find/prequery-search-results-ux',
    QUICK_FIND_POST_QUERY_UX: 'quick-find/postquery-search-results-ux',
    QUICK_FIND_CONFLUENCE_ENTITIES_NETWORK: 'quick-find/confluence-entities-network',
    QUICK_FIND_CONFLUENCE_SPACES_NETWORK: 'quick-find/confluence-spaces-network',
    QUICK_FIND_JIRA_ISSUES_AND_TYPES_NETWORK: 'quick-find/jira-issues-and-types-network',
    QUICK_FIND_JIRA_ENTITIES_NETWORK: 'quick-find/jira-entities-network',
    QUICK_FIND_ATLAS_ENTITIES_NETWORK: 'quick-find/atlas-entities-network',
    QUICK_FIND_MERCURY_ENTITIES_NETWORK: 'quick-find/mercury-entities-network',
    QUICK_FIND_TALENT_ENTITIES_NETWORK: 'quick-find/talent-entities-network',
    QUICK_FIND_ASSETS_ENTITIES_NETWORK: 'quick-find/assets-entities-network',
    QUICK_FIND_INTENT_DETECTION_NETWORK: 'quick-find/intent-detection-network',
    QUICK_FIND_INTENT_DETECTION_UX: 'quick-find/intent-detection-ux'
};
module.exports["TASK_NAMES"] = $7ee20f32daead583$export$5e8268eaa81797f5;

});

parcelRegister("bQSQw", function(module, exports) {


const $0672f58113131b34$var$baseVitalStatsEvent = ({ searchSessionId: searchSessionId, taskId: taskId, task: task, action: action, moreContext: moreContext })=>{
    return {
        action: action,
        actionSubject: 'ui',
        eventType: 'operational',
        attributes: {
            additionalAttributes: {
                task: task,
                taskId: taskId,
                hostname: window.location.hostname,
                searchSessionId: searchSessionId,
                ...moreContext
            }
        }
    };
};
const $0672f58113131b34$export$656fa717a09eb821 = ({ searchSessionId: searchSessionId, taskId: taskId, task: task, moreContext: moreContext })=>{
    return $0672f58113131b34$var$baseVitalStatsEvent({
        searchSessionId: searchSessionId,
        taskId: taskId,
        task: task,
        action: 'taskStart',
        moreContext: moreContext
    });
};
const $0672f58113131b34$export$3e9761d670712e50 = ({ searchSessionId: searchSessionId, taskId: taskId, task: task, moreContext: moreContext })=>{
    return $0672f58113131b34$var$baseVitalStatsEvent({
        searchSessionId: searchSessionId,
        taskId: taskId,
        task: task,
        action: 'taskSuccess',
        moreContext: moreContext
    });
};
const $0672f58113131b34$export$2e311f5a2c70a936 = ({ searchSessionId: searchSessionId, taskId: taskId, task: task, moreContext: moreContext })=>{
    return $0672f58113131b34$var$baseVitalStatsEvent({
        searchSessionId: searchSessionId,
        taskId: taskId,
        task: task,
        action: 'taskFail',
        moreContext: moreContext
    });
};
const $0672f58113131b34$export$807d68038784dd59 = ({ searchSessionId: searchSessionId, taskId: taskId, task: task, moreContext: moreContext })=>{
    return $0672f58113131b34$var$baseVitalStatsEvent({
        searchSessionId: searchSessionId,
        taskId: taskId,
        task: task,
        action: 'taskAbort',
        moreContext: moreContext
    });
};
module.exports["onTaskStart"] = $0672f58113131b34$export$656fa717a09eb821;
module.exports["onTaskSuccess"] = $0672f58113131b34$export$3e9761d670712e50;
module.exports["onTaskFail"] = $0672f58113131b34$export$2e311f5a2c70a936;
module.exports["onTaskAbort"] = $0672f58113131b34$export$807d68038784dd59;

});

parcelRegister("jjjIy", function(module, exports) {
// Modified from platform/packages/search/product-search-dialog/src/extensible/product-router/product/result-provider/faster-search-helpers.ts

var $bloXB = parcelRequire("bloXB");


var $lsW5D = parcelRequire("lsW5D");

function $f4ae55a82e2fef50$export$399f177751711473(searchResults, query, numberOfResultItems = 3, negateTitleHighlight) {
    const wordsInQuery = query.split(' ');
    const itemScoreMap = {};
    const filteredResults = searchResults.flatMap((result)=>{
        // 1st pass
        const doAllWordsMatch = wordsInQuery.reduce((acc, word)=>{
            if (!acc) return acc;
            return result.title.toLowerCase().includes(word.toLowerCase());
        }, true);
        if (doAllWordsMatch) {
            // 2nd and 3rd Pass
            const { highlightedTitle: highlightedTitle, negatedHighlightedTitle: negatedHighlightedTitle, score: score = 0 } = (0, $bloXB.highlightMatchedText)(result.title, wordsInQuery);
            itemScoreMap[result.title] = score;
            return [
                {
                    ...result,
                    highlightedTitle: negateTitleHighlight ? negatedHighlightedTitle : highlightedTitle
                }
            ];
        }
        return [];
    }).sort((item, secondItem)=>item && secondItem ? itemScoreMap[secondItem.title] - itemScoreMap[item.title] : 0).slice(0, numberOfResultItems);
    return filteredResults;
}
function $f4ae55a82e2fef50$export$18f3758fc3685a84(searchResults, query) {
    const wordsInQuery = query.split(' ');
    const itemScoreMap = {};
    const filteredResults = searchResults.flatMap((result)=>{
        // 1st pass
        const doAllWordsMatch = wordsInQuery.reduce((acc, word)=>{
            if (!acc) return acc;
            return result.title.toLowerCase().includes(word.toLowerCase());
        }, true);
        if (doAllWordsMatch) {
            // 2nd and 3rd Pass
            const { score: score = 0 } = (0, $bloXB.highlightMatchedText)(result.title, wordsInQuery);
            itemScoreMap[result.title] = score;
            return [
                {
                    ...result
                }
            ];
        }
        return [];
    }).sort((item, secondItem)=>item && secondItem ? itemScoreMap[secondItem.title] - itemScoreMap[item.title] : 0);
    return filteredResults;
}
function $f4ae55a82e2fef50$export$bf5c34de39b9bf13(recentActivities, query) {
    const normalizedQuery = (0, $lsW5D.normalizeWorkItemKey)(query);
    // Search by both the normalized key and the literal query, deduplicating by id
    const byNormalized = normalizedQuery && query !== normalizedQuery ? $f4ae55a82e2fef50$export$18f3758fc3685a84(recentActivities, normalizedQuery) : [];
    const byLiteral = $f4ae55a82e2fef50$export$18f3758fc3685a84(recentActivities, query);
    const seen = new Set(byNormalized.map((r)=>r.id));
    return [
        ...byNormalized,
        ...byLiteral.filter((r)=>!seen.has(r.id))
    ];
}
module.exports["filterSearchResultsWithHighlighting"] = $f4ae55a82e2fef50$export$399f177751711473;
module.exports["filterSearchResults"] = $f4ae55a82e2fef50$export$18f3758fc3685a84;
module.exports["filterRecentActivities"] = $f4ae55a82e2fef50$export$bf5c34de39b9bf13;

});

parcelRegister("bloXB", function(module, exports) {
/**
 * Breakdown of the filtering & ordering logic :
 *
 * 0th pass: if the string has any highlight tags, remove them and continue
 * An alternate could be to exit early, but then we don't have the scoring information from the later passes
 *
 * 1st Pass - Complete match of query broken by words - This checks that all the words of the query must occur somewhere in the Title.
 *    - This is case insensitive.
 *    - This is unordered.
 *    For eg -
 *    Query - "mad max" will NOT let "Nomad" or "Climax" pass through,
 *    but  "Nomad Climax", "Madmax", "max Mad" will pass through
 *
 * 2nd Pass Scoring - Score calculation based on the kind of matches.
 *    There are 3 types - Exact match, StartsWith match & Partial match
 *    For eg -
 *    Exact Match (Score = 100) - Query: "Mad" will score "mad", "mad max" with 100.
 *            Note: Special characters stripped -  "Mad" will score "mad-max", "max-mad" with 100.
 *    StartsWith Match (Score = 10) - Query: "ark" will score "ARKK" and "Arkose Meeting" as 10
 *    Partial Match (Score = 1) - Query: "mad max" will score "Nomad Climax" as 2
 *
 *    Mix of multiple matching scenarios is possible.
 *    For example - "mad max" query will score "Mad Climax" as 100 (Exact) + 1 (Partial) = 101
 *
 * 3rd Pass - Sorting & Highlighting
 *    Sorting happens in the descending order of the score.
 *    Highlighting will match the entered query and inject necessary tags.
 *    Note: if both StartsWith and Partial matching exists in the same word then only StartsWith is highlighted
 *
 *    Two new properties are populated:
 *    1. highlightedText - highlights the query
 *    2. negatedHighlightedText - highights everything except the part that matches the query
 */ const $6609f2e7706baea1$var$HIGHLIGHT_START_TAG = '@@@hl@@@';
const $6609f2e7706baea1$var$HIGHLIGHT_END_TAG = '@@@endhl@@@';
const $6609f2e7706baea1$var$SPECIAL_CHARACTER_REGEX = /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/g;
const $6609f2e7706baea1$var$CONSECUTIVE_START_REGEX = new RegExp(`${$6609f2e7706baea1$var$HIGHLIGHT_START_TAG}${$6609f2e7706baea1$var$HIGHLIGHT_START_TAG}`, 'g');
const $6609f2e7706baea1$var$CONSECUTIVE_END_REGEX = new RegExp(`${$6609f2e7706baea1$var$HIGHLIGHT_END_TAG}${$6609f2e7706baea1$var$HIGHLIGHT_END_TAG}`, 'g');
const $6609f2e7706baea1$var$CONSECUTIVE_START_END_REGEX = new RegExp(`${$6609f2e7706baea1$var$HIGHLIGHT_START_TAG}${$6609f2e7706baea1$var$HIGHLIGHT_END_TAG}`, 'g');
const $6609f2e7706baea1$var$ESCAPE_SPECIAL_CHARACTERS = /[.*+?^${}()|[\]\\]/g;
const $6609f2e7706baea1$var$cleanStartRegex = new RegExp($6609f2e7706baea1$var$HIGHLIGHT_START_TAG, 'g');
const $6609f2e7706baea1$var$cleanEndRegex = new RegExp($6609f2e7706baea1$var$HIGHLIGHT_END_TAG, 'g');
const $6609f2e7706baea1$export$9f4c92a576b56d82 = (source, matchWords)=>{
    // Remove any previous highlighting and regenerate
    // Supports the use case where we perform this on the frontend, and later the backend starts doing it for us first
    const cleanedSource = source.replace($6609f2e7706baea1$var$cleanStartRegex, '').replace($6609f2e7706baea1$var$cleanEndRegex, '');
    const lowerCaseMatchWords = matchWords.filter((word)=>word !== '').map((word)=>word.toLowerCase());
    const wordsDetails = cleanedSource.split(' ').map((word)=>{
        const lowerCaseWord = word.toLowerCase();
        const alphabetOnlyWord = lowerCaseWord.replace($6609f2e7706baea1$var$SPECIAL_CHARACTER_REGEX, ' ').split(' ');
        let partialCount = 0;
        let startsWithCount = 0;
        let exactMatchCount = 0;
        let exactMatch = '';
        let partialMatch = '';
        let startsWithMatch = '';
        for(let i = 0; i < lowerCaseMatchWords.length; ++i){
            if (lowerCaseWord === lowerCaseMatchWords[i] || alphabetOnlyWord.includes(lowerCaseMatchWords[i])) {
                exactMatchCount++;
                exactMatch = lowerCaseMatchWords[i];
                break;
            }
            if (lowerCaseWord.startsWith(lowerCaseMatchWords[i])) {
                startsWithCount++;
                startsWithMatch = lowerCaseMatchWords[i];
                continue;
            }
            if (lowerCaseWord.includes(lowerCaseMatchWords[i])) {
                partialCount++;
                partialMatch = lowerCaseMatchWords[i];
            }
        }
        const score = 100 * exactMatchCount + 10 * startsWithCount + partialCount;
        if (exactMatchCount > 0 || startsWithCount > 0 || partialCount > 0) {
            const pattern = exactMatchCount > 0 ? exactMatch : startsWithCount > 0 ? startsWithMatch : partialMatch;
            const regExp = new RegExp(`(${pattern.replace($6609f2e7706baea1$var$ESCAPE_SPECIAL_CHARACTERS, '\\$&')})`, 'ig');
            const openingClosingRegExp = new RegExp(`(${$6609f2e7706baea1$var$HIGHLIGHT_START_TAG}|${$6609f2e7706baea1$var$HIGHLIGHT_END_TAG})`, 'ig');
            const highlighted = word.replace(regExp, `${$6609f2e7706baea1$var$HIGHLIGHT_START_TAG}$1${$6609f2e7706baea1$var$HIGHLIGHT_END_TAG}`).replace($6609f2e7706baea1$var$CONSECUTIVE_START_END_REGEX, ``);
            const mirror = {
                [`${$6609f2e7706baea1$var$HIGHLIGHT_START_TAG}`]: `${$6609f2e7706baea1$var$HIGHLIGHT_END_TAG}`,
                [`${$6609f2e7706baea1$var$HIGHLIGHT_END_TAG}`]: `${$6609f2e7706baea1$var$HIGHLIGHT_START_TAG}`
            };
            const mirroredHighlighted = highlighted.replace(openingClosingRegExp, (ch)=>mirror[ch]);
            const negatedHighlight = `${$6609f2e7706baea1$var$HIGHLIGHT_START_TAG}${mirroredHighlighted}${$6609f2e7706baea1$var$HIGHLIGHT_END_TAG}`.replace($6609f2e7706baea1$var$CONSECUTIVE_START_REGEX, `${$6609f2e7706baea1$var$HIGHLIGHT_START_TAG}`).replace($6609f2e7706baea1$var$CONSECUTIVE_END_REGEX, `${$6609f2e7706baea1$var$HIGHLIGHT_END_TAG}`).replace($6609f2e7706baea1$var$CONSECUTIVE_START_END_REGEX, '');
            return {
                highlighted: highlighted,
                negatedHighlight: negatedHighlight,
                score: score
            };
        }
        // no match scenario
        return {
            negatedHighlight: `${$6609f2e7706baea1$var$HIGHLIGHT_START_TAG}${word}${$6609f2e7706baea1$var$HIGHLIGHT_END_TAG}`,
            highlighted: word,
            score: score
        };
    });
    const highlightedTitle = wordsDetails.map((wordObj)=>wordObj.highlighted).join(' ');
    const negatedHighlightedTitle = wordsDetails.map((wordObj)=>wordObj.negatedHighlight).join(' ');
    const finalScore = wordsDetails.reduce((acc, word)=>acc + word.score, 0);
    if (highlightedTitle !== '' && highlightedTitle !== cleanedSource) return {
        highlightedTitle: highlightedTitle,
        negatedHighlightedTitle: negatedHighlightedTitle,
        score: finalScore
    };
    return {};
};
module.exports["highlightMatchedText"] = $6609f2e7706baea1$export$9f4c92a576b56d82;

});

parcelRegister("lsW5D", function(module, exports) {
/**
 * Normalizes an issue key query by removing hyphens and spaces so that
 * queries like "AAA34", "AAA 34", and "AAA-34" all match the canonical key "AAA-34".
 * Returns undefined if the value does not look like an issue key.
 */ const $36dfe9a646cd7d4d$export$2c6ff4235668ce91 = (value)=>{
    const normalized = value.replace(/^([a-zA-Z]+)[\s-]?(\d+)$/, '$1-$2').toLowerCase();
    return normalized !== value.toLowerCase() || /^[a-zA-Z]+-\d+$/.test(value) ? normalized : undefined;
};
module.exports["normalizeWorkItemKey"] = $36dfe9a646cd7d4d$export$2c6ff4235668ce91;

});

parcelRegister("4tgkZ", function(module, exports) {

var $8AgZb = parcelRequire("8AgZb");


var $fXT59 = parcelRequire("fXT59");

const $fa792d959dc8194b$export$3d3f5f86906a7f73 = (0, $8AgZb.KnowledgeDiscoveryJiraSearchClassification);
const $fa792d959dc8194b$export$928cec68d7595d16 = (0, $fXT59.disposableValue)(null);
const $fa792d959dc8194b$export$3d750f4e9f4d0fc8 = {
    Jql: 'JQL'
};
const $fa792d959dc8194b$export$5cd976a4b4b84eb3 = (currentQuery)=>{
    const stored = $fa792d959dc8194b$export$928cec68d7595d16.value();
    if (!stored || stored.patternType !== $fa792d959dc8194b$export$3d750f4e9f4d0fc8.Jql) return false;
    return stored.query.trim() === currentQuery.trim();
};
module.exports["IntentMode"] = $fa792d959dc8194b$export$3d3f5f86906a7f73;
module.exports["INTENT_DETECTION"] = $fa792d959dc8194b$export$928cec68d7595d16;
module.exports["PatternType"] = $fa792d959dc8194b$export$3d750f4e9f4d0fc8;
module.exports["isJqlQueryDetected"] = $fa792d959dc8194b$export$5cd976a4b4b84eb3;

});

parcelRegister("8AgZb", function(module, exports) {
const $17298238d3880205$export$52027d47033ea8ad = {
    GNIN: 'GNIN',
    FPS: 'FPS'
};
module.exports["KnowledgeDiscoveryJiraSearchClassification"] = $17298238d3880205$export$52027d47033ea8ad;

});

parcelRegister("9wmQG", function(module, exports) {
/**
 * This file provides the necessary wrappers and utility functions to provide
 * analytics data for Quick Find result positions. Quick Find analytics contains
 * data such as the number of results, the number of sections, and the
 * position / section of a selected result.
 *
 * It does this by using the DOM as the source of truth rather than having to
 * maintain section objects and indexes in the code. This allows rendering
 * display components to be simplified and could prove to be more robust, e.g.
 * if a search result doesn't render due to an error and subsequently hits
 * its error boundary, section and results count remain correct.
 *
 * There is however the requirement that all heading and results components
 * are siblings in the DOM tree.
 */ /* eslint-disable @atlaskit/platform/no-direct-document-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-classname-prop */ 
var $42omo = parcelRequire("42omo");


var $d6omw = parcelRequire("d6omw");

var $cFEpk = parcelRequire("cFEpk");

var $da71s = parcelRequire("da71s");

var $c5fb920fb7e7d9be$require$differenceInMinutes = $d6omw.default;
var $c5fb920fb7e7d9be$require$parseISO = $da71s.default;
var $c5fb920fb7e7d9be$require$isValid = $cFEpk.default;
const $c5fb920fb7e7d9be$export$e7b6022782937b95 = 'search-dialog-heading';
const $c5fb920fb7e7d9be$export$926357658a80ff2a = 'search-dialog-result';
const $c5fb920fb7e7d9be$export$f8cbabfc03558964 = 'bulk-connect-banner';
const $c5fb920fb7e7d9be$var$resultTypes = [
    'peopleAndTeams',
    'recentQueries',
    'recentActivities',
    'queryFilters',
    'searchResults',
    'zeroQueries',
    'autocompleteSuggestions',
    'filterSuggestions',
    'intentRouter',
    'recommendations',
    'intentRouterWorkItem'
];
const $c5fb920fb7e7d9be$export$8814e97d826fd90d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ children: children, id: id, ...rest }, ref)=>{
    return(// Ignoring this check as class is not being used for styling
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: $c5fb920fb7e7d9be$export$e7b6022782937b95,
        "data-section-id": id,
        "data-testid": "search-dialog-heading-analytics-wrapper",
        ref: ref,
        ...rest
    }, children));
});
const $c5fb920fb7e7d9be$export$e01f22447ddebe43 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ children: children, resultType: resultType, product: product, id: id, connectorType: connectorType, minutesSinceActivityTimestamp: minutesSinceActivityTimestamp, recentActivityEventType: recentActivityEventType, zeroQueryType: zeroQueryType, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        // Ignoring this check as class is not being used for styling
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: $c5fb920fb7e7d9be$export$926357658a80ff2a,
        "data-result-type": resultType,
        "data-product": product,
        "data-id": id,
        "data-connector-type": connectorType,
        "data-since-activity-timestamp": minutesSinceActivityTimestamp,
        "data-recent-activity-event-type": recentActivityEventType,
        "data-zero-query-type": zeroQueryType,
        ref: ref,
        ...rest
    }, children);
});
const $c5fb920fb7e7d9be$export$75fc08fd8853e1c3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ children: children, ...rest }, ref)=>{
    return(// Ignoring this check as class is not being used for styling
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: $c5fb920fb7e7d9be$export$f8cbabfc03558964,
        ref: ref,
        ...rest
    }, children));
});
const $c5fb920fb7e7d9be$export$1be6c28d5e945bdf = ()=>{
    const resultNodes = Array.from(document.getElementsByClassName($c5fb920fb7e7d9be$export$926357658a80ff2a));
    const counts = {};
    for(let i = 0; i < resultNodes.length; i++){
        const product = resultNodes[i].getAttribute('data-product');
        if (!product) continue;
        counts[product] = (counts[product] ?? 0) + 1;
    }
    return counts;
};
const $c5fb920fb7e7d9be$export$e21758a6ca606f0a = ()=>{
    return Object.keys($c5fb920fb7e7d9be$export$1be6c28d5e945bdf());
};
const $c5fb920fb7e7d9be$export$a9cb3c6c659d9dfe = ()=>{
    const resultNodes = Array.from(document.getElementsByClassName($c5fb920fb7e7d9be$export$926357658a80ff2a));
    const productSet = new Set();
    for(let i = 0; i < resultNodes.length; i++){
        if (resultNodes[i].getAttribute('data-result-type') !== 'recommendations') continue;
        const product = resultNodes[i].getAttribute('data-product');
        product && productSet.add(product);
    }
    return Array.from(productSet);
};
const $c5fb920fb7e7d9be$export$d812a070b2ee9d66 = ()=>{
    const bannerNode = document.querySelector(`.${$c5fb920fb7e7d9be$export$f8cbabfc03558964}`);
    return bannerNode !== null;
};
const $c5fb920fb7e7d9be$var$isNotRecentQuery = (product)=>{
    return Boolean(product);
};
function $c5fb920fb7e7d9be$export$4e2371c785c39b57(compareWithTimeInMs) {
    try {
        if (typeof compareWithTimeInMs !== 'string') return null;
        const startTime = $c5fb920fb7e7d9be$require$parseISO(compareWithTimeInMs);
        if (!$c5fb920fb7e7d9be$require$isValid(startTime)) return null;
        const difference = $c5fb920fb7e7d9be$require$differenceInMinutes(new Date(), startTime, 'floor');
        return difference >= 0 ? difference : null;
    } catch  {
        // Swallowing error, bad timestamp should not throw error
        return null;
    }
}
/**
 * Maps each result's data-id to its sectionId by walking sibling heading/result
 * nodes, mirroring how `ItemsAnalyticsProvider.getItemIndexes` resolves sectionId.
 */ const $c5fb920fb7e7d9be$var$buildResultSectionIdMap = ()=>{
    const map = new Map();
    let allNodes;
    try {
        allNodes = $c5fb920fb7e7d9be$var$getAllHeadingsAndResults().allNodes;
    } catch  {
        return map;
    }
    let currentSectionId = null;
    for (const node of allNodes){
        if ($c5fb920fb7e7d9be$var$isHeading(node)) currentSectionId = node.getAttribute('data-section-id');
        else if ($c5fb920fb7e7d9be$var$isResult(node)) {
            const resultId = node.getAttribute('data-id');
            if (resultId) map.set(resultId, currentSectionId);
        }
    }
    return map;
};
const $c5fb920fb7e7d9be$export$8841f6f549512fc2 = ()=>{
    const resultNodes = Array.from(document.getElementsByClassName($c5fb920fb7e7d9be$export$926357658a80ff2a));
    const sectionIdMap = $c5fb920fb7e7d9be$var$buildResultSectionIdMap();
    const resultList = [];
    for(let i = 0; i < resultNodes.length; i++){
        const id = resultNodes[i].getAttribute('data-id');
        const product = resultNodes[i].getAttribute('data-product');
        const connectorType = resultNodes[i].getAttribute('data-connector-type');
        const resultType = resultNodes[i].getAttribute('data-result-type');
        const rawMinutesSinceActivityTimestamp = parseInt(resultNodes[i].getAttribute('data-since-activity-timestamp') || '', 10);
        const minutesSinceActivityTimestamp = isNaN(rawMinutesSinceActivityTimestamp) ? null : rawMinutesSinceActivityTimestamp;
        // Missing attribute -> explicit `null` (mirrors `minutesSinceActivityTimestamp`).
        const recentActivityEventType = resultNodes[i].getAttribute('data-recent-activity-event-type') || null;
        if (id && $c5fb920fb7e7d9be$var$isNotRecentQuery(product)) {
            const resultShown = {
                id: id,
                product: product,
                position: i,
                metadata: {
                    minutesSinceActivityTimestamp: minutesSinceActivityTimestamp,
                    ...connectorType && {
                        connectorType: connectorType
                    },
                    resultType: resultType,
                    sectionId: sectionIdMap.get(id) ?? null,
                    recentActivityEventType: recentActivityEventType
                }
            };
            resultList.push(resultShown);
        }
    }
    return resultList;
};
const $c5fb920fb7e7d9be$export$837a07087631b7e0 = ()=>{
    const resultNodes = Array.from(document.getElementsByClassName($c5fb920fb7e7d9be$export$926357658a80ff2a));
    const zeroQueryNodes = resultNodes.filter((node)=>node.getAttribute('data-result-type') === 'zeroQueries');
    return zeroQueryNodes.map((node, idx)=>({
            zeroQueryType: node.getAttribute('data-zero-query-type') ?? '',
            zeroQueryPosition: idx
        }));
};
const $c5fb920fb7e7d9be$export$334c5c15d40bbec1 = ()=>{
    const resultNodes = Array.from(document.getElementsByClassName($c5fb920fb7e7d9be$export$926357658a80ff2a));
    return $c5fb920fb7e7d9be$var$resultTypes.reduce((o, resultType)=>{
        o[resultType] = resultNodes.filter((node)=>node.getAttribute('data-result-type') === resultType).length || 0;
        return o;
    }, {});
};
const $c5fb920fb7e7d9be$var$getAllHeadingsAndResults = ()=>{
    const headingNodes = Array.from(document.getElementsByClassName($c5fb920fb7e7d9be$export$e7b6022782937b95));
    const resultNodes = Array.from(document.getElementsByClassName($c5fb920fb7e7d9be$export$926357658a80ff2a));
    if (!headingNodes.length || !resultNodes.length) return {
        allNodes: [],
        headingNodes: [],
        resultNodes: []
    };
    const parentNode = headingNodes.length ? headingNodes[0].parentNode : resultNodes.length ? resultNodes[0].parentNode : undefined;
    if (!parentNode) throw new Error('Could not find a parent node for headings and results');
    const allNodes = Array.from(parentNode.children).filter((e)=>$c5fb920fb7e7d9be$var$isHeading(e) || $c5fb920fb7e7d9be$var$isResult(e));
    return {
        allNodes: allNodes,
        headingNodes: headingNodes,
        resultNodes: resultNodes
    };
};
const $c5fb920fb7e7d9be$var$isHeading = (e)=>{
    return e.classList.contains($c5fb920fb7e7d9be$export$e7b6022782937b95);
};
const $c5fb920fb7e7d9be$var$isResult = (e)=>{
    return e.classList.contains($c5fb920fb7e7d9be$export$926357658a80ff2a) || e.querySelector(`.${$c5fb920fb7e7d9be$export$926357658a80ff2a}`) !== null;
};
const $c5fb920fb7e7d9be$export$e9dac44129e02fa9 = ()=>{
    try {
        const { allNodes: allNodes, headingNodes: headingNodes, resultNodes: resultNodes } = $c5fb920fb7e7d9be$var$getAllHeadingsAndResults();
        // If the first node is a result, then we count it as a section
        const sectionCount = allNodes.length ? headingNodes.length + ($c5fb920fb7e7d9be$var$isResult(allNodes[0]) ? 1 : 0) : 0;
        return {
            sectionCount: sectionCount,
            resultCount: resultNodes.length
        };
    } catch  {
        return {};
    }
};
module.exports["SearchDialogHeaderAnalyticsWrapper"] = $c5fb920fb7e7d9be$export$8814e97d826fd90d;
module.exports["SearchDialogResultAnalyticsWrapper"] = $c5fb920fb7e7d9be$export$e01f22447ddebe43;
module.exports["getProductResultCounts"] = $c5fb920fb7e7d9be$export$1be6c28d5e945bdf;
module.exports["getProductsInResults"] = $c5fb920fb7e7d9be$export$e21758a6ca606f0a;
module.exports["getProductsInRecommendations"] = $c5fb920fb7e7d9be$export$a9cb3c6c659d9dfe;
module.exports["getIsBulkConnectBannerShown"] = $c5fb920fb7e7d9be$export$d812a070b2ee9d66;
module.exports["calculateMinuteDifference"] = $c5fb920fb7e7d9be$export$4e2371c785c39b57;
module.exports["getResultsShown"] = $c5fb920fb7e7d9be$export$8841f6f549512fc2;
module.exports["getShownZeroQueries"] = $c5fb920fb7e7d9be$export$837a07087631b7e0;
module.exports["getResultTypeCounts"] = $c5fb920fb7e7d9be$export$334c5c15d40bbec1;
module.exports["getSectionsAndResultsCount"] = $c5fb920fb7e7d9be$export$e9dac44129e02fa9;

});

parcelRegister("kQT7c", function(module, exports) {

var $b4tvS = parcelRequire("b4tvS");


var $9d9t8 = parcelRequire("9d9t8");


var $eakyO = parcelRequire("eakyO");


var $3E8x9 = parcelRequire("3E8x9");


var $def8z = parcelRequire("def8z");


const $6e55f7e6ca9a4561$var$GOOGLE_INTEGRATION_ARI = 'ari:cloud:platform::integration/google';
const $6e55f7e6ca9a4561$export$e6a288d5cd4cda6 = (partial)=>partial.__typename === 'SearchResultGoogleDocument' || $6e55f7e6ca9a4561$export$34ee1a2c0a1a45b7(partial) && partial.integrationId === $6e55f7e6ca9a4561$var$GOOGLE_INTEGRATION_ARI && partial.subtype === 'document';
const $6e55f7e6ca9a4561$export$34ee1a2c0a1a45b7 = (partial)=>partial.__typename === 'SearchResultGraphDocument';
const $6e55f7e6ca9a4561$var$SMART_LINK_ENTITY_REGEX = /^ari:.*::remote-link/;
const $6e55f7e6ca9a4561$export$8cc78980eb89e95d = (resultAri)=>$6e55f7e6ca9a4561$var$SMART_LINK_ENTITY_REGEX.test(resultAri);
const $6e55f7e6ca9a4561$export$c5fdbcc9e7462013 = ({ connectorType: connectorType, resultAri: resultAri, eventType: eventType, productKey: productKey, thirdPartyConfigs: thirdPartyConfigs })=>connectorType === (0, $eakyO.ConnectorSources).Smartlinks || $6e55f7e6ca9a4561$export$8cc78980eb89e95d(resultAri) || (0, $def8z.isProductSmartlink)({
        productKey: productKey,
        thirdPartyConfigs: thirdPartyConfigs
    }) || eventType === (0, $3E8x9.VIEWED_EVENT).SL_VIEWED || eventType === (0, $3E8x9.VIEWED_EVENT).SL_CLICKED;
const $6e55f7e6ca9a4561$var$getProduct3PConfig = (productKey, thirdPartyConfigs)=>{
    return productKey && (0, $b4tvS.is3pProductKey)(productKey) ? thirdPartyConfigs[productKey] : null;
};
const $6e55f7e6ca9a4561$export$15ebd9395cf27aef = ({ connectorType: connectorType, resultNodeId: resultNodeId, eventType: eventType, productKey: productKey, thirdPartyConfigs: thirdPartyConfigs })=>{
    // Return the connectorType if it's already valid
    if ((0, $9d9t8.isConnectorSource)(connectorType)) return connectorType;
    // connectorType will not exist for the following cases:
    // * when search GraphQL response returns null for connectorType
    // * when the given API doesn't return a connectorType. E.g. user documents.
    // as a result, we use fallback logic to determine the connectorType.
    if ($6e55f7e6ca9a4561$export$c5fdbcc9e7462013({
        connectorType: connectorType,
        resultAri: resultNodeId,
        eventType: eventType,
        productKey: productKey,
        thirdPartyConfigs: thirdPartyConfigs
    })) return (0, $eakyO.ConnectorSources).Smartlinks;
    const config = $6e55f7e6ca9a4561$var$getProduct3PConfig(productKey, thirdPartyConfigs);
    // No config found for the product
    if (!config) return undefined;
    if (config.isFederated) return (0, $eakyO.ConnectorSources).Federated;
    // Return the single connector source if it's valid
    if (config.connectorSources?.length === 1) {
        const source = config.connectorSources[0];
        if ((0, $9d9t8.isConnectorSource)(source)) return source;
    }
    // Default to Full for any other case where config exists
    return (0, $eakyO.ConnectorSources).Full;
};
module.exports["isResultSmartLink"] = $6e55f7e6ca9a4561$export$c5fdbcc9e7462013;
module.exports["getResultConnectorSource"] = $6e55f7e6ca9a4561$export$15ebd9395cf27aef;

});

parcelRegister("3E8x9", function(module, exports) {
// Copied from confluence/next/packages/navigation-search-dialog/src/suppliers/utils/eventTypeMessage.tsx
// Extracted from @atlassian/recent-work-ui activity-event-type-message to create this
// helper function to convert timestamp to readable metadata

var $42omo = parcelRequire("42omo");


var $dlSEv = parcelRequire("dlSEv");


var $dhNqt = parcelRequire("dhNqt");


var $6gF1I = parcelRequire("6gF1I");


var $aXWIB = parcelRequire("aXWIB");


var $5mJ0F = parcelRequire("5mJ0F");

var $Lyrmh = parcelRequire("Lyrmh");

var $38e9d08a360f6294$export$d245b105c09339d8 = /*#__PURE__*/ function(VIEWED_EVENT) {
    VIEWED_EVENT["VIEWED"] = "viewed";
    VIEWED_EVENT["SL_VIEWED"] = "sl-viewed";
    VIEWED_EVENT["SL_CLICKED"] = "sl-clicked";
    VIEWED_EVENT["CLICKED"] = "clicked";
    return VIEWED_EVENT;
}({});
var $38e9d08a360f6294$export$eb4e9f525aef1cc3 = /*#__PURE__*/ function(WORKED_EVENT) {
    WORKED_EVENT["COMMENTED"] = "commented";
    WORKED_EVENT["CREATED"] = "created";
    WORKED_EVENT["EDITED"] = "edited";
    WORKED_EVENT["PUBLISHED"] = "published";
    WORKED_EVENT["UPDATED"] = "updated";
    WORKED_EVENT["SHARED"] = "shared";
    return WORKED_EVENT;
}({});
function $38e9d08a360f6294$export$e873c799b137eec4(date) {
    return (0, $dlSEv.default)(new Date(date), $38e9d08a360f6294$var$startOfOneWeekAgo());
}
function $38e9d08a360f6294$var$startOfOneWeekAgo() {
    return (0, $dhNqt.default)((0, $6gF1I.default)(new Date(), 1));
}
const $38e9d08a360f6294$export$9e4fb3fb50a3c754 = ({ eventType: eventType, timestamp: timestamp, isMyActivityData: isMyActivityData })=>{
    const isAbsolute = $38e9d08a360f6294$export$e873c799b137eec4(timestamp);
    const message = (0, $Lyrmh.useEventTypeMessage)(eventType, {
        isMyActivityData: isMyActivityData,
        isAbsolute: isAbsolute
    });
    const { value: value, unit: unit } = (0, $5mJ0F.selectUnit)(new Date(timestamp).getTime(), new Date(), {
        day: 7
    });
    const values = isAbsolute ? {
        // Show the absolute time if the activity was more than a week ago
        // e.g: You viewed on January 1, 2021
        absoluteTime: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedDate), {
            value: timestamp,
            month: "short",
            day: "2-digit",
            year: "numeric"
        })
    } : {
        // Show the relative time if the activity was within a week ago
        // e.g: You viewed 2 hours ago
        relativeTime: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedRelativeTime), {
            value: value,
            unit: unit
        })
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...message,
        values: values
    });
};
module.exports["VIEWED_EVENT"] = $38e9d08a360f6294$export$d245b105c09339d8;
module.exports["WORKED_EVENT"] = $38e9d08a360f6294$export$eb4e9f525aef1cc3;
module.exports["isMoreThanOneWeekAgo"] = $38e9d08a360f6294$export$e873c799b137eec4;
module.exports["EventTypeMessage"] = $38e9d08a360f6294$export$9e4fb3fb50a3c754;

});

parcelRegister("JQd0k", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jSnXV = parcelRequire("jSnXV");

const $e31678cde9628b17$export$e70e6da722faba05 = (callback, debounceTime)=>{
    const ref = (0, $42omo.useRef)();
    (0, $42omo.useEffect)(()=>{
        ref.current = callback;
    }, [
        callback
    ]);
    const debouncedCallback = (0, $42omo.useMemo)(()=>{
        const func = ()=>{
            ref.current?.();
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(func, debounceTime);
    }, [
        debounceTime
    ]);
    return debouncedCallback;
};
module.exports["useDebouncedCallback"] = $e31678cde9628b17$export$e70e6da722faba05;

});

parcelRegister("gzcCN", function(module, exports) {
var $78275d0f42176934$export$fb160374438e1cd7 = /*#__PURE__*/ function(SearchConfluenceSubtype) {
    SearchConfluenceSubtype["LIVE"] = "LIVE";
    return SearchConfluenceSubtype;
}({});
module.exports["SearchConfluenceSubtype"] = $78275d0f42176934$export$fb160374438e1cd7;

});

parcelRegister("icWhS", function(module, exports) {

var $aU479 = parcelRequire("aU479");

const $2ffa685ce1f1083f$var$CONFLUENCE_VALUE_SEPARATOR = '---';
const $2ffa685ce1f1083f$var$CONFLUENCE_ATTRIBUTE_SEPARATOR = '___';
const $2ffa685ce1f1083f$export$ce6d1d009c92f1be = ({ url: url, query: query, searchSessionId: searchSessionId, additionalAnalytics: additionalAnalytics })=>{
    const urlObject = new URL(url);
    urlObject.searchParams.set('search_id', searchSessionId);
    let events = [];
    if (query) events.push(`queryHash${$2ffa685ce1f1083f$var$CONFLUENCE_VALUE_SEPARATOR}${(0, $aU479.hashData)(query)}`);
    if (additionalAnalytics) Object.entries(additionalAnalytics).forEach(([attribute, value])=>{
        events.push(`${attribute}${$2ffa685ce1f1083f$var$CONFLUENCE_VALUE_SEPARATOR}${value}`);
    });
    if (events.length === 0) return urlObject.toString();
    const analyticsFormattedForUrlParsing = encodeURIComponent(events.join($2ffa685ce1f1083f$var$CONFLUENCE_ATTRIBUTE_SEPARATOR));
    urlObject.searchParams.set('additional_analytics', analyticsFormattedForUrlParsing);
    return urlObject.toString();
};
const $2ffa685ce1f1083f$export$2e67c54459604a9 = (additionalAnalytics)=>{
    const formattedEvents = {};
    if (typeof additionalAnalytics !== 'string') return formattedEvents;
    const events = additionalAnalytics?.split($2ffa685ce1f1083f$var$CONFLUENCE_ATTRIBUTE_SEPARATOR);
    events.forEach((event)=>{
        const formattedEvent = event?.split($2ffa685ce1f1083f$var$CONFLUENCE_VALUE_SEPARATOR);
        const hasProperlyFormattedEvent = formattedEvent.length === 2;
        if (hasProperlyFormattedEvent) formattedEvents[formattedEvent[0]] = formattedEvent[1];
    });
    return formattedEvents;
};
const $2ffa685ce1f1083f$export$b780bd7096d811c5 = ({ url: url, searchSessionId: searchSessionId, resultId: resultId, projectId: projectId })=>{
    const jiraResultARIPattern = /^ari:cloud:jira:[a-z0-9-]+:[a-z]+\/[0-9]+$/;
    if (!resultId.match(jiraResultARIPattern)) return url;
    const jiraProjectARIPattern = /^ari:cloud:jira:[a-z0-9-]+:project\/[0-9]+$/;
    if (projectId && !projectId.match(jiraProjectARIPattern)) return url;
    const urlObject = new URL(url);
    urlObject.searchParams.set('searchSessionId', searchSessionId);
    const searchObjectId = resultId.split('/').pop();
    searchObjectId && urlObject.searchParams.set('searchObjectId', searchObjectId);
    const searchContentType = resultId.split('/')[0].split(':').pop();
    searchContentType && urlObject.searchParams.set('searchContentType', searchContentType);
    const searchContainerId = projectId?.split('/').pop();
    searchContainerId && urlObject.searchParams.set('searchContainerId', searchContainerId);
    return urlObject.toString();
};
const $2ffa685ce1f1083f$export$a5abc05a86b8de68 = ({ url: url, searchSessionId: searchSessionId, customParams: customParams = new Map([]) })=>{
    const urlObject = new URL(url);
    urlObject.searchParams.set('search_id', searchSessionId);
    customParams.forEach((value, key)=>{
        urlObject.searchParams.set(key || '', value || '');
    });
    return urlObject.toString();
};
module.exports["getConfluenceUrlWithAnalyticsQueryParams"] = $2ffa685ce1f1083f$export$ce6d1d009c92f1be;
module.exports["getJiraUrlWithAnalyticsQueryParams"] = $2ffa685ce1f1083f$export$b780bd7096d811c5;
module.exports["getGenericUrlWithAnalyticsQueryParams"] = $2ffa685ce1f1083f$export$a5abc05a86b8de68;

});

parcelRegister("aU479", function(module, exports) {

var $7azCD = parcelRequire("7azCD");


var $1HJbl = parcelRequire("1HJbl");


var $ipWWT = parcelRequire("ipWWT");


var $5e5BE = parcelRequire("5e5BE");

// copied over from @confluence/hash
const $d5e09354796e09eb$var$hash = (data, asBytes = false)=>{
    const hash = (0, $7azCD.sha256).create();
    hash.update(data);
    if (asBytes) return hash.array();
    return hash.hex();
};
const $d5e09354796e09eb$export$5fdf8c875acfc1b3 = (data)=>{
    return $d5e09354796e09eb$var$hash(data, true);
};
const $d5e09354796e09eb$export$7904c6256691057a = (data)=>{
    return $d5e09354796e09eb$var$hash(data);
};
module.exports["hashData"] = $d5e09354796e09eb$export$7904c6256691057a;

});

parcelRegister("1HJbl", function(module, exports) {
/**
 * Strip highlight markers from text
 */ const $cf5e87116ee7c968$export$7512fe8206a7f75b = (text)=>text && text.replace(/@@@hl@@@/g, '').replace(/@@@endhl@@@/g, '');
module.exports["cleanExcerpt"] = $cf5e87116ee7c968$export$7512fe8206a7f75b;

});

parcelRegister("ipWWT", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $ay6Zz = parcelRequire("ay6Zz");

const $dba528931595cd79$export$451f7a1e7c934f54 = (userId, primaryProduct, orgId, cloudId)=>{
    if (primaryProduct === 'confluence') return (0, $dh538.fg)('platform-adopt-teams-nav-config') ? (0, $ay6Zz.navigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: userId
        },
        cloudId: cloudId,
        hostProduct: 'confluence'
    }).href : `/wiki/people/${userId}`;
    else if (primaryProduct === 'townsquare') return (0, $dh538.fg)('platform-adopt-teams-nav-config') ? (0, $ay6Zz.navigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: userId
        },
        cloudId: cloudId,
        hostProduct: 'home'
    }).href : `/o/${orgId}/people/${userId}?cloudId=${cloudId}`;
};
module.exports["getUserPath"] = $dba528931595cd79$export$451f7a1e7c934f54;

});

parcelRegister("5e5BE", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $ay6Zz = parcelRequire("ay6Zz");

const $1c9cc7f1c0db61db$export$9456a8e088bfede1 = (teamId, primaryProduct, orgId, cloudId)=>{
    if (primaryProduct === 'confluence') return (0, $dh538.fg)('platform-adopt-teams-nav-config') ? (0, $ay6Zz.navigateToTeamsApp)({
        type: 'TEAM',
        payload: {
            teamId: teamId
        },
        cloudId: cloudId,
        hostProduct: 'confluence'
    }).href : `/wiki/people/team/${teamId}`;
    else if (primaryProduct === 'townsquare') return (0, $dh538.fg)('platform-adopt-teams-nav-config') ? (0, $ay6Zz.navigateToTeamsApp)({
        type: 'TEAM',
        payload: {
            teamId: teamId
        },
        cloudId: cloudId
    }).href : `/o/${orgId}/people/team/${teamId}?cloudId=${cloudId}`;
};
module.exports["getTeamPath"] = $1c9cc7f1c0db61db$export$9456a8e088bfede1;

});

parcelRegister("9kYXz", function(module, exports) {

var $7ZetK = parcelRequire("7ZetK");


var $2Znam = parcelRequire("2Znam");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $aXWIB = parcelRequire("aXWIB");

const $09a4f345db91ad30$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    googleDocsLabel: {
        id: "document-search-result.google-docs-label",
        defaultMessage: "Docs"
    },
    googleSlidesLabel: {
        id: "document-search-result.google-slides-label",
        defaultMessage: "Slides"
    },
    googleSheetsLabel: {
        id: "document-search-result.google-sheets-label",
        defaultMessage: "Sheets"
    },
    msWordLabel: {
        id: "document-search-result.ms-word-label",
        defaultMessage: "Word"
    },
    msPowerpointLabel: {
        id: "document-search-result.ms-powerpoint-label",
        defaultMessage: "PowerPoint"
    },
    msExcelLabel: {
        id: "document-search-result.ms-excel-label",
        defaultMessage: "Excel"
    },
    documentLabel: {
        id: "document.label",
        defaultMessage: "Document"
    },
    spreadsheetLabel: {
        id: "spreadsheet.label",
        defaultMessage: "Spreadsheet"
    },
    presentationLabel: {
        id: "presentation.label",
        defaultMessage: "Presentation"
    },
    fileLabel: {
        id: "file.label",
        defaultMessage: "File"
    },
    databaseLabel: {
        id: "database.label",
        defaultMessage: "Database"
    },
    webPageLabel: {
        id: "web-page.label",
        defaultMessage: "Web Page"
    },
    pageLabel: {
        id: "page.label",
        defaultMessage: "Page"
    },
    blogpostLabel: {
        id: "blogpost.label",
        defaultMessage: "Blogpost"
    },
    dashboardLabel: {
        id: "dashboard.label",
        defaultMessage: "Dashboard"
    },
    invoiceLabel: {
        id: "invoice.label",
        defaultMessage: "Invoice"
    },
    designLabel: {
        id: "design.label",
        defaultMessage: "Design"
    },
    dealLabel: {
        id: "deal.label",
        defaultMessage: "Deal"
    },
    videoLabel: {
        id: "video.label",
        defaultMessage: "Video"
    },
    taskLabel: {
        id: "task.label",
        defaultMessage: "Task"
    },
    issueLabel: {
        id: "issue.label",
        defaultMessage: "Issue"
    },
    spaceLabel: {
        id: "space.label",
        defaultMessage: "Space"
    },
    projectLabel: {
        id: "project.label",
        defaultMessage: "Project"
    },
    repositoryLabel: {
        id: "repository.label",
        defaultMessage: "Repository"
    },
    branchLabel: {
        id: "branch.label",
        defaultMessage: "Branch"
    },
    commitLabel: {
        id: "commit.label",
        defaultMessage: "Commit"
    },
    pullRequestLabel: {
        id: "pull-request.label",
        defaultMessage: "Pull Request"
    },
    workItemLabel: {
        id: "work-item.label",
        defaultMessage: "Work Item"
    },
    customerOrgLabel: {
        id: "customer-org.label",
        defaultMessage: "Customer Org"
    },
    imageLabel: {
        id: "image.label",
        defaultMessage: "Image"
    },
    archiveLabel: {
        id: "archive.label",
        defaultMessage: "Archive"
    },
    audioLabel: {
        id: "audio.label",
        defaultMessage: "Audio"
    },
    pdfLabel: {
        id: "pdf.label",
        defaultMessage: "PDF"
    },
    codeLabel: {
        id: "code.label",
        defaultMessage: "Code"
    },
    channelLabel: {
        id: "channel.label",
        defaultMessage: "Channel"
    },
    knowledgeArticleLabel: {
        id: "3p-result-labeling.knowledge_article.label",
        defaultMessage: "Knowledge article"
    },
    newsArticleLabel: {
        id: "3p-result-labeling.news_article.label",
        defaultMessage: "News article"
    },
    otherLabel: {
        id: "other.label",
        defaultMessage: "Other"
    }
});


const $a9e61b13b0839871$export$a47c0c6de01249fd = ({ product: product, subtype: subtype })=>{
    if (!product || !subtype) return;
    const SUBTYPE_DOCUMENT = 'DOCUMENT';
    const SUBTYPE_PRESENTATION = 'PRESENTATION';
    const SUBTYPE_SPREADSHEET = 'SPREADSHEET';
    const GOOGLE_LABELS = {
        [SUBTYPE_DOCUMENT]: (0, $09a4f345db91ad30$export$defe85febe8b728c).googleDocsLabel,
        [SUBTYPE_PRESENTATION]: (0, $09a4f345db91ad30$export$defe85febe8b728c).googleSlidesLabel,
        [SUBTYPE_SPREADSHEET]: (0, $09a4f345db91ad30$export$defe85febe8b728c).googleSheetsLabel
    };
    const MICROSOFT_LABELS = {
        [SUBTYPE_DOCUMENT]: (0, $09a4f345db91ad30$export$defe85febe8b728c).msWordLabel,
        [SUBTYPE_PRESENTATION]: (0, $09a4f345db91ad30$export$defe85febe8b728c).msPowerpointLabel,
        [SUBTYPE_SPREADSHEET]: (0, $09a4f345db91ad30$export$defe85febe8b728c).msExcelLabel
    };
    const normalizedSubtype = subtype?.toUpperCase();
    let label;
    if (product === (0, $b4tvS.ProductKeys).Sharepoint || product === (0, $b4tvS.ProductKeys).OneDrive) label = MICROSOFT_LABELS[normalizedSubtype];
    else if (product.includes((0, $b4tvS.ProductKeys).GoogleDrive)) label = GOOGLE_LABELS[normalizedSubtype];
    else if (product.includes((0, $b4tvS.ProductKeys).AtlassianWebCrawler) && // QF returns subtype with underscores, f.e. 'WEB_PAGE', so we need to support both
    subtype.replace('_', '-') === (0, $2Znam.NounSubtypeKey).WebPage) label = (0, $09a4f345db91ad30$export$defe85febe8b728c).webPageLabel;
    else if (subtype === (0, $2Znam.NounSubtypeKey).KnowledgeArticle || // QF returns subtype in uppercase (e.g. 'KNOWLEDGE_ARTICLE'), so we support both casings
    normalizedSubtype === 'KNOWLEDGE_ARTICLE') label = (0, $09a4f345db91ad30$export$defe85febe8b728c).knowledgeArticleLabel;
    else if (subtype === (0, $2Znam.NounSubtypeKey).NewsArticle || // QF returns subtype in uppercase (e.g. 'NEWS_ARTICLE'), so we support both casings
    normalizedSubtype === 'NEWS_ARTICLE') label = (0, $09a4f345db91ad30$export$defe85febe8b728c).newsArticleLabel;
    return label;
};
// Provider-aware label so that e.g. GitHub work items render as "Issue"
// rather than the generic "Work item". Mirrors the providerDefaultLabelMap
// in the full search results page work-item renderer.
const $a9e61b13b0839871$var$providerDefaultLabelMap = {
    [(0, $b4tvS.ProductKeys).Github]: (0, $09a4f345db91ad30$export$defe85febe8b728c).issueLabel
};
const $a9e61b13b0839871$export$67bc9d7952cf216d = ({ product: product, subtype: subtype, resourceType: resourceType })=>{
    const documentLabel = $a9e61b13b0839871$export$a47c0c6de01249fd({
        product: product,
        subtype: subtype
    });
    if (documentLabel) return documentLabel;
    if (!resourceType) return;
    if (resourceType === (0, $7ZetK.ResourceType).VIDEO) return (0, $09a4f345db91ad30$export$defe85febe8b728c).videoLabel;
    else if (resourceType === (0, $7ZetK.ResourceType).REPOSITORY) return (0, $09a4f345db91ad30$export$defe85febe8b728c).repositoryLabel;
    else if (resourceType === (0, $7ZetK.ResourceType).PULL_REQUEST) return (0, $09a4f345db91ad30$export$defe85febe8b728c).pullRequestLabel;
    else if (resourceType === (0, $7ZetK.ResourceType).BRANCH) return (0, $09a4f345db91ad30$export$defe85febe8b728c).branchLabel;
    else if (resourceType === (0, $7ZetK.ResourceType).COMMIT) return (0, $09a4f345db91ad30$export$defe85febe8b728c).commitLabel;
    else if (resourceType === (0, $7ZetK.ResourceType).WORK_ITEM) {
        if (product && $a9e61b13b0839871$var$providerDefaultLabelMap[product]) return $a9e61b13b0839871$var$providerDefaultLabelMap[product];
        return (0, $09a4f345db91ad30$export$defe85febe8b728c).workItemLabel;
    }
    return undefined;
};
const $a9e61b13b0839871$export$19dc2415a5fa9123 = ({ product: product, subtype: subtype })=>{
    if (!product || !subtype) return;
    const labelKey = `${subtype}Label`;
    if (labelKey in (0, $09a4f345db91ad30$export$defe85febe8b728c)) return (0, $09a4f345db91ad30$export$defe85febe8b728c)[labelKey];
    else return (0, $09a4f345db91ad30$export$defe85febe8b728c).otherLabel;
};
module.exports["getDocumentSubtypeLabel"] = $a9e61b13b0839871$export$a47c0c6de01249fd;
module.exports["getSubtypeLabel"] = $a9e61b13b0839871$export$67bc9d7952cf216d;
module.exports["getRemoteLinkSubtypeLabel"] = $a9e61b13b0839871$export$19dc2415a5fa9123;

});

parcelRegister("i6Ooe", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $5nBzc = parcelRequire("5nBzc");




const $4851d5766ba33563$export$373c576b545d33cb = (0, $aXWIB.defineMessages)({
    open: {
        id: "search-page.common.graph-work-item-status.open",
        defaultMessage: "Open"
    },
    closed: {
        id: "search-page.common.graph-work-item-status.closed",
        defaultMessage: "Closed"
    }
});


/**
 * Map a third-party **work-item** status (e.g. GitHub issue states) onto the
 * appropriate Atlaskit Lozenge appearance.
 *
 * Only the two canonical GitHub work-item states (`OPEN`, `CLOSED`) are
 * supported. Inputs are case-insensitive — callers may pass the value as it
 * comes from the API (`"open"`, `"OPEN"`, …). Anything else falls back to
 * `'neutral'`.
 *
 * Kept separate from `getPullRequestStatusAppearance` so the two domains stay
 * decoupled and additions to either map can't accidentally affect the other.
 */ const $c051f5e53e3ba6ed$var$workItemStatusToLozengeMap = {
    OPEN: 'information',
    // blue
    CLOSED: 'success' // green
};
const $c051f5e53e3ba6ed$var$getAppearance = (status)=>(status ? $c051f5e53e3ba6ed$var$workItemStatusToLozengeMap[status.toUpperCase()] : undefined) ?? 'neutral';
const $c051f5e53e3ba6ed$export$c8ca8b382bc642d1 = ({ status: status })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    if (!status) return null;
    const message = (0, $4851d5766ba33563$export$373c576b545d33cb)[status.toLowerCase()];
    const label = message ? formatMessage(message) : status;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
        appearance: $c051f5e53e3ba6ed$var$getAppearance(status),
        testId: "graph-work-item-status-lozenge-test-id"
    }, label);
};
module.exports["GraphWorkItemStatusLozenge"] = $c051f5e53e3ba6ed$export$c8ca8b382bc642d1;

});

parcelRegister("2waBy", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $g5QRf = parcelRequire("g5QRf");


var $fwXBL = parcelRequire("fwXBL");


var $eiXsV = parcelRequire("eiXsV");


var $226KS = parcelRequire("226KS");


var $hbYDZ = parcelRequire("hbYDZ");


var $9lz2c = parcelRequire("9lz2c");


var $5aaqS = parcelRequire("5aaqS");


var $1yB28 = parcelRequire("1yB28");


var $4ayWZ = parcelRequire("4ayWZ");


var $4AkKf = parcelRequire("4AkKf");


var $eG1e2 = parcelRequire("eG1e2");


var $gJsgh = parcelRequire("gJsgh");


var $5LN4K = parcelRequire("5LN4K");


var $bVHZY = parcelRequire("bVHZY");


var $f6IRL = parcelRequire("f6IRL");


var $99wB5 = parcelRequire("99wB5");


var $2qVkt = parcelRequire("2qVkt");


var $gj7hi = parcelRequire("gj7hi");


var $6iY4P = parcelRequire("6iY4P");


var $5tnQQ = parcelRequire("5tnQQ");


var $57Wda = parcelRequire("57Wda");


var $8hhCV = parcelRequire("8hhCV");


var $66dpz = parcelRequire("66dpz");


var $6atSO = parcelRequire("6atSO");


var $eQfRp = parcelRequire("eQfRp");


var $i7jPX = parcelRequire("i7jPX");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $aRSt4 = parcelRequire("aRSt4");

const $5a4ea6f059d19d35$var$isImageDataUrl = (str)=>/^data:image\/[^;]+;base64,/.test(str); /**
                                                                                 * Returns the appropriate icon for a Jira item based on the provided parameters.
                                                                                 *
                                                                                 * @param {string | null | undefined} iconUrl - The URL of the icon image.
                                                                                 * @param {SearchResultType | string} type - The type of the search result (e.g., 'board', 'plan', etc.).
                                                                                 * @param {boolean} isIssue - Flag indicating if the item is an issue.
                                                                                 * @param {'small' | 'medium'} [size='small'] - The size of the icon ('small' or 'medium').
                                                                                 * @returns {React.JSX.Element} The JSX element representing the icon.
                                                                                 */ 
const $5a4ea6f059d19d35$export$348a13c9e1254ce4 = ({ iconUrl: iconUrl, type: type, isIssue: isIssue, size: size = 'small' })=>{
    const imageSize = size === 'medium' ? 22 : 16; // Use the iconUrl if available
    if (iconUrl) {
        if (isIssue) // wrapper is only needed for issues. Other types don't need the background and padding with iconUrl.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
            label: "Work item icon",
            size: size
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
            alt: "Work item icon",
            testId: "jira-entity-icon",
            width: imageSize,
            height: imageSize,
            src: iconUrl
        }));
        return(// The image covers up the whole wrapper
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
            isInset: false,
            label: `${type} icon`,
            size: size
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
            alt: `${type} icon`,
            testId: "jira-entity-icon",
            src: iconUrl
        })));
    }
    if (isIssue) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
        label: "Work item icon",
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2qVkt))), {
        spacing: "none",
        size: size,
        label: "work-item-icon"
    }));
    let icon;
    switch(type){
        case 'board':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5aaqS))), {
                spacing: "none",
                size: size,
                label: "board-icon"
            });
            break;
        case 'plan':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f6IRL))), {
                spacing: "none",
                size: size,
                label: "plan-icon"
            });
            break;
        case 'filter':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4AkKf))), {
                spacing: "none",
                size: size,
                label: "filter-icon"
            });
            break;
        case 'dashboard':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ayWZ))), {
                spacing: "none",
                size: size,
                label: "dashboard-icon"
            });
            break;
        case 'project':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hbYDZ))), {
                spacing: "none",
                size: size,
                label: "space-icon"
            });
            break;
        case 'incident':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5LN4K))), {
                spacing: "none",
                size: size,
                label: "incident-icon"
            });
            break;
        default:
            // This never happens
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aRSt4.ProductIcon), {
                size: size,
                product: (0, $b4tvS.ProductKeys).Jira
            });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
        label: `${type} icon`,
        size: size
    }, icon);
};
const $5a4ea6f059d19d35$export$e375917bfb190d26 = ({ iconUrl: iconUrl, type: type, size: size = 'small', isLiveDoc: isLiveDoc = false })=>{
    try {
        // Use the iconUrl if available, the iconUrl for Confluence entities is usually an absolute URL
        // We only use custom iconUrl for Spaces
        if (type === 'space' && iconUrl && ($5a4ea6f059d19d35$var$isImageDataUrl(iconUrl) || new URL(iconUrl))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
            isInset: false,
            label: `${type} icon`,
            size: size
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
            src: iconUrl
        }));
    } catch  {} /*
              ** For finding all the Confluence entities look at platform/packages/search/search-page/src/common/utils/filters/constants.ts -> typeFilter1PMapping
              * */ 
    let icon;
    switch(type){
        case 'space':
            // spaces usually have an iconUrl, but if not we fall back to the project icon
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bVHZY))), {
                size: size,
                label: "space icon"
            });
            break;
        case 'page':
            if (isLiveDoc) icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $66dpz.default), {
                size: size,
                label: "live page icon"
            });
            else icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8hhCV.default), {
                size: size,
                label: "page icon"
            });
            break;
        case 'blogpost':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6iY4P.default), {
                size: size,
                label: "blogpost icon"
            });
            break;
        case 'attachment':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9lz2c))), {
                spacing: "none",
                size: size,
                label: "attachment icon"
            });
            break;
        case 'comment':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
                spacing: "none",
                size: size,
                label: "comment icon"
            });
            break;
        case 'whiteboard':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eQfRp.default), {
                size: size,
                label: "whiteboard icon"
            });
            break;
        case 'slide':
            // CNS-25852: render the slide icon for slides search results so
            // they no longer fall back to the generic Confluence product icon.
            // Imported directly from icon-lab rather than @atlaskit/object
            // because the object codegen entry doesn't exist yet.
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5QRf))), {
                spacing: "none",
                size: size,
                label: "slide icon",
                color: "var(--ds-icon-accent-green, #22A06B)"
            });
            break;
        case 'database':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $57Wda.default), {
                size: size,
                label: "database icon"
            });
            break;
        case 'question':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6atSO.default), {
                size: size,
                label: "question icon"
            });
            break;
        case 'calendar':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5tnQQ.default), {
                size: size,
                label: "calendar icon"
            });
            break;
        case 'embed':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($99wB5))), {
                spacing: "none",
                size: size,
                label: "embed icon"
            });
            break;
        case 'folder':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eG1e2))), {
                spacing: "none",
                size: size,
                label: "folder icon"
            });
            break;
        default:
            // fallback to product icon. It has no wrapper
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aRSt4.ProductIcon), {
                label: "confluence icon",
                size: size,
                product: (0, $b4tvS.ProductKeys).Confluence
            });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
        label: `${type} icon`,
        size: size
    }, icon);
};
const $5a4ea6f059d19d35$export$397605bdd85a2f89 = ({ iconUrl: iconUrl, type: type, size: size = 'small' })=>{
    try {
        // Use the iconUrl if available, the iconUrl for Atlas entities is usually an absolute URL
        if (iconUrl && ($5a4ea6f059d19d35$var$isImageDataUrl(iconUrl) || new URL(iconUrl))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
            isInset: false,
            label: `${type} icon`,
            size: size
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
            src: iconUrl
        }));
    } catch  {}
    let icon;
    switch(type){
        case 'goal':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gJsgh))), {
                size: size,
                label: "goal icon"
            });
            break;
        case 'project':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bVHZY))), {
                size: size,
                label: "project icon"
            });
            break;
        default:
            // fallback to product icon. It has no wrapper
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aRSt4.ProductIcon), {
                label: "Atlas icon",
                size: size,
                product: (0, $b4tvS.ProductKeys).Atlas
            });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
        label: `${type} icon`,
        size: size
    }, icon);
}; /**
    * Returns the appropriate icon for a Jira item based on the provided parameters.
    *
    * @param {string | null | undefined} iconUrl - The URL of the icon image.
    * @param {SearchResultType | string} type - The type of the search result (e.g., 'board', 'plan', etc.).
    * @param {boolean} isIssue - Flag indicating if the item is an issue.
    * @param {'small' | 'medium'} [size='small'] - The size of the icon ('small' or 'medium').
    * @returns {React.JSX.Element} The JSX element representing the icon.
    */ 
const $5a4ea6f059d19d35$export$fbba347fb6ffa903 = ({ iconUrl: iconUrl, type: type, size: size = 'small' })=>{
    // Use the iconUrl if available
    if (iconUrl) return(// The image covers up the whole wrapper
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
        label: `${type} icon`,
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        alt: "",
        testId: "assets-entity-icon",
        src: iconUrl
    })));
    let icon;
    switch(type){
        case 'schema':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($226KS))), {
                spacing: "none",
                size: size,
                label: "schema-icon"
            });
            break;
        case 'type':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eiXsV))), {
                spacing: "none",
                size: size,
                label: "type-icon"
            });
            break;
        case 'object':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fwXBL))), {
                spacing: "none",
                size: size,
                label: "object-icon"
            });
            break;
        default:
            // This never happens
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aRSt4.ProductIcon), {
                size: size,
                product: (0, $b4tvS.ProductKeys).Assets
            });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
        label: `${type} icon`,
        size: size
    }, icon);
};
module.exports["getJiraEntityIcon"] = $5a4ea6f059d19d35$export$348a13c9e1254ce4;
module.exports["getConfluenceEntityIcon"] = $5a4ea6f059d19d35$export$e375917bfb190d26;
module.exports["getAtlasEntityIcon"] = $5a4ea6f059d19d35$export$397605bdd85a2f89;
module.exports["getAssetsEntityIcon"] = $5a4ea6f059d19d35$export$fbba347fb6ffa903;

});

parcelRegister("eiXsV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0aca1d30928709a7afbf0b04d0a092a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a6a0dfbc8274aeb4$var$_react = $a6a0dfbc8274aeb4$var$_interopRequireDefault((parcelRequire("42omo")));

var $a6a0dfbc8274aeb4$var$_baseNew = $a6a0dfbc8274aeb4$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a6a0dfbc8274aeb4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsObjectType".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing object types in Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a6a0dfbc8274aeb4$var$AssetsObjectTypeIcon = (props)=>/*#__PURE__*/ $a6a0dfbc8274aeb4$var$_react.default.createElement($a6a0dfbc8274aeb4$var$_baseNew.default, Object.assign({
        name: "AssetsObjectTypeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11 14.5h3.5V11H11zm-5.5-11a2 2 0 1 0-4 0 2 2 0 0 0 4 0M16 14.625c0 .76-.616 1.375-1.375 1.375h-3.75c-.76 0-1.375-.616-1.375-1.375v-3.75c0-.76.616-1.375 1.375-1.375h3.75c.76 0 1.375.616 1.375 1.375zM7 3.5a3.5 3.5 0 0 1-2.75 3.418V11.5a.5.5 0 0 0 .5.5H8v1.5H4.75a2 2 0 0 1-2-2V6.918A3.5 3.5 0 1 1 7 3.5"/>`
    }, props));
$a6a0dfbc8274aeb4$var$AssetsObjectTypeIcon.displayName = 'AssetsObjectTypeIcon';
var $a6a0dfbc8274aeb4$var$_default = module.exports.default = $a6a0dfbc8274aeb4$var$AssetsObjectTypeIcon;

});

parcelRegister("aRSt4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $tvI67 = parcelRequire("tvI67");


var $9VJDA = parcelRequire("9VJDA");


var $4EMbH = parcelRequire("4EMbH");


var $1yEFx = parcelRequire("1yEFx");


var $9d9t8 = parcelRequire("9d9t8");


var $2OtFZ = parcelRequire("2OtFZ");

const $6ae4bffafe6abebf$export$1a199e029d5e93d6 = ({ product: product, size: size = 'large', isSelected: isSelected = false, useSearchResultIcon: useSearchResultIcon = false, ...props })=>{
    const products = (0, $1yEFx.useProductConfigs)();
    if (product) {
        // First check if it's a Forge connector - prioritize dynamic API icons
        if ((0, $9d9t8.isForgeConnectorProductKey)(product)) {
            const forgeIcon = (0, $9d9t8.getForgeConnectorIcon)(product);
            if (forgeIcon) // Forge connector icons are RovoLogo functions, not React components
            return forgeIcon({
                ...props,
                size: size
            });
        }
        // Fallback to static products map (covers hardcoded Forge connectors and all other products)
        const config = products[product];
        if (config) {
            const Icon = useSearchResultIcon && config.SearchResultIcon || config.Icon;
            if (Icon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
                ...props,
                size: size,
                shouldUseNewLogoDesign: true
            });
        }
    }
    // Fallback to AppsIcon
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($tvI67))), {
        label: "",
        spacing: "spacious",
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
    });
};
const $6ae4bffafe6abebf$export$f73e324780005aef = ({ isShowMore: isShowMore, productOrNounKey: productOrNounKey, size: size = 'large', isSelected: isSelected = false, ...props })=>{
    if (isShowMore) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
        label: "",
        size: (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? 'small' : 'medium',
        spacing: (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? 'compact' : 'spacious',
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
    });
    return $6ae4bffafe6abebf$export$fe03eddc92730a5c({
        productOrNounKey: productOrNounKey,
        size: size,
        isSelected: isSelected,
        ...props
    });
};
const $6ae4bffafe6abebf$export$fe03eddc92730a5c = ({ productOrNounKey: productOrNounKey, size: size = 'large', isSelected: isSelected = false, ...props })=>{
    const products = (0, $1yEFx.useProductConfigs)();
    let Icon;
    if (productOrNounKey) {
        const isNounFilter = (0, $4EMbH.isNounKey)(productOrNounKey);
        if (isNounFilter) Icon = (0, $4EMbH.nouns)[productOrNounKey].Icon;
        else {
            // First check if it's a Forge connector - prioritize dynamic API icons
            if ((0, $9d9t8.isForgeConnectorProductKey)(productOrNounKey)) {
                const forgeIcon = (0, $9d9t8.getForgeConnectorIcon)(productOrNounKey);
                if (forgeIcon) // Forge connector icons are RovoLogo functions, not React components
                return forgeIcon({
                    ...props,
                    size: size
                });
            }
            // Fallback to static products map (covers hardcoded Forge connectors and all other products)
            const productConfig = products[productOrNounKey];
            if (productConfig?.Icon) Icon = productConfig.Icon;
        }
        if (Icon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            ...props,
            size: size
        });
    }
    // Fallback to AppsIcon
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($tvI67))), {
        label: "",
        size: (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? 'small' : 'medium',
        spacing: (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? 'compact' : 'spacious',
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
    });
};
module.exports["ProductIcon"] = $6ae4bffafe6abebf$export$1a199e029d5e93d6;
module.exports["IconDecider"] = $6ae4bffafe6abebf$export$f73e324780005aef;
module.exports["ProductOrNounIcon"] = $6ae4bffafe6abebf$export$fe03eddc92730a5c;

});

parcelRegister("4EMbH", function(module, exports) {

var $lAFHW = parcelRequire("lAFHW");


var $9yyKc = parcelRequire("9yyKc");

/* custom-link-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $i7jPX = parcelRequire("i7jPX");

function $0ee2752244ba67e0$export$5efe8561ca252843({ size: size = 'medium', label: label = '', testId: testId }) {
    return(// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    /*#__PURE__*/ $42omo.createElement((0, $i7jPX.default), {
        label: label,
        size: size,
        isInset: false,
        backgroundColor: "white",
        testId: testId
    }, /*#__PURE__*/ $42omo.createElement("svg", {
        height: "100%",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ $42omo.createElement("rect", {
        //eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        fill: "#dddee1",
        x: "0",
        y: "0",
        width: "24",
        height: "24"
    }), /*#__PURE__*/ $42omo.createElement("path", {
        fill: "#101214",
        fillRule: "evenodd",
        d: "M19 12a7 7 0 1 0-14 0 7 7 0 0 0 14 0m-9.37 4.625.026.074a5.26 5.26 0 0 1-2.833-3.824h2.136c.069 1.426.306 2.73.67 3.75m1.08-3.75c.068 1.255.278 2.353.567 3.162.179.5.37.841.54 1.042a.6.6 0 0 0 .183.165.7.7 0 0 0 .183-.165c.17-.2.361-.543.54-1.042.288-.809.498-1.907.566-3.162zm2.58-1.75h-2.58c.068-1.255.278-2.353.567-3.162.179-.5.37-.841.54-1.042A.7.7 0 0 1 12 6.756a.6.6 0 0 1 .183.165c.17.2.361.543.54 1.042.288.809.498 1.907.566 3.162m1.751 1.75c-.069 1.426-.306 2.73-.67 3.75l-.027.074a5.26 5.26 0 0 0 2.833-3.824zm2.136-1.75H15.04c-.069-1.426-.306-2.73-.67-3.75l-.027-.074a5.26 5.26 0 0 1 2.833 3.824m-8.218 0H6.823a5.26 5.26 0 0 1 2.833-3.824l-.027.074c-.364 1.02-.601 2.324-.67 3.75",
        clipRule: "evenodd"
    }))));
}



var $aXWIB = parcelRequire("aXWIB");

const $40bcb23b548b87bc$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    webPage: {
        id: "search-page.products.custom-website",
        defaultMessage: "Web page"
    },
    webPages: {
        id: "search-page.products.custom-websites",
        defaultMessage: "Web pages"
    },
    project: {
        id: "search-page.nouns.project",
        defaultMessage: "Project"
    },
    projects: {
        id: "search-page.nouns.projects",
        defaultMessage: "Projects"
    },
    goal: {
        id: "search-page.nouns.goal",
        defaultMessage: "Goal"
    },
    goals: {
        id: "search-page.nouns.goals",
        defaultMessage: "Goals"
    },
    tag: {
        id: "search-page.nouns.tag",
        defaultMessage: "Tag"
    },
    tags: {
        id: "search-page.nouns.tags",
        defaultMessage: "Tags"
    }
});


const $518be078bbe36df5$export$a93cddd79e3ea530 = {
    project: 'project',
    goal: 'goal',
    // tag: 'tag',
    AtlassianWebCrawler: 'atlassian-web-crawler'
};
const $518be078bbe36df5$export$cc6a3ce6b37346b2 = (key)=>{
    return Object.values($518be078bbe36df5$export$a93cddd79e3ea530).includes(key);
};
const $518be078bbe36df5$export$5cb7c19fcb84c9cd = {
    [$518be078bbe36df5$export$a93cddd79e3ea530.project]: {
        displayName: (0, $40bcb23b548b87bc$export$defe85febe8b728c).project,
        displayNamePlural: (0, $40bcb23b548b87bc$export$defe85febe8b728c).projects,
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $lAFHW.ProjectsIcon), 'Project')
    },
    [$518be078bbe36df5$export$a93cddd79e3ea530.goal]: {
        displayName: (0, $40bcb23b548b87bc$export$defe85febe8b728c).goal,
        displayNamePlural: (0, $40bcb23b548b87bc$export$defe85febe8b728c).goals,
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $lAFHW.GoalsIcon), 'Goal')
    },
    //Tag Noun has been omitted because it is not currently implemented in FPS and risks visual degradation with the t25 icon update
    //Discussion here: https://atlassian.slack.com/archives/C08HFJLM7J5/p1742856483784089
    // [NounKeys.tag]: {
    // 	displayName: messages.tag,
    // 	displayNamePlural: messages.tags,
    // 	Icon: RovoLogoFromLogo(HashtagIcon, 'Tag'),
    // },
    [$518be078bbe36df5$export$a93cddd79e3ea530.AtlassianWebCrawler]: {
        displayName: (0, $40bcb23b548b87bc$export$defe85febe8b728c).webPage,
        displayNamePlural: (0, $40bcb23b548b87bc$export$defe85febe8b728c).webPages,
        Icon: (0, $9yyKc.RovoLogoFromLogo)((0, $0ee2752244ba67e0$export$5efe8561ca252843), 'Atlassian Web Crawler')
    }
};
const $518be078bbe36df5$export$341b1567666c2663 = [
    $518be078bbe36df5$export$a93cddd79e3ea530.project,
    $518be078bbe36df5$export$a93cddd79e3ea530.goal,
    // NounKeys.tag,
    $518be078bbe36df5$export$a93cddd79e3ea530.AtlassianWebCrawler // Web Crawler is not a noun, we should improve this
];
module.exports["NounKeys"] = $518be078bbe36df5$export$a93cddd79e3ea530;
module.exports["isNounKey"] = $518be078bbe36df5$export$cc6a3ce6b37346b2;
module.exports["nouns"] = $518be078bbe36df5$export$5cb7c19fcb84c9cd;
module.exports["NOUNS_ORDER"] = $518be078bbe36df5$export$341b1567666c2663;

});

parcelRegister("9lW6K", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $d2d3be1d2699235a$var$HIGHLIGHT_START_TAG = '@@@hl@@@';
const $d2d3be1d2699235a$var$HIGHLIGHT_END_TAG = '@@@endhl@@@';
const $d2d3be1d2699235a$var$highlightRE = new RegExp(`${$d2d3be1d2699235a$var$HIGHLIGHT_START_TAG}(.*?)${$d2d3be1d2699235a$var$HIGHLIGHT_END_TAG}.*`);
const $d2d3be1d2699235a$var$openingTagRE = new RegExp(`(.*?)${$d2d3be1d2699235a$var$HIGHLIGHT_START_TAG}`);
const $d2d3be1d2699235a$export$c43ff622b37ceaa9 = (title)=>{
    const enrichedTitle = [];
    // counter added to maintain uniqueness of element key
    // during subsequent rerenders due to query changes
    let counter = 0;
    if (!title.match($d2d3be1d2699235a$var$highlightRE)) // if there are no matches then return the title as is
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        key: title + counter
    }, title);
    while(title){
        const [preMatch, preText] = title.match($d2d3be1d2699235a$var$openingTagRE) || [];
        title = title.replace(preText, '');
        if (preText && preText !== '') enrichedTitle.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            as: "span",
            key: preText + counter
        }, preText));
        const [boldMatch, highlightText] = title.match($d2d3be1d2699235a$var$highlightRE) || [];
        title = title.replace(`${$d2d3be1d2699235a$var$HIGHLIGHT_START_TAG}${highlightText}${$d2d3be1d2699235a$var$HIGHLIGHT_END_TAG}`, '');
        if (highlightText && highlightText !== '') enrichedTitle.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            as: "strong",
            key: highlightText + counter
        }, highlightText));
        if (preMatch === undefined && boldMatch === undefined) {
            if (title !== '') enrichedTitle.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                as: "span",
                key: title + counter
            }, title));
            break;
        }
        counter++;
    }
    return enrichedTitle;
};
module.exports["enrichResultTitle"] = $d2d3be1d2699235a$export$c43ff622b37ceaa9;

});

parcelRegister("1VHLw", function(module, exports) {
/**
 * Returns true for middle-clicks (button === 1). Right-clicks are excluded to avoid
 * double-counting with onContextMenu.
 */ const $9456440de0859bb4$export$15213acd7ac7d39a = (e)=>{
    return e.button === 1;
};
module.exports["isAuxClick"] = $9456440de0859bb4$export$15213acd7ac7d39a;

});

parcelRegister("46mBC", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $39XmP = parcelRequire("39XmP");


var $dh538 = parcelRequire("dh538");


var $b4tvS = parcelRequire("b4tvS");

/**
 * Explicitly OPT IN a non-1P product to cross-product URL wrapping.
 *
 * Use sparingly — most products that should be wrapped are expressible via
 * the 1P default rule. Typed loosely as `Record<string, true>` because, by
 * definition, these keys are not in {@link ProductKeys1P}.
 */ const $ffa8421a28e6e843$var$ADDITIONAL_WRAPPABLE_PRODUCTS = {
    goals: true,
    projects: true,
    loom: true,
    teams: true
};
/**
 * Explicitly OPT OUT a 1P product from cross-product URL wrapping.
 *
 * Typed against {@link ProductKeys1P} so a stale entry (e.g. after a 1P key
 * is removed from the master `ProductKeys1P` constant) fails the build.
 */ const $ffa8421a28e6e843$var$NON_WRAPPABLE_1P = {
};
const $ffa8421a28e6e843$export$4cf40959dee0db9c = (resultProduct)=>{
    if (resultProduct in $ffa8421a28e6e843$var$NON_WRAPPABLE_1P) return false;
    if (resultProduct in $ffa8421a28e6e843$var$ADDITIONAL_WRAPPABLE_PRODUCTS) return true;
    return (0, $b4tvS.is1pProductKey)(resultProduct);
};
const $ffa8421a28e6e843$export$8e7034cb7abd8b0f = {
    ADDITIONAL_WRAPPABLE_PRODUCTS: $ffa8421a28e6e843$var$ADDITIONAL_WRAPPABLE_PRODUCTS,
    NON_WRAPPABLE_1P: $ffa8421a28e6e843$var$NON_WRAPPABLE_1P
};
const $ffa8421a28e6e843$export$2a57f89490774c5c = (args)=>{
    const { bridge: bridge, primaryProduct: primaryProduct, primarySubProduct: primarySubProduct } = args;
    // `useCrossProductUrlWrapper` requires a non-empty `product` string. When
    // `primaryProduct` is undefined the outer guard below short-circuits and
    // the wrapper is never invoked, so this fallback is only there to keep
    // the hook call legal.
    const wrapUrl = (0, $39XmP.default)({
        bridge: bridge,
        product: primaryProduct ?? 'unknown',
        subProduct: primarySubProduct || undefined
    });
    const isEnabled = (0, $dh538.fg)('rovo_search_cross_product_url_wrapping');
    return (0, $42omo.useMemo)(()=>(url, resultProduct)=>{
            if (!isEnabled || !url || !primaryProduct || !resultProduct) return url;
            if (!$ffa8421a28e6e843$export$4cf40959dee0db9c(resultProduct)) return url;
            if (resultProduct === primaryProduct) return url;
            return wrapUrl(url);
        }, [
        wrapUrl,
        primaryProduct,
        isEnabled
    ]);
};
module.exports["useSearchCrossProductUrlWrapper"] = $ffa8421a28e6e843$export$2a57f89490774c5c;

});

parcelRegister("jAenQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fpGTa = parcelRequire("fpGTa");


var $7WbA8 = parcelRequire("7WbA8");

const $5c2811b97c7b9fe1$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { onNavigate: onNavigate } = (0, $7WbA8.useAppContext)();
    const { href: href, onClick: originalOnClick } = props;
    const onClick = (0, $42omo.useCallback)((event, analyticsEvent)=>{
        originalOnClick?.(event, analyticsEvent);
        // Use onNavigate if
        // - alwaysUseOnLinkClick is true
        // - navigating to the same site and not new tab/window
        const metaPressed = event.ctrlKey || event.metaKey || event.shiftKey;
        const sameOrigin = window.location.origin === new URL(href).origin;
        const onNavigateOverride = typeof onNavigate === 'object' ? onNavigate.options.alwaysUseOnLinkClick : false;
        const useOnNavigate = onNavigateOverride || sameOrigin && !metaPressed;
        if (useOnNavigate) {
            event.preventDefault();
            // Handles SPA navigation if consumer provides their own onNavigate
            const onNavigateCallback = typeof onNavigate === 'function' ? onNavigate : onNavigate.callback;
            onNavigateCallback(href, 'push');
        }
    }, [
        href,
        onNavigate,
        originalOnClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fpGTa.default), {
        ref: ref,
        ...props,
        onClick: onClick
    });
});
module.exports["Link"] = $5c2811b97c7b9fe1$export$a6c7ac8248d6e38a;

});

parcelRegister("a7nUd", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $1yEFx = parcelRequire("1yEFx");


var $gpC9w = parcelRequire("gpC9w");


var $h7sRY = parcelRequire("h7sRY");


var $mdlgz = parcelRequire("mdlgz");


var $gCEkV = parcelRequire("gCEkV");

const $d8124c60cf01e764$var$socialMetadataStyles = (0, $ecnYn.xcss)({
    alignItems: 'center',
    paddingInlineStart: 'space.050',
    paddingInlineEnd: 'space.050'
});
const $d8124c60cf01e764$var$subheadingStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    font: 'font.body'
});
const $d8124c60cf01e764$var$subheadingLeftAreaStyles = (0, $ecnYn.xcss)({
    gridArea: 'subheading-left',
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    overflow: 'hidden'
});
const $d8124c60cf01e764$var$inlineStyles = (0, $ecnYn.xcss)({
    flex: '1 0 auto',
    position: 'absolute',
    zIndex: 'card',
    alignItems: 'center'
});
const $d8124c60cf01e764$var$hiddenReferenceInlineStyles = (0, $ecnYn.xcss)({
    flex: '1 0 auto',
    visibility: 'hidden',
    position: 'relative',
    zIndex: '1',
    alignItems: 'center'
});
const $d8124c60cf01e764$var$metadataItemStyles = (0, $ecnYn.xcss)({
    display: 'inline-flex',
    alignItems: 'center'
});
const $d8124c60cf01e764$var$renderParts = (part, spacer)=>{
    const [key, value] = Array.isArray(part) ? part : [
        part,
        part
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), {
        key: key
    }, value, spacer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $mdlgz.Spacer), null));
};
const $d8124c60cf01e764$var$filterPart = (part)=>{
    if (Array.isArray(part)) return !!part[1];
    return !!part;
};
const $d8124c60cf01e764$var$renderSocialMetadata = (defaultSocialParts)=>{
    const socialSignalIndex = defaultSocialParts.findIndex((item)=>Array.isArray(item) && item[1] === 'social-signal');
    const hasBreadcrumb = socialSignalIndex !== -1;
    const parts = defaultSocialParts.filter((_, index)=>index !== socialSignalIndex).filter($d8124c60cf01e764$var$filterPart);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.150",
        xcss: $d8124c60cf01e764$var$socialMetadataStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, parts?.map((m)=>$d8124c60cf01e764$var$renderParts(m, false)))), hasBreadcrumb && defaultSocialParts[defaultSocialParts.length - 1]);
};
const $d8124c60cf01e764$var$SearchMetadataWithOverflowObserver = ({ metadataItems: metadataItems, searchResultId: searchResultId, containerRef: containerRef })=>{
    const headerMetadataWithIds = metadataItems.map((item, index)=>{
        const prefix = searchResultId || 'default';
        return {
            id: `metadata-${prefix}-${index}`,
            content: item
        };
    });
    const headerMetadataRefs = (0, $42omo.useRef)([]);
    headerMetadataRefs.current = headerMetadataWithIds.map((_, i)=>headerMetadataRefs.current[i] ?? /*#__PURE__*/ (0, $42omo.createRef)());
    const visibleItems = (0, $gCEkV.useOverflowObserver)({
        containerRef: containerRef,
        itemRefs: headerMetadataRefs,
        itemIds: headerMetadataWithIds.map((item)=>item.id)
    });
    const hasHiddenItems = headerMetadataWithIds.length > visibleItems.length;
    const processVisibleItems = ()=>{
        const visibleMetadata = headerMetadataWithIds.filter((item)=>visibleItems.includes(item.id));
        // If we have hidden items, remove spacer from last visible item
        if (hasHiddenItems && visibleMetadata.length > 0) {
            const lastIndex = visibleMetadata.length - 1;
            visibleMetadata[lastIndex] = {
                ...visibleMetadata[lastIndex],
                content: (0, $gpC9w.filterSpacer)(visibleMetadata[lastIndex].content)
            };
        }
        return visibleMetadata;
    };
    const processedVisibleItems = processVisibleItems();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $d8124c60cf01e764$var$subheadingLeftAreaStyles,
            $d8124c60cf01e764$var$subheadingStyles
        ],
        testId: "search-page-result-metadata"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        xcss: [
            $d8124c60cf01e764$var$hiddenReferenceInlineStyles
        ],
        testId: "search-page-result-metadata-hidden"
    }, headerMetadataWithIds.map((item, index)=>{
        const elementId = `reference:${item.id}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            key: elementId,
            id: elementId,
            ref: headerMetadataRefs.current[index],
            xcss: $d8124c60cf01e764$var$metadataItemStyles
        }, item.content);
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        xcss: [
            $d8124c60cf01e764$var$inlineStyles
        ],
        testId: "search-page-result-metadata-visible"
    }, processedVisibleItems.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            key: `visible-${item.id}`,
            xcss: $d8124c60cf01e764$var$metadataItemStyles
        }, item.content)), hasHiddenItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h7sRY.MetadataPopupButton), {
        metadata: headerMetadataWithIds.filter((item)=>!visibleItems.includes(item.id)).map((item)=>item.content),
        isFirstElement: processedVisibleItems.length === 0
    })));
};
const $d8124c60cf01e764$export$8e7fb1f8fe599124 = ({ searchResultId: searchResultId, product: product, productSelected: productSelected, parts: defaultParts = [], socialParts: defaultSocialParts = [], displaySpacer: displaySpacer = true, containerRef: containerRef })=>{
    const products = (0, $1yEFx.useProductConfigs)();
    // TODO: Shouldn't need to cast here, need to clean up the stack above this to not pass string around as product
    // Product name is hidden when productSelected=true (i.e. a specific app is selected)
    const productDisplayName = !product || productSelected ? '' : products[product]?.displayName || '';
    const parts = defaultParts.filter($d8124c60cf01e764$var$filterPart);
    const hasSocialParts = defaultSocialParts.filter($d8124c60cf01e764$var$filterPart).length > 0;
    if (hasSocialParts) parts.push([
        'social-metadata',
        $d8124c60cf01e764$var$renderSocialMetadata(defaultSocialParts)
    ]);
    if (productDisplayName) parts.unshift([
        'product-display-name',
        productDisplayName
    ]);
    const metadataItems = parts.map((m, i)=>$d8124c60cf01e764$var$renderParts(m, displaySpacer && i < parts.length - 1));
    // If we don't have a containerRef, we don't want to use the overflow observer
    return containerRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d8124c60cf01e764$var$SearchMetadataWithOverflowObserver, {
        metadataItems: metadataItems,
        searchResultId: searchResultId,
        containerRef: containerRef
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, metadataItems);
};
module.exports["SearchMetadata"] = $d8124c60cf01e764$export$8e7fb1f8fe599124;

});

parcelRegister("gpC9w", function(module, exports) {
/**
 * This file was adapted from confluence/next/packages/search-utils/src/excerpt.tsx
 */ 
var $42omo = parcelRequire("42omo");

const $99c74e00bcd0e3ac$export$325faed136549eaf = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(node)) return node;
    // Check if element is a Spacer component
    if (typeof node.type === 'function' && node.type.IS_METADATA_SPACER) return null;
    // If the element has children, filter out spacers
    if (node.props.children) {
        const children = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(node.props.children);
        const filteredChildren = children.filter((child)=>!/*#__PURE__*/ ((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child) && typeof child.type === 'function' && child.type.IS_METADATA_SPACER));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(node, node.props, ...filteredChildren);
    }
    return node;
};
module.exports["filterSpacer"] = $99c74e00bcd0e3ac$export$325faed136549eaf;

});

parcelRegister("h7sRY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1qfLF = parcelRequire("1qfLF");


var $9VJDA = parcelRequire("9VJDA");


var $lGgRw = parcelRequire("lGgRw");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $gpC9w = parcelRequire("gpC9w");

const $7ee3c09784cf4e4a$var$popupContentContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    padding: 'space.200',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: 'space.100',
    borderRadius: 'radius.small',
    background: 'elevation.surface.overlay',
    boxShadow: 'elevation.shadow.overlay'
});
const $7ee3c09784cf4e4a$var$subheadingStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    font: 'font.body'
});
const $7ee3c09784cf4e4a$var$iconButtonContainerStyles = (0, $ecnYn.xcss)({
    margin: 'space.025',
    marginLeft: 'space.075',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $7ee3c09784cf4e4a$var$iconButtonContainerIsFirstElementStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.025'
});
const $7ee3c09784cf4e4a$export$b31e3e19fb9e4d37 = ({ metadata: metadata, isFirstElement: isFirstElement })=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: [
                    $7ee3c09784cf4e4a$var$popupContentContainerStyles,
                    $7ee3c09784cf4e4a$var$subheadingStyles
                ]
            }, metadata.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    key: index
                }, (0, $gpC9w.filterSpacer)(item)))),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: [
                    $7ee3c09784cf4e4a$var$iconButtonContainerStyles,
                    isFirstElement && $7ee3c09784cf4e4a$var$iconButtonContainerIsFirstElementStyles
                ]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                ...triggerProps,
                appearance: "subtle",
                spacing: "compact",
                isSelected: isOpen,
                onClick: ()=>setIsOpen(!isOpen),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                label: "More"
            }))
    });
};
module.exports["MetadataPopupButton"] = $7ee3c09784cf4e4a$export$b31e3e19fb9e4d37;

});

parcelRegister("mdlgz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

const $20801d48939844b3$var$metadataSpacerStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.050',
    marginRight: 'space.050'
});
const $20801d48939844b3$export$d7a54cba636a8cd6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        as: "span",
        xcss: $20801d48939844b3$var$metadataSpacerStyles
    }, "\u2022");
$20801d48939844b3$export$d7a54cba636a8cd6.IS_METADATA_SPACER = true;
module.exports["Spacer"] = $20801d48939844b3$export$d7a54cba636a8cd6;

});

parcelRegister("gCEkV", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $36ce85b8deff1c0a$export$c376cfef3a1f950d = ({ containerRef: containerRef, itemRefs: itemRefs, itemIds: itemIds, alwaysVisibleRef: alwaysVisibleRef })=>{
    const observerRef = (0, $42omo.useRef)(null);
    const [visibleItems, setVisibleItems] = (0, $42omo.useState)(itemIds);
    const rightNavWidth = alwaysVisibleRef ? alwaysVisibleRef.current?.offsetWidth ?? 80 : 0;
    const rootMargin = `0px -${rightNavWidth}px 0px 0px`;
    (0, $42omo.useEffect)(()=>{
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                const target = entry.target;
                const targetId = target.getAttribute('id');
                const isReferenceElement = targetId?.startsWith('reference:');
                if (isReferenceElement && targetId) {
                    const elementId = targetId.split('reference:')[1];
                    // Set visibility for corresponding target element from reference element id
                    if (entry.isIntersecting) setVisibleItems((prev)=>[
                            ...prev.filter((id)=>id !== elementId),
                            elementId
                        ]);
                    else setVisibleItems((prev)=>prev.filter((id)=>id !== elementId));
                }
            });
        }, {
            root: containerRef.current,
            rootMargin: rootMargin,
            threshold: 0.99
        });
        observerRef.current = observer;
        return ()=>{
            observer.disconnect();
        };
    }, [
        containerRef,
        rootMargin
    ]);
    (0, $42omo.useEffect)(()=>{
        const observer = observerRef.current;
        if (!observer) return;
        itemRefs.current.forEach((itemRef)=>{
            if (itemRef?.current) observer.observe(itemRef.current);
        });
    }, [
        itemRefs,
        itemIds
    ]);
    return visibleItems;
};
module.exports["useOverflowObserver"] = $36ce85b8deff1c0a$export$c376cfef3a1f950d;

});

parcelRegister("kXlQy", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $dh538 = parcelRequire("dh538");


var $gzcCN = parcelRequire("gzcCN");


var $cORSX = parcelRequire("cORSX");

const $5966da29ebb2ee73$export$95cacd63dfd98bee = ({ type: type, defaultMessage: defaultMessage = null, subtype: subtype })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const message = (0, $cORSX.messages)[type];
    const isLiveDoc = subtype === (0, $gzcCN.SearchConfluenceSubtype).LIVE && (0, $dh538.fg)('confluence_live_pages_open_beta_trait_opted_in');
    if (!message) return defaultMessage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isLiveDoc ? formatMessage((0, $cORSX.messages).liveDoc) : formatMessage(message));
};
const $5966da29ebb2ee73$export$446974e6d8045139 = (type)=>{
    if (!type || !(0, $cORSX.messages)[type]) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5966da29ebb2ee73$export$95cacd63dfd98bee, {
        type: type
    });
};
module.exports["SearchResultType"] = $5966da29ebb2ee73$export$95cacd63dfd98bee;
module.exports["getSearchResultType"] = $5966da29ebb2ee73$export$446974e6d8045139;

});

parcelRegister("cORSX", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $166784a2a3778ef6$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    liveDoc: {
        id: "live_doc_type",
        defaultMessage: "Live Doc"
    },
    page: {
        id: "search_result_type_page",
        defaultMessage: "Page"
    },
    blogpost: {
        id: "search_result_type_blogpost",
        defaultMessage: "Blog Post"
    },
    whiteboard: {
        id: "search_result_type_whiteboard",
        defaultMessage: "Whiteboard"
    },
    slide: {
        id: "search_result_type_slide",
        defaultMessage: "Slides"
    },
    database: {
        id: "search_result_type_database",
        defaultMessage: "Database"
    },
    space: {
        id: "search_result_type_space",
        defaultMessage: "Space"
    },
    attachment: {
        id: "search_result_type_attachment",
        defaultMessage: "Attachment"
    },
    comment: {
        id: "search_result_type_comment",
        defaultMessage: "Comment"
    },
    folder: {
        id: "search_result_type_folder",
        defaultMessage: "Folder"
    },
    calendar: {
        id: "search_result_type_calendar",
        defaultMessage: "Calendar"
    },
    space_calendar: {
        // snake_case returned by the API
        id: "search_result_type_space_calendar",
        defaultMessage: "Space calendar"
    },
    question: {
        id: "search_result_type_question",
        defaultMessage: "Question"
    },
    answer: {
        id: "search_result_type_answer",
        defaultMessage: "Answer"
    },
    embed: {
        id: "search_result_type_embed",
        defaultMessage: "Smart Link"
    },
    board: {
        id: "search_result_type_board",
        defaultMessage: "Board"
    },
    dashboard: {
        id: "search_result_type_dashboard",
        defaultMessage: "Dashboard"
    },
    filter: {
        id: "search_result_type_filter",
        defaultMessage: "Filter"
    },
    issue: {
        id: "search_result_type_issue",
        defaultMessage: "Work item"
    },
    plan: {
        id: "search_result_type_plan",
        defaultMessage: "Plan"
    },
    project: {
        id: "search_result_type_project",
        defaultMessage: "Project"
    },
    goal: {
        id: "search_result_type_goal",
        defaultMessage: "Goal"
    },
    tag: {
        id: "search_result_type_tag",
        defaultMessage: "Tag"
    },
    learning: {
        id: "search_result_type_learning",
        defaultMessage: "Learning"
    },
    unrecognised: {
        id: "search_result_type_unrecognised",
        defaultMessage: "Unrecognised"
    },
    document: {
        id: "search_result_type_document",
        defaultMessage: "Document"
    },
    spreadsheet: {
        id: "search_result_type_spreadsheet",
        defaultMessage: "Spreadsheet"
    },
    presentation: {
        id: "search_result_type_presentation",
        defaultMessage: "Presentation"
    },
    'sharepoint-document': {
        id: "search_result_type_sharepoint_document",
        defaultMessage: "Sharepoint Document"
    },
    message: {
        id: "search_result_type_message",
        defaultMessage: "Message"
    },
    repository: {
        id: "search_result_type_repository",
        defaultMessage: "Repository"
    },
    'pull-request': {
        id: "search_result_type_pull_request",
        defaultMessage: "Pull Request"
    },
    commit: {
        id: "search_result_type_commit",
        defaultMessage: "Commit"
    },
    branch: {
        id: "search_result_type_branch",
        defaultMessage: "Branch"
    },
    file: {
        id: "search_result_type_file",
        defaultMessage: "File"
    },
    channel: {
        id: "search_result_type_channel",
        defaultMessage: "Channel"
    },
    component: {
        id: "search_result_type_component",
        defaultMessage: "Component"
    },
    'work-item': {
        id: "search_result_type_work_item",
        defaultMessage: "Work Item"
    },
    card: {
        id: "search_result_type_card",
        defaultMessage: "Card"
    },
    incident: {
        id: "search_result_type_incident",
        defaultMessage: "Incident"
    },
    focus_area: {
        id: "search_result_type_focus_area",
        defaultMessage: "Focus area"
    },
    focus_area_status_update: {
        id: "search_result_type_focus_area_status_update",
        defaultMessage: "Focus area update"
    },
    organization: {
        id: "search_result_type_organization",
        defaultMessage: "Organization"
    },
    organization_status_update: {
        id: "search_result_type_organization_status_update",
        defaultMessage: "Organization update"
    },
    ask: {
        id: "search_result_type_ask",
        defaultMessage: "Ask"
    },
    risk: {
        id: "search_result_type_risk",
        defaultMessage: "Risk"
    },
    email: {
        id: "search_result_type_email",
        defaultMessage: "Email"
    },
    gliffy: {
        id: "search_result_type_gliffy",
        defaultMessage: "Gliffy Diagram"
    },
    deal: {
        id: "search_result_type_deal",
        defaultMessage: "Deal"
    },
    'customer-org': {
        id: "search_result_type_customer_org",
        defaultMessage: "Customer Organization"
    },
    'data-table': {
        id: "search_result_type_data_table",
        defaultMessage: "Data table"
    },
    'customer-contact': {
        id: "search_result_type_customer_contact",
        defaultMessage: "Customer contact"
    },
    object: {
        id: "search_result_type_object",
        defaultMessage: "Object"
    },
    schema: {
        id: "search_result_type_schema",
        defaultMessage: "Schema"
    },
    type: {
        id: "search_result_type_type",
        defaultMessage: "Object type"
    },
    position: {
        id: "search_result_type_position",
        defaultMessage: "Position"
    },
    video: {
        id: "search_result_type_video",
        defaultMessage: "Video"
    },
    task: {
        id: "search_result_type_task",
        defaultMessage: "Task"
    },
    epic: {
        id: "search_result_type_epic",
        defaultMessage: "Epic"
    },
    bug: {
        id: "search_result_type_bug",
        defaultMessage: "Bug"
    },
    story: {
        id: "search_result_type_story",
        defaultMessage: "Story"
    },
    'sub-task': {
        id: "search_result_type_sub_task",
        defaultMessage: "Sub-task"
    },
    subtask: {
        id: "search_result_type_subtask",
        defaultMessage: "Sub-task"
    },
    improvement: {
        id: "search_result_type_improvement",
        defaultMessage: "Improvement"
    },
    'new feature': {
        id: "search_result_type_new_feature",
        defaultMessage: "New feature"
    },
    change: {
        id: "search_result_type_change",
        defaultMessage: "Change"
    },
    problem: {
        id: "search_result_type_problem",
        defaultMessage: "Problem"
    },
    'service request': {
        id: "search_result_type_service_request",
        defaultMessage: "Service request"
    }
});
module.exports["messages"] = $166784a2a3778ef6$export$defe85febe8b728c;

});

parcelRegister("4Chrd", function(module, exports) {
parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $9d9t8 = parcelRequire("9d9t8");

const $a109b171cfb70082$export$b697429ad83cc9eb = (thirdPartyConfigs, providerId)=>{
    if (!thirdPartyConfigs || !providerId) return undefined;
    // Find by providerId (dynamic API adds this field to configs, even for static Forge connectors)
    const [product] = Object.entries(thirdPartyConfigs).find(([, config])=>config?.providerId === providerId) || [];
    // Ensure the product is in our defined set or is a Forge connector so we can cast it safely
    if (product && !(0, $b4tvS.all3pProductKeys).includes(product) && !(0, $9d9t8.isForgeConnectorProductKey)(product)) return undefined;
    return product ? product : undefined;
};
module.exports["getProductFromProviderId"] = $a109b171cfb70082$export$b697429ad83cc9eb;

});

parcelRegister("2vU0F", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $8f7cbfaf49d968e0$var$pullRequestStatusToLozengeMap = {
    OPEN: 'information',
    // blue
    MERGED: 'success',
    // green
    DECLINED: 'danger',
    // red
    DRAFT: 'neutral' // grey
};
const $8f7cbfaf49d968e0$export$2e2105095afb1fad = (status)=>$8f7cbfaf49d968e0$var$pullRequestStatusToLozengeMap[status] ?? 'neutral';
const $8f7cbfaf49d968e0$export$43932e794c008e49 = (0, $aXWIB.defineMessages)({
    status_open: {
        id: "search-pull-request-result.status.open",
        defaultMessage: "Open"
    },
    status_merged: {
        id: "search-pull-request-result.status.merged",
        defaultMessage: "Merged"
    },
    status_declined: {
        id: "search-pull-request-result.status.declined",
        defaultMessage: "Declined"
    },
    status_draft: {
        id: "search-pull-request-result.status.draft",
        defaultMessage: "Draft"
    },
    status_unknown: {
        id: "search-pull-request-result.status.unknown",
        defaultMessage: "Unknown"
    }
});
const $8f7cbfaf49d968e0$export$d8a08f59b3eb7920 = {
    OPEN: $8f7cbfaf49d968e0$export$43932e794c008e49.status_open,
    MERGED: $8f7cbfaf49d968e0$export$43932e794c008e49.status_merged,
    DECLINED: $8f7cbfaf49d968e0$export$43932e794c008e49.status_declined,
    DRAFT: $8f7cbfaf49d968e0$export$43932e794c008e49.status_draft,
    UNKNOWN: $8f7cbfaf49d968e0$export$43932e794c008e49.status_unknown
};
const $8f7cbfaf49d968e0$export$348ea44fc966c8f3 = (status)=>(status && $8f7cbfaf49d968e0$export$d8a08f59b3eb7920[status]) ?? $8f7cbfaf49d968e0$export$43932e794c008e49.status_unknown;
module.exports["getPullRequestStatusAppearance"] = $8f7cbfaf49d968e0$export$2e2105095afb1fad;
module.exports["pullRequestStatusMessages"] = $8f7cbfaf49d968e0$export$43932e794c008e49;
module.exports["getPullRequestStatusMessage"] = $8f7cbfaf49d968e0$export$348ea44fc966c8f3;

});

parcelRegister("1nJM3", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $42omo = parcelRequire("42omo");


var $bg4YX = parcelRequire("bg4YX");

const $ee0af2ae8a3f715b$export$2804e03de329c539 = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, failSection: failSection })=>{
    return {
        eventType: 'track',
        source: failSection,
        actionSubject: 'searchPageErrorBoundary',
        action: 'failed',
        attributes: {
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    };
};



var $3CshZ = parcelRequire("3CshZ");


var $f8oYd = parcelRequire("f8oYd");


const $58d4b2eeaa52f5f4$export$e926676385687eaf = ({ children: children, fallback: fallback, renderWithErrorInfo: renderWithErrorInfo, section: section, onException: customOnException, setErrorBoundaryResetCb: setErrorBoundaryResetCb })=>{
    const logException = (0, $f8oYd.useLogException)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const onException = (0, $42omo.useCallback)((error)=>{
        fireAnalyticsEvent((0, $ee0af2ae8a3f715b$export$2804e03de329c539)({
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            failSection: section
        }));
        logException(error);
        // Call custom handler if provided
        customOnException?.(error);
    }, [
        logException,
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes,
        section,
        customOnException
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bg4YX.ErrorBoundary), {
        fallback: fallback,
        renderWithErrorInfo: renderWithErrorInfo,
        onException: onException,
        setErrorBoundaryResetCb: setErrorBoundaryResetCb
    }, children);
};
module.exports["ErrorBoundary"] = $58d4b2eeaa52f5f4$export$e926676385687eaf;

});

parcelRegister("f8oYd", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $j4ply = parcelRequire("j4ply");


var $7Evbj = parcelRequire("7Evbj");

const $ef865eddba22b4a1$export$67ff3bc9583d7c16 = ()=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [user] = (0, $j4ply.useUser)();
    // Store data required for logging exceptions in refs to prevent re-renders
    return (0, $42omo.useCallback)(async (error)=>await (0, $7Evbj.logException)(error, user?.id, primaryProduct), [
        primaryProduct,
        user?.id
    ]);
};
module.exports["useLogException"] = $ef865eddba22b4a1$export$67ff3bc9583d7c16;

});

parcelRegister("4VkIo", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9rRKJ = parcelRequire("9rRKJ");


var $j4ply = parcelRequire("j4ply");


var $djVCD = parcelRequire("djVCD");


var $8uOED = parcelRequire("8uOED");

const $9dfab17f37eb0047$export$e90e90fddddd8154 = ({ experience: experience = (0, $9rRKJ.SearchExperience).SEARCH_PAGE })=>{
    const [search] = (0, $djVCD.useSearch)();
    const [selectedDatasource] = (0, $djVCD.useSelectedDatasource)();
    const [{ products: products, allFilterExcludedProducts: allFilterExcludedProducts, thirdPartyConfigs: thirdPartyConfigs }] = (0, $j4ply.useBootstrap)();
    const currentUserId = (0, $j4ply.useCurrentUserId)();
    const { filters: filters, selectedProducts: selectedProducts, jsmIncidentFilterIds: jsmIncidentFilterIds } = search;
    return (0, $42omo.useMemo)(()=>{
        return (0, $8uOED.getSelectedFilters)({
            filters: filters,
            selectedProducts: selectedProducts,
            selectedDatasource: selectedDatasource,
            availableProducts: products,
            allFilterExcludedProducts: allFilterExcludedProducts,
            thirdPartyConfigs: thirdPartyConfigs,
            jsmIncidentFilterIds: jsmIncidentFilterIds,
            experience: experience,
            currentUserId: currentUserId
        });
    }, [
        filters,
        selectedProducts,
        selectedDatasource,
        products,
        allFilterExcludedProducts,
        thirdPartyConfigs,
        jsmIncidentFilterIds,
        experience,
        currentUserId
    ]);
};
module.exports["useSelectedFilters"] = $9dfab17f37eb0047$export$e90e90fddddd8154;

});

parcelRegister("8uOED", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $gHaxX = parcelRequire("gHaxX");


var $b4tvS = parcelRequire("b4tvS");


var $9rRKJ = parcelRequire("9rRKJ");


var $dOOW1 = parcelRequire("dOOW1");

const $e43dba4dbad73dd8$export$68a801b7b3c0bfaa = ({ selectedProducts: selectedProducts, availableProducts: availableProducts })=>{
    const selectedProduct = selectedProducts?.[0];
    const filteredProducts = selectedProduct ? [
        selectedProduct
    ] : availableProducts;
    return {
        selectedProduct: selectedProduct,
        filteredProducts: filteredProducts,
        availableProducts: availableProducts
    };
};



var $b4tDU = parcelRequire("b4tDU");


var $922yL = parcelRequire("922yL");

var $dWCFT = parcelRequire("dWCFT");

var $ksiqf = parcelRequire("ksiqf");

/**
 * Calendar date in the user's local timezone as YYYY-MM-DD (matches backend
 * {@code ContentSearcherQueryHelper#buildSalesforceCloseDateQuery} contract).
 */ function $b37f0c8d7075360a$var$toYmdLocal(d) {
    return (0, $dWCFT.default)(d, 'yyyy-MM-dd');
}
function $b37f0c8d7075360a$var$startOfTodayLocal() {
    const n = new Date();
    return new Date(n.getFullYear(), n.getMonth(), n.getDate());
}
const $b37f0c8d7075360a$var$ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;
function $b37f0c8d7075360a$export$63976aebd4b36830(selectedOption, customIsoDate) {
    if (!selectedOption || selectedOption === 'anytime') return undefined;
    if (selectedOption === 'custom') {
        if (!customIsoDate || !$b37f0c8d7075360a$var$ISO_DATE.test(customIsoDate)) return undefined;
        return customIsoDate;
    }
    const today = $b37f0c8d7075360a$var$startOfTodayLocal();
    const tomorrow = (0, $922yL.default)(today, 1);
    switch(selectedOption){
        case 'today':
            return $b37f0c8d7075360a$var$toYmdLocal(today);
        case 'last7days':
            return `${$b37f0c8d7075360a$var$toYmdLocal((0, $ksiqf.default)(today, 6))}:${$b37f0c8d7075360a$var$toYmdLocal(today)}`;
        case 'last30days':
            return `${$b37f0c8d7075360a$var$toYmdLocal((0, $ksiqf.default)(today, 29))}:${$b37f0c8d7075360a$var$toYmdLocal(today)}`;
        case 'last90days':
            return `${$b37f0c8d7075360a$var$toYmdLocal((0, $ksiqf.default)(today, 89))}:${$b37f0c8d7075360a$var$toYmdLocal(today)}`;
        case 'last365days':
            return `${$b37f0c8d7075360a$var$toYmdLocal((0, $ksiqf.default)(today, 364))}:${$b37f0c8d7075360a$var$toYmdLocal(today)}`;
        case 'next7days':
            return `${$b37f0c8d7075360a$var$toYmdLocal(tomorrow)}:${$b37f0c8d7075360a$var$toYmdLocal((0, $922yL.default)(today, 7))}`;
        case 'next30days':
            return `${$b37f0c8d7075360a$var$toYmdLocal(tomorrow)}:${$b37f0c8d7075360a$var$toYmdLocal((0, $922yL.default)(today, 30))}`;
        case 'next90days':
            return `${$b37f0c8d7075360a$var$toYmdLocal(tomorrow)}:${$b37f0c8d7075360a$var$toYmdLocal((0, $922yL.default)(today, 90))}`;
        case 'next365days':
            return `${$b37f0c8d7075360a$var$toYmdLocal(tomorrow)}:${$b37f0c8d7075360a$var$toYmdLocal((0, $922yL.default)(today, 365))}`;
        default:
            // Already-resolved ISO single date or range (e.g. restored from URL)
            if ($b37f0c8d7075360a$var$ISO_DATE.test(selectedOption)) return selectedOption;
            if (/^\d{4}-\d{2}-\d{2}:\d{4}-\d{2}-\d{2}$/.test(selectedOption)) return selectedOption;
            return undefined;
    }
}



var $133ZR = parcelRequire("133ZR");


var $5iakG = parcelRequire("5iakG");


var $jyecU = parcelRequire("jyecU");

const $a24d078566cd43b5$export$a50dff3bb8b597ca = ({ availableProducts: availableProducts, filters: filters, selectedProducts: selectedProducts, allFilterExcludedProducts: allFilterExcludedProducts }, { thirdPartyConfigs: thirdPartyConfigs })=>{
    // Filter out excluded products from "All" filter
    const allFilterIncludedProducts = availableProducts.filter((product)=>!allFilterExcludedProducts.includes(product));
    const productsToSearch = selectedProducts[0] ? [
        selectedProducts[0]
    ] : allFilterIncludedProducts;
    const typeFilter = filters[0, $5iakG.universalTypeFilterId];
    return (0, $jyecU.getUniversalTypeEntities)(productsToSearch, typeFilter, thirdPartyConfigs, availableProducts, selectedProducts);
};



var $gY9AU = parcelRequire("gY9AU");

const $5f15807d66c8b2dc$export$f6546bb98204a0ca = ({ filters: filters, selectedProducts: selectedProducts, selectedDatasource: selectedDatasource, availableProducts: products, allFilterExcludedProducts: allFilterExcludedProducts, thirdPartyConfigs: thirdPartyConfigs, currentUserId: currentUserId, jsmIncidentFilterIds: jsmIncidentFilterIds, experience: experience = (0, $9rRKJ.SearchExperience).SEARCH_PAGE })=>{
    const { selectedProduct: selectedProduct, filteredProducts: filteredProducts, availableProducts: availableProducts } = (0, $e43dba4dbad73dd8$export$68a801b7b3c0bfaa)({
        selectedProducts: selectedProducts,
        availableProducts: products
    });
    const { selectedEntities: selectedEntities, entitiesForQuery: entitiesForQuery, entitiesForResultsCountQuery: entitiesForResultsCountQuery, selectedTypes: selectedTypes } = (0, $a24d078566cd43b5$export$a50dff3bb8b597ca)({
        availableProducts: availableProducts,
        filters: filters,
        selectedProducts: selectedProducts,
        allFilterExcludedProducts: allFilterExcludedProducts
    }, {
        thirdPartyConfigs: thirdPartyConfigs
    });
    const watchedByMeValue = (0, $gY9AU.getBooleanFilterValue)(filters[0, $133ZR.watchedFilterId]);
    const titleMatchValue = (0, $gY9AU.getBooleanFilterValue)(filters[0, $133ZR.titleMatchFilterId]);
    const selectedDateRange = (0, $gY9AU.getSelectedDateRange)(filters[0, $133ZR.lastUpdatedFilterId]);
    const filterDateRange = (0, $gY9AU.getFilterDateRange)(filters[0, $133ZR.lastUpdatedFilterId]);
    const commonContributors = (0, $gY9AU.getSelectFilterValue)(filters[0, $133ZR.contributorFilterId]).length ? (0, $gY9AU.getSelectFilterValue)(filters[0, $133ZR.contributorFilterId]) : undefined;
    const pageStatusValue = (0, $gY9AU.getSelectFilterValue)(filters[0, $133ZR.pageStatusFilterId])[0];
    const assigneeARIValues = (0, $gY9AU.getSelectFilterValue)(filters[0, $133ZR.assigneeFilterId]).map((assigneeId)=>{
        return `ari:cloud:identity::user/${assigneeId}`;
    });
    const reporterARIValues = (0, $gY9AU.getSelectFilterValue)(filters[0, $133ZR.reporterFilterId]).map((reporterId)=>{
        return `ari:cloud:identity::user/${reporterId}`;
    });
    const watcherARIValues = (watchedByMeValue && currentUserId ? [
        currentUserId
    ] : []).map((watcherId)=>{
        return `ari:cloud:identity::user/${watcherId}`;
    });
    const commenterARIValues = (0, $gY9AU.getBooleanFilterValue)(filters[0, $133ZR.commentedByMeFilterId]) && currentUserId ? [
        `ari:cloud:identity::user/${currentUserId}`
    ] : [];
    const assignee3PValues = (0, $gY9AU.getSelectFilterValue)(filters[0, $133ZR.assigneeFilterId]).map((assigneeId)=>{
        if (assigneeId.startsWith('ari:cloud:')) return (0, $gHaxX.IdentityUserAri).parse(assigneeId).resourceId;
        return assigneeId;
    });
    const isSelectedThirdPartyProduct = !!selectedProduct && (0, $b4tvS.is3pProductKey)(selectedProduct);
    const selectedSpaceValues = (0, $gY9AU.getSelectFilterValue)(filters[0, $133ZR.spaceFilterId]);
    const selectedContentValues = (0, $gY9AU.getSelectFilterValue)(filters[0, $133ZR.contentFilterId]);
    const confluenceOnlyValues = (values)=>isSelectedThirdPartyProduct ? [] : values;
    const thirdPartySpaceValues = selectedProduct === (0, $b4tvS.ProductKeys).GoogleDrive || selectedProduct === (0, $b4tvS.ProductKeys).Sharepoint ? selectedSpaceValues : [];
    const thirdPartyContentValues = isSelectedThirdPartyProduct ? selectedContentValues : [];
    const containerAris = [
        ...(0, $gY9AU.getSelectFilterValue)(filters[0, $133ZR.projectFilterId])
    ];
    const createdByValues = (0, $gY9AU.getSelectFilterValue)(filters[0, $133ZR.createdByFilterId]);
    const labelsValues = (0, $gY9AU.getSelectFilterValue)(filters[0, $133ZR.labelFilterId]);
    const lastUpdatedByValues = (0, $gY9AU.getSelectFilterValue)(filters[0, $133ZR.lastUpdatedByFilterId]);
    // When both the primary (space) and dependent (contentUnder) filters are selected, the backend
    // treats ancestorAris with OR logic, which would incorrectly broaden results.
    // Prefer the dependent filter when present since it is more specific; otherwise fall back to
    // the primary filter. The store handles the reverse: when the primary filter is selected after
    // the dependent, it clears the dependent so only the primary is sent.
    const ancestorAris = thirdPartyContentValues.length > 0 ? thirdPartyContentValues : thirdPartySpaceValues;
    const ownerValues = (0, $gY9AU.getSelectFilterValue)(filters[0, $133ZR.ownerFilterId]);
    const opportunityStatusValue = (0, $gY9AU.getSelectFilterValue)(filters[0, $133ZR.opportunityStatusFilterId])[0];
    const pullRequestStatusValues = (0, $gY9AU.getSelectFilterValue)(filters[0, $133ZR.pullRequestStatusFilterId]);
    const repositoryValues = (0, $gY9AU.getSelectFilterValue)(filters[0, $133ZR.repositoryFilterId]);
    const campaignStatusValues = (0, $gY9AU.getSelectFilterValue)(filters[0, $133ZR.campaignStatusFilterId]);
    const caseStatusValues = (0, $gY9AU.getSelectFilterValue)(filters[0, $133ZR.caseStatusFilterId]);
    const salesforceStageValues = (0, $gY9AU.getSelectFilterValue)(filters[0, $133ZR.salesforceStageFilterId]);
    const slackChannelValues = (0, $gY9AU.getSelectFilterValue)(filters[0, $133ZR.slackChannelFilterId]);
    const workspaceNameValues = (0, $dh538.fg)('rovo_fps_show_workspace_name_filter') ? (0, $gY9AU.getSelectFilterValue)(filters[0, $133ZR.workspaceNameFilterId]) : [];
    const hasAttachmentValue = (0, $gY9AU.getBooleanFilterValue)(filters[0, $133ZR.hasAttachmentFilterId]);
    const sortFilters = (0, $gY9AU.getSortFilters)(filters[0, $133ZR.sortFilterId]);
    // Get close date value for Salesforce filter
    const closeDateFilterState = filters[0, $133ZR.closeDateFilterId];
    const closeDateSelectedOption = (0, $gY9AU.getSelectFilterValue)(filters[0, $133ZR.closeDateFilterId])[0];
    const closeDateCustomValue = closeDateFilterState && 'customValue' in closeDateFilterState && closeDateFilterState.customValue ? closeDateFilterState.customValue.closeDateVal : undefined;
    const salesforceCloseDate = (0, $b37f0c8d7075360a$export$63976aebd4b36830)(closeDateSelectedOption, closeDateSelectedOption === 'custom' ? closeDateCustomValue : undefined);
    const isAllProductsSelected = (0, $b4tDU.isAllProductSearch)(selectedProducts);
    const selectedFilters = {
        commonFilters: {
            range: {
                lastModified: selectedDateRange
            },
            contributorsFilter: commonContributors
        },
        jiraFilters: {
            issueFilter: {
                projectARIs: (0, $gY9AU.omitNonJiraFilterValues)((0, $gY9AU.getSelectFilterValue)(filters[0, $133ZR.projectFilterId]), selectedProduct),
                watcherARIs: (0, $gY9AU.omitNonJiraFilterValues)(watcherARIValues, selectedProduct),
                assigneeARIs: (0, $gY9AU.omitNonJiraFilterValues)(assigneeARIValues, selectedProduct),
                issueTypeIDs: jsmIncidentFilterIds,
                issueLabels: (0, $gY9AU.omitNonJiraFilterValues)((0, $gY9AU.getSelectFilterValue)(filters[0, $133ZR.labelFilterId]), selectedProduct),
                statusCategories: (0, $gY9AU.omitNonJiraFilterValues)((0, $gY9AU.getJiraIssueStatusFilterOptions)(filters[0, $133ZR.statusFilterId]), selectedProduct),
                reporterARIs: (0, $gY9AU.omitNonJiraFilterValues)(reporterARIValues, selectedProduct),
                commenterARIs: (0, $gY9AU.omitNonJiraFilterValues)(commenterARIValues, selectedProduct),
                issueTypes: (0, $gY9AU.getSelectedJiraWorkType)(selectedTypes, selectedProduct)
            },
            projectFilter: {
                projectTypes: experience === (0, $9rRKJ.SearchExperience).QUICK_FIND ? [] : (0, $gY9AU.getJiraProjectFilter)(selectedProduct)
            }
        },
        assetsFilters: {
            objectSchemaFilter: {
                schemaARIs: (0, $dh538.fg)('assets_rovo_search_all') ? (0, $gY9AU.getSelectFilterValue)(filters[0, $133ZR.assetsSchemaFilterId]) : []
            },
            objectTypeFilter: {
                typeARIs: (0, $dh538.fg)('assets_rovo_search_all') ? (0, $gY9AU.getSelectFilterValue)(filters[0, $133ZR.assetsTypeFilterId]) : []
            }
        },
        confluenceFilters: {
            spacesFilter: confluenceOnlyValues(selectedSpaceValues),
            isVerified: (0, $gY9AU.getBooleanFilterValue)(filters[0, $133ZR.verifiedFilterId]) || undefined,
            contributorsFilter: (0, $gY9AU.getSelectFilterValue)(filters[0, $133ZR.contributorFilterId]),
            ancestorIdsFilter: confluenceOnlyValues(selectedContentValues),
            range: selectedProduct !== (0, $b4tvS.ProductKeys).Confluence ? filterDateRange : [],
            owners: (0, $gY9AU.getSelectFilterValue)(filters[0, $133ZR.ownerFilterId]),
            labelsFilter: selectedProduct === (0, $b4tvS.ProductKeys).Confluence ? (0, $gY9AU.getSelectFilterValue)(filters[0, $133ZR.labelFilterId]) : [],
            titleMatchOnly: titleMatchValue,
            ...pageStatusValue ? {
                pageStatus: [
                    pageStatusValue
                ]
            } : {},
            contentStatuses: selectedProduct === (0, $b4tvS.ProductKeys).Confluence ? (0, $gY9AU.getContentStatusValue)(filters[0, $133ZR.archivedFilterId]) : [],
            containerStatus: selectedProduct === (0, $b4tvS.ProductKeys).Confluence ? (0, $gY9AU.getContainerStatusValue)(filters[0, $133ZR.archivedFilterId]) : []
        },
        mercuryFilters: {
            owners: (0, $gY9AU.getSelectFilterValue)(filters[0, $133ZR.ownerFilterId]),
            focusAreaTypeIds: (0, $gY9AU.getSelectFilterValue)(filters[0, $133ZR.focusAreaTypeFilterId]),
            ancestorIds: (0, $gY9AU.getSelectFilterValue)(filters[0, $133ZR.focusAreaUnderFilterId])
        },
        ...(0, $dh538.fg)('talent_global_search') ? {
            talentFilters: {
                owners: (0, $gY9AU.getSelectFilterValue)(filters[0, $133ZR.ownerFilterId]),
                employmentTypes: (0, $gY9AU.getSelectFilterValue)(filters[0, $133ZR.positionEmploymentTypeFilterId]).map((value)=>decodeURIComponent(value)),
                focusAreas: (0, $gY9AU.getSelectFilterValue)(filters[0, $133ZR.positionFocusAreaFilterId]),
                jobFamilies: (0, $gY9AU.getSelectFilterValue)(filters[0, $133ZR.positionJobFamilyFilterId]).map((value)=>decodeURIComponent(value)),
                statuses: (0, $gY9AU.getSelectFilterValue)(filters[0, $133ZR.positionStatusFilterId]).map((value)=>decodeURIComponent(value)),
                teams: (0, $gY9AU.getSelectFilterValue)(filters[0, $133ZR.positionTeamFilterId])
            }
        } : {},
        compassFilters: {
            componentFilter: {
                componentStates: (0, $gY9AU.getArchivedAndPendingComponentsValue)(filters[0, $133ZR.archivedAndPendingComponentsFilterId])
            }
        },
        thirdPartyFilters: (0, $dOOW1.getThirdPartyFilters)(filteredProducts, titleMatchValue, selectedEntities, thirdPartyConfigs, isAllProductsSelected, filterDateRange, assignee3PValues, containerAris, createdByValues, lastUpdatedByValues, ancestorAris, labelsValues, undefined, selectedDatasource?.datasourceId, ownerValues, salesforceStageValues, salesforceCloseDate, opportunityStatusValue, pullRequestStatusValues, repositoryValues, campaignStatusValues, caseStatusValues, slackChannelValues, hasAttachmentValue, workspaceNameValues),
        sortFilters: sortFilters
    };
    const unselectedProductsThirdPartyFilters = (0, $dOOW1.getThirdPartyFilters)(availableProducts, titleMatchValue, selectedEntities, thirdPartyConfigs, isAllProductsSelected, filterDateRange, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
    const { commonFilters: commonFilters, jiraFilters: jiraFilters, confluenceFilters: confluenceFilters, mercuryFilters: mercuryFilters, compassFilters: compassFilters, thirdPartyFilters: thirdPartyFilters, assetsFilters: assetsFilters, talentFilters: talentFilters } = selectedFilters;
    const isEmpty = !commonFilters.range.lastModified && !commonFilters.contributorsFilter && selectedEntities.length === 0 && confluenceFilters.spacesFilter.length === 0 && !confluenceFilters.isVerified && !confluenceFilters.titleMatchOnly && confluenceFilters.contentStatuses.length === 0 && confluenceFilters.containerStatus.length === 0 && confluenceFilters.contributorsFilter.length === 0 && confluenceFilters.ancestorIdsFilter.length === 0 && confluenceFilters.range.length === 0 && confluenceFilters.owners.length === 0 && confluenceFilters.labelsFilter.length === 0 && (!confluenceFilters.pageStatus || confluenceFilters.pageStatus.length === 0) && jiraFilters.issueFilter.assigneeARIs.length === 0 && jiraFilters.issueFilter.projectARIs.length === 0 && jiraFilters.issueFilter.statusCategories.length === 0 && jiraFilters.issueFilter.reporterARIs.length === 0 && jiraFilters.issueFilter.commenterARIs.length === 0 && mercuryFilters.owners.length === 0 && jiraFilters.issueFilter.issueLabels.length === 0 && (!jiraFilters.issueFilter.issueTypes || jiraFilters.issueFilter.issueTypes?.length === 0) && mercuryFilters.owners.length === 0 && mercuryFilters.focusAreaTypeIds.length === 0 && mercuryFilters.ancestorIds.length === 0 && compassFilters.componentFilter.componentStates.length === 0 && ((0, $dh538.fg)('talent_global_search') ? talentFilters?.owners.length === 0 && talentFilters?.employmentTypes.length === 0 && talentFilters?.focusAreas.length === 0 && talentFilters?.jobFamilies.length === 0 && talentFilters?.statuses.length === 0 && talentFilters?.teams.length === 0 : true) && ((0, $dh538.fg)('assets_rovo_search_all') ? assetsFilters.objectSchemaFilter.schemaARIs.length === 0 && assetsFilters.objectTypeFilter.typeARIs.length === 0 : true) && (!thirdPartyFilters.range || Object.keys(thirdPartyFilters.range).length === 0) && !thirdPartyFilters.titleMatchOnly && thirdPartyFilters.subtypes.length === 0 && (!thirdPartyFilters.assignees || thirdPartyFilters.assignees?.length === 0) && (!thirdPartyFilters.lastUpdatedBy || thirdPartyFilters.lastUpdatedBy?.length === 0) && (!thirdPartyFilters.createdBy || thirdPartyFilters.createdBy?.length === 0) && (!thirdPartyFilters.ancestorAris || thirdPartyFilters.ancestorAris?.length === 0) && (!thirdPartyFilters.containerAris || thirdPartyFilters.containerAris?.length === 0) && (!thirdPartyFilters.salesforceFilters?.stage || thirdPartyFilters.salesforceFilters.stage.length === 0) && (!thirdPartyFilters.salesforceFilters?.owners || thirdPartyFilters.salesforceFilters.owners.length === 0) && !thirdPartyFilters.salesforceFilters?.closeDate && (!thirdPartyFilters.salesforceFilters?.campaignStatuses || thirdPartyFilters.salesforceFilters.campaignStatuses.length === 0) && (!thirdPartyFilters.salesforceFilters?.caseStatuses || thirdPartyFilters.salesforceFilters.caseStatuses.length === 0) && (!thirdPartyFilters.gitFilters?.pullRequestStatus || thirdPartyFilters.gitFilters.pullRequestStatus.length === 0) && (!thirdPartyFilters.gitFilters?.repoName || thirdPartyFilters.gitFilters.repoName.length === 0) && !thirdPartyFilters.teamsFilters?.hasAttachment && !thirdPartyFilters.thirdPartyProducts?.some((p)=>p.product === 'slack' && p.channels && p.channels.length > 0);
    return {
        selectedFilters: selectedFilters,
        unselectedProductsThirdPartyFilters: unselectedProductsThirdPartyFilters,
        selectedEntities: selectedEntities,
        entitiesForResultsCountQuery: entitiesForResultsCountQuery,
        entities: entitiesForQuery,
        hasFiltersSelected: !isEmpty
    };
};
module.exports["getSelectedFilters"] = $5f15807d66c8b2dc$export$f6546bb98204a0ca;

});

parcelRegister("gY9AU", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $jwO5V = parcelRequire("jwO5V");


var $brNow = parcelRequire("brNow");


var $7iBhV = parcelRequire("7iBhV");


var $2Znam = parcelRequire("2Znam");


var $b4tvS = parcelRequire("b4tvS");


var $gW8Zi = parcelRequire("gW8Zi");


var $eMDCS = parcelRequire("eMDCS");


var $4tTFP = parcelRequire("4tTFP");


var $d151M = parcelRequire("d151M");


var $aXWIB = parcelRequire("aXWIB");

const $ff70e75a80572c21$export$c054401256af44b9 = '[System] Incident';
const $ff70e75a80572c21$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    incident: {
        id: "search-client.jira.issue.incident.label",
        defaultMessage: "[System] Incident"
    }
});


const $397b5a5e3acc8878$export$1c47b2cd6d3f5b5a = {
    ['showCurrent']: [],
    ['showArchived']: [
        'ARCHIVED',
        'CURRENT'
    ]
};
const $397b5a5e3acc8878$export$7069271803c33dc3 = {
    ['showCurrent']: [],
    ['showArchived']: [
        'ARCHIVED',
        'CURRENT',
        'DRAFT'
    ]
};
const $397b5a5e3acc8878$export$a240a4826113d43 = (filter)=>{
    const archivedContentOption = $397b5a5e3acc8878$export$49b41db8fadc5da(filter);
    return archivedContentOption ? $397b5a5e3acc8878$export$7069271803c33dc3['showArchived'] : $397b5a5e3acc8878$export$7069271803c33dc3['showCurrent'];
};
const $397b5a5e3acc8878$export$b934b4f495e2c091 = (filter)=>{
    const archivedContentOption = $397b5a5e3acc8878$export$49b41db8fadc5da(filter);
    return archivedContentOption ? $397b5a5e3acc8878$export$1c47b2cd6d3f5b5a['showArchived'] : $397b5a5e3acc8878$export$1c47b2cd6d3f5b5a['showCurrent'];
};
const $397b5a5e3acc8878$export$fa0dcd7cda441845 = (filter)=>{
    const archivedContentOption = $397b5a5e3acc8878$export$49b41db8fadc5da(filter);
    return archivedContentOption ? [
        'ACTIVE',
        'PENDING',
        'ARCHIVED'
    ] : [];
};
const $397b5a5e3acc8878$export$ba6044efb2e123e9 = {
    [(0, $b4tvS.ProductKeys).Jira]: [
        'software',
        'business'
    ],
    [(0, $b4tvS.ProductKeys).JiraProductDiscovery]: [
        'product_discovery'
    ],
    [(0, $b4tvS.ProductKeys).JiraServiceManagement]: [
        'service_desk'
    ]
};
const $397b5a5e3acc8878$export$e1f376159111dbe6 = (filterValues, selectedProduct)=>{
    // when all products are searched
    if (!selectedProduct) // don't return any values in all product selected mode for assignee and project filters
    return [];
    switch(selectedProduct){
        case (0, $b4tvS.ProductKeys).Jira:
        case (0, $b4tvS.ProductKeys).JiraProductDiscovery:
        case (0, $b4tvS.ProductKeys).JiraServiceManagement:
            return filterValues;
    }
    return [];
};
const $397b5a5e3acc8878$export$5c4691ac7ffb1183 = 'DUMMY_JIRA_ISSUE_TYPE_ID';
const $397b5a5e3acc8878$export$4df832a1d124a3d4 = async (cloudId, intl, issueType, activationId, primaryProduct)=>{
    if (!cloudId) return $397b5a5e3acc8878$export$5c4691ac7ffb1183;
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: cloudId,
        activationId: activationId,
        product: primaryProduct
    });
    const searchString = intl.formatMessage((0, $ff70e75a80572c21$export$defe85febe8b728c)[issueType]);
    const issueTypes = await (0, $brNow.jiraIssueTypeJQLQuery)(cloudId, searchString, headers);
    const ids = issueTypes?.data?.jira.jqlBuilder.fieldValues.edges;
    if (!ids || ids.length === 0) return $397b5a5e3acc8878$export$5c4691ac7ffb1183;
    if (ids.length > 1) {
        const issueTypeNode = ids.find((id)=>id.node?.displayName === searchString);
        if (!issueTypeNode) return $397b5a5e3acc8878$export$5c4691ac7ffb1183;
        const issueType = issueTypeNode.node?.issueTypes[0];
        return issueType && issueType.issueTypeId ? issueType.issueTypeId : $397b5a5e3acc8878$export$5c4691ac7ffb1183;
    } else {
        const node = ids[0].node;
        if (!node) return $397b5a5e3acc8878$export$5c4691ac7ffb1183;
        return node.issueTypes[0].issueTypeId || $397b5a5e3acc8878$export$5c4691ac7ffb1183;
    }
};
const $397b5a5e3acc8878$export$75ec3b8bb22cb14f = (filter)=>{
    return (0, $d151M.isSelectFilter)(filter?.type) ? filter.value : [];
};
const $397b5a5e3acc8878$export$1800e9d06ef0f63b = (filter)=>{
    return (0, $d151M.isSelectFilter)(filter?.type) ? filter.customValue : {};
};
const $397b5a5e3acc8878$export$49b41db8fadc5da = (filter)=>{
    return filter?.type === 'boolean' ? filter.value : false;
};
const $397b5a5e3acc8878$export$7efdc6b7aa39e72a = (filter)=>{
    const selectedDateOption = $397b5a5e3acc8878$export$75ec3b8bb22cb14f(filter)[0];
    if (selectedDateOption && selectedDateOption !== (0, $7iBhV.CUSTOM_OPTION_VALUE)) return (0, $4tTFP.convertLastUpdatedToDateRange)(selectedDateOption);
    else if (selectedDateOption === (0, $7iBhV.CUSTOM_OPTION_VALUE)) {
        const customDateRange = $397b5a5e3acc8878$export$1800e9d06ef0f63b(filter);
        if (customDateRange?.from || customDateRange?.to) return (0, $gW8Zi.convertCustomDateToRange)(customDateRange.from, customDateRange.to);
    }
    return;
};
const $397b5a5e3acc8878$export$9ec55eff3923c72 = (filter)=>{
    const selectedDateOption = $397b5a5e3acc8878$export$75ec3b8bb22cb14f(filter)[0];
    if (selectedDateOption && selectedDateOption !== (0, $7iBhV.CUSTOM_OPTION_VALUE)) return [
        (0, $4tTFP.getConfluenceDateOptionValues)(selectedDateOption)
    ];
    else if (selectedDateOption === (0, $7iBhV.CUSTOM_OPTION_VALUE)) {
        const customDateRange = $397b5a5e3acc8878$export$1800e9d06ef0f63b(filter);
        if (customDateRange?.from && customDateRange?.to) return [
            (0, $4tTFP.getConfluenceDateOptionFromCustomDates)(customDateRange.from, customDateRange.to)
        ];
    }
    return [];
};
const $397b5a5e3acc8878$export$ac0baabacf9504ae = (selectedProduct)=>{
    if (!selectedProduct) return []; // In the BE, it will target all Jira products if the array is empty
    switch(selectedProduct){
        case (0, $b4tvS.ProductKeys).Jira:
        case (0, $b4tvS.ProductKeys).JiraProductDiscovery:
        case (0, $b4tvS.ProductKeys).JiraServiceManagement:
            return $397b5a5e3acc8878$export$ba6044efb2e123e9[selectedProduct];
    }
    return [];
};
const $397b5a5e3acc8878$export$b8e499230f5115d8 = {
    [(0, $2Znam.TypeFilterValueKey).Epic]: 'Epic',
    [(0, $2Znam.TypeFilterValueKey).Bug]: 'Bug',
    [(0, $2Znam.TypeFilterValueKey).Story]: 'Story',
    [(0, $2Znam.TypeFilterValueKey).Task]: 'Task',
    [(0, $2Znam.TypeFilterValueKey).Subtask]: 'Subtask'
};
const $397b5a5e3acc8878$export$f548e13b50401f80 = (selectedType, selectedProduct)=>{
    const hasSelectedProductThatIsNotJira = Boolean(selectedProduct) && selectedProduct !== (0, $b4tvS.ProductKeys).Jira;
    if (hasSelectedProductThatIsNotJira || selectedType.length === 0) return [];
    return selectedType.flatMap((typeOption)=>{
        const workType = $397b5a5e3acc8878$export$b8e499230f5115d8[typeOption];
        return workType ? [
            workType
        ] : [];
    });
};
const $397b5a5e3acc8878$export$7dcf1656cd04caad = [
    'OPEN',
    'NEW',
    'INDETERMINATE',
    'DONE',
    'UNDEFINED'
];
const $397b5a5e3acc8878$export$5f47ad4f5e0267c4 = (filter)=>{
    const filterValues = $397b5a5e3acc8878$export$75ec3b8bb22cb14f(filter);
    const appliedFilterOptions = filterValues.flatMap((filtervalue)=>{
        const filterOptions = $397b5a5e3acc8878$export$7dcf1656cd04caad.filter((status)=>{
            if (!(0, $dh538.fg)('rovo_search_in_jira_granular_status_filters')) return status === 'OPEN' || status === 'DONE';
            else return status !== 'OPEN';
        }).find((allowedValue)=>filtervalue === allowedValue);
        return filterOptions ? [
            filterOptions
        ] : [];
    });
    return appliedFilterOptions;
};
const $397b5a5e3acc8878$export$97dd8d7ab50aafbd = (filter)=>{
    const selectedSortOption = $397b5a5e3acc8878$export$75ec3b8bb22cb14f(filter)[0];
    return (0, $eMDCS.convertSortToFilter)(selectedSortOption);
};
module.exports["getContentStatusValue"] = $397b5a5e3acc8878$export$a240a4826113d43;
module.exports["getBooleanFilterValue"] = $397b5a5e3acc8878$export$49b41db8fadc5da;
module.exports["getContainerStatusValue"] = $397b5a5e3acc8878$export$b934b4f495e2c091;
module.exports["getArchivedAndPendingComponentsValue"] = $397b5a5e3acc8878$export$fa0dcd7cda441845;
module.exports["JiraProductProjectFilterKey"] = $397b5a5e3acc8878$export$ba6044efb2e123e9;
module.exports["omitNonJiraFilterValues"] = $397b5a5e3acc8878$export$e1f376159111dbe6;
module.exports["getJiraIssueTypesFilter"] = $397b5a5e3acc8878$export$4df832a1d124a3d4;
module.exports["getSelectFilterValue"] = $397b5a5e3acc8878$export$75ec3b8bb22cb14f;
module.exports["getSelectedDateRange"] = $397b5a5e3acc8878$export$7efdc6b7aa39e72a;
module.exports["getFilterDateRange"] = $397b5a5e3acc8878$export$9ec55eff3923c72;
module.exports["getJiraProjectFilter"] = $397b5a5e3acc8878$export$ac0baabacf9504ae;
module.exports["getSelectedJiraWorkType"] = $397b5a5e3acc8878$export$f548e13b50401f80;
module.exports["allowedJiraIssueStatuses"] = $397b5a5e3acc8878$export$7dcf1656cd04caad;
module.exports["getJiraIssueStatusFilterOptions"] = $397b5a5e3acc8878$export$5f47ad4f5e0267c4;
module.exports["getSortFilters"] = $397b5a5e3acc8878$export$97dd8d7ab50aafbd;

});

parcelRegister("brNow", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $hw4j5 = parcelRequire("hw4j5");

const $c2ce3ac8cb311ba1$var$GQL_JIRA_ISSUE_TYPE_OPERATION_NAME = 'SearchPageJiraIssueTypeQuery';
const $c2ce3ac8cb311ba1$var$jqlIssueTypeQueryString = `query ${$c2ce3ac8cb311ba1$var$GQL_JIRA_ISSUE_TYPE_OPERATION_NAME}(
	$cloudId: ID!,
	$first: Int = 10,
	$jqlTerm: String!,
	$jql: String!,
	$searchString: String!) {
		jira {
			jqlBuilder(cloudId: $cloudId) {
				fieldValues (
					first: $first
					jqlTerm: $jqlTerm
					jqlContext: $jql
					searchString: $searchString
				) {
					edges {
						node {
							displayName
							... on JiraJqlIssueTypeFieldValue {
								issueTypes {
									issueTypeId
								}
							}
						}
					}
          		}
			}
		}
	}`;
const $c2ce3ac8cb311ba1$export$bd7a9ccdb07f26a6 = (0, $hw4j5.inMemoryCache)();
const $c2ce3ac8cb311ba1$export$299504e13b0b41d4 = async (cloudId, searchString, headers)=>{
    return $c2ce3ac8cb311ba1$export$bd7a9ccdb07f26a6.inMemoryDecorator(`${cloudId}-${searchString}`, async ()=>{
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $c2ce3ac8cb311ba1$var$jqlIssueTypeQueryString,
            variables: {
                cloudId: cloudId,
                jqlTerm: 'type',
                searchString: searchString,
                jql: ''
            },
            operationName: $c2ce3ac8cb311ba1$var$GQL_JIRA_ISSUE_TYPE_OPERATION_NAME,
            headers: {
                'X-ExperimentalApi': 'JiraJqlBuilder',
                ...headers
            }
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["jiraIssueTypeJQLQuery"] = $c2ce3ac8cb311ba1$export$299504e13b0b41d4;

});

parcelRegister("7iBhV", function(module, exports) {
const $ec40d4e0b09453d5$export$5ef321009a5b450c = 'custom';
const $ec40d4e0b09453d5$export$62fed45313a13eff = 'universalTypeFilter';
module.exports["CUSTOM_OPTION_VALUE"] = $ec40d4e0b09453d5$export$5ef321009a5b450c;
module.exports["universalTypeFilterId"] = $ec40d4e0b09453d5$export$62fed45313a13eff;

});

parcelRegister("inrbX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $c6GJD = parcelRequire("c6GJD");


var $6yNqK = parcelRequire("6yNqK");


var $731W9 = parcelRequire("731W9");


var $j4ply = parcelRequire("j4ply");


var $4VmlX = parcelRequire("4VmlX");


var $djVCD = parcelRequire("djVCD");

const $3a401808d4c266ad$export$82052fbad762998f = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $42omo.useCallback)((payload)=>{
        createAnalyticsEvent({
            ...payload,
            source: 'searchDialog'
        }).fire((0, $6yNqK.DEFAULT_GAS_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    const fireAnalyticsScreenEvent = (0, $42omo.useCallback)((payload)=>{
        createAnalyticsEvent({
            ...payload,
            eventType: 'screen',
            source: 'searchDialog'
        }).fire((0, $6yNqK.DEFAULT_GAS_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireAnalyticsEvent: fireAnalyticsEvent,
        fireAnalyticsScreenEvent: fireAnalyticsScreenEvent
    };
};
const $3a401808d4c266ad$export$380f10e960af9b57 = ()=>{
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const fetchEntitiesRequestId = (0, $4VmlX.useFetchEntitiesRequestId)();
    const fetchSpacesRequestId = (0, $4VmlX.useFetchSpacesRequestId)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [queryUpdatedTime] = (0, $djVCD.useQueryUpdatedTime)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [queryVersion] = (0, $djVCD.useQueryVersion)();
    const [experimentConfig] = (0, $j4ply.useExperimentConfig)();
    const applicationMode = (0, $j4ply.useApplicationMode)();
    const [analyticsAttributes] = (0, $j4ply.useAnalyticsAttributes)();
    const [productSelected] = (0, $djVCD.useSelectedProduct)();
    const filters = (0, $djVCD.useFilterAttributesForTracking)();
    const [productEdition] = (0, $j4ply.useProductEdition)();
    return (0, $42omo.useMemo)(()=>{
        const { frontendExperiments: frontendExperiments = {}, combinedExperiment: combinedExperiment = {} } = experimentConfig;
        const { filterSelections: filterSelections, filters: filterCategories } = filters;
        const quickFind3pExperiment = (0, $c6GJD.default).getExperiment('quick_find_3p_search_results_experiment', {
            fireExperimentExposure: false
        });
        const commonAttributes = {
            productEdition: productEdition,
            frontendExperiments: {
                activeExperiments: Object.keys(frontendExperiments).filter((experiment)=>frontendExperiments[experiment]?.serveExperiment),
                ...frontendExperiments,
                quick_find_3p_search_results_experiment: {
                    abTestId: 'quick_find_3p_search_results_experiment',
                    ...quickFind3pExperiment.value
                }
            },
            combinedExperiment: combinedExperiment,
            ...$3a401808d4c266ad$export$e44a494bf5ca923a(quickFindQuery),
            queryUpdatedAgo: queryUpdatedTime ? Date.now() - queryUpdatedTime : undefined,
            queryVersion: queryVersion,
            searchSessionId: searchSessionId,
            fetchEntitiesTraceId: fetchEntitiesRequestId,
            fetchSpacesTraceId: fetchSpacesRequestId,
            isQuickFind: true,
            mode: applicationMode,
            productSelected: productSelected || (0, $6yNqK.ALL_PRODUCTS_STRING),
            filters: filterCategories,
            filterSelections: filterSelections,
            ...analyticsAttributes
        };
        const nonPrivacySafeAttributes = {
            query: quickFindQuery
        };
        return {
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        };
    }, [
        analyticsAttributes,
        applicationMode,
        experimentConfig,
        fetchEntitiesRequestId,
        fetchSpacesRequestId,
        filters,
        productEdition,
        productSelected,
        queryUpdatedTime,
        queryVersion,
        quickFindQuery,
        searchSessionId
    ]);
};
const $3a401808d4c266ad$export$dba3e2bcdbd49da4 = (query)=>(query.match(/\w+/g) || []).length;
const $3a401808d4c266ad$export$e44a494bf5ca923a = (query)=>{
    const wordCount = $3a401808d4c266ad$export$dba3e2bcdbd49da4(query);
    return {
        numberOfTerms: wordCount,
        queryHash: (0, $731W9.sha256Hash)(query),
        queryHashSHA256: (0, $731W9.sha256Hash)(query),
        queryLength: query.length,
        wordCount: wordCount
    };
};
module.exports["useQuickFindAnalytics"] = $3a401808d4c266ad$export$82052fbad762998f;
module.exports["useQuickFindAttributes"] = $3a401808d4c266ad$export$380f10e960af9b57;
module.exports["getCommonQueryAttributes"] = $3a401808d4c266ad$export$e44a494bf5ca923a;
module.exports["getWordCount"] = $3a401808d4c266ad$export$dba3e2bcdbd49da4;

});

parcelRegister("lGfXC", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $6jKOp = parcelRequire("6jKOp");


var $bQSQw = parcelRequire("bQSQw");

const $65a45d81c286798a$export$b551db3ea2671aa7 = (taskId, taskName, searchSessionId, fireAnalyticsEvent, configNetworkTaskStartAt, context)=>{
    const baseParams = {
        taskId: taskId,
        task: taskName,
        searchSessionId: searchSessionId
    };
    return {
        onStart: ()=>{
            fireAnalyticsEvent((0, $bQSQw.onTaskStart)({
                ...baseParams,
                moreContext: context
            }));
        },
        onSuccess: (traceInfo)=>{
            const timeTaken = performance.now() - configNetworkTaskStartAt;
            const tracingHeaders = (0, $dh538.fg)('rovo-search-vitalstats-tracing-headers') ? (0, $6jKOp.normaliseTraceInfo)(traceInfo) : {};
            fireAnalyticsEvent((0, $bQSQw.onTaskSuccess)({
                ...baseParams,
                moreContext: {
                    ...context,
                    timeTaken: timeTaken,
                    ...tracingHeaders
                }
            }));
        },
        onError: (errorName, errorMessage, traceInfo)=>{
            const timeTaken = performance.now() - configNetworkTaskStartAt;
            const tracingHeaders = (0, $dh538.fg)('rovo-search-vitalstats-tracing-headers') ? (0, $6jKOp.normaliseTraceInfo)(traceInfo) : {};
            fireAnalyticsEvent((0, $bQSQw.onTaskFail)({
                ...baseParams,
                moreContext: {
                    ...context,
                    errorName: errorName,
                    errorMessage: errorMessage,
                    timeTaken: timeTaken,
                    ...tracingHeaders
                }
            }));
        }
    };
};
module.exports["createVitalStatsNetworkCallbacks"] = $65a45d81c286798a$export$b551db3ea2671aa7;

});

parcelRegister("ja8yA", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $2qzBQ = parcelRequire("2qzBQ");


var $jnPv4 = parcelRequire("jnPv4");


var $6jKOp = parcelRequire("6jKOp");

// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ const $f525b3f0ba3d21ed$export$6635638df40163e1 = 'quick-find-recent-activities';


/* eslint-disable @atlaskit/platform/no-module-level-eval */ 
var $dh538 = parcelRequire("dh538");

const $96bd0be78eb47b74$var$ConfluencePageFragment = `
  fragment ConfluencePageFragment on ConfluencePage {
    __typename
    title
    pageStatus: status
    subtype
    ancestors {
      __typename
      id
      title
    }
    links {
      __typename
      base
      webUi
    }
    space {
      id
      name
    }
  }
`;
const $96bd0be78eb47b74$var$ConfluenceBlogPostFragment = `
  fragment ConfluenceBlogPostFragment on ConfluenceBlogPost {
    __typename
    title
    blogStatus: status
    links {
      __typename
      base
      webUi
    }
    space {
      id
      name
    }
  }
`;
const $96bd0be78eb47b74$var$ConfluenceWhiteboardFragment = `
  fragment ConfluenceWhiteboardFragment on ConfluenceWhiteboard {
    __typename
    title
    links {
      base
      webUi
    }
    space {
      id
      name
    }
  }
`;
const $96bd0be78eb47b74$var$AtlasProjectFragment = `
  fragment AtlasProjectFragment on TownsquareProject {
    __typename
    key
    name
    url
    iconData
  }
`;
const $96bd0be78eb47b74$var$AtlasGoalFragment = `
  fragment AtlasGoalFragment on TownsquareGoal {
    __typename
    key
    name
    url
    iconData
  }
`;
const $96bd0be78eb47b74$var$JiraSingleIssueLineTextFieldFragment = `
  fragment JiraSingleIssueLineTextFieldFragment on JiraSingleLineTextField {
    text
		issue @include(if: $includeJiraIssueMetadata) {
			projectField {
				project {
					name
				}
			}
			issueTypeField {
				issueType {
					name
				}
			}
		}
  }
`;
const $96bd0be78eb47b74$var$JiraIssueFragment = `
  fragment JiraIssueFragment on JiraIssue {
    __typename
    key
    webUrl
    statusCategory {
      name,
      colorName
    }
    issueType {
      avatar {
        small
      }
    }
    fieldsById(ids: ["summary"]) {
      edges {
        node {
          __typename
          ...JiraSingleIssueLineTextFieldFragment
        }
      }
    }
  }
  ${$96bd0be78eb47b74$var$JiraSingleIssueLineTextFieldFragment}
`;
const $96bd0be78eb47b74$var$GraphDocumentFragment = `
  fragment GraphDocumentFragment on ExternalDocument {
    id
    type {
        category
    }
    displayName
    parent @optIn(to: "ExternalDataDepotQueryV2"){
        ... on ExternalDocument {
            displayName
        }
    }
    url
    provider {
        providerId
    }
  }
`;
const $96bd0be78eb47b74$var$GraphRemoteLinkFragment = `
  fragment GraphRemoteLinkFragment on ExternalRemoteLink {
	  id
		displayName
		category @optIn(to: "ExternalDataDepotQueryV2")
		url
    provider {
			providerId
		}
  }
`;
const $96bd0be78eb47b74$var$LoomVideoFragment = `
  fragment LoomVideoFragment on LoomVideo {
    name
    loomUrl: url
  }
`;
const $96bd0be78eb47b74$var$ExternalPullRequestFragment = `
  fragment ExternalPullRequestFragment on ExternalPullRequest {
    id
    displayName
    url
    status
    provider {
      providerId
    }
  }
`;
const $96bd0be78eb47b74$var$ExternalWorkItemFragment = `
  fragment ExternalWorkItemFragment on ExternalWorkItem {
    id
    displayName
    url
    workItemStatus: status
    provider {
      providerId
    }
  }
`;
const $96bd0be78eb47b74$var$AssetsObjectFragment = `
  fragment AssetsObjectFragment on AssetsObject {
    id
		displayTypename @optIn(to: "AssetsApFields")
    links {
      web
    }
    assetsLabel: label
    objectKey
    assetsIcon: avatar {
      url48
    }
    objectType {
      schema {
        name
      }
    }
  }
`;
const $96bd0be78eb47b74$var$AssetsObjectTypeFragment = `
fragment AssetsObjectTypeFragment on AssetsObjectType {
	id
	displayTypename @optIn(to: "AssetsApFields")
	links {
		web
	}
	assetsLabel: name
	assetsIcon: icon {
		url48
	}
	schema {
		assetsSchemaName: name
	}
}
`;
const $96bd0be78eb47b74$var$AssetsSchemaFragment = `
fragment AssetsSchemaFragment on AssetsSchema {
	id
	displayTypename @optIn(to: "AssetsApFields")
	links {
		web
	}
	assetsLabel: name
}
`;
const $96bd0be78eb47b74$export$5db520940cf00715 = 'QuickFindActivitiesQuery';
const $96bd0be78eb47b74$export$8a781e50bcd90a75 = `
  query ${$96bd0be78eb47b74$export$5db520940cf00715}(
    $filteredProducts: [String!]
    $filteredObjectTypes: [String!]
    $filteredEventTypes: [String!]
    $itemsLimit: Int!
    $filteredRootContainerIds: [ID!]
    $after: String
    $includeJiraIssueMetadata: Boolean = false
  ) {
    activity {
      myActivity {
        all(
          filter: {
            arguments: {
              products: $filteredProducts
              objectTypes: $filteredObjectTypes
              eventTypes: $filteredEventTypes
            }
            rootContainerIds: $filteredRootContainerIds
          }
          first: $itemsLimit
          after: $after
        ) {
          __typename
          edges {
            cursor
            __typename
            node {
              __typename
              object {
                __typename
                id
                type
                product
                data {
                  __typename
                  ...ConfluencePageFragment
                  ...ConfluenceBlogPostFragment
                  ...ConfluenceWhiteboardFragment
                  ...AtlasProjectFragment
                  ...AtlasGoalFragment
                  ...JiraIssueFragment
                  ...GraphDocumentFragment
									...GraphRemoteLinkFragment
									...LoomVideoFragment
									...ExternalPullRequestFragment
									...ExternalWorkItemFragment
                  ${(0, $dh538.fg)('assets_rovo_search_all') ? `...AssetsObjectFragment` : ''}
									${(0, $dh538.fg)('assets_rovo_search_all') ? `...AssetsObjectTypeFragment` : ''}
									${(0, $dh538.fg)('assets_rovo_search_all') ? `...AssetsSchemaFragment` : ''}
                }
              }
              event {
                __typename
                eventType
                timestamp
              }
            }
          }
        }
      }
    }
  }
  ${$96bd0be78eb47b74$var$ConfluencePageFragment}
  ${$96bd0be78eb47b74$var$ConfluenceBlogPostFragment}
  ${$96bd0be78eb47b74$var$ConfluenceWhiteboardFragment}
  ${$96bd0be78eb47b74$var$AtlasProjectFragment}
  ${$96bd0be78eb47b74$var$AtlasGoalFragment}
  ${$96bd0be78eb47b74$var$JiraIssueFragment}
  ${$96bd0be78eb47b74$var$GraphDocumentFragment}
	${$96bd0be78eb47b74$var$GraphRemoteLinkFragment}
	${$96bd0be78eb47b74$var$LoomVideoFragment}
	${$96bd0be78eb47b74$var$ExternalPullRequestFragment}
	${$96bd0be78eb47b74$var$ExternalWorkItemFragment}
  ${(0, $dh538.fg)('assets_rovo_search_all') ? $96bd0be78eb47b74$var$AssetsObjectFragment : ''}
	${(0, $dh538.fg)('assets_rovo_search_all') ? $96bd0be78eb47b74$var$AssetsObjectTypeFragment : ''}
	${(0, $dh538.fg)('assets_rovo_search_all') ? $96bd0be78eb47b74$var$AssetsSchemaFragment : ''}
`;


const $8055f1273433c91e$export$ba6bff93c920ff4a = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers, networkCallbacks: networkCallbacks })=>{
    networkCallbacks?.onStart();
    return (0, $4qT1X.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: (0, $96bd0be78eb47b74$export$8a781e50bcd90a75),
        operationName: $96bd0be78eb47b74$export$5db520940cf00715,
        headers: headers
    }).then((result)=>{
        const traceInfo = (0, $6jKOp.extractTraceInfoFromResponse)(result);
        networkCallbacks?.onSuccess(traceInfo);
        return result;
    }, (error)=>{
        networkCallbacks?.onError(error?.name || 'UnknownError', error?.message || 'An unknown error occurred');
        throw error;
    });
};
const { refreshOnAccessDecorator: $8055f1273433c91e$var$refreshOnAccessDecoratorRecentActivities, clear: $8055f1273433c91e$var$clearRecentActivitiesCache } = (0, $jnPv4.promiseCache)({
    name: (0, $f525b3f0ba3d21ed$export$6635638df40163e1)
});
const $8055f1273433c91e$var$FAILURE_EXPIRATION_MS = 5000; // 5 seconds for failure
const $8055f1273433c91e$var$SUCCESS_EXPIRATION_MS = 300000; // 5 minutes for success
const $8055f1273433c91e$export$ffce414fbab0f879 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers, expiration: expiration, onlyRefreshIfExpired: onlyRefreshIfExpired, returnExpired: returnExpired, analyticsCallback: analyticsCallback, networkCallbacks: networkCallbacks })=>{
    const cacheKey = (0, $2qzBQ.generateHash)(`${(0, $f525b3f0ba3d21ed$export$6635638df40163e1)}|${JSON.stringify(variables)}`).toString();
    const writeBackWithTTL = (value, ttl)=>{
        $8055f1273433c91e$var$refreshOnAccessDecoratorRecentActivities({
            key: cacheKey,
            supplier: async ()=>value,
            returnExpired: false,
            onlyRefreshIfExpired: false,
            expiration: ttl
        });
    };
    return $8055f1273433c91e$var$refreshOnAccessDecoratorRecentActivities({
        key: cacheKey,
        supplier: async ()=>{
            try {
                const result = await (0, $4qT1X.fetchAgg)({
                    variables: variables,
                    aggAbsoluteUrl: aggAbsoluteUrl,
                    graphQuery: (0, $96bd0be78eb47b74$export$8a781e50bcd90a75),
                    operationName: $96bd0be78eb47b74$export$5db520940cf00715,
                    headers: headers
                });
                writeBackWithTTL(result, $8055f1273433c91e$var$SUCCESS_EXPIRATION_MS);
                return result;
            } catch (error) {
                // On failure, cache the rejected promise with a short TTL to avoid hammering the service
                // This ensures the error is still thrown when accessed, but prevents immediate retries
                writeBackWithTTL(Promise.reject(error), $8055f1273433c91e$var$FAILURE_EXPIRATION_MS);
                // Re-throw the error so the caller knows the request failed
                throw error;
            }
        },
        expiration: expiration,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        returnExpired: returnExpired,
        analyticsCallback: analyticsCallback,
        networkCallbacks: networkCallbacks
    });
};
const $8055f1273433c91e$export$b0de6826751f4fe0 = ({ variables: variables, graphQuery: graphQuery, aggAbsoluteUrl: aggAbsoluteUrl, operationName: operationName, headers: headers })=>{
    return (0, $4qT1X.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: operationName,
        headers: headers
    });
};
const $8055f1273433c91e$export$a13e8bf43a8d56c7 = (key)=>$8055f1273433c91e$var$clearRecentActivitiesCache(key);
module.exports["recentActivitiesQuery"] = $8055f1273433c91e$export$ba6bff93c920ff4a;
module.exports["cachedRecentActivitiesQuery"] = $8055f1273433c91e$export$ffce414fbab0f879;
module.exports["fetchJiraIssuesQuery"] = $8055f1273433c91e$export$b0de6826751f4fe0;

});

parcelRegister("3R0ts", function(module, exports) {

var $6Gsan = parcelRequire("6Gsan");

const $979dcbe39352dbbd$export$194e5f2c2ebfcf47 = 'quick-find-dialog';
const $979dcbe39352dbbd$export$954ad19cca7aaecd = 'quick-find-open';
const $979dcbe39352dbbd$export$d73367afdae3e8ef = 'quick-find-close';
const $979dcbe39352dbbd$export$529299d30909140a = 'quick-find-post-query';
const $979dcbe39352dbbd$export$b1255d59856835f2 = 'quick-find-loading';
const $979dcbe39352dbbd$export$90774abdf51eb445 = [
    (0, $6Gsan.PrimaryProductKeys).Confluence,
    (0, $6Gsan.PrimaryProductKeys).Jira,
    (0, $6Gsan.PrimaryProductKeys).Assets,
    (0, $6Gsan.PrimaryProductKeys).RovoExtension,
    (0, $6Gsan.PrimaryProductKeys).Talent
];
const $979dcbe39352dbbd$export$4551c7df8148d8af = 'atlassian.search-dialog.ai-dialog.referrer';
const $979dcbe39352dbbd$export$fffb71ae1a2b6d2f = 2;
module.exports["SEARCH_DIALOG_WIDTH_OBSERVER_ID"] = $979dcbe39352dbbd$export$194e5f2c2ebfcf47;
module.exports["QUICK_FIND_OPEN_INTERACTION"] = $979dcbe39352dbbd$export$954ad19cca7aaecd;
module.exports["QUICK_FIND_CLOSE_INTERACTION"] = $979dcbe39352dbbd$export$d73367afdae3e8ef;
module.exports["QUICK_FIND_POST_QUERY_INTERACTION"] = $979dcbe39352dbbd$export$529299d30909140a;
module.exports["QUICK_FIND_LOADING_HOLD"] = $979dcbe39352dbbd$export$b1255d59856835f2;
module.exports["PRODUCTS_WITH_INLINE_FILTERS"] = $979dcbe39352dbbd$export$90774abdf51eb445;
module.exports["SEARCH_DIALOG_AI_DIALOG_REFERER_KEY"] = $979dcbe39352dbbd$export$4551c7df8148d8af;
module.exports["DEFAULT_RECENT_AND_SUGGESTED_QUERY_LIMIT"] = $979dcbe39352dbbd$export$fffb71ae1a2b6d2f;

});

parcelRegister("lHqdD", function(module, exports) {
/**
 * Generic builder for the `ml_lens` envelope that lets the ML Lens transformer
 * split a single GASv3 event into one metric per logical dimension (e.g. one
 * metric per product/connector).
 *
 * See: https://hello.atlassian.net/wiki/spaces/~93171358/pages/6820686403/
 *   GASv3+Events+Transformation+for+ML+Lens+Metrics+Schema
 *
 * This module is intentionally domain-agnostic: callers provide the namespace,
 * the metric-set base tags and the list of metrics. Surface-specific helpers
 * (e.g. Quick Find post-query, Full Page Search results) live alongside this
 * file and delegate to {@link buildMlLensEnvelope}.
 */ const $93e272fdd2ffb3d6$export$aaa5dab2f0c84de8 = ({ namespace: namespace, baseTags: baseTags, metrics: metrics, userId: userId })=>({
        version: '1',
        metric_sets: [
            {
                namespace: namespace,
                tags: {
                    ...baseTags,
                    ...userId ? {
                        user_id: userId
                    } : {}
                },
                metrics: metrics
            }
        ]
    });
module.exports["buildMlLensEnvelope"] = $93e272fdd2ffb3d6$export$aaa5dab2f0c84de8;

});

parcelRegister("chwej", function(module, exports) {
const $8c8fb827b5015331$export$52f97816f69502ce = 'atl-edge-region-hint';
function $8c8fb827b5015331$export$ef0639c0600b3b26(primaryProduct, productDataRegions) {
    const primaryProductDataRegion = primaryProduct ? productDataRegions[primaryProduct]?.[0] : undefined;
    const confluenceDataRegion = productDataRegions['confluence']?.[0];
    const jiraDataRegion = productDataRegions['jira']?.[0];
    const firstDataRegion = Object.entries(productDataRegions)[0]?.[0];
    return primaryProductDataRegion ?? confluenceDataRegion ?? jiraDataRegion ?? firstDataRegion;
}
module.exports["EDGE_REGION_HINT_HEADER"] = $8c8fb827b5015331$export$52f97816f69502ce;
module.exports["getEdgeRegionHint"] = $8c8fb827b5015331$export$ef0639c0600b3b26;

});

parcelRegister("1SV4e", function(module, exports) {

var $5G9KX = parcelRequire("5G9KX");

const $8ca6facece17d017$export$ec4722d39a5031c0 = 'atlassian.unified-search.recent-searches';
const $8ca6facece17d017$export$c1b7badf23670c19 = 50;
const $8ca6facece17d017$export$98712b4e855f892c = (item)=>typeof item === 'string' ? {
        query: item
    } : item;
const $8ca6facece17d017$export$74e99d9695eabee6 = ({ value: value, userId: userId, productId: productId, key: key })=>{
    const recentSearchesRaw = (0, $5G9KX.getLocalStorageItemAsString)(key);
    const recentSearches = recentSearchesRaw ? JSON.parse(recentSearchesRaw) : {};
    if (!recentSearches[userId]) recentSearches[userId] = {};
    let userSearches = recentSearches[userId];
    if (!userSearches[productId]) userSearches[productId] = [];
    let productSearches = userSearches[productId];
    // Normalize the value: if it's a string, trim it; if it's an object, trim the query
    const normalizedValue = typeof value === 'string' ? value.trim() : {
        ...value,
        query: value.query.trim()
    };
    // Pop the last value of the array if it is too long
    if (productSearches.length === $8ca6facece17d017$export$c1b7badf23670c19) productSearches.pop();
    // If the given value is a duplicate (based on query), remove it from the array
    const { query: normalizedQuery } = $8ca6facece17d017$export$98712b4e855f892c(normalizedValue);
    productSearches = productSearches.filter((v)=>$8ca6facece17d017$export$98712b4e855f892c(v).query !== normalizedQuery);
    productSearches.unshift(normalizedValue);
    recentSearches[userId][productId] = productSearches;
    (0, $5G9KX.setLocalStorageItem)(key, JSON.stringify(recentSearches));
};
const $8ca6facece17d017$export$1216255791599668 = ({ userId: userId, productId: productId, key: key })=>{
    const recentSearchesRaw = (0, $5G9KX.getLocalStorageItemAsString)(key);
    const recentSearches = recentSearchesRaw ? JSON.parse(recentSearchesRaw) : {};
    const userSearches = recentSearches[userId] || {};
    return userSearches[productId] || [];
};
const $8ca6facece17d017$export$6adb2cc1366d1e30 = ({ value: value, userId: userId, productId: productId, key: key })=>{
    const recentSearchesRaw = (0, $5G9KX.getLocalStorageItemAsString)(key);
    const recentSearches = recentSearchesRaw ? JSON.parse(recentSearchesRaw) : {};
    if (!recentSearches[userId] || !recentSearches[userId][productId]) return [];
    const { query: queryToRemove } = $8ca6facece17d017$export$98712b4e855f892c(value);
    recentSearches[userId][productId] = recentSearches[userId][productId].filter((v)=>$8ca6facece17d017$export$98712b4e855f892c(v).query !== queryToRemove);
    (0, $5G9KX.setLocalStorageItem)(key, JSON.stringify(recentSearches));
    return recentSearches[userId][productId];
};
module.exports["RECENT_SEARCH_KEY"] = $8ca6facece17d017$export$ec4722d39a5031c0;
module.exports["getRecentQueryObject"] = $8ca6facece17d017$export$98712b4e855f892c;
module.exports["addRecentSearch"] = $8ca6facece17d017$export$74e99d9695eabee6;
module.exports["getRecentSearches"] = $8ca6facece17d017$export$1216255791599668;
module.exports["removeRecentSearch"] = $8ca6facece17d017$export$6adb2cc1366d1e30;

});

parcelRegister("8aC7e", function(module, exports) {
$parcel$export(module.exports, "default", () => $24d120d5a9177b55$export$2e2bcd8739ae039);
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $42omo = parcelRequire("42omo");


var $hnvzE = parcelRequire("hnvzE");


var $iA4lt = parcelRequire("iA4lt");


var $gkXKl = parcelRequire("gkXKl");


var $b4tvS = parcelRequire("b4tvS");
parcelRequire("1yEFx");



var $9rRKJ = parcelRequire("9rRKJ");


var $2OtFZ = parcelRequire("2OtFZ");


var $1ikWy = parcelRequire("1ikWy");


var $eO6NY = parcelRequire("eO6NY");





var $dh538 = parcelRequire("dh538");


var $2qzBQ = parcelRequire("2qzBQ");


var $jnPv4 = parcelRequire("jnPv4");


var $3Tbc2 = parcelRequire("3Tbc2");


var $i1nCm = parcelRequire("i1nCm");


var $78yNl = parcelRequire("78yNl");

const { refreshOnAccessDecorator: $565d370b0f69fbc8$var$refreshOnAccessDecoratorSmartlinkUsageAndTopApps, get: $565d370b0f69fbc8$var$getSmartlinkUsageAndTopAppsCache, clear: $565d370b0f69fbc8$var$clearSmartlinkUsageAndTopAppsCache } = (0, $jnPv4.promiseCache)({
    name: (0, $i1nCm.SEARCH_PERSONALIZATION_SMARTLINK_USAGE_AND_TOP_APPS_SITE_CACHE_KEY),
    expiration: (0, $i1nCm.SEVEN_DAY_MS_TTL)
});
const $565d370b0f69fbc8$var$fetchSiteSmartlinkUsageAndTopAppsService = async (siteId)=>{
    // Re-uses the existing TAP-delivery site traits endpoint that smartlink uses;
    // every site-scoped TAP trait is returned in the same `attributes` bag.
    const requestUrl = (0, $78yNl.getSmartlinkSiteTraitsUrl)(siteId);
    const requestOptions = {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return fetch(requestUrl, requestOptions).then((response)=>{
        if (response.ok) return response.json();
        return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
    });
};
const $565d370b0f69fbc8$var$fetchSmartlinkUsageAndTopAppsTrait = async ({ siteId: siteId, analyticsCallback: analyticsCallback, cacheKeySuffix: cacheKeySuffix, degradationCallback: degradationCallback = ()=>{} })=>{
    const key = (0, $2qzBQ.generateHash)(`${(0, $i1nCm.SEARCH_PERSONALIZATION_SMARTLINK_USAGE_AND_TOP_APPS_SITE_CACHE_KEY)}|${siteId}|${cacheKeySuffix}`);
    const supplier = async ()=>{
        const fetchPromise = $565d370b0f69fbc8$var$fetchSiteSmartlinkUsageAndTopAppsService(siteId).then((data)=>{
            const { attributes: attributes } = data;
            return attributes?.find((t)=>t.name === (0, $i1nCm.SMARTLINK_USAGE_AND_TOP_APPS_TRAIT));
        }).catch(()=>undefined); // treat non-200 as empty and avoid caching a rejected promise
        const degrader = new (0, $3Tbc2.DegradablePromise)(fetchPromise, degradationCallback, 1000); // 1s degrade threshold
        return degrader.promise();
    };
    const existing = $565d370b0f69fbc8$var$getSmartlinkUsageAndTopAppsCache(key.toString());
    // Choose TTL based on outcome:
    // - success (non-empty trait): default SEVEN_DAY_TTL
    // - empty (undefined): ONE_DAY_TTL
    // - degraded (timeout/reject): ONE_HOUR_TTL
    const effectiveExpiration = !existing?.storedValue ? (0, $i1nCm.ONE_HOUR_MS_TTL) : undefined;
    const effectiveOnlyRefreshIfExpired = true;
    // Helper to re-write the cached value with a specific TTL without re-fetching
    const writeBackWithTTL = (value, ttl)=>{
        $565d370b0f69fbc8$var$refreshOnAccessDecoratorSmartlinkUsageAndTopApps({
            key: key.toString(),
            supplier: async ()=>value,
            returnExpired: false,
            onlyRefreshIfExpired: false,
            // force refresh to apply new TTL
            expiration: ttl
        });
    };
    return $565d370b0f69fbc8$var$refreshOnAccessDecoratorSmartlinkUsageAndTopApps({
        key: key.toString(),
        supplier: async ()=>{
            try {
                const result = await supplier(); // Trait | undefined (no degrade)
                if (result) writeBackWithTTL(result, (0, $i1nCm.SEVEN_DAY_MS_TTL));
                else writeBackWithTTL(undefined, (0, $i1nCm.ONE_DAY_MS_TTL));
                return result;
            } catch  {
                // On degrade/timeout, return undefined so promiseCache stores an "empty" value
                // and then write back a short TTL to avoid hammering
                writeBackWithTTL(undefined, (0, $i1nCm.ONE_HOUR_MS_TTL));
                return undefined;
            }
        },
        onlyRefreshIfExpired: effectiveOnlyRefreshIfExpired,
        expiration: effectiveExpiration,
        analyticsCallback: analyticsCallback
    });
};
const $565d370b0f69fbc8$export$c51adaa111ad7984 = (key)=>$565d370b0f69fbc8$var$clearSmartlinkUsageAndTopAppsCache(key);
const $565d370b0f69fbc8$export$efe206f958294f9e = (trait)=>{
    if (trait?.name !== (0, $i1nCm.SMARTLINK_USAGE_AND_TOP_APPS_TRAIT) || typeof trait?.value !== 'string') return undefined;
    const segments = trait.value.split(',');
    const [first, ...rest] = segments;
    const percentage = parseInt((first ?? '').trim(), 10);
    if (Number.isNaN(percentage)) return undefined;
    const mostUsedApps = rest.map((s)=>s.trim()).filter(Boolean);
    return {
        percentage: percentage,
        mostUsedApps: mostUsedApps
    };
};
const $565d370b0f69fbc8$export$9f0f423d6c87a84a = async ({ siteId: siteId, analyticsCallback: analyticsCallback, degradationCallback: degradationCallback })=>{
    if (!siteId) return undefined;
    const trait = await $565d370b0f69fbc8$var$fetchSmartlinkUsageAndTopAppsTrait({
        siteId: siteId,
        analyticsCallback: analyticsCallback,
        degradationCallback: degradationCallback,
        cacheKeySuffix: 'rovo-search-smartlink-usage-and-top-apps'
    });
    return $565d370b0f69fbc8$export$efe206f958294f9e(trait);
};






var $6yNqK = parcelRequire("6yNqK");




const $97a7f23b507766a3$export$817a2282565e7f38 = ({ cloudId: cloudId, experience: experience, percentage: percentage, dataPresent: dataPresent })=>{
    return {
        action: 'taskSuccess',
        actionSubject: 'smartLinkUsageAndTopAppsFetch',
        eventType: 'operational',
        source: experience === (0, $9rRKJ.SearchExperience).QUICK_FIND ? (0, $6yNqK.SEARCH_DIALOG_EVENT_SOURCE) : (0, $6yNqK.EVENT_SOURCE),
        attributes: {
            additionalAttributes: {
                cloudId: cloudId,
                percentage: percentage,
                dataPresent: dataPresent
            }
        }
    };
};
const $97a7f23b507766a3$export$eeb9c73de731d022 = ({ cloudId: cloudId, experience: experience, reason: reason })=>{
    return {
        action: 'taskFail',
        actionSubject: 'smartLinkUsageAndTopAppsFetch',
        eventType: 'operational',
        source: experience === (0, $9rRKJ.SearchExperience).QUICK_FIND ? (0, $6yNqK.SEARCH_DIALOG_EVENT_SOURCE) : (0, $6yNqK.EVENT_SOURCE),
        attributes: {
            additionalAttributes: {
                cloudId: cloudId,
                reason: reason
            }
        }
    };
};






var $3CshZ = parcelRequire("3CshZ");

/**
 * Tenant editions covered by the underlying TAP site trait
 * (`rovo_nudge_end_user_rendered_smartlinks_percent_and_most_used_apps`).
 * The trait is only computed for MAU customers on paid editions; calling the
 * endpoint for tenants outside this set just returns an empty payload, so we
 * skip the fetch entirely.
 */ const $8801996e88559d75$var$COVERED_EDITIONS = new Set([
    'STANDARD',
    'PREMIUM',
    'ENTERPRISE'
]);
const $8801996e88559d75$var$isPrimaryProductCovered = (primaryProduct, productEdition)=>{
    const edition = productEdition?.[primaryProduct];
    return !!edition && $8801996e88559d75$var$COVERED_EDITIONS.has(edition.toUpperCase());
};
const $8801996e88559d75$export$bb9929b0c526b28f = (experience, primaryProduct, cloudId, thirdPartyConfigs, productEdition)=>{
    const [smartLinkUsageAndTopApps, setSmartLinkUsageAndTopApps] = (0, $42omo.useState)(undefined);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)({
        experience: experience
    });
    // Ensure we only ever trigger the fetch once per mount, even if
    // `thirdPartyConfigs` / `productEdition` (and therefore
    // `isFPSGitHubSocialProofBannerEnabled` / `isCoveredTenant`) later change —
    // the trait is site-scoped and doesn't change within a session.
    const hasFetchedRef = (0, $42omo.useRef)(false);
    // The only consumer of this value is `BulkConnectBanner` on the Full Page
    // Search surface (via `useSmartLinkUsageAndTopApps()` → `OAuthBanner`'s
    // `teamConnectedPercentage`). Quick Find does not read it, so skip the
    // fetch (and the analytics event) entirely when running inside Quick Find.
    const isQuickFind = experience === (0, $9rRKJ.SearchExperience).QUICK_FIND;
    // NO EXPOSURE! Allocate to short-circuit the hook if the experiment is disabled
    // or the user is not eligible.
    const isFPSGitHubSocialProofBannerEnabled = (0, $2OtFZ.serveFPSGitHubSocialProofBannerExperiment)({
        thirdPartyConfigs: thirdPartyConfigs
    }, {
        fireExperimentExposure: false
    });
    const isCoveredTenant = $8801996e88559d75$var$isPrimaryProductCovered(primaryProduct, productEdition);
    (0, $42omo.useEffect)(()=>{
        if (!isQuickFind && isFPSGitHubSocialProofBannerEnabled && // The edition check is redundant with the trait itself — the trait is
        // only computed for covered editions, so an uncovered tenant just
        // resolves to empty data. Behind the debug gate we bypass this guard so
        // the fetch (and its analytics) runs regardless of edition, letting us
        // observe in prod why the trait may be empty.
        (isCoveredTenant || (0, $dh538.fg)('debug_social_proof_percentage_trait_fetch')) && cloudId && !hasFetchedRef.current) {
            hasFetchedRef.current = true;
            (0, $565d370b0f69fbc8$export$9f0f423d6c87a84a)({
                siteId: cloudId
            }).then((data)=>{
                setSmartLinkUsageAndTopApps(data);
                // DEBUG (debug_social_proof_percentage_trait_fetch): the fetch can
                // resolve successfully but with empty/missing trait data, in which
                // case `data` is `undefined`. Normally we skip the success event in
                // that scenario, which makes empty-trait fetches invisible in prod.
                // Behind the debug gate we fire the success event regardless so we
                // can observe these resolved-but-empty fetches, flagged via
                // `dataPresent`/sentinel `percentage`.
                if (data) fireAnalyticsEvent((0, $97a7f23b507766a3$export$817a2282565e7f38)({
                    cloudId: cloudId,
                    experience: experience,
                    percentage: data.percentage,
                    dataPresent: true
                }));
                else if ((0, $dh538.fg)('debug_social_proof_percentage_trait_fetch')) fireAnalyticsEvent((0, $97a7f23b507766a3$export$817a2282565e7f38)({
                    cloudId: cloudId,
                    experience: experience,
                    // Sentinel: the fetch resolved but returned no parseable
                    // percentage. `dataPresent: false` disambiguates this from a
                    // genuine 0% reading.
                    percentage: -1,
                    dataPresent: false
                }));
            }).catch((error)=>{
                fireAnalyticsEvent((0, $97a7f23b507766a3$export$eeb9c73de731d022)({
                    cloudId: cloudId,
                    experience: experience,
                    reason: error instanceof Error ? error.message : String(error)
                }));
            });
        }
    }, [
        isQuickFind,
        isFPSGitHubSocialProofBannerEnabled,
        isCoveredTenant,
        cloudId,
        experience,
        fireAnalyticsEvent
    ]);
    return smartLinkUsageAndTopApps;
};









var $8yIwZ = parcelRequire("8yIwZ");


var $jwO5V = parcelRequire("jwO5V");


var $7GE7t = parcelRequire("7GE7t");


var $johDC = parcelRequire("johDC");





var $4EMbH = parcelRequire("4EMbH");





var $1yEFx = parcelRequire("1yEFx");


var $dmTG5 = parcelRequire("dmTG5");


var $cFN1h = parcelRequire("cFN1h");


var $3htW4 = parcelRequire("3htW4");


var $31eSD = parcelRequire("31eSD");


var $bQSQw = parcelRequire("bQSQw");


var $1xk5k = parcelRequire("1xk5k");


var $lGfXC = parcelRequire("lGfXC");





var $f8oYd = parcelRequire("f8oYd");


var $j4ply = parcelRequire("j4ply");

const $de054ade02a2d419$var$mapProductInfoToDataRegions = (productInfo)=>{
    if (!productInfo || productInfo.length === 0) return undefined;
    return productInfo.reduce((acc, info)=>{
        if (!info?.name || !info.dataRegion) return acc;
        acc[info.name] = Array.isArray(info.dataRegion) ? info.dataRegion : [
            info.dataRegion
        ];
        return acc;
    }, {});
};
const $de054ade02a2d419$var$mapProductEdition = (productEdition, firstPartyProducts)=>{
    if (!productEdition || !firstPartyProducts || firstPartyProducts.length === 0) return undefined;
    return firstPartyProducts.reduce((acc, product)=>{
        acc[product.name] = productEdition;
        return acc;
    }, {});
};
const $de054ade02a2d419$var$mapSiteMetadata = (siteMetadata, cloudId, firstPartyProducts)=>{
    if (!siteMetadata) return [];
    return [
        {
            siteId: cloudId || '',
            siteName: siteMetadata.siteName || '',
            isNounsAvailable: false,
            isRovoEnabled: siteMetadata.isRovoEnabled ?? false,
            isJiraIssueIndexed: siteMetadata.isJiraIssueIndexed ?? false,
            productEdition: $de054ade02a2d419$var$mapProductEdition(siteMetadata.productEdition, firstPartyProducts),
            productDataRegions: $de054ade02a2d419$var$mapProductInfoToDataRegions(siteMetadata.productInfo),
            rovoFeatures: undefined
        }
    ];
};
const $de054ade02a2d419$var$mapFirstPartyProductsToResources = (firstPartyProducts, cloudId, siteName)=>{
    return firstPartyProducts.map((product)=>({
            id: `ari:cloud:${product.name}::site/${cloudId || ''}`,
            baseUrl: '',
            siteName: siteName || ''
        }));
};
const $de054ade02a2d419$var$mapThirdPartyProductsToResources = (thirdPartyProducts)=>{
    return thirdPartyProducts.map((product)=>({
            type: product.name,
            outboundAuthUrl: product.outboundAuthUrl || '',
            isUserOAuthed: product.isUserOAuthed,
            providerId: product.providerId || '',
            connectionId: product.connectionId ?? undefined,
            isImpersonationAuthEnabled: product.isImpersonationAuthEnabled ?? undefined,
            integrationId: product.integrationARI ? product.integrationARI : undefined,
            workspaceName: product.workspaceName ?? undefined,
            workspaceUrl: product.workspaceUrl ?? undefined,
            datasourceId: product.datasourceId ?? undefined,
            connectorSyncType: product.connectorSyncType ?? undefined,
            connectorCreatedAt: product.connectorCreatedAt ?? undefined,
            lightIcon: product.lightIcon ?? undefined,
            entityTypes: product.entityTypes ?? undefined,
            environmentType: product.environmentType ?? undefined
        }));
};
const $de054ade02a2d419$export$160fbca21b53d78a = (configuration, cloudId)=>{
    const firstPartyProducts = configuration.firstPartyProducts || [];
    const thirdPartyProducts = configuration.thirdPartyProducts || [];
    const siteMetadata = configuration.siteMetadata;
    return {
        firstPartyConfig: {
            resources: $de054ade02a2d419$var$mapFirstPartyProductsToResources(firstPartyProducts, cloudId, siteMetadata?.siteName || ''),
            intercomHmac: configuration.intercomHmac || '',
            siteMetadata: $de054ade02a2d419$var$mapSiteMetadata(siteMetadata, cloudId, firstPartyProducts)
        },
        thirdPartyConfig: $de054ade02a2d419$var$mapThirdPartyProductsToResources(thirdPartyProducts)
    };
};


/**
 * Site-metadata helper functions used by `useFetchConfig`.
 *
 * These helpers each have **two implementations**, switched by the
 * `rovo_fps_use_rovo_config` feature gate:
 *
 * - **On** — delegate to the canonical implementation in
 *   `@atlassian/rovo-connectors-config/utils/site-metadata-helpers`. This is
 *   the path that will become the sole implementation once the gate is
 *   fully ramped and `useFetchConfig` is replaced by `useRovoConfig`.
 * - **Off** — run the original inline logic. Preserves verbatim behaviour
 *   for everyone not on the gate.
 *
 * Both branches must return identical results for any given input — see
 * `__tests__/site-metadata-helpers-equivalence.test.ts` for the `ffTest.both`
 * coverage that enforces this.
 *
 * **Not exported from the package.** Lives at
 * `controllers/config/site-metadata-helpers.ts` and is intentionally absent
 * from `package.json` `"exports"`. External consumers should keep going
 * through the `./use-fetch-config` subpath.
 */ 



var $lT617 = parcelRequire("lT617");

/** Matches `ari:cloud:<product>::<resource-type>/<cloudId>` and captures the cloudId. */ const $46834f5e82f1cd55$var$EXTRACT_CLOUD_ID = /ari:cloud:.*?\/(.*)/;
const $46834f5e82f1cd55$export$c1871fdf674a03c4 = (firstPartyResponse)=>{
    if ((0, $dh538.fg)('rovo_fps_use_rovo_config')) return (0, $lT617.getFirstCloudId)(firstPartyResponse);
    const match = firstPartyResponse.resources[0]?.id.match($46834f5e82f1cd55$var$EXTRACT_CLOUD_ID);
    const extractedCloudId = match ? match[1] : '';
    return extractedCloudId;
};
const $46834f5e82f1cd55$export$243c13f4da40a98e = (firstPartyResponse, cloudId)=>{
    if ((0, $dh538.fg)('rovo_fps_use_rovo_config')) return (0, $lT617.isRovoEnabledForSite)(firstPartyResponse, cloudId);
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return false;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId)?.isRovoEnabled;
};
const $46834f5e82f1cd55$export$37c9c6a3ae5f363c = (firstPartyResponse, cloudId)=>{
    if ((0, $dh538.fg)('rovo_fps_use_rovo_config')) return (0, $lT617.getJiraIssueIndexedForTenant)(firstPartyResponse, cloudId);
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return false;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId)?.isJiraIssueIndexed;
};
const $46834f5e82f1cd55$export$53e066a63a960439 = (firstPartyResponse, cloudId)=>{
    if ((0, $dh538.fg)('rovo_fps_use_rovo_config')) return (0, $lT617.getProductEdition)(firstPartyResponse, cloudId);
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return undefined;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId && !!metadata.productEdition)?.productEdition;
};
const $46834f5e82f1cd55$export$c635d3296555e2da = (firstPartyResponse, cloudId)=>{
    if ((0, $dh538.fg)('rovo_fps_use_rovo_config')) return (0, $lT617.getProductDataRegions)(firstPartyResponse, cloudId);
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return undefined;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId && !!metadata.productDataRegions)?.productDataRegions;
};
const $46834f5e82f1cd55$export$2a1c0662041ee0a3 = (firstPartyResponse, cloudId)=>{
    if ((0, $dh538.fg)('rovo_fps_use_rovo_config')) return (0, $lT617.getRovoFeatures)(firstPartyResponse, cloudId);
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return undefined;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId && !!metadata.rovoFeatures)?.rovoFeatures;
};


/**
 * Helper functions to parse the search combined config response. Ideally
 * this file should exist in the search-client package, however there are
 * too many 3P types defined in search-page.
 */ 













var $a5RR2 = parcelRequire("a5RR2");


var $9yyKc = parcelRequire("9yyKc");





var $9d9t8 = parcelRequire("9d9t8");


var $2Znam = parcelRequire("2Znam");

/**
 * Maps CloudGraph ATI to TypeFilterValueKey
 */ const $b390fff55a169820$var$ATI_TO_TYPE_FILTER_KEY_MAP = {
    'ati:cloud:graph:document': (0, $2Znam.TypeFilterValueKey).Document,
    'ati:cloud:graph:message': (0, $2Znam.TypeFilterValueKey).Message,
    'ati:cloud:graph:conversation': (0, $2Znam.TypeFilterValueKey).Conversation,
    'ati:cloud:graph:design': (0, $2Znam.TypeFilterValueKey).Design,
    'ati:cloud:graph:video': (0, $2Znam.TypeFilterValueKey).Video,
    'ati:cloud:graph:space': (0, $2Znam.TypeFilterValueKey).Space,
    'ati:cloud:graph:comment': (0, $2Znam.TypeFilterValueKey).Comment,
    'ati:cloud:graph:repository': (0, $2Znam.TypeFilterValueKey).Repository,
    'ati:cloud:graph:pull-request': (0, $2Znam.TypeFilterValueKey).PullRequest,
    'ati:cloud:graph:commit': (0, $2Znam.TypeFilterValueKey).Commit,
    'ati:cloud:graph:branch': (0, $2Znam.TypeFilterValueKey).Branch,
    'ati:cloud:graph:calendar-event': (0, $2Znam.TypeFilterValueKey).Calendar,
    'ati:cloud:graph:work-item': (0, $2Znam.TypeFilterValueKey).WorkItem,
    'ati:cloud:graph:project': (0, $2Znam.TypeFilterValueKey).Project,
    'ati:cloud:graph:deal': (0, $2Znam.TypeFilterValueKey).Deal,
    'ati:cloud:graph:customer-org': (0, $2Znam.TypeFilterValueKey).CustomerOrg,
    'ati:cloud:graph:dashboard': (0, $2Znam.TypeFilterValueKey).Dashboard,
    'ati:cloud:graph:data-table': (0, $2Znam.TypeFilterValueKey).DataTable
};
/**
 * Checks if an ATI string is a CloudGraph ATI
 */ const $b390fff55a169820$var$isCloudGraphAti = (ati)=>{
    return ati.startsWith('ati:cloud:graph:');
};
function $b390fff55a169820$export$770175465f396551(atis) {
    const typeFilterConfig = new Map();
    // Group ATIs by their corresponding TypeFilterValueKey
    const atisByTypeKey = new Map();
    for (const ati of atis)if ($b390fff55a169820$var$isCloudGraphAti(ati)) {
        const typeKey = $b390fff55a169820$var$ATI_TO_TYPE_FILTER_KEY_MAP[ati];
        if (typeKey) {
            if (!atisByTypeKey.has(typeKey)) atisByTypeKey.set(typeKey, []);
            atisByTypeKey.get(typeKey).push(ati);
        }
    }
    // Convert to TypeFilterConfig3P format
    for (const [typeKey, entityAtis] of atisByTypeKey)typeFilterConfig.set(typeKey, {
        entities3P: entityAtis,
        subTypes3P: []
    });
    return typeFilterConfig;
}






var $1ks6T = parcelRequire("1ks6T");

const $d6310552730441ce$var$FEDERATED_NO_OAUTH_PRODUCT_KEYS = new Set([
    'servicenow',
    'zendesk'
]);
const $d6310552730441ce$var$mapForgeConnectorToThirdPartyConfig = (forgeConnector)=>{
    // Validate required fields
    if (!forgeConnector.lightIcon || !forgeConnector.workspaceName) return undefined;
    const icon = (0, $9yyKc.get3PLogoFromURL)(forgeConnector.lightIcon, forgeConnector.workspaceName, 'medium');
    const searchResultIcon = (0, $9yyKc.get3PLogoFromURL)(forgeConnector.lightIcon, forgeConnector.providerId, 'large');
    const productKey = forgeConnector.type;
    // Register the icon in the registry so ProductOrNounIcon can access it without props
    (0, $9d9t8.registerForgeConnectorIcon)(productKey, icon);
    // Build type filter config
    const typeFilterConfig = forgeConnector.entityTypes ? (0, $b390fff55a169820$export$770175465f396551)(forgeConnector.entityTypes) : new Map();
    // Register the type mapping in the cache so universal type filter can use it
    if ((0, $dh538.fg)('rovo-search-dynamic-forge-config')) (0, $1xk5k.registerForgeConnectorTypeMapping)(productKey, typeFilterConfig);
    const config = {
        id: forgeConnector.type,
        displayName: forgeConnector.environmentType ? `${forgeConnector.workspaceName} (${forgeConnector.environmentType})` : forgeConnector.workspaceName,
        resourceType: forgeConnector.type,
        datasourceId: forgeConnector.datasourceId,
        connectionId: forgeConnector.connectionId,
        providerId: forgeConnector.providerId,
        outboundAuthUrl: forgeConnector.outboundAuthUrl,
        integrationAri: forgeConnector.integrationId ? forgeConnector.integrationId : `ari:cloud:platform::integration/${forgeConnector.providerId}`,
        filters: [
            'lastUpdated',
            'universalTypeFilter'
        ],
        displayWorkspaceNameAsProductName: true,
        isEnabled: ()=>true,
        userNeedsOAuth: !forgeConnector.isUserOAuthed,
        requiresOauth: !forgeConnector.isUserOAuthed && !forgeConnector.outboundAuthUrl ? false : true,
        icon: icon,
        searchResultIcon: searchResultIcon,
        typeFilterConfig: typeFilterConfig,
        workspaceName: forgeConnector.workspaceName,
        connectorSources: [
            (0, $9d9t8.FULL_CONNECTOR_SOURCE)
        ]
    };
    return config;
};
const $d6310552730441ce$export$4cb8ef4a677c563c = (resources)=>{
    const THIRD_PARTY_TYPES = (0, $1ks6T.getThirdPartyTypes)();
    // Use a map to track connector sources for each providerId
    // This is useful for deduping search results for providers that are hybrid smartlink and full connectors
    const connectorSourceMap = new Map();
    let productKeys = [];
    let thirdPartyConfigsWithAPIResponse = {};
    resources.forEach((resource)=>{
        // Handle Forge connectors first (if feature flag enabled)
        if ((0, $9d9t8.isForgeConnectorProductKey)(resource.type) && (0, $dh538.fg)('rovo-search-dynamic-forge-config')) {
            const config = $d6310552730441ce$var$mapForgeConnectorToThirdPartyConfig(resource);
            if (config) {
                const productKey = resource.type;
                productKeys.push(productKey);
                thirdPartyConfigsWithAPIResponse[productKey] = config;
            }
            return; // Early return for Forge connectors
        }
        // Handle hardcoded connectors (existing logic)
        const productKey = THIRD_PARTY_TYPES[resource.type] || '';
        if (!productKey) return;
        const { providerId: providerId, datasourceId: datasourceId } = resource;
        productKeys.push(productKey);
        let config = {};
        const staticConfig = (0, $a5RR2.ThirdPartyConfigsSync).get(productKey);
        if (staticConfig) {
            const isSlackConnectorSyncTypeEnabled = (0, $dh538.fg)('ai_3p_slack_connector_status_transition_enabled') && productKey === 'slack';
            const isFederatedNoOAuthConnector = $d6310552730441ce$var$FEDERATED_NO_OAUTH_PRODUCT_KEYS.has(productKey) && resource.connectorSyncType === (0, $9d9t8.FEDERATED_CONNECTOR_SOURCE) && (0, $dh538.fg)('rovo_fps_hide_federated_servicenow_zendesk_auth');
            let sourceType;
            if (resource.type.startsWith((0, $9d9t8.SMARTLINKS_CONNECTOR_SOURCE))) sourceType = (0, $9d9t8.SMARTLINKS_CONNECTOR_SOURCE);
            else if (resource.type.startsWith((0, $9d9t8.LITE_CONNECTOR_SOURCE))) sourceType = (0, $9d9t8.LITE_CONNECTOR_SOURCE);
            else if (isFederatedNoOAuthConnector) sourceType = (0, $9d9t8.FEDERATED_CONNECTOR_SOURCE);
            else if (isSlackConnectorSyncTypeEnabled) sourceType = resource.connectorSyncType === 'federated' ? (0, $9d9t8.FEDERATED_CONNECTOR_SOURCE) : (0, $9d9t8.FULL_CONNECTOR_SOURCE);
            else if (staticConfig.isFederated) sourceType = (0, $9d9t8.FEDERATED_CONNECTOR_SOURCE);
            else sourceType = (0, $9d9t8.FULL_CONNECTOR_SOURCE);
            connectorSourceMap.set(providerId, (connectorSourceMap.get(providerId) || new Set()).add(sourceType));
            const existingConfig = thirdPartyConfigsWithAPIResponse[productKey];
            const isExistingConfigFullConnectorSource = existingConfig?.connectorSources?.includes((0, $9d9t8.FULL_CONNECTOR_SOURCE)) || false;
            const outboundAuthUrl = isFederatedNoOAuthConnector ? '' : isExistingConfigFullConnectorSource && existingConfig?.outboundAuthUrl ? existingConfig.outboundAuthUrl : resource.outboundAuthUrl;
            const userNeedsOAuth = isFederatedNoOAuthConnector ? false : isExistingConfigFullConnectorSource && existingConfig ? existingConfig.userNeedsOAuth : !resource.isUserOAuthed;
            config = {
                ...staticConfig,
                outboundAuthUrl: outboundAuthUrl,
                userNeedsOAuth: userNeedsOAuth,
                providerId: providerId,
                datasourceId: datasourceId,
                connectionId: resource.connectionId,
                workspaceName: resource.workspaceName,
                workspaceUrl: resource.workspaceUrl,
                connectorSources: Array.from(connectorSourceMap.get(providerId) || []),
                impersonationEnabled: resource.isImpersonationAuthEnabled,
                connectorCreatedAt: resource.connectorCreatedAt
            };
            const datasourceList = [];
            // Add the main config without the nested datasources
            // eslint-disable-next-line no-unused-vars
            const { datasources: datasources, ...configWithoutDatasources } = config;
            configWithoutDatasources.datasourceId = resource.datasourceId;
            configWithoutDatasources.connectionId = resource.connectionId;
            // TODO: Leave config level logic at the root of the datasource itself and datasource specific logic in the datasources -> https://hello.jira.atlassian.cloud/browse/DCCNT-1386
            const datasource = {
                ...configWithoutDatasources,
                ...resource,
                outboundAuthUrl: isFederatedNoOAuthConnector ? '' : resource.outboundAuthUrl,
                userNeedsOAuth: isFederatedNoOAuthConnector ? false : !resource.isUserOAuthed,
                integrationAri: resource.integrationId || configWithoutDatasources.integrationAri
            };
            datasourceList.push(datasource);
            // Add third-party configs, also without the nested datasources
            const extraDatasources = thirdPartyConfigsWithAPIResponse[productKey]?.datasources || [];
            const cleanedExtraDatasources = extraDatasources.map(// eslint-disable-next-line no-unused-vars
            ({ datasources: datasources, ...configWithoutDatasources })=>configWithoutDatasources);
            datasourceList.push(...cleanedExtraDatasources);
            // Assign the cleaned datasourceList back to the main config
            config.datasources = datasourceList;
            thirdPartyConfigsWithAPIResponse[productKey] = config;
        }
    });
    // Filter product keys to only include valid ones.
    // Note: Only filter hardcoded product keys, Forge connectors use their own type as product key
    const filteredProductKeys = productKeys.filter((productKey)=>{
        if ((0, $9d9t8.isForgeConnectorProductKey)(productKey)) return true; // Forge connectors are always valid
        // For hardcoded 3P connectors, check if they're in allProductKeys
        return (0, $b4tvS.getAllProductKeys)().includes(productKey);
    });
    // Deduplicate product keys.
    // Multiple raw resources can map to the same product key (e.g. smartlinks-connector-gdrive
    // and google-drive-connector both map to 'drive'). While thirdPartyConfigs is an object
    // and naturally deduplicates, productKeys is an array that accumulates duplicates.
    // Without dedup, SSR produces different query variables than SPA (which accidentally
    // deduplicates via buildProducts in the bootstrap store's onUpdate handler).
    const deduplicatedProductKeys = [
        ...new Set(filteredProductKeys)
    ];
    return {
        productKeys: deduplicatedProductKeys,
        thirdPartyConfigs: thirdPartyConfigsWithAPIResponse
    };
};


const $bed1ea961f397265$export$fc6c3173f0bc0482 = ({ configuration: configuration })=>{
    if (configuration.firstPartyProducts) {
        const firstPartyProducts = configuration.firstPartyProducts.map((product)=>product.name);
        const accessibleNouns = firstPartyProducts.filter((product)=>product in (0, $4EMbH.nouns));
        return accessibleNouns;
    } else return [];
};
const $bed1ea961f397265$export$b38c0215344366f7 = ({ configuration: configuration, primaryProduct: primaryProduct, cloudId: cloudId })=>{
    let accessibleProducts = [];
    // TODO: QS-9614 Stop having to convert back to legacy 1P/3P config types
    const { thirdPartyConfig: thirdPartyConfig } = (0, $de054ade02a2d419$export$160fbca21b53d78a)(configuration, cloudId);
    // Add first party products to the array (deduplicated — multiple resource ARIs
    // can map to the same product key, e.g. bitbucket::site and bitbucket::workspace)
    if (configuration.firstPartyProducts) {
        const knownProductKeys = (0, $b4tvS.getAllProductKeys)();
        const firstPartyProducts = [
            ...new Set(configuration.firstPartyProducts.map((product)=>product.name).filter((product)=>knownProductKeys.includes(product)))
        ];
        accessibleProducts.push(...firstPartyProducts);
    }
    // Add Atlas to the array if there is more than one accessible noun
    const accessibleNouns = $bed1ea961f397265$export$fc6c3173f0bc0482({
        configuration: configuration,
        primaryProduct: primaryProduct,
        cloudId: cloudId
    });
    if (accessibleNouns.length > 1) accessibleProducts.push((0, $b4tvS.ProductKeys).Atlas);
    // Add third party products to the array
    if (configuration?.siteMetadata?.isRovoEnabled) {
        const { productKeys: thirdPartyProductKeys } = (0, $d6310552730441ce$export$4cb8ef4a677c563c)(thirdPartyConfig);
        accessibleProducts.push(...thirdPartyProductKeys);
    }
    // Always ensure the primary product is in the list, even if the config
    // response doesn't include it (e.g. resources only contain other products).
    if (!accessibleProducts.includes(primaryProduct)) accessibleProducts.unshift(primaryProduct);
    return accessibleProducts;
};
const $bed1ea961f397265$export$c635d3296555e2da = ({ configuration: configuration })=>{
    if (configuration?.siteMetadata?.productInfo?.length) {
        const entries = configuration.siteMetadata.productInfo.reduce((acc, product)=>{
            if (product.name) {
                const dataRegion = Array.isArray(product.dataRegion) ? product.dataRegion : typeof product.dataRegion === 'string' ? [
                    product.dataRegion
                ] : [];
                acc.push([
                    product.name,
                    dataRegion
                ]);
            }
            return acc;
        }, []);
        return Object.fromEntries(entries);
    } else return undefined;
};
const $bed1ea961f397265$export$53e066a63a960439 = ({ configuration: configuration })=>{
    const productEdition = configuration?.siteMetadata?.productEdition;
    if (typeof productEdition === 'string' && productEdition) return {
        confluence: productEdition
    };
    else return undefined;
};
const $bed1ea961f397265$export$37755e2ec7a40bc1 = ({ configuration: configuration, cloudId: cloudId })=>{
    if (configuration?.siteMetadata?.isRovoEnabled) // TODO: QS-9614 Stop having to convert back to legacy 1P/3P config types
    return (0, $d6310552730441ce$export$4cb8ef4a677c563c)((0, $de054ade02a2d419$export$160fbca21b53d78a)(configuration, cloudId).thirdPartyConfig).thirdPartyConfigs;
    else return {};
};
const $bed1ea961f397265$export$5a5f668a90736418 = (args)=>{
    const { configuration: configuration } = args;
    const accessibleProducts = $bed1ea961f397265$export$b38c0215344366f7(args);
    return {
        accessibleNouns: $bed1ea961f397265$export$fc6c3173f0bc0482(args),
        accessibleProducts: accessibleProducts,
        intercomHmac: configuration?.intercomHmac ?? undefined,
        isJiraIssueIndexed: Boolean(configuration?.siteMetadata?.isJiraIssueIndexed),
        isRovoEnabled: Boolean(configuration?.siteMetadata?.isRovoEnabled),
        productDataRegions: $bed1ea961f397265$export$c635d3296555e2da(args),
        productEdition: $bed1ea961f397265$export$53e066a63a960439(args),
        rovoFeatures: undefined,
        thirdPartyConfigs: $bed1ea961f397265$export$37755e2ec7a40bc1(args),
        supportedAccessibleProducts: (0, $1ikWy.getAccessibleProducts)({
            supportedProducts: (0, $b4tvS.getAllProductKeys)(),
            accessibleProducts: accessibleProducts
        })
    };
};



const $79c4d57fc1792dc7$var$EXTRACT_PRODUCT = /ari:cloud:(.*)?::/;
const $79c4d57fc1792dc7$var$EMPTY_RESPONSE = [];
const $79c4d57fc1792dc7$export$2b0ac18f7cd43e19 = (props)=>{
    // These return the same type and are like for like replacements, this is the easiest way to safely FG without generating extra network calls.
    /* eslint-disable react-hooks/rules-of-hooks */ return (0, $dh538.fg)('rovo_fps_use_rovo_config') ? $79c4d57fc1792dc7$export$d8e38f995daf9dc5(props) : $79c4d57fc1792dc7$export$757ae11853c85282(props);
/* eslint-enable react-hooks/rules-of-hooks */ };
const $79c4d57fc1792dc7$export$757ae11853c85282 = ({ cloudId: cloudIdProp, configFetchAbsoluteUrl: configFetchAbsoluteUrl, aggregatorHostName: aggregatorHostName, userId: userId, primaryProduct: primaryProduct, aggAbsoluteUrl: aggAbsoluteUrl, multiSiteSearchInRovo: multiSiteSearchInRovo, experience: experience, activationId: activationId, preloadDataProvider: preloadDataProvider })=>{
    const supportedProducts = (0, $1yEFx.useProductConfigs)();
    // Unnecessary, should be removed to save react cycles
    const [firstPartyResponse, setFirstPartyResponse] = (0, $42omo.useState)();
    const [isConfigLoaded, setIsConfigLoaded] = (0, $42omo.useState)(false);
    // Unnecessary, should be removed to save react cycles
    const [combinedThirdPartyResponse, setCombinedThirdPartyResponse] = (0, $42omo.useState)({});
    // Rovo Multiple Site Search
    const [linkedCloudARIs, setLinkedCloudARIs] = (0, $42omo.useState)(undefined);
    // Combined Config Response
    const [combinedConfigResponse, setCombinedConfigResponse] = (0, $42omo.useState)();
    // Unnecessary, should be removed to save react cycles
    const [accessibleProductsConfig, setAccessibleProductsConfig] = (0, $42omo.useState)({
        nouns: []
    });
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)({
        experience: experience
    });
    const [searchSessionId] = (0, $j4ply.useSearchSessionId)();
    const logException = (0, $f8oYd.useLogException)();
    const firstCloudId = (0, $42omo.useMemo)(()=>{
        if (!cloudIdProp && firstPartyResponse) return (0, $46834f5e82f1cd55$export$c1871fdf674a03c4)(firstPartyResponse);
        return '';
    }, [
        firstPartyResponse,
        cloudIdProp
    ]);
    const thirdPartyResponse = combinedThirdPartyResponse;
    const atlAttributionHeaders = (0, $42omo.useMemo)(()=>(0, $jwO5V.buildAtlAttributionHeaders)({
            cloudId: cloudIdProp,
            activationId: activationId,
            product: primaryProduct
        }), [
        cloudIdProp,
        activationId,
        primaryProduct
    ]);
    // Rovo Multiple Site Search - Store linked site ARIs in state
    (0, $42omo.useEffect)(()=>{
        const cloudId = cloudIdProp || firstCloudId;
        if (cloudId && multiSiteSearchInRovo) (0, $johDC.searchLinkedSitesQuery)({
            variables: {
                id: `ari:cloud:confluence::site/${cloudId}`
            },
            aggAbsoluteUrl: aggAbsoluteUrl,
            headers: atlAttributionHeaders
        }).then((response)=>{
            const edges = response?.data?.collabContext_workspaceIsConnectedToWorkspace?.edges ?? [];
            const linkedARIs = edges.map((edge)=>edge.node.id);
            // Move current cloudId to index 0 if it exists and isn't already there
            // This is a temporary solution for multiple site search in rovo with correct CloudIdARIs sequence
            const currentCloudIdARI = `ari:cloud:confluence::site/${cloudId}`;
            const currentIndex = linkedARIs.findIndex((ari)=>ari === currentCloudIdARI);
            if (currentIndex > 0) {
                // Remove from current position and add to beginning
                linkedARIs.splice(currentIndex, 1);
                linkedARIs.unshift(currentCloudIdARI);
            }
            setLinkedCloudARIs(linkedARIs);
        }).catch((error)=>{
            logException(error);
        });
    }, [
        cloudIdProp,
        firstCloudId,
        multiSiteSearchInRovo,
        logException,
        aggAbsoluteUrl,
        atlAttributionHeaders
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!firstPartyResponse) {
            if (!cloudIdProp) return;
            if (combinedThirdPartyResponse.productKeys) return;
            /**
       * Combined config caching strategy shared across both:
       * - network fetch path (`getCombinedSearchConfig`)
       * - SSR-preloaded network seed path (`seedCombinedConfigCacheEntry`)
       *
       * Strategy:
       * - refresh only when cached data is expired
       * - return cached value even if expired
       */ const combinedConfigTTL = 60000; // 1 minute
            const fetchCombinedConfig = ()=>{
                const uxTaskId = crypto.randomUUID();
                const taskStartAt = performance.now();
                const baseUXVitalStatsParams = {
                    searchSessionId: searchSessionId,
                    taskId: uxTaskId,
                    task: (0, $31eSD.TASK_NAMES).SEARCH_PAGE_COMBINED_CONFIG_UX
                };
                // DegradedDependency may not be visible to the end-user due to request caching. This is a health metric for our BE
                const degradationCallback = (reason)=>{
                    fireAnalyticsEvent((0, $dmTG5.onDegradedDependency)({
                        dependency: 'search-combined-config',
                        searchSessionId: searchSessionId,
                        reason: reason,
                        source: (0, $6yNqK.EVENT_SOURCE)
                    }));
                };
                const cacheAnalyticsCallback = async (state)=>{
                    fireAnalyticsEvent((0, $3htW4.onRequestCacheAccess)({
                        requestName: 'search-combined-config',
                        searchSessionId: searchSessionId,
                        cacheHit: state.hit,
                        refreshTriggered: state.refreshTriggered,
                        source: (0, $6yNqK.EVENT_SOURCE)
                    }));
                };
                // Create network callbacks for tracking network requests
                const configNetworkTaskId = crypto.randomUUID();
                const networkCallbacks = (0, $lGfXC.createVitalStatsNetworkCallbacks)(configNetworkTaskId, (0, $31eSD.TASK_NAMES).SEARCH_PAGE_COMBINED_CONFIG_NETWORK, searchSessionId, fireAnalyticsEvent, taskStartAt, {
                    uxTaskId: uxTaskId
                });
                const searchConfigParams = {
                    cloudId: cloudIdProp,
                    userId: userId,
                    aggAbsoluteUrl: aggAbsoluteUrl,
                    degradationCallback: degradationCallback,
                    cacheAnalyticsCallback: cacheAnalyticsCallback,
                    expiration: combinedConfigTTL,
                    returnExpired: true,
                    onlyRefreshIfExpired: true,
                    networkCallbacks: networkCallbacks,
                    headers: atlAttributionHeaders
                };
                // Fire task start for UX tracking
                fireAnalyticsEvent((0, $bQSQw.onTaskStart)(baseUXVitalStatsParams));
                (0, $7GE7t.getCombinedSearchConfig)(searchConfigParams).then((configuration)=>{
                    setCombinedConfigResponse(configuration);
                    const { firstPartyConfig: firstPartyConfig, thirdPartyConfig: thirdPartyConfig } = (0, $de054ade02a2d419$export$160fbca21b53d78a)(configuration, cloudIdProp);
                    setFirstPartyResponse(firstPartyConfig);
                    setCombinedThirdPartyResponse((0, $d6310552730441ce$export$4cb8ef4a677c563c)(thirdPartyConfig));
                    // Fire user experience metric - user got data (success from UX perspective)
                    fireAnalyticsEvent((0, $bQSQw.onTaskSuccess)({
                        ...baseUXVitalStatsParams,
                        moreContext: {
                            timeTaken: performance.now() - taskStartAt
                        }
                    }));
                }).catch((error)=>{
                    logException(error);
                    // FailedDependency is visible to the end-user. This is a health metric for our UX
                    fireAnalyticsEvent((0, $cFN1h.onFailedDependency)({
                        dependency: 'search-combined-config',
                        searchSessionId: searchSessionId,
                        source: (0, $6yNqK.EVENT_SOURCE)
                    }));
                    // Fire user experience metric - user did not get data (failure from UX perspective)
                    fireAnalyticsEvent((0, $bQSQw.onTaskFail)({
                        ...baseUXVitalStatsParams,
                        moreContext: {
                            error: error.name,
                            timeTaken: performance.now() - taskStartAt
                        }
                    }));
                    setFirstPartyResponse({
                        resources: [],
                        intercomHmac: '',
                        siteMetadata: []
                    });
                    setCombinedThirdPartyResponse({
                        productKeys: $79c4d57fc1792dc7$var$EMPTY_RESPONSE,
                        thirdPartyConfigs: {}
                    });
                });
            };
            // We skip trying to access the config from the preload provider if
            // the preload came from Quick Find. The reason for this is that the
            // combined config call will have already been cached in memory and
            // there's no reason to pipe it through the preload provider.
            let isPreloadFromQuickFind = false;
            try {
                const preloadedSearch = preloadDataProvider?.getPreloadedSearch({
                    cloudId: cloudIdProp
                });
                isPreloadFromQuickFind = Boolean(preloadedSearch && preloadedSearch.source === 'quick-find');
            } catch  {
            // Reading the preload provider should never throw, but be defensive
            // — a bad lookup must not block config loading.
            }
            if (preloadDataProvider && !isPreloadFromQuickFind) {
                try {
                    const preloadedSearch = preloadDataProvider.getPreloadedSearch({
                        cloudId: cloudIdProp
                    });
                    if (preloadedSearch && preloadedSearch.config) {
                        const preloadUxTaskId = crypto.randomUUID();
                        const preloadTaskStartAt = performance.now();
                        const preloadMoreContext = {
                            isSSREvent: true,
                            isConfigFromCache: Boolean(preloadedSearch.isConfigFromCache)
                        };
                        const preloadBaseUXVitalStatsParams = {
                            searchSessionId: searchSessionId,
                            taskId: preloadUxTaskId,
                            task: (0, $31eSD.TASK_NAMES).SEARCH_PAGE_COMBINED_CONFIG_UX,
                            moreContext: preloadMoreContext
                        };
                        fireAnalyticsEvent((0, $bQSQw.onTaskStart)(preloadBaseUXVitalStatsParams));
                        try {
                            setCombinedConfigResponse(preloadedSearch.config);
                            const { firstPartyConfig: firstPartyConfig, thirdPartyConfig: thirdPartyConfig } = (0, $de054ade02a2d419$export$160fbca21b53d78a)(preloadedSearch.config, cloudIdProp);
                            setFirstPartyResponse(firstPartyConfig);
                            setCombinedThirdPartyResponse((0, $d6310552730441ce$export$4cb8ef4a677c563c)(thirdPartyConfig));
                            if (!preloadedSearch.isConfigFromCache) (0, $7GE7t.seedCombinedConfigCacheEntry)({
                                cloudId: cloudIdProp,
                                userId: userId,
                                config: preloadedSearch.config,
                                expiration: combinedConfigTTL
                            }).catch((seedError)=>{
                                logException(seedError);
                            });
                            fireAnalyticsEvent((0, $bQSQw.onTaskSuccess)({
                                ...preloadBaseUXVitalStatsParams,
                                moreContext: {
                                    ...preloadMoreContext,
                                    timeTaken: performance.now() - preloadTaskStartAt
                                }
                            }));
                            if (preloadedSearch.isConfigFromCache) // Preload gives immediate UI data, but we still run the normal combined-config
                            // path so cache TTL rules can trigger a network refresh when the entry is expired.
                            fetchCombinedConfig();
                            return; // Code smell, code is poorly structured, difficult to glean logic
                        } catch (error) {
                            logException(error);
                            fireAnalyticsEvent((0, $bQSQw.onTaskFail)({
                                ...preloadBaseUXVitalStatsParams,
                                moreContext: {
                                    ...preloadMoreContext,
                                    error: error instanceof Error ? error.name : 'unknown',
                                    timeTaken: performance.now() - preloadTaskStartAt
                                }
                            }));
                            fetchCombinedConfig();
                            return; // Code smell, code is poorly structured, difficult to glean logic
                        }
                    }
                    if (preloadedSearch && !preloadedSearch.config) fireAnalyticsEvent((0, $cFN1h.onFailedDependency)({
                        dependency: 'search-config-ssr',
                        searchSessionId: searchSessionId,
                        source: (0, $6yNqK.EVENT_SOURCE),
                        moreContext: {
                            cacheFailReason: preloadedSearch.cacheFailReason ?? 'none',
                            configFailReason: preloadedSearch.configFailReason ?? 'none',
                            preloadPayloadWithoutConfig: true
                        }
                    }));
                    fetchCombinedConfig();
                } catch (error) {
                    logException(error);
                    fetchCombinedConfig();
                }
                return;
            }
            fetchCombinedConfig();
        }
    }, [
        firstPartyResponse,
        combinedThirdPartyResponse.productKeys,
        cloudIdProp,
        userId,
        aggAbsoluteUrl,
        logException,
        fireAnalyticsEvent,
        searchSessionId,
        atlAttributionHeaders,
        preloadDataProvider
    ]);
    (0, $42omo.useEffect)(()=>{
        if (thirdPartyResponse.productKeys && firstPartyResponse && !accessibleProductsConfig.products) {
            let allAccessibleProducts = [];
            const firstPartyProducts = [
                ...new Set(firstPartyResponse.resources.flatMap((resource)=>{
                    const { id: id } = resource;
                    const match = id.match($79c4d57fc1792dc7$var$EXTRACT_PRODUCT);
                    if (match && match.length >= 2 && match[1] in supportedProducts) return [
                        match[1]
                    ];
                    return [];
                }))
            ];
            if (firstPartyProducts.length === 0 && primaryProduct) // Use the primary product if the 1P Search Config request fails
            allAccessibleProducts.push(primaryProduct);
            else allAccessibleProducts.push(...firstPartyProducts);
            // Always ensure the primary product is in the list, even if the config
            // response doesn't include it (e.g. resources only contain other products).
            // This mirrors the error fallback behavior where the primary product is
            // always available so users can search within their hosting product.
            if (primaryProduct && !allAccessibleProducts.includes(primaryProduct)) allAccessibleProducts.unshift(primaryProduct);
            // Goal and Project nouns are now returned via the first party product list in the combined config response.
            const accessibleNouns = firstPartyResponse.resources.flatMap((resource)=>{
                const { id: id } = resource;
                const match = id.match($79c4d57fc1792dc7$var$EXTRACT_PRODUCT);
                if (match && match.length >= 2 && match[1] in (0, $4EMbH.nouns)) return [
                    match[1]
                ];
                return [];
            });
            // If nouns are available we also need to add Townsquare to the list of accessible products.
            // This way Projects will be fetched by default when no filters are selected.
            if (accessibleNouns.length > 0) allAccessibleProducts.push((0, $b4tvS.ProductKeys).Atlas);
            // with combined config, bitbucket is handled in the BE
            // Allow 3P products only if a user has Rovo enabled.
            // Long-term it won't be needed if the 3p-configuration check ensures Rovo eligibility.
            // See https://hello.atlassian.net/wiki/spaces/SEARCH/pages/4469899124.
            const doesUserHaveRovo = (0, $46834f5e82f1cd55$export$243c13f4da40a98e)(firstPartyResponse, cloudIdProp);
            if (doesUserHaveRovo) {
                const thirdPartyProductKeys = thirdPartyResponse.productKeys || [];
                allAccessibleProducts.push(...thirdPartyProductKeys);
                setAccessibleProductsConfig({
                    products: allAccessibleProducts,
                    nouns: accessibleNouns,
                    thirdPartyConfigs: thirdPartyResponse.thirdPartyConfigs
                });
            } else setAccessibleProductsConfig({
                products: allAccessibleProducts,
                nouns: accessibleNouns,
                thirdPartyConfigs: {}
            });
            setIsConfigLoaded(true);
        }
    }, [
        thirdPartyResponse,
        firstPartyResponse,
        setAccessibleProductsConfig,
        primaryProduct,
        fireAnalyticsEvent,
        logException,
        cloudIdProp,
        accessibleProductsConfig.products,
        supportedProducts
    ]);
    const accessibleProducts = accessibleProductsConfig.products;
    const parsedConfigFromNewCombinedConfigParser = (0, $42omo.useMemo)(()=>{
        if (primaryProduct && cloudIdProp && combinedConfigResponse) {
            const parsedCombinedConfig = (0, $bed1ea961f397265$export$5a5f668a90736418)({
                configuration: combinedConfigResponse,
                primaryProduct: primaryProduct,
                cloudId: cloudIdProp
            });
            return {
                ...parsedCombinedConfig,
                firstCloudId: '',
                isConfigLoaded: // cloudId must always exist when using the combined endpoint, hence we don't infer one
                isConfigLoaded,
                linkedCloudARIs: linkedCloudARIs,
                onOAuthSuccess: undefined
            };
        }
        return null;
    }, [
        primaryProduct,
        cloudIdProp,
        combinedConfigResponse,
        isConfigLoaded,
        linkedCloudARIs
    ]);
    if (parsedConfigFromNewCombinedConfigParser) return parsedConfigFromNewCombinedConfigParser;
    return {
        accessibleProducts: accessibleProducts,
        accessibleNouns: accessibleProductsConfig.nouns,
        thirdPartyConfigs: accessibleProductsConfig.thirdPartyConfigs,
        firstCloudId: firstCloudId,
        intercomHmac: firstPartyResponse?.intercomHmac,
        isRovoEnabled: (0, $46834f5e82f1cd55$export$243c13f4da40a98e)(firstPartyResponse, cloudIdProp),
        isJiraIssueIndexed: (0, $46834f5e82f1cd55$export$37c9c6a3ae5f363c)(firstPartyResponse, cloudIdProp),
        productEdition: (0, $46834f5e82f1cd55$export$53e066a63a960439)(firstPartyResponse, cloudIdProp),
        productDataRegions: (0, $46834f5e82f1cd55$export$c635d3296555e2da)(firstPartyResponse, cloudIdProp),
        rovoFeatures: (0, $46834f5e82f1cd55$export$2a1c0662041ee0a3)(firstPartyResponse, cloudIdProp),
        isConfigLoaded: isConfigLoaded,
        linkedCloudARIs: linkedCloudARIs,
        onOAuthSuccess: undefined
    };
};
const $79c4d57fc1792dc7$export$d8e38f995daf9dc5 = ({ cloudId: cloudId, primaryProduct: primaryProduct, aggAbsoluteUrl: aggAbsoluteUrl, multiSiteSearchInRovo: multiSiteSearchInRovo, preloadDataProvider: preloadDataProvider })=>{
    const rovoConfig = (0, $8yIwZ.useRovoConfig)({
        cloudId: cloudId,
        aggAbsoluteUrl: aggAbsoluteUrl,
        multiSiteSearchInRovo: multiSiteSearchInRovo,
        // `SearchPreloadDataProvider` (search-page) is a structural
        // superset of `RovoConfigPreloadProvider`
        // (rovo-connectors-config). Both have the same
        // `getPreloadedSearch` / `clearPreloadedSearch` contract; the
        // search-page provider just exposes more fields on
        // `SearchPreloadData` than the narrow `RovoConfigPreloadData`
        // type references.
        preloadDataProvider: preloadDataProvider,
        shouldBypassPreloadProvider: (preloaded)=>preloaded?.source === 'quick-find',
        onForgeConnectorTypeMapping: (0, $1xk5k.registerForgeConnectorTypeMapping)
    });
    return (0, $42omo.useMemo)(()=>{
        const { combinedConfigResponse: _ignored, accessibleProducts: accessibleProducts, ...rest } = rovoConfig;
        const list = accessibleProducts ?? [];
        /**
     * Primary product fallback logic:
     * - If `primaryProduct` is not set or config has not loaded, do nothing (return the list as-is, even if empty).
     * - Otherwise, ensure the primary product is in the list (add it if missing).
     */ if (!primaryProduct || !rest.isConfigLoaded) return {
            ...rest,
            accessibleProducts: accessibleProducts
        };
        if (list.includes(primaryProduct)) return {
            ...rest,
            accessibleProducts: list
        };
        return {
            ...rest,
            accessibleProducts: [
                primaryProduct,
                ...list
            ]
        };
    }, [
        rovoConfig,
        primaryProduct
    ]);
};






var $lgPOO = parcelRequire("lgPOO");





var $gSaNw = parcelRequire("gSaNw");

const $d178f4c20cce9572$export$8a525a626086c807 = ({ children: children, experience: experience = (0, $9rRKJ.SearchExperience).SEARCH_PAGE, ...props })=>{
    const { cloudId: cloudId, configFetchAbsoluteUrl: configFetchAbsoluteUrl, user: user, primaryProduct: primaryProduct, primarySubProduct: primarySubProduct, aggAbsoluteUrl: aggAbsoluteUrl, SAINHostName: SAINHostName, aggregatorHostName: aggregatorHostName, preloadDataProvider: preloadDataProvider, orgId: orgId, analyticsAttributes: analyticsAttributes, products: products, queryParams: queryParams, features: features, searchSessionId: searchSessionId, callbacks: callbacks, experimentLayers: experimentLayers, hasEditOrViewPlanPermission: hasEditOrViewPlanPermission } = props;
    const onError = (0, $f8oYd.useLogException)();
    const bootstrapProviderExp = (0, $gSaNw.serveBootstrapProviderExp)();
    const smartLinkUsage = (0, $eO6NY.useFetchSmartLinkUsage)(experience, cloudId);
    // Under rovo-search-remove-rss-bootstrap-fg, experimentConfig is computed in StaticContextProvider
    // via getExperimentConfig. We still call useExperimentConfig unconditionally (rules of hooks) but don't
    // pass the result through initialProps on the FG-on path.
    // Keep in sync with: bootstrap-context-provider/static-context-provider/index.tsx
    const experimentConfig = (0, $gkXKl.useExperimentConfig)({
        primaryProduct: primaryProduct,
        experimentLayers: experimentLayers ?? [],
        sideBySideExperiment: features?.sideBySide?.experiments,
        statsigLayer: undefined,
        onError: onError
    });
    // Compute multiSiteSearchInRovo independently for useFetchConfig.
    // Under FG-on, we avoid depending on experimentConfig for this value since experimentConfig
    // will be owned by StaticContextProvider. This direct Statsig call is pure and side-effect-free.
    const multiSiteSearchInRovo = (0, $gSaNw.serveBootstrapProviderExp)() ? (0, $iA4lt.getFrontendExperiment)({
        abTestId: 'multi_site_search_in_rovo',
        onError: onError
    }).cohort === 'test' : (0, $2OtFZ.getMultiSiteSearchInRovo)(experimentConfig);
    const { accessibleProducts: accessibleProducts, accessibleNouns: accessibleNouns, thirdPartyConfigs: thirdPartyConfigs, firstCloudId: firstCloudId, intercomHmac: intercomHmac, isRovoEnabled: isRovoEnabled, isJiraIssueIndexed: isJiraIssueIndexed, productEdition: productEdition, productDataRegions: productDataRegions, rovoFeatures: rovoFeatures, isConfigLoaded: isConfigLoaded, linkedCloudARIs: linkedCloudARIs, onOAuthSuccess: onOAuthSuccess } = (0, $79c4d57fc1792dc7$export$2b0ac18f7cd43e19)({
        cloudId: cloudId,
        configFetchAbsoluteUrl: configFetchAbsoluteUrl,
        aggregatorHostName: aggregatorHostName,
        preloadDataProvider: preloadDataProvider,
        userId: user?.id,
        primaryProduct: primaryProduct,
        aggAbsoluteUrl: aggAbsoluteUrl,
        multiSiteSearchInRovo: multiSiteSearchInRovo,
        experience: experience,
        activationId: analyticsAttributes?.activationId
    });
    // Must be called after useFetchConfig so we have the resolved thirdPartyConfigs
    // and productEdition. Reading these from the bootstrap store here would be a
    // circular read.
    const smartLinkUsageAndTopApps = (0, $8801996e88559d75$export$bb9929b0c526b28f)(experience, primaryProduct, cloudId, thirdPartyConfigs, productEdition);
    const allFilterExcludedProducts = (0, $42omo.useMemo)(()=>[
            (0, $b4tvS.ProductKeys).Trello,
            (0, $b4tvS.ProductKeys).Gmail,
            (0, $b4tvS.ProductKeys).OutlookMail
        ], []);
    const getInitialProps = (0, $42omo.useCallback)(()=>{
        let storeContainerInitialProps = {
            cloudId: cloudId ?? firstCloudId,
            aggAbsoluteUrl: aggAbsoluteUrl,
            SAINHostName: SAINHostName,
            aggregatorHostName: aggregatorHostName,
            user: user,
            primaryProduct: primaryProduct,
            primarySubProduct: primarySubProduct,
            orgId: orgId,
            analyticsAttributes: analyticsAttributes,
            features: features,
            // Under rovo-search-remove-rss-bootstrap-fg, experimentConfig is computed
            // in StaticContextProvider via getExperimentConfig instead of being passed through here.
            ...!(0, $gSaNw.serveBootstrapProviderExp)() && {
                experimentConfig: experimentConfig
            },
            experimentLayers: experimentLayers,
            intercomHmac: intercomHmac,
            isRovoEnabled: isRovoEnabled,
            isJiraIssueIndexed: isJiraIssueIndexed,
            isConfigLoaded: isConfigLoaded,
            // Under rovo-search-remove-rss-bootstrap-fg, getAccessibleProducts is computed
            // in StaticContextProvider instead of here. Pass raw products through.
            products: (0, $gSaNw.serveBootstrapProviderExp)() ? products : (0, $1ikWy.getAccessibleProducts)({
                supportedProducts: (0, $b4tvS.getAllProductKeys)(),
                products: products,
                accessibleProducts: accessibleProducts
            }),
            nouns: accessibleNouns,
            allFilterExcludedProducts: allFilterExcludedProducts,
            productEdition: productEdition,
            productDataRegions: productDataRegions,
            rovoFeatures: rovoFeatures,
            linkedCloudARIs: linkedCloudARIs,
            hasEditOrViewPlanPermission: hasEditOrViewPlanPermission,
            smartLinkUsage: smartLinkUsage,
            smartLinkUsageAndTopApps: smartLinkUsageAndTopApps
        };
        if (searchSessionId) storeContainerInitialProps.searchSessionId = searchSessionId;
        if (accessibleProducts) storeContainerInitialProps.thirdPartyConfigs = thirdPartyConfigs;
        return storeContainerInitialProps;
    }, [
        cloudId,
        firstCloudId,
        aggAbsoluteUrl,
        SAINHostName,
        aggregatorHostName,
        user,
        primaryProduct,
        primarySubProduct,
        orgId,
        analyticsAttributes,
        features,
        experimentConfig,
        intercomHmac,
        isRovoEnabled,
        isJiraIssueIndexed,
        isConfigLoaded,
        products,
        accessibleProducts,
        accessibleNouns,
        allFilterExcludedProducts,
        productEdition,
        productDataRegions,
        searchSessionId,
        thirdPartyConfigs,
        rovoFeatures,
        linkedCloudARIs,
        experimentLayers,
        hasEditOrViewPlanPermission,
        smartLinkUsage,
        smartLinkUsageAndTopApps
    ]);
    if (bootstrapProviderExp) {
        const initialProps = getInitialProps();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
            name: "bootstrap-context"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lgPOO.BootstrapContextProvider), {
            initialProps: initialProps,
            queryParams: queryParams,
            queryParamsCallback: callbacks?.updateQueryParameters,
            getSpaceIdsFromSpaceKeys: callbacks?.getSpaceIdsFromSpaceKeys,
            onSearchCompleted: callbacks?.onSearchCompleted,
            onOAuthSuccess: onOAuthSuccess,
            experience: experience,
            accessibleProducts: accessibleProducts
        }, children));
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
        name: "bootstrap-rss"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $j4ply.BootstrapStoreContainer), {
        initialProps: getInitialProps(),
        queryParams: queryParams,
        queryParamsCallback: callbacks?.updateQueryParameters,
        getSpaceIdsFromSpaceKeys: callbacks?.getSpaceIdsFromSpaceKeys,
        onSearchCompleted: callbacks?.onSearchCompleted,
        onOAuthSuccess: onOAuthSuccess
    }, children));
};


var $24d120d5a9177b55$export$2e2bcd8739ae039 = (0, $d178f4c20cce9572$export$8a525a626086c807);

});

parcelRegister("bHLTK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $j4ply = parcelRequire("j4ply");


var $ehGUC = parcelRequire("ehGUC");


var $djVCD = parcelRequire("djVCD");

const $4622611068a1c461$export$3776ece9f99ed2df = ({ children: children, experience: experience = 'search-page' })=>{
    const [shouldAutoSelectPrimaryProduct, setShouldAutoSelectPrimaryProduct] = (0, $42omo.useState)(true);
    const intl = (0, $aXWIB.useIntl)();
    const [queryParams] = (0, $j4ply.useQueryParams)();
    const [cloudId] = (0, $j4ply.useCloudId)();
    const [aggAbsoluteUrl] = (0, $j4ply.useAggAbsoluteUrl)();
    const [initialSpaceARIs] = (0, $j4ply.useInitialSpaceARIs)();
    const [user] = (0, $j4ply.useUser)();
    const products = (0, $j4ply.useAvailableProducts)();
    const [allFilterExcludedProducts] = (0, $j4ply.useAllFilterExcludedProducts)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [experimentConfig] = (0, $j4ply.useExperimentConfig)();
    const [productEdition] = (0, $j4ply.useProductEdition)();
    const [productDataRegions] = (0, $j4ply.useProductDataRegions)();
    const [thirdPartyConfigs] = (0, $j4ply.useThirdPartyConfigs)();
    const [orgId] = (0, $j4ply.useOrgId)();
    const [analyticsAttributes] = (0, $j4ply.useAnalyticsAttributes)();
    const setQueryParams = (0, $j4ply.useSetQueryParams)(queryParams);
    const applicationMode = (0, $j4ply.useApplicationMode)();
    const primaryProductToAutoSelect = (0, $j4ply.useAutoSelectPrimaryProduct)();
    const config = (0, $42omo.useMemo)(()=>({
            aggAbsoluteUrl: aggAbsoluteUrl,
            ari: '',
            cloudId: cloudId,
            experimentConfig: experimentConfig,
            initialSpaceARIs: initialSpaceARIs,
            // Default to an empty array so downstream `Array.isArray(config.contributorAccountIds)`
            // checks (in 3p Space / Content Under typeahead queries) succeed before any
            // contributor selection has been merged into the config by
            // loadInitialSelectFilterOptions / setSelectFilterLookupInput. The actions
            // downstream replace this with the live `allFiltersState.contributor.value` when a
            // contributor is selected.
            contributorAccountIds: [],
            intl: intl,
            productDataRegions: productDataRegions,
            productEdition: productEdition,
            userId: user?.id || '',
            product: queryParams?.product,
            primaryProduct: primaryProduct,
            orgId: orgId,
            thirdPartyConfigs: thirdPartyConfigs,
            activationId: analyticsAttributes?.activationId
        }), [
        aggAbsoluteUrl,
        cloudId,
        experimentConfig,
        initialSpaceARIs,
        intl,
        productDataRegions,
        productEdition,
        user?.id,
        queryParams?.product,
        primaryProduct,
        orgId,
        thirdPartyConfigs,
        analyticsAttributes?.activationId
    ]);
    const queryParamsInUse = (0, $42omo.useMemo)(()=>{
        const { lastModified_lt: _lastModified_lt, lastModified_gt: _lastModified_gt, ...queryParamsInUse } = queryParams;
        return queryParamsInUse;
    }, [
        queryParams
    ]);
    // primaryProductToAutoSelect will be set to the primary product if the user is in unified search
    // and no product is selected
    // This is to ensure that the primary product is selected by default for unified search
    (0, $42omo.useEffect)(()=>{
        if (products && products.length > 0) {
            if (shouldAutoSelectPrimaryProduct && primaryProductToAutoSelect) setQueryParams({
                ...queryParams,
                product: primaryProductToAutoSelect
            });
            setShouldAutoSelectPrimaryProduct(false);
        }
    }, [
        applicationMode,
        primaryProduct,
        primaryProductToAutoSelect,
        products,
        queryParams,
        setQueryParams,
        shouldAutoSelectPrimaryProduct
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $djVCD.SearchStoreContainer), {
        queryParams: queryParamsInUse,
        allFilters: (0, $ehGUC.allFilters),
        config: config,
        setQueryParams: setQueryParams,
        availableProducts: products,
        allFilterExcludedProducts: allFilterExcludedProducts,
        applicationMode: applicationMode,
        primaryProduct: primaryProduct,
        thirdPartyConfigs: thirdPartyConfigs,
        experience: experience
    }, children);
};
module.exports["SearchStoreProvider"] = $4622611068a1c461$export$3776ece9f99ed2df;

});

parcelRegister("ehGUC", function(module, exports) {
$parcel$export(module.exports, "assigneeFilter", () => (parcelRequire("5X4Ay")).filter);
$parcel$export(module.exports, "commentedByMeFilter", () => (parcelRequire("2a0ps")).filter);
$parcel$export(module.exports, "contributorFilter", () => (parcelRequire("aGXLL")).filter);
$parcel$export(module.exports, "projectFilter", () => (parcelRequire("gHwfH")).filter);
$parcel$export(module.exports, "spaceFilter", () => (parcelRequire("a97k3")).filter);
$parcel$export(module.exports, "watchedFilter", () => (parcelRequire("9DkM9")).filter);
$parcel$export(module.exports, "assetsSchemaFilter", () => (parcelRequire("lx1ar")).filter);
$parcel$export(module.exports, "assetsTypeFilter", () => (parcelRequire("iUihD")).filter);
$parcel$export(module.exports, "sortFilter", () => (parcelRequire("fJFyr")).filter);
$parcel$export(module.exports, "hasAttachmentFilter", () => (parcelRequire("lPWNq")).filter);
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $5iakG = parcelRequire("5iakG");


var $fw303 = parcelRequire("fw303");


var $k7ise = parcelRequire("k7ise");


var $lx1ar = parcelRequire("lx1ar");


var $iUihD = parcelRequire("iUihD");


var $5X4Ay = parcelRequire("5X4Ay");


var $5VnRb = parcelRequire("5VnRb");


var $F3Hv6 = parcelRequire("F3Hv6");


var $hHAPz = parcelRequire("hHAPz");


var $2a0ps = parcelRequire("2a0ps");


var $dQXZO = parcelRequire("dQXZO");


var $aGXLL = parcelRequire("aGXLL");


var $c5dmm = parcelRequire("c5dmm");


var $6jSbc = parcelRequire("6jSbc");


var $e7L4o = parcelRequire("e7L4o");


var $9HRbP = parcelRequire("9HRbP");


var $lPWNq = parcelRequire("lPWNq");


var $gwbWt = parcelRequire("gwbWt");


var $1uGSo = parcelRequire("1uGSo");


var $huubg = parcelRequire("huubg");


var $dFCIx = parcelRequire("dFCIx");


var $5ousX = parcelRequire("5ousX");


var $1sswv = parcelRequire("1sswv");


var $jqLa8 = parcelRequire("jqLa8");


var $fLju9 = parcelRequire("fLju9");


var $dXdDw = parcelRequire("dXdDw");


var $5eFo6 = parcelRequire("5eFo6");


var $aeffu = parcelRequire("aeffu");


var $gHwfH = parcelRequire("gHwfH");


var $3TPSi = parcelRequire("3TPSi");


var $f1JPm = parcelRequire("f1JPm");


var $dzNsR = parcelRequire("dzNsR");


var $720nW = parcelRequire("720nW");


var $iz3ta = parcelRequire("iz3ta");


var $fJFyr = parcelRequire("fJFyr");


var $a97k3 = parcelRequire("a97k3");


var $b6IhR = parcelRequire("b6IhR");


var $iaYRG = parcelRequire("iaYRG");


var $dUIpv = parcelRequire("dUIpv");


var $bF9JE = parcelRequire("bF9JE");


var $9DkM9 = parcelRequire("9DkM9");


var $3Q16G = parcelRequire("3Q16G");

const $7ad99be56c688d66$export$d8428ac7d93fb69a = Object.freeze({
    [(0, $1uGSo.filter).id]: (0, $1uGSo.filter),
    [(0, $aGXLL.filter).id]: (0, $aGXLL.filter),
    [(0, $a97k3.filter).id]: (0, $a97k3.filter),
    [(0, $9DkM9.filter).id]: (0, $9DkM9.filter),
    [(0, $bF9JE.filter).id]: (0, $bF9JE.filter),
    [(0, $5X4Ay.filter).id]: (0, $5X4Ay.filter),
    [(0, $f1JPm.filter).id]: (0, $f1JPm.filter),
    [(0, $2a0ps.filter).id]: (0, $2a0ps.filter),
    [(0, $gHwfH.filter).id]: (0, $gHwfH.filter),
    [(0, $5iakG.universalTypeFilterId)]: (0, $dUIpv.filter),
    [(0, $dQXZO.filter).id]: (0, $dQXZO.filter),
    [(0, $iaYRG.filter).id]: (0, $iaYRG.filter),
    [(0, $5ousX.filter).id]: (0, $5ousX.filter),
    [(0, $c5dmm.filter).id]: (0, $c5dmm.filter),
    [(0, $gwbWt.filter).id]: (0, $gwbWt.filter),
    [(0, $6jSbc.filter).id]: (0, $6jSbc.filter),
    [(0, $e7L4o.filter).id]: (0, $e7L4o.filter),
    [(0, $1sswv.filter).id]: (0, $1sswv.filter),
    [(0, $fw303.filter).id]: (0, $fw303.filter),
    [(0, $huubg.filter).id]: (0, $huubg.filter),
    [(0, $b6IhR.filter).id]: (0, $b6IhR.filter),
    [(0, $k7ise.filter).id]: (0, $k7ise.filter),
    [(0, $lx1ar.filter).id]: (0, $lx1ar.filter),
    [(0, $iUihD.filter).id]: (0, $iUihD.filter),
    [(0, $5eFo6.filter).id]: (0, $5eFo6.filter),
    [(0, $jqLa8.filter).id]: (0, $jqLa8.filter),
    [(0, $dXdDw.filter).id]: (0, $dXdDw.filter),
    [(0, $aeffu.filter).id]: (0, $aeffu.filter),
    [(0, $fLju9.filter).id]: (0, $fLju9.filter),
    [(0, $dFCIx.filter).id]: (0, $dFCIx.filter),
    [(0, $5VnRb.filter).id]: (0, $5VnRb.filter),
    [(0, $F3Hv6.filter).id]: (0, $F3Hv6.filter),
    [(0, $fJFyr.filter).id]: (0, $fJFyr.filter),
    [(0, $720nW.filter).id]: (0, $720nW.filter),
    [(0, $dzNsR.filter).id]: (0, $dzNsR.filter),
    [(0, $hHAPz.filter).id]: (0, $hHAPz.filter),
    [(0, $3TPSi.filter).id]: (0, $3TPSi.filter),
    [(0, $iz3ta.filter).id]: (0, $iz3ta.filter),
    [(0, $9HRbP.filter).id]: (0, $9HRbP.filter),
    [(0, $3Q16G.filter).id]: (0, $3Q16G.filter),
    [(0, $lPWNq.filter).id]: (0, $lPWNq.filter)
});
module.exports["allFilters"] = $7ad99be56c688d66$export$d8428ac7d93fb69a;

});

parcelRegister("lx1ar", function(module, exports) {

var $f6o22 = parcelRequire("f6o22");


var $jwO5V = parcelRequire("jwO5V");


var $lldrI = parcelRequire("lldrI");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $6Ea6j = parcelRequire("6Ea6j");

const $f0e9e4856ecf1749$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Assets
];
const $f0e9e4856ecf1749$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'assetsSchema',
    products: $f0e9e4856ecf1749$var$productKeys1P,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'assetsSchema',
        fetcher: async (queryParams, config)=>{
            const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const allSchemas = await (0, $lldrI.assetsSchemasQuery)(queryParams, headers);
            const hydratedSchemaOptions = allSchemas.data?.assets_schemasByIds?.map((schema)=>{
                return {
                    trackingKey: schema.id,
                    value: schema.id,
                    queryParamValue: schema.id,
                    label: schema.name || '',
                    product: config.product,
                    isSuggested: false,
                    isSelected: false
                };
            });
            return hydratedSchemaOptions ?? [];
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            const suggestedSchemas = await (0, $f6o22.searchAssetsSchemas)();
            const recommendedSchemaOptions = suggestedSchemas.map((schema)=>{
                return {
                    trackingKey: schema.ari,
                    value: schema.ari,
                    queryParamValue: schema.ari,
                    label: schema.name || '',
                    product: config.product,
                    isSuggested: true,
                    isSelected: false
                };
            });
            return recommendedSchemaOptions;
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            const resultSchemas = await (0, $f6o22.searchAssetsSchemas)(query);
            const searchSchemaOptions = resultSchemas.map((schema)=>{
                return {
                    trackingKey: schema.ari,
                    value: schema.ari,
                    queryParamValue: schema.ari,
                    label: schema.name || '',
                    product: config.product,
                    isSuggested: false,
                    isSelected: false
                };
            });
            return searchSchemaOptions;
        }
    },
    isSuggestedFilter: (primaryProduct)=>primaryProduct === (0, $b4tvS.ProductKeys).Assets
});
module.exports["filter"] = $f0e9e4856ecf1749$export$3dea766d36a8935f;

});

parcelRegister("f6o22", function(module, exports) {

var $dwp40 = parcelRequire("dwp40");


var $2qzBQ = parcelRequire("2qzBQ");


var $jnPv4 = parcelRequire("jnPv4");

const $d45fe597670d508d$export$3317731fce42efc4 = 'assets-workspace-id';
const { refreshOnAccessDecorator: $d45fe597670d508d$var$refreshOnAccessDecoratorAssets } = (0, $jnPv4.promiseCache)({
    name: $d45fe597670d508d$export$3317731fce42efc4,
    expiration: 86400000 // 24 hours
});
async function $d45fe597670d508d$export$7397855f2e1b36a6() {
    const url = '/rest/servicedesk/cmdb/latest/workspace';
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    };
    const key = (0, $2qzBQ.generateHash)($d45fe597670d508d$export$3317731fce42efc4);
    const supplier = ()=>(0, $dwp40.utils).requestService({
            url: url
        }, options);
    const response = await $d45fe597670d508d$var$refreshOnAccessDecoratorAssets({
        key: key.toString(),
        supplier: supplier,
        returnExpired: false,
        onlyRefreshIfExpired: true
    });
    const ids = response.results ?? [];
    return ids.length ? ids[0].id : null;
}
async function $d45fe597670d508d$export$54126e20e262ab6a(query = '', maxResults = 3) {
    const workspaceId = await $d45fe597670d508d$export$7397855f2e1b36a6();
    if (!workspaceId) // returning empty array as fallback
    return [];
    const url = `/gateway/api/jsm/assets/workspace/${workspaceId}/v1/objectschema/list?maxResults=${maxResults}&includeCounts=false${query ? `&query=${query}` : ''}`;
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        const responseData = await response.json();
        const schemas = responseData.values ?? [];
        const transformedSchemas = schemas.map((schema)=>({
                ...schema,
                schemaLabel: schema.name,
                ari: `ari:cloud:cmdb::schema/${workspaceId}/${schema.id}`
            }));
        return transformedSchemas;
    } catch (error) {
        // fire analytics event
        return [];
    }
}
async function $d45fe597670d508d$export$ba9ddace9845bd14(query = '', maxResults = 3) {
    const workspaceId = await $d45fe597670d508d$export$7397855f2e1b36a6();
    if (!workspaceId) // returning empty array as fallback
    return [];
    const url = `/gateway/api/jsm/assets/workspace/${workspaceId}/v1/objecttype/all/list?pageSize=${maxResults}${query ? `&filterBy=${query}` : ''}`;
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        const responseData = await response.json();
        const types = responseData.data ?? [];
        const transformedTypes = types.map((type)=>({
                ...type,
                ari: `ari:cloud:cmdb::type/${workspaceId}/${type.id}`
            }));
        return transformedTypes;
    } catch (error) {
        // fire analytics event
        return [];
    }
}
module.exports["searchAssetsSchemas"] = $d45fe597670d508d$export$54126e20e262ab6a;
module.exports["searchAssetsTypes"] = $d45fe597670d508d$export$ba9ddace9845bd14;

});

parcelRegister("lldrI", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $hw4j5 = parcelRequire("hw4j5");

const $4019b67a14efb803$var$GQL_ASSETS_SCHEMAS_NAME = 'SearchPageAssetsSchemasQuery';
const $4019b67a14efb803$var$assetsSchemasQueryString = `query ${$4019b67a14efb803$var$GQL_ASSETS_SCHEMAS_NAME}(
	$schemaARIs: [ID!]!) {
		assets_schemasByIds(ids: $schemaARIs) {
    		id
    		key
    		name
    		sequentialId @optIn(to: "AssetsApFields")
  		}
	}`;
const $4019b67a14efb803$export$2ab52cbd1429b72b = (0, $hw4j5.inMemoryCache)();
const $4019b67a14efb803$export$3c3ad61134eb56ad = async (schemaARIs, headers)=>{
    return $4019b67a14efb803$export$2ab52cbd1429b72b.inMemoryDecorator(`${schemaARIs}`, async ()=>{
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $4019b67a14efb803$var$assetsSchemasQueryString,
            variables: {
                schemaARIs: schemaARIs
            },
            headers: {
                'X-ExperimentalApi': 'AssetsSchemas',
                ...headers
            }
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["assetsSchemasQuery"] = $4019b67a14efb803$export$3c3ad61134eb56ad;

});

parcelRegister("iUihD", function(module, exports) {

var $f6o22 = parcelRequire("f6o22");


var $jwO5V = parcelRequire("jwO5V");


var $cDIp4 = parcelRequire("cDIp4");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $6Ea6j = parcelRequire("6Ea6j");

const $3d6dea92f1cbe7be$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Assets
];
const $3d6dea92f1cbe7be$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'assetsType',
    products: $3d6dea92f1cbe7be$var$productKeys1P,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'assetsType',
        fetcher: async (queryParams, config)=>{
            const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const allTypes = await (0, $cDIp4.assetsObjectTypesQuery)(queryParams, headers);
            const hydratedTypeOptions = allTypes.data?.assets_objectTypesByIds?.map((type)=>{
                return {
                    trackingKey: type.id,
                    value: type.id,
                    queryParamValue: type.id,
                    label: type.name || '',
                    product: config.product,
                    isSuggested: false,
                    isSelected: false,
                    avatarUrl: type.icon.url16,
                    metadata: {
                        schemaName: type.schema.name
                    }
                };
            });
            return hydratedTypeOptions ?? [];
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            const suggestedTypes = await (0, $f6o22.searchAssetsTypes)();
            const recommendedTypeOptions = suggestedTypes.map((type)=>{
                return {
                    trackingKey: type.ari,
                    value: type.ari,
                    queryParamValue: type.ari,
                    label: type.name || '',
                    product: config.product,
                    isSuggested: true,
                    isSelected: false,
                    avatarUrl: type.icon.url16,
                    metadata: {
                        schemaName: type.schemaLabel
                    }
                };
            });
            return recommendedTypeOptions;
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            const resultTypes = await (0, $f6o22.searchAssetsTypes)(query);
            const searchTypeOptions = resultTypes.map((type)=>{
                return {
                    trackingKey: type.ari,
                    value: type.ari,
                    queryParamValue: type.ari,
                    label: type.name || '',
                    product: config.product,
                    isSuggested: false,
                    isSelected: false,
                    avatarUrl: type.icon.url16,
                    metadata: {
                        schemaName: type.schemaLabel
                    }
                };
            });
            return searchTypeOptions;
        }
    },
    isSuggestedFilter: (primaryProduct)=>primaryProduct === (0, $b4tvS.ProductKeys).Assets
});
module.exports["filter"] = $3d6dea92f1cbe7be$export$3dea766d36a8935f;

});

parcelRegister("cDIp4", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $hw4j5 = parcelRequire("hw4j5");

const $12919923fb6e43fb$var$GQL_ASSETS_OBJECT_TYPES_NAME = 'SearchPageAssetsObjectTypesQuery';
const $12919923fb6e43fb$var$assetsObjectTypesQueryString = `query ${$12919923fb6e43fb$var$GQL_ASSETS_OBJECT_TYPES_NAME}(
	$objectTypeARIs: [ID!]!) {
		assets_objectTypesByIds(ids: $objectTypeARIs) {
    		id
    		name
    		sequentialId @optIn(to: "AssetsApFields")
    		icon {
      			url16
    		}
    		schema {
      			name
    		}
  		}
	}`;
const $12919923fb6e43fb$export$4b370fc8e83d008b = (0, $hw4j5.inMemoryCache)();
const $12919923fb6e43fb$export$b573ef4e7e3425c7 = async (objectTypeARIs, headers)=>{
    return $12919923fb6e43fb$export$4b370fc8e83d008b.inMemoryDecorator(`${objectTypeARIs}`, async ()=>{
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $12919923fb6e43fb$var$assetsObjectTypesQueryString,
            variables: {
                objectTypeARIs: objectTypeARIs
            },
            operationName: $12919923fb6e43fb$var$GQL_ASSETS_OBJECT_TYPES_NAME,
            headers: {
                'X-ExperimentalApi': 'AssetsObjectTypes',
                ...headers
            }
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["assetsObjectTypesQuery"] = $12919923fb6e43fb$export$b573ef4e7e3425c7;

});

parcelRegister("2CQZl", function(module, exports) {

var $5kTPO = parcelRequire("5kTPO");

const $807072fc846be7b2$export$83f72e15d115a0e7 = ({ query: query, userId: userId, cloudId: cloudId, productKey: productKey, maxNumberOfResults: maxNumberOfResults, intl: intl })=>{
    const requestParams = {
        context: {
            contextType: 'assignee',
            principalId: userId,
            productAttributes: {
                isEntitledConfluenceExternalCollaborator: true
            },
            productKey: productKey,
            siteId: cloudId
        },
        includeGroups: false,
        includeTeams: false,
        includeUsers: true,
        maxNumberOfResults: maxNumberOfResults,
        performSearchQueryOnly: false,
        query: query
    };
    return (0, $5kTPO.default)(requestParams, intl);
};
module.exports["getAssignees"] = $807072fc846be7b2$export$83f72e15d115a0e7;

});

parcelRegister("i8MOh", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $hw4j5 = parcelRequire("hw4j5");

const $00597ab6f62a5638$export$69a3209f1a06c04d = (0, $hw4j5.inMemoryCache)();
const $00597ab6f62a5638$var$GQL_OPERATION_NAME = 'SearchPageUserQuery';
const $00597ab6f62a5638$var$getUserQuery = ()=>`
query ${$00597ab6f62a5638$var$GQL_OPERATION_NAME}($accountId: ID!) {
  user(accountId: $accountId) {
    id
    accountId
    name
    picture
  }
}
`;
const $00597ab6f62a5638$export$25f4d46d5dabadfc = (accountId, headers)=>{
    return $00597ab6f62a5638$export$69a3209f1a06c04d.inMemoryDecorator(accountId, async ()=>{
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $00597ab6f62a5638$var$getUserQuery(),
            variables: {
                accountId: accountId
            },
            operationName: $00597ab6f62a5638$var$GQL_OPERATION_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
const $00597ab6f62a5638$export$c3d7afa7f49d431e = (0, $hw4j5.inMemoryCache)();
const $00597ab6f62a5638$var$GQL_USERS_OPERATION_NAME = 'SearchPageUsersQuery';
const $00597ab6f62a5638$var$getUsersQuery = ()=>`
query ${$00597ab6f62a5638$var$GQL_USERS_OPERATION_NAME}($accountIds: [ID!]!) {
  users(accountIds: $accountIds) {
    id
    name
    picture
    accountId
  }
}
`;
const $00597ab6f62a5638$export$ef7fb495aeba8901 = (accountIds, headers)=>{
    return $00597ab6f62a5638$export$c3d7afa7f49d431e.inMemoryDecorator(// TODO: >>>> Limit this to a max string length
    // TODO: Refactor so that it can cache per user id
    accountIds.join(','), async ()=>{
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $00597ab6f62a5638$var$getUsersQuery(),
            variables: {
                accountIds: accountIds
            },
            operationName: $00597ab6f62a5638$var$GQL_USERS_OPERATION_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["usersQuery"] = $00597ab6f62a5638$export$ef7fb495aeba8901;

});

parcelRegister("cxsgw", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $2qzBQ = parcelRequire("2qzBQ");


var $hw4j5 = parcelRequire("hw4j5");

const $647d8a1794bbb565$var$operationName = 'FPSConfluenceSmartUsersQuery';
const $647d8a1794bbb565$var$SmartsRecommendedUserQuery = `
query ${$647d8a1794bbb565$var$operationName}($userId: String!, $tenantId: String!, $maxNumberOfResults: Int!) {
  smarts {
    results: recommendedUser(
      recommendationsQuery: {
        context: {
          userId: $userId
          tenantId: $tenantId
          product: "confluence"
        },
        modelRequestParams: {
          caller: "full-page-search"
          experience: "CgUserNearbyUser"
        }
        requestingUserId: $userId
        maxNumberOfResults: $maxNumberOfResults
      }
    ) {
      id
      user {
        accountId
        name
        picture
      }
    }
  }
}
`;
const $647d8a1794bbb565$export$69a3209f1a06c04d = (0, $hw4j5.inMemoryCache)();
// Expire the cache if there are errors or edges are empty
const $647d8a1794bbb565$var$expireWhen = (result)=>{
    const { data: data, errors: errors } = result;
    if (!data || errors && errors.length > 0) return true;
    const { results: results } = data.smarts;
    return !results || results.length === 0;
};
const $647d8a1794bbb565$export$74adda2a74e06fa9 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>$647d8a1794bbb565$export$69a3209f1a06c04d.inMemoryDecorator((0, $2qzBQ.generateHashFromVariables)(variables), ()=>(0, $4qT1X.fetchAgg)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: $647d8a1794bbb565$var$SmartsRecommendedUserQuery,
            operationName: $647d8a1794bbb565$var$operationName,
            headers: headers
        }), $647d8a1794bbb565$var$expireWhen);
module.exports["smartsRecommendedUserQuery"] = $647d8a1794bbb565$export$74adda2a74e06fa9;

});

parcelRegister("jXNWU", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");

const $873f5aaeb784a6a1$export$c5dfc39e7764783c = 'searchThirdPartyFilterOptions';
const $873f5aaeb784a6a1$export$417982613a1b9ae2 = `
query ${$873f5aaeb784a6a1$export$c5dfc39e7764783c}($cloudId: ID!, $datasourceId: String!, $orgId: String) {
  search {
    configuration(cloudId: $cloudId) {
      thirdPartyFilterOptions(datasourceId: $datasourceId, orgId: $orgId) {
        filters {
          name
          values {
            name
            label
          }
        }
      }
    }
  }
}`;
const $873f5aaeb784a6a1$export$cbfaf396d242dba9 = ()=>$873f5aaeb784a6a1$export$417982613a1b9ae2;


const $f10b449f037fa26e$export$cd224500ea4a2de1 = async ({ cloudId: cloudId, datasourceId: datasourceId, orgId: orgId, aggAbsoluteUrl: aggAbsoluteUrl })=>{
    try {
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: (0, $873f5aaeb784a6a1$export$cbfaf396d242dba9)(),
            variables: {
                cloudId: cloudId,
                datasourceId: datasourceId,
                orgId: orgId != null && orgId !== '' ? orgId : null
            },
            operationName: (0, $873f5aaeb784a6a1$export$c5dfc39e7764783c),
            aggAbsoluteUrl: aggAbsoluteUrl
        });
        const filterOptions = response.data?.search?.configuration?.thirdPartyFilterOptions ?? null;
        if (response.errors?.length) {
            console.warn(`[${(0, $873f5aaeb784a6a1$export$c5dfc39e7764783c)}] GraphQL errors for datasource "${datasourceId}":`, response.errors);
            if (!filterOptions) throw new Error(`[${(0, $873f5aaeb784a6a1$export$c5dfc39e7764783c)}] GraphQL errors prevented loading third-party filter options for datasource "${datasourceId}"`);
        }
        return filterOptions;
    } catch (error) {
        console.error(`[${(0, $873f5aaeb784a6a1$export$c5dfc39e7764783c)}] Failed to fetch third-party filter options for datasource "${datasourceId}":`, error);
        throw error;
    }
};
module.exports["getThirdPartyFilterOptions"] = $f10b449f037fa26e$export$cd224500ea4a2de1;

});

parcelRegister("jxvxe", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $hw4j5 = parcelRequire("hw4j5");

const $48a5c8423b40f47c$export$fe2cce9cc2f02a10 = (0, $hw4j5.inMemoryCache)();
const $48a5c8423b40f47c$var$GQL_CF_PAGES_OPERATION_NAME = 'SearchPageConfluencePagesQuery';
const $48a5c8423b40f47c$var$getConfluencePagesQuery = ()=>`
query ${$48a5c8423b40f47c$var$GQL_CF_PAGES_OPERATION_NAME}($pageIds: [ID]!) {
  confluence {
    pages(ids: $pageIds) {
      id
      title
      type
      links {
        base
      }
    }
  }
}
`;
const $48a5c8423b40f47c$export$eeab7469706cab80 = (pageIds, headers)=>{
    return $48a5c8423b40f47c$export$fe2cce9cc2f02a10.inMemoryDecorator(// TODO: >>>> Limit this to a max string length
    // TODO: Refactor so that it can cache per page id
    pageIds.join(','), async ()=>{
        if (pageIds.length === 0) return {
            data: {
                confluence: {
                    pages: []
                }
            }
        };
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $48a5c8423b40f47c$var$getConfluencePagesQuery(),
            variables: {
                pageIds: pageIds
            },
            operationName: $48a5c8423b40f47c$var$GQL_CF_PAGES_OPERATION_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["confluencePagesQuery"] = $48a5c8423b40f47c$export$eeab7469706cab80;

});

parcelRegister("i14PY", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $2qzBQ = parcelRequire("2qzBQ");


var $hw4j5 = parcelRequire("hw4j5");

const $654994348c889f70$var$operationName = 'SearchEntitiesQuery';
const $654994348c889f70$var$getSearchEntitiesQuery = ({ includeSpaceKey: includeSpaceKey, includeContainerId: includeContainerId })=>{
    const SearchConfluenceSpace = `
    ... on SearchConfluenceSpace {
      key
    }
  `;
    // containerId is available on ExternalDocument entity (3P documents like Google Drive folders)
    const ContainerIdFragment = `
    ... on SearchResultGraphDocument {
      entity {
        ... on ExternalDocument {
          containerId
        }
      }
    }
  `;
    return `
  query ${$654994348c889f70$var$operationName}(
		$experience: String!, 
		$query: String!, 
		$first: Int, 
		$filters: SearchFilterInput!
		$experimentId: String
		$shadowExperimentId: String
		$experimentLayers: [SearchExperimentLayer]
	) {
    search {
      results: search(
        experience: $experience
        query: $query
        first: $first
        filters: $filters
				experimentContext: {
					experimentId: $experimentId
					shadowExperimentId: $shadowExperimentId
					experimentLayers: $experimentLayers
				}
      ) {
        edges {
          node {
            id
            title
            type
            url
            iconUrl
            ${includeSpaceKey ? SearchConfluenceSpace : ``}
            ${includeContainerId ? ContainerIdFragment : ``}
          }
        }
      }
    }
  }
  `;
};
const $654994348c889f70$export$69a3209f1a06c04d = (0, $hw4j5.inMemoryCache)();
// Expire the cache if there are errors or edges are empty
const $654994348c889f70$var$expireWhen = (result)=>{
    const { data: data, errors: errors } = result;
    if (!data || errors && errors.length > 0) return true;
    return data.search?.results.edges.length === 0;
};
const $654994348c889f70$export$98f1867fd4cb2c65 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers, includeSpaceKey: includeSpaceKey, includeContainerId: includeContainerId })=>$654994348c889f70$export$69a3209f1a06c04d.inMemoryDecorator((0, $2qzBQ.generateHashFromVariables)(variables), ()=>(0, $4qT1X.fetchAgg)({
            variables: {
                first: 20,
                experience: '',
                ...variables
            },
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: $654994348c889f70$var$getSearchEntitiesQuery({
                includeSpaceKey: includeSpaceKey,
                includeContainerId: includeContainerId
            }),
            operationName: $654994348c889f70$var$operationName,
            headers: headers
        }), $654994348c889f70$var$expireWhen);
module.exports["searchEntitiesQuery"] = $654994348c889f70$export$98f1867fd4cb2c65;

});

parcelRegister("aGXLL", function(module, exports) {

var $78z3f = parcelRequire("78z3f");


var $jwO5V = parcelRequire("jwO5V");


var $8RDn3 = parcelRequire("8RDn3");


var $i8MOh = parcelRequire("i8MOh");


var $b4tvS = parcelRequire("b4tvS");
parcelRequire("1yEFx");



var $6Ea6j = parcelRequire("6Ea6j");


var $ewGgp = parcelRequire("ewGgp");


var $4bHQd = parcelRequire("4bHQd");

const $a7df8cf79771da11$var$MAX_SEARCHED_OPTIONS_RESULTS = 5;
const $a7df8cf79771da11$export$a4d01c087c4a6f1c = [
    '@',
    'contributor:'
];
// Filter out Trello for milestone 1 (QS-4733)
// Focus does not have contributor field
const $a7df8cf79771da11$var$productKeys1P = (0, $b4tvS.all1pProductKeys).filter((key)=>key !== (0, $b4tvS.ProductKeys).Trello && key !== (0, $b4tvS.ProductKeys).Focus && key !== (0, $b4tvS.ProductKeys).Talent);
// Figma doesn't support contributor
// https://atlassian.slack.com/archives/C07P3MD2U9Z/p1733868616441159?thread_ts=1733866616.102409&cid=C07P3MD2U9Z
const $a7df8cf79771da11$var$all3pProductKeysExceptFigma = (0, $b4tvS.all3pProductKeys).filter((key)=>key !== (0, $78z3f.ProductKeys3P).Figma);
const $a7df8cf79771da11$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'contributor',
    // 1P only for now (excluding Trello)
    products: [
        ...$a7df8cf79771da11$var$productKeys1P,
        ...$a7df8cf79771da11$var$all3pProductKeysExceptFigma
    ],
    alwaysVisible: true,
    universal: true,
    queryParams: {
        key: 'contributors',
        fetcher: async (queryParams, config)=>{
            const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const initialUsersReponse = await (0, $i8MOh.usersQuery)([
                ...queryParams
            ], headers);
            const allRecommendedUsers = initialUsersReponse.data?.users ?? [];
            const recommendedUserOptions = allRecommendedUsers.map((user)=>({
                    trackingKey: user.accountId,
                    value: user.accountId,
                    label: user.name,
                    avatarUrl: user.picture,
                    queryParamValue: user.accountId,
                    product: config.product
                }));
            return recommendedUserOptions;
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return (0, $4bHQd.loadRecommendedUsers)(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            if (!config.intl) return []; // base on existing interface, can only query contributors with intl
            const response = await (0, $8RDn3.getContributors)({
                query: query,
                cloudId: config.cloudId || '',
                userId: config.userId || '',
                productKey: (0, $ewGgp.getUrsProductKey)(config.primaryProduct),
                maxNumberOfResults: $a7df8cf79771da11$var$MAX_SEARCHED_OPTIONS_RESULTS,
                intl: config.intl
            });
            if (!response) // TODO: log not found somewhere
            return [];
            return response.map((contributor)=>({
                    trackingKey: contributor.id,
                    value: contributor.id,
                    label: contributor.name,
                    avatarUrl: contributor.avatarUrl,
                    queryParamValue: contributor.id,
                    product: config.product
                }));
        }
    }
});
module.exports["filter"] = $a7df8cf79771da11$export$3dea766d36a8935f;

});

parcelRegister("8RDn3", function(module, exports) {

var $5kTPO = parcelRequire("5kTPO");

const $ed0ac8d2f9bf46f2$export$f63f2da3517cdf9c = ({ query: query, userId: userId, cloudId: cloudId, productKey: productKey, maxNumberOfResults: maxNumberOfResults, intl: intl })=>{
    const requestParams = {
        context: {
            contextType: 'contributors',
            principalId: userId,
            productAttributes: {
                isEntitledConfluenceExternalCollaborator: true
            },
            productKey: productKey,
            siteId: cloudId
        },
        includeGroups: false,
        includeTeams: false,
        includeUsers: true,
        maxNumberOfResults: maxNumberOfResults,
        performSearchQueryOnly: false,
        query: query
    };
    return (0, $5kTPO.default)(requestParams, intl);
};
module.exports["getContributors"] = $ed0ac8d2f9bf46f2$export$f63f2da3517cdf9c;

});

parcelRegister("lEZ2M", function(module, exports) {

var $5kTPO = parcelRequire("5kTPO");

const $f6e777910b6712c8$export$cc8468b84430954 = ({ query: query, userId: userId, cloudId: cloudId, productKey: productKey, maxNumberOfResults: maxNumberOfResults, intl: intl })=>{
    const requestParams = {
        context: {
            contextType: 'createdBy',
            principalId: userId,
            productAttributes: {
                isEntitledConfluenceExternalCollaborator: true
            },
            productKey: productKey,
            siteId: cloudId
        },
        includeGroups: false,
        includeTeams: false,
        includeUsers: true,
        maxNumberOfResults: maxNumberOfResults,
        performSearchQueryOnly: false,
        query: query
    };
    return (0, $5kTPO.default)(requestParams, intl);
};
module.exports["getCreatedBy"] = $f6e777910b6712c8$export$cc8468b84430954;

});

parcelRegister("4yWWa", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $hw4j5 = parcelRequire("hw4j5");

const $2c6215c9ce99d54a$export$fb16ff36c6030271 = (0, $hw4j5.inMemoryCache)();
const $2c6215c9ce99d54a$var$GQL_MERCURY_FOCUS_AREA_TYPES_OPERATION_NAME = 'FocusAreaTypes';
const $2c6215c9ce99d54a$var$mercuryFocusAreaTypesQueryString = `query ${$2c6215c9ce99d54a$var$GQL_MERCURY_FOCUS_AREA_TYPES_OPERATION_NAME}($cloudId: ID!) {
  mercury {
    focusAreaTypes(cloudId: $cloudId) @optIn(to: "Mercury") {
      id
      name
      hierarchyLevel
    }
  }
}`;
const $2c6215c9ce99d54a$export$780cc3f06f467bfe = (cloudId, headers)=>{
    return $2c6215c9ce99d54a$export$fb16ff36c6030271.inMemoryDecorator(cloudId, async ()=>{
        if (!cloudId) return {
            data: {
                mercury: {
                    focusAreaTypes: []
                }
            }
        };
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $2c6215c9ce99d54a$var$mercuryFocusAreaTypesQueryString,
            variables: {
                cloudId: cloudId
            },
            operationName: $2c6215c9ce99d54a$var$GQL_MERCURY_FOCUS_AREA_TYPES_OPERATION_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["mercuryFocusAreaTypesQuery"] = $2c6215c9ce99d54a$export$780cc3f06f467bfe;

});

parcelRegister("d95gt", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $hw4j5 = parcelRequire("hw4j5");

const $7ddfceef9c6f7249$export$7e54d23e8f945514 = (0, $hw4j5.inMemoryCache)();
const $7ddfceef9c6f7249$var$GQL_MERCURY_FOCUS_AREAS_OPERATION_NAME = 'FocusAreas';
const $7ddfceef9c6f7249$var$mercuryFocusAreasQueryString = `query ${$7ddfceef9c6f7249$var$GQL_MERCURY_FOCUS_AREAS_OPERATION_NAME}($cloudId: ID!, $q: String, $first: Int, $sort: [MercuryFocusAreaSort]) {
  mercury {
    focusAreas(cloudId: $cloudId, q: $q, first: $first, sort: $sort) @optIn(to: "Mercury") {
      edges {
        node {
          id
          uuid
          name
          status {
		    key            
          }
          health {
            key
          }
          focusAreaType {
		  	name
            hierarchyLevel
          }
		  owner {
            name
          }
        }
      }
    }
  }
}`;
const $7ddfceef9c6f7249$var$MercuryFocusAreaSortField = {
    Budget: 'BUDGET',
    FocusAreaType: 'FOCUS_AREA_TYPE',
    HasParent: 'HAS_PARENT',
    HierarchyLevel: 'HIERARCHY_LEVEL',
    LastUpdated: 'LAST_UPDATED',
    Name: 'NAME',
    Spend: 'SPEND',
    Status: 'STATUS',
    TargetDate: 'TARGET_DATE',
    Watching: 'WATCHING'
};
const $7ddfceef9c6f7249$var$MercuryFocusAreaSortOrder = {
    ASC: 'ASC',
    DESC: 'DESC'
};
const $7ddfceef9c6f7249$export$f9d9785ff9cc54a6 = (cloudId, q, first = 20, sort = [
    {
        field: $7ddfceef9c6f7249$var$MercuryFocusAreaSortField.FocusAreaType,
        order: $7ddfceef9c6f7249$var$MercuryFocusAreaSortOrder['ASC']
    },
    {
        field: $7ddfceef9c6f7249$var$MercuryFocusAreaSortField.Name,
        order: $7ddfceef9c6f7249$var$MercuryFocusAreaSortOrder['ASC']
    }
], headers)=>{
    return $7ddfceef9c6f7249$export$7e54d23e8f945514.inMemoryDecorator(`${cloudId}-${q}-${first}-${JSON.stringify(sort)}`, async ()=>{
        if (!cloudId) return {
            data: {
                mercury: {
                    focusAreas: {
                        edges: []
                    }
                }
            }
        };
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $7ddfceef9c6f7249$var$mercuryFocusAreasQueryString,
            variables: {
                cloudId: cloudId,
                q: q,
                first: first,
                sort: sort
            },
            operationName: $7ddfceef9c6f7249$var$GQL_MERCURY_FOCUS_AREAS_OPERATION_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["mercuryFocusAreasQuery"] = $7ddfceef9c6f7249$export$f9d9785ff9cc54a6;

});

parcelRegister("22zVp", function(module, exports) {

var $b4tvS = parcelRequire("b4tvS");

const $96bffdf1601f19c9$export$ecb101fddedffa32 = (product, includeDC = false)=>{
    const jiraProducts = includeDC ? [
        (0, $b4tvS.ProductKeys).Jira,
        (0, $b4tvS.ProductKeys).JiraDC,
        (0, $b4tvS.ProductKeys).JiraProductDiscovery,
        (0, $b4tvS.ProductKeys).JiraServiceManagement
    ] : [
        (0, $b4tvS.ProductKeys).Jira,
        (0, $b4tvS.ProductKeys).JiraProductDiscovery,
        (0, $b4tvS.ProductKeys).JiraServiceManagement
    ];
    return Boolean(jiraProducts.find((jiraProduct)=>jiraProduct === product));
};
module.exports["isJiraProduct"] = $96bffdf1601f19c9$export$ecb101fddedffa32;

});

parcelRegister("1tvnk", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $hw4j5 = parcelRequire("hw4j5");

const $d787c8d425cdec7f$export$a8f449a3d81f3a4c = (0, $hw4j5.inMemoryCache)();
const $d787c8d425cdec7f$var$GQL_CF_LABEL_OPERATION_NAME = 'SearchLabelsQuery';
const $d787c8d425cdec7f$var$getConfluenceLabelsQuery = ()=>`
query ${$d787c8d425cdec7f$var$GQL_CF_LABEL_OPERATION_NAME}($cloudId: ID! $searchText: String!, $limit: Int) {
  confluence {
    searchLabels(cloudId: $cloudId, searchText: $searchText, limit: $limit) @optIn(to: "ConfluenceExperimentalSearchLabels") {
	  otherLabels {
        label
      }
      suggestedLabels {
        label
      }
    }
  }
}
`;
const $d787c8d425cdec7f$export$b9ea4761dac8a473 = (cloudId, searchText, limit, headers)=>{
    return $d787c8d425cdec7f$export$a8f449a3d81f3a4c.inMemoryDecorator(searchText, async ()=>{
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $d787c8d425cdec7f$var$getConfluenceLabelsQuery(),
            variables: {
                cloudId: cloudId,
                searchText: searchText,
                limit: limit
            },
            operationName: $d787c8d425cdec7f$var$GQL_CF_LABEL_OPERATION_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["confluenceLabelsQuery"] = $d787c8d425cdec7f$export$b9ea4761dac8a473;

});

parcelRegister("7uR1u", function(module, exports) {

var $dwp40 = parcelRequire("dwp40");

const $9b493b78b0147f03$export$eddac1daa475a197 = async ({ query: query = '', absoluteUrl: absoluteUrl })=>{
    const options = {
        path: 'rest/api/1.0/labels/suggest',
        queryParams: {
            query: query
        },
        requestInit: {
            method: 'GET',
            headers: {
                accept: 'application/json',
                'x-atlassian-capability': 'ROVO_FULL_PAGE_SEARCH'
            }
        }
    };
    return (0, $dwp40.utils).requestService({
        url: absoluteUrl
    }, options);
};
module.exports["getSuggestedJiraLabels"] = $9b493b78b0147f03$export$eddac1daa475a197;

});

parcelRegister("98IoL", function(module, exports) {

var $5kTPO = parcelRequire("5kTPO");

const $c7b96c55ef1af949$export$5fc95d9e84e12fd3 = ({ query: query, userId: userId, cloudId: cloudId, productKey: productKey, maxNumberOfResults: maxNumberOfResults, intl: intl })=>{
    const requestParams = {
        context: {
            contextType: 'lastUpdatedBy',
            principalId: userId,
            productAttributes: {
                isEntitledConfluenceExternalCollaborator: true
            },
            productKey: productKey,
            siteId: cloudId
        },
        includeGroups: false,
        includeTeams: false,
        includeUsers: true,
        maxNumberOfResults: maxNumberOfResults,
        performSearchQueryOnly: false,
        query: query
    };
    return (0, $5kTPO.default)(requestParams, intl);
};
module.exports["getLastUpdatedBy"] = $c7b96c55ef1af949$export$5fc95d9e84e12fd3;

});

parcelRegister("3Pbzb", function(module, exports) {

var $5kTPO = parcelRequire("5kTPO");

const $04a21b2c3e4676ff$export$148de59b68ce26ae = ({ query: query, userId: userId, cloudId: cloudId, productKey: productKey, maxNumberOfResults: maxNumberOfResults, intl: intl })=>{
    const requestParams = {
        context: {
            contextType: 'owners',
            principalId: userId,
            productAttributes: {
                isEntitledConfluenceExternalCollaborator: true
            },
            productKey: productKey,
            siteId: cloudId
        },
        includeGroups: false,
        includeTeams: false,
        includeUsers: true,
        maxNumberOfResults: maxNumberOfResults,
        performSearchQueryOnly: false,
        query: query
    };
    return (0, $5kTPO.default)(requestParams, intl);
};
module.exports["getOwners"] = $04a21b2c3e4676ff$export$148de59b68ce26ae;

});

parcelRegister("1APZs", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $hw4j5 = parcelRequire("hw4j5");

const $341a3e7febf59a97$export$77f684104cbf1994 = (0, $hw4j5.inMemoryCache)();
const $341a3e7febf59a97$var$QUERY_NAME = 'PositionEmploymentTypes';
const $341a3e7febf59a97$var$positionEmploymentTypesQueryString = `query ${$341a3e7febf59a97$var$QUERY_NAME}($cloudId: ID!, $fieldId: ID!, $rql: String, $after: String, $first: Int) {
  radar_fieldValues(
    cloudId: $cloudId
    uniqueFieldId: $fieldId
    rql: $rql
    first: $first
    after: $after
  ) { 
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      cursor
      node {
        ... on RadarStringFieldValue {
          __typename
          isRestricted
          stringValue: value
        }
      }
    }
  }
}`;
const $341a3e7febf59a97$export$66f27dc417575281 = (cloudId, rql, first = 20, after, headers)=>{
    const fieldId = 'positionEmploymentType';
    return $341a3e7febf59a97$export$77f684104cbf1994.inMemoryDecorator([
        cloudId,
        first,
        rql,
        fieldId,
        after
    ].filter(Boolean).join('-'), async ()=>{
        if (!cloudId) return {
            data: {
                radar_fieldValues: {
                    edges: []
                }
            }
        };
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $341a3e7febf59a97$var$positionEmploymentTypesQueryString,
            variables: {
                cloudId: cloudId,
                first: first,
                rql: rql,
                fieldId: fieldId,
                after: after
            },
            operationName: $341a3e7febf59a97$var$QUERY_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["positionEmploymentTypesQuery"] = $341a3e7febf59a97$export$66f27dc417575281;

});

parcelRegister("gkPq5", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $hw4j5 = parcelRequire("hw4j5");

const $0ef59a00ea746990$export$5918017b3202b827 = (0, $hw4j5.inMemoryCache)();
const $0ef59a00ea746990$var$QUERY_NAME = 'PositionJobFamilies';
const $0ef59a00ea746990$var$positionJobFamiliesQueryString = `query ${$0ef59a00ea746990$var$QUERY_NAME}($cloudId: ID!, $fieldId: ID!, $rql: String, $after: String, $first: Int) {
  radar_fieldValues(
    cloudId: $cloudId
    uniqueFieldId: $fieldId
    rql: $rql
    first: $first
    after: $after
  ) { 
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      cursor
      node {
        ... on RadarStringFieldValue {
          __typename
          isRestricted
          stringValue: value
        }
      }
    }
  }
}`;
const $0ef59a00ea746990$export$9573cb9936eb57f3 = (cloudId, first = 20, rql, after, headers)=>{
    const fieldId = 'positionJobFamily';
    return $0ef59a00ea746990$export$5918017b3202b827.inMemoryDecorator([
        cloudId,
        first,
        rql,
        fieldId,
        after
    ].filter(Boolean).join('-'), async ()=>{
        if (!cloudId) return {
            data: {
                radar_fieldValues: {
                    edges: []
                }
            }
        };
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $0ef59a00ea746990$var$positionJobFamiliesQueryString,
            variables: {
                cloudId: cloudId,
                first: first,
                rql: rql,
                fieldId: fieldId,
                after: after
            },
            operationName: $0ef59a00ea746990$var$QUERY_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["positionJobFamiliesQuery"] = $0ef59a00ea746990$export$9573cb9936eb57f3;

});

parcelRegister("3FxSV", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $hw4j5 = parcelRequire("hw4j5");

const $eeb9c275443983dc$export$9030a66c314dd4f9 = (0, $hw4j5.inMemoryCache)();
const $eeb9c275443983dc$var$QUERY_NAME = 'PositionStatuses';
const $eeb9c275443983dc$var$positionStatusesQueryString = `query ${$eeb9c275443983dc$var$QUERY_NAME}($cloudId: ID!, $fieldId: ID!, $rql: String, $after: String, $first: Int) {
  radar_fieldValues(
    cloudId: $cloudId
    uniqueFieldId: $fieldId
    rql: $rql
    first: $first
    after: $after
  ) { 
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      cursor
      node {
        ... on RadarStatusFieldValue {
          __typename
          isRestricted
          statusValue: value
          statusDisplayValue: displayValue
          appearance
        }
      }
    }
  }
}`;
const $eeb9c275443983dc$export$edd0381f12f6ff4d = (cloudId, first = 20, rql, after, headers)=>{
    const fieldId = 'positionStatus';
    return $eeb9c275443983dc$export$9030a66c314dd4f9.inMemoryDecorator([
        cloudId,
        first,
        rql,
        fieldId,
        after
    ].filter(Boolean).join('-'), async ()=>{
        if (!cloudId) return {
            data: {
                radar_fieldValues: {
                    edges: []
                }
            }
        };
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $eeb9c275443983dc$var$positionStatusesQueryString,
            variables: {
                cloudId: cloudId,
                first: first,
                rql: rql,
                fieldId: fieldId,
                after: after
            },
            operationName: $eeb9c275443983dc$var$QUERY_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["positionStatusesQuery"] = $eeb9c275443983dc$export$edd0381f12f6ff4d;

});

parcelRegister("eDERK", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $hw4j5 = parcelRequire("hw4j5");

const $c9b75add6fb06773$export$7e7f4c6c4a157b2d = (0, $hw4j5.inMemoryCache)();
const $c9b75add6fb06773$var$QUERY_NAME = 'PositionTeams';
const $c9b75add6fb06773$var$positionTeamsQueryString = `query ${$c9b75add6fb06773$var$QUERY_NAME}($cloudId: ID!, $fieldId: ID!, $rql: String, $after: String, $first: Int) {
  radar_fieldValues(
    cloudId: $cloudId
    uniqueFieldId: $fieldId
    rql: $rql
    first: $first
    after: $after
  ) { 
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      cursor
      node {
        __typename
        __isRadarFieldValue: __typename
        ... on RadarAriFieldValue {
          __typename
          isRestricted
          ari
          value {
            __typename
            ... on TeamV2 {
              __typename
              displayName
              id
              organizationId
              smallAvatarImageUrl
            }
          }
        }
      }
    }
  }
}`;
const $c9b75add6fb06773$export$ed23ff9c143a4269 = (cloudId, first = 20, rql, after, headers)=>{
    const fieldId = 'team';
    return $c9b75add6fb06773$export$7e7f4c6c4a157b2d.inMemoryDecorator([
        cloudId,
        first,
        rql,
        fieldId,
        after
    ].filter(Boolean).join('-'), async ()=>{
        if (!cloudId) return {
            data: {
                radar_fieldValues: {
                    edges: []
                }
            }
        };
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $c9b75add6fb06773$var$positionTeamsQueryString,
            variables: {
                cloudId: cloudId,
                first: first,
                rql: rql,
                fieldId: fieldId,
                after: after
            },
            operationName: $c9b75add6fb06773$var$QUERY_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["positionTeamsQuery"] = $c9b75add6fb06773$export$ed23ff9c143a4269;

});

parcelRegister("1WLN3", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $hw4j5 = parcelRequire("hw4j5");

const $0ec6fc46fa2dbafd$export$56d694fb8fe349ab = (0, $hw4j5.inMemoryCache)();
const $0ec6fc46fa2dbafd$var$GQL_JIRA_PROJECTS_OPERATION_NAME = 'SearchPageJiraProjectQuery';
const $0ec6fc46fa2dbafd$var$jiraProjectsQueryString = `query ${$0ec6fc46fa2dbafd$var$GQL_JIRA_PROJECTS_OPERATION_NAME}($projectIds: [ID!]!) {
  jira {
    jiraProjects(ids: $projectIds) {
			projectId
      name
      avatar {
        small
      }
    }
  }
}`;
const $0ec6fc46fa2dbafd$export$fd1d4a933080bfe2 = (projectIds, headers)=>{
    return $0ec6fc46fa2dbafd$export$56d694fb8fe349ab.inMemoryDecorator(projectIds.join(','), async ()=>{
        if (projectIds.length === 0) return {
            data: {
                jira: {
                    jiraProjects: []
                }
            }
        };
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $0ec6fc46fa2dbafd$var$jiraProjectsQueryString,
            variables: {
                projectIds: projectIds
            },
            operationName: $0ec6fc46fa2dbafd$var$GQL_JIRA_PROJECTS_OPERATION_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return $0ec6fc46fa2dbafd$var$filterProjectsWithoutId(response);
    });
};
const $0ec6fc46fa2dbafd$var$filterProjectsWithoutId = (response)=>{
    const filteredProjects = response.data?.jira.jiraProjects?.filter((project)=>project.projectId);
    return {
        ...response,
        data: {
            jira: {
                jiraProjects: filteredProjects
            }
        }
    };
};
module.exports["jiraProjectsQuery"] = $0ec6fc46fa2dbafd$export$fd1d4a933080bfe2;

});

parcelRegister("a97k3", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $a5RR2 = parcelRequire("a5RR2");


var $jwO5V = parcelRequire("jwO5V");


var $8hQhN = parcelRequire("8hQhN");


var $i14PY = parcelRequire("i14PY");


var $4qT1X = parcelRequire("4qT1X");

const $4205d6666548c699$var$LOOM_SPACES_BY_IDS_OPERATION_NAME = 'LoomRovoSpacesByIdsQuery';
const $4205d6666548c699$var$loomSpacesByIdsQuery = `
	query ${$4205d6666548c699$var$LOOM_SPACES_BY_IDS_OPERATION_NAME}($ids: [ID!]!) {
		loom_spaces(ids: $ids) {
			id
			name
			url
		}
	}
`;
const $4205d6666548c699$export$d3c2717269e16428 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>(0, $4qT1X.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: $4205d6666548c699$var$loomSpacesByIdsQuery,
        operationName: $4205d6666548c699$var$LOOM_SPACES_BY_IDS_OPERATION_NAME,
        headers: headers
    });





const $42a9c2d809b7880c$var$LOOM_SPACES_SEARCH_OPERATION_NAME = 'LoomRovoSpacesSearchQuery';
const $42a9c2d809b7880c$var$loomSpacesSearchQuery = `
	query ${$42a9c2d809b7880c$var$LOOM_SPACES_SEARCH_OPERATION_NAME}($siteId: ID!, $query: String) {
		loom_spacesSearch(siteId: $siteId, query: $query) {
			id
			name
			url
		}
	}
`;
const $42a9c2d809b7880c$var$trimToLimit = (result, limit)=>typeof limit === 'number' ? {
        ...result,
        data: result.data ? {
            ...result.data,
            loom_spacesSearch: result.data.loom_spacesSearch.slice(0, limit)
        } : result.data
    } : result;
const $42a9c2d809b7880c$export$79bd8211418f2310 = async ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const { siteId: siteId, query: query, limit: limit } = variables;
    const response = await (0, $4qT1X.fetchAgg)({
        variables: {
            siteId: siteId,
            query: query
        },
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: $42a9c2d809b7880c$var$loomSpacesSearchQuery,
        operationName: $42a9c2d809b7880c$var$LOOM_SPACES_SEARCH_OPERATION_NAME,
        headers: headers
    });
    return $42a9c2d809b7880c$var$trimToLimit(response, limit);
};



var $johDC = parcelRequire("johDC");


var $2XoKG = parcelRequire("2XoKG");


var $IpMWN = parcelRequire("IpMWN");


var $1HJbl = parcelRequire("1HJbl");


var $hm6w9 = parcelRequire("hm6w9");


var $k8y62 = parcelRequire("k8y62");


var $2Znam = parcelRequire("2Znam");


var $b4tvS = parcelRequire("b4tvS");

parcelRequire("1yEFx");



var $dOOW1 = parcelRequire("dOOW1");


var $5XpfZ = parcelRequire("5XpfZ");


var $6Ea6j = parcelRequire("6Ea6j");


var $cOUgi = parcelRequire("cOUgi");

// TODO: Add Loom in 1P product when backend is ready
const $f270dad94ab1fad4$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Confluence
];
const $f270dad94ab1fad4$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('space');
const $f270dad94ab1fad4$var$getProducts3PFromConfig = ()=>$f270dad94ab1fad4$var$products3PFromConfig;
const $f270dad94ab1fad4$var$LOOKUP_ENTITIES = [
    'ati:cloud:confluence:space'
];
const $f270dad94ab1fad4$var$DEFAULT_LOOM_SPACE_INITIAL_LIMIT = 15;
const $f270dad94ab1fad4$var$DEFAULT_LOOM_SPACE_LOOKUP_LIMIT = 15;
const $f270dad94ab1fad4$var$isLoomSpaceProduct = (product)=>product === (0, $b4tvS.ProductKeys).Loom && (0, $dh538.fg)('loom-rovo-search');
const $f270dad94ab1fad4$var$isSingleSelectSpaceProduct = (product)=>(0, $b4tvS.is3pProductKey)(product ?? '') && !$f270dad94ab1fad4$var$isLoomSpaceProduct(product);
async function $f270dad94ab1fad4$var$searchDcSpaces(query, config) {
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    let spacesResponse = await (0, $johDC.confluenceDcSpaceFilterOptionsQuery)({
        variables: {
            query: query,
            cloudIdARI: `ari:cloud:confluence::site/${config.cloudId}`,
            limit: 5,
            entities: (0, $k8y62.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
            product: (0, $b4tvS.ProductKeys).ConfluenceDC
        },
        aggAbsoluteUrl: config.aggAbsoluteUrl,
        headers: headers
    });
    return spacesResponse?.data?.search?.search?.edges?.map(({ node: node })=>({
            trackingKey: node.entity.id,
            value: node.entity.id,
            queryParamValue: node.entity.id,
            avatarUrl: node.entity?.icon?.url,
            label: (0, $1HJbl.cleanExcerpt)(node.entity.displayName),
            product: config.product
        })) ?? [];
}
async function $f270dad94ab1fad4$var$searchThirdPartySpaceOptions(config, query = '') {
    const cloudId = config.cloudId;
    const product = config.product;
    // Get integrationAri from the static ThirdPartyConfigs using the product key.
    // This avoids the dependency on selectedDatasource being populated in the store,
    // which was causing lookup/search to fail when selectedDatasource was undefined.
    const integrationAri = config.selectedDatasource?.integrationAri ?? (0, $a5RR2.ThirdPartyConfigsSync).get(product)?.integrationAri;
    if (!cloudId || !product || !integrationAri) return [];
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const subtypes = product === (0, $b4tvS.ProductKeys).Sharepoint ? [
        (0, $2Znam.NounSubtypeKey).Site,
        (0, $2Znam.NounSubtypeKey).Subsite
    ] : [
        (0, $2Znam.NounSubtypeKey).Space
    ];
    let spacesResponse = await (0, $johDC.thirdPartySpaceFilterOptionsQuery)({
        variables: {
            query: query,
            cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
            limit: 15,
            entities: (0, $k8y62.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
            product: product,
            integration: integrationAri,
            subtypes: subtypes
        },
        aggAbsoluteUrl: config.aggAbsoluteUrl,
        headers: headers
    });
    return spacesResponse?.data?.search?.search?.edges?.map(({ node: node })=>({
            value: node.entity.id,
            trackingKey: node.entity.id,
            queryParamValue: node.entity.id,
            avatarUrl: node.entity?.icon?.url,
            label: (0, $1HJbl.cleanExcerpt)(node.entity.displayName),
            product: product
        })) ?? [];
}
async function $f270dad94ab1fad4$var$fetchLoomSpaceOptions(config, { query: query = '', limit: limit = $f270dad94ab1fad4$var$DEFAULT_LOOM_SPACE_INITIAL_LIMIT } = {}) {
    const cloudId = config.cloudId;
    if (!cloudId) return [];
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const spacesResponse = await (0, $42a9c2d809b7880c$export$79bd8211418f2310)({
        variables: {
            query: query || undefined,
            siteId: cloudId,
            limit: limit
        },
        aggAbsoluteUrl: config.aggAbsoluteUrl,
        headers: headers
    });
    return spacesResponse?.data?.loom_spacesSearch?.map((space)=>({
            value: space.id,
            trackingKey: space.id,
            queryParamValue: space.id,
            avatarUrl: undefined,
            label: (0, $1HJbl.cleanExcerpt)(space.name),
            product: (0, $b4tvS.ProductKeys).Loom
        })) ?? [];
}
const $f270dad94ab1fad4$var$spaceFilterInitial = {
    id: 'space',
    products: [
        ...$f270dad94ab1fad4$var$productKeys1P,
        ...$f270dad94ab1fad4$var$getProducts3PFromConfig()
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'spaces',
        fetcher: async (queryParams, config)=>{
            if ($f270dad94ab1fad4$var$isLoomSpaceProduct(config.product)) {
                const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
                    cloudId: config.cloudId,
                    activationId: config.activationId,
                    product: config.primaryProduct
                });
                const spacesResponse = await (0, $4205d6666548c699$export$d3c2717269e16428)({
                    variables: {
                        ids: queryParams
                    },
                    aggAbsoluteUrl: config.aggAbsoluteUrl,
                    headers: headers
                });
                const spacesOptions = spacesResponse?.data?.loom_spaces?.map((space)=>({
                        trackingKey: space.id,
                        value: space.id,
                        label: space.name,
                        avatarUrl: undefined,
                        queryParamValue: space.id,
                        product: config.product
                    }));
                return spacesOptions || [];
            }
            if (config.product === (0, $b4tvS.ProductKeys).ConfluenceDC || config.product === (0, $b4tvS.ProductKeys).GoogleDrive || config.product === (0, $b4tvS.ProductKeys).Sharepoint) {
                const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
                    cloudId: config.cloudId,
                    activationId: config.activationId,
                    product: config.primaryProduct
                });
                const spacesResponse = await (0, $johDC.spaceARIEntitiesQuery)({
                    variables: {
                        ids: queryParams
                    },
                    aggAbsoluteUrl: config.aggAbsoluteUrl,
                    headers: headers
                });
                const spacesOptions = spacesResponse.data?.external_entities?.space?.map((space)=>({
                        trackingKey: space.id,
                        value: space.id,
                        label: space.displayName,
                        avatarUrl: space.icon?.url || '',
                        queryParamValue: space.id,
                        product: config.product
                    }));
                return spacesOptions || [];
            }
            const cloudId = config.cloudId;
            // Practically cloudId should always be present, but we need to satisfy the type checker
            if (!cloudId) return [];
            const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const response = await (0, $IpMWN.confluenceSpaceKeysToIdsQuery)({
                spaceKeys: queryParams,
                cloudId: cloudId,
                headers: headers
            });
            const spaceIds = response.data?.spaces?.nodes?.map((node)=>node?.id).filter((0, $dOOW1.notEmpty)) ?? [];
            const spaceARIs = spaceIds.map((id)=>`ari:cloud:confluence:${cloudId}:space/${id}`);
            const initialSpacesResponse = await (0, $2XoKG.confluenceSpacesQuery)(spaceARIs, headers);
            const allRecommendedSpaces = initialSpacesResponse.data?.confluence.spaces.map((space)=>({
                    key: space.key,
                    name: space.name,
                    ari: space.id,
                    avatarUrl: space.links?.base && space.icon?.path ? `${space.links.base}${space.icon.path}` : ''
                })) || [];
            return allRecommendedSpaces.map((space)=>({
                    trackingKey: space.ari,
                    value: space.key,
                    queryParamValue: space.key,
                    avatarUrl: space.avatarUrl,
                    label: space.name || '',
                    product: config.product
                }));
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            if ($f270dad94ab1fad4$var$isLoomSpaceProduct(config.product)) return $f270dad94ab1fad4$var$fetchLoomSpaceOptions(config, {
                limit: $f270dad94ab1fad4$var$DEFAULT_LOOM_SPACE_INITIAL_LIMIT
            });
            if (config.product === (0, $b4tvS.ProductKeys).ConfluenceDC) {
                const spaces = await $f270dad94ab1fad4$var$searchDcSpaces('', config);
                return spaces;
            }
            if (config.product === (0, $b4tvS.ProductKeys).GoogleDrive || config.product === (0, $b4tvS.ProductKeys).Sharepoint) return $f270dad94ab1fad4$var$searchThirdPartySpaceOptions(config);
            const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const recommendedSpacesResponse = await (0, $8hQhN.smartsRecommendedContainerQuery)({
                aggAbsoluteUrl: config.aggAbsoluteUrl,
                variables: {
                    userId: config.userId || '',
                    tenantId: config.cloudId || ''
                },
                headers: headers
            });
            const allRecommendedSpaces = recommendedSpacesResponse.data?.smarts.results?.flatMap(({ container: container })=>{
                if (!(container && container.key)) return [];
                return [
                    {
                        key: container.key,
                        name: container.name,
                        ari: container.id,
                        avatarUrl: container.links?.base && container.icon?.path ? `${container.links.base}${container.icon.path}` : ''
                    }
                ];
            }) || [];
            const recommendedSpaceOptions = allRecommendedSpaces.map((space)=>{
                return {
                    trackingKey: space.ari,
                    value: space.key,
                    queryParamValue: space.key,
                    avatarUrl: space.avatarUrl,
                    label: space.name || '',
                    product: config.product
                };
            });
            return recommendedSpaceOptions;
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            if ($f270dad94ab1fad4$var$isLoomSpaceProduct(config.product)) return $f270dad94ab1fad4$var$fetchLoomSpaceOptions(config, {
                query: query,
                limit: $f270dad94ab1fad4$var$DEFAULT_LOOM_SPACE_LOOKUP_LIMIT
            });
            if (config.product === (0, $b4tvS.ProductKeys).ConfluenceDC) return $f270dad94ab1fad4$var$searchDcSpaces(query, config);
            if (config.product === (0, $b4tvS.ProductKeys).GoogleDrive || config.product === (0, $b4tvS.ProductKeys).Sharepoint) return $f270dad94ab1fad4$var$searchThirdPartySpaceOptions(config, query);
            const backendExperiment = config.experimentConfig && (0, $hm6w9.getBackendExperiment)({
                experimentConfig: config.experimentConfig,
                entities: $f270dad94ab1fad4$var$LOOKUP_ENTITIES,
                productEdition: config.productEdition,
                isHello: (0, $5XpfZ.isHello)(config.cloudId),
                productDataRegions: config.productDataRegions,
                experience: 'search-page-space-filter',
                tenantId: config.cloudId
            });
            const { experimentLayers: experimentLayers, experimentId: experimentId, shadowExperimentId: shadowExperimentId } = backendExperiment || {};
            const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const response = await (0, $i14PY.searchEntitiesQuery)({
                aggAbsoluteUrl: config.aggAbsoluteUrl,
                variables: {
                    query: query,
                    first: 15,
                    filters: {
                        entities: [
                            'ati:cloud:confluence:space'
                        ],
                        locations: [
                            `ari:cloud:confluence::site/${config.cloudId}`
                        ]
                    },
                    experience: 'full-page-search-space-filter',
                    experimentId: experimentId,
                    shadowExperimentId: shadowExperimentId,
                    experimentLayers: experimentLayers?.map(({ name: name, layerId: layerId, shadowId: shadowId, definitions: definitions })=>({
                            name: name,
                            layerId: layerId,
                            shadowId: shadowId,
                            definitions: definitions
                        }))
                },
                includeSpaceKey: true,
                headers: headers
            });
            const { data: data } = response;
            if (!data) return [];
            return data.search?.results.edges.map(({ node: node })=>({
                    trackingKey: node.id || '',
                    value: node.key || '',
                    queryParamValue: node.key ?? '',
                    avatarUrl: node.iconUrl || undefined,
                    label: node.title,
                    product: config.product
                })) ?? [];
        }
    },
    isSuggestedFilter: (primaryProduct)=>primaryProduct === (0, $b4tvS.ProductKeys).Confluence
};
/**
 * Builds the raw (unwrapped) monad for the given state and config, choosing
 * SingleSelectFilter for 3P products and MultiSelectFilter for 1P. Used internally
 * so that withSelectTypeFilter can wrap exactly once — calling filter.withState would
 * double-wrap because filter.withState itself calls withSelectTypeFilter for 3P.
 */ const $f270dad94ab1fad4$var$buildSelectFilter = (state, config)=>{
    if ($f270dad94ab1fad4$var$isSingleSelectSpaceProduct(config.product)) return (0, $cOUgi.SingleSelectFilter)({
        initial: $f270dad94ab1fad4$var$spaceFilterInitial,
        state: {
            ...state,
            type: 'single-select'
        },
        config: config
    });
    return (0, $6Ea6j.MultiSelectFilter)({
        initial: $f270dad94ab1fad4$var$spaceFilterInitial,
        state: {
            ...state,
            type: 'multi-select'
        },
        config: config
    });
};
/**
 * Ensures every chained monad operation re-dispatches through buildSelectFilter so the
 * correct select type (SingleSelectFilter for 3P, MultiSelectFilter for 1P) is preserved
 * throughout the chain. Without this, base-select-filter operations (loadInitialOptions,
 * setQueryParams, etc.) return a plain SelectFilter monad that always uses multi-select
 * setOption. buildSelectFilter is used instead of filter.withState to avoid double-wrapping:
 * filter.withState for 3P already calls withSelectTypeFilter internally.
 */ const $f270dad94ab1fad4$var$withSelectTypeFilter = (spaceFilter, config)=>({
        ...spaceFilter,
        loadInitialOptions: async (onStateChange)=>$f270dad94ab1fad4$var$withSelectTypeFilter($f270dad94ab1fad4$var$buildSelectFilter((await spaceFilter.loadInitialOptions(onStateChange)).getState(), config), config),
        setOption: (option, customValue)=>$f270dad94ab1fad4$var$withSelectTypeFilter($f270dad94ab1fad4$var$buildSelectFilter(spaceFilter.setOption(option, customValue).getState(), config), config),
        clearOptions: ()=>$f270dad94ab1fad4$var$withSelectTypeFilter($f270dad94ab1fad4$var$buildSelectFilter(spaceFilter.clearOptions().getState(), config), config),
        setLookupInput: async (query, onStateChange)=>$f270dad94ab1fad4$var$withSelectTypeFilter($f270dad94ab1fad4$var$buildSelectFilter((await spaceFilter.setLookupInput(query, onStateChange)).getState(), config), config),
        clear: ()=>$f270dad94ab1fad4$var$withSelectTypeFilter($f270dad94ab1fad4$var$buildSelectFilter(spaceFilter.clear().getState(), config), config),
        queryParams: {
            ...spaceFilter.queryParams,
            set: async (queryParams, onStateChange)=>$f270dad94ab1fad4$var$withSelectTypeFilter($f270dad94ab1fad4$var$buildSelectFilter((await spaceFilter.queryParams.set(queryParams, onStateChange)).getState(), config), config)
        }
    });
// Used only for its static shape (id, type, products, queryParams.key, etc.) via the
// spread below. withState and getInitialState are overridden to dispatch per product.
const $f270dad94ab1fad4$var$baseFilter = (0, $6Ea6j.createMultiSelectFilter)($f270dad94ab1fad4$var$spaceFilterInitial);
const $f270dad94ab1fad4$export$3dea766d36a8935f = {
    ...$f270dad94ab1fad4$var$baseFilter,
    withState: (state, config)=>{
        // buildSelectFilter is the single source of truth for monad construction.
        // For 3P, wrap with withSelectTypeFilter to preserve single-select dispatch
        // through every chained operation; 1P uses MultiSelectFilter directly.
        const monad = $f270dad94ab1fad4$var$buildSelectFilter(state, config);
        return $f270dad94ab1fad4$var$isSingleSelectSpaceProduct(config.product) ? $f270dad94ab1fad4$var$withSelectTypeFilter(monad, config) : monad;
    },
    getInitialState: (config)=>{
        return $f270dad94ab1fad4$export$3dea766d36a8935f.withState($f270dad94ab1fad4$var$baseFilter.getInitialState(config).getState(), config);
    }
};
module.exports["filter"] = $f270dad94ab1fad4$export$3dea766d36a8935f;

});

parcelRegister("8hQhN", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $2qzBQ = parcelRequire("2qzBQ");


var $hw4j5 = parcelRequire("hw4j5");

const $d33e20668d2d4273$var$operationName = 'SmartsRecommendedContainerQuery';
const $d33e20668d2d4273$var$SmartsRecommendedContainerQuery = `
query ${$d33e20668d2d4273$var$operationName}($userId: String!, $tenantId: String!) {
  smarts {
    results: recommendedContainer(
      recommendationsQuery: {
        context: {
          userId: $userId,
          tenantId: $tenantId,
          product: "confluence"
        },
        modelRequestParams: {
          caller: "full-page-search",
          experience: "CgContainerNearbyUser"
        },
        requestingUserId: $userId
      }
    ) {
      id
      score
      container {
        createdDate
        id
        key
        name
        spaceId
        status
        type
        links {
          base
        }
        icon {
          path
        }
      }
    }
  }
}
`;
const $d33e20668d2d4273$export$69a3209f1a06c04d = (0, $hw4j5.inMemoryCache)();
// Expire the cache if there are errors or edges are empty
const $d33e20668d2d4273$var$expireWhen = (result)=>{
    const { data: data, errors: errors } = result;
    if (!data || errors && errors.length > 0) return true;
    const { results: results } = data.smarts;
    return !results || results.length === 0;
};
const $d33e20668d2d4273$export$9d6625cf80401405 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>$d33e20668d2d4273$export$69a3209f1a06c04d.inMemoryDecorator((0, $2qzBQ.generateHashFromVariables)(variables), ()=>(0, $4qT1X.fetchAgg)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: $d33e20668d2d4273$var$SmartsRecommendedContainerQuery,
            operationName: $d33e20668d2d4273$var$operationName,
            headers: headers
        }), $d33e20668d2d4273$var$expireWhen);
module.exports["smartsRecommendedContainerQuery"] = $d33e20668d2d4273$export$9d6625cf80401405;

});

parcelRegister("2XoKG", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $hw4j5 = parcelRequire("hw4j5");

const $85b6e230af4df339$export$f400862b5c7e6c62 = (0, $hw4j5.inMemoryCache)();
const $85b6e230af4df339$var$GQL_CF_SPACES_OPERATION_NAME = 'SearchPageConfluenceSpacesQuery';
const $85b6e230af4df339$var$getConfluenceSpacesQuery = ()=>`
query ${$85b6e230af4df339$var$GQL_CF_SPACES_OPERATION_NAME}($spaceIds: [ID]!) {
  confluence {
    spaces(ids: $spaceIds) {
      id
      spaceId
      name
      key
      links {
        base
      }
      icon {
        path
      }
    }
  }
}
`;
const $85b6e230af4df339$export$d8fbf668d55936f8 = (spaceIds, headers)=>{
    return $85b6e230af4df339$export$f400862b5c7e6c62.inMemoryDecorator(// TODO: >>>> Limit this to a max string length
    // TODO: Refactor so that it can cache per page id
    spaceIds.join(','), async ()=>{
        if (spaceIds.length === 0) return {
            data: {
                confluence: {
                    spaces: []
                }
            }
        };
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $85b6e230af4df339$var$getConfluenceSpacesQuery(),
            variables: {
                spaceIds: spaceIds
            },
            operationName: $85b6e230af4df339$var$GQL_CF_SPACES_OPERATION_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["confluenceSpacesQuery"] = $85b6e230af4df339$export$d8fbf668d55936f8;

});

parcelRegister("IpMWN", function(module, exports) {

var $4qT1X = parcelRequire("4qT1X");


var $hw4j5 = parcelRequire("hw4j5");

const $ea45c916174bba4e$var$spacesCache = (0, $hw4j5.inMemoryCache)();
const $ea45c916174bba4e$var$GRAPHQL_OPERATION_NAME = 'ConfluenceSpaceKeysToIdsQuery';
const $ea45c916174bba4e$var$getConfluenceSpaceKeysToIdsQuery = ()=>`
query ${$ea45c916174bba4e$var$GRAPHQL_OPERATION_NAME}($spaceKeys: [String]) {
  spaces(spaceKeys: $spaceKeys) {
    nodes {
      id
 	}
  }
}
`;
const $ea45c916174bba4e$export$726cc5bea9d2607e = ({ spaceKeys: spaceKeys, cloudId: cloudId, headers: headers })=>{
    return $ea45c916174bba4e$var$spacesCache.inMemoryDecorator(`${spaceKeys.join(',')}-${cloudId}`, async ()=>{
        // Technically fetchAgg is a util to fetch from AGG, but since we're overriding the URL it works with cc-graphql.
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: $ea45c916174bba4e$var$getConfluenceSpaceKeysToIdsQuery(),
            variables: {
                spaceKeys: spaceKeys
            },
            operationName: $ea45c916174bba4e$var$GRAPHQL_OPERATION_NAME,
            aggAbsoluteUrl: `/gateway/api/ex/confluence/${cloudId}/graphql`,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["confluenceSpaceKeysToIdsQuery"] = $ea45c916174bba4e$export$726cc5bea9d2607e;

});

parcelRegister("6CITI", function(module, exports) {

var $5G9KX = parcelRequire("5G9KX");


var $4Zqgi = parcelRequire("4Zqgi");

const $705af924ede424d6$var$PREFIX = '@atlassian.search-ai.';
const $705af924ede424d6$var$setString = (key, value)=>{
    try {
        (0, $5G9KX.setLocalStorageItem)(`${$705af924ede424d6$var$PREFIX}${key}`, value);
    } catch (error) {
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'setString'
        });
    }
};
const $705af924ede424d6$var$getString = (key)=>{
    return (0, $5G9KX.getLocalStorageItemAsString)(`${$705af924ede424d6$var$PREFIX}${key}`);
};
const $705af924ede424d6$export$74cea4b24a6bc9fa = {
    getString: $705af924ede424d6$var$getString,
    setString: $705af924ede424d6$var$setString
};
module.exports["localStore"] = $705af924ede424d6$export$74cea4b24a6bc9fa;

});

parcelRegister("kIdP4", function(module, exports) {
const $1c4bb92f3ae586c5$export$c9058316764c140e = (...refs)=>(node)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(node);
            else if (ref != null) ref.current = node;
        });
    };
module.exports["mergeRefs"] = $1c4bb92f3ae586c5$export$c9058316764c140e;

});

parcelRegister("a5OFf", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dpPtd = parcelRequire("dpPtd");


var $dh538 = parcelRequire("dh538");





var $aXWIB = parcelRequire("aXWIB");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $cOrQJ = parcelRequire("cOrQJ");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");
var $1yEFx = parcelRequire("1yEFx");


var $9d9t8 = parcelRequire("9d9t8");


var $i2RLU = parcelRequire("i2RLU");


var $2zyFZ = parcelRequire("2zyFZ");


var $ckkm9 = parcelRequire("ckkm9");


var $2OtFZ = parcelRequire("2OtFZ");








var $1qfLF = parcelRequire("1qfLF");


var $cO1el = parcelRequire("cO1el");


var $hmuev = parcelRequire("hmuev");


var $cwkWT = parcelRequire("cwkWT");

var $dcJ7R = parcelRequire("dcJ7R");




var $2W0qg = parcelRequire("2W0qg");


var $5dK2X = parcelRequire("5dK2X");




const $1dfe068c1a1bfcd2$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    dismiss: {
        id: "oauth-message-dismiss",
        defaultMessage: "Dismiss"
    }
});


const $52087ab64c3a7923$var$containerBaseStyles = (0, $ecnYn.xcss)({
    wordBreak: 'break-word',
    borderRadius: 'radius.small',
    backgroundColor: 'color.background.neutral'
});
const $52087ab64c3a7923$var$searchResultsContainerStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.150',
    paddingRight: 'space.150',
    paddingTop: 'space.150',
    paddingBottom: 'space.150'
});
const $52087ab64c3a7923$var$searchDialogContainerStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.100',
    paddingRight: 'space.100',
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});
const $52087ab64c3a7923$var$searchDialogContainerWithLeftPaddingStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.150',
    paddingRight: 'space.100',
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});
const $52087ab64c3a7923$var$connectPressableStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.100',
    paddingRight: 'space.100',
    paddingInline: 'space.150',
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    color: 'color.link',
    ':hover': {
        textDecoration: 'underline',
        color: 'color.link.pressed'
    },
    ':active': {
        textDecoration: 'underline',
        color: 'color.link.pressed'
    },
    whiteSpace: 'nowrap' // so that "Connect" doesn't get broken up needlessly
});
const $52087ab64c3a7923$var$actionsContainer = (0, $ecnYn.xcss)({
    flexBasis: 'fit-content'
});
const $52087ab64c3a7923$export$1b25a7895791d4fc = (props)=>{
    const { content: content, onAuthorize: onAuthorize, onDismiss: onDismiss, isOnSearchDialog: isOnSearchDialog, isBulkConnect: isBulkConnect, testId: testId, oAuthSource: oAuthSource } = props;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const ctaButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        onClick: ()=>onAuthorize(oAuthSource),
        backgroundColor: "color.background.neutral.subtle",
        xcss: $52087ab64c3a7923$var$connectPressableStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        weight: "medium",
        size: "medium",
        color: "color.link"
    }, content.connectText));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cwkWT.default), {
        alignItems: "center",
        templateColumns: isBulkConnect ? 'min-content auto 1fr auto' : 'min-content 1fr auto',
        columnGap: isBulkConnect && isOnSearchDialog ? 'space.075' : 'space.150',
        testId: testId,
        xcss: [
            $52087ab64c3a7923$var$containerBaseStyles,
            isOnSearchDialog ? content.iconNeedsPadding ? $52087ab64c3a7923$var$searchDialogContainerWithLeftPaddingStyles : $52087ab64c3a7923$var$searchDialogContainerStyles : $52087ab64c3a7923$var$searchResultsContainerStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(content.MessageIcon, {
        size: 'small'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: !isBulkConnect && isOnSearchDialog ? 'space.025' : 'space.050',
        alignBlock: "center",
        shouldWrap: true
    }, isOnSearchDialog || isBulkConnect ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        size: "medium",
        as: isBulkConnect ? undefined : 'strong',
        weight: isBulkConnect ? 'medium' : undefined
    }, content.title) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "small",
        as: "h3"
    }, content.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        size: "medium",
        color: isOnSearchDialog ? 'color.text.subtle' : undefined
    }, content.description)), isBulkConnect && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        testId: testId && `${testId}--actions-cta`,
        alignBlock: "center"
    }, ctaButton), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        testId: testId && `${testId}--actions`,
        space: "space.150",
        rowSpace: "space.0",
        alignBlock: "center",
        xcss: $52087ab64c3a7923$var$actionsContainer
    }, !isBulkConnect && ctaButton, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                ...iconProps,
                label: "",
                color: "currentColor"
            }),
        onClick: onDismiss,
        label: formatMessage((0, $1dfe068c1a1bfcd2$export$defe85febe8b728c).dismiss),
        appearance: 'subtle',
        spacing: 'compact'
    })));
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $ccHMk = parcelRequire("ccHMk");





var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");










parcelRequire("1yEFx");








const $5bb43d84305a44a8$export$a2731dd889a27eaf = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        "aria-hidden": "true",
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
        fill: "var(--ds-background-neutral-bold, #292A2E)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 5.33337C10.1097 5.33337 5.33325 10.2298 5.33325 16.2701C5.33325 21.1022 8.3896 25.2018 12.6278 26.6479C13.1609 26.7492 13.3566 26.4107 13.3566 26.1218C13.3566 25.861 13.3467 24.9995 13.3422 24.0856C10.3746 24.7472 9.74847 22.7952 9.74847 22.7952C9.26325 21.5311 8.56412 21.1949 8.56412 21.1949C7.59632 20.5162 8.63707 20.5301 8.63707 20.5301C9.70819 20.6073 10.2722 21.6571 10.2722 21.6571C11.2236 23.3291 12.7675 22.8457 13.3762 22.5663C13.472 21.8594 13.7484 21.377 14.0535 21.1039C11.6842 20.8273 9.19365 19.8895 9.19365 15.6989C9.19365 14.5048 9.61034 13.5292 10.2927 12.7633C10.1819 12.4878 9.81683 11.3755 10.396 9.86903C10.396 9.86903 11.2917 9.57509 13.3301 10.9901C14.181 10.7478 15.0935 10.6262 16 10.6221C16.9065 10.6262 17.8197 10.7478 18.6722 10.9901C20.7081 9.57509 21.6026 9.86903 21.6026 9.86903C22.1832 11.3755 21.8179 12.4878 21.7071 12.7633C22.3911 13.5292 22.8049 14.5048 22.8049 15.6989C22.8049 19.8995 20.3096 20.8244 17.9344 21.0952C18.317 21.4346 18.6579 22.1001 18.6579 23.1205C18.6579 24.5838 18.6455 25.7616 18.6455 26.1218C18.6455 26.4128 18.8375 26.7539 19.3782 26.6465C23.6141 25.1987 26.6666 21.1006 26.6666 16.2701C26.6666 10.2298 21.8909 5.33337 16 5.33337Z",
        fill: "var(--ds-text-inverse, #FFFFFF)"
    }));


var $91de9746dbea2539$exports = {};
$91de9746dbea2539$exports = new URL("github_dark.35a1e263.gif", import.meta.url).toString();


var $500322ca0e641057$exports = {};
$500322ca0e641057$exports = new URL("github_light.9ae56730.gif", import.meta.url).toString();





const $9e845e8f0d3e92f5$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    description: {
        id: "oauth-banner.oauth-social-proof-message.github.description",
        defaultMessage: "Expand your search results to include GitHub PRs, issues, and repos."
    },
    successFlagTitle: {
        id: "oauth-banner.oauth-social-proof-message.github.success-flag-title",
        defaultMessage: "{product} connected"
    },
    successFlagDescription: {
        id: "oauth-banner.oauth-social-proof-message.github.success-flag-description",
        defaultMessage: "You can now find and action on PRs, commits, and repos in Rovo Search and Chat."
    }
});


const $63f6ad3f921e52cf$export$7a4f7369b5d6a78e = ({ colorMode: colorMode })=>{
    return {
        productIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5bb43d84305a44a8$export$a2731dd889a27eaf), null),
        description: (0, $9e845e8f0d3e92f5$export$defe85febe8b728c).description,
        successFlagTitle: (0, $9e845e8f0d3e92f5$export$defe85febe8b728c).successFlagTitle,
        successFlagDescription: (0, $9e845e8f0d3e92f5$export$defe85febe8b728c).successFlagDescription,
        // Use the dark GIF only when the theme is explicitly dark, default to the light GIF otherwise
        imageSrc: colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($91de9746dbea2539$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($500322ca0e641057$exports)))
    };
};


const $0d23e5415599265a$var$contentRegistry = {
    [(0, $b4tvS.ProductKeys).Github]: (0, $63f6ad3f921e52cf$export$7a4f7369b5d6a78e)
};
const $0d23e5415599265a$export$defa06e894d14087 = (product, params)=>$0d23e5415599265a$var$contentRegistry[product](params);





const $ca59f813d2f1dff5$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    dismiss: {
        // NOTE: i18n `id`s are intentionally kept stable across the
        // OAuthMessageWithPreview → OAuthSocialProofMessage rename so existing
        // translations are not lost.
        id: "oauth-banner.oauth-social-proof-message.dismiss",
        defaultMessage: "Dismiss"
    },
    oauthSocialProofMessageTitleLowAdoption: {
        id: "oauth-banner.oauth-social-proof-message.title-low-adoption",
        defaultMessage: "Your team connected {product}"
    },
    oauthSocialProofMessageTitleHighAdoption: {
        id: "oauth-banner.oauth-social-proof-message.title-high-adoption",
        defaultMessage: "{percentage}% of your team has connected apps like {product}"
    },
    oauthSocialProofMessageConnect: {
        id: "oauth-banner.oauth-social-proof-message.connect",
        defaultMessage: "Connect to {product}"
    },
    oauthSocialProofMessageImageAlt: {
        id: "oauth-banner.oauth-social-proof-message.image-alt",
        defaultMessage: "Animated preview of {product} search results"
    }
});


const $a443a61fd09ae17f$var$styles = {
    container: "_zulp12x7 _1reo15vq _18m915vq _2rko1mok _189ee4h9 _1dqonqa1 _1h6d1l7x _kqswh2mm _1e0c1txw _4cvr1fhb _bfhkvuon _1bsb1osq _4t3i1lit",
    content: "_16jlkb7n _1o9zkb7n _i0dl1wug _1q51pxbi _85i5pxbi _bozgv47k _y4tiv47k _1ul9idpf _bfhk1bhr",
    productIcon: "_16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _4cvr1h6o _1bah1h6o",
    titleWrapper: "_16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf",
    titleText: "_1reo15vq _18m915vq _1e0c1ule _1bto1l2s _o5721q9c",
    imageContainer: "_16jlidpf _1o9zidpf _i0dl1wug _1reo15vq _18m915vq _1bsb52fy _kqswh2mm _1e0c1txw _4cvr1fhb _1bah1fhb _bfhki8nm",
    bannerImage: "_1e0c1ule _1bsb1osq _4t3i1osq _5ral1dfr"
};
/**
 * Threshold above which we switch from the low-adoption title
 * ("Your team connected {product}") to the high-adoption title
 * ("{percentage}% of your team has connected apps like {product}").
 */ const $a443a61fd09ae17f$var$TEAM_CONNECTED_MID_TIER_MIN = 30;
const $a443a61fd09ae17f$export$a76ecc112fc9a0f6 = 'oauth-social-proof-message';
const $a443a61fd09ae17f$export$ebc4d6d9761342bc = ({ onAuthorize: onAuthorize, onDismiss: onDismiss, oAuthSource: oAuthSource, product: product, teamConnectedPercentage: teamConnectedPercentage = 0, hidePreviewImage: hidePreviewImage = false })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const products = (0, $1yEFx.useProductConfigs)();
    const { productIcon: productIcon, description: description, imageSrc: imageSrc } = (0, $0d23e5415599265a$export$defa06e894d14087)(product, {
        colorMode: colorMode
    });
    const { displayName: displayName } = products[product] || {};
    const productDisplayName = displayName && typeof displayName === 'string' ? displayName : product; // Pick the title variant based on what percentage of the user's team
    // has already connected — a "social proof" nudge.
    //   <30% → "Your team connected {product}"
    //   ≥30% → "{percentage}% of your team has connected apps like {product}"
    const titleMessage = teamConnectedPercentage >= $a443a61fd09ae17f$var$TEAM_CONNECTED_MID_TIER_MIN ? (0, $ca59f813d2f1dff5$export$defe85febe8b728c).oauthSocialProofMessageTitleHighAdoption : (0, $ca59f813d2f1dff5$export$defe85febe8b728c).oauthSocialProofMessageTitleLowAdoption;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $a443a61fd09ae17f$var$styles.container,
        testId: $a443a61fd09ae17f$export$a76ecc112fc9a0f6
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $a443a61fd09ae17f$var$styles.content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center"
    }, productIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $a443a61fd09ae17f$var$styles.productIcon
    }, productIcon) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $a443a61fd09ae17f$var$styles.titleWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        xcss: $a443a61fd09ae17f$var$styles.titleText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...titleMessage,
        values: {
            percentage: teamConnectedPercentage,
            product: productDisplayName
        }
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        size: "medium",
        color: "color.text",
        maxLines: 2
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        onClick: ()=>onAuthorize(oAuthSource)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...(0, $ca59f813d2f1dff5$export$defe85febe8b728c).oauthSocialProofMessageConnect,
        values: {
            product: productDisplayName
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "default",
        onClick: onDismiss
    }, formatMessage((0, $ca59f813d2f1dff5$export$defe85febe8b728c).dismiss))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $a443a61fd09ae17f$var$styles.imageContainer
    }, !hidePreviewImage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "img",
        src: imageSrc,
        alt: formatMessage((0, $ca59f813d2f1dff5$export$defe85febe8b728c).oauthSocialProofMessageImageAlt, {
            product: productDisplayName
        }),
        xcss: $a443a61fd09ae17f$var$styles.bannerImage
    })));
};






const $270ff42eb089344c$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    authorizationFail: {
        id: "oauth-banner.authorization-fail",
        defaultMessage: "Failed to connect to {product}."
    },
    authorizationSuccess: {
        id: "oauth-banner.authorization-success",
        defaultMessage: "Account connected to {product}."
    },
    connectThirdPartyProductTitle: {
        id: "connect_third_party_product_title",
        defaultMessage: "Your admin has added {product}!"
    },
    connectThirdPartyProductTitleAlternate: {
        id: "connect_third_party_product_title_alternate",
        defaultMessage: "{product} is now available!"
    },
    connectThirdPartyProductDescription: {
        id: "connect_third_party_product_description",
        defaultMessage: "Connect your account to see missing results"
    },
    connect: {
        id: "oauth-message-connect",
        defaultMessage: "Connect"
    }
});



var $5A2fk = parcelRequire("5A2fk");

const $627ae985e76305b5$var$oauthBannerContainerStyles = (0, $ecnYn.xcss)({
    paddingBottom: 'space.075',
    paddingLeft: 'space.100',
    paddingRight: 'space.100'
});
const $627ae985e76305b5$export$4177cdcc6454d6f2 = ({ product: product, outboundAuthUrl: outboundAuthUrl, isOnSearchDialog: isOnSearchDialog, isSmartlink: isSmartlink, useOAuthHandlers: useOAuthHandlers, fireAnalyticsEvent: fireAnalyticsEvent, thirdPartyConfigs: thirdPartyConfigs, teamConnectedPercentage: teamConnectedPercentage })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const products = (0, $1yEFx.useProductConfigs)();
    const [isDismissed, setIsDismissed] = (0, $42omo.useState)(false);
    const productString = product === 'sharepoint' ? 'SharePoint' : products[product]?.displayName || '';
    const Icon = products[product].Icon;
    const showAlternateConnectMessage = product === (0, $b4tvS.ProductKeys).Figma || isSmartlink;
    const connectorSource = isSmartlink ? (0, $9d9t8.SMARTLINKS_CONNECTOR_SOURCE) : (0, $9d9t8.FULL_CONNECTOR_SOURCE);
    const isFPSGithubBanner = !isOnSearchDialog && product === (0, $b4tvS.ProductKeys).Github;
    const showOAuthSocialProofMessage = isFPSGithubBanner && (0, $2OtFZ.serveFPSGitHubSocialProofBannerExperiment)({
        thirdPartyConfigs: thirdPartyConfigs
    });
    const isFPSGithubBannerPromo = isFPSGithubBanner && (0, $2OtFZ.serveFPSGitHubAuthBannerPromo)({
        thirdPartyConfigs: thirdPartyConfigs
    });
    // When the social-proof variant is shown, the connector-specific config
    // (e.g. `github/config.tsx`) owns the success-flag copy. We resolve it
    // here and pass the formatted strings through to `useOAuthHandlers` so
    // the controller stays connector-agnostic.
    const socialProofContent = showOAuthSocialProofMessage ? (0, $0d23e5415599265a$export$defa06e894d14087)((0, $b4tvS.ProductKeys).Github, {
        colorMode: colorMode
    }) : undefined;
    const successFlagTitle = socialProofContent?.successFlagTitle !== undefined ? formatMessage(socialProofContent.successFlagTitle, {
        product: productString
    }) : formatMessage((0, $270ff42eb089344c$export$defe85febe8b728c).authorizationSuccess, {
        product: productString
    });
    const successFlagDescription = socialProofContent?.successFlagDescription !== undefined ? formatMessage(socialProofContent.successFlagDescription) : undefined;
    const { onAuthorize: onAuthorize, onDismiss: onDismiss } = useOAuthHandlers({
        product: product,
        connectorSource: connectorSource,
        successFlagTitle: successFlagTitle,
        successFlagDescription: successFlagDescription,
        showUnderstoodButton: showOAuthSocialProofMessage,
        failFlagTitle: formatMessage((0, $270ff42eb089344c$export$defe85febe8b728c).authorizationFail, {
            product: productString
        }),
        outboundAuthUrl: outboundAuthUrl,
        onCompletedAction: ()=>{
            setIsDismissed(true);
        },
        onDismissAction: ()=>{
            setIsDismissed(true);
            if (isFPSGithubBannerPromo) (0, $5A2fk.snoozeProduct)(product);
            else (0, $5A2fk.increaseProductDismissCount)(product);
        },
        isOnSearchDialog: isOnSearchDialog
    });
    $627ae985e76305b5$var$useBannerShownAnalytics({
        fireAnalyticsEvent: fireAnalyticsEvent,
        isOnSearchDialog: isOnSearchDialog,
        product: product,
        connectorSource: connectorSource
    });
    const title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...showAlternateConnectMessage ? (0, $270ff42eb089344c$export$defe85febe8b728c).connectThirdPartyProductTitleAlternate : (0, $270ff42eb089344c$export$defe85febe8b728c).connectThirdPartyProductTitle,
        values: {
            product: productString
        }
    });
    const description = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $270ff42eb089344c$export$defe85febe8b728c).connectThirdPartyProductDescription);
    if (isDismissed) return null;
    const messageContent = {
        title: title,
        description: description,
        connectText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $270ff42eb089344c$export$defe85febe8b728c).connect),
        MessageIcon: Icon
    };
    const messageProps = {
        content: messageContent,
        onAuthorize: onAuthorize,
        onDismiss: ()=>{
            fireAnalyticsEvent((0, $i2RLU.onBannerDismissed)({
                isOnSearchDialog: isOnSearchDialog,
                oAuthSource: isOnSearchDialog ? (0, $ckkm9.OAuthSource).quickFindOAuthBanner : (0, $ckkm9.OAuthSource).searchPageOAuthBanner,
                componentName: 'OAuthBanner',
                product: product,
                connectorSource: connectorSource
            }));
            return onDismiss();
        }
    };
    if (showOAuthSocialProofMessage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a443a61fd09ae17f$export$ebc4d6d9761342bc), {
        product: product,
        onAuthorize: onAuthorize,
        onDismiss: messageProps.onDismiss,
        oAuthSource: (0, $ckkm9.OAuthSource).searchPageOAuthBanner,
        teamConnectedPercentage: teamConnectedPercentage
    });
    return isOnSearchDialog ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $627ae985e76305b5$var$oauthBannerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52087ab64c3a7923$export$1b25a7895791d4fc), {
        ...messageProps,
        isOnSearchDialog: true,
        oAuthSource: (0, $ckkm9.OAuthSource).quickFindOAuthBanner
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52087ab64c3a7923$export$1b25a7895791d4fc), {
        ...messageProps,
        oAuthSource: (0, $ckkm9.OAuthSource).searchPageOAuthBanner
    });
};
const $627ae985e76305b5$var$useBannerShownAnalytics = ({ fireAnalyticsEvent: fireAnalyticsEvent, isOnSearchDialog: isOnSearchDialog, product: product, connectorSource: connectorSource })=>{
    (0, $42omo.useEffect)(()=>{
        fireAnalyticsEvent((0, $2zyFZ.onBannerShown)({
            isOnSearchDialog: isOnSearchDialog,
            oAuthSource: isOnSearchDialog ? (0, $ckkm9.OAuthSource).quickFindOAuthBanner : (0, $ckkm9.OAuthSource).searchPageOAuthBanner,
            componentName: 'OAuthBanner',
            product: product,
            connectorSource: connectorSource
        }));
    }, [
        fireAnalyticsEvent,
        isOnSearchDialog,
        product,
        connectorSource
    ]);
};



var $def8z = parcelRequire("def8z");





var $RWXHe = parcelRequire("RWXHe");


var $6RGiC = parcelRequire("6RGiC");

const $4d7a3d27ae0dfe35$export$83d3a14acfdb8d27 = ({ isOnSearchDialog: isOnSearchDialog, headlessVisiblePlacement: HeadlessVisiblePlacement, thirdPartyConfigs: thirdPartyConfigs, eligibleProducts: eligibleProducts, useOAuthHandlers: useOAuthHandlers, fireAnalyticsEvent: fireAnalyticsEvent, teamConnectedPercentage: teamConnectedPercentage })=>{
    const suppressBanner = (0, $6RGiC.useShouldSuppressBannerForAnimation)();
    if ((0, $dh538.fg)('rovo_search_3p_banner_opt_out') || isOnSearchDialog && suppressBanner) return null;
    // First product that needs OAuth (eligibleProducts is already ordered + filtered at call site)
    const displayedProduct = eligibleProducts.find((product)=>thirdPartyConfigs[product]?.userNeedsOAuth);
    const displayedProduct3PConfig = displayedProduct ? thirdPartyConfigs[displayedProduct] : undefined;
    const outboundAuthUrl = displayedProduct3PConfig?.outboundAuthUrl;
    // a little redundant way of getting this value, but just making use of common function
    const isSmartlink = (0, $def8z.isProductSmartlink)({
        productKey: displayedProduct,
        thirdPartyConfigs: thirdPartyConfigs
    });
    if (!displayedProduct || !outboundAuthUrl) return null;
    if (isOnSearchDialog && (0, $2OtFZ.serveQF3PBannerExperiment)()) {
        const isHeadlessPlacementEnabled = (0, $dh538.fg)('post-office_enable_search-quick-find-headless');
        if (isHeadlessPlacementEnabled && HeadlessVisiblePlacement) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(HeadlessVisiblePlacement, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $RWXHe.PlacementSlot), {
            trackImpressionOnMount: true
        });
    }
    const oauthBannerComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $627ae985e76305b5$export$4177cdcc6454d6f2), {
        product: displayedProduct,
        outboundAuthUrl: outboundAuthUrl,
        useOAuthHandlers: useOAuthHandlers,
        isSmartlink: isSmartlink,
        isOnSearchDialog: isOnSearchDialog,
        fireAnalyticsEvent: fireAnalyticsEvent,
        thirdPartyConfigs: thirdPartyConfigs,
        teamConnectedPercentage: teamConnectedPercentage
    });
    return isOnSearchDialog ? oauthBannerComponent : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dpPtd.FlagsProvider), null, oauthBannerComponent);
};
module.exports["OAuthContainer"] = $4d7a3d27ae0dfe35$export$83d3a14acfdb8d27;

});

parcelRegister("i2RLU", function(module, exports) {
// @ts-ignore - this is not a valid package entry point and cannot be resolved when using a modern Typescript 'moduleResolution' setting

var $6yNqK = parcelRequire("6yNqK");

const $414cef57e6aae72a$export$97e8379351820edc = ({ isOnSearchDialog: isOnSearchDialog, oAuthSource: oAuthSource, componentName: componentName, product: product, connectorSource: connectorSource })=>({
        source: isOnSearchDialog ? (0, $6yNqK.SEARCH_DIALOG_EVENT_SOURCE) : (0, $6yNqK.EVENT_SOURCE),
        eventType: 'ui',
        actionSubject: 'button',
        action: 'clicked',
        actionSubjectId: 'searchBannerDismissed',
        attributes: {
            // The fireAnalytics function in useAnalytics requires attributes to be defined in additionalAttributes
            // The fireAnalytics function in useQuickFindAnalytics does not require attributes to be defined in additionalAttributes
            // We should consolidate analytics signatures between QF and FPS (https://product-fabric.atlassian.net/browse/QS-7746)
            ...isOnSearchDialog ? {
                componentName: componentName,
                oAuthSource: oAuthSource,
                product: product,
                connectorSource: connectorSource
            } : {
                additionalAttributes: {
                    componentName: componentName,
                    oAuthSource: oAuthSource,
                    product: product,
                    connectorSource: connectorSource
                }
            }
        }
    });
module.exports["onBannerDismissed"] = $414cef57e6aae72a$export$97e8379351820edc;

});

parcelRegister("2zyFZ", function(module, exports) {
// @ts-ignore - this is not a valid package entry point and cannot be resolved when using a modern Typescript 'moduleResolution' setting

var $6yNqK = parcelRequire("6yNqK");

const $a5eed839749b1cd0$export$7d1e74b831505b41 = ({ isOnSearchDialog: isOnSearchDialog, oAuthSource: oAuthSource, componentName: componentName, product: product, connectorSource: connectorSource })=>({
        source: isOnSearchDialog ? (0, $6yNqK.SEARCH_DIALOG_EVENT_SOURCE) : (0, $6yNqK.EVENT_SOURCE),
        eventType: 'track',
        actionSubject: 'searchBanner',
        action: 'shown',
        attributes: {
            // The fireAnalytics function in useAnalytics requires attributes to be defined in additionalAttributes
            // The fireAnalytics function in useQuickFindAnalytics does not require attributes to be defined in additionalAttributes
            // We should consolidate analytics signatures between QF and FPS (https://product-fabric.atlassian.net/browse/QS-7746)
            ...isOnSearchDialog ? {
                componentName: componentName,
                oAuthSource: oAuthSource,
                product: product,
                connectorSource: connectorSource
            } : {
                additionalAttributes: {
                    componentName: componentName,
                    oAuthSource: oAuthSource,
                    product: product,
                    connectorSource: connectorSource
                }
            }
        }
    });
module.exports["onBannerShown"] = $a5eed839749b1cd0$export$7d1e74b831505b41;

});

parcelRegister("8UOsA", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ecnYn = parcelRequire("ecnYn");


var $2W0qg = parcelRequire("2W0qg");




const $7ad591125a6bb6cf$export$e5220a1129d6e11c = (0, $aXWIB.defineMessages)({
    feedbackButton: {
        id: "search_common.feedback_button",
        defaultMessage: "Give feedback"
    }
});


const $db4f68a9c93392e4$var$feedbackButtonStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    color: 'color.link',
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    padding: 'space.0',
    ':hover': {
        textDecoration: 'underline',
        cursor: 'pointer'
    }
});
const $db4f68a9c93392e4$var$feedbackButtonSmallStyles = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $db4f68a9c93392e4$export$116fedbe5e2e2bd8 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { onClick: onClick, size: t1 } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const t2 = size === "small" && $db4f68a9c93392e4$var$feedbackButtonSmallStyles;
    let t3;
    if ($[0] !== t2) {
        t3 = [
            $db4f68a9c93392e4$var$feedbackButtonStyles,
            t2
        ];
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $7ad591125a6bb6cf$export$e5220a1129d6e11c).feedbackButton);
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] !== onClick || $[4] !== t3) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            xcss: t3,
            onClick: onClick
        }, t4);
        $[3] = onClick;
        $[4] = t3;
        $[5] = t5;
    } else t5 = $[5];
    return t5;
} : ({ onClick: onClick, size: size = 'medium' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        xcss: [
            $db4f68a9c93392e4$var$feedbackButtonStyles,
            size === 'small' && $db4f68a9c93392e4$var$feedbackButtonSmallStyles
        ],
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $7ad591125a6bb6cf$export$e5220a1129d6e11c).feedbackButton));
module.exports["FeedbackButton"] = $db4f68a9c93392e4$export$116fedbe5e2e2bd8;

});

parcelRegister("7Yuqm", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $6uGcC = parcelRequire("6uGcC");


var $iLCTn = parcelRequire("iLCTn");


var $5XpfZ = parcelRequire("5XpfZ");

const $135f97f348b2ff15$var$packageName = "platform-pkg";
const $135f97f348b2ff15$var$packageVersion = "0.0.0-use.local";
const $135f97f348b2ff15$export$2db401a6b81eceee = `${$135f97f348b2ff15$var$packageName}@${$135f97f348b2ff15$var$packageVersion}`;
const $135f97f348b2ff15$export$25dc0a1e75f58d8f = '9b88e53b-d04d-4f1c-ae85-6d7f59d1ca7a';
const $135f97f348b2ff15$export$d04cd98bb7625919 = 'customfield_10047';
const $135f97f348b2ff15$export$83c8d7110915321e = 'search-page';


const $a7df8303f8002da0$export$e0fccaef47ee61b8 = (keys)=>{
    return JSON.stringify(keys);
};



const $2ed018b70d6fe5e9$export$67d3c3516a0ee4ec = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("6yoZS")).then((module)=>{
        return {
            default: module.default
        };
    }));

const $2ed018b70d6fe5e9$var$AkFeedbackFlag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("6yoZS")).then(({ FeedbackFlag: FeedbackFlag })=>{
        return {
            default: FeedbackFlag
        };
    }));
const $2ed018b70d6fe5e9$var$FeedbackCollector = ({ cloudId: cloudId, experimentConfig: experimentConfig, isOpen: isOpen, primaryProduct: primaryProduct, product: product, setIsOpen: setIsOpen, onSubmit: onSubmit, onCancel: onCancel, source: source, userId: userId, userName: userName, mode: mode, requestId: requestId, traceId: traceId })=>{
    const { locale: locale } = (0, $aXWIB.useIntl)();
    const [displayFlag, setDisplayFlag] = (0, $42omo.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2ed018b70d6fe5e9$export$67d3c3516a0ee4ec, {
        locale: locale,
        onClose: ()=>{
            onCancel?.();
            setIsOpen(false);
        },
        onSubmit: ()=>{
            onSubmit?.();
            setDisplayFlag(true);
            setIsOpen(false);
        },
        atlassianAccountId: userId,
        name: userName,
        entrypointId: (0, $135f97f348b2ff15$export$25dc0a1e75f58d8f),
        additionalFields: [
            {
                id: (0, $135f97f348b2ff15$export$d04cd98bb7625919),
                value: (0, $a7df8303f8002da0$export$e0fccaef47ee61b8)({
                    experimentLayers: experimentConfig.backendExperiment?.experimentLayers,
                    frontendExperiments: experimentConfig.frontendExperiments,
                    version: (0, $135f97f348b2ff15$export$2db401a6b81eceee),
                    release: (0, $iLCTn.getProductReleaseVersion)(primaryProduct),
                    source: source,
                    product: product,
                    primaryProduct: primaryProduct,
                    // JQL has an issue with "contains" search. Use this value to filter out JQL feedback.
                    primaryProductFilterString: `primaryProduct${primaryProduct}`,
                    cloudId: cloudId,
                    userId: userId,
                    isHello: (0, $5XpfZ.isHello)(cloudId),
                    mode: mode,
                    requestId: requestId,
                    traceId: traceId
                })
            }
        ]
    })), displayFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6uGcC.default), {
        onDismissed: ()=>setDisplayFlag(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($2ed018b70d6fe5e9$var$AkFeedbackFlag, {
        locale: locale
    }))));
};
var $2ed018b70d6fe5e9$export$2e2bcd8739ae039 = $2ed018b70d6fe5e9$var$FeedbackCollector;
module.exports["default"] = $2ed018b70d6fe5e9$export$2e2bcd8739ae039;

});

parcelRegister("iLCTn", function(module, exports) {
const $e71cbd5e593c3cac$var$memoizedQuerySelector = (selectors)=>{
    let element = null;
    return ()=>{
        if (!element) element = document.querySelector(selectors);
        return element;
    };
};
const $e71cbd5e593c3cac$export$d521605fb33b0dfd = (product)=>{
    switch(product?.toLowerCase()){
        case 'confluence':
            return window.__buildInfo?.FRONTEND_VERSION || 'noversion';
        case 'jira':
            return window.BUILD_KEY;
        // @ts-ignore - TS2872 TypeScript 5.9.2 upgrade
        case 'townsquare':
            const versionMeta = $e71cbd5e593c3cac$var$memoizedQuerySelector('meta[name="release-version"]');
            if (versionMeta instanceof HTMLMetaElement) return versionMeta.content;
    }
    return 'noversion';
};
module.exports["getProductReleaseVersion"] = $e71cbd5e593c3cac$export$d521605fb33b0dfd;

});

parcelRegister("6yoZS", function(module, exports) {

let $4c594eef01830b0b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4c594eef01830b0b$var$load("hhss7"),
    $4c594eef01830b0b$var$load("cyGuT")
]).then(()=>parcelRequire('biiXa'));

});

parcelRegister("eoZmS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");


var $dpPtd = parcelRequire("dpPtd");


var $8tdj3 = parcelRequire("8tdj3");


var $eXmBZ = parcelRequire("eXmBZ");


var $lGgRw = parcelRequire("lGgRw");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $3gadb = parcelRequire("3gadb");


var $dnIVK = parcelRequire("dnIVK");


var $j4ply = parcelRequire("j4ply");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");
var $1yEFx = parcelRequire("1yEFx");


var $2OtFZ = parcelRequire("2OtFZ");


var $YqPsE = parcelRequire("YqPsE");




const $c62e19c9051d98ef$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    authorizeConnectThirdPartyProduct: {
        id: "sidebar-authorize_connect_third_party_product",
        defaultMessage: "Your admin has added <strong>{product}!</strong>{br}\n\t\t\tConnect your account to see missing results, including documents only you have access to.\n\t\t"
    },
    authorizeConnectThirdPartyProductAlternate: {
        id: "sidebar-authorize_connect_third_party_product_alternate_msg",
        defaultMessage: "<strong>{product} is now available!</strong>{br}\n\t\t\tConnect your account to see missing results, including content only you have access to.\n\t\t"
    },
    dismiss: {
        id: "sidebar-oauth-warning-dismiss",
        defaultMessage: "Dismiss"
    },
    authorize: {
        id: "sidebar-oauth-warning-authorize",
        defaultMessage: "Authorize"
    },
    authorizationFail: {
        id: "sidebar-oauth-warning.authorization-fail",
        defaultMessage: "Failed to connect to {product}."
    },
    authorizationSuccess: {
        id: "sidebar-oauth-warning.authorization-success",
        defaultMessage: "Successfully connected to {product}."
    },
    notNow: {
        id: "sidebar-oauth-warning.not-now",
        defaultMessage: "Not now"
    },
    connect: {
        id: "sidebar-oauth-warning.connect",
        defaultMessage: "Connect"
    },
    appFilterTooltipContent: {
        id: "sidebar-oauth-warning.app-filter-tooltip-content",
        defaultMessage: "Connect your account to see missing results, including documents only you have access to."
    },
    appFilterTooltipContentAlternate: {
        id: "sidebar-oauth-warning.app-filter-tooltip-content-alternate",
        defaultMessage: "Connect your account to see missing results, including content only you have access to."
    }
});


const $c151e079e3af8d1c$var$popupContentStyles = (0, $ecnYn.xcss)({
    width: '20rem',
    padding: 'space.200',
    display: 'flex',
    flexDirection: 'column'
});
const $c151e079e3af8d1c$var$buttonContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'row'
});
const $c151e079e3af8d1c$var$buttonStyles = (0, $ecnYn.xcss)({
    margin: 'space.100'
});
const $c151e079e3af8d1c$var$infoIconStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.050',
    cursor: 'pointer'
});
const $c151e079e3af8d1c$var$popupTriggerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
});
const $c151e079e3af8d1c$var$connectButtonStyles = (0, $ecnYn.xcss)({
    marginLeft: 'auto',
    right: 'space.200',
    display: 'flex',
    flexDirection: 'column'
});
const $c151e079e3af8d1c$var$sidebarStyles = (0, $ecnYn.xcss)({
    width: '100%'
});
const $c151e079e3af8d1c$var$connectTextStyles = (0, $ecnYn.xcss)({
    color: 'color.link',
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    ':hover': {
        color: 'color.link.pressed',
        textDecoration: 'underline'
    }
});
const $c151e079e3af8d1c$var$singleSelectConnectTextStyles = (0, $ecnYn.xcss)({
    color: 'color.link',
    font: 'font.body.small',
    fontWeight: 'font.weight.medium',
    ':hover': {
        color: 'color.link.pressed',
        textDecoration: 'underline'
    }
});
const $c151e079e3af8d1c$export$14011507d36518b5 = ({ product: product, isSmartlink: isSmartlink, isInline: isInline, trigger: trigger, isOnSearchDialog: isOnSearchDialog, searchQuery: searchQuery, useOAuthHandlers: useOAuthHandlers, useIsUserOAuthed: useIsUserOAuthed, option: option, index: index, postAuthAction: postAuthAction, oAuthSource: oAuthSource, datasourceId: datasourceId, thirdPartyConfigs: thirdPartyConfigs, onAppFilterClick: onAppFilterClick })=>{
    const products = (0, $1yEFx.useProductConfigs)();
    const [{ cloudId: cloudId }] = (0, $j4ply.useBootstrap)();
    const [isPopupOpen, setIsPopupOpen] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { userNeedsOAuth: userNeedsOAuth, outboundAuthUrl: outboundAuthUrl } = useIsUserOAuthed(product, datasourceId);
    const fireOAuthHovered = (0, $dnIVK.useFireOAuthHovered)({
        cloudId: cloudId || '',
        product: product || '',
        isOnSearchDialog: isOnSearchDialog,
        thirdPartyConfigs: thirdPartyConfigs || {}
    });
    // For Forge connectors, use workspaceName from thirdPartyConfigs
    const workspaceName = thirdPartyConfigs ? (0, $YqPsE.getWorkspaceNameFromProduct)(product, thirdPartyConfigs) : undefined;
    const productString = product && workspaceName || product && products[product]?.displayName || '';
    const { onAuthorize: onAuthorize, onDismiss: onDismiss } = useOAuthHandlers({
        product: product,
        successFlagTitle: formatMessage((0, $c62e19c9051d98ef$export$defe85febe8b728c).authorizationSuccess, {
            product: productString
        }),
        failFlagTitle: formatMessage((0, $c62e19c9051d98ef$export$defe85febe8b728c).authorizationFail, {
            product: productString
        }),
        outboundAuthUrl: outboundAuthUrl || '',
        onCompletedAction: ()=>{
            setIsPopupOpen(false);
            option?.showFilter();
            option?.onSelect();
            postAuthAction?.();
        },
        onDismissAction: ()=>{
            setIsPopupOpen(false);
        },
        isOnSearchDialog: isOnSearchDialog,
        query: searchQuery,
        datasourceId: datasourceId
    });
    const connectMessage = product === (0, $b4tvS.ProductKeys).Figma || isSmartlink ? (0, $c62e19c9051d98ef$export$defe85febe8b728c).authorizeConnectThirdPartyProductAlternate : (0, $c62e19c9051d98ef$export$defe85febe8b728c).authorizeConnectThirdPartyProduct;
    //This component is a functional wrapper that turns the trigger prop into a popup trigger.
    // if no warning is needed, we just render the trigger
    if (!product || !userNeedsOAuth || !outboundAuthUrl) return trigger({
        isDisabled: false
    });
    const handleClickConnect = ()=>{
        onAppFilterClick?.();
        // Skip popup and connect immediately if either of these experiments are enabled
        // serveOneClick3PConnectExperiment was a SHIP decision so this will always return true
        // We aren't cleaning this experiment up in the code since there is a growth holdout attached to it
        if ((0, $2OtFZ.serveOneClick3PConnectExperiment)() || (0, $2OtFZ.isInUnifiedSearch3PConnectImprovementsTestCohort)()) {
            onAuthorize(oAuthSource);
            return;
        }
        setIsPopupOpen(!isPopupOpen);
    };
    const handleConnectHover = ()=>{
        setTimeout(()=>{
            fireOAuthHovered(oAuthSource);
        }, 1000);
    };
    const connectButton = ()=>{
        const tooltipMessage = product === (0, $b4tvS.ProductKeys).Figma || isSmartlink ? (0, $c62e19c9051d98ef$export$defe85febe8b728c).appFilterTooltipContentAlternate : (0, $c62e19c9051d98ef$export$defe85febe8b728c).appFilterTooltipContent;
        switch((0, $2OtFZ.getUnifiedSearch3PConnectImprovementsCohort)()){
            case 'icon-and-tooltip':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                    testId: "connect-button-tooltip",
                    content: formatMessage(tooltipMessage)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    testId: "connect-button-with-context",
                    xcss: $c151e079e3af8d1c$var$connectButtonStyles,
                    onMouseEnter: handleConnectHover
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
                    space: "space.050",
                    alignBlock: "center"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    xcss: (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? $c151e079e3af8d1c$var$singleSelectConnectTextStyles : $c151e079e3af8d1c$var$connectTextStyles
                }, formatMessage((0, $c62e19c9051d98ef$export$defe85febe8b728c).connect)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
                    testId: "link-external-icon",
                    label: "link-external",
                    color: "var(--ds-icon-brand, #1868DB)",
                    size: "small"
                }))));
            case 'icon-only':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    testId: "connect-button-with-context",
                    xcss: $c151e079e3af8d1c$var$connectButtonStyles,
                    onMouseEnter: handleConnectHover
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
                    space: "space.050",
                    alignBlock: "center"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    xcss: (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? $c151e079e3af8d1c$var$singleSelectConnectTextStyles : $c151e079e3af8d1c$var$connectTextStyles
                }, formatMessage((0, $c62e19c9051d98ef$export$defe85febe8b728c).connect)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
                    testId: "link-external-icon",
                    label: "link-external",
                    color: "var(--ds-icon-brand, #1868DB)",
                    size: "small"
                })));
            case 'tooltip-only':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                    testId: "connect-button-tooltip",
                    content: formatMessage(tooltipMessage)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    testId: "connect-button-with-context",
                    xcss: $c151e079e3af8d1c$var$connectButtonStyles,
                    onMouseEnter: handleConnectHover
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    xcss: (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? $c151e079e3af8d1c$var$singleSelectConnectTextStyles : $c151e079e3af8d1c$var$connectTextStyles
                }, formatMessage((0, $c62e19c9051d98ef$export$defe85febe8b728c).connect))));
            // control
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    xcss: $c151e079e3af8d1c$var$connectButtonStyles,
                    onMouseEnter: handleConnectHover
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    xcss: (0, $2OtFZ.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? $c151e079e3af8d1c$var$singleSelectConnectTextStyles : $c151e079e3af8d1c$var$connectTextStyles
                }, formatMessage((0, $c62e19c9051d98ef$export$defe85febe8b728c).connect)));
        }
    };
    const triggerComponent = (triggerProps)=>{
        const oAuthWarning = isInline ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $c151e079e3af8d1c$var$infoIconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
            label: "oauth warning",
            color: "var(--ds-icon-brand, #1868DB)",
            size: "small"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, connectButton());
        return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            onClick: handleClickConnect,
            onMouseEnter: handleConnectHover,
            xcss: [
                $c151e079e3af8d1c$var$popupTriggerStyles,
                !isInline && !isOnSearchDialog && $c151e079e3af8d1c$var$sidebarStyles
            ]
        }, trigger({
            oAuthWarning: oAuthWarning,
            isDisabled: true,
            triggerProps: triggerProps
        })));
    };
    const isFurtherDownThanFourth = index && index > 3;
    const rightRailPopupPlacement = isFurtherDownThanFourth ? 'left-end' : 'left-start';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        isOpen: isPopupOpen,
        onClose: ()=>setIsPopupOpen(false),
        placement: isOnSearchDialog || isInline ? 'bottom-start' : rightRailPopupPlacement,
        trigger: triggerComponent,
        shouldRenderToParent: true,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $c151e079e3af8d1c$var$popupContentStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
                space: "space.100"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, formatMessage(connectMessage, {
                product: productString,
                strong: (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                        as: "strong"
                    }, text),
                br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("br", null)
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
                xcss: $c151e079e3af8d1c$var$buttonContainerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
                xcss: $c151e079e3af8d1c$var$buttonStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                onClick: onDismiss
            }, formatMessage((0, $c62e19c9051d98ef$export$defe85febe8b728c).notNow))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
                xcss: $c151e079e3af8d1c$var$buttonStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                onClick: ()=>onAuthorize(oAuthSource),
                appearance: "primary"
            }, formatMessage((0, $c62e19c9051d98ef$export$defe85febe8b728c).connect)))))
    });
};
const $c151e079e3af8d1c$export$3415e5401c1f1ae1 = (props)=>{
    return props.isOnSearchDialog || props.skipFlagsProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c151e079e3af8d1c$export$14011507d36518b5, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dpPtd.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c151e079e3af8d1c$export$14011507d36518b5, props));
};
module.exports["OAuthWarningWrapper"] = $c151e079e3af8d1c$export$3415e5401c1f1ae1;

});

parcelRegister("YqPsE", function(module, exports) {

var $b4tvS = parcelRequire("b4tvS");


var $9d9t8 = parcelRequire("9d9t8");

const $7b8e63dc3b89f14f$export$ee0bd2121a6df2d5 = (product, thirdPartyConfigs)=>{
    let workspaceName;
    if (product && thirdPartyConfigs) {
        // Check if it's a 3P product or Forge connector
        const is3POrForge = (0, $b4tvS.is3pProductKey)(product) || (0, $9d9t8.isForgeConnectorProductKey)(product);
        if (is3POrForge) {
            const config = thirdPartyConfigs[product];
            const shouldDisplayWorkspaceName = config?.displayWorkspaceNameAsProductName;
            const shouldUseFanOutConnector = config?.fanOutConnectorSources;
            if (shouldDisplayWorkspaceName || shouldUseFanOutConnector) workspaceName = config?.workspaceName;
        }
    }
    return workspaceName;
};
module.exports["getWorkspaceNameFromProduct"] = $7b8e63dc3b89f14f$export$ee0bd2121a6df2d5;

});

parcelRegister("5xGHP", function(module, exports) {
const $00b64bc742da3325$export$abf7f7ce81b5b4bb = ({ action: action, actionSubjectId: actionSubjectId, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'track',
        action: action,
        actionSubject: 'appSelector',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });
module.exports["onAppFilterSelect"] = $00b64bc742da3325$export$abf7f7ce81b5b4bb;

});

parcelRegister("kRxMN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");


var $bHjhd = parcelRequire("bHjhd");


var $dh538 = parcelRequire("dh538");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $5iakG = parcelRequire("5iakG");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $9rRKJ = parcelRequire("9rRKJ");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $1Whri = parcelRequire("1Whri");


var $2g1PW = parcelRequire("2g1PW");


var $auNCB = parcelRequire("auNCB");

var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $fVUfS = parcelRequire("fVUfS");

var $iXCQx = parcelRequire("iXCQx");




const $97d67a1241dac654$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    results: {
        id: "search-page.ai-mode.results",
        defaultMessage: "Results"
    },
    aiMode: {
        id: "search-page.ai-mode.ai-mode",
        defaultMessage: "AI Mode"
    }
});





const $9b3ba1f7e3fd9ab7$export$82eafebb825fc23f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_28_24028)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M6.85547 1.51562C8.12151 1.4809 9.35861 1.84767 10.3965 2.55078L8.6416 3.42871C8.13013 3.2267 7.58107 3.11916 7.02051 3.11914C5.84959 3.11914 4.7264 3.58415 3.89844 4.41211C3.07057 5.24006 2.60547 6.36334 2.60547 7.53418C2.6056 8.70484 3.07069 9.82744 3.89844 10.6553C4.7264 11.4832 5.84959 11.9482 7.02051 11.9482C8.19136 11.9482 9.31466 11.4832 10.1426 10.6553C10.6138 10.1839 10.9673 9.61692 11.1846 9H12.8584C12.6582 9.79708 12.2963 10.552 11.7852 11.2139L14.9482 14.4326C15.0899 14.5858 15.166 14.7885 15.1611 14.9971C15.1562 15.2056 15.0706 15.4045 14.9219 15.5508C14.7732 15.697 14.5728 15.7797 14.3643 15.7812C14.1557 15.7827 13.9545 15.7027 13.8037 15.5586L10.6426 12.3428C9.42299 13.2614 7.90008 13.6825 6.38184 13.5205C4.86341 13.3584 3.46313 12.6253 2.46484 11.4697C1.46662 10.3142 0.944698 8.82266 1.00488 7.29688C1.0651 5.77111 1.70293 4.32521 2.78906 3.25195C3.87532 2.17867 5.32899 1.55751 6.85547 1.51562Z",
        fill: "url(#pattern0_28_24028)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M11.3958 2.42259C11.4884 2.16884 11.7297 2 11.9998 2C12.2699 2 12.5116 2.16884 12.6042 2.42259L13.1316 3.86825L14.5774 4.39558C14.8311 4.48814 15 4.72946 15 4.99959C15 5.26972 14.8311 5.51144 14.5774 5.604L13.1316 6.13133L12.6042 7.57699C12.5116 7.83075 12.2703 7.99958 12.0002 7.99958C11.7301 7.99958 11.4884 7.83075 11.3958 7.57699L10.8684 6.13133L9.42263 5.604C9.16885 5.51144 9 5.27012 9 4.99999C9 4.72986 9.16885 4.48814 9.42263 4.39558L10.8684 3.86825L11.3958 2.42259Z",
        fill: "url(#pattern1_28_24028)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("pattern", {
        id: "pattern0_28_24028",
        patternContentUnits: "objectBoundingBox",
        width: "1",
        height: "1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("use", {
        href: "#image0_28_24028",
        transform: "matrix(0.00196772 0 0 0.00195312 -0.00373519 0)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("pattern", {
        id: "pattern1_28_24028",
        patternContentUnits: "objectBoundingBox",
        width: "1",
        height: "1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("use", {
        href: "#image0_28_24028",
        transform: "scale(0.00195312)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_28_24028"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "16",
        height: "16",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("image", {
        id: "image0_28_24028",
        width: "512",
        height: "512",
        preserveAspectRatio: "none",
        href: "data:image/png;base64,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"
    })));


const $af57685ca39b004e$var$styles = {
    root: "_2rko12b0 _1dqonqa1 _189ee4h9 _1h6d1l7x _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _bfhk1j9a",
    tabOptionStyles: "_2rko12b0 _bfhk1j9a _19bv12x7 _u5f3u2gc _4t3iqslr",
    tabOptionLinkStyles: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _9oik1r31 _1bnxglyw _jf4cnqa1",
    tabOptionSelectedStyles: "_bfhk15s3",
    searchIconWrapperStyles: "_1bsb7vkz _4t3i7vkz"
};
const $af57685ca39b004e$export$e1e2cdfa7f3f030c = ({ query: query, tenantDomain: tenantDomain })=>{
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $af57685ca39b004e$var$styles.root
    }, /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
        space: "space.0"
    }, /*#__PURE__*/ $42omo.createElement((0, $fVUfS.default), {
        xcss: (0, $1Whri.cx)($af57685ca39b004e$var$styles.tabOptionStyles, $af57685ca39b004e$var$styles.tabOptionSelectedStyles)
    }, /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($2g1PW))), {
        color: "var(--ds-icon-selected, #1868DB)",
        label: ""
    }), /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        color: "color.text.selected",
        weight: "medium"
    }, intl.formatMessage((0, $97d67a1241dac654$export$defe85febe8b728c).results)))), /*#__PURE__*/ $42omo.createElement((0, $auNCB.default), {
        xcss: (0, $1Whri.cx)($af57685ca39b004e$var$styles.tabOptionStyles, $af57685ca39b004e$var$styles.tabOptionLinkStyles),
        href: `${tenantDomain}/wiki/ai-search/?aiSearchQuery=${query}`
    }, /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $af57685ca39b004e$var$styles.searchIconWrapperStyles
    }, /*#__PURE__*/ $42omo.createElement((0, $9b3ba1f7e3fd9ab7$export$82eafebb825fc23f), null)), /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        color: "color.text.subtle",
        weight: "medium"
    }, intl.formatMessage((0, $97d67a1241dac654$export$defe85febe8b728c).aiMode))))));
};



var $gCEkV = parcelRequire("gCEkV");


var $86ob4 = parcelRequire("86ob4");


var $5eWut = parcelRequire("5eWut");


var $3CshZ = parcelRequire("3CshZ");


var $j4ply = parcelRequire("j4ply");


var $djVCD = parcelRequire("djVCD");

parcelRequire("ehGUC");
var $lx1ar = parcelRequire("lx1ar");
var $gHwfH = parcelRequire("gHwfH");
var $fJFyr = parcelRequire("fJFyr");
var $a97k3 = parcelRequire("a97k3");


var $fw303 = parcelRequire("fw303");


var $k7ise = parcelRequire("k7ise");





var $iUihD = parcelRequire("iUihD");


var $5X4Ay = parcelRequire("5X4Ay");


var $5VnRb = parcelRequire("5VnRb");


var $F3Hv6 = parcelRequire("F3Hv6");


var $hHAPz = parcelRequire("hHAPz");


var $2a0ps = parcelRequire("2a0ps");


var $dQXZO = parcelRequire("dQXZO");


var $aGXLL = parcelRequire("aGXLL");


var $c5dmm = parcelRequire("c5dmm");


var $6jSbc = parcelRequire("6jSbc");


var $e7L4o = parcelRequire("e7L4o");


var $lPWNq = parcelRequire("lPWNq");


var $gwbWt = parcelRequire("gwbWt");


var $1uGSo = parcelRequire("1uGSo");


var $huubg = parcelRequire("huubg");


var $dFCIx = parcelRequire("dFCIx");


var $5ousX = parcelRequire("5ousX");


var $1sswv = parcelRequire("1sswv");


var $fLju9 = parcelRequire("fLju9");


var $dXdDw = parcelRequire("dXdDw");


var $5eFo6 = parcelRequire("5eFo6");


var $aeffu = parcelRequire("aeffu");





var $3TPSi = parcelRequire("3TPSi");


var $f1JPm = parcelRequire("f1JPm");


var $dzNsR = parcelRequire("dzNsR");


var $720nW = parcelRequire("720nW");


var $iz3ta = parcelRequire("iz3ta");





var $b6IhR = parcelRequire("b6IhR");


var $iaYRG = parcelRequire("iaYRG");


var $bF9JE = parcelRequire("bF9JE");


var $9DkM9 = parcelRequire("9DkM9");


var $3Q16G = parcelRequire("3Q16G");


var $fSUtG = parcelRequire("fSUtG");


var $kC3Bu = parcelRequire("kC3Bu");


var $c4DtA = parcelRequire("c4DtA");


var $5XOrc = parcelRequire("5XOrc");








var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $5cssW = parcelRequire("5cssW");










const $d833b8acd04d2361$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    assetsSchema: {
        id: "search-page.filters.names.assets-schema",
        defaultMessage: "Schema"
    },
    assetsFilterAssetsSchemaPlaceholder: {
        id: "search-page.assets.filter.assets-schema.placeholder",
        defaultMessage: "Find schemas"
    },
    assetsFilterLabelSelected: {
        id: "search-page.assets.filter.assets-schema.label.selected",
        defaultMessage: "Selected"
    },
    assetsFilterLabelUnselected: {
        id: "search-page.assets.filter.assets-schema.label.unselected",
        defaultMessage: "Suggested"
    },
    assetsIconLabel: {
        id: "search-page.assets.filter.assets-schema.icon.label",
        defaultMessage: "Assets schema filter"
    }
});


const $fe5cf55c35009aac$var$AssetsSchemaFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit, onClearOptions: onClearOptions })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $lx1ar.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $d833b8acd04d2361$export$a7357cdd1f0b0168).assetsFilterLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $d833b8acd04d2361$export$a7357cdd1f0b0168).assetsFilterLabelUnselected),
            options: suggestedOptions
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: setOption,
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: formatMessage((0, $d833b8acd04d2361$export$a7357cdd1f0b0168).assetsSchema),
        placeholder: formatMessage((0, $d833b8acd04d2361$export$a7357cdd1f0b0168).assetsFilterAssetsSchemaPlaceholder),
        filterOrControlId: 'assetsSchema',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $lx1ar.filter).id
            });
        },
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled
    });
};
var $fe5cf55c35009aac$export$2e2bcd8739ae039 = $fe5cf55c35009aac$var$AssetsSchemaFilter;


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");





var $eiXsV = parcelRequire("eiXsV");


var $226KS = parcelRequire("226KS");


var $gj7hi = parcelRequire("gj7hi");


var $1s5hv = parcelRequire("1s5hv");



var $eyWa4 = parcelRequire("eyWa4");


















const $9778a7b060ccfdbb$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    assetsType: {
        id: "search-page.filters.names.assets-type",
        defaultMessage: "Object type"
    },
    assetsFilterAssetsTypePlaceholder: {
        id: "search-page.assets.filter.assets-type.placeholder",
        defaultMessage: "Find object types"
    },
    assetsFilterLabelSelected: {
        id: "search-page.assets.filter.assets-type.label.selected",
        defaultMessage: "Selected"
    },
    assetsFilterLabelUnselected: {
        id: "search-page.assets.filter.assets-type.label.unselected",
        defaultMessage: "Suggested"
    },
    assetsIconLabel: {
        id: "search-page.assets.filter.assets-type.icon.label",
        defaultMessage: "Object type filter"
    }
});


const $672b5810e8d0600a$var$styles = {
    imageContainer: "_1bsb7vkz _4t3i7vkz"
};
const $672b5810e8d0600a$var$AssetsTypeFilter = ({ isFilterInDropdown: isFilterInDropdown, onClearOptions: onClearOptions })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $iUihD.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const formatOptionLabel = (data)=>{
        return /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.100"
        }, /*#__PURE__*/ $42omo.createElement((0, $1s5hv.default), null, /*#__PURE__*/ $42omo.createElement((0, $gj7hi.default), {
            src: data.avatarUrl,
            alt: data.label,
            className: (0, $gMc0m.default)([
                $672b5810e8d0600a$var$styles.imageContainer
            ])
        })), /*#__PURE__*/ $42omo.createElement((0, $eyWa4.default), {
            space: "space.025"
        }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, data.label), /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.100"
        }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($226KS))), {
            label: "",
            size: "small",
            color: "var(--ds-text-subtlest)"
        }), /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
            color: "color.text.subtlest"
        }, data.metadata.schemaName))));
    };
    const groupedOptions = [
        {
            label: formatMessage((0, $9778a7b060ccfdbb$export$a7357cdd1f0b0168).assetsFilterLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $9778a7b060ccfdbb$export$a7357cdd1f0b0168).assetsFilterLabelUnselected),
            options: suggestedOptions
        }
    ];
    return /*#__PURE__*/ $42omo.createElement((0, $lBO0P.default), {
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: setOption,
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: formatMessage((0, $9778a7b060ccfdbb$export$a7357cdd1f0b0168).assetsType),
        placeholder: formatMessage((0, $9778a7b060ccfdbb$export$a7357cdd1f0b0168).assetsFilterAssetsTypePlaceholder),
        filterOrControlId: 'assetsType',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: formatOptionLabel,
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $iUihD.filter).id
            });
        },
        iconBefore: /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eiXsV))), {
            label: formatMessage((0, $9778a7b060ccfdbb$export$a7357cdd1f0b0168).assetsIconLabel),
            size: "medium"
        }),
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled
    });
};
var $672b5810e8d0600a$export$2e2bcd8739ae039 = $672b5810e8d0600a$var$AssetsTypeFilter;



var $1a3HI = parcelRequire("1a3HI");


var $iK2jT = parcelRequire("iK2jT");


var $5rAmH = parcelRequire("5rAmH");


var $3IsTa = parcelRequire("3IsTa");


var $17vNL = parcelRequire("17vNL");


var $9wx2v = parcelRequire("9wx2v");


var $D9B8R = parcelRequire("D9B8R");


var $iKcwP = parcelRequire("iKcwP");


var $kGrYY = parcelRequire("kGrYY");


var $5KTta = parcelRequire("5KTta");


var $3hfXG = parcelRequire("3hfXG");


var $10wA9 = parcelRequire("10wA9");


var $6alnB = parcelRequire("6alnB");


var $aq7DS = parcelRequire("aq7DS");


var $iLJVZ = parcelRequire("iLJVZ");




const $e73ad23c671b68e3$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    clearFilters: {
        id: "search-page.filters.clear-filters-button-label",
        defaultMessage: "Clear filters"
    },
    suggestedFilters: {
        id: "search-page.filters.suggested-filters-section-label",
        defaultMessage: "Suggested"
    }
});



var $j8URb = parcelRequire("j8URb");


var $d2tOF = parcelRequire("d2tOF");


var $90exq = parcelRequire("90exq");


var $epJdx = parcelRequire("epJdx");


var $3xkiG = parcelRequire("3xkiG");


var $1zHCN = parcelRequire("1zHCN");


var $4VBuR = parcelRequire("4VBuR");


var $d8wvI = parcelRequire("d8wvI");


var $dHIx8 = parcelRequire("dHIx8");


var $5HYjQ = parcelRequire("5HYjQ");


var $kvgSJ = parcelRequire("kvgSJ");


var $dm37y = parcelRequire("dm37y");


var $2UnmY = parcelRequire("2UnmY");


var $1Ddz9 = parcelRequire("1Ddz9");


var $6YAWs = parcelRequire("6YAWs");


var $eCrxg = parcelRequire("eCrxg");


var $b7IiT = parcelRequire("b7IiT");


var $23zGK = parcelRequire("23zGK");


var $hTSDS = parcelRequire("hTSDS");


var $5773E = parcelRequire("5773E");


var $3LQ5r = parcelRequire("3LQ5r");

const $96015a04b79b5a40$export$82462a21aead86ed = {
    [(0, $fw303.filter).id]: (0, $c4DtA.default),
    [(0, $1uGSo.filter).id]: (0, $aq7DS.default),
    [(0, $5iakG.universalTypeFilterId)]: (0, $23zGK.default),
    [(0, $aGXLL.filter).id]: (0, $D9B8R.default),
    [(0, $a97k3.filter).id]: (0, $6YAWs.default),
    [(0, $6jSbc.filter).id]: (0, $5KTta.default),
    [(0, $e7L4o.filter).id]: (0, $3hfXG.default),
    [(0, $bF9JE.filter).id]: (0, $hTSDS.default),
    [(0, $9DkM9.filter).id]: (0, $5773E.default),
    [(0, $5X4Ay.filter).id]: (0, $1a3HI.default),
    [(0, $f1JPm.filter).id]: (0, $5HYjQ.default),
    [(0, $2a0ps.filter).id]: (0, $17vNL.default),
    [(0, $gHwfH.filter).id]: (0, $d8wvI.default),
    [(0, $dQXZO.filter).id]: (0, $9wx2v.default),
    [(0, $iaYRG.filter).id]: (0, $b7IiT.default),
    [(0, $5ousX.filter).id]: (0, $d2tOF.default),
    [(0, $c5dmm.filter).id]: (0, $iKcwP.default),
    [(0, $huubg.filter).id]: (0, $iLJVZ.default),
    [(0, $gwbWt.filter).id]: (0, $6alnB.default),
    [(0, $1sswv.filter).id]: (0, $90exq.default),
    [(0, $b6IhR.filter).id]: (0, $eCrxg.default),
    [(0, $k7ise.filter).id]: (0, $5XOrc.default),
    [(0, $lx1ar.filter).id]: (0, $fe5cf55c35009aac$export$2e2bcd8739ae039),
    [(0, $iUihD.filter).id]: (0, $672b5810e8d0600a$export$2e2bcd8739ae039),
    [(0, $5eFo6.filter).id]: (0, $1zHCN.default),
    [(0, $fLju9.filter).id]: (0, $epJdx.default),
    [(0, $dXdDw.filter).id]: (0, $3xkiG.default),
    [(0, $aeffu.filter).id]: (0, $4VBuR.default),
    [(0, $720nW.filter).id]: (0, $2UnmY.default),
    [(0, $hHAPz.filter).id]: (0, $3IsTa.default),
    [(0, $5VnRb.filter).id]: (0, $iK2jT.default),
    [(0, $F3Hv6.filter).id]: (0, $5rAmH.default),
    [(0, $dFCIx.filter).id]: (0, $j8URb.default),
    [(0, $3TPSi.filter).id]: (0, $dHIx8.default),
    [(0, $dzNsR.filter).id]: (0, $kvgSJ.default),
    [(0, $iz3ta.filter).id]: (0, $1Ddz9.default),
    [(0, $3Q16G.filter).id]: (0, $3LQ5r.default),
    [(0, $lPWNq.filter).id]: (0, $10wA9.default)
};
const $96015a04b79b5a40$var$inlineStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    padding: 'space.050',
    margin: 'space.negative.050',
    flex: '1 0 auto',
    position: 'absolute',
    zIndex: 'card'
});
const $96015a04b79b5a40$var$aiTabsStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    zIndex: 'card',
    padding: 'space.050',
    margin: 'space.negative.050'
});
const $96015a04b79b5a40$var$inlineWithAIModeTabsStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    padding: 'space.050',
    margin: 'space.negative.050',
    flex: '1 0 auto',
    position: 'absolute',
    zIndex: 'card',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    marginInlineStart: '190px'
});
const $96015a04b79b5a40$var$hiddenReferenceInlineStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    padding: 'space.050',
    margin: 'space.negative.050',
    flex: '1 0 auto',
    visibility: 'hidden',
    position: 'relative',
    zIndex: '1'
});
const $96015a04b79b5a40$var$filterRowStyles = (0, $ecnYn.xcss)({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column'
});
const $96015a04b79b5a40$var$suggestedFiltersDividerStyles = (0, $ecnYn.xcss)({
    borderLeft: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    height: '29px',
    marginInline: 'space.150',
    width: '1px'
});
const $96015a04b79b5a40$var$appSelectorFiltersDividerStyles = (0, $ecnYn.xcss)({
    borderLeft: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    height: '29px',
    width: '1px',
    alignSelf: 'center'
});
const $96015a04b79b5a40$var$suggestedFilterStyles = (0, $ecnYn.xcss)({
    alignItems: 'center',
    color: 'color.text.subtlest',
    display: 'flex',
    gap: 'space.100',
    width: 'max-content'
});
const $96015a04b79b5a40$export$506070318f3da67b = ({ onClear: onClear })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        id: "clear-all-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        onClick: onClear,
        appearance: "subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, formatMessage((0, $e73ad23c671b68e3$export$a7357cdd1f0b0168).clearFilters))));
};
const $96015a04b79b5a40$var$SuggestedFilters = ({ primaryProduct: primaryProduct, onFilterChange: onFilterChange, onClearOptions: onClearOptions })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $96015a04b79b5a40$var$suggestedFilterStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $96015a04b79b5a40$var$suggestedFiltersDividerStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        as: "p"
    }, `${formatMessage((0, $e73ad23c671b68e3$export$a7357cdd1f0b0168).suggestedFilters)}:`), primaryProduct === (0, $b4tvS.ProductKeys).Confluence && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6YAWs.default), {
        showPrimaryProductIcon: true,
        onFilterChange: (change)=>onFilterChange?.((0, $a97k3.filter).id, change, (0, $5eWut.FILTER_CHANGE_LOCATION).INLINE_FPS_SUGGESTION),
        onClearOptions: onClearOptions
    }), (0, $dh538.fg)('rovo_fps_sort_in_suggested_filters') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dm37y.ResultsSort), {
        onFilterChange: (change)=>onFilterChange?.((0, $fJFyr.filter).id, change, (0, $5eWut.FILTER_CHANGE_LOCATION).INLINE_FPS_SUGGESTION),
        onClearOptions: onClearOptions,
        showPrimaryProductIcon: true
    })), primaryProduct === (0, $b4tvS.ProductKeys).Assets && (0, $dh538.fg)('assets_rovo_search_all') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fe5cf55c35009aac$export$2e2bcd8739ae039), {
        showPrimaryProductIcon: true,
        onFilterChange: (change)=>onFilterChange?.((0, $lx1ar.filter).id, change, (0, $5eWut.FILTER_CHANGE_LOCATION).INLINE_FPS_SUGGESTION),
        onClearOptions: onClearOptions
    }), primaryProduct === (0, $b4tvS.ProductKeys).Jira && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8wvI.default), {
        showPrimaryProductIcon: true,
        onFilterChange: (change)=>onFilterChange?.((0, $gHwfH.filter).id, change, (0, $5eWut.FILTER_CHANGE_LOCATION).INLINE_FPS_SUGGESTION),
        onClearOptions: onClearOptions
    }), (0, $dh538.fg)('rovo_fps_sort_in_suggested_filters') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dm37y.ResultsSort), {
        onFilterChange: (change)=>onFilterChange?.((0, $fJFyr.filter).id, change, (0, $5eWut.FILTER_CHANGE_LOCATION).INLINE_FPS_SUGGESTION),
        onClearOptions: onClearOptions,
        showPrimaryProductIcon: true
    })));
};
const $96015a04b79b5a40$var$ProductFilters = ({ containerRef: containerRef })=>{
    const [cloudId] = (0, $j4ply.useCloudId)();
    const [query] = (0, $djVCD.useSearchQuery)();
    const { data: tenantDomain } = (0, $bHjhd.useCloudIdToUrl)(cloudId || '');
    const [{ filtersInLine: filtersInLine }] = (0, $djVCD.useFiltersToDisplay)();
    const [productSelected] = (0, $djVCD.useSelectedProduct)();
    const { resetSort: resetSort, clearAllFilters: clearAllFilters } = (0, $djVCD.useSearchActions)();
    const [isAnyFilterSelected] = (0, $djVCD.useAnyFilterSelected)();
    const isConfluence = productSelected === (0, $b4tvS.ProductKeys).Confluence;
    const isJira = productSelected === (0, $b4tvS.ProductKeys).Jira;
    const isCompass = productSelected === (0, $b4tvS.ProductKeys).Compass;
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const filtersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [features] = (0, $j4ply.useFeatures)();
    const isLiteMode = features?.lite?.enabled ?? false;
    // Elements in the navbar that will never be hidden despite resizes
    const alwaysVisibleRef = (0, $42omo.useRef)();
    const dropdownRef = (0, $42omo.useRef)();
    const appSelectFilterRef = (0, $42omo.useRef)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const fireAnalyticsCb = (0, $42omo.useCallback)((payload)=>{
        const { attributes: attributes, ...rest } = payload;
        fireAnalyticsEvent({
            ...rest,
            attributes: {
                // Search-page needs to have attributes within additionalAttributes or else it gets ommitted when
                // the event is emitted
                additionalAttributes: {
                    ...attributes
                }
            }
        });
    }, [
        fireAnalyticsEvent
    ]);
    const { onFilterChange: onFilterChange, onDropdownOpenChange: onDropdownOpenChange, onFilterClearAction: onFilterClearAction, onSingleFilterClearAction: onSingleFilterClearAction } = (0, $fSUtG.useFilterAnalytics)(fireAnalyticsCb, commonAttributes, (0, $9rRKJ.SearchExperience).SEARCH_PAGE);
    let filtersRendered = filtersInLine.filter((id)=>id !== (0, $5iakG.universalTypeFilterId) || productSelected !== (0, $b4tvS.ProductKeys).Atlas);
    // Hide content under filter from navbar QS-5384
    if (isConfluence) filtersRendered = filtersRendered.filter((id)=>id !== (0, $dQXZO.filter).id);
    else if (isCompass) filtersRendered = filtersRendered.filter((id)=>id !== (0, $k7ise.filter).id);
    else if (productSelected === (0, $b4tvS.ProductKeys).Assets && (0, $dh538.fg)('assets_rovo_search_all')) filtersRendered = filtersRendered.filter((id)=>id !== (0, $aGXLL.filter).id);
    else if (productSelected === (0, $b4tvS.ProductKeys).Salesforce) filtersRendered = filtersRendered.filter((id)=>id !== (0, $5ousX.filter).id);
    // Owner, Stage, and Close Date filters for Salesforce should only appear in the dropdown panel.
    if (productSelected === (0, $b4tvS.ProductKeys).Salesforce) filtersRendered = filtersRendered.filter((id)=>id !== (0, $5ousX.filter).id && id !== (0, $720nW.filter).id && id !== (0, $hHAPz.filter).id);
    if (// don't show assets filters on townsquare if the flag is set
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    primaryProduct === (0, $b4tvS.ProductKeys).Atlas && (0, $dh538.fg)('assets_rovo_search_all') && !(0, $dh538.fg)('rovo_search_show_assets_filters_in_townsquare')) filtersRendered = filtersRendered.filter((id)=>id !== (0, $lx1ar.filter).id && id !== (0, $iUihD.filter).id);
    // Note: filter visibility is centralised in `useFiltersToDisplay` which already applies
    // FILTER_EXCLUSION_RULES + FILTER_INCLUSION_RULES via `getExcludedFilterIds`. The list
    // returned here (`filtersRendered`) is therefore already projected and we don't need to
    // re-apply the exclusion at the call site.
    const filterRefs = (0, $42omo.useRef)([]);
    filterRefs.current = filtersRendered.filter((id)=>$96015a04b79b5a40$export$82462a21aead86ed[id]).map((_, i)=>filterRefs.current[i] ?? /*#__PURE__*/ (0, $42omo.createRef)());
    const visibleFilters = (0, $gCEkV.useOverflowObserver)({
        containerRef: containerRef,
        alwaysVisibleRef: alwaysVisibleRef,
        itemRefs: filterRefs,
        itemIds: filtersRendered
    });
    const filtersRef = (0, $42omo.useRef)(null);
    (0, $86ob4.useWidthObserverRegistration)('filters', filtersRef);
    const displaySuggestedConfluenceFilters = primaryProduct === (0, $b4tvS.ProductKeys).Confluence && !isAnyFilterSelected;
    const displaySuggestedAssetsFilters = primaryProduct === (0, $b4tvS.ProductKeys).Assets && !isAnyFilterSelected && (0, $dh538.fg)('assets_rovo_search_all');
    const displaySuggestedJiraFilters = primaryProduct === (0, $b4tvS.ProductKeys).Jira && !isAnyFilterSelected && (0, $dh538.fg)('jira_fps_suggested_filter');
    const displaySuggestedFilters = displaySuggestedConfluenceFilters || displaySuggestedAssetsFilters || displaySuggestedJiraFilters;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $96015a04b79b5a40$var$filterRowStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.100",
        xcss: $96015a04b79b5a40$var$hiddenReferenceInlineStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        style: {
            width: dropdownRef.current?.offsetWidth ?? 40
        }
    }), filtersDiscoverability2Enabled && !isLiteMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        style: {
            width: appSelectFilterRef.current?.offsetWidth ?? 96
        }
    }), filtersRendered.map((id, index)=>{
        const Filter = $96015a04b79b5a40$export$82462a21aead86ed[id];
        if (!Filter) return null;
        const elementId = `reference:${id}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
            key: elementId
        }, index === 0 && !isLiteMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $96015a04b79b5a40$var$appSelectorFiltersDividerStyles
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            id: elementId,
            ref: filterRefs.current[index]
        }, id === (0, $1uGSo.filter).id || id === (0, $5iakG.universalTypeFilterId) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Filter, {
            testId: `ref-test-id-${id}`,
            onFilterChange: (change)=>onFilterChange(id, change, (0, $5eWut.FILTER_CHANGE_LOCATION).INLINE_FPS),
            onClearOptions: onSingleFilterClearAction
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Filter, {
            onFilterChange: (change)=>onFilterChange(id, change, (0, $5eWut.FILTER_CHANGE_LOCATION).INLINE_FPS),
            onClearOptions: onSingleFilterClearAction
        })));
    })), (0, $dh538.fg)('rovo_ai_mode_restore_toggle_search') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $96015a04b79b5a40$var$aiTabsStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $af57685ca39b004e$export$e1e2cdfa7f3f030c), {
        query: query,
        tenantDomain: tenantDomain
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.100",
        xcss: (0, $dh538.fg)('rovo_ai_mode_restore_toggle_search') ? $96015a04b79b5a40$var$inlineWithAIModeTabsStyles : $96015a04b79b5a40$var$inlineStyles,
        ref: filtersRef,
        role: "list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        ref: dropdownRef,
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kGrYY.default), {
        onFiltersChange: onFilterChange,
        onDropdownOpenChange: onDropdownOpenChange,
        onClearOptions: onSingleFilterClearAction
    })), filtersDiscoverability2Enabled && !isLiteMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        ref: appSelectFilterRef,
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kC3Bu.default), null)), filtersRendered.map((id, index)=>{
        const Filter = $96015a04b79b5a40$export$82462a21aead86ed[id];
        if (!visibleFilters.includes(id) || !Filter) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
            key: id
        }, index === 0 && !isLiteMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $96015a04b79b5a40$var$appSelectorFiltersDividerStyles
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            id: id,
            role: "listitem"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Filter, {
            onFilterChange: (change)=>onFilterChange(id, change, (0, $5eWut.FILTER_CHANGE_LOCATION).INLINE_FPS),
            onClearOptions: onSingleFilterClearAction
        })));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.100",
        ref: alwaysVisibleRef,
        role: "listitem"
    }, (isConfluence || isJira) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dm37y.ResultsSort), null), isAnyFilterSelected ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($96015a04b79b5a40$export$506070318f3da67b, {
        onClear: ()=>{
            clearAllFilters();
            resetSort();
            onFilterClearAction('inline-search-page');
        }
    }) : null, displaySuggestedFilters && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($96015a04b79b5a40$var$SuggestedFilters, {
        primaryProduct: primaryProduct,
        onFilterChange: onFilterChange,
        onClearOptions: onSingleFilterClearAction
    }))));
};
var $96015a04b79b5a40$export$2e2bcd8739ae039 = $96015a04b79b5a40$var$ProductFilters;
module.exports["filters"] = $96015a04b79b5a40$export$82462a21aead86ed;
module.exports["default"] = $96015a04b79b5a40$export$2e2bcd8739ae039;

});

parcelRegister("5eWut", function(module, exports) {
const $5f5be382d680405d$export$ba5ea5559df2d439 = {
    DROPDOWN: 'dropdown',
    INLINE: 'inline',
    DROPDOWN_FPS: 'dropdown-search-page',
    INLINE_FPS: 'inline-search-page',
    INLINE_FPS_SUGGESTION: 'inline-search-page-suggestion'
};
const $5f5be382d680405d$export$ef6638e4a0319a7a = ({ attributes: attributes, action: action, location: location, actionSubjectId: actionSubjectId })=>({
        eventType: 'ui',
        action: action,
        actionSubject: 'filter',
        actionSubjectId: actionSubjectId,
        attributes: {
            ...attributes,
            location: location
        }
    });
const $5f5be382d680405d$export$37ec8c521d184f25 = ({ attributes: attributes, action: action, actionSubjectId: actionSubjectId })=>({
        eventType: 'ui',
        action: action,
        actionSubject: 'filterDropdown',
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
const $5f5be382d680405d$export$9c0c40377c27961c = ({ attributes: attributes, location: location, actionSubjectId: actionSubjectId })=>({
        eventType: 'ui',
        action: 'clear',
        actionSubject: 'filter',
        actionSubjectId: actionSubjectId,
        attributes: {
            ...attributes,
            location: location
        }
    });
const $5f5be382d680405d$export$5e2091b35b0526ca = ({ attributes: attributes, location: location, actionSubjectId: actionSubjectId })=>({
        eventType: 'ui',
        action: 'clear',
        actionSubject: 'filter',
        actionSubjectId: actionSubjectId,
        attributes: {
            ...attributes,
            location: location
        }
    });
module.exports["FILTER_CHANGE_LOCATION"] = $5f5be382d680405d$export$ba5ea5559df2d439;
module.exports["onFilterSelection"] = $5f5be382d680405d$export$ef6638e4a0319a7a;
module.exports["onFilterDropdown"] = $5f5be382d680405d$export$37ec8c521d184f25;
module.exports["onFilterClear"] = $5f5be382d680405d$export$9c0c40377c27961c;
module.exports["onSingleFilterClear"] = $5f5be382d680405d$export$5e2091b35b0526ca;

});

parcelRegister("fSUtG", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9rRKJ = parcelRequire("9rRKJ");


var $5eWut = parcelRequire("5eWut");


const $77b89a57ceb0cc94$export$1b9951cfecf7ee51 = (fireAnalyticsEvent, commonAttributes, experience)=>{
    const onFilterChange = (0, $42omo.useCallback)((filterId, changes, location)=>{
        // Omitting these attrtibutes as there is a race condition here since the filter attributes
        // have not yet been applied in the store so it will always be one update behind.
        const { productSelected: _productSelected, filters: _filters, filterSelections: filterSelections, ...restAttributes } = commonAttributes;
        const change = (Array.isArray(changes) ? changes : [
            changes
        ])[0];
        if (!change) return; // This should never be executed
        fireAnalyticsEvent((0, $5eWut.onFilterSelection)({
            action: change.isSelected ? 'unselected' : 'selected',
            actionSubjectId: experience === (0, $9rRKJ.SearchExperience).QUICK_FIND ? 'searchDialogFilter' : 'searchPageFilter',
            location: location,
            attributes: {
                ...restAttributes,
                filterId: filterId,
                location: location
            }
        }));
    }, [
        commonAttributes,
        experience,
        fireAnalyticsEvent
    ]);
    const onDropdownOpenChange = (0, $42omo.useCallback)((isOpen)=>{
        fireAnalyticsEvent((0, $5eWut.onFilterDropdown)({
            action: isOpen ? 'open' : 'close',
            actionSubjectId: experience === (0, $9rRKJ.SearchExperience).QUICK_FIND ? 'searchDialogDropdown' : 'searchPageDropdown',
            attributes: {
                ...commonAttributes
            }
        }));
    }, [
        commonAttributes,
        experience,
        fireAnalyticsEvent
    ]);
    const onFilterClearAction = (0, $42omo.useCallback)((location)=>{
        fireAnalyticsEvent((0, $5eWut.onFilterClear)({
            location: location,
            actionSubjectId: experience === (0, $9rRKJ.SearchExperience).QUICK_FIND ? 'searchDialogFilter' : 'searchPageFilter',
            attributes: {
                ...commonAttributes
            }
        }));
    }, [
        commonAttributes,
        experience,
        fireAnalyticsEvent
    ]);
    const onSingleFilterClearAction = (0, $42omo.useCallback)(({ filterId: filterId })=>{
        const filters = [
            filterId
        ];
        const filterSelections = Array.isArray(commonAttributes?.filterSelections) ? commonAttributes?.filterSelections.filter((s)=>s?.filterId === filterId) : [];
        fireAnalyticsEvent((0, $5eWut.onSingleFilterClear)({
            location: filterId,
            actionSubjectId: experience === (0, $9rRKJ.SearchExperience).QUICK_FIND ? 'searchDialogFilter' : 'searchPageFilter',
            attributes: {
                ...commonAttributes,
                filters: filters,
                filterSelections: filterSelections
            }
        }));
    }, [
        commonAttributes,
        experience,
        fireAnalyticsEvent
    ]);
    return {
        onFilterChange: onFilterChange,
        onDropdownOpenChange: onDropdownOpenChange,
        onFilterClearAction: onFilterClearAction,
        onSingleFilterClearAction: onSingleFilterClearAction
    };
};
module.exports["useFilterAnalytics"] = $77b89a57ceb0cc94$export$1b9951cfecf7ee51;

});

parcelRegister("k5mzm", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $3hOY6 = parcelRequire("3hOY6");

const $1ca63d475ea1e3a7$var$boxStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.small',
    boxSizing: 'border-box'
});
const $1ca63d475ea1e3a7$export$7a7fa4424cb20976 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, props.selectProps.isSearchable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        paddingInline: "space.100",
        paddingBlockStart: "space.100",
        xcss: $1ca63d475ea1e3a7$var$boxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).Control, props)));
module.exports["Control"] = $1ca63d475ea1e3a7$export$7a7fa4424cb20976;

});

parcelRegister("ls6iZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $6f0Oj = parcelRequire("6f0Oj");

var $2W0qg = parcelRequire("2W0qg");

var $ecnYn = parcelRequire("ecnYn");


var $3hOY6 = parcelRequire("3hOY6");


var $euOzb = parcelRequire("euOzb");




const $fe1ccd918cb4fcd2$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    searchClearFilterLabel: {
        id: "search-page.filter.clear.filter.label",
        defaultMessage: "Clear filter"
    }
});


const $4c5bd174a9ae63a6$var$clearFilterOptionsButtonStyles = (0, $ecnYn.xcss)({
    background: "var(--ds-background-input, #FFFFFF)",
    color: 'color.text.subtle',
    border: 'none',
    paddingLeft: 'space.250',
    font: 'inherit',
    cursor: 'pointer',
    outline: 'inherit',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '36px',
    width: '100%',
    ':hover': {
        backgroundColor: 'color.background.input.hovered'
    },
    ':disabled': {
        color: 'color.text.accent.gray',
        cursor: 'default'
    }
});
const $4c5bd174a9ae63a6$var$ClearFilterOptionsButton = ({ onClick: onClick, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        onClick: onClick,
        xcss: $4c5bd174a9ae63a6$var$clearFilterOptionsButtonStyles
    }, children);
};
const $4c5bd174a9ae63a6$var$menuFooterStyles = (0, $ecnYn.xcss)({
    borderTop: `${"var(--ds-border, #0B120E24)"} solid ${"var(--ds-border-width, 1px)"}`
});
const $4c5bd174a9ae63a6$export$383d5f7db11e21ca = (props)=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).MenuList, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $4c5bd174a9ae63a6$var$menuFooterStyles
    }, props.selectProps.canClearFilter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4c5bd174a9ae63a6$var$ClearFilterOptionsButton, {
        onClick: ()=>props.selectProps.onClearOptions()
    }, formatMessage((0, $fe1ccd918cb4fcd2$export$a7357cdd1f0b0168).searchClearFilterLabel))));
};
const $4c5bd174a9ae63a6$export$d1b6a8b216735e8c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).MenuList, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $4c5bd174a9ae63a6$var$menuFooterStyles
    }, props.selectProps.canClearFilter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $euOzb.default), {
        onClick: ()=>props.selectProps.onClearOptions()
    })));
};
module.exports["MenuListWithClearFilterOptionLabel"] = $4c5bd174a9ae63a6$export$383d5f7db11e21ca;
module.exports["MenuListWithoutClearFilterOptionLabel"] = $4c5bd174a9ae63a6$export$d1b6a8b216735e8c;

});

parcelRegister("jQ2up", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $esRft = parcelRequire("esRft");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $1GzhS = parcelRequire("1GzhS");

var $ecnYn = parcelRequire("ecnYn");


var $Y34Hw = parcelRequire("Y34Hw");

const $b87e75291ab80188$var$optionTextWrapperStyles = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    marginLeft: 'space.100',
    color: 'color.text',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $b87e75291ab80188$var$renderOptionLabelText = (label)=>typeof label === 'string' ? (0, $Y34Hw.enrichExcerpt)(label) : label;
const $b87e75291ab80188$export$2cf7ef1e2dd6c6b1 = ({ option: option, state: state, children: children })=>{
    const renderedLabel = $b87e75291ab80188$var$renderOptionLabelText(option.label);
    if (state.context === 'menu' || state.context === 'value') {
        const spaces = {
            menu: 'space.050',
            value: undefined
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            space: spaces[state.context]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            alignItems: "center"
        }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $b87e75291ab80188$var$optionTextWrapperStyles
        }, renderedLabel)));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $b87e75291ab80188$var$optionTextWrapperStyles
    }, renderedLabel);
};
const $b87e75291ab80188$export$100d0de045bdee7c = (Component)=>(option, state)=>{
        const props = {
            option: option,
            state: state
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b87e75291ab80188$export$2cf7ef1e2dd6c6b1, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, props));
    };
const $b87e75291ab80188$var$AvatarOptionLabel = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
        src: props.option.avatarUrl,
        appearance: "circle",
        size: "small",
        borderColor: "none"
    });
const $b87e75291ab80188$export$aaa1dc33930567f9 = $b87e75291ab80188$export$100d0de045bdee7c($b87e75291ab80188$var$AvatarOptionLabel);
module.exports["createOptionLabelFormatter"] = $b87e75291ab80188$export$100d0de045bdee7c;
module.exports["formatAvatarOptionLabel"] = $b87e75291ab80188$export$aaa1dc33930567f9;

});

parcelRegister("Y34Hw", function(module, exports) {
/**
 * This file was adapted from confluence/next/packages/search-utils/src/excerpt.tsx
 */ 
var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");


var $67gKI = parcelRequire("67gKI");


var $4Chrd = parcelRequire("4Chrd");


var $j5Jtm = parcelRequire("j5Jtm");


var $iwLe7 = parcelRequire("iwLe7");


var $akQ4J = parcelRequire("akQ4J");


var $9ohv9 = parcelRequire("9ohv9");










const $74113bae213f2e9f$var$SPECIAL_CHARS_REGEX = /^[!#$%^&*() ,.<>?\/\[\]_\-+=`~\|:;{}\\]+/;
const $74113bae213f2e9f$var$MAX_EXCERPT_LENGTH = 80;
const $74113bae213f2e9f$export$16c2ab98757b54d6 = (excerpt, noLeadingEllipsis, prefix)=>{
    if (!excerpt) return [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            key: "empty"
        }, '')
    ];
    excerpt = (0, $j5Jtm.replaceHtmlEntities)(excerpt).trim();
    if (!excerpt) return [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            key: "empty"
        }, '')
    ];
    const beginsWithHighlight = excerpt.slice(0, 8) === '@@@hl@@@';
    const beginsWithUrl = excerpt.slice(0, 4) === 'http' || beginsWithHighlight && excerpt.slice(8, 12) === 'http';
    // Strip leading special characters unless the excerpt begins with a highlight
    if (!beginsWithHighlight) excerpt = excerpt.replace($74113bae213f2e9f$var$SPECIAL_CHARS_REGEX, '');
    // Add ellipsis prefix if beginning of excerpt isn't a URL and excerpt length is greater than 80
    if (!noLeadingEllipsis && !beginsWithUrl && excerpt.length > $74113bae213f2e9f$var$MAX_EXCERPT_LENGTH) excerpt = '...'.concat(excerpt);
    // Add ellipsis suffix if excerpt doesn't end with ending punctuation and if length is greater than 80
    if (excerpt.length > $74113bae213f2e9f$var$MAX_EXCERPT_LENGTH && !excerpt.slice(-1).match(/[.!?]/)) excerpt = excerpt.concat('...');
    // Replace line breaks with separators
    excerpt = excerpt.replace(/\n+/g, " \xb7 ");
    return $74113bae213f2e9f$export$b847312d69858d61(excerpt, prefix);
};
// Utility function to insert zero-width space every N characters
const $74113bae213f2e9f$var$insertZeroWidthSpace = (str, interval)=>{
    let result = '';
    for(let i = 0; i < str.length; i++){
        result += str[i];
        if ((i + 1) % interval === 0) result += '\u200B';
    }
    return result;
};
const $74113bae213f2e9f$export$ca7c2d622a259944 = (segment)=>{
    return segment.split(' ').map((word)=>{
        if (word.length > 20) return $74113bae213f2e9f$var$insertZeroWidthSpace(word, 5);
        return word;
    }).join(' ');
};
const $74113bae213f2e9f$export$b847312d69858d61 = (excerpt, prefix)=>{
    if (!excerpt) return [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            key: "empty"
        }, '')
    ];
    excerpt = (0, $j5Jtm.replaceHtmlEntities)(excerpt).trim();
    if (!excerpt) return [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            key: "empty"
        }, '')
    ];
    const res = [];
    let pre, textMatch;
    let i = 0;
    while(excerpt){
        // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
        const match = excerpt.match(RegExp("(.*?)@@@hl@@@(.*?)@@@endhl@@@(.*)", "s"));
        if (!match) {
            res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                as: "span",
                key: excerpt
            }, $74113bae213f2e9f$export$ca7c2d622a259944(excerpt)));
            break;
        }
        [, pre, textMatch, excerpt] = match;
        if (pre) res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            as: "span",
            key: `pre-${i}`
        }, $74113bae213f2e9f$export$ca7c2d622a259944(pre)));
        if (textMatch) res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            as: "strong",
            key: `textMatch-${i}`
        }, $74113bae213f2e9f$export$ca7c2d622a259944(textMatch)));
        i++;
    }
    return(// NOTE: wrapping these in <div> previously broke focus rings
    // in search results
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, prefix, res));
};
const $74113bae213f2e9f$export$fdcae512e9fdc5ad = (timestamp)=>{
    return $74113bae213f2e9f$export$96e2a37e068d7fac($74113bae213f2e9f$export$7e0fd00186ff29c6(timestamp));
};
const $74113bae213f2e9f$export$7e0fd00186ff29c6 = (timestamp)=>{
    if (!timestamp) timestamp = new Date();
    const secondsPast = (0, $iwLe7.secondsSinceDate)(timestamp);
    const timeUnits = {
        seconds: secondsPast,
        minutes: secondsPast / 60,
        hours: secondsPast / 3600,
        days: secondsPast / 86400,
        months: secondsPast / 2592000,
        years: secondsPast / 31536000
    };
    return {
        seconds: Math.floor(timeUnits.seconds),
        minutes: Math.floor(timeUnits.minutes),
        hours: Math.floor(timeUnits.hours),
        days: Math.floor(timeUnits.days),
        months: Math.floor(timeUnits.months),
        years: Math.floor(timeUnits.years)
    };
};
const $74113bae213f2e9f$export$96e2a37e068d7fac = ({ seconds: seconds, minutes: minutes, hours: hours, days: days, months: months, years: years })=>{
    return $74113bae213f2e9f$export$3e6e07f5a5b9cd48(seconds, minutes, hours, days, months, years);
};
const $74113bae213f2e9f$export$3e6e07f5a5b9cd48 = (seconds, minutes, hours, days, months, years)=>{
    if (years > 0) return {
        unit: 'year',
        value: years
    };
    else if (months > 0) return {
        unit: 'month',
        value: months
    };
    else if (days > 0) return {
        unit: 'day',
        value: days
    };
    else if (hours > 0) return {
        unit: 'hour',
        value: hours
    };
    else if (minutes > 0) return {
        unit: 'minute',
        value: minutes
    };
    else return {
        unit: 'second',
        value: seconds
    };
};
const $74113bae213f2e9f$export$596e547f4ce626bc = (integrationId, user)=>{
    if (!integrationId || !user) return;
    const isSlack = integrationId === 'ari:cloud:platform::integration/slack';
    const isMsTeams = integrationId === 'ari:cloud:platform::integration/microsoft';
    if (isSlack) {
        const openDmUrl = $74113bae213f2e9f$export$9eb522d6e073fba0(user);
        if (openDmUrl) return {
            integration: 'slack',
            openDmUrl: openDmUrl
        };
    } else if (isMsTeams) {
        const openDmUrl = $74113bae213f2e9f$export$198aa8f5b10ebb27(user);
        if (openDmUrl) return {
            integration: 'ms-teams',
            openDmUrl: openDmUrl
        };
    }
};
const $74113bae213f2e9f$export$9eb522d6e073fba0 = (user)=>{
    const externalId = user?.externalId;
    if (!externalId) return;
    return `https://slack.com/app_redirect?channel=${externalId}`;
};
const $74113bae213f2e9f$export$198aa8f5b10ebb27 = (user)=>{
    const email = user?.email;
    if (!email) return;
    return `https://teams.microsoft.com/l/chat/0/0?users=${email}`;
};
const $74113bae213f2e9f$export$3856aba7736e125f = 'microsoft';
const $74113bae213f2e9f$export$c60276faecd0e082 = (integrationKey, resourceType)=>{
    if (integrationKey !== $74113bae213f2e9f$export$3856aba7736e125f || !resourceType) return undefined;
    if ((0, $akQ4J.SHAREPOINT_RESOURCE_TYPES).includes(resourceType)) return 'sharepoint';
    if ((0, $9ohv9.TEAMS_RESOURCE_TYPES).includes(resourceType)) return 'teams';
    return undefined;
};
const $74113bae213f2e9f$export$42f00afbb84516be = ({ thirdPartyConfigs: thirdPartyConfigs, providerId: providerId, integrationId: integrationId, resourceType: resourceType })=>{
    const integrationKey = (0, $67gKI.getIntegrationKey)(integrationId);
    return(// Last-resort fallback: returns the raw integration key (e.g. 'slack', 'github').
    // For Microsoft products without a matching resourceType (e.g. OneDrive), this returns
    // 'microsoft' which has no displayName — intentional, as we can't disambiguate further.
    (0, $4Chrd.getProductFromProviderId)(thirdPartyConfigs, providerId) || $74113bae213f2e9f$export$c60276faecd0e082(integrationKey, resourceType) || integrationKey);
};
module.exports["processExcerpt"] = $74113bae213f2e9f$export$16c2ab98757b54d6;
module.exports["enrichExcerpt"] = $74113bae213f2e9f$export$b847312d69858d61;
module.exports["getRelativeTimeSince"] = $74113bae213f2e9f$export$fdcae512e9fdc5ad;
module.exports["getExternalMessageDmIntegrationInfo"] = $74113bae213f2e9f$export$596e547f4ce626bc;
module.exports["MICROSOFT_INTEGRATION_KEY"] = $74113bae213f2e9f$export$3856aba7736e125f;
module.exports["getProductFromMicrosoftResourceType"] = $74113bae213f2e9f$export$c60276faecd0e082;
module.exports["get3PProductFromProviderIdOrIntegrationId"] = $74113bae213f2e9f$export$42f00afbb84516be;

});

parcelRegister("67gKI", function(module, exports) {

var $1VCtc = parcelRequire("1VCtc");

const $35d29bc8359ee927$export$fb63ba58603395b8 = (integrationId)=>{
    try {
        const integrationKey = integrationId ? (0, $1VCtc.PlatformIntegrationAri).parse(integrationId).integrationKey : undefined;
        if (integrationKey === 'jira-dc-secondary' || integrationKey === 'jira-dc-tertiary') return 'jira-dc';
        return integrationKey;
    } catch  {
        // TODO QS-7368 log exception for invalid integration IDs
        return undefined;
    }
};
module.exports["getIntegrationKey"] = $35d29bc8359ee927$export$fb63ba58603395b8;

});

parcelRegister("1BldJ", function(module, exports) {
const $1452f19e089e8a7b$export$cfcac91fe687137b = (type)=>{
    if (type === 'project') return 'space';
    return type;
};
module.exports["getJiraSearchResultTypeMetadata"] = $1452f19e089e8a7b$export$cfcac91fe687137b;

});

parcelRegister("9ZAVx", function(module, exports) {
const $6a43e1949f0f5c36$export$e4f4cdacb4bd8fe7 = (a, b, productsOrder)=>{
    const indexA = productsOrder.indexOf(a);
    const indexB = productsOrder.indexOf(b);
    if (indexA === -1 || indexB === -1) return 0;
    else return indexA - indexB;
};
module.exports["getProductOrder"] = $6a43e1949f0f5c36$export$e4f4cdacb4bd8fe7;

});

parcelRegister("hrMXM", function(module, exports) {

var $6Gsan = parcelRequire("6Gsan");


var $b4tvS = parcelRequire("b4tvS");

const $ffb8a5ec19715038$export$67a9e61f14e838d2 = (primaryProduct)=>{
    if (primaryProduct === (0, $6Gsan.PrimaryProductKeys).Assets) return [
        (0, $b4tvS.ProductKeys).Assets,
        ...(0, $b4tvS.PRODUCTS_ORDER_WITH_3P_BY_POPULARITY)
    ];
    if (primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira) {
        const jiraProducts = [
            (0, $b4tvS.ProductKeys).Jira,
            (0, $b4tvS.ProductKeys).Confluence,
            (0, $b4tvS.ProductKeys).JiraProductDiscovery,
            (0, $b4tvS.ProductKeys).JiraServiceManagement
        ];
        // Bring all Jira products to the top
        return [
            ...jiraProducts,
            ...(0, $b4tvS.PRODUCTS_ORDER_WITH_3P_BY_POPULARITY).filter((key)=>!jiraProducts.includes(key))
        ];
    }
    return 0, $b4tvS.PRODUCTS_ORDER_WITH_3P_BY_POPULARITY;
};
module.exports["getProductsOrderByPrimaryProduct"] = $ffb8a5ec19715038$export$67a9e61f14e838d2;

});

parcelRegister("5cssW", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");


var $dh538 = parcelRequire("dh538");


var $2Znam = parcelRequire("2Znam");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $djVCD = parcelRequire("djVCD");


var $7jUYs = parcelRequire("7jUYs");


var $037Ux = parcelRequire("037Ux");





var $9rRKJ = parcelRequire("9rRKJ");

const $74feadaff115f70a$export$6d20082d2748aae3 = (params)=>{
    if (params.selectedProducts.length > 0) return params.selectedProducts;
    const primaryProduct = params.primaryProduct ?? '';
    const safePrimaryProduct = (0, $b4tvS.isProductKey)(primaryProduct) ? [
        primaryProduct
    ] : undefined;
    if (params.experience === (0, $9rRKJ.SearchExperience).QUICK_FIND) return safePrimaryProduct ?? params.availableProducts;
    return params.availableProducts;
};


const $ded31ca78b6b8828$export$ac822ab68badd883 = ({ filterId: filterId, optionValuesToExclude: optionValuesToExclude })=>{
    const intl = (0, $aXWIB.useIntl)();
    const [state, storeActions] = (0, $djVCD.useSelectFilterStore)({
        filterId: filterId
    });
    const viewActions = {
        setOption: (option, customValue, setSelectedProduct, validateDependentFilterId)=>{
            const options = Array.isArray(option) ? option : [
                option
            ];
            const optionChange = options.map((option)=>({
                    value: option.value,
                    isSelected: !option.isSelected
                }));
            const productToSelect = (0, $037Ux.getProductToSelect)({
                isUniversal: state?.universal,
                primaryProduct: state?.primaryProduct ?? undefined,
                productToSet: setSelectedProduct,
                selectedProduct: state?.selectedProducts[0],
                experience: state?.experience
            });
            const customOptions = {
                customValue: customValue,
                setSelectedProduct: productToSelect,
                validateDependentFilterId: validateDependentFilterId
            };
            return storeActions.setSelectFilterOption({
                filterId: filterId,
                optionChange: optionChange,
                ...Object.values(customOptions).some((customOption)=>customOption !== undefined) ? {
                    options: customOptions
                } : {}
            });
        },
        loadInitialOptions: ()=>storeActions.loadInitialSelectFilterOptions({
                intl: intl,
                filterId: filterId
            }),
        setLookupInput: (query)=>storeActions.setSelectFilterLookupInput({
                filterId: filterId,
                query: query
            }),
        clearLookupInput: ()=>storeActions.setSelectFilterLookupInput({
                filterId: filterId,
                query: ''
            }),
        clearOptions: ()=>storeActions.clearSelectFilterOptions({
                filterId: filterId
            })
    };
    if (!state) return [
        ,
        viewActions
    ];
    // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
    const filteredOptions = state.options.filter((option)=>{
        if (optionValuesToExclude) return !optionValuesToExclude.includes(option.value);
        return true;
    });
    // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
    const selectedOptionsCount = state.selectedOptions.length;
    const viewState = {
        defaultIsOpen: state.alwaysVisible === false,
        isLookupDefined: state.lookup.isDefined,
        isLoading: state.queryParams.isLoading || state.initialOptions.isLoading || state.lookup.isLoading,
        lookupInput: state.lookup.input,
        options: filteredOptions,
        suggestedOptions: filteredOptions.filter((option)=>!option.isSelected && option.isSuggested),
        selectedOptions: state.selectedOptions,
        isLookupActive: state.lookup.isActive,
        alwaysVisible: state.alwaysVisible,
        customValue: state.customValue,
        badgeLabel: selectedOptionsCount > 1 ? `+${selectedOptionsCount - 1}` : undefined,
        firstSelectedOptionLabel: state.selectedOptions[0]?.label
    };
    return [
        viewState,
        viewActions
    ];
};
const $ded31ca78b6b8828$export$eb312ee1d3a7a748 = ({ filterId: filterId, optionsToProducts: optionsToProducts })=>{
    const intl = (0, $aXWIB.useIntl)();
    const [state, storeActions] = (0, $djVCD.useSelectFilterStore)({
        filterId: filterId
    });
    const viewActions = {
        setOption: (option)=>{
            const options = Array.isArray(option) ? option : [
                option
            ];
            const optionChange = options.map((option)=>({
                    value: option.value,
                    isSelected: !option.isSelected
                }));
            const productToSelect = (0, $037Ux.getProductToSelect)({
                isUniversal: state?.universal,
                primaryProduct: state?.primaryProduct ?? undefined,
                selectedProduct: state?.selectedProducts[0],
                experience: state?.experience
            });
            return storeActions.setSelectFilterOption({
                filterId: filterId,
                optionChange: optionChange,
                options: {
                    setSelectedProduct: productToSelect
                }
            });
        },
        loadInitialOptions: ()=>storeActions.loadInitialSelectFilterOptions({
                filterId: filterId,
                intl: intl
            }),
        setLookupInput: (query)=>storeActions.setSelectFilterLookupInput({
                filterId: filterId,
                query: query
            }),
        clearLookupInput: ()=>storeActions.setSelectFilterLookupInput({
                filterId: filterId,
                query: ''
            }),
        clearOptions: ()=>storeActions.clearSelectFilterOptions({
                filterId: filterId
            })
    };
    if (!state) return [
        ,
        viewActions
    ];
    const selectedProductsAvailable = state.selectedProducts.length > 0;
    const productsNew = (0, $74feadaff115f70a$export$6d20082d2748aae3)({
        selectedProducts: state.selectedProducts,
        primaryProduct: state.primaryProduct ?? undefined,
        experience: state.experience,
        availableProducts: state.availableProducts
    });
    const products = productsNew;
    const filteredOptions = state.options.filter((option)=>option.isDefault || option.isSelected || optionsToProducts[option.value]?.some((product)=>products.includes(product)))// This is a temporary hack to filter out Atlas specific types, unless Atlas is the selected product
    .filter((option)=>!(state.selectedProducts[0] !== (0, $b4tvS.ProductKeys).Atlas && (option.value === 'goal' || option.value === 'tag')))// Filtering out all options that are tied exclusively to allFilterExcludedProducts for universal types
    .filter((option)=>!selectedProductsAvailable && optionsToProducts[option.value]?.length ? optionsToProducts[option.value].some((product)=>!state.allFilterExcludedProducts.includes(product)) : true);
    // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
    const selectedOptions = state.selectedOptions.map((option)=>({
            ...option
        }));
    if (products.length === 1 && products[0] === (0, $b4tvS.ProductKeys).ConfluenceDC && (0, $dh538.fg)('confluence_live_pages_open_beta_trait_opted_in')) {
        const isPageOption = (option)=>option.value === (0, $2Znam.TypeFilterValueKey).Page;
        // Update both filtered and selected options that match Page type
        [
            filteredOptions,
            selectedOptions
        ].flatMap((options)=>options.filter(isPageOption)).forEach((option)=>{
            option.label = intl.formatMessage((0, $7jUYs.typeLabels).page);
        });
    }
    const viewState = {
        defaultIsOpen: state.alwaysVisible === false,
        // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
        isLookupDefined: state.lookup.isDefined,
        isLoading: // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
        state.queryParams.isLoading || state.initialOptions.isLoading || state.lookup.isLoading,
        // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
        lookupInput: state.lookup.input,
        options: filteredOptions,
        // @ts-ignore - TS7006 TypeScript 5.9.2 upgrade
        suggestedOptions: filteredOptions.filter((option)=>!option.isSelected && option.isSuggested),
        selectedOptions: selectedOptions,
        // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
        isLookupActive: state.lookup.isActive,
        alwaysVisible: state.alwaysVisible
    };
    return [
        viewState,
        viewActions
    ];
};
module.exports["useSelectFilter"] = $ded31ca78b6b8828$export$ac822ab68badd883;
module.exports["useUniversalSelectFilter"] = $ded31ca78b6b8828$export$eb312ee1d3a7a748;

});

parcelRegister("3dgQu", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $lAFHW = parcelRequire("lAFHW");


var $6Gsan = parcelRequire("6Gsan");




const $2984110e254169a0$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    confluenceIconLabel: {
        id: "rovo-search.confluence.filter.icon.label",
        defaultMessage: "Confluence filter"
    },
    jiraIconLabel: {
        id: "rovo-search.jira.filter.icon.label",
        defaultMessage: "Jira filter"
    },
    assetsIconLabel: {
        id: "rovo-search.assets.filter.icon.label",
        defaultMessage: "Assets filter"
    },
    talentIconLabel: {
        id: "rovo-search.talent.filter.icon.label",
        defaultMessage: "Talent filter"
    }
});


const $e1c3616515d2ed7a$export$5d27b8605be74adf = (props)=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { showPrimaryProductIcon: showPrimaryProductIcon, primaryProduct: primaryProduct } = props;
    if (!showPrimaryProductIcon || !primaryProduct) return null;
    if (primaryProduct === (0, $6Gsan.PrimaryProductKeys).Confluence) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.ConfluenceIcon), {
        shouldUseNewLogoDesign: true,
        label: formatMessage((0, $2984110e254169a0$export$a7357cdd1f0b0168).confluenceIconLabel),
        size: "xxsmall"
    });
    if (primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.JiraIcon), {
        shouldUseNewLogoDesign: true,
        label: formatMessage((0, $2984110e254169a0$export$a7357cdd1f0b0168).jiraIconLabel),
        size: "xxsmall"
    });
    if (primaryProduct === (0, $6Gsan.PrimaryProductKeys).Assets) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.AssetsIcon), {
        shouldUseNewLogoDesign: true,
        label: formatMessage((0, $2984110e254169a0$export$a7357cdd1f0b0168).assetsIconLabel),
        size: "xxsmall"
    });
    if (primaryProduct === (0, $6Gsan.PrimaryProductKeys).Talent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.TalentIcon), {
        shouldUseNewLogoDesign: true,
        label: formatMessage((0, $2984110e254169a0$export$a7357cdd1f0b0168).talentIconLabel),
        size: "xxsmall"
    });
    // Add more primary product icons here
    return null;
};
module.exports["FilterProductIcon"] = $e1c3616515d2ed7a$export$5d27b8605be74adf;

});

parcelRegister("kGrYY", function(module, exports) {
/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $c4sKh = parcelRequire("c4sKh");


var $ccHMk = parcelRequire("ccHMk");


var $52EPl = parcelRequire("52EPl");


var $6f0Oj = parcelRequire("6f0Oj");

var $1GzhS = parcelRequire("1GzhS");

var $ecnYn = parcelRequire("ecnYn");


var $5iakG = parcelRequire("5iakG");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $9rRKJ = parcelRequire("9rRKJ");


var $euOzb = parcelRequire("euOzb");


var $2ZCkf = parcelRequire("2ZCkf");


var $coCs8 = parcelRequire("coCs8");


var $kfaxy = parcelRequire("kfaxy");


var $5eWut = parcelRequire("5eWut");


var $j4ply = parcelRequire("j4ply");


var $djVCD = parcelRequire("djVCD");

parcelRequire("ehGUC");
var $9DkM9 = parcelRequire("9DkM9");


var $fw303 = parcelRequire("fw303");


var $k7ise = parcelRequire("k7ise");


var $5X4Ay = parcelRequire("5X4Ay");


var $5VnRb = parcelRequire("5VnRb");


var $F3Hv6 = parcelRequire("F3Hv6");


var $hHAPz = parcelRequire("hHAPz");


var $2a0ps = parcelRequire("2a0ps");


var $dQXZO = parcelRequire("dQXZO");


var $aGXLL = parcelRequire("aGXLL");


var $c5dmm = parcelRequire("c5dmm");


var $6jSbc = parcelRequire("6jSbc");


var $e7L4o = parcelRequire("e7L4o");


var $lPWNq = parcelRequire("lPWNq");


var $gwbWt = parcelRequire("gwbWt");


var $1uGSo = parcelRequire("1uGSo");


var $huubg = parcelRequire("huubg");


var $dFCIx = parcelRequire("dFCIx");


var $5ousX = parcelRequire("5ousX");


var $1sswv = parcelRequire("1sswv");


var $jqLa8 = parcelRequire("jqLa8");


var $fLju9 = parcelRequire("fLju9");


var $dXdDw = parcelRequire("dXdDw");


var $5eFo6 = parcelRequire("5eFo6");


var $aeffu = parcelRequire("aeffu");


var $gHwfH = parcelRequire("gHwfH");


var $3TPSi = parcelRequire("3TPSi");


var $f1JPm = parcelRequire("f1JPm");


var $dzNsR = parcelRequire("dzNsR");


var $720nW = parcelRequire("720nW");


var $iz3ta = parcelRequire("iz3ta");


var $a97k3 = parcelRequire("a97k3");


var $b6IhR = parcelRequire("b6IhR");


var $iaYRG = parcelRequire("iaYRG");


var $bF9JE = parcelRequire("bF9JE");





var $3Q16G = parcelRequire("3Q16G");


var $fJ1R6 = parcelRequire("fJ1R6");


var $kC3Bu = parcelRequire("kC3Bu");


var $c4DtA = parcelRequire("c4DtA");


var $5XOrc = parcelRequire("5XOrc");


var $1a3HI = parcelRequire("1a3HI");


var $iK2jT = parcelRequire("iK2jT");


var $5rAmH = parcelRequire("5rAmH");


var $3IsTa = parcelRequire("3IsTa");


var $17vNL = parcelRequire("17vNL");


var $9wx2v = parcelRequire("9wx2v");


var $D9B8R = parcelRequire("D9B8R");


var $iKcwP = parcelRequire("iKcwP");


var $5KTta = parcelRequire("5KTta");


var $3hfXG = parcelRequire("3hfXG");


var $10wA9 = parcelRequire("10wA9");


var $6alnB = parcelRequire("6alnB");


var $aq7DS = parcelRequire("aq7DS");


var $iLJVZ = parcelRequire("iLJVZ");


var $j8URb = parcelRequire("j8URb");


var $d2tOF = parcelRequire("d2tOF");


var $90exq = parcelRequire("90exq");








var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $5cssW = parcelRequire("5cssW");










const $488fa3f84a08f0df$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    positionFilterEmploymentTypeLabel: {
        id: "search-page.filters.names.positionEmploymentType",
        defaultMessage: "Employment type"
    },
    positionFilterEmploymentTypePlaceholder: {
        id: "search-page.talent.filter.position-employment-type.content.placeholder",
        defaultMessage: "Find employment types"
    },
    positionFilterEmploymentTypeLabelSelected: {
        id: "search-page.talent.filter.position-employment-type.content.selected",
        defaultMessage: "Selected"
    },
    positionFilterEmploymentTypeLabelUnselected: {
        id: "search-page.talent.filter.position-employment-type.content.unselected",
        defaultMessage: "Suggested"
    }
});


const $3b25659dee9869d9$var$PositionEmploymentTypeFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $jqLa8.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $488fa3f84a08f0df$export$a7357cdd1f0b0168).positionFilterEmploymentTypeLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $488fa3f84a08f0df$export$a7357cdd1f0b0168).positionFilterEmploymentTypeLabelUnselected),
            options: suggestedOptions
        }
    ];
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $488fa3f84a08f0df$export$a7357cdd1f0b0168).positionFilterEmploymentTypeLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        canClearFilter: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: label,
        placeholder: formatMessage((0, $488fa3f84a08f0df$export$a7357cdd1f0b0168).positionFilterEmploymentTypePlaceholder),
        filterOrControlId: 'positionEmploymentType',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $jqLa8.filter).id
            });
        },
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $3b25659dee9869d9$export$2e2bcd8739ae039 = $3b25659dee9869d9$var$PositionEmploymentTypeFilter;



var $epJdx = parcelRequire("epJdx");


var $3xkiG = parcelRequire("3xkiG");


var $1zHCN = parcelRequire("1zHCN");


var $4VBuR = parcelRequire("4VBuR");


var $d8wvI = parcelRequire("d8wvI");


var $dHIx8 = parcelRequire("dHIx8");


var $5HYjQ = parcelRequire("5HYjQ");


var $kvgSJ = parcelRequire("kvgSJ");


var $dm37y = parcelRequire("dm37y");


var $2UnmY = parcelRequire("2UnmY");


var $1Ddz9 = parcelRequire("1Ddz9");


var $6YAWs = parcelRequire("6YAWs");


var $eCrxg = parcelRequire("eCrxg");


var $b7IiT = parcelRequire("b7IiT");


var $23zGK = parcelRequire("23zGK");


var $hTSDS = parcelRequire("hTSDS");


var $5773E = parcelRequire("5773E");


var $3LQ5r = parcelRequire("3LQ5r");




const $d8436d38d53a83ed$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    clearFilters: {
        id: "search-page.filters.dropdown.clear-filters",
        defaultMessage: "Clear filters"
    },
    dropdownButtonLabel: {
        id: "search-page.filters.dropdown.button",
        defaultMessage: "More filters"
    }
});


const $b409c1590183c3bd$var$dropdownContainerStyles = (0, $ecnYn.xcss)({
    width: '312px'
});
const $b409c1590183c3bd$var$filtersContainerStyles = (0, $ecnYn.xcss)({
    padding: 'space.200'
});
const $b409c1590183c3bd$var$clearButtonStylesOld = (0, $ecnYn.xcss)({
    margin: 'space.200'
});
const $b409c1590183c3bd$var$clearButtonStyles = (0, $ecnYn.xcss)({
    paddingInline: 'space.200',
    paddingBlock: 'space.300'
});
const $b409c1590183c3bd$var$filters = {
    [(0, $5iakG.universalTypeFilterId)]: (0, $23zGK.default),
    [(0, $1uGSo.filter).id]: (0, $aq7DS.default),
    [(0, $c5dmm.filter).id]: (0, $iKcwP.default),
    [(0, $aGXLL.filter).id]: (0, $D9B8R.default),
    [(0, $huubg.filter).id]: (0, $iLJVZ.default),
    [(0, $5ousX.filter).id]: (0, $d2tOF.default),
    [(0, $1sswv.filter).id]: (0, $90exq.default),
    [(0, $a97k3.filter).id]: (0, $6YAWs.default),
    [(0, $6jSbc.filter).id]: (0, $5KTta.default),
    [(0, $e7L4o.filter).id]: (0, $3hfXG.default),
    [(0, $5X4Ay.filter).id]: (0, $1a3HI.default),
    [(0, $f1JPm.filter).id]: (0, $5HYjQ.default),
    [(0, $gHwfH.filter).id]: (0, $d8wvI.default),
    [(0, $dQXZO.filter).id]: (0, $9wx2v.default),
    [(0, $gwbWt.filter).id]: (0, $6alnB.default),
    [(0, $b6IhR.filter).id]: (0, $eCrxg.default),
    [(0, $5eFo6.filter).id]: (0, $1zHCN.default),
    [(0, $jqLa8.filter).id]: (0, $3b25659dee9869d9$export$2e2bcd8739ae039),
    [(0, $dXdDw.filter).id]: (0, $3xkiG.default),
    [(0, $aeffu.filter).id]: (0, $4VBuR.default),
    [(0, $fLju9.filter).id]: (0, $epJdx.default),
    [(0, $720nW.filter).id]: (0, $2UnmY.default),
    [(0, $5VnRb.filter).id]: (0, $iK2jT.default),
    [(0, $F3Hv6.filter).id]: (0, $5rAmH.default),
    [(0, $hHAPz.filter).id]: (0, $3IsTa.default),
    [(0, $dFCIx.filter).id]: (0, $j8URb.default),
    [(0, $3TPSi.filter).id]: (0, $dHIx8.default),
    [(0, $dzNsR.filter).id]: (0, $kvgSJ.default),
    [(0, $iz3ta.filter).id]: (0, $1Ddz9.default),
    [(0, $3Q16G.filter).id]: (0, $3LQ5r.default)
};
const $b409c1590183c3bd$var$checkboxFilters = {
    [(0, $9DkM9.filter).id]: (0, $5773E.default),
    [(0, $bF9JE.filter).id]: (0, $hTSDS.default),
    [(0, $iaYRG.filter).id]: (0, $b7IiT.default),
    [(0, $fw303.filter).id]: (0, $c4DtA.default),
    [(0, $k7ise.filter).id]: (0, $5XOrc.default),
    [(0, $2a0ps.filter).id]: (0, $17vNL.default),
    [(0, $lPWNq.filter).id]: (0, $10wA9.default)
};
const $b409c1590183c3bd$var$dividerStylesOld = (0, $ecnYn.xcss)({
    borderBottomWidth: 'border.width',
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderTop: 0,
    marginInline: 'space.200'
});
const $b409c1590183c3bd$var$dividerStyles = (0, $ecnYn.xcss)({
    borderBottomWidth: 'border.width',
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderTop: 0
});
const $b409c1590183c3bd$var$badgeStyles = (0, $ecnYn.xcss)({
    alignItems: 'center',
    alignSelf: 'center',
    display: 'flex'
});
const $b409c1590183c3bd$var$DropdownFilter = ({ experience: experience = (0, $9rRKJ.SearchExperience).SEARCH_PAGE, onFiltersChange: onFiltersChange, onDropdownOpenChange: onDropdownOpenChange, hideOnHoverOut: hideOnHoverOut = false, onClearOptions: onClearOptions })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [{ selectedFilterCount: selectedFilterCountWithoutProduct }] = (0, $djVCD.useSelectedFilterCount)();
    const { resetSort: resetSort, clearAllFilters: clearAllFilters, unsetFilterDropdownOpen: unsetFilterDropdownOpen } = (0, $djVCD.useSearchActions)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const [isAnyFilterSelected] = (0, $djVCD.useAnyFilterSelected)();
    const isConfluence = selectedProduct === (0, $b4tvS.ProductKeys).Confluence;
    const isJira = selectedProduct === (0, $b4tvS.ProductKeys).Jira;
    const filtersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [features] = (0, $j4ply.useFeatures)();
    const isLiteMode = features?.lite?.enabled ?? false;
    // `useFiltersToDisplay` centrally applies FILTER_EXCLUSION_RULES + FILTER_INCLUSION_RULES
    // via `getExcludedFilterIds`, projecting both `filtersInLine` (consumed by ProductFilters)
    // and `filtersInDropdown` (consumed here). No further filtering is required at the call site.
    const [{ filtersInDropdown: filtersInDropdown }] = (0, $djVCD.useFiltersToDisplay)({
        basedOnPrimaryProduct: experience === (0, $9rRKJ.SearchExperience).QUICK_FIND,
        primaryProduct: primaryProduct
    });
    // `useSelectedFilterCount` also applies FILTER_EXCLUSION_RULES + FILTER_INCLUSION_RULES
    // centrally, so we only need to add 1 here for the selected-product chip (when visible).
    const selectedFilterCount = selectedProduct && filtersDiscoverability2Enabled && !isLiteMode ? selectedFilterCountWithoutProduct + 1 : selectedFilterCountWithoutProduct;
    const [filterDropdownOpenByQueryParam] = (0, $djVCD.useFilterDropdownOpenByQueryParam)();
    const [isDropdownOpen, setIsDropdownOpen] = (0, $42omo.useState)(false);
    const handleDropdownOpenChange = (0, $42omo.useCallback)(({ isOpen: isOpen })=>{
        setIsDropdownOpen(isOpen);
        onDropdownOpenChange?.(isOpen);
        if (!isOpen && filterDropdownOpenByQueryParam) unsetFilterDropdownOpen();
    }, [
        onDropdownOpenChange,
        filterDropdownOpenByQueryParam,
        unsetFilterDropdownOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kfaxy.MaybeHoverOutWrapper), {
        enabled: hideOnHoverOut,
        callback: ()=>handleDropdownOpenChange({
                isOpen: false
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
        testId: "dropdown-filter-menu",
        ...filtersDiscoverability2Enabled && {
            isOpen: isDropdownOpen || filterDropdownOpenByQueryParam,
            onOpenChange: handleDropdownOpenChange
        },
        trigger: ({ triggerRef: triggerRef, ...providedProps })=>filtersDiscoverability2Enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2ZCkf.FilterButton), {
                ref: triggerRef,
                ...providedProps,
                isSelected: selectedFilterCount > 0 || isDropdownOpen,
                testId: "dropdown-filter-button",
                "aria-label": formatMessage((0, $d8436d38d53a83ed$export$a7357cdd1f0b0168).dropdownButtonLabel),
                filterOrControlId: "dropdown",
                hasChevron: false,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, selectedFilterCount > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    xcss: $b409c1590183c3bd$var$badgeStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4sKh.default), {
                    appearance: "informationBold"
                }, selectedFilterCount)) : null)
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $coCs8.FilterButtonOld), {
                otherProps: {
                    ...providedProps,
                    ref: triggerRef
                },
                isSelected: selectedFilterCount > 0,
                filterOrControlId: "dropdown",
                selectionBadge: selectedFilterCount > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4sKh.default), {
                    appearance: "informationBold"
                }, selectedFilterCount) : null,
                testId: "dropdown-filter-button",
                ariaLabel: formatMessage((0, $d8436d38d53a83ed$export$a7357cdd1f0b0168).dropdownButtonLabel)
            }),
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: $b409c1590183c3bd$var$dropdownContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: $b409c1590183c3bd$var$filtersContainerStyles,
        space: "space.200"
    }, filtersDiscoverability2Enabled && !isLiteMode && experience !== (0, $9rRKJ.SearchExperience).QUICK_FIND && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kC3Bu.default), {
        isFilterInDropdown: true
    }), experience === (0, $9rRKJ.SearchExperience).QUICK_FIND && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fJ1R6.AppSelector), {
        isFilterInDropdown: true
    }), filtersInDropdown.map((filterId)=>{
        // TODO: remove the typecast here
        // (was added so that product type filters didn't have to be included in the filters object)
        const Filter = $b409c1590183c3bd$var$filters[filterId];
        if (!Filter) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Filter, {
            key: filterId,
            isFilterInDropdown: true,
            // Filters inside the dropdown should not close when hovering out
            hideOnHoverOut: false,
            onFilterChange: (change)=>onFiltersChange?.(filterId, change, experience === (0, $9rRKJ.SearchExperience).QUICK_FIND ? (0, $5eWut.FILTER_CHANGE_LOCATION).DROPDOWN : (0, $5eWut.FILTER_CHANGE_LOCATION).DROPDOWN_FPS),
            onClearOptions: onClearOptions
        });
    }), (isConfluence || isJira) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dm37y.ResultsSort), {
        isFilterInDropdown: true
    }), filtersInDropdown.filter((id)=>{
        if (experience === (0, $9rRKJ.SearchExperience).QUICK_FIND) return id !== (0, $9DkM9.filter).id && id !== (0, $2a0ps.filter).id;
        else return true;
    }).map((filterId)=>{
        const Filter = $b409c1590183c3bd$var$checkboxFilters[filterId];
        if (!Filter) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Filter, {
            key: filterId,
            isFilterInDropdown: true,
            onFilterChange: (change)=>onFiltersChange?.(filterId, change, experience === (0, $9rRKJ.SearchExperience).QUICK_FIND ? (0, $5eWut.FILTER_CHANGE_LOCATION).DROPDOWN : (0, $5eWut.FILTER_CHANGE_LOCATION).DROPDOWN_FPS),
            onClearOptions: onClearOptions
        });
    })), isAnyFilterSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, filtersDiscoverability2Enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $b409c1590183c3bd$var$dividerStyles
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $b409c1590183c3bd$var$dividerStylesOld
    }), filtersDiscoverability2Enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $euOzb.default), {
        xcss: $b409c1590183c3bd$var$clearButtonStyles,
        text: (0, $d8436d38d53a83ed$export$a7357cdd1f0b0168).clearFilters,
        onClick: ()=>{
            // TODO: Consolidate these clear filter functions
            // Should we use clearAllAvailableFilters or clearAllFilters?
            // https://product-fabric.atlassian.net/browse/QS-5911
            clearAllFilters();
            resetSort();
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $b409c1590183c3bd$var$clearButtonStylesOld
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        onClick: ()=>{
            // TODO: Consolidate these clear filter functions
            // Should we use clearAllAvailableFilters or clearAllFilters?
            // https://product-fabric.atlassian.net/browse/QS-5911
            clearAllFilters();
            resetSort();
        }
    }, formatMessage((0, $d8436d38d53a83ed$export$a7357cdd1f0b0168).clearFilters)))))));
};
var $b409c1590183c3bd$export$2e2bcd8739ae039 = $b409c1590183c3bd$var$DropdownFilter;
module.exports["default"] = $b409c1590183c3bd$export$2e2bcd8739ae039;

});

parcelRegister("fJ1R6", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $8tdj3 = parcelRequire("8tdj3");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $3gadb = parcelRequire("3gadb");


var $fLkRZ = parcelRequire("fLkRZ");


var $b4tvS = parcelRequire("b4tvS");

var $6Gsan = parcelRequire("6Gsan");
parcelRequire("1yEFx");
var $1yEFx = parcelRequire("1yEFx");


var $7WbA8 = parcelRequire("7WbA8");


var $lBO0P = parcelRequire("lBO0P");


var $9ZAVx = parcelRequire("9ZAVx");


var $hrMXM = parcelRequire("hrMXM");


var $YqPsE = parcelRequire("YqPsE");


var $5xGHP = parcelRequire("5xGHP");


var $3KrAM = parcelRequire("3KrAM");


var $gGFxq = parcelRequire("gGFxq");


var $inrbX = parcelRequire("inrbX");


var $j4ply = parcelRequire("j4ply");


var $4VmlX = parcelRequire("4VmlX");


var $djVCD = parcelRequire("djVCD");




const $d39873dfddd4cec0$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    app: {
        id: "search-page.filters.names.app-select",
        defaultMessage: "App"
    },
    all: {
        id: "search-page.filter.app-select.all",
        defaultMessage: "All"
    },
    appSelectPlaceholder: {
        id: "search-page.filter.app-select.placeholder",
        defaultMessage: "Find app"
    },
    appSelectLabelSelected: {
        id: "search-page.filter.app-select.label.selected",
        defaultMessage: "Selected"
    },
    appSelectLabelUnselected: {
        id: "search-page.filter.app-select.label.unselected",
        defaultMessage: "Suggested"
    },
    appRedirectTooltip: {
        id: "search-page.filter.app-select.tooltip.redirect",
        defaultMessage: "Open a full page search filtered by {appLabel} results"
    }
});




parcelRequire("1yEFx");





const $80e3da07755ed193$export$46bdcc80066cc764 = ({ existingOptionValues: existingOptionValues, primaryProduct: primaryProduct, thirdPartyConfigs: thirdPartyConfigs, hasGitHubConfig: hasGitHubConfig })=>{
    if (primaryProduct !== (0, $6Gsan.PrimaryProductKeys).Jira) return false;
    const isGitHubConnected = (0, $gGFxq.isUserOAuthed)((0, $b4tvS.ProductKeys).Github, thirdPartyConfigs ?? {}).userNeedsOAuth === false;
    if (!isGitHubConnected || !hasGitHubConfig) return false;
    const isGitHubAlreadyIncluded = existingOptionValues.includes((0, $b4tvS.ProductKeys).Github);
    if (isGitHubAlreadyIncluded) return false;
    return true;
};


const $6e769a1a76e8bc25$var$MAX_SUGGESTED_1P = 3; // This includes the primary product
const $6e769a1a76e8bc25$var$MAX_SUGGESTED_3P = 2;
const $6e769a1a76e8bc25$var$appOptionStyles = {
    default: "_zulp12x7 _1bsb1osq _1e0c11p5 _4cvr1h6o _yv0e1mfv"
};
const $6e769a1a76e8bc25$var$getOptionLabel = (productKey, productConfig, thirdPartyConfigs)=>{
    // Edge case: This is to get the name of Confluence DC sites
    const workspaceName = (0, $YqPsE.getWorkspaceNameFromProduct)(productKey, thirdPartyConfigs);
    if (workspaceName) return workspaceName;
    if (typeof productConfig.displayName === 'string') return productConfig.displayName;
     // In theory this we should not reach here as displayName is rendered as a string
    return '';
};
const $6e769a1a76e8bc25$export$ab67fd9b6bfc576 = ({ isFilterInDropdown: isFilterInDropdown, fit: fit })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const availableProducts = (0, $j4ply.useAvailableProducts)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const productConfigs = (0, $1yEFx.useProductConfigs)();
    const [thirdPartyConfigs] = (0, $j4ply.useThirdPartyConfigs)();
    const { selectProductFilter: selectProductFilter, unselectProductFilter: unselectProductFilter, clearAllFilters: clearAllFilters } = (0, $djVCD.useSearchActions)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { onNavigate: onNavigate, generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $7WbA8.useAppContext)();
    const quickFindQuery = (0, $4VmlX.useQuickFindQuery)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $4VmlX.useQuickFindActions)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $inrbX.useQuickFindAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $inrbX.useQuickFindAttributes)();
    const onAppSelectEvent = (0, $42omo.useCallback)((props)=>{
        const { productKey: productKey, isRedirectedToFPS: isRedirectedToFPS } = props;
        fireAnalyticsEvent((0, $5xGHP.onAppFilterSelect)({
            actionSubjectId: productKey,
            action: 'selected',
            attributes: {
                ...commonAttributes,
                isPostAuthAction: false,
                isRedirectedToFPS: isRedirectedToFPS,
                source: isFilterInDropdown ? 'app-selector-dropdown' : 'app-selector-inline'
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        }));
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        isFilterInDropdown,
        nonPrivacySafeAttributes
    ]);
    const onSelectChange = (0, $42omo.useCallback)((value)=>{
        const selectedValue = Array.isArray(value) ? value[1] : value;
        const productKey = selectedValue.value;
        if (!(0, $b4tvS.isProductKey)(productKey)) return;
        if (productKey === primaryProduct) {
            selectProductFilter(productKey);
            onAppSelectEvent({
                productKey: productKey,
                isRedirectedToFPS: false
            });
            return;
        }
        const onNavigateCallback = typeof onNavigate === 'function' ? onNavigate : onNavigate.callback;
        onNavigateCallback(generateSearchUrl({
            ...queryParams,
            product: productKey,
            text: quickFindQuery
        }), 'push');
        onAppSelectEvent({
            productKey: productKey,
            isRedirectedToFPS: true
        });
        clearAllFilters();
        setQuickFindOpen(false);
    }, [
        clearAllFilters,
        generateSearchUrl,
        onAppSelectEvent,
        onNavigate,
        primaryProduct,
        queryParams,
        quickFindQuery,
        selectProductFilter,
        setQuickFindOpen
    ]);
    const allAppOptions = (0, $42omo.useMemo)(()=>{
        const productsOrder = (0, $hrMXM.getProductsOrderByPrimaryProduct)(primaryProduct);
        const counts = {
            apps1P: 0,
            apps3P: 0
        };
        const baseAppOptions = availableProducts.filter((productKey)=>{
            // Always exclude Atlas
            if (productKey === (0, $b4tvS.ProductKeys).Atlas || productKey === (0, $b4tvS.ProductKeys).AtlassianWebCrawler) return false;
            return true;
        }).filter((productKey)=>{
            const { userNeedsOAuth: userNeedsOAuth } = (0, $gGFxq.isUserOAuthed)(productKey, thirdPartyConfigs); // For 3P products, undefined means not configured — filter out
            if ((0, $b4tvS.is3pProductKey)(productKey)) return userNeedsOAuth === false;
             // For 1P products, undefined is expected (no OAuth needed)
            return !userNeedsOAuth;
        }).filter((productKey)=>productConfigs[productKey]).sort((a, b)=>(0, $9ZAVx.getProductOrder)(a, b, productsOrder)).filter((productKey)=>{
            // Edge Case: Loom is considered as 1P only for the App selector
            if (productKey === (0, $b4tvS.ProductKeys).Loom) {
                if (counts.apps1P < $6e769a1a76e8bc25$var$MAX_SUGGESTED_1P) {
                    counts.apps1P += 1;
                    return true;
                }
                return false;
            }
            if ((0, $b4tvS.is1pProductKey)(productKey) && counts.apps1P < $6e769a1a76e8bc25$var$MAX_SUGGESTED_1P) {
                counts.apps1P += 1;
                return true;
            }
            if ((0, $b4tvS.is3pProductKey)(productKey) && counts.apps3P < $6e769a1a76e8bc25$var$MAX_SUGGESTED_3P) {
                counts.apps3P += 1;
                return true;
            }
            return false;
        }).map((productKey)=>{
            return {
                value: productKey,
                isSelected: productKey === selectedProduct,
                label: $6e769a1a76e8bc25$var$getOptionLabel(productKey, productConfigs[productKey], thirdPartyConfigs),
                isDefault: false,
                trackingKey: productKey,
                queryParamValue: productKey,
                isSuggested: false
            };
        });
        if ((0, $80e3da07755ed193$export$46bdcc80066cc764)({
            existingOptionValues: baseAppOptions.map((option)=>option.value),
            primaryProduct: primaryProduct,
            thirdPartyConfigs: thirdPartyConfigs,
            hasGitHubConfig: Boolean(productConfigs[(0, $b4tvS.ProductKeys).Github])
        })) baseAppOptions.push({
            value: (0, $b4tvS.ProductKeys).Github,
            isSelected: (0, $b4tvS.ProductKeys).Github === selectedProduct,
            label: $6e769a1a76e8bc25$var$getOptionLabel((0, $b4tvS.ProductKeys).Github, productConfigs[(0, $b4tvS.ProductKeys).Github], thirdPartyConfigs),
            isDefault: false,
            trackingKey: (0, $b4tvS.ProductKeys).Github,
            queryParamValue: (0, $b4tvS.ProductKeys).Github,
            isSuggested: false
        });
        return baseAppOptions;
    }, [
        availableProducts,
        primaryProduct,
        productConfigs,
        selectedProduct,
        thirdPartyConfigs
    ]);
    const selectedOption = (0, $42omo.useMemo)(()=>{
        const singleSelectedOption = allAppOptions.filter((option)=>option.isSelected)[0];
        return singleSelectedOption ? [
            singleSelectedOption
        ] : [];
    }, [
        allAppOptions
    ]);
    const selectedStateIcon = (0, $42omo.useMemo)(()=>{
        if ((0, $b4tvS.isProductKey)(selectedProduct)) {
            const productConfig = productConfigs[selectedProduct];
            const Icon = productConfig.Icon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
                size: "xxsmall"
            });
        }
        if (primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fLkRZ.JiraAppSelectorIconWithGithub), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3KrAM.AllAppsIcon), null);
    }, [
        primaryProduct,
        productConfigs,
        selectedProduct
    ]);
    const groupedOptions = [
        {
            label: formatMessage((0, $d39873dfddd4cec0$export$a7357cdd1f0b0168).appSelectLabelUnselected),
            options: allAppOptions
        }
    ];
    const formatOptionLabel = (0, $42omo.useCallback)((data)=>{
        const productKey = data.value;
        const appLabel = data.label;
        if (typeof productKey !== 'string' || !(0, $b4tvS.isProductKey)(productKey)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
        const productConfig = productConfigs[productKey];
        const Icon = productConfig.Icon;
        const AppOption = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
                size: "small"
            }), appLabel, props.isRedirect && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
                size: "small",
                label: ""
            }));
        if (productKey === primaryProduct) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $6e769a1a76e8bc25$var$appOptionStyles.default
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(AppOption, {
            isRedirect: false
        }));
        const tooltipContent = formatMessage((0, $d39873dfddd4cec0$export$a7357cdd1f0b0168).appRedirectTooltip, {
            appLabel: appLabel
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            testId: "qf-app-fps-redirect-tooltip",
            position: "right",
            content: tooltipContent
        }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                ...tooltipProps,
                xcss: $6e769a1a76e8bc25$var$appOptionStyles.default
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(AppOption, {
                isRedirect: true
            })));
    }, [
        formatMessage,
        primaryProduct,
        productConfigs
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        testId: "qf-app-selector",
        onSelectChange: onSelectChange,
        options: groupedOptions,
        selectedOptions: selectedOption,
        label: selectedOption.length === 0 ? formatMessage((0, $d39873dfddd4cec0$export$a7357cdd1f0b0168).app) : '',
        placeholder: formatMessage((0, $d39873dfddd4cec0$export$a7357cdd1f0b0168).appSelectPlaceholder),
        formatOptionLabel: formatOptionLabel,
        iconBefore: selectedStateIcon,
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: true,
        canClearFilter: true,
        onClearOptions: unselectProductFilter,
        hideOnHoverOut: primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira && (0, $dh538.fg)('search_qf_close_dropdown_on_hover_off')
    });
};
module.exports["AppSelector"] = $6e769a1a76e8bc25$export$ab67fd9b6bfc576;

});

parcelRegister("fLkRZ", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $304abc6f6f5e7b0a$export$20d3ba059bd0c642 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(11);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            width: "16",
            height: "16",
            rx: "4",
            fill: "#1868DB"
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    let t2;
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
            clipPath: "url(#clip0_2023_10818)"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
            clipPath: "url(#clip1_2023_10818)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M11.5797 9.51003C9.1108 8.31624 8.38955 8.13786 7.34929 8.13786C6.12871 8.13786 5.08845 8.64556 4.15915 10.0726L4.00658 10.3059C3.88174 10.498 3.854 10.5666 3.854 10.6489C3.854 10.7313 3.89561 10.7999 4.04819 10.8959L5.61552 11.8702C5.69874 11.9251 5.76809 11.9525 5.83744 11.9525C5.92066 11.9525 5.97614 11.9113 6.05936 11.7878L6.30903 11.4036C6.69739 10.8136 7.04415 10.6215 7.48799 10.6215C7.87636 10.6215 8.33407 10.7313 8.90275 11.0057L10.5394 11.7741C10.7059 11.8564 10.8862 11.8153 10.9694 11.6232L11.7461 9.92168C11.8294 9.72958 11.7739 9.60608 11.5797 9.51003ZM4.38107 6.50497C6.84996 7.69876 7.57121 7.87714 8.61148 7.87714C9.83205 7.87714 10.8723 7.36944 11.8016 5.94238L11.9542 5.70911C12.079 5.517 12.1068 5.4484 12.1068 5.36607C12.1068 5.28373 12.0652 5.21513 11.9126 5.11907L10.3452 4.14483C10.262 4.08994 10.1927 4.0625 10.1233 4.0625C10.0401 4.0625 9.98462 4.10367 9.9014 4.22716L9.65174 4.61137C9.26338 5.2014 8.91662 5.39351 8.47277 5.39351C8.08441 5.39351 7.62669 5.28373 7.05802 5.0093L5.42133 4.24088C5.25489 4.15855 5.07458 4.19972 4.99136 4.39182L4.21463 6.09332C4.13141 6.28542 4.18689 6.40892 4.38107 6.50497Z",
            fill: "white"
        })));
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M18 4C18 1.79086 19.7909 0 22 0H30C32.2091 0 34 1.79086 34 4V12C34 14.2091 32.2091 16 30 16H22C19.7909 16 18 14.2091 18 12V4Z",
            fill: "#292A2E"
        });
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M25.9996 3.00003C23.2385 3.00003 20.9995 5.29523 20.9995 8.12662C20.9995 10.3917 22.4322 12.3133 24.4188 12.9912C24.6687 13.0387 24.7605 12.88 24.7605 12.7446C24.7605 12.6224 24.7558 12.2185 24.7537 11.7901C23.3627 12.1003 23.0691 11.1853 23.0691 11.1853C22.8417 10.5927 22.514 10.4351 22.514 10.4351C22.0603 10.117 22.5482 10.1235 22.5482 10.1235C23.0503 10.1597 23.3146 10.6518 23.3146 10.6518C23.7606 11.4355 24.4843 11.209 24.7697 11.078C24.8145 10.7466 24.9441 10.5205 25.0871 10.3924C23.9765 10.2628 22.8091 9.82323 22.8091 7.85886C22.8091 7.29915 23.0044 6.84183 23.3242 6.48281C23.2723 6.35369 23.1012 5.83227 23.3727 5.12612C23.3727 5.12612 23.7926 4.98834 24.7481 5.65161C25.1469 5.53803 25.5746 5.48106 25.9996 5.47911C26.4245 5.48106 26.8525 5.53803 27.2521 5.65161C28.2065 4.98834 28.6258 5.12612 28.6258 5.12612C28.8979 5.83227 28.7267 6.35369 28.6748 6.48281C28.9954 6.84183 29.1894 7.29915 29.1894 7.85886C29.1894 9.8279 28.0197 10.2614 26.9063 10.3884C27.0856 10.5475 27.2454 10.8594 27.2454 11.3377C27.2454 12.0237 27.2396 12.5757 27.2396 12.7446C27.2396 12.881 27.3296 13.0409 27.5831 12.9905C29.5687 12.3119 30.9995 10.3909 30.9995 8.12662C30.9995 5.29523 28.7609 3.00003 25.9996 3.00003Z",
            fill: "white"
        });
        $[1] = t1;
        $[2] = t2;
        $[3] = t3;
    } else {
        t1 = $[1];
        t2 = $[2];
        t3 = $[3];
    }
    let t4;
    let t5;
    let t6;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("mask", {
            id: "path-5-inside-1_2023_10818",
            fill: "white"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M36 4C36 1.79086 37.7909 0 40 0H48C50.2091 0 52 1.79086 52 4V12C52 14.2091 50.2091 16 48 16H40C37.7909 16 36 14.2091 36 12V4Z"
        }));
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M36 4C36 1.79086 37.7909 0 40 0H48C50.2091 0 52 1.79086 52 4V12C52 14.2091 50.2091 16 48 16H40C37.7909 16 36 14.2091 36 12V4Z",
            fill: "white"
        });
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M40 0V1H48V0V-1H40V0ZM52 4H51V12H52H53V4H52ZM48 16V15H40V16V17H48V16ZM36 12H37V4H36H35V12H36ZM40 16V15C38.3431 15 37 13.6569 37 12H36H35C35 14.7614 37.2386 17 40 17V16ZM52 12H51C51 13.6569 49.6569 15 48 15V16V17C50.7614 17 53 14.7614 53 12H52ZM48 0V1C49.6569 1 51 2.34315 51 4H52H53C53 1.23858 50.7614 -1 48 -1V0ZM40 0V-1C37.2386 -1 35 1.23858 35 4H36H37C37 2.34315 38.3431 1 40 1V0Z",
            fill: "#0B120E",
            fillOpacity: "0.14",
            mask: "url(#path-5-inside-1_2023_10818)"
        });
        $[4] = t4;
        $[5] = t5;
        $[6] = t6;
    } else {
        t4 = $[4];
        t5 = $[5];
        t6 = $[6];
    }
    let t7;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
            clipPath: "url(#clip2_2023_10818)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M39.4724 11.3855L39.9428 12.1939C40.0406 12.3641 40.1811 12.4978 40.346 12.595L42.0261 9.70197H38.666C38.666 9.89038 38.7149 10.0788 38.8126 10.249L39.4724 11.3855Z",
            fill: "#0066DA"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M43.9993 6.29837L42.3193 3.4053C42.1544 3.50255 42.0139 3.63626 41.9161 3.80644L38.8126 9.15497C38.7167 9.32148 38.6661 9.51005 38.666 9.70198H42.0261L43.9993 6.29837Z",
            fill: "#00AC47"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M47.6534 12.595C47.8184 12.4978 47.9589 12.3641 48.0566 12.1939L48.2521 11.8596L49.1868 10.249C49.2846 10.0788 49.3335 9.89038 49.3335 9.70197H45.9731L46.6882 11.0999L47.6534 12.595Z",
            fill: "#EA4335"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M43.9999 6.29846L45.6799 3.40539C45.5149 3.30814 45.3256 3.25952 45.1301 3.25952H42.8697C42.6742 3.25952 42.4848 3.31422 42.3198 3.40539L43.9999 6.29846Z",
            fill: "#00832D"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M45.9723 9.70197H42.0257L40.3457 12.595C40.5107 12.6923 40.7 12.7409 40.8955 12.7409H47.1025C47.298 12.7409 47.4874 12.6862 47.6523 12.595L45.9723 9.70197Z",
            fill: "#2684FC"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M47.635 6.48071L46.0832 3.80644C45.9855 3.63626 45.845 3.50255 45.68 3.4053L44 6.29837L45.9733 9.70198H49.3272C49.3272 9.51357 49.2784 9.32515 49.1806 9.15497L47.635 6.48071Z",
            fill: "#FFBA00"
        }));
        $[7] = t7;
    } else t7 = $[7];
    let t8;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
            id: "clip0_2023_10818"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            width: "16",
            height: "16",
            fill: "white"
        }));
        $[8] = t8;
    } else t8 = $[8];
    let t9;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
            id: "clip1_2023_10818"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            width: "8.25276",
            height: "7.89",
            fill: "white",
            transform: "translate(3.854 4.0625)"
        }));
        $[9] = t9;
    } else t9 = $[9];
    let t10;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
            width: "52",
            height: "16",
            viewBox: "0 0 52 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t1, t2, t3, t4, t5, t6, t7, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, t8, t9, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
            id: "clip2_2023_10818"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            width: "10.6667",
            height: "9.48148",
            fill: "white",
            transform: "translate(38.666 3.2594)"
        }))));
        $[10] = t10;
    } else t10 = $[10];
    return t10;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "52",
        height: "16",
        viewBox: "0 0 52 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_2023_10818)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "16",
        height: "16",
        rx: "4",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip1_2023_10818)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M11.5797 9.51003C9.1108 8.31624 8.38955 8.13786 7.34929 8.13786C6.12871 8.13786 5.08845 8.64556 4.15915 10.0726L4.00658 10.3059C3.88174 10.498 3.854 10.5666 3.854 10.6489C3.854 10.7313 3.89561 10.7999 4.04819 10.8959L5.61552 11.8702C5.69874 11.9251 5.76809 11.9525 5.83744 11.9525C5.92066 11.9525 5.97614 11.9113 6.05936 11.7878L6.30903 11.4036C6.69739 10.8136 7.04415 10.6215 7.48799 10.6215C7.87636 10.6215 8.33407 10.7313 8.90275 11.0057L10.5394 11.7741C10.7059 11.8564 10.8862 11.8153 10.9694 11.6232L11.7461 9.92168C11.8294 9.72958 11.7739 9.60608 11.5797 9.51003ZM4.38107 6.50497C6.84996 7.69876 7.57121 7.87714 8.61148 7.87714C9.83205 7.87714 10.8723 7.36944 11.8016 5.94238L11.9542 5.70911C12.079 5.517 12.1068 5.4484 12.1068 5.36607C12.1068 5.28373 12.0652 5.21513 11.9126 5.11907L10.3452 4.14483C10.262 4.08994 10.1927 4.0625 10.1233 4.0625C10.0401 4.0625 9.98462 4.10367 9.9014 4.22716L9.65174 4.61137C9.26338 5.2014 8.91662 5.39351 8.47277 5.39351C8.08441 5.39351 7.62669 5.28373 7.05802 5.0093L5.42133 4.24088C5.25489 4.15855 5.07458 4.19972 4.99136 4.39182L4.21463 6.09332C4.13141 6.28542 4.18689 6.40892 4.38107 6.50497Z",
        fill: "white"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M18 4C18 1.79086 19.7909 0 22 0H30C32.2091 0 34 1.79086 34 4V12C34 14.2091 32.2091 16 30 16H22C19.7909 16 18 14.2091 18 12V4Z",
        fill: "#292A2E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25.9996 3.00003C23.2385 3.00003 20.9995 5.29523 20.9995 8.12662C20.9995 10.3917 22.4322 12.3133 24.4188 12.9912C24.6687 13.0387 24.7605 12.88 24.7605 12.7446C24.7605 12.6224 24.7558 12.2185 24.7537 11.7901C23.3627 12.1003 23.0691 11.1853 23.0691 11.1853C22.8417 10.5927 22.514 10.4351 22.514 10.4351C22.0603 10.117 22.5482 10.1235 22.5482 10.1235C23.0503 10.1597 23.3146 10.6518 23.3146 10.6518C23.7606 11.4355 24.4843 11.209 24.7697 11.078C24.8145 10.7466 24.9441 10.5205 25.0871 10.3924C23.9765 10.2628 22.8091 9.82323 22.8091 7.85886C22.8091 7.29915 23.0044 6.84183 23.3242 6.48281C23.2723 6.35369 23.1012 5.83227 23.3727 5.12612C23.3727 5.12612 23.7926 4.98834 24.7481 5.65161C25.1469 5.53803 25.5746 5.48106 25.9996 5.47911C26.4245 5.48106 26.8525 5.53803 27.2521 5.65161C28.2065 4.98834 28.6258 5.12612 28.6258 5.12612C28.8979 5.83227 28.7267 6.35369 28.6748 6.48281C28.9954 6.84183 29.1894 7.29915 29.1894 7.85886C29.1894 9.8279 28.0197 10.2614 26.9063 10.3884C27.0856 10.5475 27.2454 10.8594 27.2454 11.3377C27.2454 12.0237 27.2396 12.5757 27.2396 12.7446C27.2396 12.881 27.3296 13.0409 27.5831 12.9905C29.5687 12.3119 30.9995 10.3909 30.9995 8.12662C30.9995 5.29523 28.7609 3.00003 25.9996 3.00003Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("mask", {
        id: "path-5-inside-1_2023_10818",
        fill: "white"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M36 4C36 1.79086 37.7909 0 40 0H48C50.2091 0 52 1.79086 52 4V12C52 14.2091 50.2091 16 48 16H40C37.7909 16 36 14.2091 36 12V4Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M36 4C36 1.79086 37.7909 0 40 0H48C50.2091 0 52 1.79086 52 4V12C52 14.2091 50.2091 16 48 16H40C37.7909 16 36 14.2091 36 12V4Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M40 0V1H48V0V-1H40V0ZM52 4H51V12H52H53V4H52ZM48 16V15H40V16V17H48V16ZM36 12H37V4H36H35V12H36ZM40 16V15C38.3431 15 37 13.6569 37 12H36H35C35 14.7614 37.2386 17 40 17V16ZM52 12H51C51 13.6569 49.6569 15 48 15V16V17C50.7614 17 53 14.7614 53 12H52ZM48 0V1C49.6569 1 51 2.34315 51 4H52H53C53 1.23858 50.7614 -1 48 -1V0ZM40 0V-1C37.2386 -1 35 1.23858 35 4H36H37C37 2.34315 38.3431 1 40 1V0Z",
        fill: "#0B120E",
        fillOpacity: "0.14",
        mask: "url(#path-5-inside-1_2023_10818)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip2_2023_10818)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M39.4724 11.3855L39.9428 12.1939C40.0406 12.3641 40.1811 12.4978 40.346 12.595L42.0261 9.70197H38.666C38.666 9.89038 38.7149 10.0788 38.8126 10.249L39.4724 11.3855Z",
        fill: "#0066DA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M43.9993 6.29837L42.3193 3.4053C42.1544 3.50255 42.0139 3.63626 41.9161 3.80644L38.8126 9.15497C38.7167 9.32148 38.6661 9.51005 38.666 9.70198H42.0261L43.9993 6.29837Z",
        fill: "#00AC47"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M47.6534 12.595C47.8184 12.4978 47.9589 12.3641 48.0566 12.1939L48.2521 11.8596L49.1868 10.249C49.2846 10.0788 49.3335 9.89038 49.3335 9.70197H45.9731L46.6882 11.0999L47.6534 12.595Z",
        fill: "#EA4335"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M43.9999 6.29846L45.6799 3.40539C45.5149 3.30814 45.3256 3.25952 45.1301 3.25952H42.8697C42.6742 3.25952 42.4848 3.31422 42.3198 3.40539L43.9999 6.29846Z",
        fill: "#00832D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M45.9723 9.70197H42.0257L40.3457 12.595C40.5107 12.6923 40.7 12.7409 40.8955 12.7409H47.1025C47.298 12.7409 47.4874 12.6862 47.6523 12.595L45.9723 9.70197Z",
        fill: "#2684FC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M47.635 6.48071L46.0832 3.80644C45.9855 3.63626 45.845 3.50255 45.68 3.4053L44 6.29837L45.9733 9.70198H49.3272C49.3272 9.51357 49.2784 9.32515 49.1806 9.15497L47.635 6.48071Z",
        fill: "#FFBA00"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_2023_10818"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "16",
        height: "16",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip1_2023_10818"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "8.25276",
        height: "7.89",
        fill: "white",
        transform: "translate(3.854 4.0625)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip2_2023_10818"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "10.6667",
        height: "9.48148",
        fill: "white",
        transform: "translate(38.666 3.2594)"
    }))));
module.exports["JiraAppSelectorIconWithGithub"] = $304abc6f6f5e7b0a$export$20d3ba059bd0c642;

});

parcelRegister("3KrAM", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");


var $78z3f = parcelRequire("78z3f");


var $6Gsan = parcelRequire("6Gsan");
parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");
var $1yEFx = parcelRequire("1yEFx");


var $j4ply = parcelRequire("j4ply");

const $23f4502b40886e8a$var$styles = {
    container: "_zulp1b66 _1e0c1txw _4cvr1h6o",
    iconBox: "_1reo15vq _18m915vq _2rko12b0 _1e0c1txw _4cvr1h6o _1bah1h6o _1bsb7vkz _4t3i7vkz _1o9zidpf"
}; /**
    * Renders a strip of 3 app icons: the primary 1P app icon (Confluence if Jira,
    * Jira otherwise) followed by static Google Drive and Slack icons.
    */ 
const $23f4502b40886e8a$export$a9ec35d044cf4cf = ()=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const productConfigs = (0, $1yEFx.useProductConfigs)();
    const FirstPartyIcon = primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira ? productConfigs[(0, $b4tvS.ProductKeys).Confluence]?.Icon : productConfigs[(0, $b4tvS.ProductKeys).Jira]?.Icon;
    const icons = [
        FirstPartyIcon,
        productConfigs[(0, $78z3f.ProductKeys3P).GoogleDrive]?.Icon,
        productConfigs[(0, $78z3f.ProductKeys3P).Slack]?.Icon
    ].filter(Boolean);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        role: "presentation",
        "aria-hidden": "true",
        xcss: $23f4502b40886e8a$var$styles.container
    }, icons.map((Icon, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            key: index,
            xcss: $23f4502b40886e8a$var$styles.iconBox
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            size: "xxsmall"
        }))));
};
module.exports["AllAppsIcon"] = $23f4502b40886e8a$export$a9ec35d044cf4cf;

});

parcelRegister("3fzmz", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $gHaxX = parcelRequire("gHaxX");


var $4bnNr = parcelRequire("4bnNr");


var $dHZuf = parcelRequire("dHZuf");

const $8e3820e3b87a8a9b$export$4e07a927e22bed0a = ({ query: query, projectARIs: projectARIs, accountARIs: accountARIs })=>{
    let text;
    if (query) {
        // If the query looks like an issue key, use issueKey instead of textfields
        if ((0, $dHZuf.isQueryLikeWorkItemKey)(query)) text = `issuekey ~ "${encodeURIComponent(query)}*"`;
        else text = `textfields ~ "${encodeURIComponent(query)}*"`;
    }
    const projectIds = projectARIs.map($8e3820e3b87a8a9b$var$getProjectIdFromProjectAri).filter(Boolean);
    const projectJQL = projectARIs.length > 0 ? `project IN (${encodeURIComponent(projectIds.join(','))})` : undefined;
    const accountIds = accountARIs.map($8e3820e3b87a8a9b$var$getAccountIdFromUserAri).filter(Boolean);
    const assigneeClause = accountIds.length > 0 ? `assignee IN (${encodeURIComponent(accountIds.join(','))})` : undefined;
    return [
        text,
        projectJQL,
        assigneeClause
    ].filter(Boolean).join(' AND ');
};
function $8e3820e3b87a8a9b$var$getProjectIdFromProjectAri(projectAri) {
    try {
        return projectAri ? (0, $4bnNr.JiraProjectAri).parse(projectAri).projectId : undefined;
    } catch  {
        return undefined;
    }
}
function $8e3820e3b87a8a9b$var$getAccountIdFromUserAri(userAri) {
    try {
        return userAri ? (0, $gHaxX.IdentityUserAri).parse(userAri).userId : undefined;
    } catch  {
        return undefined;
    }
}
const $8e3820e3b87a8a9b$export$23c957892b92c4a0 = ({ query: query, jiraFilters: jiraFilters, generateSearchUrl: generateSearchUrl, queryParams: queryParams = {}, issueKeyLookup: issueKeyLookup, isQueryJql: isQueryJql = false })=>{
    const trimmedQuery = query.trim();
    let jql;
    const typedJqlRoutingEnabled = (0, $dh538.fg)('rovo_fps_route_typed_jql_as_jql');
    if (typedJqlRoutingEnabled && isQueryJql) jql = trimmedQuery;
    else if (trimmedQuery !== '' && (jiraFilters.issueFilter.projectARIs.length !== 0 || jiraFilters.issueFilter.assigneeARIs.length !== 0)) /* If query is empty we don't need to build jql as it will be ignored by generateSearchUrl
		 ** Otherwise, we pass the JQL to be redirected to work items page */ jql = $8e3820e3b87a8a9b$export$4e07a927e22bed0a({
        query: trimmedQuery,
        accountARIs: jiraFilters.issueFilter.assigneeARIs,
        projectARIs: jiraFilters.issueFilter.projectARIs
    });
    /* generateSearchUrl takes care of navigating to a signle work item page in case the query is a work item key
	 * Otherwise, it'll take the user to work items page.
	 * */ return generateSearchUrl({
        ...queryParams,
        text: query,
        ...jql && {
            jql: jql
        }
    }, true, undefined, undefined, issueKeyLookup);
};
const $8e3820e3b87a8a9b$export$ddc03b5bf54ec4ae = (query)=>`/jira/search?searchString=${encodeURIComponent(query)}`;
const $8e3820e3b87a8a9b$export$9b8240b7fc8c64cd = (params)=>{
    const trimmedQuery = params.query.trim();
    if (trimmedQuery === '') return [];
    const jqlUrl = $8e3820e3b87a8a9b$export$23c957892b92c4a0({
        ...params,
        query: trimmedQuery,
        issueKeyLookup: false
    });
    return [
        jqlUrl,
        $8e3820e3b87a8a9b$export$ddc03b5bf54ec4ae(trimmedQuery)
    ];
};
module.exports["buildJql"] = $8e3820e3b87a8a9b$export$4e07a927e22bed0a;
module.exports["getWorkItemPageUrl"] = $8e3820e3b87a8a9b$export$23c957892b92c4a0;
module.exports["getWorkItemPrefetchUrls"] = $8e3820e3b87a8a9b$export$9b8240b7fc8c64cd;

});

parcelRegister("dHZuf", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $371c7e1a4d1f86a2$export$e43472a3ada71740 = (query)=>/^[A-Z0-9]{2,}-\d+$/i.test(query.trim());
const $371c7e1a4d1f86a2$var$ISSUE_NAVIGATOR_URL = `/issues/?jql=${encodeURIComponent('created >= -30d order by created DESC')}`;
const $371c7e1a4d1f86a2$var$buildJiraJqlUrl = (jql, query)=>`/issues/?jql=${encodeURIComponent(jql)}&text=${encodeURIComponent(query)}`;
const $371c7e1a4d1f86a2$var$buildJiraSearchUrl = (searchString, issueKeyLookup)=>{
    if (!issueKeyLookup && (0, $dh538.fg)('rovo_search_update_work_items_link')) {
        const clauseField = $371c7e1a4d1f86a2$export$e43472a3ada71740(searchString) ? 'issuekey' : 'textfields';
        return `/issues/?jql=${clauseField} ~ "${encodeURIComponent(searchString)}*"`;
    }
    return `/jira/search?${new URLSearchParams({
        searchString: searchString
    }).toString()}`;
};
const $371c7e1a4d1f86a2$export$772e48b507423c7c = (query, jql, issueKeyLookup)=>{
    const trimmedQuery = query.trim();
    if (jql) return $371c7e1a4d1f86a2$var$buildJiraJqlUrl(jql, query);
    if (trimmedQuery) return $371c7e1a4d1f86a2$var$buildJiraSearchUrl(trimmedQuery, issueKeyLookup);
    return $371c7e1a4d1f86a2$var$ISSUE_NAVIGATOR_URL;
};
const $371c7e1a4d1f86a2$var$buildRovoSearchUrl = (siteUrl)=>{
    const path = '/jira/rovo-search';
    if (!siteUrl) return path;
    return new URL(path, siteUrl || '').href;
};
const $371c7e1a4d1f86a2$export$48bdb02c221fe04 = (urlQueryParams, isSecondaryLink, customParams, issueKeyLookup = true)=>{
    const searchParams = new URLSearchParams(customParams || {});
    // This function assumes the text is in sync with JQL text field
    let queryString = searchParams.get('text') || urlQueryParams.text?.toString() || '';
    const jql = searchParams.get('jql') || !isSecondaryLink && urlQueryParams.jql?.toString() || '';
    // remove jql from params as it's already picked up
    searchParams.delete('jql');
    if (!isSecondaryLink) Object.entries(urlQueryParams).forEach(([key, value])=>{
        // add current params if they are not in custom search params
        if (value !== undefined && value !== null && !searchParams.has(key)) searchParams.set(key, String(value));
    });
    let url = isSecondaryLink ? $371c7e1a4d1f86a2$export$772e48b507423c7c(queryString, jql, issueKeyLookup) : $371c7e1a4d1f86a2$var$buildRovoSearchUrl();
    const params = searchParams.toString();
    if (params) url = url.concat(url.includes('?') ? '&' : '?').concat(params);
    return url;
};
module.exports["isQueryLikeWorkItemKey"] = $371c7e1a4d1f86a2$export$e43472a3ada71740;
module.exports["generateJiraSearchUrl"] = $371c7e1a4d1f86a2$export$48bdb02c221fe04;

});

parcelRegister("jKHO6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::69ae267b4083f769df5c410ef6fc3d4b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e6144b661b61fa96$var$_react = $e6144b661b61fa96$var$_interopRequireDefault((parcelRequire("42omo")));

var $e6144b661b61fa96$var$_baseNew = $e6144b661b61fa96$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $e6144b661b61fa96$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Risk".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing risks.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e6144b661b61fa96$var$RiskIcon = (props)=>/*#__PURE__*/ $e6144b661b61fa96$var$_react.default.createElement($e6144b661b61fa96$var$_baseNew.default, Object.assign({
        name: "RiskIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 5.518a.5.5 0 0 0-.146-.354l-3.518-3.518a.5.5 0 0 0-.354-.146H5.518a.5.5 0 0 0-.354.146L1.646 5.164a.5.5 0 0 0-.146.354v4.964a.5.5 0 0 0 .146.354l3.518 3.518a.5.5 0 0 0 .354.146h4.964a.5.5 0 0 0 .354-.146l3.518-3.518a.5.5 0 0 0 .146-.354zm1.5 4.964a2 2 0 0 1-.586 1.415l-3.517 3.517a2 2 0 0 1-1.415.586H5.518a2 2 0 0 1-1.414-.586L.586 11.897A2 2 0 0 1 0 10.482V5.518a2 2 0 0 1 .586-1.414L4.104.586A2 2 0 0 1 5.518 0h4.964a2 2 0 0 1 1.415.586l3.517 3.518A2 2 0 0 1 16 5.518z"/><path fill="currentcolor" d="M8.75 3.5V9h-1.5V3.5zm-.75 7a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/>`
    }, props));
$e6144b661b61fa96$var$RiskIcon.displayName = 'RiskIcon';
var $e6144b661b61fa96$var$_default = module.exports.default = $e6144b661b61fa96$var$RiskIcon;

});

parcelRegister("aKt88", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5nBzc = parcelRequire("5nBzc");

// This mapping is copied from Jira FE:
// https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/master/jira/src/packages/issue/status-theming/src/statusCategoryToThemeMap.tsx
//
// If you are going to change this, please check the Jira FE mapping first to make sure they are in sync.
//
// It uses the statusCategoryId field from GQL to map to the corresponding Atlaskit lozenge appearance.
// The category IDs follow the Jira FE mapping, while the values use the semantic ADS appearances.
const $a22683c399072c80$var$STATUS_APPEARANCE_NEUTRAL = 'neutral';
const $a22683c399072c80$var$STATUS_APPEARANCE_SUCCESS = 'success';
const $a22683c399072c80$var$STATUS_APPEARANCE_INFORMATION = 'information';
const $a22683c399072c80$export$d9e35f42afe1e488 = {
    '1': $a22683c399072c80$var$STATUS_APPEARANCE_NEUTRAL,
    '2': $a22683c399072c80$var$STATUS_APPEARANCE_NEUTRAL,
    '3': $a22683c399072c80$var$STATUS_APPEARANCE_SUCCESS,
    '4': $a22683c399072c80$var$STATUS_APPEARANCE_INFORMATION
};



var $kc79t = parcelRequire("kc79t");


var $1hlFx = parcelRequire("1hlFx");

const $6a5caf72f25c94c4$var$jiraIssueStatusToLozengeMap = {
    [(0, $kc79t.JiraStatusCategoryColor).Red]: 'danger',
    [(0, $kc79t.JiraStatusCategoryColor).Brown]: 'neutral',
    [(0, $kc79t.JiraStatusCategoryColor).Green]: 'success',
    [(0, $kc79t.JiraStatusCategoryColor).Yellow]: 'warning',
    [(0, $kc79t.JiraStatusCategoryColor).BlueGray]: 'information',
    [(0, $kc79t.JiraStatusCategoryColor).MediumGray]: 'neutral'
};
const $6a5caf72f25c94c4$var$STATUS_REGEX = /[\s-]+/g;
/**
 * Remove when visual refresh flag is removed
 */ const $6a5caf72f25c94c4$var$getAppearance = (name)=>{
    name = name.replace($6a5caf72f25c94c4$var$STATUS_REGEX, '').toLowerCase();
    switch(true){
        case [
            'todo',
            'unavailable',
            'minor',
            'notstarted'
        ].includes(name):
            return 'neutral';
        case [
            'available',
            'completed',
            'done',
            'approved',
            'resolved',
            'added',
            'closed'
        ].includes(name):
            return 'success';
        case [
            'error',
            'declined',
            'deleted',
            'failed',
            'rejected'
        ].includes(name):
            return 'danger';
        case [
            'inprogress',
            'open',
            'modified'
        ].includes(name):
            return 'information';
    }
    return 'neutral';
};
const $6a5caf72f25c94c4$export$b70265791d2079d4 = (name, statusInfo, isLoading)=>{
    if (name) {
        if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1hlFx.MetaDataItemSkeleton), null);
        let appearance;
        if (statusInfo?.statusCategoryId) appearance = (0, $a22683c399072c80$export$d9e35f42afe1e488)[statusInfo.statusCategoryId];
        else if (statusInfo?.color) appearance = $6a5caf72f25c94c4$var$jiraIssueStatusToLozengeMap[statusInfo.color];
        if (appearance) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
            isBold: true,
            appearance: appearance,
            testId: "jira-status-lozenge-test-id"
        }, name);
        const fallbackAppearance = $6a5caf72f25c94c4$var$getAppearance(name);
        if (fallbackAppearance) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
            appearance: fallbackAppearance,
            testId: "jira-status-lozenge-test-id"
        }, name);
    }
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1hlFx.MetaDataItemSkeleton), null);
    return null;
};
module.exports["getStatus"] = $6a5caf72f25c94c4$export$b70265791d2079d4;

});

parcelRegister("kc79t", function(module, exports) {
const $a91146fce116fa8b$export$539cfae207f2a8d6 = {
    MediumGray: 'MEDIUM_GRAY',
    Green: 'GREEN',
    Yellow: 'YELLOW',
    Brown: 'BROWN',
    Red: 'WARM_RED',
    BlueGray: 'BLUE_GRAY'
};
module.exports["JiraStatusCategoryColor"] = $a91146fce116fa8b$export$539cfae207f2a8d6;

});

parcelRegister("1hlFx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $6F6hl = parcelRequire("6F6hl");


var $9WEcF = parcelRequire("9WEcF");

const $d0f7782f05ea6f67$var$messages = (0, $aXWIB.defineMessages)({
    loadingResult: {
        id: "search_result_skeleton_loading_result",
        defaultMessage: "Loading result"
    }
});
const $d0f7782f05ea6f67$var$commonStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.accent.gray.subtlest'
});
const $d0f7782f05ea6f67$var$skeletonTextStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.full'
});
const $d0f7782f05ea6f67$var$titleStyles = (0, $ecnYn.xcss)({
    width: '280px',
    height: "var(--ds-space-200, 16px)",
    marginBottom: 'space.050'
});
const $d0f7782f05ea6f67$var$iconStyles = (0, $ecnYn.xcss)({
    width: 'size.400',
    height: 'size.400',
    borderRadius: 'radius.small'
});
const $d0f7782f05ea6f67$var$containerStyles = (0, $ecnYn.xcss)({
    pointerEvents: 'none'
});
const $d0f7782f05ea6f67$var$descriptionContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    rowGap: 'space.100'
});
const $d0f7782f05ea6f67$var$descriptionStyles = (0, $ecnYn.xcss)({
    width: '100%',
    height: "var(--ds-space-150, 12px)"
});
const $d0f7782f05ea6f67$var$metadataStyles = (0, $ecnYn.xcss)({
    width: '200px',
    height: "var(--ds-space-150, 12px)",
    marginBottom: 'space.050'
});
const $d0f7782f05ea6f67$var$metadataItemStyles = (0, $ecnYn.xcss)({
    height: "var(--ds-space-150, 12px)",
    borderRadius: 'radius.large'
});
const $d0f7782f05ea6f67$var$narrowMetadataItemStyles = (0, $ecnYn.xcss)({
    width: '50px'
});
const $d0f7782f05ea6f67$var$wideMetadataItemStyles = (0, $ecnYn.xcss)({
    width: '100px'
});
const $d0f7782f05ea6f67$export$9ecbe061c4358be9 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        testId: "metadata-item-skeleton",
        xcss: [
            $d0f7782f05ea6f67$var$commonStyles,
            $d0f7782f05ea6f67$var$metadataItemStyles,
            $d0f7782f05ea6f67$var$narrowMetadataItemStyles
        ]
    });
};
const $d0f7782f05ea6f67$export$a72c2188d2b05fba = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        testId: "metadata-item-skeleton-wide",
        xcss: [
            $d0f7782f05ea6f67$var$commonStyles,
            $d0f7782f05ea6f67$var$metadataItemStyles,
            $d0f7782f05ea6f67$var$wideMetadataItemStyles
        ]
    });
};
const $d0f7782f05ea6f67$export$dd3282b157ef6f7a = ()=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $d0f7782f05ea6f67$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9WEcF.SearchResult), {
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                $d0f7782f05ea6f67$var$descriptionContainerStyles
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                $d0f7782f05ea6f67$var$commonStyles,
                $d0f7782f05ea6f67$var$skeletonTextStyles,
                $d0f7782f05ea6f67$var$descriptionStyles
            ]
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                $d0f7782f05ea6f67$var$commonStyles,
                $d0f7782f05ea6f67$var$skeletonTextStyles,
                $d0f7782f05ea6f67$var$descriptionStyles
            ]
        })),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                $d0f7782f05ea6f67$var$commonStyles,
                $d0f7782f05ea6f67$var$iconStyles
            ]
        }),
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), null, formatMessage($d0f7782f05ea6f67$var$messages.loadingResult)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                $d0f7782f05ea6f67$var$commonStyles,
                $d0f7782f05ea6f67$var$skeletonTextStyles,
                $d0f7782f05ea6f67$var$titleStyles
            ]
        })),
        headerMetadataParts: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: [
                    $d0f7782f05ea6f67$var$commonStyles,
                    $d0f7782f05ea6f67$var$skeletonTextStyles,
                    $d0f7782f05ea6f67$var$metadataStyles
                ]
            })
        ],
        // TODO: QS-7036 consolidate the logic of the loading state as it's now split between
        //  this component and the SearchResult component (hence the prop)
        isLoadingSkeleton: true
    }));
};
module.exports["MetaDataItemSkeleton"] = $d0f7782f05ea6f67$export$9ecbe061c4358be9;
module.exports["MetaDataItemSkeletonWide"] = $d0f7782f05ea6f67$export$a72c2188d2b05fba;
module.exports["SearchResultSkeleton"] = $d0f7782f05ea6f67$export$dd3282b157ef6f7a;

});

parcelRegister("9WEcF", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $9Q2dU = parcelRequire("9Q2dU");


var $dh538 = parcelRequire("dh538");


var $6f0Oj = parcelRequire("6f0Oj");

var $cwkWT = parcelRequire("cwkWT");

var $ecnYn = parcelRequire("ecnYn");


var $3gadb = parcelRequire("3gadb");


var $2OtFZ = parcelRequire("2OtFZ");


var $46mBC = parcelRequire("46mBC");


var $7WbA8 = parcelRequire("7WbA8");








var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");


var $cOQz3 = parcelRequire("cOQz3");


var $9VJDA = parcelRequire("9VJDA");


var $gdv5Z = parcelRequire("gdv5Z");


var $i25hX = parcelRequire("i25hX");




const $dec63c756dcbc0c4$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    copyLinkLabel: {
        id: "copy-content-link-label",
        defaultMessage: "Copy link"
    },
    aiSummaryLabel: {
        id: "ai-summary-label",
        defaultMessage: "Summarize"
    },
    moreActionsLabel: {
        id: "more-actions-label",
        defaultMessage: "More Actions"
    },
    summarizeInChatLabel: {
        id: "summarize-in-chat-label",
        defaultMessage: "Summarize"
    }
});


const $b6487e77d6f03314$var$SUMMARIZE_IN_CHAT_CONTAINER_WIDTH_BREAKPOINT = 700;
const $b6487e77d6f03314$var$SearchResultContextMenu = ({ url: url, hideSummarizeInChat: hideSummarizeInChat = false, isContextMenuOpen: isContextMenuOpen, containerWidth: containerWidth, setIsContextMenuOpen: setIsContextMenuOpen, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const publish = (0, $i25hX.usePublish)('ai-mate');
    const divRef = (0, $42omo.useRef)(null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
        trigger: ({ triggerRef: triggerRef, onClick: onClick, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                ...props,
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                label: formatMessage((0, $dec63c756dcbc0c4$export$defe85febe8b728c).moreActionsLabel),
                isTooltipDisabled: false,
                spacing: "compact",
                ref: triggerRef,
                onClick: (e)=>{
                    onClick?.(e);
                    onContextMenuButtonClicked?.();
                }
            }),
        placement: "right-start",
        testId: "search-result-context-menu",
        onOpenChange: ()=>setIsContextMenuOpen(!isContextMenuOpen),
        isOpen: isContextMenuOpen,
        returnFocusRef: divRef,
        zIndex: 2
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), {
        testId: "search-result-context-menu-dropdown"
    }, containerWidth < $b6487e77d6f03314$var$SUMMARIZE_IN_CHAT_CONTAINER_WIDTH_BREAKPOINT && !hideSummarizeInChat && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        onMouseDown: ()=>{
            setIsContextMenuOpen(false);
            onSummarizeInChatButtonClicked?.();
            if (!url) return;
            publish({
                type: 'browser-context-payload',
                source: 'search-result',
                data: {
                    context: {
                        browserUrl: url
                    }
                }
            });
            publish({
                type: 'chat-new',
                source: 'search-result',
                data: {
                    dialogues: [],
                    prompt: `Summarize ${url}`,
                    name: `Summarize ${url}`
                }
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cOQz3))), {
            color: "currentColor",
            label: "summarize-in-chat-button",
            spacing: "spacious"
        }),
        testId: "context-menu-summarize-in-chat-button"
    }, formatMessage((0, $dec63c756dcbc0c4$export$defe85febe8b728c).summarizeInChatLabel)))));
};
var $b6487e77d6f03314$export$2e2bcd8739ae039 = $b6487e77d6f03314$var$SearchResultContextMenu;



var $a7nUd = parcelRequire("a7nUd");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 





var $bUlM5 = parcelRequire("bUlM5");



var $dcJ7R = parcelRequire("dcJ7R");




var $9vOy1 = parcelRequire("9vOy1");


var $1VHLw = parcelRequire("1VHLw");





var $fm8DG = parcelRequire("fm8DG");


var $jAenQ = parcelRequire("jAenQ");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $ccHMk = parcelRequire("ccHMk");










var $fVUfS = parcelRequire("fVUfS");







const $191c632f5b8a9958$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    summarizeInChatButtonText: {
        id: "summarize-in-chat-button-text",
        defaultMessage: "Summarize"
    }
});


const $e573f3e1c068bc84$var$styles = {
    gradientBorderWrapper: "_2rko12b0 _ca0qt94y _u5f3t94y _n3tdt94y _19bvt94y _1e0c116y _1itkw4kx",
    customSummarizeButton: "_zulp1b66 _2rko12b0 _11c8fhey _1rjcv77o _18zrutpp _1dqoglyw _1e0c116y _4cvr1h6o _4t3iqslr _bfhkvuon _syazazsu _k48p1wq8 _o5721q9c _80omtlke _1ygbdfik _1ah3v77o _irr319i6 _1di613ro"
};
const $e573f3e1c068bc84$export$82e212324eddea91 = ({ url: url, ari: ari, testId: testId, onClick: onClick, showGradientBorder: showGradientBorder = false, spacing: spacing = 'compact' })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const publish = (0, $i25hX.usePublish)('ai-mate');
    const promptRovoChat = (e)=>{
        onClick?.();
        e.stopPropagation();
        if (!url) return;
        publish({
            type: 'browser-context-payload',
            source: 'search-result',
            data: {
                context: {
                    browserUrl: url
                }
            }
        });
        publish({
            type: 'chat-new',
            source: 'search-result',
            data: {
                dialogues: [],
                prompt: `Summarize ${url}`,
                name: `Summarize ${url}`,
                ...ari && (0, $dh538.fg)('read_fe_search_artifact_context') ? {
                    searchArtifact: {
                        url: url,
                        ari: ari
                    }
                } : {}
            }
        });
    };
    if (showGradientBorder) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        xcss: $e573f3e1c068bc84$var$styles.gradientBorderWrapper,
        testId: "summarize-in-chat-gradient-border"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        xcss: $e573f3e1c068bc84$var$styles.customSummarizeButton,
        onClick: promptRovoChat,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cOQz3))), {
        label: ""
    }), formatMessage((0, $191c632f5b8a9958$export$a7357cdd1f0b0168).summarizeInChatButtonText)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($cOQz3))),
        spacing: spacing,
        onClick: promptRovoChat,
        testId: testId
    }, formatMessage((0, $191c632f5b8a9958$export$a7357cdd1f0b0168).summarizeInChatButtonText));
};



var $kqMUN = parcelRequire("kqMUN");


var $976IZ = parcelRequire("976IZ");

const $ab9ed5f36da1b106$var$summarizeButtonRevampTreatment = (0, $2OtFZ.serveFullpageSearchSummarizeButtonRevamp)({
    fireExperimentExposure: false
});
const $ab9ed5f36da1b106$var$isRevampTreatment = $ab9ed5f36da1b106$var$summarizeButtonRevampTreatment !== 'control';
const $ab9ed5f36da1b106$var$isBorderTreatment = $ab9ed5f36da1b106$var$summarizeButtonRevampTreatment === 'border';
const $ab9ed5f36da1b106$var$headingAreaStyles = (0, $ecnYn.xcss)({
    gridArea: 'heading',
    font: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    minWidth: '476px'
});
const $ab9ed5f36da1b106$var$headingAreaRevampStyles = (0, $ecnYn.xcss)({
    gridArea: 'heading',
    font: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    minWidth: '0px'
});
const $ab9ed5f36da1b106$var$titleStyles = (0, $ecnYn.xcss)({
    display: 'inline-flex',
    overflow: 'hidden'
});
const $ab9ed5f36da1b106$var$titleTextStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    font: 'inherit'
});
const $ab9ed5f36da1b106$var$titleTextLinkStyles = (0, $ecnYn.xcss)({
    color: 'color.link',
    ':hover': {
        color: 'color.link'
    }
});
const $ab9ed5f36da1b106$var$visitedLinkStyles = (0, $ecnYn.xcss)({
    textDecoration: 'none',
    ':visited:active': {
        color: 'color.link.visited.pressed'
    },
    ':visited': {
        color: 'color.link.visited'
    }
});
const $ab9ed5f36da1b106$var$visitedLinkPatchStyles = (0, $ecnYn.xcss)({
    color: 'color.link.visited',
    ':active': {
        color: 'color.link.visited.pressed'
    }
});
const $ab9ed5f36da1b106$var$titleMetadataStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    gap: 'space.100',
    alignItems: 'center',
    justifyContent: 'end',
    height: "var(--ds-space-300, 24px)"
});
const $ab9ed5f36da1b106$export$9e8cf942b0ab74d9 = ({ id: id, title: title, url: url, isThirdParty: isThirdParty = false, appMode: appMode, isHovered: isHovered, titleMetadata: titleMetadata, showSummarizeInChatButton: showSummarizeInChatButton = false, hasRelatedLinks: hasRelatedLinks, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked })=>{
    const isRovoMode = appMode === (0, $9vOy1.ApplicationModes).Rovo; /**
                                                         * A dynamic search_id query param and queryHash is appended to the document URL for 1P search results.
                                                         * As a result we are unable to use the browser's visited links history to determine if a link has been visited.
                                                         * This is workaround until we have a better solution.
                                                         */ 
    const visitedLinks = (0, $976IZ.getVisitedLinks)();
    const isVisitedLink = id ? (0, $kqMUN.isVisited)(visitedLinks, id) : false;
    const onClick = ({ isAuxClick: isAuxClick = false, isSummarizeClick: isSummarizeClick = false, hasRelatedLinks: hasRelatedLinks = false } = {})=>{
        // Mark the link as visited, but only for normal clicks
        if (id && !isSummarizeClick) (0, $976IZ.addVisitedLink)(id);
        onResultClicked?.({
            hasRelatedLinks: hasRelatedLinks,
            isAuxClick: isAuxClick,
            isSummarizeClick: isSummarizeClick
        });
    };
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ $42omo.createElement((0, $6f0Oj.default), {
        xcss: $ab9ed5f36da1b106$var$isRevampTreatment ? $ab9ed5f36da1b106$var$headingAreaRevampStyles : $ab9ed5f36da1b106$var$headingAreaStyles,
        onClick: ()=>onClick({
                hasRelatedLinks: hasRelatedLinks
            }),
        onContextMenu: onResultContextMenu,
        onAuxClick: (e)=>{
            if ((0, $1VHLw.isAuxClick)(e)) return onClick({
                isAuxClick: true,
                hasRelatedLinks: hasRelatedLinks
            });
        }
    }, id && url ? /*#__PURE__*/ $42omo.createElement((0, $cwkWT.default), {
        templateColumns: "minmax(50%, 1fr) min-content",
        gap: "space.400"
    }, /*#__PURE__*/ $42omo.createElement((0, $bUlM5.default), {
        alignItems: "center",
        gap: "space.100"
    }, /*#__PURE__*/ $42omo.createElement((0, $jAenQ.Link), {
        xcss: [
            $ab9ed5f36da1b106$var$visitedLinkStyles,
            isVisitedLink && $ab9ed5f36da1b106$var$visitedLinkPatchStyles,
            $ab9ed5f36da1b106$var$titleStyles
        ],
        rel: isThirdParty ? 'noreferrer' : '',
        target: isThirdParty ? '_blank' : undefined,
        href: url,
        testId: "search-page-result-link"
    }, /*#__PURE__*/ $42omo.createElement((0, $6f0Oj.default), {
        xcss: [
            $ab9ed5f36da1b106$var$titleTextStyles,
            $ab9ed5f36da1b106$var$titleTextLinkStyles,
            isVisitedLink && $ab9ed5f36da1b106$var$visitedLinkPatchStyles
        ],
        as: "h2"
    }, title)), isHovered && isRovoMode && /*#__PURE__*/ $42omo.createElement((0, $dcJ7R.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ $42omo.createElement((0, $fm8DG.CopyLinkButton), {
        showSuccess: true,
        testId: id,
        fullResultUrl: url,
        onClick: onCopyLinkButtonClicked
    }), showSummarizeInChatButton && /*#__PURE__*/ $42omo.createElement((0, $e573f3e1c068bc84$export$82e212324eddea91), {
        ari: id,
        url: url,
        showGradientBorder: $ab9ed5f36da1b106$var$isBorderTreatment,
        onClick: ()=>{
            onSummarizeInChatButtonClicked?.();
            onClick({
                isSummarizeClick: true
            });
        },
        testId: 'search-result-summarize-in-chat'
    }))), titleMetadata && /*#__PURE__*/ $42omo.createElement((0, $6f0Oj.default), {
        xcss: $ab9ed5f36da1b106$var$titleMetadataStyles
    }, titleMetadata)) : /*#__PURE__*/ $42omo.createElement((0, $6f0Oj.default), {
        xcss: $ab9ed5f36da1b106$var$titleStyles
    }, /*#__PURE__*/ $42omo.createElement((0, $6f0Oj.default), {
        xcss: $ab9ed5f36da1b106$var$titleTextStyles,
        as: "h2"
    }, title))));
};





const $35a6830d0984657f$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    lastActive: {
        id: "search-page.results.product-results.third-party.last-active",
        defaultMessage: "Last active {relativeDate}"
    },
    threadTypeLabel: {
        id: "search-page.results.product-results.third-party.thread-type-label",
        defaultMessage: "Thread"
    },
    messageTypeLabel: {
        id: "search-page.results.product-results.third-party.message-type-label",
        defaultMessage: "Message"
    },
    channelTypeLabel: {
        id: "search-page.results.product-results.third-party.channel-type-label",
        defaultMessage: "Channel"
    },
    channelMemberCount: {
        id: "search-page.results.product-results.third-party.channel-member-count",
        defaultMessage: "{memberCount, plural, one {# member} other {# members}}"
    },
    privateConversationText: {
        id: "search-page.results.product-results.third-party.private-conversation-text",
        defaultMessage: "{users} in a private conversation"
    },
    noContributorsText: {
        id: "search-page.results.product-results.third-party.no-contributors-label",
        defaultMessage: "External people in #{channelName}"
    },
    externalPeopleText: {
        id: "search-page.results.product-results.third-party.external-people-label",
        defaultMessage: "External people"
    },
    externalPersonText: {
        id: "search-page.results.product-results.third-party.external-person-label",
        defaultMessage: "External person"
    },
    titleWithRemainingContributors: {
        id: "search-page.results.product-results.third-party.title-with-remaining-contributors",
        defaultMessage: "{title} and {remainingContributorsCount} {remainingContributorsCount, plural, one {other} other {others}}"
    },
    titleAndChannelName: {
        id: "search-page.results.product-results.third-party.title-and-channel-name",
        defaultMessage: "{title} in #{channelName}"
    },
    messageResultLockIconTooltip: {
        id: "search-page.results.product-results.third-party.message-search-result.message-result-lock-icon-tooltip",
        defaultMessage: "Restricted - Only specific people can see this result"
    },
    privateChannelLabel: {
        id: "search-result.private-channel-label",
        defaultMessage: "Private Channel"
    }
});


const $caeb18e39a927b2a$var$isRevampTreatment = (0, $2OtFZ.serveFullpageSearchSummarizeButtonRevamp)({
    fireExperimentExposure: false
}) !== 'control';
const $caeb18e39a927b2a$var$SUMMARIZE_IN_CHAT_CONTAINER_WIDTH_BREAKPOINT = 700;
const $caeb18e39a927b2a$var$searchResultContainerStyles = (0, $ecnYn.xcss)({
    position: 'relative'
});
const $caeb18e39a927b2a$var$iconAreaStyles = (0, $ecnYn.xcss)({
    gridArea: 'icon',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    width: "var(--ds-space-600, 48px)"
});
const $caeb18e39a927b2a$var$newIconStyles = (0, $ecnYn.xcss)({
    marginBlockStart: 'space.075'
});
const $caeb18e39a927b2a$var$headerRightAreaStylesInVisible = (0, $ecnYn.xcss)({
    opacity: 0
});
const $caeb18e39a927b2a$var$headerRightAreaStylesVisible = (0, $ecnYn.xcss)({
    opacity: 1
});
const $caeb18e39a927b2a$var$bodyAreaStyles = (0, $ecnYn.xcss)({
    gridArea: 'body',
    paddingTop: 'space.050',
    overflowWrap: 'break-word'
});
const $caeb18e39a927b2a$var$bodyAreaHiddenStyles = (0, $ecnYn.xcss)({
    display: 'none'
});
const $caeb18e39a927b2a$var$footerAreaStyles = (0, $ecnYn.xcss)({
    gridArea: 'footer'
});
const $caeb18e39a927b2a$var$lockIconStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginInlineEnd: 'space.075',
    paddingTop: 'space.025'
});
const $caeb18e39a927b2a$var$headerRightContainerStyles = (0, $ecnYn.xcss)({
    gridArea: 'header-right',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-end'
});
const $caeb18e39a927b2a$export$a2def421b23768aa = ({ id: id, product: product, productSelected: productSelected, primaryProduct: primaryProduct, primarySubProduct: primarySubProduct, description: description, footer: footer, icon: icon, url: url, hideSummarizeInChat: hideSummarizeInChat = false, role: role = 'listitem', cloudId: cloudId, title: // required for AI Summaries
title, isThirdParty: isThirdParty, appMode: appMode, headerMetadataParts: headerMetadataParts, headerMetadataSocialParts: headerMetadataSocialParts, titleMetadata: titleMetadata, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu, onCopyLinkButtonClicked: onCopyLinkButtonClicked, onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked, onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked, onContextMenuButtonClicked: onContextMenuButtonClicked, isLoadingSkeleton: isLoadingSkeleton = false, isLinkedResult: isLinkedResult = false, isPrivate: isPrivate, hasRelatedLinks: hasRelatedLinks = false, mainContentWidth: mainContentWidth })=>{
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $7WbA8.useAppContext)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const [isFocused, setIsFocused] = (0, $42omo.useState)(false);
    const [isContextMenuOpen, setIsContextMenuOpen] = (0, $42omo.useState)(false);
    const containerRef = (0, $42omo.useRef)(null);
    const isContextMenuVisible = !isLinkedResult && (isHovered || isFocused || isContextMenuOpen);
    const searchResultWidth = mainContentWidth || 0;
    const isRovoLLMCheckPassed = !(0, $dh538.fg)('kd_summarize_in_chat_rovo_llm_check') || isRovoLLMEnabled;
    const showSummarizeInChatByTitle = isRovoLLMCheckPassed && !hideSummarizeInChat && ($caeb18e39a927b2a$var$isRevampTreatment || searchResultWidth >= $caeb18e39a927b2a$var$SUMMARIZE_IN_CHAT_CONTAINER_WIDTH_BREAKPOINT);
    const [hasDescriptionContent, setHasDescriptionContent] = (0, $42omo.useState)(isLoadingSkeleton ? true : !!description);
    const descriptionRef = (0, $42omo.useCallback)((node)=>{
        // The loading skeleton intentionally renders a description made of empty
        // styled boxes (no text / media nodes). Skip the "is this empty?" heuristic
        // when rendering as a skeleton so the body row is preserved and the skeleton
        // keeps its full vertical height.
        if (isLoadingSkeleton) return;
        if (node) {
            const hasContent = (node.textContent?.trim().length ?? 0) > 0 || node.querySelector('img, svg, canvas, video') !== null;
            if (!hasContent) setHasDescriptionContent(false);
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- only re-check when description identity or skeleton mode changes
    [
        description,
        isLoadingSkeleton
    ]);
    const wrapCrossProductUrl = (0, $46mBC.useSearchCrossProductUrlWrapper)({
        bridge: 'searchPage',
        primaryProduct: primaryProduct,
        primarySubProduct: primarySubProduct
    });
    const wrappedUrl = wrapCrossProductUrl(url, product);
    return /*#__PURE__*/ $42omo.createElement((0, $6f0Oj.default), {
        role: role,
        onMouseEnter: ()=>{
            setIsHovered(true);
            if (isRovoLLMCheckPassed && !hideSummarizeInChat) (0, $2OtFZ.serveFullpageSearchSummarizeButtonRevamp)({
                fireExperimentExposure: true
            });
        },
        onMouseLeave: ()=>setIsHovered(false),
        onFocusCapture: ()=>setIsFocused(true),
        onBlurCapture: ()=>setIsFocused(false),
        testId: isLoadingSkeleton ? 'search-page-result-skeleton' : 'search-page-result',
        ref: containerRef,
        xcss: $caeb18e39a927b2a$var$searchResultContainerStyles
    }, /*#__PURE__*/ $42omo.createElement((0, $cwkWT.default), {
        columnGap: "space.150",
        rowGap: "space.050",
        templateAreas: [
            'icon heading header-right',
            'icon subheading-left header-right',
            ...hasDescriptionContent || isLoadingSkeleton ? [
                'icon body body'
            ] : [],
            ...footer ? [
                'icon footer footer'
            ] : []
        ],
        templateColumns: "auto 1fr auto"
    }, /*#__PURE__*/ $42omo.createElement((0, $6f0Oj.default), {
        xcss: $caeb18e39a927b2a$var$iconAreaStyles
    }, /*#__PURE__*/ $42omo.createElement((0, $6f0Oj.default), {
        xcss: $caeb18e39a927b2a$var$newIconStyles
    }, icon)), /*#__PURE__*/ $42omo.createElement((0, $ab9ed5f36da1b106$export$9e8cf942b0ab74d9), {
        id: id,
        title: title,
        url: wrappedUrl,
        isThirdParty: isThirdParty,
        appMode: appMode,
        onResultClicked: onResultClicked,
        onResultContextMenu: onResultContextMenu,
        onCopyLinkButtonClicked: onCopyLinkButtonClicked,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        isHovered: isHovered,
        titleMetadata: titleMetadata,
        showSummarizeInChatButton: showSummarizeInChatByTitle,
        hasRelatedLinks: hasRelatedLinks
    }), /*#__PURE__*/ $42omo.createElement((0, $a7nUd.SearchMetadata), {
        searchResultId: id,
        product: product,
        productSelected: productSelected,
        parts: headerMetadataParts,
        socialParts: headerMetadataSocialParts,
        containerRef: containerRef
    }), /*#__PURE__*/ $42omo.createElement((0, $6f0Oj.default), {
        xcss: $caeb18e39a927b2a$var$headerRightContainerStyles
    }, isPrivate && /*#__PURE__*/ $42omo.createElement((0, $6f0Oj.default), {
        xcss: $caeb18e39a927b2a$var$lockIconStyles
    }, /*#__PURE__*/ $42omo.createElement((0, $3gadb.default), {
        content: formatMessage((0, $35a6830d0984657f$export$defe85febe8b728c).messageResultLockIconTooltip)
    }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))), {
        label: formatMessage((0, $35a6830d0984657f$export$defe85febe8b728c).privateChannelLabel),
        color: "var(--ds-icon-accent-red, #C9372C)",
        size: "small"
    }))), !$caeb18e39a927b2a$var$isRevampTreatment && !isLoadingSkeleton && isRovoLLMCheckPassed && searchResultWidth <= $caeb18e39a927b2a$var$SUMMARIZE_IN_CHAT_CONTAINER_WIDTH_BREAKPOINT && !hideSummarizeInChat && // Context Menu should not be rendered when rendering as a loading skeleton
    /*#__PURE__*/ $42omo.createElement((0, $6f0Oj.default), {
        xcss: isContextMenuVisible ? $caeb18e39a927b2a$var$headerRightAreaStylesVisible : $caeb18e39a927b2a$var$headerRightAreaStylesInVisible,
        testId: "search-result-context-menu"
    }, /*#__PURE__*/ $42omo.createElement((0, $b6487e77d6f03314$export$2e2bcd8739ae039), {
        url: wrappedUrl,
        isContextMenuOpen: isContextMenuOpen,
        containerWidth: searchResultWidth,
        setIsContextMenuOpen: setIsContextMenuOpen,
        setIsFocused: setIsFocused,
        setIsHovered: setIsHovered,
        id: id || '',
        cloudId: cloudId,
        onSummarizeInChatButtonClicked: onSummarizeInChatButtonClicked,
        hideSummarizeInChat: hideSummarizeInChat,
        onContextMenuCopyButtonClicked: onContextMenuCopyButtonClicked,
        onContextMenuButtonClicked: onContextMenuButtonClicked
    }))), description && /*#__PURE__*/ $42omo.createElement((0, $6f0Oj.default), {
        ref: descriptionRef,
        xcss: [
            $caeb18e39a927b2a$var$bodyAreaStyles,
            !hasDescriptionContent && !isLoadingSkeleton && $caeb18e39a927b2a$var$bodyAreaHiddenStyles
        ]
    }, description), footer && /*#__PURE__*/ $42omo.createElement((0, $6f0Oj.default), {
        xcss: $caeb18e39a927b2a$var$footerAreaStyles
    }, footer)));
};
module.exports["SearchResult"] = $caeb18e39a927b2a$export$a2def421b23768aa;

});

parcelRegister("fm8DG", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1bY7o = parcelRequire("1bY7o");


var $3sFtD = parcelRequire("3sFtD");


var $2W0qg = parcelRequire("2W0qg");

var $ecnYn = parcelRequire("ecnYn");


var $3gadb = parcelRequire("3gadb");




const $7c784569f8558ead$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    copyLinkTooltipLabel: {
        id: "copy-link-tooltip-label",
        defaultMessage: "Copy link"
    },
    copiedLinkTooltipLabel: {
        id: "copied-link-tooltip-label",
        defaultMessage: "Copied!"
    },
    successIconLabel: {
        id: "copy-link-success-icon-label",
        defaultMessage: "Success icon"
    },
    copyLinkButtonLabel: {
        id: "copy-link-button-label",
        defaultMessage: "Copy Link"
    }
});


const $4850c225b0c92f37$var$TIMEOUT_DELAY = 2500;
const $4850c225b0c92f37$var$cursorDisabledStyles = (0, $ecnYn.xcss)({
    cursor: 'default',
    border: 'none'
});
const $4850c225b0c92f37$var$buttonStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.small',
    height: `${24 / 14}em`,
    width: `${24 / 14}em`,
    paddingInlineEnd: 'space.0',
    paddingInlineStart: 'space.0',
    ':hover': {
        background: "var(--ds-background-neutral, #0515240F)"
    },
    ':active': {
        background: "var(--ds-background-neutral-hovered, #0B120E24)"
    },
    ':disabled': {
        background: 'transparent'
    }
});
const $4850c225b0c92f37$var$borderStyles = (0, $ecnYn.xcss)({
    border: `1px solid ${"var(--ds-border, #0B120E24)"}`,
    borderRadius: 'radius.small',
    boxSizing: 'border-box',
    paddingInline: 'space.050',
    paddingBlock: 'space.050',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '24px',
    width: '24px'
});
const $4850c225b0c92f37$export$534d10f1c5b9c7b3 = ({ showSuccess: showSuccess, fullResultUrl: fullResultUrl, isButton: isButton, testId: testId, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [isCopied, setIsCopied] = (0, $42omo.useState)(false);
    const [tooltipLabel, setTooltipLabel] = (0, $42omo.useState)(formatMessage((0, $7c784569f8558ead$export$a7357cdd1f0b0168).copyLinkTooltipLabel));
    const updateTooltip = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useLayoutEffect(()=>{
        updateTooltip.current?.();
    }, [
        tooltipLabel
    ]);
    const copyToClipboard = async ()=>{
        // Call the onClick callback if it exists
        onClick?.();
        if (!fullResultUrl) return;
        await navigator.clipboard.writeText(typeof fullResultUrl === 'function' ? fullResultUrl() : fullResultUrl);
        if (showSuccess) {
            setIsCopied(true);
            setTooltipLabel(formatMessage((0, $7c784569f8558ead$export$a7357cdd1f0b0168).copiedLinkTooltipLabel));
            setTimeout(()=>{
                setIsCopied(false);
                setTooltipLabel(formatMessage((0, $7c784569f8558ead$export$a7357cdd1f0b0168).copyLinkTooltipLabel));
            }, $4850c225b0c92f37$var$TIMEOUT_DELAY);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: ({ update: update })=>{
            updateTooltip.current = update;
            return tooltipLabel;
        },
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        isDisabled: isCopied,
        onClick: copyToClipboard,
        testId: testId,
        "aria-label": formatMessage((0, $7c784569f8558ead$export$a7357cdd1f0b0168).copyLinkButtonLabel),
        backgroundColor: "color.background.neutral.subtle",
        xcss: [
            isButton ? $4850c225b0c92f37$var$buttonStyles : $4850c225b0c92f37$var$borderStyles,
            isCopied && $4850c225b0c92f37$var$cursorDisabledStyles
        ]
    }, isCopied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
        label: formatMessage((0, $7c784569f8558ead$export$a7357cdd1f0b0168).successIconLabel),
        color: "var(--ds-icon-accent-green, #22A06B)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)",
        "aria-hidden": "true"
    })));
};
module.exports["CopyLinkButton"] = $4850c225b0c92f37$export$534d10f1c5b9c7b3;

});

parcelRegister("kqMUN", function(module, exports) {
const $4f66da019ad71cb5$export$df30b8dffa0e57a6 = (visitedLinks, id)=>{
    return visitedLinks.has(id);
};
module.exports["isVisited"] = $4f66da019ad71cb5$export$df30b8dffa0e57a6;

});

parcelRegister("976IZ", function(module, exports) {

var $5G9KX = parcelRequire("5G9KX");


const $5de3908e70286a2a$var$SEARCH_PAGE_VISITED_KEY = 'atlassian.search-page.visited';
const $5de3908e70286a2a$export$5d8cdaf303406828 = (value)=>{
    (0, $5G9KX.setLocalStorageItem)($5de3908e70286a2a$var$SEARCH_PAGE_VISITED_KEY, JSON.stringify([
        ...$5de3908e70286a2a$export$ea4ff4efe040153f(),
        value
    ]));
};
const $5de3908e70286a2a$export$ea4ff4efe040153f = ()=>{
    const visitedLinksRaw = (0, $5G9KX.getLocalStorageItemAsString)($5de3908e70286a2a$var$SEARCH_PAGE_VISITED_KEY);
    return new Set(visitedLinksRaw ? JSON.parse(visitedLinksRaw) : []);
};
module.exports["addVisitedLink"] = $5de3908e70286a2a$export$5d8cdaf303406828;
module.exports["getVisitedLinks"] = $5de3908e70286a2a$export$ea4ff4efe040153f;

});

parcelRegister("cWRpe", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $esRft = parcelRequire("esRft");


var $brMqq = parcelRequire("brMqq");

const $b5c0067abfebc5a4$var$styles = {
    container: "_kqswh2mm _xpfz12b0 _1lck1bhr _ontxe4h9 _wh24nqa1 _jw4istnw _1if2idpf _1ffoidpf _1pww1crf _1lve1crf _nzgk1bhr",
    quickFind: "_1pww19bv _1lve19bv"
};
const $b5c0067abfebc5a4$export$ebd26aa8d8b5f39b = ({ src: src, isQuickFind: isQuickFind = false })=>{
    return /*#__PURE__*/ $42omo.createElement("span", {
        className: (0, $gMc0m.default)([
            $b5c0067abfebc5a4$var$styles.container,
            isQuickFind && $b5c0067abfebc5a4$var$styles.quickFind
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $esRft.default), {
        src: src
    }), /*#__PURE__*/ $42omo.createElement((0, $brMqq.TalentSearchResultIcon), null));
};
module.exports["TalentUserAvatar"] = $b5c0067abfebc5a4$export$ebd26aa8d8b5f39b;

});

parcelRegister("7loel", function(module, exports) {
/* TODO: Remove this when the backend stops sending dummy board URLs,
         as locationless boards will be handled by the backend and this check will no longer be needed.
 */ const $28d75649ec4ac5b0$export$45d5a01e88e241a6 = (url)=>Boolean(url?.endsWith('/browse/DummyJiraBoard'));
module.exports["isDummyBoardUrl"] = $28d75649ec4ac5b0$export$45d5a01e88e241a6;

});

parcelRegister("8njjC", function(module, exports) {
/**
 * The icon tile appearance to use when rendering a Mercury Risk search result,
 * derived from the risk's status key.
 *
 * Shared between the Quick Find product entity renderer and the Full Page Search
 * Mercury Risk result renderer so the mapping stays in sync across surfaces.
 */ const $86b0d511f7135bdb$export$5a6f14acbd6f72d1 = (statusKey)=>{
    switch(statusKey?.toLowerCase()){
        case 'accepted':
            return 'blue';
        case 'resolved':
            return 'green';
        default:
            return 'gray';
    }
};
module.exports["getRiskIconAppearance"] = $86b0d511f7135bdb$export$5a6f14acbd6f72d1;

});

parcelRegister("92zSJ", function(module, exports) {

var $bOpS4 = parcelRequire("bOpS4");

const $3b640916832a713a$var$getContentString = (adf, level = 0)=>{
    let aggregatedString = '';
    if (adf.content) adf.content.forEach((node)=>{
        if (node.type === 'text') aggregatedString += node.text;
        else if (node.content && level < 15) aggregatedString += ' ' + $3b640916832a713a$var$getContentString(node, ++level);
    });
    return aggregatedString;
};
const $3b640916832a713a$export$c40fed6f44bda628 = (description, query)=>{
    /**
   * This description can be either a complicated JSON which is actually an ADF (Atlassian Document Format) schema of the entire content of the jira issue.
   * or it could be a simple excerpt. This uncertainity is due to the progressive development of the BE feature and rolling it out.
   */ try {
        const adf = JSON.parse(description);
        const text = $3b640916832a713a$var$getContentString(adf);
        return (0, $bOpS4.truncateTextWithQuery)(text, query);
    } catch (e) {
        return description.length > (0, $bOpS4.MAX_CHARACTERS_IN_EXCERPT) ? description.substring(0, (0, $bOpS4.MAX_CHARACTERS_IN_EXCERPT)) + '...' : description.substring(0, (0, $bOpS4.MAX_CHARACTERS_IN_EXCERPT));
    }
};
module.exports["getSummarizedAdfContent"] = $3b640916832a713a$export$c40fed6f44bda628;

});

parcelRegister("bOpS4", function(module, exports) {
const $93d9d061d8a03301$var$MAX_WORDS = 20;
const $93d9d061d8a03301$export$6e2b3cea5902982b = 250;
const $93d9d061d8a03301$export$91c2cc655c44ef69 = (text, query)=>{
    if (!text) return '';
    const lowerCaseQuery = query.toLowerCase();
    const words = text.split(' ');
    const indexOfQuery = words.findIndex((value)=>lowerCaseQuery === value.toLowerCase());
    if (indexOfQuery > $93d9d061d8a03301$var$MAX_WORDS) return [
        '...'
    ].concat(words.slice(indexOfQuery - $93d9d061d8a03301$var$MAX_WORDS, indexOfQuery + $93d9d061d8a03301$var$MAX_WORDS)).concat('...').join(' ');
    return words.slice(0, 2 * $93d9d061d8a03301$var$MAX_WORDS).join(' ').substring(0, $93d9d061d8a03301$export$6e2b3cea5902982b) + (text.length > $93d9d061d8a03301$export$6e2b3cea5902982b ? '...' : '');
};
module.exports["MAX_CHARACTERS_IN_EXCERPT"] = $93d9d061d8a03301$export$6e2b3cea5902982b;
module.exports["truncateTextWithQuery"] = $93d9d061d8a03301$export$91c2cc655c44ef69;

});

parcelRegister("7yVTH", function(module, exports) {
/* eslint-disable @atlassian/tangerine/import/no-restricted-paths */ 
var $dh538 = parcelRequire("dh538");


var $chwej = parcelRequire("chwej");


var $idpYy = parcelRequire("idpYy");


var $5iakG = parcelRequire("5iakG");


var $b4tvS = parcelRequire("b4tvS");


var $2OtFZ = parcelRequire("2OtFZ");


var $2GQhu = parcelRequire("2GQhu");


var $5XpfZ = parcelRequire("5XpfZ");


var $22zVp = parcelRequire("22zVp");


var $gY9AU = parcelRequire("gY9AU");

const $389fa27b7e70fb9c$export$62c31c0f13603e08 = (jiraFilters, availableProducts)=>{
    const allAvailableJiraProductTypes = Object.keys((0, $gY9AU.JiraProductProjectFilterKey)).reduce((acc, productKey)=>{
        const jiraProductKey = productKey;
        if (!availableProducts || availableProducts.includes(jiraProductKey)) acc.push(...(0, $gY9AU.JiraProductProjectFilterKey)[jiraProductKey]);
        return acc;
    }, []);
    return {
        ...jiraFilters,
        projectFilter: {
            ...jiraFilters.projectFilter,
            projectTypes: allAvailableJiraProductTypes
        }
    };
};


/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $cUcZ5 = parcelRequire("cUcZ5");


var $lRrav = parcelRequire("lRrav");


// DJB2 hash function for JSON objects
function $8ec58c33150c42f9$var$hashJsonObjectDJB2(jsonObject) {
    // Convert the JSON object to a string
    const jsonString = JSON.stringify(jsonObject);
    // Initialize hash value
    let hash = 5381;
    // Iterate over each character in the string
    for(let i = 0; i < jsonString.length; i++){
        const char = jsonString.charCodeAt(i);
        hash = hash * 33 ^ char; // XOR and multiply by 33
    }
    // Ensure the hash is a positive 32-bit integer
    return (hash >>> 0).toString(16);
}
const $8ec58c33150c42f9$var$sessionIdsMap = new Map();
function $8ec58c33150c42f9$export$8b9832780ea0337b(variables) {
    if ($8ec58c33150c42f9$var$sessionIdsMap.size > 1000) $8ec58c33150c42f9$var$sessionIdsMap.clear();
    const { sessionId: sessionId, searchSessionId: searchSessionId, ...vars } = variables;
    const queryKey = $8ec58c33150c42f9$var$hashJsonObjectDJB2(vars);
    const existingSession = $8ec58c33150c42f9$var$sessionIdsMap.get(queryKey);
    if (existingSession) return existingSession;
    $8ec58c33150c42f9$var$sessionIdsMap.set(queryKey, [
        sessionId,
        searchSessionId
    ]);
    return [
        sessionId,
        searchSessionId
    ];
}
function $8ec58c33150c42f9$export$77a5fc99991cbb57() {
    $8ec58c33150c42f9$var$sessionIdsMap.clear();
}
const $8ec58c33150c42f9$export$966bb5e577b5d521 = (forceUpdate = false)=>{
    const sessionId = (0, $lRrav.SEARCH_SESSION_ID).value();
    if (!sessionId || forceUpdate) // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    (0, $lRrav.SEARCH_SESSION_ID).update((0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))());
};






var $hm6w9 = parcelRequire("hm6w9");


var $gkXKl = parcelRequire("gkXKl");


var $b4tDU = parcelRequire("b4tDU");

const $30a294c49652f998$export$f080ba31649d3794 = (selectedProducts)=>{
    const is3pGroupingEnabled = (0, $dh538.fg)('fps_3p_grouping_rollout_gate');
    if (is3pGroupingEnabled === false) return (0, $b4tDU.isAllProductSearch)(selectedProducts) ? 'boosted-and-smartlinks' : undefined;
    return 'enable-v2';
};
const $30a294c49652f998$export$8c6fefe9b6b2ccd8 = (props)=>{
    const experimentConfig = (0, $gkXKl.getExperimentConfig)({
        primaryProduct: props.primaryProduct,
        experimentLayers: props.experimentLayers,
        sideBySideExperiment: undefined,
        statsigLayer: undefined,
        onError: props.onError,
        getLayerValuesFn: props.getLayerValuesFn
    });
    const backendExperiment = (0, $hm6w9.getBackendExperiment)({
        experimentConfig: experimentConfig,
        entities: props.entities,
        productEdition: props.productEdition,
        isHello: props.isHello,
        productDataRegions: props.productDataRegions,
        experience: props.experienceLayer,
        tenantId: props.cloudId,
        isJiraIssueIndexed: props.isJiraIssueIndexed,
        thirdPartyFilters: props.thirdPartyFilters,
        backendExperimentOverrides: props.backendExperimentOverrides,
        getLayerValuesFn: props.getLayerValuesFn
    });
    const { experimentId: experimentId, shadowExperimentId: shadowExperimentId, experimentLayers: experimentLayers, matchingLayerExperimentsMetadata: matchingLayerExperimentsMetadata } = backendExperiment || {};
    const fanoutExperimentCohort = $30a294c49652f998$export$f080ba31649d3794(props.selectedProducts);
    return {
        experimentId: experimentId,
        experimentLayers: experimentLayers,
        matchingLayerExperimentsMetadata: (0, $dh538.fg)('search_experiment_layer_metadata') ? matchingLayerExperimentsMetadata : undefined,
        shadowExperimentId: shadowExperimentId,
        fanoutExperimentCohort: fanoutExperimentCohort,
        backendExperiment: backendExperiment
    };
};



var $8uOED = parcelRequire("8uOED");


var $74x1m = parcelRequire("74x1m");

const $46dd28b200fb61b5$export$8a04e6ddedd0bb29 = ({ queryParams: queryParams, cloudId: cloudId, availableProducts: availableProducts, allFilterExcludedProducts: allFilterExcludedProducts, thirdPartyConfigs: thirdPartyConfigs, currentUserId: currentUserId, jsmIncidentFilterIds: jsmIncidentFilterIds })=>{
    const { filters: filters, selectedProducts: selectedProducts, selectedDatasource: selectedDatasource } = (0, $74x1m.getSearchConfig)({
        cloudId: cloudId,
        queryParams: queryParams,
        thirdPartyConfigs: thirdPartyConfigs
    });
    const selectedFilters = (0, $8uOED.getSelectedFilters)({
        filters: filters,
        selectedProducts: selectedProducts,
        selectedDatasource: selectedDatasource,
        availableProducts: availableProducts,
        allFilterExcludedProducts: allFilterExcludedProducts,
        thirdPartyConfigs: thirdPartyConfigs,
        currentUserId: currentUserId,
        jsmIncidentFilterIds: jsmIncidentFilterIds
    });
    return {
        selectedProducts: selectedProducts,
        ...selectedFilters
    };
};


const $ee9a789ba0acc902$export$cd3c83311f418ff4 = ({ queryParams: queryParams })=>{
    if (!queryParams) return {
        searchQuery: '',
        originalQuery: undefined
    };
    const searchQuery = queryParams?.text ?? '';
    const originalQuery = queryParams?.originalQuery;
    return {
        searchQuery: searchQuery,
        originalQuery: originalQuery
    };
};


/* eslint-disable @atlassian/tangerine/import/no-restricted-paths */ /**
 * Utility for resolving the `__relay_internal__pv__*` provided variables
 * required by the search-results persisted query.
 *
 * Non-Relay callers (e.g. SSR preload helpers that POST persisted queries
 * directly to AGG) must include these variables in their request body to
 * satisfy the gateway's `Boolean!` NonNull declarations. Historically those
 * callers duplicated the keys as a static map, which silently drifts from
 * the live `.relayprovider` evaluations performed inside the Relay
 * environment.
 *
 * This module is the single source of truth for that resolution. It calls
 * each provider's `get()` at invocation time so feature-gate / experiment
 * results are picked up at runtime (including during SSR, on the
 * assumption that the underlying feature gates are SSR-evaluable). The
 * shape of the returned map is pinned to the generated query artifact by
 * `index.relay-provided-variables.test.ts`.
 *
 * SSR Safety: This function is synchronous, contains no React hooks, and
 * does not touch browser-only globals directly. Each provider's `get()`
 * implementation must uphold the same contract.
 */ 
var $5SuoG = parcelRequire("5SuoG");


var $aqtD4 = parcelRequire("aqtD4");


var $4PNBt = parcelRequire("4PNBt");


var $iLuVY = parcelRequire("iLuVY");

const $8a72a7af1eb7b223$export$722bffef5ff5d4b4 = ()=>({
        __relay_internal__pv__isassetsenabledrelayprovider: (0, $5SuoG.default).get(),
        __relay_internal__pv__iscustomerorgownersenabledrelayprovider: (0, $aqtD4.default).get(),
        __relay_internal__pv__isdealownersenabledrelayprovider: (0, $4PNBt.default).get(),
        __relay_internal__pv__isslacktopreactionenabledrelayprovider: (0, $iLuVY.default).get()
    });


const $dcbc1c19e076ebdf$export$b83d7680b0db727d = ({ backendExperimentOverrides: backendExperimentOverrides, cloudId: cloudId, experimentLayers: rawExperimentLayers, experience: experience, isJiraIssueIndexed: isJiraIssueIndexed, jsmIncidentFilterIds: jsmIncidentFilterIds, primaryProduct: primaryProduct, productDataRegions: productDataRegions, productEdition: productEdition, products: products, queryParams: queryParams, sessionId: rawSessionId, searchSessionId: rawSearchSessionId, thirdPartyConfigs: thirdPartyConfigs, user: user, onError: onError, getLayerValuesFn: getLayerValuesFn, expectResult: expectResult = true, isLiteMode: isLiteMode = false })=>{
    const { originalQuery: originalQuery, searchQuery: searchQuery } = (0, $ee9a789ba0acc902$export$cd3c83311f418ff4)({
        queryParams: queryParams
    });
    const searchableProducts = $dcbc1c19e076ebdf$var$getSearchableProducts(searchQuery, products);
    const { entities: entities, entitiesForResultsCountQuery: entitiesForResultsCountQuery, selectedFilters: selectedFilters, selectedProducts: selectedProducts, unselectedProductsThirdPartyFilters: unselectedProductsThirdPartyFilters } = (0, $46dd28b200fb61b5$export$8a04e6ddedd0bb29)({
        allFilterExcludedProducts: (0, $5iakG.ALL_FILTER_EXCLUDED_PRODUCTS),
        availableProducts: products,
        cloudId: cloudId,
        currentUserId: user?.id,
        jsmIncidentFilterIds: jsmIncidentFilterIds,
        queryParams: queryParams,
        thirdPartyConfigs: thirdPartyConfigs
    });
    const { assetsFilters: assetsFilters, commonFilters: commonFilters, compassFilters: compassFilters, confluenceFilters: confluenceFilters, jiraFilters: jiraFilters, mercuryFilters: mercuryFilters, sortFilters: sortFilters, talentFilters: talentFilters, thirdPartyFilters: thirdPartyFilters } = selectedFilters;
    const { experimentId: experimentId, experimentLayers: experimentLayers, matchingLayerExperimentsMetadata: matchingLayerExperimentsMetadata, shadowExperimentId: shadowExperimentId, fanoutExperimentCohort: fanoutExperimentCohort, backendExperiment: backendExperiment } = (0, $30a294c49652f998$export$8c6fefe9b6b2ccd8)({
        backendExperimentOverrides: backendExperimentOverrides,
        cloudId: cloudId,
        entities: entities,
        experimentLayers: rawExperimentLayers,
        experienceLayer: experience,
        isHello: (0, $5XpfZ.isHello)(cloudId),
        isJiraIssueIndexed: isJiraIssueIndexed,
        onError: onError,
        primaryProduct: primaryProduct,
        productDataRegions: productDataRegions,
        productEdition: productEdition,
        selectedProducts: products,
        thirdPartyFilters: selectedFilters.thirdPartyFilters,
        getLayerValuesFn: getLayerValuesFn
    });
    const requestHeaders = {
        [(0, $chwej.EDGE_REGION_HINT_HEADER)]: primaryProduct && productDataRegions ? (0, $chwej.getEdgeRegionHint)(primaryProduct, productDataRegions) : undefined
    };
    const sharedQueryVariables = {
        cloudIdARI: (0, $2GQhu.getCloudIdARI)(cloudId, primaryProduct),
        commonFilters: commonFilters,
        compassFilters: compassFilters,
        confluenceFilters: confluenceFilters,
        disableQueryReplacement: !!originalQuery,
        entities: entities,
        experience: experience,
        jiraFilters: jiraFilters,
        limit: $dcbc1c19e076ebdf$var$getLimit(entities),
        mercuryFilters: mercuryFilters,
        query: searchQuery,
        queryVersion: 1,
        searchSessionId: rawSearchSessionId,
        sessionId: rawSessionId,
        sort: sortFilters,
        sourceProduct: primaryProduct,
        tenantId: cloudId,
        thirdPartyFilters: thirdPartyFilters,
        ...(0, $dh538.fg)('assets_rovo_search_all') ? {
            assetsFilters: assetsFilters
        } : {},
        ...(0, $dh538.fg)('talent_global_search') ? {
            talentFilters: talentFilters
        } : {}
    };
    const searchResultsQueryVariables = {
        ...sharedQueryVariables,
        expectResult: expectResult,
        /**
		 * Highlighting is only useful for results
		 */ enableHighlighting: true,
        experimentId: /**
		 * Experimentation is only valid in results section. Note that experiments
		 * can differ based on selected entites/products, so if we include experiments
		 * in counts, the counts will change as filters change
		 */ experimentId,
        experimentLayers: experimentLayers?.map(({ name: name, layerId: layerId, shadowId: shadowId, definitions: definitions })=>({
                name: name,
                layerId: layerId,
                shadowId: shadowId,
                definitions: definitions
            })),
        ...matchingLayerExperimentsMetadata ? {
            matchingLayerExperimentsMetadata: matchingLayerExperimentsMetadata
        } : {},
        fanoutExperimentCohort: fanoutExperimentCohort,
        includeGithubCode: selectedProducts.length === 1 && (0, $b4tvS.GITHUB_PRODUCT_KEYS).includes(selectedProducts[0]) && (0, $dh538.fg)('rovo_github_code_search'),
        includeJiraLiteModeFields: isLiteMode && selectedProducts.some((product)=>(0, $22zVp.isJiraProduct)(product, true)),
        includeIconUrl: (0, $dh538.fg)('rovo_search_confluence_icons_fps'),
        includeNavBoostScore: (0, $dh538.fg)('kd_enable_nav_boost_score'),
        includePassionfruitAsk: (0, $dh538.fg)('platform_passionfruit_search_onboarding_enabled'),
        includeRisk: (0, $dh538.fg)('platform_mercury_risk_search_ui_enabled'),
        includePositions: (0, $dh538.fg)('talent_global_search'),
        includeThirdPartyId: (0, $2OtFZ.serve3PClickIngestionExperiment)(thirdPartyConfigs, {
            fireExperimentExposure: false
        }),
        includeReactionsAndCommentCount: (0, $dh538.fg)('rovo_fps_graph_like_comment_count'),
        shadowExperimentId: shadowExperimentId,
        thirdPartyFilters: thirdPartyFilters
    };
    const rightPanelQueryVariables = {
        ...sharedQueryVariables,
        expectResult: expectResult,
        /**
		 * Counts searches for approx all entities (see getSelectedFilters for edge cases)
		 */ entities: entitiesForResultsCountQuery,
        /**
		 * We need to search for all Jira product types to support counts in Jira/JSM/JPD correctly
		 */ jiraFilters: (0, $389fa27b7e70fb9c$export$62c31c0f13603e08)(jiraFilters, searchableProducts),
        limit: 0,
        sort: [],
        thirdPartyFilters: unselectedProductsThirdPartyFilters
    };
    /**
	 * Relay uses the entire variables objects as a cache key. For this reason,
	 * when making the same search request, we need to ensure we retrieve the
	 * same sessionId and searchSessionId. We do this by caching these ids
	 * and retrieving them using the variables object excluding the ids as a cache key.
	 */ const [searchResultsQuerySessionId, searchResultsQuerySearchSessionId] = (0, $8ec58c33150c42f9$export$8b9832780ea0337b)(searchResultsQueryVariables);
    searchResultsQueryVariables.sessionId = searchResultsQuerySessionId;
    searchResultsQueryVariables.searchSessionId = searchResultsQuerySearchSessionId;
    const [rightPanelQuerySessionId, rightPanelQuerySearchSessionId] = (0, $8ec58c33150c42f9$export$8b9832780ea0337b)(rightPanelQueryVariables);
    rightPanelQueryVariables.sessionId = rightPanelQuerySessionId;
    rightPanelQueryVariables.searchSessionId = rightPanelQuerySearchSessionId;
    const searchResultsQueryRelayProvidedVariables = (0, $8a72a7af1eb7b223$export$722bffef5ff5d4b4)();
    return {
        backendExperiment: backendExperiment,
        requestHeaders: requestHeaders,
        rightPanelQueryVariables: rightPanelQueryVariables,
        searchResultsQueryRelayProvidedVariables: searchResultsQueryRelayProvidedVariables,
        searchResultsQueryVariables: searchResultsQueryVariables
    };
};
const $dcbc1c19e076ebdf$var$getLimit = (entities)=>{
    return entities.length === (0, $idpYy.getDefaultEntityAti)().length ? (0, $idpYy.RESULT_LIMIT_FOR_MULTIPLE_PRODUCTS) : (0, $idpYy.RESULT_LIMIT_FOR_SINGLE_PRODUCT);
};
const $dcbc1c19e076ebdf$var$getSearchableProducts = (searchQuery, products)=>{
    const isEmptyQuery = !searchQuery || searchQuery.trim() === '';
    return products.filter((product)=>!isEmptyQuery || (0, $b4tvS.productsSupportingEmptyQuery).includes(product));
};
module.exports["generateSearchInputs"] = $dcbc1c19e076ebdf$export$b83d7680b0db727d;

});

parcelRegister("lRrav", function(module, exports) {

var $fXT59 = parcelRequire("fXT59");

const $c845c336f40b6e62$export$e9ddc0ee913bbcbd = (0, $fXT59.disposableValue)();
module.exports["SEARCH_SESSION_ID"] = $c845c336f40b6e62$export$e9ddc0ee913bbcbd;

});

parcelRegister("74x1m", function(module, exports) {

var $lIbf3 = parcelRequire("lIbf3");

/**
 * Lightweight filter data for query generation.
 * Constructs minimal filter objects without importing filter definition files,
 * avoiding transitive deps on smart-user-picker, @atlaskit/select, react-dom etc.
 *
 *
 */ 
var $78z3f = parcelRequire("78z3f");


var $b4tvS = parcelRequire("b4tvS");


var $b12s7 = parcelRequire("b12s7");


var $cxQs0 = parcelRequire("cxQs0");


var $6Ea6j = parcelRequire("6Ea6j");


var $cOUgi = parcelRequire("cOUgi");


var $ILLS9 = parcelRequire("ILLS9");


var $jreQ3 = parcelRequire("jreQ3");


var $cSPiD = parcelRequire("cSPiD");


var $5jwMp = parcelRequire("5jwMp");

// Helper product arrays
const $e92713e1ce621101$var$confluenceProducts = [
    (0, $b4tvS.ProductKeys).Confluence
];
const $e92713e1ce621101$var$jiraProducts = [
    (0, $b4tvS.ProductKeys).Jira,
    (0, $b4tvS.ProductKeys).JiraProductDiscovery,
    (0, $b4tvS.ProductKeys).JiraServiceManagement
];
const $e92713e1ce621101$var$assetsProducts = [
    (0, $b4tvS.ProductKeys).Assets
];
const $e92713e1ce621101$var$mercuryProducts = [
    (0, $b4tvS.ProductKeys).Focus
];
const $e92713e1ce621101$var$talentProducts = [
    (0, $b4tvS.ProductKeys).Talent
];
const $e92713e1ce621101$var$contributorProducts = (0, $b4tvS.all1pProductKeys).filter((key)=>key !== (0, $b4tvS.ProductKeys).Trello && key !== (0, $b4tvS.ProductKeys).Focus && key !== (0, $b4tvS.ProductKeys).Talent);
const $e92713e1ce621101$var$contributor3P = (0, $b4tvS.all3pProductKeys).filter((key)=>key !== (0, $78z3f.ProductKeys3P).Figma);
const $e92713e1ce621101$export$e8343e733de21ab3 = {
    lastUpdated: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'lastUpdated',
        products: [
            (0, $b4tvS.ProductKeys).Atlas,
            (0, $b4tvS.ProductKeys).Confluence,
            (0, $b4tvS.ProductKeys).Focus,
            (0, $b4tvS.ProductKeys).Jira,
            (0, $b4tvS.ProductKeys).JiraProductDiscovery,
            (0, $b4tvS.ProductKeys).JiraServiceManagement,
            (0, $b4tvS.ProductKeys).Compass,
            (0, $b4tvS.ProductKeys).Trello,
            (0, $b4tvS.ProductKeys).Bitbucket,
            ...(0, $b12s7.getProducts3PFromConfigForFilter)('lastUpdated')
        ],
        alwaysVisible: true,
        universal: true,
        queryParams: {
            key: 'lastModified',
            generateQueryParamsGetState: (0, $ILLS9.generateQueryParamsGetState)
        }
    }),
    contributor: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'contributor',
        products: [
            ...$e92713e1ce621101$var$contributorProducts,
            ...$e92713e1ce621101$var$contributor3P
        ],
        alwaysVisible: true,
        universal: true,
        queryParams: {
            key: 'contributors'
        }
    }),
    space: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'space',
        products: [
            ...$e92713e1ce621101$var$confluenceProducts,
            ...(0, $b12s7.getProducts3PFromConfigForFilter)('space')
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'spaces'
        }
    }),
    watchedByMe: (0, $cxQs0.createBooleanFilter)({
        id: 'watchedByMe',
        products: [
            (0, $b4tvS.ProductKeys).Jira,
            (0, $b4tvS.ProductKeys).JiraProductDiscovery,
            (0, $b4tvS.ProductKeys).JiraServiceManagement
        ],
        alwaysVisible: true,
        universal: false,
        queryParams: {
            key: 'jWatchedByMe'
        }
    }),
    verified: (0, $cxQs0.createBooleanFilter)({
        id: 'verified',
        products: [
            ...$e92713e1ce621101$var$confluenceProducts,
            ...(0, $b12s7.getProducts3PFromConfigForFilter)('verified')
        ],
        alwaysVisible: true,
        universal: false,
        queryParams: {
            key: 'verified'
        }
    }),
    assignee: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'assignee',
        products: [
            ...$e92713e1ce621101$var$jiraProducts,
            ...(0, $b12s7.getProducts3PFromConfigForFilter)('assignee')
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'jAssignee'
        }
    }),
    reporter: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'reporter',
        products: [
            ...$e92713e1ce621101$var$jiraProducts,
            ...(0, $b12s7.getProducts3PFromConfigForFilter)('reporter')
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'jReporter'
        }
    }),
    commentedByMe: (0, $cxQs0.createBooleanFilter)({
        id: 'commentedByMe',
        products: [
            (0, $b4tvS.ProductKeys).Jira,
            (0, $b4tvS.ProductKeys).JiraProductDiscovery,
            (0, $b4tvS.ProductKeys).JiraServiceManagement,
            ...(0, $b12s7.getProducts3PFromConfigForFilter)('commentedByMe')
        ],
        alwaysVisible: true,
        universal: false,
        queryParams: {
            key: 'jCommentedByMe'
        }
    }),
    project: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'project',
        products: [
            ...$e92713e1ce621101$var$jiraProducts,
            ...(0, $b12s7.getProducts3PFromConfigForFilter)('project')
        ],
        alwaysVisible: true,
        universal: false,
        queryParams: {
            key: 'jProject',
            generateQueryParamsGetState: (0, $5jwMp.generateQueryParamsGetState)
        }
    }),
    universalTypeFilter: (0, $cOUgi.createSingleSelectFilter)({
        id: 'universalTypeFilter',
        products: [
            ...(0, $b4tvS.all1pProductKeys),
            ...(0, $b4tvS.all3pProductKeys)
        ],
        alwaysVisible: true,
        universal: true,
        queryParams: {
            key: 'type'
        }
    }),
    content: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'content',
        products: [
            ...$e92713e1ce621101$var$confluenceProducts,
            ...(0, $b12s7.getProducts3PFromConfigForFilter)('content')
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'ancestor'
        }
    }),
    onlyTitleMatch: (0, $cxQs0.createBooleanFilter)({
        id: 'onlyTitleMatch',
        products: [
            ...$e92713e1ce621101$var$confluenceProducts,
            ...(0, $b12s7.getProducts3PFromConfigForFilter)('onlyTitleMatch')
        ],
        alwaysVisible: true,
        universal: false,
        queryParams: {
            key: 'titleMatch'
        }
    }),
    owner: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'owner',
        products: [
            (0, $b4tvS.ProductKeys).Confluence,
            (0, $b4tvS.ProductKeys).Focus,
            ...(0, $b12s7.getProducts3PFromConfigForFilter)('owner')
        ],
        alwaysVisible: true,
        universal: false,
        queryParams: {
            key: 'owners'
        }
    }),
    createdBy: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'createdBy',
        products: [
            ...(0, $b12s7.getProducts3PFromConfigForFilter)('createdBy')
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'createdBy'
        }
    }),
    label: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'label',
        products: [
            (0, $b4tvS.ProductKeys).Confluence,
            (0, $b4tvS.ProductKeys).Jira,
            (0, $b4tvS.ProductKeys).JiraProductDiscovery,
            (0, $b4tvS.ProductKeys).JiraServiceManagement
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'labels'
        }
    }),
    focusAreaType: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'focusAreaType',
        products: [
            ...$e92713e1ce621101$var$mercuryProducts
        ],
        alwaysVisible: true,
        universal: false,
        queryParams: {
            key: 'focusAreaTypes'
        }
    }),
    focusAreaUnder: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'focusAreaUnder',
        products: [
            ...$e92713e1ce621101$var$mercuryProducts
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'focusAreaUnder'
        }
    }),
    pageStatus: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'pageStatus',
        products: [
            ...$e92713e1ce621101$var$confluenceProducts
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'pageStatus',
            generateQueryParamsGetState: (0, $jreQ3.generateQueryParamsGetState)
        }
    }),
    archived: (0, $cxQs0.createBooleanFilter)({
        id: 'archived',
        products: [
            ...$e92713e1ce621101$var$confluenceProducts,
            ...(0, $b12s7.getProducts3PFromConfigForFilter)('archived')
        ],
        alwaysVisible: true,
        universal: false,
        queryParams: {
            key: 'archived'
        }
    }),
    lastUpdatedBy: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'lastUpdatedBy',
        products: [
            (0, $b4tvS.ProductKeys).Salesforce,
            (0, $b4tvS.ProductKeys).Hubspot
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'lastUpdatedBy'
        }
    }),
    statusFilter: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'statusFilter',
        products: [
            (0, $b4tvS.ProductKeys).Jira,
            (0, $b4tvS.ProductKeys).JiraProductDiscovery,
            (0, $b4tvS.ProductKeys).JiraServiceManagement,
            ...(0, $b12s7.getProducts3PFromConfigForFilter)('statusFilter')
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'status'
        }
    }),
    compassArchived: (0, $cxQs0.createBooleanFilter)({
        id: 'compassArchived',
        products: [
            (0, $b4tvS.ProductKeys).Compass
        ],
        alwaysVisible: true,
        universal: false,
        queryParams: {
            key: 'compassArchived'
        }
    }),
    assetsSchema: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'assetsSchema',
        products: [
            ...$e92713e1ce621101$var$assetsProducts
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'assetsSchema'
        }
    }),
    assetsType: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'assetsType',
        products: [
            ...$e92713e1ce621101$var$assetsProducts
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'assetsType'
        }
    }),
    positionStatus: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'positionStatus',
        products: [
            ...$e92713e1ce621101$var$talentProducts
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'positionStatuses'
        }
    }),
    positionEmploymentType: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'positionEmploymentType',
        products: [
            ...$e92713e1ce621101$var$talentProducts
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'positionEmploymentTypes'
        }
    }),
    positionJobFamily: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'positionJobFamily',
        products: [
            ...$e92713e1ce621101$var$talentProducts
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'positionJobFamilies'
        }
    }),
    positionTeam: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'positionTeam',
        products: [
            ...$e92713e1ce621101$var$talentProducts
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'positionTeams',
            generateQueryParamsGetState: (0, $cSPiD.generateQueryParamsGetState)
        }
    }),
    positionFocusArea: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'positionFocusArea',
        products: [
            ...$e92713e1ce621101$var$talentProducts
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'positionFocusAreas'
        }
    }),
    opportunityStatus: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'opportunityStatus',
        products: [
            (0, $b4tvS.ProductKeys).Salesforce
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'opportunityStatus'
        }
    }),
    campaignStatus: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'campaignStatus',
        products: [
            (0, $b4tvS.ProductKeys).Salesforce
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'campaignStatuses'
        }
    }),
    caseStatus: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'caseStatus',
        products: [
            (0, $b4tvS.ProductKeys).Salesforce
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'caseStatuses'
        }
    }),
    sort: (0, $cOUgi.createSingleSelectFilter)({
        id: 'sort',
        products: [
            (0, $b4tvS.ProductKeys).Confluence,
            (0, $b4tvS.ProductKeys).Jira
        ],
        alwaysVisible: true,
        universal: false,
        queryParams: {
            key: 'sort'
        }
    }),
    salesforceStage: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'salesforceStage',
        products: [
            (0, $b4tvS.ProductKeys).Salesforce
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'salesforceStages'
        }
    }),
    closeDate: (0, $cOUgi.createSingleSelectFilter)({
        id: 'closeDate',
        products: [
            (0, $b4tvS.ProductKeys).Salesforce
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'closeDate'
        }
    }),
    pullRequestStatus: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'pullRequestStatus',
        products: [
            (0, $b4tvS.ProductKeys).Bitbucket,
            ...(0, $b12s7.getProducts3PFromConfigForFilter)('pullRequestStatus')
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'pullRequestStatus'
        }
    }),
    repository: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'repository',
        products: [
            ...(0, $b12s7.getProducts3PFromConfigForFilter)('repository')
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'repository'
        }
    }),
    slackChannel: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'slackChannel',
        products: (0, $b12s7.getProducts3PFromConfigForFilter)('slackChannel'),
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'slackChannels'
        }
    }),
    folder: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'folder',
        // TODO: Add Loom product when end-to-end is ready
        products: [],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'folders'
        }
    }),
    workspaceName: (0, $6Ea6j.createMultiSelectFilter)({
        id: 'workspaceName',
        products: (0, $b12s7.getProducts3PFromConfigForFilter)('workspaceName'),
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'workspaceName'
        }
    }),
    hasAttachment: (0, $cxQs0.createBooleanFilter)({
        id: 'hasAttachment',
        products: (0, $b12s7.getProducts3PFromConfigForFilter)('hasAttachment'),
        alwaysVisible: true,
        universal: false,
        queryParams: {
            key: 'hasAttachment'
        }
    })
};



var $6l1Qf = parcelRequire("6l1Qf");

const $6a365e752c0347e7$export$2e9655e8b4177582 = ({ cloudId: cloudId, queryParams: queryParams, thirdPartyConfigs: thirdPartyConfigs })=>{
    // Parse query params so they're typed more strongly
    const parsedQueryParams = (0, $lIbf3.parseQueryParams)(queryParams);
    const { lastModified_lt: _, lastModified_gt: __, ...parsedQueryParamsInUse } = parsedQueryParams;
    const queryParamsWithValuesAsStringArray = (0, $lIbf3.convertQueryParamsToStringArray)(parsedQueryParamsInUse, Object.keys(parsedQueryParams));
    // Get utilities for processing query params into filters
    const { getSelectedProducts: getSelectedProducts } = (0, $6l1Qf.FilterUtils)((0, $e92713e1ce621101$export$e8343e733de21ab3), {});
    // Get selected products from query params
    const selectedProducts = getSelectedProducts(queryParams);
    // Get minimal filters object containing selected values based on query params
    const filters = Object.fromEntries(Object.entries((0, $e92713e1ce621101$export$e8343e733de21ab3)).map(([filterId, filter])=>{
        return [
            filterId,
            filter.queryParams.getState(queryParamsWithValuesAsStringArray, cloudId)
        ];
    }));
    // Get selected datasource
    const selectedDatasource = (0, $lIbf3.getDatasourceFromId)(parsedQueryParams.datasource, selectedProducts[0], thirdPartyConfigs);
    return {
        cql: parsedQueryParams.cql,
        searchQuery: parsedQueryParams.text || '',
        originalQuery: parsedQueryParams.originalQuery,
        filters: filters,
        selectedProducts: selectedProducts,
        selectedDatasource: selectedDatasource
    };
};
module.exports["getSearchConfig"] = $6a365e752c0347e7$export$2e9655e8b4177582;

});

parcelRegister("gbTNF", function(module, exports) {
const $403fcd9fe22bce08$export$f09e972bbd9c2e = ({ cloudId: cloudId, primaryProduct: primaryProduct, activationId: activationId, locale: locale, orgId: orgId, query: query })=>{
    const product = primaryProduct || '';
    const siteId = primaryProduct === 'jira' ? `ari:cloud:jira-software::site/${cloudId}` : `ari:cloud:${product}::site/${cloudId}`;
    const workspaceId = activationId ? `ari:cloud:${product}:${cloudId}:workspace/${activationId}` : '';
    return {
        query: query,
        siteId: siteId,
        locale: locale,
        orgId: orgId ?? '',
        workspaceId: workspaceId,
        cloudId: cloudId,
        product: product
    };
};
module.exports["buildIntentDetectionVariables"] = $403fcd9fe22bce08$export$f09e972bbd9c2e;

});

parcelRegister("5w7WU", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $6yuru = parcelRequire("6yuru");


var $9EFEY = parcelRequire("9EFEY");


var $4Zqgi = parcelRequire("4Zqgi");


var $f7lNm = parcelRequire("f7lNm");







function $b48bc080623d26d3$export$7542d9981bb876f9(query) {
    const lowercaseQuery = query.toLowerCase();
    if (/^[a-z][a-z0-9_]+-\d+$/.test(lowercaseQuery) && (0, $dh538.fg)('kd_restrict_jira_issue_query_intent')) return {
        queryIntent: (0, $f7lNm.QueryIntent).JIRA_ISSUE,
        transformedQuery: query
    };
    if (/\w+-\d+/.test(lowercaseQuery) && !(0, $dh538.fg)('kd_restrict_jira_issue_query_intent')) return {
        queryIntent: (0, $f7lNm.QueryIntent).JIRA_ISSUE,
        transformedQuery: query
    };
    if (lowercaseQuery.endsWith(' agent') || lowercaseQuery.endsWith(' agents')) return {
        queryIntent: (0, $f7lNm.QueryIntent).AGENT,
        transformedQuery: query.replace(' agent', '').replace(' Agent', '')
    };
}





const $e8b8727e3edb8560$export$6c52de753cb858f8 = 'KnowledgeDiscoveryIntentDetectionQuery';
const $e8b8727e3edb8560$export$12788ba4bf4fbd92 = `
    ... on KnowledgeDiscoveryBookmarkIntent {
        __typename
        bookmark {
            id
            url
            title
            description
            keyPhrase
            bookmarkState
            lastModifierAccountId
            lastModifiedTimestamp
            parentAdminhubBookmarkId
        }
    }
`;
const $e8b8727e3edb8560$export$6f87cad788b6beba = `
	... on KnowledgeDiscoveryPersonIntent {
		__typename
		persons {
			accountId
			name
			email
			picture
			jobTitle
			department
			organization
			location
			zoneInfo
		}
	}
`;
const $e8b8727e3edb8560$export$5cc310960e46a388 = `
	... on KnowledgeDiscoveryNavContentIntent {
		__typename
		url
		title
		createdAt
	}
`;
const $e8b8727e3edb8560$export$8145deeb4e892b30 = ()=>`
	query KnowledgeDiscoveryIntentDetectionQuery(
		$siteId: String!
		$query: String!
		$locale: String!
		$orgId: String!
	) {
		knowledgeDiscovery {
			intentDetection(locale: $locale, orgId: $orgId, query: $query, siteId: $siteId) {
				... on KnowledgeDiscoveryIntentDetectionSuccess {
					__typename
					errors {
						errorType
						statusCode
					}
					detectionMetadata {
						cacheHit
						latencyMs
						method
						model
						timestamp
						entityMetadata {
							entityCount
							entityType
						}
					}
					intent {
						classification
						detectionType
						subTypes
						transformedQuery
						... on KnowledgeDiscoveryJiraIntent {
							__typename
						}
						... on KnowledgeDiscoveryKeywordOrAcronymIntent {
							__typename
						}
						... on KnowledgeDiscoveryNaturalLanguageIntent {
							__typename
						}
						... on KnowledgeDiscoveryNoneIntent {
							__typename
						}
						... on KnowledgeDiscoveryPersonIntent {
							__typename
						}
						... on KnowledgeDiscoveryTeamIntent {
							__typename
						}
						... on KnowledgeDiscoveryTopicIntent {
							__typename
						}
						... on KnowledgeDiscoveryNavigationalIntent {
							__typename
						}
						... on KnowledgeDiscoveryOrgChartIntent {
							__typename
						}
						${(0, $dh538.fg)('kd_enable_sain_hero_nav') ? $e8b8727e3edb8560$export$5cc310960e46a388 : ''}
						${(0, $dh538.fg)('kd_bookmark_query_intent') ? $e8b8727e3edb8560$export$12788ba4bf4fbd92 : ''}
						${(0, $dh538.fg)('kd_fe_persons_intent_detection_els') ? $e8b8727e3edb8560$export$6f87cad788b6beba : ''}
					}
				}
			}
		}
	}
`;


// Jira-family product keys that support NL→JQL (jira, jira-product-discovery, jira-servicedesk).
// Used to guard against over-triggering JIRA_NATURAL_LANGUAGE_QUERY on non-Jira surfaces.
const $8ad1f7056bd8c98a$var$JIRA_FAMILY_APP_IDS = new Set([
    'jira',
    'jira-product-discovery',
    'jira-servicedesk'
]);
const $8ad1f7056bd8c98a$export$c16051a8e758ff55 = async ({ query: query, siteId: siteId, locale: locale, metadata: metadata, cloudId: cloudId, orgId: orgId, workspaceId: workspaceId, product: product, selectedProduct: selectedProduct, setQueryIntent: setQueryIntent, setTransformedQuery: setTransformedQuery, setIntentData: setIntentData, setRequestId: setRequestId, setTraceId: setTraceId, onError: onError })=>{
    const handleError = (error)=>{
        setQueryIntent((0, $f7lNm.QueryIntent).NONE);
        setTransformedQuery('');
        onError?.(error);
        (0, $4Zqgi.logger).error({
            error: error,
            functionName: 'getQueryIntent: handleError'
        });
    };
    try {
        const frontendQueryIntent = (0, $b48bc080623d26d3$export$7542d9981bb876f9)(query);
        // Intent from the frontend has a higher priority than the BE
        // Add any experiment and gate exclusion logic in `getFrontendQueryIntent` to prevent messy conditionals in this function
        if (!!frontendQueryIntent) {
            setQueryIntent(frontendQueryIntent.queryIntent);
            setTransformedQuery(frontendQueryIntent.transformedQuery);
            return;
        }
        const aggResponse = await (0, $9EFEY.fetchAggResponse)({
            graphQuery: (0, $e8b8727e3edb8560$export$8145deeb4e892b30)(),
            variables: {
                query: query,
                siteId: siteId,
                locale: locale,
                orgId: orgId,
                ...metadata ? {
                    metadata: metadata
                } : {}
            },
            operationName: (0, $e8b8727e3edb8560$export$6c52de753cb858f8),
            // we're using the cache to make sure the number of calls remain the same
            // make sure the cache key format is different from the actual intent detection call
            cache: {
                ttl: 300000,
                key: `shadow-intent-detection-${query}`
            },
            headers: (0, $6yuru.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: cloudId,
                product: product
            })
        });
        // Trace / request IDs from the gateway HTTP response (for analytics and debugging).
        const gatewayTracingHeaders = aggResponse.gatewayTracingHeaders ?? {};
        const response = aggResponse?.data?.knowledgeDiscovery.intentDetection;
        if (!response || !aggResponse?.data || aggResponse?.errors && aggResponse?.errors.length > 0 || response?.errors && response?.errors.length > 0) {
            // errors show up at the top level or in the response
            let errorMessage = aggResponse?.errors?.[0]?.message;
            if (response?.errors && response?.errors.length > 0) errorMessage = response?.errors?.[0]?.message;
            const error = errorMessage ? new Error(errorMessage) : new Error('getQueryIntent error');
            handleError(error);
            return;
        }
        // Intent from the BE
        let queryIntent = response.intent?.classification;
        if (queryIntent === (0, $f7lNm.QueryIntent).VISUAL && !(0, $dh538.fg)('hybrid_orchestrator_enable_image_search')) queryIntent = (0, $f7lNm.QueryIntent).NATURAL_LANGUAGE_QUERY;
        if ((queryIntent === (0, $f7lNm.QueryIntent).JIRA_NATURAL_LANGUAGE_QUERY || queryIntent === (0, $f7lNm.QueryIntent).JIRA_NLQ_KEYWORD) && selectedProduct && !$8ad1f7056bd8c98a$var$JIRA_FAMILY_APP_IDS.has(selectedProduct) && (0, $dh538.fg)('kd_fix_sain_jira_nql_query_intent_overtriggering')) queryIntent = (0, $f7lNm.QueryIntent).NATURAL_LANGUAGE_QUERY;
        setQueryIntent(queryIntent);
        setTransformedQuery(response.intent?.transformedQuery);
        setIntentData?.(response.intent);
        setRequestId(gatewayTracingHeaders['atl-request-id'] ?? '');
        setTraceId?.(gatewayTracingHeaders['x-trace-id'] ?? '');
    } catch (error) {
        handleError(error);
    }
};
module.exports["getQueryIntent"] = $8ad1f7056bd8c98a$export$c16051a8e758ff55;

});

parcelRegister("3LDzU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $dPJCf = parcelRequire("dPJCf");

const $e1bacc011ec444be$export$b6ea13c37acfe578 = ()=>{
    const isTransition = (0, $dPJCf.useIsTransition)();
    // Immediate runtime guard for non-initial-load mode.
    const isTransitionRef = (0, $42omo.useRef)(isTransition);
    isTransitionRef.current = isTransition;
    // Sticky provider-local retirement flag for explicitly consumed preload data.
    const clearedRef = (0, $42omo.useRef)(false);
    return (0, $42omo.useMemo)(()=>({
            getPreloadedSearch: ({ cloudId: requestedCloudId })=>{
                // When rovo_search_preload_from_quick_find_using_async is on, we relax two
                // previously-strict guards so the preloaded payload can be reused to warm up
                // Quick Find:
                //   1. We no longer bail out during route transitions.
                //   2. We no longer prevent the payload from being returned after it has been
                //      explicitly consumed (the `clearedRef` flag). The consumer (search-page)
                //      is now responsible for clearing it at the right times.
                if (!(0, $6mKj3.expVal)('rovo_search_preload_from_quick_find_using_async', 'isEnabled', false) && isTransitionRef.current) return null;
                const preloadedSearch = window.__PRELOADED_SEARCH__;
                if (!preloadedSearch || preloadedSearch.cloudId !== requestedCloudId) return null;
                if (!(0, $6mKj3.expVal)('rovo_search_preload_from_quick_find_using_async', 'isEnabled', false) && clearedRef.current) return null;
                return preloadedSearch;
            },
            clearPreloadedSearch: ({ cloudId: requestedCloudId })=>{
                const preloadedSearch = window.__PRELOADED_SEARCH__;
                if (preloadedSearch?.cloudId === requestedCloudId) {
                    if ((0, $6mKj3.expVal)('rovo_search_preload_from_quick_find_using_async', 'isEnabled', false)) window.__PRELOADED_SEARCH__ = undefined;
                    clearedRef.current = true;
                }
            }
        }), []);
};
module.exports["usePreloadDataProvider"] = $e1bacc011ec444be$export$b6ea13c37acfe578;

});

parcelRegister("55aR8", function(module, exports) {
const $4bbc408b7ad2b7dd$export$5f3101fcfc6eab72 = (value)=>{
    return typeof value === 'boolean';
};
module.exports["jiraNINFpsNLQBooleanValidator"] = $4bbc408b7ad2b7dd$export$5f3101fcfc6eab72;

});

parcelRegister("1ks6T", function(module, exports) {

var $a5RR2 = parcelRequire("a5RR2");

const $599a9faff285cfe4$export$6750011b01164bda = ()=>{
    // old sharepoint product key is put here (kept for backwards compatibility), as the new one is in the config
    const oldThirdPartyTypes = {
        'ai-3p-connector:sharepoint-domain': `sharepoint`,
        'ai-3p-connector:google-workspace': `drive`
    };
    const thirdPartyTypes = {
        ...oldThirdPartyTypes,
        // add third party types for dual connectors
        'lite-connector-gdrive': `drive`,
        'smartlinks-connector-gdrive': `drive`,
        'smartlinks-connector-gdrive-rsl': `drive`,
        'smartlinks-connector-salesforce': `salesforce`,
        'smartlinks-connector-airtable': `airtable`,
        'smartlinks-connector-figma': `figma`,
        'smartlinks-connector-gitlab': `gitlab`,
        'smartlinks-connector-miro': `miro`,
        'smartlinks-connector-asana': `asana`,
        'smartlinks-connector-smartsheet': `smartsheet`,
        'smartlinks-connector-dropbox': `dropbox`,
        'smartlinks-connector-box': `box`,
        'smartlinks-connector-lucid': `lucid`,
        'smartlinks-connector-hubspot': `hubspot`,
        'smartlinks-connector-docusign': `docusign`,
        'smartlinks-connector-slack': `slack`,
        'smartlinks-connector-teams': `teams`,
        'smartlinks-connector-azure-devops': `azure-devops`,
        'smartlinks-connector-notion': `notion`,
        'smartlinks-connector-onedrive': `onedrive`,
        'smartlinks-connector-sharepoint': `sharepoint`
    };
    (0, $a5RR2.ThirdPartyConfigsSync).forEach((config)=>{
        if (config.resourceType) thirdPartyTypes[config.resourceType] = config.id;
    });
    return thirdPartyTypes;
};
module.exports["getThirdPartyTypes"] = $599a9faff285cfe4$export$6750011b01164bda;

});

parcelRegister("8l0cM", function(module, exports) {

var $jLeRZ = parcelRequire("jLeRZ");


var $b4tvS = parcelRequire("b4tvS");


var $9d9t8 = parcelRequire("9d9t8");

const $5db0f2e78f1b965f$export$1cbda5ccc2e23e06 = (0, $jLeRZ.z).union([
    (0, $jLeRZ.z).nativeEnum((0, $b4tvS.ProductKeys)),
    (0, $jLeRZ.z).string().refine((0, $9d9t8.isForgeConnectorProductKey), (val)=>({
            message: `${val} is not a valid product key`
        }))
]);
module.exports["productKeySchema"] = $5db0f2e78f1b965f$export$1cbda5ccc2e23e06;

});

parcelRegister("ibEDi", function(module, exports) {

var $jLeRZ = parcelRequire("jLeRZ");

const $793f2b8b65bcc568$export$7a844b7429919d2 = (0, $jLeRZ.z).nativeEnum({
    All: 'all'
});
module.exports["allContentTypeSchema"] = $793f2b8b65bcc568$export$7a844b7429919d2;

});

parcelRegister("e9G7T", function(module, exports) {

var $jLeRZ = parcelRequire("jLeRZ");

const $c499c41912d3ce5b$export$578ac6cc3cc5997a = (0, $jLeRZ.z).nativeEnum({
    WorkItem: 'work-item'
});
module.exports["asanaContentTypeSchema"] = $c499c41912d3ce5b$export$578ac6cc3cc5997a;

});

parcelRegister("jg4n8", function(module, exports) {

var $jLeRZ = parcelRequire("jLeRZ");

const $42d1cb8e16ae16eb$export$36d574e92bf2f0fc = (0, $jLeRZ.z).nativeEnum({
    AssetsObject: 'object',
    Schema: 'schema',
    Type: 'type'
});
module.exports["assetsContentTypeSchema"] = $42d1cb8e16ae16eb$export$36d574e92bf2f0fc;

});

parcelRegister("cRtk3", function(module, exports) {

var $jLeRZ = parcelRequire("jLeRZ");

const $2e9594c1e5ebd349$export$ddfc756f87e8324d = (0, $jLeRZ.z).nativeEnum({
    Goal: 'goal',
    Learning: 'learning',
    Project: 'project',
    Tag: 'tag'
});
module.exports["atlasContentTypeSchema"] = $2e9594c1e5ebd349$export$ddfc756f87e8324d;

});

parcelRegister("flB9e", function(module, exports) {

var $jLeRZ = parcelRequire("jLeRZ");

const $dffbb087911423d3$export$ffa5bf38ea9a76ee = (0, $jLeRZ.z).enum([
    'true',
    'false'
]).transform((x)=>x === 'true');
module.exports["booleanSchema"] = $dffbb087911423d3$export$ffa5bf38ea9a76ee;

});

parcelRegister("eXG0s", function(module, exports) {

var $jLeRZ = parcelRequire("jLeRZ");

const $1ccf9b93f7e8cc4a$export$236bfa8a18b6097 = (0, $jLeRZ.z).string().transform((x)=>x.split(','));
module.exports["commaSeparatedArraySchema"] = $1ccf9b93f7e8cc4a$export$236bfa8a18b6097;

});

parcelRegister("9zSTL", function(module, exports) {

var $jLeRZ = parcelRequire("jLeRZ");

const $5c405ca808d5d6ee$export$e3c670f5c4b4df75 = (0, $jLeRZ.z).nativeEnum({
    Component: 'component'
});
module.exports["compassContentTypeSchema"] = $5c405ca808d5d6ee$export$e3c670f5c4b4df75;

});

parcelRegister("jfGkT", function(module, exports) {

var $jLeRZ = parcelRequire("jLeRZ");

const $8539f26873b64bee$export$d872f0aa011c3a9d = (0, $jLeRZ.z).nativeEnum({
    Answer: 'answer',
    Attachment: 'attachment',
    Blogpost: 'blogpost',
    Calendar: 'calendar',
    Comment: 'comment',
    Database: 'database',
    Document: 'document',
    Embed: 'embed',
    Folder: 'folder',
    Gliffy: 'gliffy',
    Page: 'page',
    Question: 'question',
    Space: 'space',
    SpaceCalendar: 'space-calendar',
    Whiteboard: 'whiteboard',
    Slide: 'slide'
});
module.exports["confluenceContentTypeSchema"] = $8539f26873b64bee$export$d872f0aa011c3a9d;

});

parcelRegister("dgPAd", function(module, exports) {

var $jLeRZ = parcelRequire("jLeRZ");

const $e83270b9b8d62051$export$374297d3e3f8ca0c = (0, $jLeRZ.z).nativeEnum({
    Dashboard: 'dashboard',
    DataTable: 'data-table'
});
module.exports["databricksContentTypeSchema"] = $e83270b9b8d62051$export$374297d3e3f8ca0c;

});

parcelRegister("afn43", function(module, exports) {

var $jLeRZ = parcelRequire("jLeRZ");

const $24afd219931dd9d1$export$dbec9fc36dbba98b = (0, $jLeRZ.z).nativeEnum({
    Document: 'document',
    Presentation: 'presentation',
    Spreadsheet: 'spreadsheet'
});
module.exports["dropboxContentTypeSchema"] = $24afd219931dd9d1$export$dbec9fc36dbba98b;

});

parcelRegister("2TmKt", function(module, exports) {

var $jLeRZ = parcelRequire("jLeRZ");

const $439a54dfc84089f2$export$f4b8db47840ea062 = (0, $jLeRZ.z).nativeEnum({
    Design: 'design'
});
module.exports["figmaContentTypeSchema"] = $439a54dfc84089f2$export$f4b8db47840ea062;

});

parcelRegister("967WU", function(module, exports) {

var $jLeRZ = parcelRequire("jLeRZ");

const $61a21e9ab8678d40$export$3d532d345dacbf34 = (0, $jLeRZ.z).nativeEnum({
    Repository: 'repository',
    PullRequest: 'pull-request',
    Commit: 'commit',
    Branch: 'branch',
    DevopsWorkItem: 'devops-work-item'
});
module.exports["githubContentTypeSchema"] = $61a21e9ab8678d40$export$3d532d345dacbf34;

});

parcelRegister("5Y8VG", function(module, exports) {

var $jLeRZ = parcelRequire("jLeRZ");

const $f9cba7c8d85b9705$export$340da7d4450f4487 = (0, $jLeRZ.z).nativeEnum({
    Document: 'document',
    Presentation: 'presentation',
    Spreadsheet: 'spreadsheet',
    Video: 'video',
    Image: 'image',
    Folder: 'folder',
    Audio: 'audio',
    Pdf: 'pdf',
    Code: 'code',
    Form: 'form',
    Notebook: 'notebook',
    WebPage: 'web-page',
    Other: 'other'
});
module.exports["googleContentTypeSchema"] = $f9cba7c8d85b9705$export$340da7d4450f4487;

});

parcelRegister("8E3qI", function(module, exports) {

var $jLeRZ = parcelRequire("jLeRZ");

const $9c17499beb5e97a9$export$f63d577c43feca48 = (0, $jLeRZ.z).nativeEnum({
    Deal: 'deal',
    CustomerOrg: 'customer-org'
});
module.exports["hubspotContentTypeSchema"] = $9c17499beb5e97a9$export$f63d577c43feca48;

});

parcelRegister("deFq6", function(module, exports) {

var $jLeRZ = parcelRequire("jLeRZ");

const $e8200df5dcda7e20$export$e31a67e5bb829f5c = (0, $jLeRZ.z).nativeEnum({
    Project: 'project',
    Incident: 'incident',
    Issue: 'issue',
    Filter: 'filter',
    Dashboard: 'dashboard',
    Board: 'board',
    Plan: 'plan',
    Epic: 'epic',
    Bug: 'bug',
    Story: 'story',
    Task: 'task',
    Subtask: 'subtask'
});
module.exports["jiraContentTypeSchema"] = $e8200df5dcda7e20$export$e31a67e5bb829f5c;

});

parcelRegister("er8dU", function(module, exports) {

var $jLeRZ = parcelRequire("jLeRZ");

const $004f2a9052539930$export$7c078c2ec2ab4e93 = (0, $jLeRZ.z).nativeEnum({
    Anytime: 'anytime',
    Today: 'today',
    Yesterday: 'yesterday',
    Past7Days: 'past7Days',
    Past30Days: 'past30Days',
    PastYear: 'pastYear',
    Custom: 'custom'
});
module.exports["lastModifiedValueSchema"] = $004f2a9052539930$export$7c078c2ec2ab4e93;

});

parcelRegister("f8qqB", function(module, exports) {

var $jLeRZ = parcelRequire("jLeRZ");

const $5c3b24010b15a536$export$915266ba4ee70164 = (0, $jLeRZ.z).nativeEnum({
    Video: 'video'
});
module.exports["loomContentTypeSchema"] = $5c3b24010b15a536$export$915266ba4ee70164;

});

parcelRegister("fDjwt", function(module, exports) {

var $jLeRZ = parcelRequire("jLeRZ");

const $082f9a1e7339c7ae$export$3f35493c0e1fe9ec = (0, $jLeRZ.z).nativeEnum({
    FocusArea: 'focus-area',
    Ask: 'ask',
    Organization: 'organization',
    Risk: 'risk'
});
module.exports["mercuryContentTypeSchema"] = $082f9a1e7339c7ae$export$3f35493c0e1fe9ec;

});

parcelRegister("djv4w", function(module, exports) {

var $jLeRZ = parcelRequire("jLeRZ");

const $d053ea00a2d62d39$export$2d13808294fd047f = (0, $jLeRZ.z).nativeEnum({
    Document: 'document',
    Presentation: 'presentation',
    Spreadsheet: 'spreadsheet',
    Image: 'image',
    Folder: 'folder',
    Video: 'video',
    Pdf: 'pdf',
    Shortcut: 'shortcut',
    Archive: 'archive',
    WebPage: 'web-page',
    Page: 'page',
    Blogpost: 'blogpost',
    Notebook: 'notebook',
    Other: 'other'
});
module.exports["microsoftContentTypeSchema"] = $d053ea00a2d62d39$export$2d13808294fd047f;

});

parcelRegister("7oQyb", function(module, exports) {

var $jLeRZ = parcelRequire("jLeRZ");


var $b4tvS = parcelRequire("b4tvS");

const $8e6d11105fae89b3$export$f3a53bd43617a593 = (0, $jLeRZ.z).nativeEnum((0, $b4tvS.ProductKeys)).enum;
module.exports["ProductKey"] = $8e6d11105fae89b3$export$f3a53bd43617a593;

});

parcelRegister("373KP", function(module, exports) {

var $jLeRZ = parcelRequire("jLeRZ");

const $6215e98bc667ea14$export$e7eef498de91d92 = (0, $jLeRZ.z).nativeEnum({
    Deal: 'deal',
    CustomerContact: 'customer-contact',
    CustomerOrg: 'customer-org',
    Campaign: 'campaign',
    Case: 'case'
});
module.exports["salesforceContentTypeSchema"] = $6215e98bc667ea14$export$e7eef498de91d92;

});

parcelRegister("kFuPh", function(module, exports) {

var $jLeRZ = parcelRequire("jLeRZ");

const $57913084a9b66b3b$export$2414dbe41633e9e4 = (0, $jLeRZ.z).nativeEnum({
    WorkItem: 'work-item',
    Document: 'document',
    Comment: 'comment',
    Incident: 'incident',
    Epic: 'epic',
    CatalogItem: 'catalog-item',
    RequestedItem: 'requested-item',
    Project: 'project',
    Demand: 'demand',
    KnowledgeArticle: 'knowledge-article',
    NewsArticle: 'news-article'
});
module.exports["servicenowContentTypeSchema"] = $57913084a9b66b3b$export$2414dbe41633e9e4;

});

parcelRegister("l9RY2", function(module, exports) {

var $jLeRZ = parcelRequire("jLeRZ");

const $8a2b503f553630fa$export$78ff7f7a3ef7dca8 = (0, $jLeRZ.z).nativeEnum({
    Message: 'message',
    Conversation: 'conversation'
});
module.exports["slackContentTypeSchema"] = $8a2b503f553630fa$export$78ff7f7a3ef7dca8;

});

parcelRegister("fB9ef", function(module, exports) {

var $jLeRZ = parcelRequire("jLeRZ");

const $87c398ca5f5138ed$export$ff8ed9d399173456 = (0, $jLeRZ.z).nativeEnum({
    Dashboard: 'dashboard',
    Invoice: 'invoice',
    Deal: 'deal'
});
module.exports["smartLinksContentTypeSchema"] = $87c398ca5f5138ed$export$ff8ed9d399173456;

});

parcelRegister("kM8s6", function(module, exports) {

var $jLeRZ = parcelRequire("jLeRZ");

const $d24e50ebca007c4a$export$c7be2dbb4ce58b0d = (0, $jLeRZ.z).nativeEnum({
    Relevance: 'relevance',
    UpdatedNewest: 'updatedNewest',
    UpdatedOldest: 'updatedOldest',
    CreatedNewest: 'createdNewest',
    CreatedOldest: 'createdOldest'
});
module.exports["sortSchema"] = $d24e50ebca007c4a$export$c7be2dbb4ce58b0d;

});

parcelRegister("anS4K", function(module, exports) {

var $jLeRZ = parcelRequire("jLeRZ");

const $bd760df9eddcc52c$export$78a2f7ec9c09bf3b = (0, $jLeRZ.z).nativeEnum({
    Position: 'position'
});
module.exports["talentContentTypeSchema"] = $bd760df9eddcc52c$export$78a2f7ec9c09bf3b;

});

parcelRegister("jcLLN", function(module, exports) {

var $jLeRZ = parcelRequire("jLeRZ");

const $5c2cc2ffd60ee75d$export$e362a3dbc1368cf2 = (0, $jLeRZ.z).nativeEnum({
    Message: 'message',
    Conversation: 'conversation',
    Video: 'video',
    Attachment: 'attachment'
});
module.exports["teamsContentTypeSchema"] = $5c2cc2ffd60ee75d$export$e362a3dbc1368cf2;

});

parcelRegister("dZ9iJ", function(module, exports) {

var $jLeRZ = parcelRequire("jLeRZ");

const $3358d9f0a0b83979$export$15f07c0375d70d62 = (0, $jLeRZ.z).nativeEnum({
    Board: 'board',
    Card: 'card'
});
module.exports["trelloContentTypeSchema"] = $3358d9f0a0b83979$export$15f07c0375d70d62;

});

parcelRegister("1UZgG", function(module, exports) {

var $jLeRZ = parcelRequire("jLeRZ");

const $600abdeefbdc7562$export$c30d3299c2899a1f = (0, $jLeRZ.z).nativeEnum({
    WebPage: 'web-page'
});
module.exports["webPageContentTypeSchema"] = $600abdeefbdc7562$export$c30d3299c2899a1f;

});

parcelRegister("2OsdU", function(module, exports) {

var $jLeRZ = parcelRequire("jLeRZ");

const $56f0cf8728506f87$export$8669b3074569e564 = (0, $jLeRZ.z).nativeEnum({
    WorkItem: 'work-item',
    Document: 'document',
    Article: 'article',
    Post: 'post',
    Ticket: 'ticket',
    Comment: 'comment'
});
module.exports["zendeskContentTypeSchema"] = $56f0cf8728506f87$export$8669b3074569e564;

});

parcelRegister("4JaUT", function(module, exports) {
class $467e66f9b3647ad5$export$94cd2e6f39615373 extends Error {
    constructor(message){
        super(message);
        this.name = 'ResultsFetchError';
    }
}
module.exports["ResultsFetchError"] = $467e66f9b3647ad5$export$94cd2e6f39615373;

});

parcelRegister("lIbf3", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $b4tvS = parcelRequire("b4tvS");


var $fKv9F = parcelRequire("fKv9F");

const $d1c4c8d8da3b5693$export$17d9a81ce3c86a85 = (urlSearchParams)=>{
    const queryParamsObject = Array.from(urlSearchParams.entries()).reduce((paramsObject, [paramKey, value])=>{
        return {
            ...paramsObject,
            [paramKey]: value
        };
    }, {});
    return queryParamsObject;
};
const $d1c4c8d8da3b5693$export$67c4cee80a3410cd = (queryParams, options)=>{
    const filteredParsedQueryParamEntries = Object.entries((0, $fKv9F.searchQueryParamsBaseSchema).shape).map(([key, schema])=>{
        const queryParamValue = queryParams[key];
        const parsedRawValue = schema.safeParse(queryParamValue);
        if (parsedRawValue.success || !options?.commaSeparatedValues) return [
            key,
            parsedRawValue.data
        ];
        const commaSeparatedString = Array.isArray(queryParamValue) && queryParamValue.length ? queryParamValue.join(',') : undefined;
        const parsedString = schema.safeParse(commaSeparatedString);
        return [
            key,
            parsedString.success ? parsedString.data : null
        ];
    }).filter(([_, value])=>!(value === null || value === undefined));
    const parsedQueryParams = Object.fromEntries(filteredParsedQueryParamEntries);
    const validatedQueryParams = (0, $fKv9F.searchQueryParamsValidators).reduce((queryParams, validator)=>validator(queryParams), parsedQueryParams);
    // remove assets filters
    if ((0, $dh538.fg)('asset_rovo_search_remove_filters')) {
        if ((validatedQueryParams.product === (0, $b4tvS.ProductKeys).Assets || validatedQueryParams.assetsSchema || validatedQueryParams.assetsType) && !(0, $dh538.fg)('assets_rovo_search_all')) {
            if (validatedQueryParams.product === (0, $b4tvS.ProductKeys).Assets) validatedQueryParams.product = undefined;
            validatedQueryParams.assetsSchema = undefined;
            validatedQueryParams.assetsType = undefined;
        }
    }
    return validatedQueryParams;
};
const $d1c4c8d8da3b5693$export$60eb5b58f94d0071 = (oldQueryParams, newQueryParams)=>{
    const oldQueryParamEntries = Object.entries(oldQueryParams).filter(([_, value])=>!Array.isArray(value));
    const newQueryParamEntries = Object.entries(newQueryParams).filter(([_, value])=>!Array.isArray(value));
    const oldQueryParamArrayEntries = Object.entries(oldQueryParams).filter(([_, value])=>Array.isArray(value));
    const newQueryParamArrayEntries = Object.entries(newQueryParams).filter(([_, value])=>Array.isArray(value));
    const mergedQueryStringParamKeys = [
        ...new Set([
            ...oldQueryParamArrayEntries,
            ...newQueryParamArrayEntries
        ].map(([key])=>key))
    ];
    const mergedSearchQueryArrays = mergedQueryStringParamKeys.map((key)=>{
        return [
            key,
            [
                ...new Set([
                    ...oldQueryParams[key] ?? [],
                    ...newQueryParams[key] ?? []
                ])
            ]
        ];
    });
    return {
        ...Object.fromEntries(oldQueryParamEntries),
        ...Object.fromEntries(newQueryParamEntries),
        ...Object.fromEntries(mergedSearchQueryArrays)
    };
};
const $d1c4c8d8da3b5693$export$fc8e8d0c43c32316 = (queryParams)=>{
    return Object.entries(queryParams).flatMap((queryParam)=>{
        const [key, value] = queryParam;
        if (Array.isArray(value)) return [
            [
                key,
                value.join(',')
            ]
        ];
        return [
            [
                key,
                value
            ]
        ];
    });
};
const $d1c4c8d8da3b5693$export$17404cc52c459484 = (queryParams)=>{
    const queryParamRawEntries = Object.entries(queryParams).flatMap((queryParam)=>{
        const [paramKey, value] = queryParam;
        if (value instanceof Date) {
            const dateFormatOptions = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            };
            const dateFormatter = new Intl.DateTimeFormat('en-US', dateFormatOptions);
            const { month: month, day: day, year: year } = Object.fromEntries(dateFormatter.formatToParts(value).map((part)=>[
                    part.type,
                    part.value
                ]));
            return [
                [
                    paramKey,
                    `${year}-${month}-${day}`
                ]
            ];
        }
        if (value === false || value === true) return [
            [
                paramKey,
                String(value)
            ]
        ];
        if (Array.isArray(value)) return [
            [
                paramKey,
                value.join(',')
            ]
        ];
        // Some query params (e.g. `overrides`) are stored as structured objects in
        // `SearchQueryStringParams` (parsed via Zod). When converting back to raw query params /
        // query string, we must serialize them.
        if (value && typeof value === 'object') return [
            [
                paramKey,
                encodeURIComponent(JSON.stringify(value))
            ]
        ];
        return [
            [
                paramKey,
                value
            ]
        ];
    }).sort(([firstKey], [secondKey])=>firstKey < secondKey ? 1 : -1);
    return Object.fromEntries(queryParamRawEntries);
};
const $d1c4c8d8da3b5693$export$249cc09c933c4d7a = (queryParams)=>{
    const sanitizedQueryParams = Object.fromEntries(Object.entries(queryParams).filter(([_, value])=>value !== undefined));
    return new URLSearchParams($d1c4c8d8da3b5693$export$fc8e8d0c43c32316($d1c4c8d8da3b5693$export$17404cc52c459484(sanitizedQueryParams))).toString();
};
const $d1c4c8d8da3b5693$export$f30b1e6bbcaec160 = (queryParams)=>{
    return Object.fromEntries($d1c4c8d8da3b5693$export$fc8e8d0c43c32316($d1c4c8d8da3b5693$export$17404cc52c459484(queryParams)));
};
const $d1c4c8d8da3b5693$export$e247f217269cd2eb = (...queryParamArray)=>{
    const queryParamStrings = queryParamArray.map((queryParams)=>$d1c4c8d8da3b5693$export$249cc09c933c4d7a(queryParams));
    const allQueryParamsAreEqual = new Set(queryParamStrings).size === 1;
    return allQueryParamsAreEqual;
};
const $d1c4c8d8da3b5693$export$11c3edcbebb03988 = (queryParams, keys)=>{
    return keys.reduce((acc, key)=>{
        if (queryParams[key] === undefined) return acc;
        if (Array.isArray(queryParams[key])) return {
            ...acc,
            [key]: queryParams[key]
        };
        if (typeof queryParams[key] === 'string' || typeof queryParams[key] === 'boolean') return {
            ...acc,
            [key]: [
                queryParams[key].toString()
            ]
        };
        return acc;
    }, {});
};
const $d1c4c8d8da3b5693$export$ac30e2047efa6738 = (datasourceId, selectedProduct, thirdPartyConfigs)=>{
    if (!datasourceId || !selectedProduct || !thirdPartyConfigs) return undefined;
    const productConfig = thirdPartyConfigs[selectedProduct];
    if (!productConfig?.datasources) return undefined;
    return productConfig.datasources.find((ds)=>ds.datasourceId === datasourceId);
};
module.exports["parseQueryParams"] = $d1c4c8d8da3b5693$export$67c4cee80a3410cd;
module.exports["toQueryString"] = $d1c4c8d8da3b5693$export$249cc09c933c4d7a;
module.exports["toQueryParamsRaw"] = $d1c4c8d8da3b5693$export$f30b1e6bbcaec160;
module.exports["areAllEqualQueryParams"] = $d1c4c8d8da3b5693$export$e247f217269cd2eb;
module.exports["convertQueryParamsToStringArray"] = $d1c4c8d8da3b5693$export$11c3edcbebb03988;
module.exports["getDatasourceFromId"] = $d1c4c8d8da3b5693$export$ac30e2047efa6738;

});

parcelRegister("jyecU", function(module, exports) {

var $3JX0d = parcelRequire("3JX0d");

const $40ff74c200fc8302$export$6466dd1b74ba3dff = (productsToSearch, typeFilter, thirdPartyConfigs, availableProducts, selectedProducts)=>{
    // This early return is to appease Typescript. The typeFilter is always defined and is always single select.
    if (!typeFilter || !(typeFilter.type === 'single-select')) return {
        selectedEntities: [],
        entitiesForQuery: [],
        entitiesForResultsCountQuery: [],
        selectedTypes: []
    };
    const defaultOptionValue = typeFilter.options?.find((option)=>option.isDefault)?.value;
    const selectedTypes = typeFilter.value.filter((value)=>value !== defaultOptionValue).filter(Boolean);
    const { entitiesForQuery: entitiesForQuery, entitiesForResultsCountQuery: entitiesForResultsCountQuery } = (0, $3JX0d.getEntitiesForQuery)(productsToSearch, selectedTypes, thirdPartyConfigs, availableProducts, selectedProducts);
    return {
        selectedEntities: selectedTypes,
        entitiesForQuery: entitiesForQuery,
        entitiesForResultsCountQuery: entitiesForResultsCountQuery,
        selectedTypes: selectedTypes
    };
};
module.exports["getUniversalTypeEntities"] = $40ff74c200fc8302$export$6466dd1b74ba3dff;

});

parcelRegister("gW8Zi", function(module, exports) {
const $b3199a75d32b6583$export$79cd775d0d5c2a2 = (from, to)=>{
    const fromDate = from ? new Date(from) : new Date();
    const startOfTheFromDate = new Date(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate(), 0, 0, 0, 0);
    const toDate = to ? new Date(to) : new Date();
    const endOfTheToDate = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDate(), 23, 59, 59, 999);
    return {
        gt: from ? startOfTheFromDate.toISOString().split('Z')[0] : undefined,
        lt: to ? endOfTheToDate.toISOString().split('Z')[0] : undefined
    };
};
module.exports["convertCustomDateToRange"] = $b3199a75d32b6583$export$79cd775d0d5c2a2;

});

parcelRegister("3baWa", function(module, exports) {
// considering the user's locale-based definition of start OR end of day
const $a12915fd6eb90535$export$8db446d8af54b4b5 = (fromOffset, toOffset)=>{
    const currentDate = new Date();
    return {
        gt: new Date(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()).getTime() - fromOffset * 86400000).toISOString().split('Z')[0],
        lt: new Date(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 23, 59, 59, 999).getTime() - toOffset * 86400000).toISOString().split('Z')[0]
    };
};
module.exports["getUTCDateRange"] = $a12915fd6eb90535$export$8db446d8af54b4b5;

});

parcelRegister("4tTFP", function(module, exports) {
/**
 * Pure date and sort utility functions for filters.
 * Extracted from filters barrel to avoid importing ThirdPartyConfigs.
 *
 */ 
var $gW8Zi = parcelRequire("gW8Zi");


var $3baWa = parcelRequire("3baWa");


const $8bf5c543098fb1e6$export$50da93f10cdc6a84 = (lastUpdated)=>{
    let dateRangeValues;
    switch(lastUpdated){
        case 'today':
            dateRangeValues = (0, $3baWa.getUTCDateRange)(0, 0);
            break;
        case 'yesterday':
            dateRangeValues = (0, $3baWa.getUTCDateRange)(1, 1);
            break;
        case 'past7Days':
            dateRangeValues = (0, $3baWa.getUTCDateRange)(7, 0);
            break;
        case 'past30Days':
            dateRangeValues = (0, $3baWa.getUTCDateRange)(30, 0);
            break;
        case 'pastYear':
            dateRangeValues = (0, $3baWa.getUTCDateRange)(365, 0);
            break;
        default:
            dateRangeValues = {
                gt: '',
                lt: ''
            };
    }
    return dateRangeValues;
};
const $8bf5c543098fb1e6$export$e048252fb7949a77 = (from, to)=>{
    const { gt: gt, lt: lt } = (0, $gW8Zi.convertCustomDateToRange)(from, to);
    return {
        field: 'LASTMODIFIED',
        gt: gt,
        lt: lt
    };
};
const $8bf5c543098fb1e6$export$405f2efecb6f5de6 = (selectedDateOption)=>{
    const dateRangeValues = $8bf5c543098fb1e6$export$50da93f10cdc6a84(selectedDateOption);
    const { gt: gt, lt: lt } = dateRangeValues;
    return {
        field: 'LASTMODIFIED',
        gt: gt,
        lt: lt
    };
};
module.exports["convertLastUpdatedToDateRange"] = $8bf5c543098fb1e6$export$50da93f10cdc6a84;
module.exports["getConfluenceDateOptionFromCustomDates"] = $8bf5c543098fb1e6$export$e048252fb7949a77;
module.exports["getConfluenceDateOptionValues"] = $8bf5c543098fb1e6$export$405f2efecb6f5de6;

});

parcelRegister("fKv9F", function(module, exports) {

var $jLeRZ = parcelRequire("jLeRZ");


var $bxnmj = parcelRequire("bxnmj");


var $2Znam = parcelRequire("2Znam");


var $ibEDi = parcelRequire("ibEDi");


var $e9G7T = parcelRequire("e9G7T");


var $jg4n8 = parcelRequire("jg4n8");


var $cRtk3 = parcelRequire("cRtk3");


var $flB9e = parcelRequire("flB9e");


var $eXG0s = parcelRequire("eXG0s");


var $9zSTL = parcelRequire("9zSTL");


var $jfGkT = parcelRequire("jfGkT");


var $dgPAd = parcelRequire("dgPAd");


var $afn43 = parcelRequire("afn43");


var $2TmKt = parcelRequire("2TmKt");


var $967WU = parcelRequire("967WU");


var $5Y8VG = parcelRequire("5Y8VG");


var $8E3qI = parcelRequire("8E3qI");


var $deFq6 = parcelRequire("deFq6");


var $er8dU = parcelRequire("er8dU");


var $f8qqB = parcelRequire("f8qqB");


var $fDjwt = parcelRequire("fDjwt");


var $djv4w = parcelRequire("djv4w");


var $7oQyb = parcelRequire("7oQyb");


var $8l0cM = parcelRequire("8l0cM");


var $373KP = parcelRequire("373KP");


var $kFuPh = parcelRequire("kFuPh");


var $l9RY2 = parcelRequire("l9RY2");


var $fB9ef = parcelRequire("fB9ef");


var $kM8s6 = parcelRequire("kM8s6");


var $anS4K = parcelRequire("anS4K");


var $jcLLN = parcelRequire("jcLLN");


var $dZ9iJ = parcelRequire("dZ9iJ");


var $1UZgG = parcelRequire("1UZgG");


var $2OsdU = parcelRequire("2OsdU");

const $0c3c63d3552875fa$export$ec20ab1a5eb36014 = (0, $ibEDi.allContentTypeSchema).enum;
const $0c3c63d3552875fa$export$48b648eee115c3e5 = (0, $cRtk3.atlasContentTypeSchema).enum;
const $0c3c63d3552875fa$export$721015a6e24d06a0 = (0, $e9G7T.asanaContentTypeSchema).enum;
const $0c3c63d3552875fa$export$98ac9eece9e68319 = (0, $jfGkT.confluenceContentTypeSchema).enum;
const $0c3c63d3552875fa$export$bcc0874ed7743007 = (0, $5Y8VG.googleContentTypeSchema).enum;
const $0c3c63d3552875fa$export$847712e479ca402d = (0, $djv4w.microsoftContentTypeSchema).enum;
const $0c3c63d3552875fa$export$8c76eb96ebfefeac = (0, $afn43.dropboxContentTypeSchema).enum;
const $0c3c63d3552875fa$export$e3ddf72248eaf972 = (0, $deFq6.jiraContentTypeSchema).enum;
const $0c3c63d3552875fa$export$39271a5a1b74da02 = (0, $9zSTL.compassContentTypeSchema).enum;
const $0c3c63d3552875fa$export$145fdb32ff1a4acf = (0, $fDjwt.mercuryContentTypeSchema).enum;
const $0c3c63d3552875fa$export$d493ea6967abef56 = (0, $anS4K.talentContentTypeSchema).enum;
const $0c3c63d3552875fa$export$309520b897e0c0b = (0, $dZ9iJ.trelloContentTypeSchema).enum;
const $0c3c63d3552875fa$export$d51b5367809bb96 = (0, $l9RY2.slackContentTypeSchema).enum;
const $0c3c63d3552875fa$export$c69d59ad598aee72 = (0, $jcLLN.teamsContentTypeSchema).enum;
const $0c3c63d3552875fa$export$8de16d71f5b0d410 = (0, $967WU.githubContentTypeSchema).enum;
const $0c3c63d3552875fa$export$bf86d9f770860253 = (0, $1UZgG.webPageContentTypeSchema).enum;
const $0c3c63d3552875fa$export$66f84ff942de6e1f = (0, $2TmKt.figmaContentTypeSchema).enum;
const $0c3c63d3552875fa$export$56591a3ad34d704b = (0, $f8qqB.loomContentTypeSchema).enum;
const $0c3c63d3552875fa$export$fd3bdf5548c7bf84 = (0, $2OsdU.zendeskContentTypeSchema).enum;
const $0c3c63d3552875fa$export$6b45e4ca3151b046 = (0, $fB9ef.smartLinksContentTypeSchema).enum;
const $0c3c63d3552875fa$export$9325d29d4a9658a4 = (0, $373KP.salesforceContentTypeSchema).enum;
const $0c3c63d3552875fa$export$92229a634de6b0ae = (0, $dgPAd.databricksContentTypeSchema).enum;
const $0c3c63d3552875fa$export$7c597234a357d5f7 = (0, $8E3qI.hubspotContentTypeSchema).enum;
const $0c3c63d3552875fa$export$7f83273171d63901 = (0, $kFuPh.servicenowContentTypeSchema).enum;
const $0c3c63d3552875fa$export$a08d1bf234105c9c = (0, $jg4n8.assetsContentTypeSchema).enum;
const $0c3c63d3552875fa$export$593c74387f9db963 = (0, $jLeRZ.z).nativeEnum({
    ...$0c3c63d3552875fa$export$ec20ab1a5eb36014,
    ...$0c3c63d3552875fa$export$721015a6e24d06a0,
    ...$0c3c63d3552875fa$export$48b648eee115c3e5,
    ...$0c3c63d3552875fa$export$98ac9eece9e68319,
    ...$0c3c63d3552875fa$export$bcc0874ed7743007,
    ...$0c3c63d3552875fa$export$847712e479ca402d,
    ...$0c3c63d3552875fa$export$e3ddf72248eaf972,
    ...$0c3c63d3552875fa$export$39271a5a1b74da02,
    ...$0c3c63d3552875fa$export$145fdb32ff1a4acf,
    ...$0c3c63d3552875fa$export$309520b897e0c0b,
    ...$0c3c63d3552875fa$export$d51b5367809bb96,
    ...$0c3c63d3552875fa$export$c69d59ad598aee72,
    ...$0c3c63d3552875fa$export$66f84ff942de6e1f,
    ...$0c3c63d3552875fa$export$8de16d71f5b0d410,
    ...$0c3c63d3552875fa$export$56591a3ad34d704b,
    ...$0c3c63d3552875fa$export$bf86d9f770860253,
    ...$0c3c63d3552875fa$export$8c76eb96ebfefeac,
    ...$0c3c63d3552875fa$export$fd3bdf5548c7bf84,
    ...$0c3c63d3552875fa$export$6b45e4ca3151b046,
    ...$0c3c63d3552875fa$export$9325d29d4a9658a4,
    ...$0c3c63d3552875fa$export$7c597234a357d5f7,
    ...$0c3c63d3552875fa$export$92229a634de6b0ae,
    ...$0c3c63d3552875fa$export$a08d1bf234105c9c,
    ...$0c3c63d3552875fa$export$d493ea6967abef56,
    ...$0c3c63d3552875fa$export$7f83273171d63901
});
const $0c3c63d3552875fa$export$4f29dba8e623c3d1 = (0, $jLeRZ.z).nativeEnum({
    ...(0, $2Znam.TypeFilterValueKey),
    ...$0c3c63d3552875fa$export$ec20ab1a5eb36014
});
const $0c3c63d3552875fa$export$e2e108cbe2e4f865 = $0c3c63d3552875fa$export$4f29dba8e623c3d1.enum;
const $0c3c63d3552875fa$export$8a9f7fff0151f0f7 = (0, $jLeRZ.z).nativeEnum({
    ...(0, $bxnmj.PageStatusFilterValueKey),
    ...$0c3c63d3552875fa$export$ec20ab1a5eb36014
});
const $0c3c63d3552875fa$export$e6747eee8f26f8c0 = (0, $er8dU.lastModifiedValueSchema).enum;
const $0c3c63d3552875fa$export$d43f91ac58cde147 = (0, $kM8s6.sortSchema).enum;
const $0c3c63d3552875fa$var$jsonEncodedSchema = (schema)=>(0, $jLeRZ.z).preprocess((value)=>{
        // Expected format: URL encoded JSON string
        if (typeof value === 'string') {
            let decoded = value;
            try {
                decoded = decodeURIComponent(value);
            } catch  {
            // ignore decoding errors; schema will fail if JSON is invalid
            }
            try {
                return JSON.parse(decoded);
            } catch  {
                return value;
            }
        }
        return value;
    }, schema);
const $0c3c63d3552875fa$export$37bdef1e194c0e7e = $0c3c63d3552875fa$var$jsonEncodedSchema((0, $jLeRZ.z).object({
    sourceProduct: (0, $jLeRZ.z).string().min(1).optional(),
    frontendFeatureGates: (0, $jLeRZ.z).array((0, $jLeRZ.z).object({
        name: (0, $jLeRZ.z).string().min(1),
        value: (0, $jLeRZ.z).boolean()
    })).optional(),
    frontendExperiments: (0, $jLeRZ.z).array((0, $jLeRZ.z).object({
        name: (0, $jLeRZ.z).string().min(1),
        value: (0, $jLeRZ.z).record((0, $jLeRZ.z).union([
            (0, $jLeRZ.z).string(),
            (0, $jLeRZ.z).boolean()
        ]))
    })).optional(),
    backendExperiments: (0, $jLeRZ.z).array((0, $jLeRZ.z).object({
        name: (0, $jLeRZ.z).enum([
            'search_platform_layer_l1',
            'search_platform_layer_l2',
            'search_platform_layer_l3',
            'search_platform_layer_query_expansion'
        ]),
        analyticsDefinitions: (0, $jLeRZ.z).array((0, $jLeRZ.z).object({
            layerId: (0, $jLeRZ.z).string().nullable().optional(),
            shadowId: (0, $jLeRZ.z).string().nullable().optional(),
            entity: (0, $jLeRZ.z).string().nullable().optional(),
            subEntity: (0, $jLeRZ.z).string().nullable().optional(),
            abTestId: (0, $jLeRZ.z).string().nullable(),
            controlId: (0, $jLeRZ.z).string().nullable()
        }).passthrough()).optional()
    }).passthrough()).optional()
}).passthrough());
const $0c3c63d3552875fa$export$7b58b3b9a7b83d61 = (0, $jLeRZ.z).object({
    text: (0, $jLeRZ.z).optional((0, $jLeRZ.z).string().max(200)),
    originalQuery: (0, $jLeRZ.z).optional((0, $jLeRZ.z).string().max(200)),
    product: (0, $jLeRZ.z).optional((0, $jLeRZ.z).string().pipe((0, $8l0cM.productKeySchema))),
    datasource: (0, $jLeRZ.z).optional((0, $jLeRZ.z).string()),
    type: (0, $jLeRZ.z).optional((0, $jLeRZ.z).string().pipe($0c3c63d3552875fa$export$4f29dba8e623c3d1)),
    filterDropdownOpen: (0, $jLeRZ.z).optional((0, $flB9e.booleanSchema)),
    // Last Modified
    lastModified: (0, $jLeRZ.z).optional((0, $jLeRZ.z).string().pipe((0, $er8dU.lastModifiedValueSchema))),
    lastModified_lt: (0, $jLeRZ.z).optional((0, $jLeRZ.z).string().pipe((0, $jLeRZ.z).coerce.date())),
    lastModified_gt: (0, $jLeRZ.z).optional((0, $jLeRZ.z).string().pipe((0, $jLeRZ.z).coerce.date())),
    from: (0, $jLeRZ.z).optional((0, $jLeRZ.z).string()),
    to: (0, $jLeRZ.z).optional((0, $jLeRZ.z).string()),
    sort: (0, $jLeRZ.z).optional((0, $jLeRZ.z).string().pipe((0, $kM8s6.sortSchema))),
    titleMatch: (0, $jLeRZ.z).optional((0, $flB9e.booleanSchema)),
    // Confluence filters
    contributors: (0, $jLeRZ.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    owners: (0, $jLeRZ.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    ancestor: (0, $jLeRZ.z).optional((0, $jLeRZ.z).string()),
    // Salesforce Filters
    campaignStatuses: (0, $jLeRZ.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    caseStatuses: (0, $jLeRZ.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    isAutoApplied: (0, $jLeRZ.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    salesforceStages: (0, $jLeRZ.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    spaces: (0, $jLeRZ.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    verified: (0, $jLeRZ.z).optional((0, $flB9e.booleanSchema)),
    labels: (0, $jLeRZ.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    pageStatus: (0, $jLeRZ.z).optional((0, $jLeRZ.z).string().pipe($0c3c63d3552875fa$export$8a9f7fff0151f0f7)),
    archived: (0, $jLeRZ.z).optional((0, $flB9e.booleanSchema)),
    // Jira Filters
    jAssignee: (0, $jLeRZ.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    jReporter: (0, $jLeRZ.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    jCommentedByMe: (0, $jLeRZ.z).optional((0, $flB9e.booleanSchema)),
    jProject: (0, $jLeRZ.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    jWatchedByMe: (0, $jLeRZ.z).optional((0, $flB9e.booleanSchema)),
    // Assets Filters
    assetsSchema: (0, $jLeRZ.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    assetsType: (0, $jLeRZ.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    // Mercury Filters
    focusAreaTypes: (0, $jLeRZ.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    focusAreaUnder: (0, $jLeRZ.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    // Talent Filters
    positionEmploymentTypes: (0, $jLeRZ.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    positionFocusAreas: (0, $jLeRZ.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    positionJobFamilies: (0, $jLeRZ.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    positionStatuses: (0, $jLeRZ.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    positionTeams: (0, $jLeRZ.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    // Compass Filters
    compassArchived: (0, $jLeRZ.z).optional((0, $flB9e.booleanSchema)),
    createdBy: (0, $jLeRZ.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    lastUpdatedBy: (0, $jLeRZ.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    // Salesforce Close Date filter
    closeDate: (0, $jLeRZ.z).optional((0, $jLeRZ.z).string()),
    closeDateVal: (0, $jLeRZ.z).optional((0, $jLeRZ.z).string()),
    // Salesforce Opportunity Status filter
    opportunityStatus: (0, $jLeRZ.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    referrer: (0, $jLeRZ.z).optional((0, $jLeRZ.z).string()),
    /**
	 * URL encoded JSON string used to override feature gates/experiments for debugging.
	 */ overrides: (0, $jLeRZ.z).optional((0, $jLeRZ.z).string().pipe($0c3c63d3552875fa$export$37bdef1e194c0e7e)),
    cql: (0, $jLeRZ.z).optional((0, $jLeRZ.z).string()),
    status: (0, $jLeRZ.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    // Pull Request Status filter (GitHub, Bitbucket, GitLab)
    pullRequestStatus: (0, $jLeRZ.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    // Repository filter (GitHub)
    repository: (0, $jLeRZ.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    // Slack Channel filter
    slackChannels: (0, $jLeRZ.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    // Loom folder filter (Quick Find, multi-select)
    folders: (0, $jLeRZ.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    // MS Teams Team (workspace) filter
    workspaceName: (0, $jLeRZ.z).optional((0, $eXG0s.commaSeparatedArraySchema)),
    // MS Teams Has Attachment filter
    hasAttachment: (0, $jLeRZ.z).optional((0, $flB9e.booleanSchema))
});
const $0c3c63d3552875fa$export$f374b5430ac28f4c = $0c3c63d3552875fa$export$7b58b3b9a7b83d61.keyof().enum;
const $0c3c63d3552875fa$export$ff67c0a0b67bb249 = [
    (queryParams)=>{
        if (queryParams.lastModified !== 'custom') {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { lastModified_gt: lastModified_gt, lastModified_lt: lastModified_lt, ...restQueryParams } = queryParams;
            return restQueryParams;
        }
        return queryParams;
    },
    (queryParams)=>{
        const { lastModified_lt: lastModified_lt, lastModified_gt: lastModified_gt } = queryParams;
        if (lastModified_lt && lastModified_gt && lastModified_lt > lastModified_gt) {
            const { lastModified: _, lastModified_gt: __, lastModified_lt: ___, ...restQueryParams } = queryParams;
            return restQueryParams;
        }
        return queryParams;
    },
    // If closeDate is not 'custom', strip out closeDateVal
    (queryParams)=>{
        if (queryParams.closeDate !== 'custom') {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { closeDateVal: closeDateVal, ...restQueryParams } = queryParams;
            return restQueryParams;
        }
        return queryParams;
    }
];
const $0c3c63d3552875fa$export$83efce6e50d7c43b = (0, $jLeRZ.z).nativeEnum({
    ...(0, $7oQyb.ProductKey),
    ...$0c3c63d3552875fa$export$e2e108cbe2e4f865,
    ...$0c3c63d3552875fa$export$e6747eee8f26f8c0,
    ...$0c3c63d3552875fa$export$f374b5430ac28f4c
});
const $0c3c63d3552875fa$export$3d21d7040623da50 = $0c3c63d3552875fa$export$83efce6e50d7c43b.enum;
module.exports["ContentType"] = $0c3c63d3552875fa$export$e2e108cbe2e4f865;
module.exports["LastModified"] = $0c3c63d3552875fa$export$e6747eee8f26f8c0;
module.exports["Sort"] = $0c3c63d3552875fa$export$d43f91ac58cde147;
module.exports["searchQueryParamsBaseSchema"] = $0c3c63d3552875fa$export$7b58b3b9a7b83d61;
module.exports["searchQueryParamsValidators"] = $0c3c63d3552875fa$export$ff67c0a0b67bb249;

});

parcelRegister("21S1F", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $a7136ae8b2d202d1$export$48804b5672e75138 = (type)=>{
    let messageKey = type;
    if (type === 'page' && (0, $dh538.fg)('confluence_live_pages_open_beta_trait_opted_in')) messageKey = 'pageAndLiveDoc';
    return messageKey;
};
module.exports["getTypeOptionMessageKey"] = $a7136ae8b2d202d1$export$48804b5672e75138;

});

parcelRegister("66big", function(module, exports) {

var $1xk5k = parcelRequire("1xk5k");


var $b4tDU = parcelRequire("b4tDU");

const $894b216ca0441314$export$c0b4470d000520ff = (ati, selectedTypes, selectedProducts)=>{
    // In the "all products" and "all types" search, we drop some entities for relevance
    // If types are selected (e.g. "All products" + "Page") or a product is selected ("Confluence" + "all types"), we don't drop any entities
    if (selectedTypes.length === 0 && selectedProducts && (0, $b4tDU.isAllProductSearch)(selectedProducts)) return !(0, $1xk5k.notRequestedATIsInAllSearch)().includes(ati);
    return true;
};
module.exports["isEntityEnabled"] = $894b216ca0441314$export$c0b4470d000520ff;

});

parcelRegister("3fLdC", function(module, exports) {

var $b4tvS = parcelRequire("b4tvS");


var $dOOW1 = parcelRequire("dOOW1");

const $108ae9f9e6bc58a3$export$521c196d70b6785e = (availableProducts, product, thirdPartyConfigs)=>{
    if ((0, $b4tvS.is3pProductKey)(product)) return availableProducts.includes(product) && (!thirdPartyConfigs[product]?.userNeedsOAuth || (0, $dOOW1.isImpersonationEnabled)(product, thirdPartyConfigs));
    else return availableProducts.includes(product);
};
module.exports["isProductEntitiesIncluded"] = $108ae9f9e6bc58a3$export$521c196d70b6785e;

});

parcelRegister("jN0EV", function(module, exports) {
const $8ae69ec250b43bf2$export$e902a1c7f3216533 = (query, label)=>{
    return label.toLowerCase().includes(query.toLowerCase());
};
module.exports["lookupMatches"] = $8ae69ec250b43bf2$export$e902a1c7f3216533;

});

parcelRegister("1OY0Y", function(module, exports) {
const $e429436ebdc8254b$export$c87d62ed9387fa60 = [
    'ati:cloud:townsquare:project',
    'ati:cloud:townsquare:goal',
    'ati:cloud:townsquare:tag'
];
module.exports["DEFAULT_ATLAS_ENTITY_ATI"] = $e429436ebdc8254b$export$c87d62ed9387fa60;

});

parcelRegister("hCmMX", function(module, exports) {
const $25855452e6a3f72a$export$c07a1c127052b557 = [
    'ati:cloud:confluence:page',
    'ati:cloud:confluence:blogpost',
    'ati:cloud:confluence:attachment',
    'ati:cloud:confluence:space',
    'ati:cloud:confluence:whiteboard'
];
module.exports["DEFAULT_CONFLUENCE_ENTITY_ATI"] = $25855452e6a3f72a$export$c07a1c127052b557;

});

parcelRegister("6PclE", function(module, exports) {
const $1e6d2dee651e75e6$export$e5280e1b46081838 = [
    'ati:cloud:mercury:focus-area',
    'ati:cloud:mercury:focus-area-status-update'
];
module.exports["DEFAULT_MERCURY_ENTITY_ATI"] = $1e6d2dee651e75e6$export$e5280e1b46081838;

});

parcelRegister("kO4OQ", function(module, exports) {
const $38dd6041711f0598$export$368c06447ee18b39 = [
    'ati:cloud:radar:position'
];
module.exports["DEFAULT_TALENT_ENTITY_ATI"] = $38dd6041711f0598$export$368c06447ee18b39;

});

parcelRegister("78yNl", function(module, exports) {
const $382a1369b7330672$export$3f8022b7bd277557 = (siteId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${siteId}`;
module.exports["getSmartlinkSiteTraitsUrl"] = $382a1369b7330672$export$3f8022b7bd277557;

});

parcelRegister("fXT59", function(module, exports) {
/**
 * Interface representing a disposable resource.
 */ function $e8684f0ed4469a79$export$e29d65b7eabdc6dd(value) {
    return typeof value === 'object' && value !== null && typeof value.dispose === 'function';
}
function $e8684f0ed4469a79$export$79eba17614bd018c(initialValue, optionsOrDisposeFn) {
    let currentValue = initialValue ?? null;
    // if second param is a function, treat it as disposeFn
    const options = typeof optionsOrDisposeFn === 'function' ? {
        disposeFn: optionsOrDisposeFn,
        disposeOnUpdate: true
    } : {
        disposeOnUpdate: true,
        ...optionsOrDisposeFn
    };
    const { disposeFn: disposeFn, disposeOnUpdate: disposeOnUpdate = true } = options;
    const disposeCurrentValue = ()=>{
        if (disposeFn) disposeFn(currentValue);
        else if ($e8684f0ed4469a79$export$e29d65b7eabdc6dd(currentValue)) currentValue.dispose();
    };
    return {
        update: (nextValue)=>{
            if (disposeOnUpdate) disposeCurrentValue();
            currentValue = nextValue;
        },
        value: ()=>currentValue,
        dispose: ()=>{
            disposeCurrentValue();
            currentValue = null;
        }
    };
}
function $e8684f0ed4469a79$export$bd7305966afe1e62(disposeFn, initialValue, disposeOnUpdate = true) {
    return $e8684f0ed4469a79$export$79eba17614bd018c(initialValue, {
        disposeFn: disposeFn,
        disposeOnUpdate: disposeOnUpdate
    });
}
function $e8684f0ed4469a79$export$c86c752d0542be0d(initialValues, optionsOrDisposeFn) {
    let currentValues = initialValues ?? null;
    // if second param is a function, treat it as disposeFn
    const options = typeof optionsOrDisposeFn === 'function' ? {
        disposeFn: optionsOrDisposeFn,
        disposeOnUpdate: true
    } : {
        disposeOnUpdate: true,
        ...optionsOrDisposeFn
    };
    const { disposeFn: disposeFn, disposeOnUpdate: disposeOnUpdate = true } = options;
    const disposeCurrentValues = ()=>{
        if (disposeFn) disposeFn(currentValues);
        else currentValues?.forEach((value)=>{
            if ($e8684f0ed4469a79$export$e29d65b7eabdc6dd(value)) value.dispose();
        });
    };
    return {
        update: (nextValues)=>{
            if (disposeOnUpdate) disposeCurrentValues();
            currentValues = nextValues;
        },
        value: ()=>currentValues,
        dispose: ()=>{
            disposeCurrentValues();
            currentValues = null;
        }
    };
}
module.exports["disposableValue"] = $e8684f0ed4469a79$export$79eba17614bd018c;

});

parcelRegister("b4tDU", function(module, exports) {
const $28f266d325652ecc$export$49b588d87f72a4a8 = (selectedProducts)=>selectedProducts.length === 0;
module.exports["isAllProductSearch"] = $28f266d325652ecc$export$49b588d87f72a4a8;

});

parcelRegister("133ZR", function(module, exports) {
/**
 * Lightweight filter ID constants extracted from individual filter modules.
 *
 * These are simple string constants with zero transitive dependencies.
 * Use these instead of importing from the filter barrel file (index.tsx)
 * when you only need the filter ID for keying into a filters record.
 *
 * QS-9423: Breaking the dependency chain that dragged react-sweet-state
 * into the SSR bundle via filter barrel → filter controllers → search store.
 */ const $73b3163876151519$export$741d3c5ff1600fc4 = 'archived';
const $73b3163876151519$export$98981f5c8dc7607d = 'compassArchived';
const $73b3163876151519$export$798f70d5ba74d109 = 'assetsSchema';
const $73b3163876151519$export$51661d1a93f29640 = 'assetsType';
const $73b3163876151519$export$9c1e246329cdf939 = 'assignee';
const $73b3163876151519$export$e32111e9166eaf89 = 'closeDate';
const $73b3163876151519$export$9af0987cf592f533 = 'commentedByMe';
const $73b3163876151519$export$6a3fc832c5c25c7d = 'content';
const $73b3163876151519$export$e03d97f0eaa66910 = 'contributor';
const $73b3163876151519$export$9ab819519540cfb4 = 'createdBy';
const $73b3163876151519$export$cd646dbb07979a8d = 'focusAreaType';
const $73b3163876151519$export$2678e5eb1f9db396 = 'focusAreaUnder';
const $73b3163876151519$export$623d400c5f880682 = 'label';
const $73b3163876151519$export$7ecf570078da6b1c = 'lastUpdatedBy';
const $73b3163876151519$export$11e1218ac07ed03e = 'lastUpdated';
const $73b3163876151519$export$68c1310fa8b7db62 = 'campaignStatus';
const $73b3163876151519$export$6598f3f01335d547 = 'caseStatus';
const $73b3163876151519$export$4febaaf9b7a72ca9 = 'opportunityStatus';
const $73b3163876151519$export$c21586a37554cc74 = 'pullRequestStatus';
const $73b3163876151519$export$2e6de80282206ac4 = 'repository';
const $73b3163876151519$export$f42198825b45f0bf = 'owner';
const $73b3163876151519$export$bcfaf48394705893 = 'pageStatus';
const $73b3163876151519$export$713c4dadb56593e7 = 'positionEmploymentType';
const $73b3163876151519$export$d87a0f934d4a8c3c = 'positionFocusArea';
const $73b3163876151519$export$19dab386a6b200ee = 'positionJobFamily';
const $73b3163876151519$export$f75b5006a4fc44bc = 'positionStatus';
const $73b3163876151519$export$4c1df8b2cfbc878 = 'positionTeam';
const $73b3163876151519$export$9e360b05ef07f438 = 'project';
const $73b3163876151519$export$58bc8a3e7def8aea = 'reporter';
const $73b3163876151519$export$3515d33a163cbcb3 = 'salesforceStage';
const $73b3163876151519$export$4f9240015ff0684c = 'sort';
const $73b3163876151519$export$3a6305d8320c16a4 = 'space';
const $73b3163876151519$export$2a46d5fba7ab443f = 'statusFilter';
const $73b3163876151519$export$89b94a9f6bd9eece = 'onlyTitleMatch';
const $73b3163876151519$export$b698e15dd0654a6b = 'verified';
const $73b3163876151519$export$883e178bcc42a97b = 'watchedByMe';
const $73b3163876151519$export$26517625dab3ad98 = 'slackChannel';
const $73b3163876151519$export$c11f86df99674975 = 'folder';
const $73b3163876151519$export$1bb4d8ad1dbc2bac = 'workspaceName';
const $73b3163876151519$export$4d0145e3d3f3e249 = 'hasAttachment';
module.exports["archivedFilterId"] = $73b3163876151519$export$741d3c5ff1600fc4;
module.exports["archivedAndPendingComponentsFilterId"] = $73b3163876151519$export$98981f5c8dc7607d;
module.exports["assetsSchemaFilterId"] = $73b3163876151519$export$798f70d5ba74d109;
module.exports["assetsTypeFilterId"] = $73b3163876151519$export$51661d1a93f29640;
module.exports["assigneeFilterId"] = $73b3163876151519$export$9c1e246329cdf939;
module.exports["closeDateFilterId"] = $73b3163876151519$export$e32111e9166eaf89;
module.exports["commentedByMeFilterId"] = $73b3163876151519$export$9af0987cf592f533;
module.exports["contentFilterId"] = $73b3163876151519$export$6a3fc832c5c25c7d;
module.exports["contributorFilterId"] = $73b3163876151519$export$e03d97f0eaa66910;
module.exports["createdByFilterId"] = $73b3163876151519$export$9ab819519540cfb4;
module.exports["focusAreaTypeFilterId"] = $73b3163876151519$export$cd646dbb07979a8d;
module.exports["focusAreaUnderFilterId"] = $73b3163876151519$export$2678e5eb1f9db396;
module.exports["labelFilterId"] = $73b3163876151519$export$623d400c5f880682;
module.exports["lastUpdatedByFilterId"] = $73b3163876151519$export$7ecf570078da6b1c;
module.exports["lastUpdatedFilterId"] = $73b3163876151519$export$11e1218ac07ed03e;
module.exports["campaignStatusFilterId"] = $73b3163876151519$export$68c1310fa8b7db62;
module.exports["caseStatusFilterId"] = $73b3163876151519$export$6598f3f01335d547;
module.exports["opportunityStatusFilterId"] = $73b3163876151519$export$4febaaf9b7a72ca9;
module.exports["pullRequestStatusFilterId"] = $73b3163876151519$export$c21586a37554cc74;
module.exports["repositoryFilterId"] = $73b3163876151519$export$2e6de80282206ac4;
module.exports["ownerFilterId"] = $73b3163876151519$export$f42198825b45f0bf;
module.exports["pageStatusFilterId"] = $73b3163876151519$export$bcfaf48394705893;
module.exports["positionEmploymentTypeFilterId"] = $73b3163876151519$export$713c4dadb56593e7;
module.exports["positionFocusAreaFilterId"] = $73b3163876151519$export$d87a0f934d4a8c3c;
module.exports["positionJobFamilyFilterId"] = $73b3163876151519$export$19dab386a6b200ee;
module.exports["positionStatusFilterId"] = $73b3163876151519$export$f75b5006a4fc44bc;
module.exports["positionTeamFilterId"] = $73b3163876151519$export$4c1df8b2cfbc878;
module.exports["projectFilterId"] = $73b3163876151519$export$9e360b05ef07f438;
module.exports["reporterFilterId"] = $73b3163876151519$export$58bc8a3e7def8aea;
module.exports["salesforceStageFilterId"] = $73b3163876151519$export$3515d33a163cbcb3;
module.exports["sortFilterId"] = $73b3163876151519$export$4f9240015ff0684c;
module.exports["spaceFilterId"] = $73b3163876151519$export$3a6305d8320c16a4;
module.exports["statusFilterId"] = $73b3163876151519$export$2a46d5fba7ab443f;
module.exports["titleMatchFilterId"] = $73b3163876151519$export$89b94a9f6bd9eece;
module.exports["verifiedFilterId"] = $73b3163876151519$export$b698e15dd0654a6b;
module.exports["watchedFilterId"] = $73b3163876151519$export$883e178bcc42a97b;
module.exports["slackChannelFilterId"] = $73b3163876151519$export$26517625dab3ad98;
module.exports["folderFilterId"] = $73b3163876151519$export$c11f86df99674975;
module.exports["workspaceNameFilterId"] = $73b3163876151519$export$1bb4d8ad1dbc2bac;
module.exports["hasAttachmentFilterId"] = $73b3163876151519$export$4d0145e3d3f3e249;

});

parcelRegister("eMDCS", function(module, exports) {
/**
 * Pure date and sort utility functions for filters.
 * Extracted from filters barrel to avoid importing ThirdPartyConfigs.
 *
 */ 
var $2zuvB = parcelRequire("2zuvB");


var $fKv9F = parcelRequire("fKv9F");

const $56585d93a21bfd73$export$5b3e7019b3acc145 = (value)=>{
    switch(value){
        case (0, $fKv9F.Sort).Relevance:
            return [];
        case (0, $fKv9F.Sort).UpdatedNewest:
            return [
                {
                    field: (0, $2zuvB.SORT_FIELD_KEY).LAST_MODIFIED_DATE,
                    order: (0, $2zuvB.SORT_ORDER).DESC
                }
            ];
        case (0, $fKv9F.Sort).UpdatedOldest:
            return [
                {
                    field: (0, $2zuvB.SORT_FIELD_KEY).LAST_MODIFIED_DATE,
                    order: (0, $2zuvB.SORT_ORDER).ASC
                }
            ];
        case (0, $fKv9F.Sort).CreatedNewest:
            return [
                {
                    field: (0, $2zuvB.SORT_FIELD_KEY).CREATED_DATE,
                    order: (0, $2zuvB.SORT_ORDER).DESC
                }
            ];
        case (0, $fKv9F.Sort).CreatedOldest:
            return [
                {
                    field: (0, $2zuvB.SORT_FIELD_KEY).CREATED_DATE,
                    order: (0, $2zuvB.SORT_ORDER).ASC
                }
            ];
        default:
            return [];
    }
};
module.exports["convertSortToFilter"] = $56585d93a21bfd73$export$5b3e7019b3acc145;

});

parcelRegister("d151M", function(module, exports) {
const $1f5a7d8bdef7b5ba$export$8e6bea29334a2099 = (type)=>{
    return type === 'single-select' || type === 'multi-select';
};
module.exports["isSelectFilter"] = $1f5a7d8bdef7b5ba$export$8e6bea29334a2099;

});

parcelRegister("1ikWy", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $a5RR2 = parcelRequire("a5RR2");


var $3diYj = parcelRequire("3diYj");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $9d9t8 = parcelRequire("9d9t8");

const $9029dd6271750632$export$b38c0215344366f7 = ({ supportedProducts: supportedProducts, products: products, accessibleProducts: accessibleProducts })=>{
    // Facade: when rovo_fps_use_rovo_config is enabled, delegate to the
    // canonical implementation in @atlassian/rovo-connectors-config so that
    // search-page and other consumers share a single source of truth.
    // When disabled, fall through to the inline legacy implementation below.
    if ((0, $dh538.fg)('rovo_fps_use_rovo_config')) return (0, $3diYj.getSupportedAccessibleProducts)({
        supportedProducts: supportedProducts,
        products: products,
        accessibleProducts: accessibleProducts
    });
    if (!accessibleProducts) return [];
    const fgControlledProducts = {
        [(0, $b4tvS.ProductKeys).Talent]: (0, $dh538.fg)('talent_global_search')
    };
    const disabledProducts3PFromConfig = [];
    (0, $a5RR2.ThirdPartyConfigsSync).forEach((config, productKey3P)=>{
        if (config && !config.isEnabled()) disabledProducts3PFromConfig.push(productKey3P);
    });
    const accessibleAndSupportedProducts = accessibleProducts.filter((productKey)=>!disabledProducts3PFromConfig.find((featureGatedProduct)=>featureGatedProduct === productKey) && (productKey in fgControlledProducts ? fgControlledProducts[productKey] : true)).filter((productKey)=>{
        // Forge connectors are dynamically added and won't be in supportedProducts
        if ((0, $9d9t8.isForgeConnectorProductKey)(productKey) && (0, $dh538.fg)('rovo-search-dynamic-forge-config')) return true;
        // For hardcoded products, check if they're in supportedProducts
        return supportedProducts.includes(productKey);
    });
    if (products) {
        const allowedProducts = products.filter((product)=>accessibleAndSupportedProducts.includes(product));
        return allowedProducts;
    } else {
        if (//TODO: move this logic to xpsearch aggregator before release with the correct conditions
        // eslint-disable-next-line @atlaskit/platform/no-preconditioning
        accessibleAndSupportedProducts.includes((0, $b4tvS.ProductKeys).JiraServiceManagement) && (0, $dh538.fg)('assets_rovo_search_all') && // add assets as a product if JSM license is present, but this is until assets becomes a platform
        !(0, $dh538.fg)('aurum-assets-as-a-platform') // disable this when assets becomes a platform and we will start getting assets as its product
        ) return [
            ...accessibleAndSupportedProducts,
            (0, $b4tvS.ProductKeys).Assets
        ];
        return accessibleAndSupportedProducts;
    }
};
module.exports["getAccessibleProducts"] = $9029dd6271750632$export$b38c0215344366f7;

});

parcelRegister("lgPOO", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $lIbf3 = parcelRequire("lIbf3");


var $fHHuS = parcelRequire("fHHuS");


var $32Kiv = parcelRequire("32Kiv");


var $9opb6 = parcelRequire("9opb6");

const $54763063a77a852a$export$b676c7d6baea13e9 = ({ children: children, experience: experience, accessibleProducts: accessibleProducts, ...props })=>{
    const { thirdPartyConfigs: initialThirdPartyConfigsProp, searchSessionId: searchSessionIdProp, smartLinkUsage: smartLinkUsageProp, smartLinkUsageAndTopApps: smartLinkUsageAndTopAppsProp } = props.initialProps || {};
    const safeQueryParams = props.queryParams && (0, $lIbf3.parseQueryParams)(props.queryParams);
    /**
   * searchSessionId is generated on the client and does not change frequently, but can be refreshed with refreshSearchSessionId
   *
   * This is effectively a global so can't be drilled much deeper than search-page-relay
   */ const [searchSessionId, setSearchSessionId] = (0, $42omo.useState)(searchSessionIdProp ?? crypto.randomUUID());
    const refreshSearchSessionId = (0, $42omo.useCallback)(()=>{
        const newSearchSessionId = crypto.randomUUID();
        setSearchSessionId(newSearchSessionId);
    }, []);
    /**
   * Initial ?referrer=X paramater for analytics
   * Referrer is actually static for a single page load once, but is cleaned up after use so it isn't re-used in analytics events
   *
   * This is effectively a global so can't be drilled much deeper than search-page-relay
   */ const [referrer, setReferrer] = (0, $42omo.useState)(safeQueryParams?.referrer);
    const clearReferrer = (0, $42omo.useCallback)(()=>{
        setReferrer(undefined);
    }, []);
    /**
   * Initial ?text=X parameter for search store
   *
   * I think this is only used in search-page when checking referrer (not relay) and can be cleaned up with `search-page-relay`
   */ const [initialText] = (0, $42omo.useState)(safeQueryParams?.text);
    const staticProps = {
        refreshSearchSessionId: refreshSearchSessionId,
        clearReferrer: clearReferrer,
        initialText: initialText,
        initialThirdPartyConfigs: (0, $dh538.fg)('rovo_fps_use_rovo_config') ? {} : initialThirdPartyConfigsProp || {},
        experience: experience,
        accessibleProducts: accessibleProducts
    };
    const dynamicProps = {
        searchSessionId: searchSessionId,
        referrer: referrer,
        smartLinkUsage: smartLinkUsageProp,
        smartLinkUsageAndTopApps: smartLinkUsageAndTopAppsProp,
        ...(0, $dh538.fg)('rovo_fps_use_rovo_config') && {
            thirdPartyConfigs: initialThirdPartyConfigsProp || {}
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9opb6.StaticContextProvider), {
        ...props,
        ...staticProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fHHuS.DynamicContextProvider), {
        ...props,
        ...dynamicProps
    }, children));
};
const $54763063a77a852a$export$dada99aabcba96f5 = /*#__PURE__*/ (0, $42omo.createContext)((0, $9opb6.defaultStaticContext));
const $54763063a77a852a$export$64067c351da2da1b = /*#__PURE__*/ (0, $42omo.createContext)((0, $32Kiv.createStaticBootstrapStore)((0, $9opb6.defaultStaticContext)));
const $54763063a77a852a$export$7925fbd6de082b5c = /*#__PURE__*/ (0, $42omo.createContext)((0, $fHHuS.defaultDynamicContext));
module.exports["BootstrapContextProvider"] = $54763063a77a852a$export$b676c7d6baea13e9;
module.exports["StaticBootstrapContext"] = $54763063a77a852a$export$dada99aabcba96f5;
module.exports["StaticBootstrapStoreContext"] = $54763063a77a852a$export$64067c351da2da1b;
module.exports["DynamicBootstrapContext"] = $54763063a77a852a$export$7925fbd6de082b5c;

});

parcelRegister("gSaNw", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");

const $6c891647ea736fd7$export$1a5e9086021cdce5 = ()=>{
    // This FG is used to force enable the context store code path for e2e testing purposes
    if ((0, $dh538.fg)('rovo-search-remove-rss-bootstrap-fg')) return true;
    return (0, $c6GJD.default).getExperimentValue('rovo-search-remove-rss-bootstrap-exp', 'cohort', 'control', {
        fireExperimentExposure: true
    }) === 'test';
};
module.exports["serveBootstrapProviderExp"] = $6c891647ea736fd7$export$1a5e9086021cdce5;

});

parcelRegister("fw303", function(module, exports) {
parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $dOOW1 = parcelRequire("dOOW1");


var $cxQs0 = parcelRequire("cxQs0");

const $28f6a41f8eb2075f$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Confluence
];
const $28f6a41f8eb2075f$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('archived');
const $28f6a41f8eb2075f$export$3dea766d36a8935f = (0, $cxQs0.createBooleanFilter)({
    id: 'archived',
    queryParams: {
        key: 'archived'
    },
    products: [
        ...$28f6a41f8eb2075f$var$productKeys1P,
        ...$28f6a41f8eb2075f$var$products3PFromConfig
    ],
    alwaysVisible: true,
    universal: false
});
module.exports["filter"] = $28f6a41f8eb2075f$export$3dea766d36a8935f;

});

parcelRegister("k7ise", function(module, exports) {
parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $cxQs0 = parcelRequire("cxQs0");

const $fd56dcb3e3750fa4$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Compass
];
const $fd56dcb3e3750fa4$export$3dea766d36a8935f = (0, $cxQs0.createBooleanFilter)({
    id: 'compassArchived',
    queryParams: {
        key: 'compassArchived'
    },
    products: $fd56dcb3e3750fa4$var$productKeys1P,
    alwaysVisible: true,
    universal: false
});
module.exports["filter"] = $fd56dcb3e3750fa4$export$3dea766d36a8935f;

});

parcelRegister("5X4Ay", function(module, exports) {

var $2CQZl = parcelRequire("2CQZl");


var $jwO5V = parcelRequire("jwO5V");


var $3paC4 = parcelRequire("3paC4");


var $iUYhn = parcelRequire("iUYhn");


var $i8MOh = parcelRequire("i8MOh");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $dOOW1 = parcelRequire("dOOW1");


var $6Ea6j = parcelRequire("6Ea6j");


var $ewGgp = parcelRequire("ewGgp");


var $4bHQd = parcelRequire("4bHQd");

const $d4c3bf3cbd6e1760$var$MAX_SEARCHED_OPTIONS_RESULTS = 5;
const $d4c3bf3cbd6e1760$var$loadInitialOptions = async (config)=>{
    if (config.product === (0, $b4tvS.ProductKeys).JiraDC || config.product === (0, $b4tvS.ProductKeys).JsmDC) return (0, $4bHQd.loadRecommendedUsers)(config);
    return $d4c3bf3cbd6e1760$var$searchJiraCloudAssignee('', config, {
        initialOptions: true
    });
};
const $d4c3bf3cbd6e1760$var$searchAssignee = async (query, config)=>{
    if (config.product === (0, $b4tvS.ProductKeys).JiraDC || config.product === (0, $b4tvS.ProductKeys).JsmDC) return $d4c3bf3cbd6e1760$var$searchAssignees3P(query, config);
    return $d4c3bf3cbd6e1760$var$searchJiraCloudAssignee(query, config);
};
const $d4c3bf3cbd6e1760$var$searchAssignees3P = async (query, config)=>{
    if (!config.intl) return []; // base on existing interface, can only query with intl
    const response = await (0, $2CQZl.getAssignees)({
        query: query,
        cloudId: config.cloudId || '',
        userId: config.userId || '',
        productKey: (0, $ewGgp.getUrsProductKey)(config.primaryProduct),
        maxNumberOfResults: $d4c3bf3cbd6e1760$var$MAX_SEARCHED_OPTIONS_RESULTS,
        intl: config.intl
    });
    if (!response) return [];
    return response.map((assignee)=>({
            trackingKey: assignee.id,
            value: assignee.id,
            label: assignee.name,
            avatarUrl: assignee.avatarUrl,
            queryParamValue: assignee.id,
            product: config.product
        }));
};
const $d4c3bf3cbd6e1760$var$searchJiraCloudAssignee = async (query, config, options)=>{
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const initialUsersQuery = config.userId && options?.initialOptions ? (0, $i8MOh.usersQuery)([
        config.userId
    ], headers) : Promise.resolve({
        data: {
            users: []
        }
    });
    const searchClient = (0, $3paC4.createClient)({
        cloudId: config.cloudId || ''
    });
    const searchAssigneeQuery = searchClient.search({
        query: query,
        resultLimit: 5,
        scopes: [
            (0, $iUYhn.Scope).People
        ],
        analytics: {
            identifier: 'search-page'
        }
    });
    const [initialUsersResponse, searchAssigneeReponse] = await Promise.all([
        initialUsersQuery,
        searchAssigneeQuery
    ]);
    const searchAssigneeResults = searchAssigneeReponse.response.rawData.scopes[0]?.results ?? [];
    const allAssignees = [
        // The current user is always first
        ...initialUsersResponse.data?.users.map((user)=>({
                ...user,
                id: user.accountId
            })) ?? [],
        ...searchAssigneeResults.map((user)=>({
                picture: user.avatarUrl,
                name: user.name,
                id: user.id,
                accountId: user.id
            }))
    ];
    const userIds = new Set();
    const assigneeOptions = allAssignees.filter((user)=>!userIds.has(user.accountId) && userIds.add(user.accountId)) // Remove duplicates
    .map((user)=>({
            trackingKey: user.id,
            value: user.id,
            label: user.name,
            avatarUrl: user.picture,
            queryParamValue: user.accountId,
            product: config.product
        }));
    return assigneeOptions;
};
const $d4c3bf3cbd6e1760$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Jira,
    (0, $b4tvS.ProductKeys).JiraProductDiscovery,
    (0, $b4tvS.ProductKeys).JiraServiceManagement
];
const $d4c3bf3cbd6e1760$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('assignee');
const $d4c3bf3cbd6e1760$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'assignee',
    products: [
        ...$d4c3bf3cbd6e1760$var$productKeys1P,
        ...$d4c3bf3cbd6e1760$var$products3PFromConfig
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'jAssignee',
        fetcher: async (queryParams, config)=>{
            const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const initialUsersResponse = await (0, $i8MOh.usersQuery)(queryParams, headers);
            const allAssignees = initialUsersResponse.data?.users ?? [];
            const userIds = new Set();
            const assigneeOptions = allAssignees.filter((user)=>!userIds.has(user.accountId) && userIds.add(user.accountId)) // Remove duplicates
            .map((user)=>({
                    trackingKey: user.accountId,
                    value: user.accountId,
                    label: user.name,
                    avatarUrl: user.picture,
                    queryParamValue: user.accountId,
                    product: config.product
                }));
            return assigneeOptions;
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $d4c3bf3cbd6e1760$var$loadInitialOptions(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            return $d4c3bf3cbd6e1760$var$searchAssignee(query, config);
        }
    },
    isSuggestedFilter: (primaryProduct)=>primaryProduct === (0, $b4tvS.ProductKeys).Jira || primaryProduct === (0, $b4tvS.ProductKeys).JiraDC || primaryProduct === (0, $b4tvS.ProductKeys).JsmDC || primaryProduct === (0, $b4tvS.ProductKeys).JiraServiceManagement || primaryProduct === (0, $b4tvS.ProductKeys).JiraProductDiscovery
});
module.exports["filter"] = $d4c3bf3cbd6e1760$export$3dea766d36a8935f;

});

parcelRegister("5VnRb", function(module, exports) {
parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $dOOW1 = parcelRequire("dOOW1");


var $6Ea6j = parcelRequire("6Ea6j");


var $2zk4m = parcelRequire("2zk4m");

const $f74bec2327788b4f$var$salesforceProducts = [
    (0, $b4tvS.ProductKeys).Salesforce
];
const $f74bec2327788b4f$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('campaignStatus');
const $f74bec2327788b4f$var$campaignStatusProducts = Array.from(new Set([
    ...$f74bec2327788b4f$var$salesforceProducts,
    ...$f74bec2327788b4f$var$products3PFromConfig
]));
const $f74bec2327788b4f$var$fetchDynamicCampaignStatusOptions = async (config)=>{
    const cloudId = config.cloudId;
    const datasourceId = config.selectedDatasource?.datasourceId;
    if (!cloudId || !datasourceId) return [];
    try {
        const result = await (0, $2zk4m.getCachedThirdPartyFilterOptions)(config);
        if (!result) return [];
        const campaignStatuses = result.filters.find((f)=>f.name === 'campaignStatuses');
        if (!campaignStatuses || campaignStatuses.values.length === 0) return [];
        return campaignStatuses.values.map((status)=>({
                value: status.name,
                trackingKey: status.name,
                queryParamValue: status.name,
                isDefault: false,
                label: status.label ?? status.name,
                product: config.product,
                isSelected: false,
                isSuggested: false
            }));
    } catch  {
        return [];
    }
};
const $f74bec2327788b4f$var$fetchQueryParams = async (queryParams, config)=>{
    const allOptions = await $f74bec2327788b4f$var$fetchDynamicCampaignStatusOptions(config);
    const selected = new Set(queryParams);
    return allOptions.filter((option)=>selected.has(option.queryParamValue));
};
const $f74bec2327788b4f$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'campaignStatus',
    requiresTopLevel3PDatasource: true,
    products: $f74bec2327788b4f$var$campaignStatusProducts,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'campaignStatuses',
        fetcher: async (queryParams, config)=>{
            return $f74bec2327788b4f$var$fetchQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $f74bec2327788b4f$var$fetchDynamicCampaignStatusOptions(config);
        }
    }
});
module.exports["filter"] = $f74bec2327788b4f$export$3dea766d36a8935f;

});

parcelRegister("F3Hv6", function(module, exports) {
parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $dOOW1 = parcelRequire("dOOW1");


var $6Ea6j = parcelRequire("6Ea6j");


var $2zk4m = parcelRequire("2zk4m");

const $67cd3a959b07a560$var$salesforceProducts = [
    (0, $b4tvS.ProductKeys).Salesforce
];
const $67cd3a959b07a560$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('caseStatus');
const $67cd3a959b07a560$var$caseStatusProducts = Array.from(new Set([
    ...$67cd3a959b07a560$var$salesforceProducts,
    ...$67cd3a959b07a560$var$products3PFromConfig
]));
const $67cd3a959b07a560$var$fetchDynamicCaseStatusOptions = async (config)=>{
    const cloudId = config.cloudId;
    const datasourceId = config.selectedDatasource?.datasourceId;
    if (!cloudId || !datasourceId) return [];
    try {
        const result = await (0, $2zk4m.getCachedThirdPartyFilterOptions)(config);
        if (!result) return [];
        const caseStatuses = result.filters.find((f)=>f.name === 'caseStatuses');
        if (!caseStatuses || caseStatuses.values.length === 0) return [];
        return caseStatuses.values.map((status)=>({
                value: status.name,
                trackingKey: status.name,
                queryParamValue: status.name,
                isDefault: false,
                label: status.label ?? status.name,
                product: config.product,
                isSelected: false,
                isSuggested: false
            }));
    } catch  {
        return [];
    }
};
const $67cd3a959b07a560$var$fetchCaseStatusOptions = async (config)=>{
    return $67cd3a959b07a560$var$fetchDynamicCaseStatusOptions(config);
};
const $67cd3a959b07a560$var$fetchQueryParams = async (queryParams, config)=>{
    const allOptions = await $67cd3a959b07a560$var$fetchCaseStatusOptions(config);
    const selected = new Set(queryParams);
    return allOptions.filter((option)=>selected.has(option.queryParamValue));
};
const $67cd3a959b07a560$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'caseStatus',
    requiresTopLevel3PDatasource: true,
    products: $67cd3a959b07a560$var$caseStatusProducts,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'caseStatuses',
        fetcher: async (queryParams, config)=>{
            return $67cd3a959b07a560$var$fetchQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $67cd3a959b07a560$var$fetchCaseStatusOptions(config);
        }
    }
});
module.exports["filter"] = $67cd3a959b07a560$export$3dea766d36a8935f;

});

parcelRegister("hHAPz", function(module, exports) {
parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $dOOW1 = parcelRequire("dOOW1");


var $7GRRM = parcelRequire("7GRRM");


var $aXWIB = parcelRequire("aXWIB");

const $d896105a0f4182b9$export$95ac8a541f7029bb = (0, $aXWIB.defineMessages)({
    anytime: {
        id: "search-page.filter.close.date.anytime",
        defaultMessage: "Anytime"
    },
    today: {
        id: "search-page.filter.close.date.today",
        defaultMessage: "Today"
    },
    last7days: {
        id: "search-page.filter.close.date.last7days",
        defaultMessage: "Last 7 days"
    },
    last30days: {
        id: "search-page.filter.close.date.last30days",
        defaultMessage: "Last 30 days"
    },
    last90days: {
        id: "search-page.filter.close.date.last90days",
        defaultMessage: "Last 90 days"
    },
    last365days: {
        id: "search-page.filter.close.date.last365days",
        defaultMessage: "Last 365 days"
    },
    next7days: {
        id: "search-page.filter.close.date.next7days",
        defaultMessage: "Next 7 days"
    },
    next30days: {
        id: "search-page.filter.close.date.next30days",
        defaultMessage: "Next 30 days"
    },
    next90days: {
        id: "search-page.filter.close.date.next90days",
        defaultMessage: "Next 90 days"
    },
    next365days: {
        id: "search-page.filter.close.date.next365days",
        defaultMessage: "Next 365 days"
    },
    custom: {
        id: "search-page.filter.close.date.custom",
        defaultMessage: "Specific date"
    }
});


const $bb10e4510dc43103$var$CLOSE_DATE_VALUES = [
    'anytime',
    'today',
    'last7days',
    'last30days',
    'last90days',
    'last365days',
    'next7days',
    'next30days',
    'next90days',
    'next365days',
    'custom'
];
const $bb10e4510dc43103$var$isIsoDate = (str)=>{
    if (!str) return false;
    if (!/\d{4}-\d{2}-\d{2}/.test(str)) return false;
    const d = new Date(str);
    return !isNaN(d.getTime());
};
const $bb10e4510dc43103$var$salesforceProducts = [
    (0, $b4tvS.ProductKeys).Salesforce
];
const $bb10e4510dc43103$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('closeDate');
const $bb10e4510dc43103$var$closeDateProducts = Array.from(new Set([
    ...$bb10e4510dc43103$var$salesforceProducts,
    ...$bb10e4510dc43103$var$products3PFromConfig
]));
const $bb10e4510dc43103$export$3dea766d36a8935f = (0, $7GRRM.createSingleWithCustomOptionSelectFilter)({
    id: 'closeDate',
    products: $bb10e4510dc43103$var$closeDateProducts,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'closeDate',
        fetcher: async (values, config)=>{
            return $bb10e4510dc43103$var$CLOSE_DATE_VALUES.filter((value)=>values.includes(value)).map((value)=>({
                    trackingKey: value,
                    label: config.intl?.formatMessage((0, $d896105a0f4182b9$export$95ac8a541f7029bb)[value]) || (0, $d896105a0f4182b9$export$95ac8a541f7029bb)[value].defaultMessage,
                    value: value,
                    queryParamValue: value,
                    product: config.product
                }));
        },
        customValueParser: (queryParams)=>{
            const { closeDateVal: closeDateVal } = queryParams;
            const isDateValid = $bb10e4510dc43103$var$isIsoDate(closeDateVal?.[0]);
            const dateVal = isDateValid && closeDateVal?.[0] ? closeDateVal[0] : '';
            if (dateVal) return {
                closeDateVal: dateVal
            };
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $bb10e4510dc43103$var$CLOSE_DATE_VALUES.map((value)=>({
                    trackingKey: value,
                    label: config.intl?.formatMessage((0, $d896105a0f4182b9$export$95ac8a541f7029bb)[value]) || (0, $d896105a0f4182b9$export$95ac8a541f7029bb)[value].defaultMessage,
                    value: value,
                    queryParamValue: value,
                    product: config.product
                }));
        }
    },
    customValueFields: [
        'closeDateVal'
    ]
});
module.exports["filter"] = $bb10e4510dc43103$export$3dea766d36a8935f;

});

parcelRegister("2a0ps", function(module, exports) {
parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $dOOW1 = parcelRequire("dOOW1");


var $cxQs0 = parcelRequire("cxQs0");

const $f26296303db33d56$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Jira,
    (0, $b4tvS.ProductKeys).JiraProductDiscovery,
    (0, $b4tvS.ProductKeys).JiraServiceManagement
];
const $f26296303db33d56$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('commentedByMe');
const $f26296303db33d56$export$3dea766d36a8935f = (0, $cxQs0.createBooleanFilter)({
    id: 'commentedByMe',
    queryParams: {
        key: 'jCommentedByMe'
    },
    products: [
        ...$f26296303db33d56$var$productKeys1P,
        ...$f26296303db33d56$var$products3PFromConfig
    ],
    alwaysVisible: true,
    universal: false
});
module.exports["filter"] = $f26296303db33d56$export$3dea766d36a8935f;

});

parcelRegister("dQXZO", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $jwO5V = parcelRequire("jwO5V");


var $jxvxe = parcelRequire("jxvxe");


var $i14PY = parcelRequire("i14PY");


var $johDC = parcelRequire("johDC");


var $1HJbl = parcelRequire("1HJbl");


var $1A1pg = parcelRequire("1A1pg");


var $2Znam = parcelRequire("2Znam");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $dOOW1 = parcelRequire("dOOW1");


var $cOUgi = parcelRequire("cOUgi");

const $5955e72d8edc423d$var$getContentId = (ari)=>{
    const EXTRACT_ID = /ari:.*?:.*?:.*?:.*?\/(.*)?.*/;
    const matches = ari.match(EXTRACT_ID);
    // content id of the ari
    return matches && matches.length > 1 ? matches[1] : '';
};
const $5955e72d8edc423d$var$searchContent = async (query, config)=>{
    const location = `ari:cloud:confluence::site/${config.cloudId}`;
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const product = config.product;
    const selectedSpaceAris = $5955e72d8edc423d$var$getSelectedSpaceAris(config);
    if ($5955e72d8edc423d$var$isThirdPartyProductWithContentUnder(product)) {
        const selectedSpaceAri = selectedSpaceAris[0];
        const datasource = config.selectedDatasource ?? config.thirdPartyConfigs?.[product];
        if (!datasource?.integrationAri) return [];
        const spaceFilter = selectedSpaceAri ? {
            ancestorAris: [
                selectedSpaceAri
            ]
        } : {};
        const contributorAccountIds = (0, $dh538.fg)('rovo_fps_scope_3p_typeahead_by_contributor') ? $5955e72d8edc423d$var$getSelectedContributorAccountIds(config) : [];
        const commonFilters = contributorAccountIds.length > 0 ? {
            contributorsFilter: contributorAccountIds
        } : undefined;
        const response = await (0, $i14PY.searchEntitiesQuery)({
            aggAbsoluteUrl: config.aggAbsoluteUrl,
            variables: {
                query: query,
                first: 10,
                experience: 'search-page',
                filters: {
                    entities: (0, $1A1pg.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    locations: [
                        location
                    ],
                    ...commonFilters && {
                        commonFilters: commonFilters
                    },
                    thirdPartyFilters: {
                        titleMatchOnly: true,
                        ...spaceFilter,
                        thirdPartyProducts: [
                            {
                                product: product,
                                integrationId: datasource.integrationAri,
                                subtypes: $5955e72d8edc423d$var$getThirdPartyContentUnderSubtypes(product)
                            }
                        ]
                    }
                }
            },
            headers: headers,
            includeContainerId: true
        });
        const results = response.data?.search?.results.edges.map((content)=>{
            // Access entity.containerId for cross-filter validation (folder belongs to which drive/space)
            const containerId = content.node.entity?.containerId;
            const option = {
                trackingKey: content.node.id,
                value: content.node.id,
                label: content.node.title,
                queryParamValue: content.node.id,
                product: config.product,
                ...containerId && {
                    metadata: {
                        containerARI: containerId
                    }
                }
            };
            return option;
        }) || [];
        return results;
    }
    let contentPagesResponse;
    if (product === (0, $b4tvS.ProductKeys).ConfluenceDC) {
        contentPagesResponse = await (0, $johDC.confluenceDcContentFilterOptionsQuery)({
            variables: {
                query: query,
                cloudIdARI: location,
                limit: 10,
                entities: [
                    'ati:cloud:graph:document'
                ],
                product: product
            },
            aggAbsoluteUrl: config.aggAbsoluteUrl,
            headers: headers
        });
        return contentPagesResponse.data?.search?.search?.edges.map((content)=>({
                trackingKey: content.node.id,
                value: content.node.id,
                label: (0, $1HJbl.cleanExcerpt)(content.node.title),
                queryParamValue: content.node.id,
                product: config.product
            })) || [];
    }
    contentPagesResponse = await (0, $i14PY.searchEntitiesQuery)({
        aggAbsoluteUrl: config.aggAbsoluteUrl,
        variables: {
            query: query,
            first: 10,
            filters: {
                entities: [
                    'ati:cloud:confluence:page'
                ],
                locations: [
                    location
                ]
            }
        },
        headers: headers
    });
    const allContentPages = contentPagesResponse.data?.search?.results.edges.map((content)=>({
            title: content.node.title,
            id: content.node.id
        })) || [];
    const contentOptions = allContentPages.map((content)=>{
        const contentId = $5955e72d8edc423d$var$getContentId(content.id);
        return {
            trackingKey: contentId,
            value: contentId,
            label: content.title,
            queryParamValue: contentId,
            product: config.product
        };
    });
    return contentOptions;
};
const $5955e72d8edc423d$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Confluence
];
const $5955e72d8edc423d$var$getProducts3PFromConfig = ()=>(0, $dOOW1.getProducts3PFromConfigForFilter)('content');
const $5955e72d8edc423d$var$getFilterProducts = ()=>[
        ...$5955e72d8edc423d$var$productKeys1P,
        ...$5955e72d8edc423d$var$getProducts3PFromConfig()
    ];
const $5955e72d8edc423d$var$THIRD_PARTY_CONTENT_UNDER_SUBTYPES = {
    [(0, $b4tvS.ProductKeys).GoogleDrive]: [
        (0, $2Znam.NounSubtypeKey).Folder
    ],
    [(0, $b4tvS.ProductKeys).Sharepoint]: [
        (0, $2Znam.NounSubtypeKey).Drive,
        (0, $2Znam.NounSubtypeKey).Folder
    ]
};
const $5955e72d8edc423d$var$isThirdPartyProductWithContentUnder = (product)=>!!product && product in $5955e72d8edc423d$var$THIRD_PARTY_CONTENT_UNDER_SUBTYPES && $5955e72d8edc423d$var$getProducts3PFromConfig().includes(product);
const $5955e72d8edc423d$var$getThirdPartyContentUnderSubtypes = (product)=>$5955e72d8edc423d$var$THIRD_PARTY_CONTENT_UNDER_SUBTYPES[product] ?? [];
const $5955e72d8edc423d$var$getSelectedSpaceAris = (config)=>Array.isArray(config.initialSpaceARIs) ? config.initialSpaceARIs.filter(Boolean) : [];
const $5955e72d8edc423d$var$getSelectedContributorAccountIds = (config)=>Array.isArray(config.contributorAccountIds) ? config.contributorAccountIds.filter(Boolean) : [];
const $5955e72d8edc423d$var$withCurrentProducts = (state)=>({
        ...state,
        products: $5955e72d8edc423d$var$getFilterProducts()
    });
const $5955e72d8edc423d$var$withCurrentProductsFilter = (filter)=>({
        ...filter,
        getState: ()=>$5955e72d8edc423d$var$withCurrentProducts(filter.getState()),
        queryParams: {
            ...filter.queryParams,
            set: async (queryParams, onStateChange)=>$5955e72d8edc423d$var$withCurrentProductsFilter(await filter.queryParams.set(queryParams, onStateChange && ((state)=>onStateChange($5955e72d8edc423d$var$withCurrentProducts(state)))))
        },
        loadInitialOptions: async (onStateChange)=>$5955e72d8edc423d$var$withCurrentProductsFilter(await filter.loadInitialOptions(onStateChange && ((state)=>onStateChange($5955e72d8edc423d$var$withCurrentProducts(state))))),
        setOption: (option, customValue)=>$5955e72d8edc423d$var$withCurrentProductsFilter(filter.setOption(option, customValue)),
        clearOptions: ()=>$5955e72d8edc423d$var$withCurrentProductsFilter(filter.clearOptions()),
        setLookupInput: async (query, onStateChange)=>$5955e72d8edc423d$var$withCurrentProductsFilter(await filter.setLookupInput(query, onStateChange && ((state)=>onStateChange($5955e72d8edc423d$var$withCurrentProducts(state))))),
        clear: ()=>$5955e72d8edc423d$var$withCurrentProductsFilter(filter.clear())
    });
const $5955e72d8edc423d$var$baseFilter = (0, $cOUgi.createSingleSelectFilter)({
    id: 'content',
    products: $5955e72d8edc423d$var$getFilterProducts(),
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'ancestor',
        fetcher: async (queryParams, config)=>{
            const product = config.product;
            const location = `ari:cloud:confluence::site/${config.cloudId}`;
            const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            if ($5955e72d8edc423d$var$isThirdPartyProductWithContentUnder(product)) {
                const contentResponse = await (0, $johDC.documentARIEntitiesQuery)({
                    variables: {
                        ids: queryParams
                    },
                    aggAbsoluteUrl: config.aggAbsoluteUrl,
                    headers: headers
                });
                return contentResponse.data?.external_entities?.document?.map((content)=>({
                        trackingKey: content.id,
                        value: content.id,
                        label: content.displayName,
                        queryParamValue: content.id,
                        product: config.product,
                        ...content.container?.id && {
                            metadata: {
                                containerARI: content.container.id
                            }
                        }
                    })) || [];
            }
            if (product === (0, $b4tvS.ProductKeys).ConfluenceDC) {
                const contentPagesResponse = await (0, $johDC.confluenceDcPagesQuery)({
                    variables: {
                        query: '',
                        cloudIdARI: location,
                        limit: 10,
                        entities: [
                            'ati:cloud:graph:document'
                        ],
                        product: product,
                        ancestorIds: queryParams
                    },
                    aggAbsoluteUrl: config.aggAbsoluteUrl,
                    headers: headers
                });
                return contentPagesResponse.data?.external_entities?.document?.map((content)=>({
                        trackingKey: content.id,
                        value: content.id,
                        label: content.displayName,
                        queryParamValue: content.id,
                        product: config.product
                    })) || [];
            }
            const initialContentARIs = queryParams.map((contentId)=>`ari:cloud:confluence:${config.cloudId}:page/${contentId}`);
            const initialContentResponse = await (0, $jxvxe.confluencePagesQuery)(initialContentARIs, headers);
            const allContentPages = initialContentResponse.data?.confluence.pages.map((page)=>({
                    title: page.title,
                    id: page.id
                })) || [];
            const contentOptions = allContentPages.map((content)=>{
                const contentId = $5955e72d8edc423d$var$getContentId(content.id);
                return {
                    trackingKey: contentId,
                    value: contentId,
                    label: content.title,
                    queryParamValue: contentId,
                    product: config.product
                };
            });
            return contentOptions;
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $5955e72d8edc423d$var$searchContent('', config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            return $5955e72d8edc423d$var$searchContent(query, config);
        }
    }
});
const $5955e72d8edc423d$export$3dea766d36a8935f = {
    ...$5955e72d8edc423d$var$baseFilter,
    queryParams: {
        ...$5955e72d8edc423d$var$baseFilter.queryParams,
        getState: (queryParams, cloudId)=>$5955e72d8edc423d$var$withCurrentProducts($5955e72d8edc423d$var$baseFilter.queryParams.getState(queryParams, cloudId))
    },
    get products () {
        return $5955e72d8edc423d$var$getFilterProducts();
    },
    withState: (state, config)=>$5955e72d8edc423d$var$withCurrentProductsFilter($5955e72d8edc423d$var$baseFilter.withState({
            ...state,
            products: $5955e72d8edc423d$var$getFilterProducts()
        }, config)),
    getInitialState: (config)=>$5955e72d8edc423d$var$withCurrentProductsFilter($5955e72d8edc423d$var$baseFilter.getInitialState(config))
};
module.exports["filter"] = $5955e72d8edc423d$export$3dea766d36a8935f;

});

parcelRegister("c5dmm", function(module, exports) {

var $jwO5V = parcelRequire("jwO5V");


var $lEZ2M = parcelRequire("lEZ2M");


var $i8MOh = parcelRequire("i8MOh");


var $dOOW1 = parcelRequire("dOOW1");


var $6Ea6j = parcelRequire("6Ea6j");


var $ewGgp = parcelRequire("ewGgp");


var $4bHQd = parcelRequire("4bHQd");

const $8bdf2fa783a54336$var$MAX_SEARCHED_OPTIONS_RESULTS = 5;
const $8bdf2fa783a54336$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('createdBy');
const $8bdf2fa783a54336$var$loadInitialOptions = async (config)=>{
    return (0, $4bHQd.loadRecommendedUsers)(config);
};
const $8bdf2fa783a54336$var$searchCreatedBy = async (query, config)=>{
    if (!config.intl) return []; // base on existing interface, can only query with intl
    const response = await (0, $lEZ2M.getCreatedBy)({
        query: query,
        cloudId: config.cloudId || '',
        userId: config.userId || '',
        productKey: (0, $ewGgp.getUrsProductKey)(config.primaryProduct),
        maxNumberOfResults: $8bdf2fa783a54336$var$MAX_SEARCHED_OPTIONS_RESULTS,
        intl: config.intl
    });
    if (!response) return [];
    return response.map((user)=>({
            trackingKey: user.id,
            value: user.id,
            label: user.name,
            avatarUrl: user.avatarUrl,
            queryParamValue: user.id,
            product: config.product
        }));
};
const $8bdf2fa783a54336$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'createdBy',
    products: [
        ...$8bdf2fa783a54336$var$products3PFromConfig
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'createdBy',
        fetcher: async (queryParams, config)=>{
            const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const initialUsersResponse = await (0, $i8MOh.usersQuery)(queryParams, headers);
            const allCreatedBy = initialUsersResponse.data?.users ?? [];
            const userIds = new Set();
            const createdByOptions = allCreatedBy.filter((user)=>!userIds.has(user.accountId) && userIds.add(user.accountId)) // Remove duplicates
            .map((user)=>({
                    trackingKey: user.accountId,
                    value: user.accountId,
                    label: user.name,
                    avatarUrl: user.picture,
                    queryParamValue: user.accountId,
                    product: config.product
                }));
            return createdByOptions;
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $8bdf2fa783a54336$var$loadInitialOptions(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            return $8bdf2fa783a54336$var$searchCreatedBy(query, config);
        }
    }
});
module.exports["filter"] = $8bdf2fa783a54336$export$3dea766d36a8935f;

});

parcelRegister("6jSbc", function(module, exports) {

var $jwO5V = parcelRequire("jwO5V");


var $4yWWa = parcelRequire("4yWWa");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $6Ea6j = parcelRequire("6Ea6j");

/**
 * Queries all focus area types from graphQL and returns all options as suggested but unselected
 * @param config
 * @returns
 */ const $9bc69c6e351ac6c8$var$getInitialOptions = async (config)=>{
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const focusAreaTypesResponse = await (0, $4yWWa.mercuryFocusAreaTypesQuery)(config.cloudId || '', headers);
    const focusAreaTypes = focusAreaTypesResponse.data?.mercury.focusAreaTypes ?? [];
    return focusAreaTypes.map((focusAreaType)=>({
            trackingKey: focusAreaType.id,
            label: focusAreaType.name,
            value: focusAreaType.id,
            queryParamValue: focusAreaType.id,
            product: config.product
        }));
};
/**
 * Queries all focus area types from graphQL and returns all options as suggested and query params are suggested
 * @param queryParams
 * @param config
 * @returns
 */ const $9bc69c6e351ac6c8$var$getOptionsWithSelectionsFromQueryParams = async (queryParams, config)=>{
    const focusAreaTypeOptions = await $9bc69c6e351ac6c8$var$getInitialOptions(config);
    return focusAreaTypeOptions.filter((option)=>queryParams.includes(option.value));
};
/**
 * Queries all focus area types from graphQL and filters out options that do not match the text query
 * @param query
 * @param config
 * @returns
 */ const $9bc69c6e351ac6c8$var$getOptionsFilteredByTextQuery = async (query, config)=>{
    const focusAreaTypeOptions = await $9bc69c6e351ac6c8$var$getInitialOptions(config);
    return focusAreaTypeOptions.filter((option)=>option.label.toLowerCase().includes(query.toLowerCase()));
};
const $9bc69c6e351ac6c8$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Focus
];
const $9bc69c6e351ac6c8$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'focusAreaType',
    products: $9bc69c6e351ac6c8$var$productKeys1P,
    alwaysVisible: true,
    universal: false,
    queryParams: {
        key: 'focusAreaTypes',
        fetcher: $9bc69c6e351ac6c8$var$getOptionsWithSelectionsFromQueryParams
    },
    initialOptions: {
        fetcher: $9bc69c6e351ac6c8$var$getInitialOptions
    },
    lookup: {
        fetcher: $9bc69c6e351ac6c8$var$getOptionsFilteredByTextQuery
    }
});
module.exports["filter"] = $9bc69c6e351ac6c8$export$3dea766d36a8935f;

});

parcelRegister("e7L4o", function(module, exports) {

var $jwO5V = parcelRequire("jwO5V");


var $d95gt = parcelRequire("d95gt");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $6Ea6j = parcelRequire("6Ea6j");

// Number of results returned in dropdown
const $617022314357c679$var$FOCUS_AREA_RESULTS_LIMIT = 20;
const $617022314357c679$var$mapFocusAreaResult = (focusArea, product)=>{
    return {
        trackingKey: focusArea.node?.uuid || '',
        label: focusArea.node?.name || '',
        value: focusArea.node?.uuid || '',
        queryParamValue: focusArea.node?.uuid || '',
        metadata: {
            type: focusArea.node?.focusAreaType.name,
            owner: focusArea.node?.owner?.name,
            status: focusArea.node?.status?.key,
            health: focusArea.node?.health?.key
        },
        product: product
    };
};
/**
 * Queries focus areas by search term
 * @param query
 * @param config
 * @returns
 */ const $617022314357c679$var$searchFocusAreas = async (query, config)=>{
    const mqlQuery = `(search LIKE '${query}')`;
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const focusAreasResponse = await (0, $d95gt.mercuryFocusAreasQuery)(config.cloudId || '', mqlQuery, $617022314357c679$var$FOCUS_AREA_RESULTS_LIMIT, undefined, headers);
    const focusAreas = focusAreasResponse.data?.mercury.focusAreas.edges ?? [];
    return focusAreas.map((focusArea)=>$617022314357c679$var$mapFocusAreaResult(focusArea, config.product));
};
/**
 * Queries all selected focus areas by id from query params
 * @param queryParams
 * @param config
 * @returns
 */ const $617022314357c679$var$getOptionsWithSelectionsFromQueryParams = async (queryParams, config)=>{
    const mqlQuery = `(${queryParams.map((id)=>`id = '${id}'`).join(' OR ')})`;
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const focusAreasResponse = await (0, $d95gt.mercuryFocusAreasQuery)(config.cloudId || '', mqlQuery, $617022314357c679$var$FOCUS_AREA_RESULTS_LIMIT, undefined, headers);
    const focusAreas = focusAreasResponse.data?.mercury.focusAreas.edges ?? [];
    return focusAreas.map((focusArea)=>$617022314357c679$var$mapFocusAreaResult(focusArea, config.product));
};
const $617022314357c679$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Focus
];
const $617022314357c679$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'focusAreaUnder',
    products: $617022314357c679$var$productKeys1P,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'focusAreaUnder',
        fetcher: $617022314357c679$var$getOptionsWithSelectionsFromQueryParams
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $617022314357c679$var$searchFocusAreas('', config);
        }
    },
    lookup: {
        fetcher: $617022314357c679$var$searchFocusAreas
    }
});
module.exports["filter"] = $617022314357c679$export$3dea766d36a8935f;

});

parcelRegister("9HRbP", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $jwO5V = parcelRequire("jwO5V");


var $4qT1X = parcelRequire("4qT1X");

const $9dc0174ba173d870$var$LOOM_FOLDERS_SEARCH_OPERATION_NAME = 'LoomRovoFoldersSearchQuery';
const $9dc0174ba173d870$var$loomFoldersSearchGraphQuery = `
	query ${$9dc0174ba173d870$var$LOOM_FOLDERS_SEARCH_OPERATION_NAME}(
		$siteId: ID!
		$query: String
		$spaceId: ID
		$includeDefaultFolders: Boolean
	) {
		loom_foldersSearch(
			siteId: $siteId
			query: $query
			spaceId: $spaceId
			includeDefaultFolders: $includeDefaultFolders
		) {
			id
			name
			parentSpaceId
		}
	}
`;
const $9dc0174ba173d870$var$trimToLimit = (result, limit)=>typeof limit === 'number' ? {
        ...result,
        data: result.data ? {
            ...result.data,
            loom_foldersSearch: result.data.loom_foldersSearch.slice(0, limit)
        } : result.data
    } : result;
const $9dc0174ba173d870$export$4be1bdb8e3aa7332 = async ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    // `limit` is not sent to AGG: `loom_foldersSearch` has no limit variable in the GraphQL schema,
    // so we request the full result set and cap length client-side in `trimToLimit` below.
    const { siteId: siteId, query: query, spaceId: spaceId, includeDefaultFolders: includeDefaultFolders, limit: limit } = variables;
    const response = await (0, $4qT1X.fetchAgg)({
        variables: {
            siteId: siteId,
            query: query,
            spaceId: spaceId,
            includeDefaultFolders: includeDefaultFolders
        },
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: $9dc0174ba173d870$var$loomFoldersSearchGraphQuery,
        operationName: $9dc0174ba173d870$var$LOOM_FOLDERS_SEARCH_OPERATION_NAME,
        headers: headers
    });
    return $9dc0174ba173d870$var$trimToLimit(response, limit);
};



var $1HJbl = parcelRequire("1HJbl");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $6Ea6j = parcelRequire("6Ea6j");

const $68763af150869b1d$var$DEFAULT_LOOM_FOLDER_INITIAL_LIMIT = 15;
const $68763af150869b1d$var$DEFAULT_LOOM_FOLDER_LOOKUP_LIMIT = 15;
/** Max concurrent AGG `loom_foldersSearch` calls (1 default + N per selected space share this pool). */ const $68763af150869b1d$var$LOOM_FOLDER_AGG_CONCURRENCY = 5;
async function $68763af150869b1d$var$runWithConcurrencyLimit(tasks, concurrency) {
    if (tasks.length === 0) return [];
    const safeConcurrency = Math.max(1, Math.floor(concurrency));
    const results = new Array(tasks.length);
    let nextIndex = 0;
    const worker = async ()=>{
        for(;;){
            const index = nextIndex++;
            if (index >= tasks.length) return;
            const [outcome] = await Promise.allSettled([
                tasks[index]()
            ]);
            results[index] = outcome.status === 'fulfilled' ? outcome.value : undefined;
        }
    };
    const workerCount = Math.min(safeConcurrency, tasks.length);
    await Promise.allSettled(Array.from({
        length: workerCount
    }, ()=>worker()));
    return results;
}
const $68763af150869b1d$var$isLoomFolderProduct = (product)=>product === (0, $b4tvS.ProductKeys).Loom && (0, $dh538.fg)('loom-rovo-search');
const $68763af150869b1d$var$getSelectedSpaceAris = (config)=>Array.isArray(config.initialSpaceARIs) ? config.initialSpaceARIs.filter(Boolean) : [];
const $68763af150869b1d$var$mapFolderNodeToOption = (folder)=>({
        trackingKey: folder.id,
        value: folder.id,
        label: (0, $1HJbl.cleanExcerpt)(folder.name),
        queryParamValue: folder.id,
        product: (0, $b4tvS.ProductKeys).Loom,
        isDefault: false,
        isSelected: false,
        isSuggested: true,
        ...folder.parentSpaceId ? {
            metadata: {
                parentSpaceId: folder.parentSpaceId
            }
        } : {}
    });
async function $68763af150869b1d$var$fetchLoomFolderOptions(config, { query: query = '', limit: limit = $68763af150869b1d$var$DEFAULT_LOOM_FOLDER_INITIAL_LIMIT } = {}) {
    if (!$68763af150869b1d$var$isLoomFolderProduct(config.product)) return [];
    const cloudId = config.cloudId;
    if (!cloudId) return [];
    const spaceAris = $68763af150869b1d$var$getSelectedSpaceAris(config);
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const queryVariables = {
        siteId: cloudId,
        query: query || undefined,
        limit: limit
    };
    // Workspace / personal default folders (Personal Library, Archived, …) require no spaceId.
    // Run all folder fetches with bounded concurrency so many selected Loom spaces do not fan out
    // unbounded parallel AGG calls (see `LOOM_FOLDER_AGG_CONCURRENCY`).
    const folderFetchTasks = [
        ()=>(0, $9dc0174ba173d870$export$4be1bdb8e3aa7332)({
                variables: {
                    ...queryVariables,
                    includeDefaultFolders: true
                },
                aggAbsoluteUrl: config.aggAbsoluteUrl,
                headers: headers
            }),
        ...spaceAris.map((spaceId)=>()=>(0, $9dc0174ba173d870$export$4be1bdb8e3aa7332)({
                    variables: {
                        ...queryVariables,
                        spaceId: spaceId,
                        includeDefaultFolders: false
                    },
                    aggAbsoluteUrl: config.aggAbsoluteUrl,
                    headers: headers
                }))
    ];
    const responses = await $68763af150869b1d$var$runWithConcurrencyLimit(folderFetchTasks, $68763af150869b1d$var$LOOM_FOLDER_AGG_CONCURRENCY);
    const seenFolderIds = new Set();
    const folderOptions = [];
    for (const response of responses){
        if (response === undefined) continue;
        for (const folder of response.data?.loom_foldersSearch ?? []){
            if (seenFolderIds.has(folder.id)) continue;
            seenFolderIds.add(folder.id);
            folderOptions.push($68763af150869b1d$var$mapFolderNodeToOption(folder));
        }
    }
    return folderOptions;
}
const $68763af150869b1d$var$getInitialOptions = async (config)=>$68763af150869b1d$var$fetchLoomFolderOptions(config, {
        query: '',
        limit: $68763af150869b1d$var$DEFAULT_LOOM_FOLDER_INITIAL_LIMIT
    });
const $68763af150869b1d$var$fetchLookupOptions = async (input, config)=>{
    if (!$68763af150869b1d$var$isLoomFolderProduct(config.product)) return [];
    return $68763af150869b1d$var$fetchLoomFolderOptions(config, {
        query: input,
        limit: $68763af150869b1d$var$DEFAULT_LOOM_FOLDER_LOOKUP_LIMIT
    });
};
const $68763af150869b1d$var$getFilterProducts = ()=>(0, $dh538.fg)('loom-rovo-search') ? [
        (0, $b4tvS.ProductKeys).Loom
    ] : [];
const $68763af150869b1d$var$baseFilter = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'folder',
    products: $68763af150869b1d$var$getFilterProducts(),
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'folders'
    },
    initialOptions: {
        fetcher: $68763af150869b1d$var$getInitialOptions
    },
    lookup: {
        fetcher: $68763af150869b1d$var$fetchLookupOptions
    }
});
const $68763af150869b1d$var$canFetchLoomFoldersForConfig = (config)=>$68763af150869b1d$var$isLoomFolderProduct(config.product) && Boolean(config.cloudId);
const $68763af150869b1d$var$withLoomFolderScopedLoading = (monad, config)=>({
        ...monad,
        loadInitialOptions: async (onStateChange)=>{
            if (!$68763af150869b1d$var$canFetchLoomFoldersForConfig(config)) return monad;
            return monad.loadInitialOptions(onStateChange);
        },
        setLookupInput: async (query, onStateChange)=>{
            if (!$68763af150869b1d$var$canFetchLoomFoldersForConfig(config)) return monad;
            return monad.setLookupInput(query, onStateChange);
        }
    });
const $68763af150869b1d$export$3dea766d36a8935f = {
    ...$68763af150869b1d$var$baseFilter,
    withState: (state, config)=>$68763af150869b1d$var$withLoomFolderScopedLoading($68763af150869b1d$var$baseFilter.withState(state, config), config),
    getInitialState: (config)=>$68763af150869b1d$var$withLoomFolderScopedLoading($68763af150869b1d$var$baseFilter.getInitialState(config), config),
    get products () {
        return $68763af150869b1d$var$getFilterProducts();
    }
};
module.exports["filter"] = $68763af150869b1d$export$3dea766d36a8935f;

});

parcelRegister("lPWNq", function(module, exports) {

var $dOOW1 = parcelRequire("dOOW1");


var $cxQs0 = parcelRequire("cxQs0");

const $0b6fdb4a13c32907$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('hasAttachment');
const $0b6fdb4a13c32907$export$3dea766d36a8935f = (0, $cxQs0.createBooleanFilter)({
    id: 'hasAttachment',
    queryParams: {
        key: 'hasAttachment'
    },
    products: [
        ...$0b6fdb4a13c32907$var$products3PFromConfig
    ],
    alwaysVisible: true,
    universal: false
});
module.exports["filter"] = $0b6fdb4a13c32907$export$3dea766d36a8935f;

});

parcelRegister("gwbWt", function(module, exports) {

var $b4tvS = parcelRequire("b4tvS");
parcelRequire("1yEFx");



var $22zVp = parcelRequire("22zVp");


var $6Ea6j = parcelRequire("6Ea6j");


var $jwO5V = parcelRequire("jwO5V");


var $1tvnk = parcelRequire("1tvnk");

parcelRequire("1yEFx");


const $1023844455dd110c$export$1825bdcb0c5952b8 = async (query, config)=>{
    if (!config.intl || config.cloudId === undefined) // base on existing interface, can only query contributors with intl
    return [];
    const product = config.product;
    if (product === (0, $b4tvS.ProductKeys).ConfluenceDC) return [
        {
            trackingKey: query,
            value: query,
            label: query,
            queryParamValue: query,
            product: config.product
        }
    ];
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const initialLabelsResponse = await (0, $1tvnk.confluenceLabelsQuery)(config.cloudId, query, 10, headers);
    const suggestedLabels = initialLabelsResponse.data?.confluence.searchLabels.suggestedLabels || [];
    const otherLabels = initialLabelsResponse.data?.confluence.searchLabels.otherLabels || [];
    return [
        ...suggestedLabels,
        ...otherLabels
    ].map((label)=>({
            trackingKey: label.label || '',
            value: label.label || '',
            queryParamValue: label.label || '',
            label: label.label || '',
            product: config.product
        })) ?? [];
};
const $1023844455dd110c$export$ae59602b611675bf = async (queryParams)=>{
    return queryParams.map((label)=>({
            trackingKey: label,
            value: label,
            queryParamValue: label,
            label: label
        }));
};



var $7uR1u = parcelRequire("7uR1u");

const $552374ecba257bba$export$218f28c8d8799e97 = async (config)=>{
    if (!window) return []; // SSR Safety
    const hostname = window.location.origin;
    const response = await (0, $7uR1u.getSuggestedJiraLabels)({
        absoluteUrl: hostname
    });
    return response.suggestions.map((suggestion)=>({
            trackingKey: suggestion.label,
            value: suggestion.label,
            queryParamValue: suggestion.label,
            isDefault: false,
            label: suggestion.label,
            isSelected: false,
            isSuggested: true,
            product: config.product
        }));
};
const $552374ecba257bba$export$9a3d32e397d14cdf = async (query, config)=>{
    if (!window) return []; // SSR Safety
    const hostname = window.location.origin;
    const response = await (0, $7uR1u.getSuggestedJiraLabels)({
        query: query,
        absoluteUrl: hostname
    });
    return response.suggestions.map((suggestion)=>({
            trackingKey: suggestion.label,
            value: suggestion.label,
            queryParamValue: suggestion.label,
            isDefault: false,
            label: suggestion.label,
            isSelected: false,
            isSuggested: false,
            product: config.product
        }));
};
const $552374ecba257bba$export$eea6e8b7edaba18f = async (queryParams, config)=>{
    const options = queryParams.map((queryParam)=>({
            trackingKey: queryParam,
            value: queryParam,
            queryParamValue: queryParam,
            isDefault: false,
            label: queryParam,
            isSelected: true,
            isSuggested: false,
            product: config.product
        }));
    return options;
};


const $08baf0c4c2bfd1f5$var$getProducts1P = ()=>{
    return [
        (0, $b4tvS.ProductKeys).Confluence,
        (0, $b4tvS.ProductKeys).Jira,
        (0, $b4tvS.ProductKeys).JiraProductDiscovery,
        (0, $b4tvS.ProductKeys).JiraServiceManagement
    ];
};
const $08baf0c4c2bfd1f5$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'label',
    products: [
        ...$08baf0c4c2bfd1f5$var$getProducts1P()
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'labels',
        fetcher: async (queryParams, config)=>{
            if (config.product === (0, $b4tvS.ProductKeys).Confluence || config.product === (0, $b4tvS.ProductKeys).ConfluenceDC || config.primaryProduct === (0, $b4tvS.ProductKeys).Confluence) return (0, $1023844455dd110c$export$ae59602b611675bf)(queryParams, config);
            const safePrimaryProduct = (0, $b4tvS.isProductKey)(config.primaryProduct) ? config.primaryProduct : undefined;
            if ((0, $22zVp.isJiraProduct)(config.product) || (0, $22zVp.isJiraProduct)(safePrimaryProduct)) return (0, $552374ecba257bba$export$eea6e8b7edaba18f)(queryParams, config);
            // Not supported in other products
            return [];
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            const safePrimaryProduct = (0, $b4tvS.isProductKey)(config.primaryProduct) ? config.primaryProduct : undefined;
            if ((0, $22zVp.isJiraProduct)(config.product) || (0, $22zVp.isJiraProduct)(safePrimaryProduct)) return (0, $552374ecba257bba$export$218f28c8d8799e97)(config);
            return [];
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            if (config.product === (0, $b4tvS.ProductKeys).Confluence || config.product === (0, $b4tvS.ProductKeys).ConfluenceDC || config.primaryProduct === (0, $b4tvS.ProductKeys).Confluence) return (0, $1023844455dd110c$export$1825bdcb0c5952b8)(query, config);
            const safePrimaryProduct = (0, $b4tvS.isProductKey)(config.primaryProduct) ? config.primaryProduct : undefined;
            if ((0, $22zVp.isJiraProduct)(config.product) || (0, $22zVp.isJiraProduct)(safePrimaryProduct)) return (0, $552374ecba257bba$export$9a3d32e397d14cdf)(query, config);
            return [];
        }
    }
});
module.exports["filter"] = $08baf0c4c2bfd1f5$export$3dea766d36a8935f;

});

parcelRegister("1uGSo", function(module, exports) {
parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $fKv9F = parcelRequire("fKv9F");


var $dOOW1 = parcelRequire("dOOW1");


var $7GRRM = parcelRequire("7GRRM");


var $aXWIB = parcelRequire("aXWIB");

const $a33c6cc099d6cfe5$export$3f164da8f895a853 = (0, $aXWIB.defineMessages)({
    anytime: {
        id: "search-page.filter.last.updated.anytime",
        defaultMessage: "Anytime"
    },
    today: {
        id: "search-page.filter.last.updated.today",
        defaultMessage: "Today"
    },
    yesterday: {
        id: "search-page.filter.last.updated.yesterday",
        defaultMessage: "Yesterday"
    },
    past7Days: {
        id: "search-page.filter.last.updated.past7Days",
        defaultMessage: "Past 7 days"
    },
    past30Days: {
        id: "search-page.filter.last.updated.past30Days",
        defaultMessage: "Past 30 days"
    },
    pastYear: {
        id: "search-page.filter.last.updated.pastYear",
        defaultMessage: "Past year"
    },
    custom: {
        id: "search-page.filter.last.updated.custom",
        defaultMessage: "Custom"
    }
});



var $ILLS9 = parcelRequire("ILLS9");

const $c804900efc0ed3cd$var$LAST_UPDATED_VALUES = [
    'today',
    'yesterday',
    'past7Days',
    'past30Days',
    'pastYear',
    'custom'
];
const $c804900efc0ed3cd$var$sortCompareFn = (a, b)=>{
    return $c804900efc0ed3cd$var$LAST_UPDATED_VALUES.indexOf(a.value) - $c804900efc0ed3cd$var$LAST_UPDATED_VALUES.indexOf(b.value);
};
const $c804900efc0ed3cd$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Atlas,
    (0, $b4tvS.ProductKeys).Confluence,
    (0, $b4tvS.ProductKeys).Focus,
    (0, $b4tvS.ProductKeys).Jira,
    (0, $b4tvS.ProductKeys).JiraProductDiscovery,
    (0, $b4tvS.ProductKeys).JiraServiceManagement,
    (0, $b4tvS.ProductKeys).Compass,
    (0, $b4tvS.ProductKeys).Trello,
    (0, $b4tvS.ProductKeys).Bitbucket
];
const $c804900efc0ed3cd$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('lastUpdated');
const $c804900efc0ed3cd$export$3dea766d36a8935f = (0, $7GRRM.createSingleWithCustomOptionSelectFilter)({
    id: 'lastUpdated',
    products: [
        ...$c804900efc0ed3cd$var$productKeys1P,
        ...$c804900efc0ed3cd$var$products3PFromConfig
    ],
    alwaysVisible: true,
    universal: true,
    queryParams: {
        key: 'lastModified',
        fetcher: async (_, config)=>{
            return $c804900efc0ed3cd$var$LAST_UPDATED_VALUES.map((value)=>({
                    trackingKey: value,
                    label: config.intl?.formatMessage((0, $a33c6cc099d6cfe5$export$3f164da8f895a853)[value]) || (0, $a33c6cc099d6cfe5$export$3f164da8f895a853)[value].defaultMessage,
                    value: value,
                    queryParamValue: value,
                    product: config.product
                }));
        },
        customValueParser: $ILLS9.customValueParser,
        generateQueryParamsGetState: $ILLS9.generateQueryParamsGetState
    },
    initialOptions: {
        fetcher: async (config)=>{
            return [
                {
                    trackingKey: 'anytime',
                    label: config.intl?.formatMessage((0, $a33c6cc099d6cfe5$export$3f164da8f895a853)['anytime']) || (0, $a33c6cc099d6cfe5$export$3f164da8f895a853)['anytime'].defaultMessage,
                    value: 'anytime',
                    isDefault: true,
                    queryParamValue: (0, $fKv9F.LastModified).Anytime,
                    product: config.product
                },
                ...$c804900efc0ed3cd$var$LAST_UPDATED_VALUES.map((value)=>({
                        trackingKey: value,
                        label: config.intl?.formatMessage((0, $a33c6cc099d6cfe5$export$3f164da8f895a853)[value]) || (0, $a33c6cc099d6cfe5$export$3f164da8f895a853)[value].defaultMessage,
                        value: value,
                        queryParamValue: value,
                        product: config.product
                    }))
            ];
        }
    },
    sortCompareFn: $c804900efc0ed3cd$var$sortCompareFn,
    customValueFields: [
        'to',
        'from'
    ]
});
module.exports["filter"] = $c804900efc0ed3cd$export$3dea766d36a8935f;

});

parcelRegister("huubg", function(module, exports) {

var $jwO5V = parcelRequire("jwO5V");


var $98IoL = parcelRequire("98IoL");


var $i8MOh = parcelRequire("i8MOh");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $6Ea6j = parcelRequire("6Ea6j");


var $ewGgp = parcelRequire("ewGgp");


var $4bHQd = parcelRequire("4bHQd");

const $602c33df522af7cd$var$MAX_SEARCHED_OPTIONS_RESULTS = 5;
const $602c33df522af7cd$var$loadInitialOptions = async (config)=>{
    return (0, $4bHQd.loadRecommendedUsers)(config);
};
const $602c33df522af7cd$var$searchlastUpdatedBy = async (query, config)=>{
    if (!config.intl) return []; // base on existing interface, can only query with intl
    const productKey = (0, $ewGgp.getUrsProductKey)(config.primaryProduct);
    const response = await (0, $98IoL.getLastUpdatedBy)({
        query: query,
        cloudId: config.cloudId || '',
        userId: config.userId || '',
        productKey: productKey,
        maxNumberOfResults: $602c33df522af7cd$var$MAX_SEARCHED_OPTIONS_RESULTS,
        intl: config.intl
    });
    if (!response) return [];
    return response.map((user)=>({
            trackingKey: user.id,
            value: user.id,
            label: user.name,
            avatarUrl: user.avatarUrl,
            queryParamValue: user.id,
            product: config.product
        }));
};
const $602c33df522af7cd$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'lastUpdatedBy',
    products: [
        (0, $b4tvS.ProductKeys).Salesforce,
        (0, $b4tvS.ProductKeys).Hubspot
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'lastUpdatedBy',
        fetcher: async (queryParams, config)=>{
            const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const initialUsersResponse = await (0, $i8MOh.usersQuery)(queryParams, headers);
            const allLastUpdatedBy = initialUsersResponse.data?.users ?? [];
            const userIds = new Set();
            const lastUpdatedByOptions = allLastUpdatedBy.filter((user)=>!userIds.has(user.accountId) && userIds.add(user.accountId)) // Remove duplicates
            .map((user)=>({
                    trackingKey: user.accountId,
                    value: user.accountId,
                    label: user.name,
                    avatarUrl: user.picture,
                    queryParamValue: user.accountId,
                    product: config.product
                }));
            return lastUpdatedByOptions;
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $602c33df522af7cd$var$loadInitialOptions(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            return $602c33df522af7cd$var$searchlastUpdatedBy(query, config);
        }
    }
});
module.exports["filter"] = $602c33df522af7cd$export$3dea766d36a8935f;

});

parcelRegister("dFCIx", function(module, exports) {
parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $dOOW1 = parcelRequire("dOOW1");


var $cOUgi = parcelRequire("cOUgi");


var $dcbm4 = parcelRequire("dcbm4");


var $aXWIB = parcelRequire("aXWIB");

const $9944ee0bc1f3b08e$export$815fbd192b2af8a4 = (0, $aXWIB.defineMessages)({
    all: {
        id: "search-page.filter.opportunityStatus.all",
        defaultMessage: "Any"
    },
    open: {
        id: "search-page.filter.opportunityStatus.open",
        defaultMessage: "Open"
    },
    closed: {
        id: "search-page.filter.opportunityStatus.closed",
        defaultMessage: "Closed"
    }
});


const $0f897612a5f47c57$export$2fbe3998cc101414 = (config)=>{
    const allOption = {
        value: 'all',
        trackingKey: 'all',
        queryParamValue: 'all',
        isDefault: true,
        label: config.intl?.formatMessage((0, $9944ee0bc1f3b08e$export$815fbd192b2af8a4)['all']) ?? '',
        product: config.product
    };
    const opportunityStatusOptions = (0, $dcbm4.allOpportunityStatusFilterValueKeys).map((key)=>({
            value: key,
            trackingKey: key,
            queryParamValue: key,
            isDefault: false,
            label: config.intl?.formatMessage((0, $9944ee0bc1f3b08e$export$815fbd192b2af8a4)[key]) ?? '',
            product: config.product
        }));
    return [
        allOption,
        ...opportunityStatusOptions
    ];
};


const $4da2f64cd04b4f35$var$salesforceProducts = [
    (0, $b4tvS.ProductKeys).Salesforce
];
const $4da2f64cd04b4f35$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('opportunityStatus');
const $4da2f64cd04b4f35$var$opportunityStatusProducts = Array.from(new Set([
    ...$4da2f64cd04b4f35$var$salesforceProducts,
    ...$4da2f64cd04b4f35$var$products3PFromConfig
]));
const $4da2f64cd04b4f35$var$loadQueryParams = (queryParams, config)=>{
    const allOptions = (0, $0f897612a5f47c57$export$2fbe3998cc101414)(config);
    return allOptions.filter((option)=>!option.isDefault).filter((option)=>queryParams.includes(option.queryParamValue)).map((option)=>({
            ...option,
            product: config.product
        }));
};
const $4da2f64cd04b4f35$var$getInitialOptions = (config)=>{
    const allOptions = (0, $0f897612a5f47c57$export$2fbe3998cc101414)(config);
    return allOptions.map((option)=>({
            ...option,
            product: config.product
        }));
};
const $4da2f64cd04b4f35$export$3dea766d36a8935f = (0, $cOUgi.createSingleSelectFilter)({
    id: 'opportunityStatus',
    products: $4da2f64cd04b4f35$var$opportunityStatusProducts,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'opportunityStatus',
        fetcher: async (queryParams, config)=>{
            return $4da2f64cd04b4f35$var$loadQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $4da2f64cd04b4f35$var$getInitialOptions(config);
        }
    }
});
module.exports["filter"] = $4da2f64cd04b4f35$export$3dea766d36a8935f;

});

parcelRegister("5ousX", function(module, exports) {

var $jwO5V = parcelRequire("jwO5V");


var $3Pbzb = parcelRequire("3Pbzb");


var $cxsgw = parcelRequire("cxsgw");


var $i8MOh = parcelRequire("i8MOh");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $dOOW1 = parcelRequire("dOOW1");


var $6Ea6j = parcelRequire("6Ea6j");


var $ewGgp = parcelRequire("ewGgp");

const $94bac5f8fcf7120c$var$MAX_SMART_DEFAULT_OPTIONS = 5;
const $94bac5f8fcf7120c$var$MAX_SEARCHED_OPTIONS_RESULTS = 5;
const $94bac5f8fcf7120c$var$loadRecommendedOwner = async (config)=>{
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const initialUsersQuery = (0, $i8MOh.usersQuery)([
        ...config.userId ? [
            config.userId
        ] : [] // The current user should always be the first recommended user
    ], headers);
    const recommendedUserQuery = (0, $cxsgw.smartsRecommendedUserQuery)({
        aggAbsoluteUrl: config.aggAbsoluteUrl,
        variables: {
            userId: config.userId || '',
            tenantId: config.cloudId || '',
            maxNumberOfResults: $94bac5f8fcf7120c$var$MAX_SMART_DEFAULT_OPTIONS
        },
        headers: headers
    });
    const [initialUsersResponse, smartsRecommendedUserResponse] = await Promise.all([
        initialUsersQuery,
        recommendedUserQuery
    ]);
    const recommendedUsersResults = smartsRecommendedUserResponse.data?.smarts.results ?? [];
    const allRecommendedUsers = [
        ...initialUsersResponse.data?.users ?? [],
        ...recommendedUsersResults.flatMap((recommendedUsers)=>!!recommendedUsers && !!recommendedUsers.user ? {
                id: recommendedUsers.id,
                ...recommendedUsers.user
            } : [])
    ];
    const recommendedUserOptions = allRecommendedUsers.map((user)=>({
            trackingKey: user.accountId,
            value: user.accountId,
            label: user.name,
            avatarUrl: user.picture,
            queryParamValue: user.accountId,
            product: config.product
        }));
    return recommendedUserOptions;
};
const $94bac5f8fcf7120c$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Confluence,
    (0, $b4tvS.ProductKeys).Focus
];
const $94bac5f8fcf7120c$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('owner');
const $94bac5f8fcf7120c$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'owner',
    products: [
        ...$94bac5f8fcf7120c$var$productKeys1P,
        ...$94bac5f8fcf7120c$var$products3PFromConfig
    ],
    alwaysVisible: true,
    universal: false,
    queryParams: {
        key: 'owners',
        fetcher: async (queryParams, config)=>{
            const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const initialUsersReponse = await (0, $i8MOh.usersQuery)([
                ...queryParams
            ], headers);
            const allRecommendedUsers = initialUsersReponse.data?.users ?? [];
            const recommendedUserOptions = allRecommendedUsers.map((user)=>({
                    trackingKey: user.accountId,
                    value: user.accountId,
                    label: user.name,
                    avatarUrl: user.picture,
                    queryParamValue: user.accountId,
                    product: config.product
                }));
            return recommendedUserOptions;
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $94bac5f8fcf7120c$var$loadRecommendedOwner(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            if (!config.intl) return [];
            const response = await (0, $3Pbzb.getOwners)({
                query: query,
                cloudId: config.cloudId || '',
                userId: config.userId || '',
                productKey: (0, $ewGgp.getUrsProductKey)(config.primaryProduct),
                maxNumberOfResults: $94bac5f8fcf7120c$var$MAX_SEARCHED_OPTIONS_RESULTS,
                intl: config.intl
            });
            if (!response) // TODO: log not found somewhere
            return [];
            return response.map((owner)=>({
                    trackingKey: owner.id,
                    value: owner.id,
                    label: owner.name,
                    avatarUrl: owner.avatarUrl,
                    queryParamValue: owner.id,
                    product: config.product
                }));
        }
    }
});
module.exports["filter"] = $94bac5f8fcf7120c$export$3dea766d36a8935f;

});

parcelRegister("1sswv", function(module, exports) {
parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $dOOW1 = parcelRequire("dOOW1");


var $cOUgi = parcelRequire("cOUgi");


var $jreQ3 = parcelRequire("jreQ3");


var $bxnmj = parcelRequire("bxnmj");


var $aXWIB = parcelRequire("aXWIB");

const $0e27a4402a5009a7$export$29ee4a15a943675b = (0, $aXWIB.defineMessages)({
    all: {
        id: "search-page.filter.pageStatus.all",
        defaultMessage: "All"
    },
    roughDraft: {
        id: "search-page.filter.pageStatus.roughDraft",
        defaultMessage: "Rough draft"
    },
    inProgress: {
        id: "search-page.filter.pageStatus.inProgress",
        defaultMessage: "In progress"
    },
    readyForReview: {
        id: "search-page.filter.pageStatus.readyForReview",
        defaultMessage: "Ready for review"
    },
    verified: {
        id: "search-page.filter.pageStatus.verified",
        defaultMessage: "Verified"
    }
});


const $d364917c170d648d$export$3195c4e56ca4af29 = (config)=>{
    const allOption = {
        value: 'all',
        trackingKey: 'all',
        queryParamValue: 'all',
        isDefault: true,
        label: config.intl?.formatMessage((0, $0e27a4402a5009a7$export$29ee4a15a943675b)['all']) ?? '',
        product: config.product
    };
    const pageStatusOptions = (0, $bxnmj.allPageStatusFilterValueKeys).map((key)=>({
            value: (0, $bxnmj.PageStatusFilterValue)[key],
            trackingKey: key,
            queryParamValue: key,
            isDefault: false,
            label: config.intl?.formatMessage((0, $0e27a4402a5009a7$export$29ee4a15a943675b)[key]) ?? '',
            product: config.product
        }));
    return [
        allOption,
        ...pageStatusOptions
    ];
};


const $eaf2688e5c2f5e7e$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Confluence
];
const $eaf2688e5c2f5e7e$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('pageStatus');
const $eaf2688e5c2f5e7e$var$loadQueryParams = (queryParams, config)=>{
    const allOptions = (0, $d364917c170d648d$export$3195c4e56ca4af29)(config);
    return allOptions.filter((option)=>!option.isDefault).filter((option)=>queryParams.includes(option.queryParamValue)).map((option)=>({
            ...option,
            product: config.product
        }));
};
const $eaf2688e5c2f5e7e$var$getInitialOptions = (config)=>{
    const allOptions = (0, $d364917c170d648d$export$3195c4e56ca4af29)(config);
    return allOptions.map((option)=>({
            ...option,
            product: config.product
        }));
};
const $eaf2688e5c2f5e7e$export$3dea766d36a8935f = (0, $cOUgi.createSingleSelectFilter)({
    id: 'pageStatus',
    products: [
        ...$eaf2688e5c2f5e7e$var$productKeys1P,
        ...$eaf2688e5c2f5e7e$var$products3PFromConfig
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'pageStatus',
        fetcher: async (queryParams, config)=>{
            return $eaf2688e5c2f5e7e$var$loadQueryParams(queryParams, config);
        },
        generateQueryParamsGetState: $jreQ3.generateQueryParamsGetState
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $eaf2688e5c2f5e7e$var$getInitialOptions(config);
        }
    }
});
module.exports["filter"] = $eaf2688e5c2f5e7e$export$3dea766d36a8935f;

});

parcelRegister("jqLa8", function(module, exports) {

var $jwO5V = parcelRequire("jwO5V");


var $1APZs = parcelRequire("1APZs");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $6Ea6j = parcelRequire("6Ea6j");

// Number of results returned in dropdown
const $944ef057a61db4ac$var$LIMIT = 20;
const $944ef057a61db4ac$var$EmploymentTypeMapping = {
    Contingent: 'contingent',
    Employee: 'employee',
    Contractor: 'contractor'
};
const $944ef057a61db4ac$var$ReverseEmploymentTypeMapping = Object.fromEntries(Object.entries($944ef057a61db4ac$var$EmploymentTypeMapping).map(([key, value])=>[
        value,
        key
    ]));
const $944ef057a61db4ac$export$3362d5a8d7ac6a7b = (positionEmploymentType, product)=>{
    const value = $944ef057a61db4ac$var$EmploymentTypeMapping[positionEmploymentType.node.stringValue || ''] || 'unrecognized';
    return {
        trackingKey: value,
        label: positionEmploymentType.node.stringValue || '',
        value: value,
        queryParamValue: value,
        product: product
    };
};
/**
 * Queries position employment types by search term
 * @param query
 * @param config
 * @returns
 */ const $944ef057a61db4ac$var$searchPositionEmploymentTypes = async (query, config)=>{
    const rqlQuery = `employmentType ~ '${query}'`;
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const positionEmploymentTypesResponse = await (0, $1APZs.positionEmploymentTypesQuery)(config.cloudId || '', rqlQuery, $944ef057a61db4ac$var$LIMIT, undefined, headers);
    const positionEmploymentTypes = positionEmploymentTypesResponse.data?.radar_fieldValues.edges ?? [];
    return positionEmploymentTypes.map((positionEmploymentType)=>$944ef057a61db4ac$export$3362d5a8d7ac6a7b(positionEmploymentType, config.product));
};
/**
 * Queries all selected focus areas by id from query params
 * @param queryParams
 * @param config
 * @returns
 */ const $944ef057a61db4ac$var$getOptionsWithSelectionsFromQueryParams = async (queryParams, config)=>{
    const rqlQuery = `employmentType in ('${queryParams.map((param)=>$944ef057a61db4ac$var$ReverseEmploymentTypeMapping[param || 'unrecognized']).filter(Boolean).join("', '")}')`;
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const positionEmploymentTypesResponse = await (0, $1APZs.positionEmploymentTypesQuery)(config.cloudId || '', rqlQuery, $944ef057a61db4ac$var$LIMIT, undefined, headers);
    const positionEmploymentTypes = positionEmploymentTypesResponse.data?.radar_fieldValues.edges ?? [];
    return positionEmploymentTypes.map((positionEmploymentType)=>$944ef057a61db4ac$export$3362d5a8d7ac6a7b(positionEmploymentType, config.product));
};
const $944ef057a61db4ac$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Talent
];
const $944ef057a61db4ac$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'positionEmploymentType',
    products: $944ef057a61db4ac$var$productKeys1P,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'positionEmploymentTypes',
        fetcher: $944ef057a61db4ac$var$getOptionsWithSelectionsFromQueryParams
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $944ef057a61db4ac$var$searchPositionEmploymentTypes('', config);
        }
    },
    lookup: {
        fetcher: $944ef057a61db4ac$var$searchPositionEmploymentTypes
    }
});
module.exports["filter"] = $944ef057a61db4ac$export$3dea766d36a8935f;

});

parcelRegister("fLju9", function(module, exports) {

var $jwO5V = parcelRequire("jwO5V");


var $d95gt = parcelRequire("d95gt");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $6Ea6j = parcelRequire("6Ea6j");

// Number of results returned in dropdown
const $4f1eaa790ab361d5$var$FOCUS_AREA_RESULTS_LIMIT = 20;
const $4f1eaa790ab361d5$var$mapFocusAreaResult = (focusArea, product)=>{
    return {
        trackingKey: focusArea.node?.uuid || '',
        label: focusArea.node?.name || '',
        value: focusArea.node?.uuid || '',
        queryParamValue: focusArea.node?.uuid || '',
        metadata: {
            type: focusArea.node?.focusAreaType.name,
            owner: focusArea.node?.owner?.name,
            status: focusArea.node?.status?.key,
            health: focusArea.node?.health?.key
        },
        product: product
    };
};
/**
 * Queries focus areas by search term
 * @param query
 * @param config
 * @returns
 */ const $4f1eaa790ab361d5$var$searchPositionFocusAreas = async (query, config)=>{
    const mqlQuery = `(search LIKE '${query}')`;
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const focusAreasResponse = await (0, $d95gt.mercuryFocusAreasQuery)(config.cloudId || '', mqlQuery, $4f1eaa790ab361d5$var$FOCUS_AREA_RESULTS_LIMIT, undefined, headers);
    const focusAreas = focusAreasResponse.data?.mercury.focusAreas.edges ?? [];
    return focusAreas.map((focusArea)=>$4f1eaa790ab361d5$var$mapFocusAreaResult(focusArea, config.product));
};
/**
 * Queries all selected focus areas by id from query params
 * @param queryParams
 * @param config
 * @returns
 */ const $4f1eaa790ab361d5$var$getOptionsWithSelectionsFromQueryParams = async (queryParams, config)=>{
    const mqlQuery = `(${queryParams.map((id)=>`id = '${id}'`).join(' OR ')})`;
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const focusAreasResponse = await (0, $d95gt.mercuryFocusAreasQuery)(config.cloudId || '', mqlQuery, $4f1eaa790ab361d5$var$FOCUS_AREA_RESULTS_LIMIT, undefined, headers);
    const focusAreas = focusAreasResponse.data?.mercury.focusAreas.edges ?? [];
    return focusAreas.map((focusArea)=>$4f1eaa790ab361d5$var$mapFocusAreaResult(focusArea, config.product));
};
const $4f1eaa790ab361d5$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Talent
];
const $4f1eaa790ab361d5$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'positionFocusArea',
    products: $4f1eaa790ab361d5$var$productKeys1P,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'positionFocusAreas',
        fetcher: $4f1eaa790ab361d5$var$getOptionsWithSelectionsFromQueryParams
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $4f1eaa790ab361d5$var$searchPositionFocusAreas('', config);
        }
    },
    lookup: {
        fetcher: $4f1eaa790ab361d5$var$searchPositionFocusAreas
    }
});
module.exports["filter"] = $4f1eaa790ab361d5$export$3dea766d36a8935f;

});

parcelRegister("dXdDw", function(module, exports) {

var $jwO5V = parcelRequire("jwO5V");


var $gkPq5 = parcelRequire("gkPq5");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $6Ea6j = parcelRequire("6Ea6j");

// Number of results returned in dropdown
const $22d3362090d0f2e1$var$LIMIT = 20;
const $22d3362090d0f2e1$var$mapPositionJobFamilyResult = (positionJobFamily, product)=>{
    const encodedValue = encodeURIComponent(positionJobFamily.node.stringValue);
    return {
        trackingKey: encodedValue || '',
        label: positionJobFamily.node.stringValue || '',
        value: encodedValue || '',
        queryParamValue: encodedValue || '',
        product: product
    };
};
/**
 * Queries position job families by search term
 * @param query
 * @param config
 * @returns
 */ const $22d3362090d0f2e1$var$searchPositionJobFamilies = async (query, config)=>{
    const rqlQuery = `jobFamily ~ '${query}'`;
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const positionJobFamiliesResponse = await (0, $gkPq5.positionJobFamiliesQuery)(config.cloudId || '', $22d3362090d0f2e1$var$LIMIT, rqlQuery, undefined, headers);
    const positionJobFamilies = positionJobFamiliesResponse.data?.radar_fieldValues.edges ?? [];
    return positionJobFamilies.map((positionJobFamily)=>$22d3362090d0f2e1$var$mapPositionJobFamilyResult(positionJobFamily, config.product));
};
/**
 * Queries all selected job families by id from query params
 * @param queryParams
 * @param config
 * @returns
 */ const $22d3362090d0f2e1$var$getOptionsWithSelectionsFromQueryParams = async (queryParams, config)=>{
    const rqlQuery = `jobFamily in ('${queryParams.map((param)=>decodeURIComponent(param)).join("', '")}')`;
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const positionJobFamiliesResponse = await (0, $gkPq5.positionJobFamiliesQuery)(config.cloudId || '', $22d3362090d0f2e1$var$LIMIT, rqlQuery, undefined, headers);
    const positionJobFamilies = positionJobFamiliesResponse.data?.radar_fieldValues.edges ?? [];
    return positionJobFamilies.map((positionJobFamily)=>$22d3362090d0f2e1$var$mapPositionJobFamilyResult(positionJobFamily, config.product));
};
const $22d3362090d0f2e1$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Talent
];
const $22d3362090d0f2e1$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'positionJobFamily',
    products: $22d3362090d0f2e1$var$productKeys1P,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'positionJobFamilies',
        fetcher: $22d3362090d0f2e1$var$getOptionsWithSelectionsFromQueryParams
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $22d3362090d0f2e1$var$searchPositionJobFamilies('', config);
        }
    },
    lookup: {
        fetcher: $22d3362090d0f2e1$var$searchPositionJobFamilies
    }
});
module.exports["filter"] = $22d3362090d0f2e1$export$3dea766d36a8935f;

});

parcelRegister("5eFo6", function(module, exports) {

var $jwO5V = parcelRequire("jwO5V");


var $3FxSV = parcelRequire("3FxSV");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $6Ea6j = parcelRequire("6Ea6j");

// Number of results returned in dropdown
const $161993d68cbd0f2a$var$LIMIT = 20;
const $161993d68cbd0f2a$var$StatusMapping = {
    Filled: 'filled',
    'Not filled': 'unfilled'
};
const $161993d68cbd0f2a$var$ReverseStatusMapping = Object.fromEntries(Object.entries($161993d68cbd0f2a$var$StatusMapping).map(([key, value])=>[
        value,
        key
    ]));
const $161993d68cbd0f2a$export$aa60679002fe2884 = (positionStatus, product)=>{
    const value = $161993d68cbd0f2a$var$StatusMapping[positionStatus.node.statusValue || ''] || 'unrecognized';
    return {
        trackingKey: value,
        label: positionStatus.node.statusDisplayValue || '',
        value: value,
        queryParamValue: value,
        product: product
    };
};
/**
 * Queries position statuses by search term
 * @param query
 * @param config
 * @returns
 */ const $161993d68cbd0f2a$var$searchPositionStatuses = async (query, config)=>{
    const rqlQuery = `status ~ '${query}'`;
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const positionStatusesResponse = await (0, $3FxSV.positionStatusesQuery)(config.cloudId || '', $161993d68cbd0f2a$var$LIMIT, rqlQuery, undefined, headers);
    const positionStatuses = positionStatusesResponse.data?.radar_fieldValues.edges ?? [];
    return positionStatuses.map((positionStatus)=>$161993d68cbd0f2a$export$aa60679002fe2884(positionStatus, config.product));
};
/**
 * Queries all selected position statuses by id from query params
 * @param queryParams
 * @param config
 * @returns
 */ const $161993d68cbd0f2a$var$getOptionsWithSelectionsFromQueryParams = async (queryParams, config)=>{
    const rqlQuery = `status in ('${queryParams.map((param)=>$161993d68cbd0f2a$var$ReverseStatusMapping[param || 'unrecognized']).filter(Boolean).join("', '")}')`;
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const positionStatusesResponse = await (0, $3FxSV.positionStatusesQuery)(config.cloudId || '', $161993d68cbd0f2a$var$LIMIT, rqlQuery, undefined, headers);
    const positionStatuses = positionStatusesResponse.data?.radar_fieldValues.edges ?? [];
    return positionStatuses.map((positionStatus)=>$161993d68cbd0f2a$export$aa60679002fe2884(positionStatus, config.product));
};
const $161993d68cbd0f2a$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Talent
];
const $161993d68cbd0f2a$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'positionStatus',
    products: $161993d68cbd0f2a$var$productKeys1P,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'positionStatuses',
        fetcher: $161993d68cbd0f2a$var$getOptionsWithSelectionsFromQueryParams
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $161993d68cbd0f2a$var$searchPositionStatuses('', config);
        }
    },
    lookup: {
        fetcher: $161993d68cbd0f2a$var$searchPositionStatuses
    }
});
module.exports["filter"] = $161993d68cbd0f2a$export$3dea766d36a8935f;

});

parcelRegister("aeffu", function(module, exports) {

var $jwO5V = parcelRequire("jwO5V");


var $eDERK = parcelRequire("eDERK");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $6Ea6j = parcelRequire("6Ea6j");


var $cSPiD = parcelRequire("cSPiD");

// Number of results returned in dropdown
const $1de5e305b3bb3af1$var$LIMIT = 20;
const $1de5e305b3bb3af1$var$mapPositionTeamResult = (positionTeam, product)=>{
    return {
        trackingKey: positionTeam.node.ari || '',
        label: positionTeam.node.value?.displayName || '',
        value: positionTeam.node.ari || '',
        queryParamValue: encodeURIComponent(positionTeam.node.ari) || '',
        product: product,
        avatarUrl: positionTeam.node.value?.smallAvatarImageUrl || ''
    };
};
/**
 * Queries position teams by search term
 * @param query
 * @param config
 * @returns
 */ const $1de5e305b3bb3af1$var$searchPositionTeams = async (query, config)=>{
    const rqlQuery = `team ~ '${query}'`;
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const positionTeamsResponse = await (0, $eDERK.positionTeamsQuery)(config.cloudId || '', $1de5e305b3bb3af1$var$LIMIT, rqlQuery, undefined, headers);
    const positionTeams = positionTeamsResponse.data?.radar_fieldValues.edges ?? [];
    return positionTeams.map((positionTeam)=>$1de5e305b3bb3af1$var$mapPositionTeamResult(positionTeam, config.product));
};
/**
 * Queries all selected position teams by id from query params
 * @param queryParams
 * @param config
 * @returns
 */ const $1de5e305b3bb3af1$var$getOptionsWithSelectionsFromQueryParams = async (queryParams, config)=>{
    const rqlQuery = `team in ('${queryParams.map((param)=>decodeURIComponent(param)).join("', '")}')`;
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const positionTeamsResponse = await (0, $eDERK.positionTeamsQuery)(config.cloudId || '', $1de5e305b3bb3af1$var$LIMIT, rqlQuery, undefined, headers);
    const positionTeams = positionTeamsResponse.data?.radar_fieldValues.edges ?? [];
    return positionTeams.map((positionTeam)=>$1de5e305b3bb3af1$var$mapPositionTeamResult(positionTeam, config.product));
};
const $1de5e305b3bb3af1$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Talent
];
const $1de5e305b3bb3af1$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'positionTeam',
    products: $1de5e305b3bb3af1$var$productKeys1P,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'positionTeams',
        fetcher: $1de5e305b3bb3af1$var$getOptionsWithSelectionsFromQueryParams,
        generateQueryParamsGetState: $cSPiD.generateQueryParamsGetState
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $1de5e305b3bb3af1$var$searchPositionTeams('', config);
        }
    },
    lookup: {
        fetcher: $1de5e305b3bb3af1$var$searchPositionTeams
    }
});
module.exports["filter"] = $1de5e305b3bb3af1$export$3dea766d36a8935f;

});

parcelRegister("gHwfH", function(module, exports) {

var $a5RR2 = parcelRequire("a5RR2");


var $jwO5V = parcelRequire("jwO5V");


var $3paC4 = parcelRequire("3paC4");


var $iUYhn = parcelRequire("iUYhn");


var $1WLN3 = parcelRequire("1WLN3");


var $johDC = parcelRequire("johDC");


var $k8y62 = parcelRequire("k8y62");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $dOOW1 = parcelRequire("dOOW1");


var $6Ea6j = parcelRequire("6Ea6j");


var $5jwMp = parcelRequire("5jwMp");

const $42927da814457d11$var$projectIdToARI = (cloudId, projectId)=>`ari:cloud:jira:${cloudId}:project/${projectId}`;
const $42927da814457d11$export$c4acd5097f11a5c9 = ({ projectKey: projectKey, name: name })=>{
    if (!projectKey) return name;
    const key = `(${projectKey})`;
    if (name.toLowerCase().includes(key.toLowerCase())) return name;
    return `${name} ${key}`;
};
const $42927da814457d11$var$searchProject = async (query, config)=>{
    const searchClient = (0, $3paC4.createClient)({
        cloudId: config.cloudId || ''
    });
    let searchProjectsResponse, searchedProjects;
    const product = config.product;
    if (product === (0, $b4tvS.ProductKeys).JiraDC || product === (0, $b4tvS.ProductKeys).JsmDC) {
        const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
            cloudId: config.cloudId,
            activationId: config.activationId,
            product: config.primaryProduct
        });
        searchProjectsResponse = await (0, $johDC.jiraDcProjectFilterOptionsQuery)({
            variables: {
                query: query,
                cloudIdARI: `ari:cloud:confluence::site/${config.cloudId}`,
                limit: 5,
                entities: (0, $k8y62.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                product: (0, $b4tvS.ProductKeys).JiraDC,
                integration: config.selectedDatasource?.integrationAri,
                containerTypes: (0, $a5RR2.ThirdPartyConfigsSync).get(product)?.containerTypes
            },
            aggAbsoluteUrl: config.aggAbsoluteUrl,
            headers: headers
        });
        return searchProjectsResponse?.data?.search?.search?.edges?.map((edge)=>({
                trackingKey: edge.node.entity.id,
                value: edge.node.entity.id,
                label: $42927da814457d11$export$c4acd5097f11a5c9({
                    projectKey: edge.node.entity.key,
                    name: edge.node.entity.displayName
                }),
                avatarUrl: edge?.node?.entity?.icon?.url,
                queryParamValue: edge.node.entity.id,
                product: config.product
            })) || [];
    }
    searchProjectsResponse = await searchClient.search({
        query: query,
        resultLimit: 5,
        scopes: [
            (0, $iUYhn.Scope).JiraProject
        ],
        analytics: {
            identifier: 'search-page'
        }
    });
    searchedProjects = searchProjectsResponse.response.rawData.scopes.length > 0 ? searchProjectsResponse.response.rawData.scopes[0].results.map((projectResult)=>({
            projectId: projectResult.id,
            name: projectResult.name,
            projectKey: projectResult.attributes.projectKey,
            avatar: {
                small: 'url' in projectResult.attributes.avatar ? projectResult.attributes.avatar.url : undefined
            }
        })) : [];
    return searchedProjects.map((project)=>({
            trackingKey: $42927da814457d11$var$projectIdToARI(config.cloudId || '', project.projectId),
            value: $42927da814457d11$var$projectIdToARI(config.cloudId || '', project.projectId),
            label: $42927da814457d11$export$c4acd5097f11a5c9(project),
            avatarUrl: project.avatar?.small,
            queryParamValue: project.projectId,
            product: config.product
        }));
};
const $42927da814457d11$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Jira,
    (0, $b4tvS.ProductKeys).JiraProductDiscovery,
    (0, $b4tvS.ProductKeys).JiraServiceManagement
];
const $42927da814457d11$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('project');
const $42927da814457d11$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'project',
    products: [
        ...$42927da814457d11$var$productKeys1P,
        ...$42927da814457d11$var$products3PFromConfig
    ],
    alwaysVisible: true,
    universal: false,
    queryParams: {
        key: 'jProject',
        fetcher: async (queryParams, config)=>{
            if (config.product === (0, $b4tvS.ProductKeys).JiraDC || config.product === (0, $b4tvS.ProductKeys).JsmDC) {
                const initialProjectsResponse = await (0, $johDC.spaceARIEntitiesQuery)({
                    variables: {
                        ids: queryParams
                    }
                });
                const projectOptions = initialProjectsResponse.data?.external_entities?.space?.map((space)=>({
                        trackingKey: space.id,
                        value: space.id,
                        label: space.displayName,
                        avatarUrl: space.icon?.url || '',
                        queryParamValue: space.id,
                        product: config.product
                    }));
                return projectOptions || [];
            } else {
                const initialProjectARIs = queryParams.map((projectId)=>$42927da814457d11$var$projectIdToARI(config.cloudId || '', projectId));
                const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
                    cloudId: config.cloudId,
                    activationId: config.activationId,
                    product: config.primaryProduct
                });
                const initialProjectsResponse = await (0, $1WLN3.jiraProjectsQuery)(initialProjectARIs, headers);
                const initialProjects = initialProjectsResponse.data?.jira.jiraProjects ?? [];
                const allProjects = initialProjects;
                const projectOptions = allProjects.map((project)=>({
                        trackingKey: $42927da814457d11$var$projectIdToARI(config.cloudId || '', project.projectId),
                        value: $42927da814457d11$var$projectIdToARI(config.cloudId || '', project.projectId),
                        label: project.name,
                        avatarUrl: project.avatar?.small,
                        queryParamValue: project.projectId,
                        product: config.product
                    }));
                return projectOptions;
            }
        },
        generateQueryParamsGetState: $5jwMp.generateQueryParamsGetState
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $42927da814457d11$var$searchProject('', config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            return $42927da814457d11$var$searchProject(query, config);
        }
    },
    isSuggestedFilter: (primaryProduct)=>primaryProduct === (0, $b4tvS.ProductKeys).Jira || primaryProduct === (0, $b4tvS.ProductKeys).JiraDC || primaryProduct === (0, $b4tvS.ProductKeys).JsmDC || primaryProduct === (0, $b4tvS.ProductKeys).JiraServiceManagement || primaryProduct === (0, $b4tvS.ProductKeys).JiraProductDiscovery
});
module.exports["filter"] = $42927da814457d11$export$3dea766d36a8935f;

});

parcelRegister("3TPSi", function(module, exports) {

var $dOOW1 = parcelRequire("dOOW1");


var $6Ea6j = parcelRequire("6Ea6j");


var $aXWIB = parcelRequire("aXWIB");

const $7dbfdb36b7652279$export$9baa81d83dcf973 = [
    'open',
    'merged',
    'declined',
    'draft',
    'unknown'
];
const $7dbfdb36b7652279$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    open: {
        id: "search-page.filter.pull-request-status.open",
        defaultMessage: "Open"
    },
    merged: {
        id: "search-page.filter.pull-request-status.merged",
        defaultMessage: "Merged"
    },
    declined: {
        id: "search-page.filter.pull-request-status.declined",
        defaultMessage: "Declined"
    },
    draft: {
        id: "search-page.filter.pull-request-status.draft",
        defaultMessage: "Draft"
    },
    unknown: {
        id: "search-page.filter.pull-request-status.unknown",
        defaultMessage: "Unknown"
    }
});


const $0bfe3423d4c08986$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('pullRequestStatus');
const $0bfe3423d4c08986$var$getAllPullRequestStatusOptions = (config)=>{
    const options = (0, $7dbfdb36b7652279$export$9baa81d83dcf973).map((status)=>({
            value: status,
            trackingKey: status,
            queryParamValue: status,
            isDefault: false,
            label: config.intl?.formatMessage((0, $7dbfdb36b7652279$export$a7357cdd1f0b0168)[status]) ?? '',
            product: config.product,
            isSelected: false,
            isSuggested: false
        }));
    return options;
};
const $0bfe3423d4c08986$var$fetchQueryParams = (queryParams, config)=>{
    const allOptions = $0bfe3423d4c08986$var$getAllPullRequestStatusOptions(config);
    return allOptions.filter((option)=>queryParams.find((queryParam)=>option.value === queryParam));
};
const $0bfe3423d4c08986$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'pullRequestStatus',
    products: [
        'bitbucket',
        ...$0bfe3423d4c08986$var$products3PFromConfig
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'pullRequestStatus',
        fetcher: async (queryParams, config)=>{
            return $0bfe3423d4c08986$var$fetchQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $0bfe3423d4c08986$var$getAllPullRequestStatusOptions(config);
        }
    }
});
module.exports["filter"] = $0bfe3423d4c08986$export$3dea766d36a8935f;

});

parcelRegister("f1JPm", function(module, exports) {

var $jwO5V = parcelRequire("jwO5V");


var $3paC4 = parcelRequire("3paC4");


var $iUYhn = parcelRequire("iUYhn");


var $i8MOh = parcelRequire("i8MOh");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $dOOW1 = parcelRequire("dOOW1");


var $6Ea6j = parcelRequire("6Ea6j");

const $ed1c3ef37a9fe673$var$searchJiraCloudReporter = async (query, config, options)=>{
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const initialUsersQuery = config.userId && options?.initialOptions ? (0, $i8MOh.usersQuery)([
        config.userId
    ], headers) : Promise.resolve({
        data: {
            users: []
        }
    });
    const searchClient = (0, $3paC4.createClient)({
        cloudId: config.cloudId || ''
    });
    const searchReporterQuery = searchClient.search({
        query: query,
        resultLimit: 5,
        scopes: [
            (0, $iUYhn.Scope).People
        ],
        analytics: {
            identifier: 'search-page'
        }
    });
    const [initialUsersResponse, searchReporterReponse] = await Promise.all([
        initialUsersQuery,
        searchReporterQuery
    ]);
    const searchReporterResults = searchReporterReponse.response.rawData.scopes[0]?.results ?? [];
    const allReporters = [
        // The current user is always first
        ...initialUsersResponse.data?.users.map((user)=>({
                ...user,
                id: user.accountId
            })) ?? [],
        ...searchReporterResults.map((user)=>({
                picture: user.avatarUrl,
                name: user.name,
                id: user.id,
                accountId: user.id
            }))
    ];
    const userIds = new Set();
    return allReporters.filter((user)=>!userIds.has(user.accountId) && userIds.add(user.accountId)) // Remove duplicates
    .map((user)=>({
            trackingKey: user.accountId,
            value: user.accountId,
            label: user.name,
            avatarUrl: user.picture,
            queryParamValue: user.accountId,
            product: config.product
        }));
};
const $ed1c3ef37a9fe673$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Jira,
    (0, $b4tvS.ProductKeys).JiraProductDiscovery,
    (0, $b4tvS.ProductKeys).JiraServiceManagement
];
const $ed1c3ef37a9fe673$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('reporter');
const $ed1c3ef37a9fe673$var$getProducts = ()=>[
        ...$ed1c3ef37a9fe673$var$productKeys1P,
        ...$ed1c3ef37a9fe673$var$products3PFromConfig
    ];
const $ed1c3ef37a9fe673$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'reporter',
    products: $ed1c3ef37a9fe673$var$getProducts(),
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'jReporter',
        fetcher: async (queryParams, config)=>{
            const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const initialUsersResponse = await (0, $i8MOh.usersQuery)(queryParams, headers);
            const allReporters = initialUsersResponse.data?.users ?? [];
            const userIds = new Set();
            return allReporters.filter((user)=>!userIds.has(user.accountId) && userIds.add(user.accountId)) // Remove duplicates
            .map((user)=>({
                    trackingKey: user.accountId,
                    value: user.accountId,
                    label: user.name,
                    avatarUrl: user.picture,
                    queryParamValue: user.accountId,
                    product: config.product
                }));
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $ed1c3ef37a9fe673$var$searchJiraCloudReporter('', config, {
                initialOptions: true
            });
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            return $ed1c3ef37a9fe673$var$searchJiraCloudReporter(query, config);
        }
    }
});
module.exports["filter"] = $ed1c3ef37a9fe673$export$3dea766d36a8935f;

});

parcelRegister("dzNsR", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $a5RR2 = parcelRequire("a5RR2");


var $jwO5V = parcelRequire("jwO5V");


var $johDC = parcelRequire("johDC");


var $7YJRT = parcelRequire("7YJRT");


var $2Znam = parcelRequire("2Znam");


var $b4tvS = parcelRequire("b4tvS");


var $dOOW1 = parcelRequire("dOOW1");


var $2GQhu = parcelRequire("2GQhu");


var $6Ea6j = parcelRequire("6Ea6j");

const $0df868ad61a6ba7f$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('repository');
const $0df868ad61a6ba7f$var$FETCH_LIMIT = 30;
/**
 * Calls AGG to fetch the user's accessible repositories for the currently-selected 3P datasource.
 */ const $0df868ad61a6ba7f$var$fetchRepositoryOptions = async (config, query = '')=>{
    if (!(0, $dh538.fg)('rovo_fps_show_repository_filter')) return [];
    const { cloudId: cloudId, product: product, primaryProduct: primaryProduct, activationId: activationId } = config;
    const integrationAri = config.selectedDatasource?.integrationAri ?? (product && (0, $b4tvS.is3pProductKey)(product) ? (0, $a5RR2.ThirdPartyConfigsSync).get(product)?.integrationAri : undefined);
    if (!cloudId || !product || !integrationAri) return [];
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: cloudId,
        activationId: activationId,
        product: primaryProduct
    });
    const response = await (0, $johDC.thirdPartyRepositoryFilterOptionsQuery)({
        variables: {
            query: query,
            cloudIdARI: (0, $2GQhu.getCloudIdARI)(cloudId, primaryProduct),
            limit: $0df868ad61a6ba7f$var$FETCH_LIMIT,
            entities: (0, $7YJRT.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
            product: product,
            integration: integrationAri,
            subtypes: [
                (0, $2Znam.NounSubtypeKey).Repository
            ]
        },
        aggAbsoluteUrl: config.aggAbsoluteUrl,
        headers: headers
    });
    return response?.data?.search?.search?.edges?.map(({ node: node })=>{
        const name = node.entity?.name;
        if (!name) return undefined;
        return {
            value: name,
            trackingKey: name,
            queryParamValue: name,
            label: name,
            product: config.product,
            isDefault: false,
            isSelected: false,
            isSuggested: false
        };
    }).filter((option)=>option !== undefined) ?? [];
};
/**
 * Initial / pre-query options shown when the filter dropdown is first opened.
 */ const $0df868ad61a6ba7f$var$getInitialOptions = async (config)=>$0df868ad61a6ba7f$var$fetchRepositoryOptions(config);
/**
 * URL-hydration fetch. Resolves `?repository=...` values into
 * `SelectFilterOption`.
 */ const $0df868ad61a6ba7f$var$fetchQueryParams = async (queryParams, config)=>{
    if (queryParams.length === 0 || !(0, $dh538.fg)('rovo_fps_show_repository_filter')) return [];
    const allOptions = await $0df868ad61a6ba7f$var$fetchRepositoryOptions(config, queryParams.join(' '));
    const matched = allOptions.filter((option)=>queryParams.some((queryParam)=>option.value === queryParam)).map((option)=>({
            ...option,
            isSelected: true
        }));
    if (matched.length === queryParams.length) return matched;
    const matchedValues = new Set(matched.map((option)=>option.value));
    const fallback = queryParams.filter((queryParam)=>!matchedValues.has(queryParam)).map((queryParam)=>({
            value: queryParam,
            trackingKey: queryParam,
            queryParamValue: queryParam,
            isDefault: false,
            label: queryParam,
            product: config.product,
            isSelected: true,
            isSuggested: false
        }));
    return [
        ...matched,
        ...fallback
    ];
};
/**
 * Lookup (typeahead) fetcher.
 */ const $0df868ad61a6ba7f$var$fetchLookupOptions = async (input, config)=>{
    if (!(0, $dh538.fg)('rovo_fps_show_repository_filter') || !input) return [];
    return $0df868ad61a6ba7f$var$fetchRepositoryOptions(config, input);
};
const $0df868ad61a6ba7f$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'repository',
    products: $0df868ad61a6ba7f$var$products3PFromConfig,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'repository',
        fetcher: $0df868ad61a6ba7f$var$fetchQueryParams
    },
    initialOptions: {
        fetcher: $0df868ad61a6ba7f$var$getInitialOptions
    },
    lookup: {
        fetcher: $0df868ad61a6ba7f$var$fetchLookupOptions
    }
});
module.exports["filter"] = $0df868ad61a6ba7f$export$3dea766d36a8935f;

});

parcelRegister("720nW", function(module, exports) {

var $dh538 = parcelRequire("dh538");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $dOOW1 = parcelRequire("dOOW1");


var $6Ea6j = parcelRequire("6Ea6j");


var $2zk4m = parcelRequire("2zk4m");

const $d50e01f0d3f87cf6$var$salesforceProducts = [
    (0, $b4tvS.ProductKeys).Salesforce
];
const $d50e01f0d3f87cf6$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('salesforceStage');
const $d50e01f0d3f87cf6$var$fetchDynamicStageOptions = async (config)=>{
    const cloudId = config.cloudId;
    const datasourceId = config.selectedDatasource?.datasourceId;
    if (!cloudId || !datasourceId) return [];
    try {
        const result = await (0, $2zk4m.getCachedThirdPartyFilterOptions)(config);
        if (!result) return [];
        const opportunityStages = result.filters.find((f)=>f.name === 'opportunityStages');
        if (!opportunityStages || opportunityStages.values.length === 0) return [];
        return opportunityStages.values.map((stage)=>({
                value: stage.name,
                trackingKey: stage.name,
                queryParamValue: stage.name,
                isDefault: false,
                label: stage.label ?? stage.name,
                product: config.product,
                isSelected: false,
                isSuggested: false
            }));
    } catch  {
        return [];
    }
};
/**
 * Returns stage options — dynamic when the feature flag is on, and
 * an empty list when the feature flag is off.
 */ const $d50e01f0d3f87cf6$var$getStageOptions = async (config)=>{
    if ((0, $dh538.fg)('rovo-fps-3p-ux-salesforce-dynamic-stage-filter')) return $d50e01f0d3f87cf6$var$fetchDynamicStageOptions(config);
    return [];
};
const $d50e01f0d3f87cf6$var$fetchQueryParams = async (queryParams, config)=>{
    const allOptions = await $d50e01f0d3f87cf6$var$getStageOptions(config);
    const matched = allOptions.filter((option)=>queryParams.find((queryParam)=>option.value === queryParam));
    // If the API fetch returned no options (e.g. datasource not yet initialised on
    // initial URL load), fall back to synthetic options built from the raw query param
    // values so the store reflects hasSelection=true and shows the selected label in
    // the UI before the async fetch resolves.
    // Only apply this fallback when the flag is on — when off, the filter is disabled
    // and should not hydrate any state from query params.
    if (matched.length === 0 && queryParams.length > 0 && (0, $dh538.fg)('rovo-fps-3p-ux-salesforce-dynamic-stage-filter')) return queryParams.map((queryParam)=>({
            value: queryParam,
            trackingKey: queryParam,
            queryParamValue: queryParam,
            isDefault: false,
            label: queryParam,
            isSelected: true,
            isSuggested: false,
            product: config.product
        }));
    return matched;
};
const $d50e01f0d3f87cf6$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'salesforceStage',
    requiresTopLevel3PDatasource: true,
    products: [
        ...$d50e01f0d3f87cf6$var$salesforceProducts,
        ...$d50e01f0d3f87cf6$var$products3PFromConfig
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'salesforceStages',
        fetcher: async (queryParams, config)=>{
            return $d50e01f0d3f87cf6$var$fetchQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $d50e01f0d3f87cf6$var$getStageOptions(config);
        }
    }
});
module.exports["filter"] = $d50e01f0d3f87cf6$export$3dea766d36a8935f;

});

parcelRegister("iz3ta", function(module, exports) {

var $jwO5V = parcelRequire("jwO5V");


var $4qT1X = parcelRequire("4qT1X");

const $000856820a5317c1$export$c5dfc39e7764783c = 'searchSlackChannels';
const $000856820a5317c1$export$c94f0ac2580f3d4 = `
query ${$000856820a5317c1$export$c5dfc39e7764783c}($cloudId: ID!, $limit: Int) {
  search {
    configuration(cloudId: $cloudId) {
      thirdPartySlackChannels(limit: $limit) {
        channels {
          id
          name
          isPrivate
        }
        nextCursor
      }
    }
  }
}`;
const $000856820a5317c1$export$4b8a3f4aff3d6261 = ()=>$000856820a5317c1$export$c94f0ac2580f3d4;


const $2edf39d6904e32af$export$74d737bad7014c80 = async ({ cloudId: cloudId, limit: limit, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    try {
        const response = await (0, $4qT1X.fetchAgg)({
            graphQuery: (0, $000856820a5317c1$export$4b8a3f4aff3d6261)(),
            variables: {
                cloudId: cloudId,
                ...limit !== undefined && {
                    limit: limit
                }
            },
            operationName: (0, $000856820a5317c1$export$c5dfc39e7764783c),
            aggAbsoluteUrl: aggAbsoluteUrl,
            headers: headers
        });
        const payload = response.data?.search?.configuration?.thirdPartySlackChannels ?? null;
        if (response.errors?.length) {
            console.warn(`[${(0, $000856820a5317c1$export$c5dfc39e7764783c)}] GraphQL errors for cloudId "${cloudId}":`, response.errors);
            if (!payload) throw new Error(`[${(0, $000856820a5317c1$export$c5dfc39e7764783c)}] GraphQL errors prevented loading Slack channels for cloudId "${cloudId}"`);
        }
        return payload;
    } catch (error) {
        console.error(`[${(0, $000856820a5317c1$export$c5dfc39e7764783c)}] Failed to fetch Slack channels:`, error);
        throw error;
    }
};



var $dOOW1 = parcelRequire("dOOW1");


var $5irgt = parcelRequire("5irgt");


var $6Ea6j = parcelRequire("6Ea6j");

const $e3ef5d21a9795f09$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('slackChannel');
// 200 recommended by Slack as the max per request
// Select Filter does not support pagination, but the backend API does via cursor
// This filter can be enhanced in the future to support pagination on scroll/search if needed
const $e3ef5d21a9795f09$var$MAX_CHANNELS_TO_FETCH = 200;
/**
 * Session-level cache: maps cloudId → in-flight or resolved promise of channel options.
 * This deduplicates concurrent and repeated calls (e.g. queryParams.fetcher + initialOptions.fetcher
 * both fire on page load when a channel is pre-selected via URL param).
 * The cache is module-level so it persists for the browser session but resets on page navigation.
 */ const $e3ef5d21a9795f09$var$channelOptionsCache = new Map();
const $e3ef5d21a9795f09$export$687cc7f9972f010f = ()=>$e3ef5d21a9795f09$var$channelOptionsCache.clear();
async function $e3ef5d21a9795f09$var$doFetchSlackChannels(config) {
    const { cloudId: cloudId } = config;
    if (!cloudId) throw new Error('Cloud ID is required to fetch Slack channels');
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    try {
        const payload = await (0, $2edf39d6904e32af$export$74d737bad7014c80)({
            cloudId: cloudId,
            limit: $e3ef5d21a9795f09$var$MAX_CHANNELS_TO_FETCH,
            aggAbsoluteUrl: config.aggAbsoluteUrl,
            headers: headers
        });
        return (payload?.channels ?? []).map((channel)=>({
                value: channel.name,
                trackingKey: channel.id,
                queryParamValue: channel.name,
                label: channel.name,
                isDefault: false,
                isSelected: false,
                isSuggested: false,
                product: config.product
            }));
    } catch  {
        return [];
    }
}
const $e3ef5d21a9795f09$var$fetchSlackChannelOptions = (config)=>{
    const { cloudId: cloudId } = config;
    if (!cloudId) return Promise.resolve([]);
    // Return cached promise (handles both in-flight dedup and session-level caching).
    // If the fetch returns an empty result (e.g. network blip, auth error — doFetchSlackChannels
    // catches internally and returns []) or rejects unexpectedly, remove the cache entry so a
    // subsequent open/retry can attempt a fresh fetch rather than returning stale empty results.
    if (!$e3ef5d21a9795f09$var$channelOptionsCache.has(cloudId)) {
        const promise = $e3ef5d21a9795f09$var$doFetchSlackChannels(config);
        $e3ef5d21a9795f09$var$channelOptionsCache.set(cloudId, promise);
        promise.then((channels)=>{
            if (channels.length === 0) $e3ef5d21a9795f09$var$channelOptionsCache.delete(cloudId);
        }).catch(()=>{
            $e3ef5d21a9795f09$var$channelOptionsCache.delete(cloudId);
        });
    }
    return $e3ef5d21a9795f09$var$channelOptionsCache.get(cloudId);
};
const $e3ef5d21a9795f09$var$fetchQueryParams = async (queryParams, config)=>{
    // Hydrate selected channel names from URL params by client-side filtering
    // the full fetched list — no extra API call needed.
    const allOptions = await $e3ef5d21a9795f09$var$fetchSlackChannelOptions(config);
    const selected = new Set(queryParams);
    return allOptions.filter((option)=>selected.has(option.queryParamValue));
};
const $e3ef5d21a9795f09$var$lookupChannels = async (query, config)=>{
    const allOptions = await $e3ef5d21a9795f09$var$fetchSlackChannelOptions(config);
    if (!query) return allOptions;
    return (0, $5irgt.fuzzyFilter)(query, allOptions, (option)=>option.label);
};
const $e3ef5d21a9795f09$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'slackChannel',
    products: $e3ef5d21a9795f09$var$products3PFromConfig,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'slackChannels',
        fetcher: async (queryParams, config)=>{
            return $e3ef5d21a9795f09$var$fetchQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $e3ef5d21a9795f09$var$fetchSlackChannelOptions(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            return $e3ef5d21a9795f09$var$lookupChannels(query, config);
        }
    }
});
module.exports["filter"] = $e3ef5d21a9795f09$export$3dea766d36a8935f;

});

parcelRegister("fJFyr", function(module, exports) {

var $dh538 = parcelRequire("dh538");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $fKv9F = parcelRequire("fKv9F");


var $cOUgi = parcelRequire("cOUgi");


var $aXWIB = parcelRequire("aXWIB");

const $7a5ccdfced43df4c$export$b351dad7e43554a2 = (0, $aXWIB.defineMessages)({
    relevance: {
        id: "relevance",
        defaultMessage: "Relevance"
    },
    updatedNewest: {
        id: "updatedNewest",
        defaultMessage: "Updated (newest)"
    },
    updatedOldest: {
        id: "updatedOldest",
        defaultMessage: "Updated (oldest)"
    },
    createdNewest: {
        id: "createdNewest",
        defaultMessage: "Created (newest)"
    },
    createdOldest: {
        id: "createdOldest",
        defaultMessage: "Created (oldest)"
    }
});


const $51425ca68cc0e4db$var$SORT_VALUES = [
    'updatedNewest',
    'updatedOldest',
    'createdNewest',
    'createdOldest'
];
const $51425ca68cc0e4db$var$sortCompareFn = (a, b)=>{
    return $51425ca68cc0e4db$var$SORT_VALUES.indexOf(a.queryParamValue) - $51425ca68cc0e4db$var$SORT_VALUES.indexOf(b.queryParamValue);
};
const $51425ca68cc0e4db$var$products = [
    (0, $b4tvS.ProductKeys).Confluence,
    (0, $b4tvS.ProductKeys).Jira
];
const $51425ca68cc0e4db$export$3dea766d36a8935f = (0, $cOUgi.createSingleSelectFilter)({
    id: 'sort',
    products: $51425ca68cc0e4db$var$products,
    alwaysVisible: true,
    universal: false,
    queryParams: {
        key: 'sort',
        fetcher: async (_, config)=>{
            return $51425ca68cc0e4db$var$SORT_VALUES.map((value)=>({
                    trackingKey: value,
                    label: config.intl?.formatMessage((0, $7a5ccdfced43df4c$export$b351dad7e43554a2)[value]) || (0, $7a5ccdfced43df4c$export$b351dad7e43554a2)[value].defaultMessage,
                    value: value,
                    queryParamValue: value,
                    product: config.product
                }));
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return [
                {
                    trackingKey: (0, $fKv9F.Sort).Relevance,
                    label: config.intl?.formatMessage((0, $7a5ccdfced43df4c$export$b351dad7e43554a2)[(0, $fKv9F.Sort).Relevance]) || (0, $7a5ccdfced43df4c$export$b351dad7e43554a2)[(0, $fKv9F.Sort).Relevance].defaultMessage,
                    value: (0, $fKv9F.Sort).Relevance,
                    isDefault: true,
                    queryParamValue: (0, $fKv9F.Sort).Relevance,
                    product: config.product
                },
                ...$51425ca68cc0e4db$var$SORT_VALUES.map((value)=>({
                        trackingKey: value,
                        label: config.intl?.formatMessage((0, $7a5ccdfced43df4c$export$b351dad7e43554a2)[value]) || (0, $7a5ccdfced43df4c$export$b351dad7e43554a2)[value].defaultMessage,
                        value: value,
                        queryParamValue: value,
                        product: config.product
                    }))
            ];
        }
    },
    sortCompareFn: $51425ca68cc0e4db$var$sortCompareFn,
    isSuggestedFilter: (primaryProduct)=>(primaryProduct === (0, $b4tvS.ProductKeys).Jira || primaryProduct === (0, $b4tvS.ProductKeys).Confluence) && (0, $dh538.fg)('rovo_fps_sort_in_suggested_filters')
});
module.exports["filter"] = $51425ca68cc0e4db$export$3dea766d36a8935f;

});

parcelRegister("b6IhR", function(module, exports) {

var $dh538 = parcelRequire("dh538");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $dOOW1 = parcelRequire("dOOW1");


var $gY9AU = parcelRequire("gY9AU");


var $6Ea6j = parcelRequire("6Ea6j");


var $aXWIB = parcelRequire("aXWIB");

const $95a633f70dbb240b$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    OPEN: {
        id: "search-page.filter.status.open",
        defaultMessage: "Open"
    },
    DONE: {
        id: "search-page.filter.status.done",
        defaultMessage: "Done"
    },
    INDETERMINATE: {
        id: "search-page.filter.status.indeterminate",
        defaultMessage: "In Progress (Open)"
    },
    UNDEFINED: {
        id: "search-page.filter.status.undefined",
        defaultMessage: "Other"
    },
    NEW: {
        id: "search-page.filter.status.new",
        defaultMessage: "To Do (Open)"
    }
});


const $10d02868537a5b25$var$getProductKeys1P = ()=>{
    return [
        (0, $b4tvS.ProductKeys).Jira,
        (0, $b4tvS.ProductKeys).JiraProductDiscovery,
        (0, $b4tvS.ProductKeys).JiraServiceManagement
    ];
};
const $10d02868537a5b25$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('statusFilter');
const $10d02868537a5b25$var$getAllIssueStatusOptions = (config)=>{
    // Only use allowedJiraIssueStatuses values for Jira issue statuses or else it will be ignored in
    // the GraphQL query request. See the getJiraIssueStatusFilterOptions function.
    const options = (0, $gY9AU.allowedJiraIssueStatuses).filter((status)=>{
        if (!(0, $dh538.fg)('rovo_search_in_jira_granular_status_filters')) return status === 'OPEN' || status === 'DONE';
        else return status !== 'OPEN';
    }).map((issueStatus)=>({
            value: issueStatus,
            trackingKey: issueStatus,
            queryParamValue: issueStatus,
            isDefault: false,
            label: config.intl?.formatMessage((0, $95a633f70dbb240b$export$a7357cdd1f0b0168)[issueStatus]) ?? '',
            product: config.product,
            isSelected: false,
            isSuggested: false
        }));
    return options;
};
const $10d02868537a5b25$var$fetchQueryParams = (queryParams, config)=>{
    const allOptions = $10d02868537a5b25$var$getAllIssueStatusOptions(config);
    return allOptions.filter((option)=>queryParams.find((queryParam)=>option.value === queryParam));
};
const $10d02868537a5b25$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'statusFilter',
    // This also sets the `id=statusFilter` attribute and unfortunately `id=status` contains a global CSS target
    products: [
        ...$10d02868537a5b25$var$getProductKeys1P(),
        ...$10d02868537a5b25$var$products3PFromConfig
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'status',
        fetcher: async (queryParams, config)=>{
            return $10d02868537a5b25$var$fetchQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $10d02868537a5b25$var$getAllIssueStatusOptions(config);
        }
    }
});
module.exports["filter"] = $10d02868537a5b25$export$3dea766d36a8935f;

});

parcelRegister("iaYRG", function(module, exports) {
parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $dOOW1 = parcelRequire("dOOW1");


var $cxQs0 = parcelRequire("cxQs0");

const $d7ef0e88ac518c51$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Confluence
];
const $d7ef0e88ac518c51$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('onlyTitleMatch');
const $d7ef0e88ac518c51$export$3dea766d36a8935f = (0, $cxQs0.createBooleanFilter)({
    id: 'onlyTitleMatch',
    queryParams: {
        key: 'titleMatch'
    },
    products: [
        ...$d7ef0e88ac518c51$var$productKeys1P,
        ...$d7ef0e88ac518c51$var$products3PFromConfig
    ],
    alwaysVisible: true,
    universal: false
});
module.exports["filter"] = $d7ef0e88ac518c51$export$3dea766d36a8935f;

});

parcelRegister("dUIpv", function(module, exports) {

var $5iakG = parcelRequire("5iakG");


var $b4tvS = parcelRequire("b4tvS");


var $cOUgi = parcelRequire("cOUgi");


var $3JX0d = parcelRequire("3JX0d");

const $8238dcc2ebd02683$var$loadQueryParams = (queryParams, config)=>{
    const allOptions = (0, $3JX0d.getAllTypeOptions)(config);
    return allOptions.filter((option)=>!option.isDefault).filter((option)=>queryParams.includes(option.queryParamValue)).map((option)=>({
            trackingKey: option.value,
            label: option.label,
            value: option.value,
            queryParamValue: option.queryParamValue,
            isDefault: option.isDefault,
            product: config.product
        }));
};
const $8238dcc2ebd02683$var$getInitialOptions = (config)=>{
    const allOptions = (0, $3JX0d.getAllTypeOptions)(config);
    return allOptions.map((option)=>({
            trackingKey: option.value,
            label: option.label,
            value: option.value,
            queryParamValue: option.queryParamValue,
            isDefault: option.isDefault,
            product: config.product
        }));
};
const $8238dcc2ebd02683$var$sortCompareFn = (a, b)=>{
    const allOption = (0, $3JX0d.getAllTypeOptions)({
        intl: undefined
    });
    return allOption.findIndex((option)=>option.queryParamValue === a.queryParamValue) - allOption.findIndex((option)=>option.queryParamValue === b.queryParamValue);
};
const $8238dcc2ebd02683$export$3dea766d36a8935f = (0, $cOUgi.createSingleSelectFilter)({
    id: (0, $5iakG.universalTypeFilterId),
    products: (0, $b4tvS.allProductKeys),
    alwaysVisible: true,
    universal: true,
    queryParams: {
        key: 'type',
        fetcher: async (queryParams, config)=>{
            return $8238dcc2ebd02683$var$loadQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $8238dcc2ebd02683$var$getInitialOptions(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            // NOTE: this is the first step of filtering options
            //  the store does product specific filtering
            return (0, $3JX0d.lookupOptions)(query, config);
        }
    },
    sortCompareFn: $8238dcc2ebd02683$var$sortCompareFn
});
module.exports["filter"] = $8238dcc2ebd02683$export$3dea766d36a8935f;

});

parcelRegister("bF9JE", function(module, exports) {
parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $dOOW1 = parcelRequire("dOOW1");


var $cxQs0 = parcelRequire("cxQs0");

const $fdf2d9a71ec7e494$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Confluence
];
const $fdf2d9a71ec7e494$var$products3PFromConfig = (0, $dOOW1.getProducts3PFromConfigForFilter)('verified');
const $fdf2d9a71ec7e494$export$3dea766d36a8935f = (0, $cxQs0.createBooleanFilter)({
    id: 'verified',
    queryParams: {
        key: 'verified'
    },
    products: [
        ...$fdf2d9a71ec7e494$var$productKeys1P,
        ...$fdf2d9a71ec7e494$var$products3PFromConfig
    ],
    alwaysVisible: true,
    universal: false
});
module.exports["filter"] = $fdf2d9a71ec7e494$export$3dea766d36a8935f;

});

parcelRegister("9DkM9", function(module, exports) {
parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $cxQs0 = parcelRequire("cxQs0");

const $2f03852ff203b88b$var$productKeys1P = [
    (0, $b4tvS.ProductKeys).Jira,
    (0, $b4tvS.ProductKeys).JiraProductDiscovery,
    (0, $b4tvS.ProductKeys).JiraServiceManagement
];
const $2f03852ff203b88b$export$3dea766d36a8935f = (0, $cxQs0.createBooleanFilter)({
    id: 'watchedByMe',
    queryParams: {
        key: 'jWatchedByMe'
    },
    products: [
        ...$2f03852ff203b88b$var$productKeys1P
    ],
    alwaysVisible: true,
    universal: false
});
module.exports["filter"] = $2f03852ff203b88b$export$3dea766d36a8935f;

});

parcelRegister("3Q16G", function(module, exports) {

var $jwO5V = parcelRequire("jwO5V");


var $4qT1X = parcelRequire("4qT1X");


var $2IDcZ = parcelRequire("2IDcZ");

// Computed once at module load — the query string has no dynamic parts
const $024d722caf4032f5$var$TEAMS_WORKSPACE_GRAPH_QUERY = (0, $2IDcZ.teamsWorkspaceFilterOptionsQueryGenerator)();
const $024d722caf4032f5$var$TEAMS_INTEGRATION_ARI = 'ari:cloud:platform::integration/microsoft';
const $024d722caf4032f5$var$TEAMS_CONVERSATION_ENTITY_ATI = 'ati:cloud:graph:conversation';
const $024d722caf4032f5$var$MAX_WORKSPACE_RESULTS = 30;
const $024d722caf4032f5$export$2bb68a7d2eeb3442 = async ({ cloudId: cloudId, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const response = await (0, $4qT1X.fetchAgg)({
        graphQuery: $024d722caf4032f5$var$TEAMS_WORKSPACE_GRAPH_QUERY,
        operationName: (0, $2IDcZ.teamsWorkspaceFilterOptionsOperationName),
        variables: {
            query: '',
            cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
            limit: $024d722caf4032f5$var$MAX_WORKSPACE_RESULTS,
            entities: [
                $024d722caf4032f5$var$TEAMS_CONVERSATION_ENTITY_ATI
            ],
            product: 'teams',
            integration: $024d722caf4032f5$var$TEAMS_INTEGRATION_ARI,
            subtypes: [
                'space'
            ]
        },
        aggAbsoluteUrl: aggAbsoluteUrl,
        headers: headers
    });
    if (response.errors?.length) throw new Error(`[${(0, $2IDcZ.teamsWorkspaceFilterOptionsOperationName)}] GraphQL errors prevented loading MS Teams workspaces`);
    const seen = new Set();
    return response?.data?.search?.search?.edges?.flatMap(({ node: node })=>{
        const workspace = node?.entity?.workspace;
        if (!workspace || seen.has(workspace)) return [];
        seen.add(workspace);
        const result = {
            name: workspace,
            ...node?.entity?.id !== undefined && {
                id: node.entity.id
            }
        };
        return [
            result
        ];
    }) ?? [];
};



var $5irgt = parcelRequire("5irgt");


var $b12s7 = parcelRequire("b12s7");


var $6Ea6j = parcelRequire("6Ea6j");

/**
 * `workspaceName` filter — maps to `teamsFilters.workspaceName` in the AGG GraphQL schema.
 * Filters Microsoft Teams search results by workspace (team) name.
 *
 * The internal filter id, URL key, folder, and AGG wire field are all `workspaceName`
 * (per the naming convention agreed with the backend — PR 7086 in alexander/xpsearch-aggregator).
 *
 * Team name options are fetched from AGG's `search.configuration.thirdPartyMSTeamsWorkspaces`
 * endpoint (the same pattern as Slack channels via `thirdPartySlackChannels`).
 * Gated behind `rovo_fps_show_workspace_name_filter` (frontend) and
 * `xpsearch-aggregator_teams_team_name_filter` (backend).
 */ const $f213b0b47e1587cf$var$products3PFromConfig = (0, $b12s7.getProducts3PFromConfigForFilter)('workspaceName');
/**
 * Session-level cache: maps cloudId → in-flight or resolved promise of workspace options.
 * This deduplicates concurrent and repeated calls (e.g. queryParams.fetcher + initialOptions.fetcher
 * both fire on page load when a team is pre-selected via URL param).
 * The cache is module-level so it persists for the browser session but resets on page navigation.
 */ const $f213b0b47e1587cf$var$workspaceOptionsCache = new Map();
const $f213b0b47e1587cf$export$c6346c315d8aa4eb = ()=>$f213b0b47e1587cf$var$workspaceOptionsCache.clear();
async function $f213b0b47e1587cf$var$doFetchMSTeamsWorkspaces(config, cloudId) {
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        product: config.primaryProduct,
        cloudId: cloudId,
        activationId: config.activationId
    });
    const workspaces = await (0, $024d722caf4032f5$export$2bb68a7d2eeb3442)({
        cloudId: cloudId,
        aggAbsoluteUrl: config.aggAbsoluteUrl,
        headers: headers
    });
    return workspaces.map((workspace)=>({
            value: workspace.name,
            trackingKey: workspace.id ?? workspace.name,
            queryParamValue: workspace.name,
            label: workspace.name,
            isDefault: false,
            isSelected: false,
            isSuggested: false,
            product: config.product
        }));
}
const $f213b0b47e1587cf$var$fetchWorkspaceOptions = (config)=>{
    const { cloudId: cloudId } = config;
    if (!cloudId) return Promise.resolve([]);
    // Return cached promise (handles both in-flight dedup and session-level caching).
    // If the fetch returns an empty result or rejects, remove the cache entry so a
    // subsequent open/retry can attempt a fresh fetch rather than returning stale empty results.
    if (!$f213b0b47e1587cf$var$workspaceOptionsCache.has(cloudId)) {
        const promise = $f213b0b47e1587cf$var$doFetchMSTeamsWorkspaces(config, cloudId);
        $f213b0b47e1587cf$var$workspaceOptionsCache.set(cloudId, promise);
        promise.then((workspaces)=>{
            if (workspaces.length === 0) $f213b0b47e1587cf$var$workspaceOptionsCache.delete(cloudId);
        }).catch(()=>{
            $f213b0b47e1587cf$var$workspaceOptionsCache.delete(cloudId);
        });
    }
    return $f213b0b47e1587cf$var$workspaceOptionsCache.get(cloudId);
};
const $f213b0b47e1587cf$var$fetchQueryParams = async (queryParams, config)=>{
    // Hydrate selected team names from URL params by client-side filtering
    // the full fetched list — no extra API call needed.
    const allOptions = await $f213b0b47e1587cf$var$fetchWorkspaceOptions(config);
    const selected = new Set(queryParams);
    return allOptions.filter((option)=>selected.has(option.queryParamValue));
};
const $f213b0b47e1587cf$var$lookupWorkspaces = async (query, config)=>{
    const allOptions = await $f213b0b47e1587cf$var$fetchWorkspaceOptions(config);
    if (!query) return allOptions;
    return (0, $5irgt.fuzzyFilter)(query, allOptions, (option)=>option.label);
};
const $f213b0b47e1587cf$export$3dea766d36a8935f = (0, $6Ea6j.createMultiSelectFilter)({
    id: 'workspaceName',
    products: $f213b0b47e1587cf$var$products3PFromConfig,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'workspaceName',
        fetcher: async (queryParams, config)=>{
            return $f213b0b47e1587cf$var$fetchQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $f213b0b47e1587cf$var$fetchWorkspaceOptions(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            return $f213b0b47e1587cf$var$lookupWorkspaces(query, config);
        }
    }
});
module.exports["filter"] = $f213b0b47e1587cf$export$3dea766d36a8935f;

});

parcelRegister("iQfUJ", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $2XcAT = parcelRequire("2XcAT");

const $aee4092edb99d139$export$d2312e68e1f5ad00 = ({ initial: initial, state: state, config: config })=>{
    return (options)=>{
        const productBasedOptionsFilter = (0, $dh538.fg)('product_based_filter_options') ? (option)=>{
            return option.product === (0, $2XcAT.getProductForFilterOption)({
                config: config,
                isUniversal: initial.universal
            });
        } : ()=>true;
        const allSelectedValues = new Set([
            ...state.queryParams.options.filter(productBasedOptionsFilter).filter((option)=>option.isSelected).map((option)=>option.value),
            ...state.initialOptions.options.filter(productBasedOptionsFilter).filter((option)=>option.isSelected).map((option)=>option.value),
            ...state.lookup.options.filter(productBasedOptionsFilter).filter((lookupOption)=>lookupOption.isSelected).map((option)=>option.value)
        ]);
        if (options.isLookupActive) {
            const lookupResults = state.lookup.lookupResultOptions.map((option)=>({
                    ...option,
                    isSelected: allSelectedValues.has(option.value)
                })).sort((option1, option2)=>Number(option2.isSelected) - Number(option1.isSelected));
            return lookupResults;
        }
        const duplicateOptions = new Set();
        const newOptions = [
            ...state.queryParams.options,
            // 'interacted' lookup options are options that a user made a lookup for and has either
            // selected or deselected an option from a lookup query
            // The 'interacted' options are persisted in  state.lookup.options
            ...state.lookup.options,
            ...state.initialOptions.options
        ].filter(productBasedOptionsFilter).filter((option)=>!duplicateOptions.has(option.value) && duplicateOptions.add(option.value)).map((option)=>({
                ...option,
                isSelected: allSelectedValues.has(option.value)
            }));
        if (initial.sortCompareFn) return newOptions.sort(initial.sortCompareFn);
        return newOptions;
    };
};
module.exports["getOptions"] = $aee4092edb99d139$export$d2312e68e1f5ad00;

});

parcelRegister("6Ea6j", function(module, exports) {

var $k1VvQ = parcelRequire("k1VvQ");


var $8vGYx = parcelRequire("8vGYx");


var $iQfUJ = parcelRequire("iQfUJ");

const $bbb289b791cf3bdd$export$9c05e038f495cba8 = (initial)=>{
    const initialState = Object.freeze({
        id: initial.id,
        type: 'multi-select',
        didMount: false,
        didMountPerProducts: {},
        hasSelection: false,
        alwaysVisible: initial.alwaysVisible,
        universal: initial.universal,
        queryParams: {
            isLoading: false,
            options: []
        },
        lookup: {
            isLoading: false,
            isActive: false,
            isDefined: !!initial.lookup,
            options: [],
            lookupResultOptions: [],
            input: ''
        },
        initialOptions: {
            options: [],
            isLoading: false
        },
        options: [],
        selectedOptions: [],
        value: [],
        products: initial.products
    });
    return {
        id: initial.id,
        type: initialState.type,
        queryParams: {
            key: initial.queryParams.key,
            getState: (initial.queryParams.generateQueryParamsGetState ?? (0, $8vGYx.generateQueryParamsGetState))(initialState, initial.queryParams.key)
        },
        products: initial.products,
        universal: initial.universal,
        customValueFields: initial.customValueFields,
        withState: (state, config)=>$bbb289b791cf3bdd$export$63027158d47e5479({
                initial: initial,
                state: state,
                config: config
            }),
        getInitialState: (config)=>$bbb289b791cf3bdd$export$63027158d47e5479({
                initial: initial,
                state: initialState,
                config: config
            }),
        isCompatible: (id)=>id === initial.id,
        isSupportCustomValue: false,
        isSuggestedFilter: initial.isSuggestedFilter,
        requiresTopLevel3PDatasource: initial.requiresTopLevel3PDatasource
    };
};
const $bbb289b791cf3bdd$export$63027158d47e5479 = ({ initial: initial, state: state, config: config })=>{
    const filterState = Object.freeze({
        ...state
    });
    return {
        id: initial.id,
        type: filterState.type,
        getState: (0, $k1VvQ.getState)({
            initial: initial,
            state: filterState,
            config: config
        }),
        queryParams: {
            key: initial.queryParams.key,
            get: (0, $k1VvQ.getQueryParams)({
                initial: initial,
                state: filterState,
                config: config
            }),
            set: (0, $k1VvQ.setQueryParams)({
                initial: initial,
                state: filterState,
                config: config
            })
        },
        loadInitialOptions: (0, $k1VvQ.loadInitialOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        setOption: (0, $k1VvQ.setOption)({
            initial: initial,
            state: filterState,
            config: config
        }),
        clearOptions: (0, $k1VvQ.clearOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        setLookupInput: (0, $k1VvQ.setLookupInput)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getOptions: (0, $iQfUJ.getOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getValue: (0, $k1VvQ.getValue)({
            initial: initial,
            state: filterState,
            config: config
        }),
        clear: (0, $k1VvQ.deselectOptions)({
            initial: initial,
            state: filterState,
            config: config
        })
    };
};
module.exports["createMultiSelectFilter"] = $bbb289b791cf3bdd$export$9c05e038f495cba8;
module.exports["MultiSelectFilter"] = $bbb289b791cf3bdd$export$63027158d47e5479;

});

parcelRegister("k8y62", function(module, exports) {
const $7a01bb01e0257cf1$export$1e3b02869b42f77a = [
    'ati:cloud:graph:space'
];
module.exports["DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI"] = $7a01bb01e0257cf1$export$1e3b02869b42f77a;

});

parcelRegister("k1VvQ", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $iQfUJ = parcelRequire("iQfUJ");


var $2XcAT = parcelRequire("2XcAT");


const $a744869393e3dad8$export$639eaf0f64f8fe4 = ({ initial: initial, state: state, config: config })=>{
    const filterState = Object.freeze({
        ...state
    });
    return {
        id: initial.id,
        type: filterState.type,
        getState: $a744869393e3dad8$export$50fdfeece43146fd({
            initial: initial,
            state: filterState,
            config: config
        }),
        queryParams: {
            key: initial.queryParams.key,
            get: $a744869393e3dad8$export$e2de15bbd9edf9c6({
                initial: initial,
                state: filterState,
                config: config
            }),
            set: $a744869393e3dad8$export$7755017099c85a0d({
                initial: initial,
                state: filterState,
                config: config
            })
        },
        loadInitialOptions: $a744869393e3dad8$export$ad6c12f692e14555({
            initial: initial,
            state: filterState,
            config: config
        }),
        setOption: $a744869393e3dad8$export$b2a7969df3fe0aa3({
            initial: initial,
            state: filterState,
            config: config
        }),
        clearOptions: $a744869393e3dad8$export$69017055aa8b346e({
            initial: initial,
            state: filterState,
            config: config
        }),
        setLookupInput: $a744869393e3dad8$export$92164aa84e23cd67({
            initial: initial,
            state: filterState,
            config: config
        }),
        getOptions: (0, $iQfUJ.getOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getValue: $a744869393e3dad8$export$bf7199a9ebcb84a9({
            initial: initial,
            state: filterState,
            config: config
        }),
        clear: $a744869393e3dad8$export$d0f857db6e3e26d7({
            initial: initial,
            state: filterState,
            config: config
        })
    };
};
const $a744869393e3dad8$export$50fdfeece43146fd = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const filter = $a744869393e3dad8$export$639eaf0f64f8fe4({
            initial: initial,
            state: state,
            config: config
        });
        const allOptions = filter.getOptions({
            isLookupActive: false
        });
        const newOptions = filter.getOptions({
            isLookupActive: state.lookup.isActive
        });
        const selectedOptions = allOptions.filter((option)=>option.isSelected);
        const newState = {
            ...state,
            options: newOptions,
            selectedOptions: selectedOptions,
            hasSelection: selectedOptions.length > 0,
            value: filter.getValue()
        };
        return newState;
    };
};
const $a744869393e3dad8$export$7755017099c85a0d = ({ initial: initial, state: state, config: config })=>{
    return async (queryParams, onStateChange)=>{
        const queryParamValues = queryParams[initial.queryParams.key];
        const filter = $a744869393e3dad8$export$639eaf0f64f8fe4({
            initial: initial,
            state: state,
            config: config
        });
        if (!queryParamValues) {
            const clearedOptions = filter.clearOptions();
            onStateChange?.(clearedOptions.getState());
            return clearedOptions;
        }
        const allCurrentOptions = filter.getOptions({
            isLookupActive: false
        });
        const allQueryParamValues = allCurrentOptions.map((option)=>option.queryParamValue);
        const queryParamsToHydrate = queryParamValues.filter((value)=>!allQueryParamValues.includes(value));
        if (queryParamsToHydrate.length === 0) {
            const newOptions = allCurrentOptions.map((option)=>({
                    isSelected: queryParamValues.includes(option.queryParamValue),
                    value: option.value
                }));
            const filterWithNewOptions = filter.setOption(newOptions);
            onStateChange?.(filterWithNewOptions.getState());
            return filterWithNewOptions;
        }
        // At this point we need to hydrate the filters with new options from
        // the query params
        const newQueryParamOptions = [
            ...state.queryParams.options
        ];
        const fetcher = initial.queryParams.fetcher;
        if (fetcher) {
            onStateChange?.({
                ...state,
                queryParams: {
                    ...state.queryParams,
                    isLoading: true
                }
            });
            const fetchedOptions = await fetcher(queryParamsToHydrate, config);
            fetchedOptions.forEach((option)=>{
                const mappedOption = {
                    isSelected: true,
                    trackingKey: option.trackingKey,
                    value: option.value,
                    queryParamValue: option.queryParamValue,
                    isSuggested: false,
                    isDefault: option.isDefault ?? false,
                    avatarUrl: option.avatarUrl,
                    label: option.label,
                    metadata: option.metadata,
                    product: (0, $2XcAT.getProductForFilterOption)({
                        config: config,
                        isUniversal: initial.universal
                    })
                };
                newQueryParamOptions.push(mappedOption);
            });
        }
        const selectedOptionsFromQueryParams = newQueryParamOptions.map((option)=>({
                ...option,
                isSelected: queryParamValues.includes(option.queryParamValue)
            }));
        const selectedInitialOptionsFromQueryParams = [
            ...state.initialOptions.options
        ].map((option)=>({
                ...option,
                isSelected: queryParamValues.includes(option.queryParamValue)
            }));
        const hydratedQueryParams = $a744869393e3dad8$export$639eaf0f64f8fe4({
            initial: initial,
            state: {
                ...state,
                queryParams: {
                    ...state.queryParams,
                    options: selectedOptionsFromQueryParams,
                    isLoading: false
                },
                initialOptions: {
                    ...state.initialOptions,
                    options: selectedInitialOptionsFromQueryParams
                }
            },
            config: config
        });
        onStateChange?.(hydratedQueryParams.getState());
        return hydratedQueryParams;
    };
};
const $a744869393e3dad8$export$e2de15bbd9edf9c6 = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const queryParamValue = $a744869393e3dad8$export$639eaf0f64f8fe4({
            initial: initial,
            state: state,
            config: config
        }).getOptions({
            isLookupActive: false
        }).filter((option)=>option.isSelected).map((option)=>option.queryParamValue);
        return {
            [initial.queryParams.key]: queryParamValue
        };
    };
};
const $a744869393e3dad8$export$ad6c12f692e14555 = ({ initial: initial, state: state, config: config })=>{
    return async (onStateChange)=>{
        const didMount = (0, $dh538.fg)('product_based_filter_options') ? state.didMountPerProducts[(0, $2XcAT.getProductForFilterOption)({
            config: config,
            isUniversal: initial.universal
        })] : state.didMount;
        if (didMount) // Already loaded — return the current monad without dispatching a state change.
        // Calling onStateChange here would cause a no-op store write (new object identity
        // for the same data), which makes downstream selectors that return derived references
        // (e.g. useFilters() consumers that compute new arrays/Sets) re-render. When the
        // caller is a useEffect that depends on derived values, this can trigger an
        // infinite render loop. The store should only change when something actually changed.
        return $a744869393e3dad8$export$639eaf0f64f8fe4({
            initial: initial,
            state: state,
            config: config
        });
        const newOptions = [
            ...state.initialOptions.options
        ];
        const fetcher = initial.initialOptions?.fetcher;
        if (fetcher) {
            const fetchingInitialOptionsState = {
                ...state,
                initialOptions: {
                    ...state.initialOptions,
                    isLoading: true
                }
            };
            onStateChange?.(fetchingInitialOptionsState);
            try {
                const fetchedOptions = await fetcher(config);
                fetchedOptions.forEach((option)=>{
                    const mappedOption = {
                        isSelected: false,
                        trackingKey: option.trackingKey,
                        value: option.value,
                        queryParamValue: option.queryParamValue,
                        isSuggested: true,
                        isDefault: option.isDefault ?? false,
                        avatarUrl: option.avatarUrl,
                        label: option.label,
                        metadata: option.metadata,
                        product: (0, $2XcAT.getProductForFilterOption)({
                            config: config,
                            isUniversal: initial.universal
                        })
                    };
                    newOptions.push(mappedOption);
                });
            } catch  {
                const fetchFailedState = {
                    ...state,
                    initialOptions: {
                        ...state.initialOptions,
                        isLoading: false
                    }
                };
                onStateChange?.(fetchFailedState);
            }
        }
        const newInitialOptionsState = {
            ...state,
            didMount: true,
            didMountPerProducts: (0, $dh538.fg)('product_based_filter_options') ? {
                ...state.didMountPerProducts,
                [(0, $2XcAT.getProductForFilterOption)({
                    config: config,
                    isUniversal: initial.universal
                })]: true
            } : state.didMountPerProducts,
            initialOptions: {
                ...state.initialOptions,
                options: newOptions,
                isLoading: false
            }
        };
        onStateChange?.(newInitialOptionsState);
        return $a744869393e3dad8$export$639eaf0f64f8fe4({
            initial: initial,
            state: newInitialOptionsState,
            config: config
        });
    };
};
const $a744869393e3dad8$export$b2a7969df3fe0aa3 = ({ initial: initial, state: state, config: config })=>{
    return (option)=>{
        const optionsToChange = Array.isArray(option) ? option : [
            option
        ];
        const optionsToChangeRecord = Object.fromEntries(optionsToChange.map((option)=>[
                option.value,
                option
            ]));
        const allExistingValues = new Set([
            ...state.queryParams.options.map((o)=>o.value),
            ...state.initialOptions.options.map((o)=>o.value),
            ...state.lookup.options.map((o)=>o.value),
            ...state.lookup.lookupResultOptions.map((o)=>o.value)
        ]);
        // Options being selected that don't exist in any list yet (e.g. dynamic async-loaded options
        // selected before the store has been populated) are added directly to queryParams.options so
        // they participate in URL param generation immediately.
        const newQueryParamOptions = optionsToChange.filter((o)=>o.isSelected && !allExistingValues.has(o.value)).map((o)=>({
                value: o.value,
                queryParamValue: o.value,
                trackingKey: o.value,
                label: o.value,
                isSelected: true,
                isSuggested: false,
                isDefault: false,
                product: (0, $2XcAT.getProductForFilterOption)({
                    config: config,
                    isUniversal: initial.universal
                })
            }));
        const queryParamOptions = [
            ...state.queryParams.options.map((option)=>{
                if (!optionsToChange.find((x)=>x.value === option.value && ((0, $dh538.fg)('product_based_filter_options') ? (0, $2XcAT.getProductForFilterOption)({
                        config: config,
                        isUniversal: initial.universal
                    }) === option.product : true))) return option;
                return {
                    ...option,
                    isSelected: optionsToChangeRecord[option.value]?.isSelected ?? false
                };
            }),
            ...newQueryParamOptions
        ];
        const initialOptions = state.initialOptions.options.map((option)=>{
            if (!optionsToChange.find((x)=>x.value === option.value && ((0, $dh538.fg)('product_based_filter_options') ? (0, $2XcAT.getProductForFilterOption)({
                    config: config,
                    isUniversal: initial.universal
                }) === option.product : true))) return option;
            return {
                ...option,
                isSelected: optionsToChangeRecord[option.value]?.isSelected ?? false
            };
        });
        const duplicateOptions = new Set();
        const lookupOptions = [
            ...state.lookup.options,
            // 'interacted' lookup options are options that a user made a lookup for and has either
            // selected or deselected an option from a lookup query
            // The 'interacted' options are persisted in  state.lookup.options
            ...state.lookup.lookupResultOptions.flatMap((option)=>{
                if (!optionsToChange.find((x)=>x.value === option.value)) return [];
                return [
                    option
                ];
            })
        ].filter((option)=>!duplicateOptions.has(option.value) && duplicateOptions.add(option.value)).map((option)=>({
                ...option,
                isSuggested: true,
                isSelected: optionsToChangeRecord[option.value]?.isSelected ?? option.isSelected
            }));
        return $a744869393e3dad8$export$639eaf0f64f8fe4({
            initial: initial,
            state: {
                ...state,
                initialOptions: {
                    ...state.initialOptions,
                    options: initialOptions
                },
                queryParams: {
                    ...state.queryParams,
                    options: queryParamOptions
                },
                lookup: {
                    ...state.lookup,
                    options: lookupOptions
                }
            },
            config: config
        });
    };
};
const $a744869393e3dad8$export$69017055aa8b346e = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const queryParamOptions = state.queryParams.options.map((option)=>({
                ...option,
                isSelected: false
            }));
        const initialOptions = state.initialOptions.options.map((option)=>({
                ...option,
                isSelected: false
            }));
        const lookupOptions = state.lookup.options.map((option)=>({
                ...option,
                isSelected: false
            }));
        return $a744869393e3dad8$export$639eaf0f64f8fe4({
            initial: initial,
            state: {
                ...state,
                initialOptions: {
                    ...state.initialOptions,
                    options: initialOptions
                },
                queryParams: {
                    ...state.queryParams,
                    options: queryParamOptions
                },
                lookup: {
                    ...state.lookup,
                    options: lookupOptions
                }
            },
            config: config
        });
    };
};
const $a744869393e3dad8$export$92164aa84e23cd67 = ({ initial: initial, state: state, config: config })=>{
    return async (query, onStateChange)=>{
        if (!initial.lookup || query.length === 0 || state.lookup.input === query) {
            const noQueryState = {
                ...state,
                lookup: {
                    ...state.lookup,
                    input: query,
                    isLoading: false,
                    isActive: false
                }
            };
            onStateChange?.(noQueryState);
            return $a744869393e3dad8$export$639eaf0f64f8fe4({
                initial: initial,
                state: noQueryState,
                config: config
            });
        }
        const fetchingLookupOptionsState = {
            ...state,
            lookup: {
                ...state.lookup,
                input: query,
                isLoading: true,
                isActive: true
            }
        };
        onStateChange?.(fetchingLookupOptionsState);
        try {
            const fetchedLookupOptions = await initial.lookup.fetcher(query, config);
            const newLookupOptions = fetchedLookupOptions.map((option)=>{
                const mappedOption = {
                    isSelected: false,
                    trackingKey: option.trackingKey,
                    value: option.value,
                    queryParamValue: option.queryParamValue,
                    isSuggested: false,
                    isDefault: option.isDefault ?? false,
                    avatarUrl: option.avatarUrl,
                    label: option.label,
                    metadata: option.metadata,
                    product: (0, $2XcAT.getProductForFilterOption)({
                        config: config,
                        isUniversal: initial.universal
                    })
                };
                return mappedOption;
            });
            const newLookupOptionsState = {
                ...state,
                lookup: {
                    ...state.lookup,
                    input: query,
                    lookupResultOptions: newLookupOptions,
                    isLoading: false,
                    isActive: true
                }
            };
            onStateChange?.(newLookupOptionsState);
            return $a744869393e3dad8$export$639eaf0f64f8fe4({
                initial: initial,
                state: newLookupOptionsState,
                config: config
            });
        } catch  {
            const failedLookupOptionsState = {
                ...state,
                lookup: {
                    ...state.lookup,
                    input: query,
                    isLoading: false,
                    isActive: true
                }
            };
            onStateChange?.(failedLookupOptionsState);
            return $a744869393e3dad8$export$639eaf0f64f8fe4({
                initial: initial,
                state: failedLookupOptionsState,
                config: config
            });
        }
    };
};
const $a744869393e3dad8$export$bf7199a9ebcb84a9 = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        return $a744869393e3dad8$export$639eaf0f64f8fe4({
            initial: initial,
            state: state,
            config: config
        }).getOptions({
            isLookupActive: false
        }).filter((option)=>option.isSelected).map((option)=>option.value);
    };
};
const $a744869393e3dad8$export$d0f857db6e3e26d7 = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const filter = $a744869393e3dad8$export$639eaf0f64f8fe4({
            initial: initial,
            state: state,
            config: config
        });
        const allOptions = [
            ...filter.getOptions({
                isLookupActive: true
            }),
            ...filter.getOptions({
                isLookupActive: false
            })
        ].map((option)=>({
                value: option.value,
                isSelected: false
            }));
        return filter.setOption(allOptions);
    };
};
module.exports["getState"] = $a744869393e3dad8$export$50fdfeece43146fd;
module.exports["getQueryParams"] = $a744869393e3dad8$export$e2de15bbd9edf9c6;
module.exports["setQueryParams"] = $a744869393e3dad8$export$7755017099c85a0d;
module.exports["loadInitialOptions"] = $a744869393e3dad8$export$ad6c12f692e14555;
module.exports["setOption"] = $a744869393e3dad8$export$b2a7969df3fe0aa3;
module.exports["clearOptions"] = $a744869393e3dad8$export$69017055aa8b346e;
module.exports["setLookupInput"] = $a744869393e3dad8$export$92164aa84e23cd67;
module.exports["getValue"] = $a744869393e3dad8$export$bf7199a9ebcb84a9;
module.exports["deselectOptions"] = $a744869393e3dad8$export$d0f857db6e3e26d7;

});

parcelRegister("8vGYx", function(module, exports) {
const $5ee914132ae7909c$export$64e49a0c7bd6f7a0 = (initialState, queryParamKey)=>{
    return (queryParams)=>{
        const queryParamValue = queryParams[queryParamKey];
        return {
            ...initialState,
            value: queryParamValue || initialState.value
        };
    };
};
module.exports["generateQueryParamsGetState"] = $5ee914132ae7909c$export$64e49a0c7bd6f7a0;

});

parcelRegister("5A2fk", function(module, exports) {

var $5G9KX = parcelRequire("5G9KX");

const $c8070074de509682$var$OAUTH_BANNER_DISMISS_KEY = 'atlassian.unified-search.oauth-banner-dismiss-counts';
const $c8070074de509682$export$afe8c16e492e553f = (product, enforceMaxDismissals)=>{
    const dismissCounts = $c8070074de509682$var$getLocalStorageData();
    const hasUserDismissedThisProductBefore = (dismissCounts[product] ?? 0) > 0;
    if (enforceMaxDismissals) return !(hasUserDismissedThisProductBefore || $c8070074de509682$export$67e3eb5caec4ff4c(dismissCounts));
    return !hasUserDismissedThisProductBefore;
};
/**
 * The max number of times the user dismisses **across products**
 */ const $c8070074de509682$var$MAX_DISMISSALS = 4;
const $c8070074de509682$export$67e3eb5caec4ff4c = (dismissCounts)=>{
    const totalDismissalsAcrossProducts = Object.values(dismissCounts).reduce((prev, curr)=>(prev ?? 0) + (curr ?? 0), 0);
    return (totalDismissalsAcrossProducts ?? 0) >= $c8070074de509682$var$MAX_DISMISSALS;
};
const $c8070074de509682$export$94f957a0ee1d39c8 = (product)=>{
    const dismissCounts = $c8070074de509682$var$getLocalStorageData();
    dismissCounts[product] = (dismissCounts[product] ?? 0) + 1;
    $c8070074de509682$var$saveToLocalStorage(dismissCounts);
};
/**
 * @returns the local storage object that stores products and their dismiss counts
 */ const $c8070074de509682$var$getLocalStorageData = ()=>{
    const serializedDismissCounts = (0, $5G9KX.getLocalStorageItemAsString)($c8070074de509682$var$OAUTH_BANNER_DISMISS_KEY);
    if (!serializedDismissCounts) return {};
    let localStorageObject;
    try {
        localStorageObject = JSON.parse(serializedDismissCounts);
    } catch  {
        return {};
    }
    return localStorageObject;
};
/**
 * Saves the local storage object that stores products and their dismiss counts
 */ const $c8070074de509682$var$saveToLocalStorage = (localStorageObject)=>{
    (0, $5G9KX.setLocalStorageItem)($c8070074de509682$var$OAUTH_BANNER_DISMISS_KEY, JSON.stringify(localStorageObject));
};
const $c8070074de509682$export$f24b3540a3490d2b = 'atlassian.unified-search.oauth-banner-snooze';
const $c8070074de509682$export$fa2e89afea4272f6 = 86400000;
const $c8070074de509682$export$b05c8721285367dc = [
    1,
    1,
    1,
    90
];
/**
 * @returns the full snooze data object from localStorage, or an empty object
 * if absent or unparseable.
 */ const $c8070074de509682$var$getSnoozeData = ()=>{
    try {
        const raw = (0, $5G9KX.getLocalStorageItemAsString)($c8070074de509682$export$f24b3540a3490d2b);
        if (!raw) return {};
        return JSON.parse(raw);
    } catch  {
        return {};
    }
};
/**
 * Persists the snooze data object to localStorage.
 */ const $c8070074de509682$var$saveSnoozeData = (data, logException)=>{
    try {
        (0, $5G9KX.setLocalStorageItem)($c8070074de509682$export$f24b3540a3490d2b, JSON.stringify(data));
    } catch (error) {
        logException?.(error);
    }
};
const $c8070074de509682$export$2951fa9679f910c = (product)=>{
    const entry = $c8070074de509682$var$getSnoozeData()[product];
    if (!entry) return false;
    return Date.now() < entry.expiresAt;
};
const $c8070074de509682$export$4322d9b6ec307e17 = (product)=>{
    return $c8070074de509682$var$getSnoozeData()[product]?.dismissalCount ?? 0;
};
const $c8070074de509682$export$e173328a0c65b798 = (product, logException)=>{
    const data = $c8070074de509682$var$getSnoozeData();
    const storedCount = data[product]?.dismissalCount ?? 0;
    // If the previous cycle has completed (count === SNOOZE_DAYS.length),
    // reset to index 0 to restart the cycle on this dismiss.
    const dismissIndex = storedCount >= $c8070074de509682$export$b05c8721285367dc.length ? 0 : storedCount;
    const durationDays = $c8070074de509682$export$b05c8721285367dc[dismissIndex];
    const expiresAt = Date.now() + durationDays * $c8070074de509682$export$fa2e89afea4272f6;
    // The new stored count is the index we just used plus 1. This means after
    // the 4th dismiss the count is 4 (used to detect cycle completion on the
    // 5th dismiss), and after the 5th dismiss it resets to 1.
    const nextCount = dismissIndex + 1;
    data[product] = {
        expiresAt: expiresAt,
        dismissalCount: nextCount
    };
    $c8070074de509682$var$saveSnoozeData(data, logException);
};
module.exports["shouldShowOAuthBanner"] = $c8070074de509682$export$afe8c16e492e553f;
module.exports["increaseProductDismissCount"] = $c8070074de509682$export$94f957a0ee1d39c8;
module.exports["isProductSnoozed"] = $c8070074de509682$export$2951fa9679f910c;
module.exports["snoozeProduct"] = $c8070074de509682$export$e173328a0c65b798;

});

parcelRegister("dnIVK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ckkm9 = parcelRequire("ckkm9");


var $gRvZB = parcelRequire("gRvZB");


var $1ymk3 = parcelRequire("1ymk3");


var $3CshZ = parcelRequire("3CshZ");

const $8aec6073a00f3ac5$export$694cb0e3f167dbc8 = ({ cloudId: cloudId, product: product, connectorSource: connectorSource, isOnSearchDialog: isOnSearchDialog, thirdPartyConfigs: thirdPartyConfigs, extraAttributes: extraAttributes })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const callback = (0, $42omo.useCallback)((oAuthSource)=>{
        fireAnalyticsEvent((0, $ckkm9.onOAuthStarted)({
            cloudId: cloudId,
            product: product,
            connectorSource: connectorSource,
            commonAttributes: {
                ...commonAttributes,
                ...(0, $1ymk3.getExtensionData)(commonAttributes.isCQL)
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            isOnSearchDialog: isOnSearchDialog,
            oAuthSource: oAuthSource,
            isImpersonated: (0, $gRvZB.isProductImpersonated)(product, thirdPartyConfigs),
            extraAttributes: extraAttributes
        }));
    }, [
        fireAnalyticsEvent,
        cloudId,
        product,
        connectorSource,
        commonAttributes,
        nonPrivacySafeAttributes,
        isOnSearchDialog,
        thirdPartyConfigs,
        extraAttributes
    ]);
    return callback;
};
const $8aec6073a00f3ac5$export$cbd7e681ca5b8fd4 = ({ cloudId: cloudId, product: product, connectorSource: connectorSource, isOnSearchDialog: isOnSearchDialog, thirdPartyConfigs: thirdPartyConfigs, extraAttributes: extraAttributes })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const callback = (0, $42omo.useCallback)((oAuthSource)=>{
        fireAnalyticsEvent((0, $ckkm9.onOAuthCompleted)({
            cloudId: cloudId,
            product: product,
            connectorSource: connectorSource,
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            isOnSearchDialog: isOnSearchDialog,
            oAuthSource: oAuthSource,
            isImpersonated: (0, $gRvZB.isProductImpersonated)(product, thirdPartyConfigs),
            extraAttributes: extraAttributes
        }));
    }, [
        fireAnalyticsEvent,
        cloudId,
        product,
        connectorSource,
        commonAttributes,
        nonPrivacySafeAttributes,
        isOnSearchDialog,
        thirdPartyConfigs,
        extraAttributes
    ]);
    return callback;
};
const $8aec6073a00f3ac5$export$cff3d5cd941b3b4d = ({ cloudId: cloudId, product: product, connectorSource: connectorSource, isOnSearchDialog: isOnSearchDialog, thirdPartyConfigs: thirdPartyConfigs, extraAttributes: extraAttributes })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const callback = (0, $42omo.useCallback)((oAuthSource)=>{
        fireAnalyticsEvent((0, $ckkm9.onOAuthFailed)({
            cloudId: cloudId,
            product: product,
            connectorSource: connectorSource,
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            isOnSearchDialog: isOnSearchDialog,
            oAuthSource: oAuthSource,
            isImpersonated: (0, $gRvZB.isProductImpersonated)(product, thirdPartyConfigs),
            extraAttributes: extraAttributes
        }));
    }, [
        fireAnalyticsEvent,
        cloudId,
        product,
        connectorSource,
        commonAttributes,
        nonPrivacySafeAttributes,
        isOnSearchDialog,
        thirdPartyConfigs,
        extraAttributes
    ]);
    return callback;
};
const $8aec6073a00f3ac5$export$3168f7d5a2074317 = ({ cloudId: cloudId, product: product, connectorSource: connectorSource, isOnSearchDialog: isOnSearchDialog, thirdPartyConfigs: thirdPartyConfigs, extraAttributes: extraAttributes })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3CshZ.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $3CshZ.useCommonAndPrivateAttributes)();
    const callback = (0, $42omo.useCallback)((oAuthSource)=>{
        fireAnalyticsEvent((0, $ckkm9.onOAuthConnectHovered)({
            cloudId: cloudId,
            product: product,
            connectorSource: connectorSource,
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            isOnSearchDialog: isOnSearchDialog,
            oAuthSource: oAuthSource,
            isImpersonated: (0, $gRvZB.isProductImpersonated)(product, thirdPartyConfigs),
            extraAttributes: extraAttributes
        }));
    }, [
        fireAnalyticsEvent,
        cloudId,
        product,
        connectorSource,
        commonAttributes,
        nonPrivacySafeAttributes,
        isOnSearchDialog,
        thirdPartyConfigs,
        extraAttributes
    ]);
    return callback;
};
module.exports["useFireOAuthStarted"] = $8aec6073a00f3ac5$export$694cb0e3f167dbc8;
module.exports["useFireOAuthCompleted"] = $8aec6073a00f3ac5$export$cbd7e681ca5b8fd4;
module.exports["useFireOAuthFailed"] = $8aec6073a00f3ac5$export$cff3d5cd941b3b4d;
module.exports["useFireOAuthHovered"] = $8aec6073a00f3ac5$export$3168f7d5a2074317;

});

parcelRegister("kP8IJ", function(module, exports) {
const $0bc2da65dd976c36$export$bb417e0702eb86b5 = (isSelected)=>{
    if (isSelected) return "var(--ds-icon-selected, #1868DB)";
    return "var(--ds-icon-subtle, #505258)";
};
module.exports["getIconColor"] = $0bc2da65dd976c36$export$bb417e0702eb86b5;

});

parcelRegister("9bPlJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cd6c6061ead1c7bf826f9b8997aa8670>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6b0cf9138ae8faa3$var$_react = $6b0cf9138ae8faa3$var$_interopRequireDefault((parcelRequire("42omo")));

var $6b0cf9138ae8faa3$var$_baseNew = $6b0cf9138ae8faa3$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $6b0cf9138ae8faa3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Signature".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Toggle author visibility on sticky notes in Whiteboards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6b0cf9138ae8faa3$var$SignatureIcon = (props)=>/*#__PURE__*/ $6b0cf9138ae8faa3$var$_react.default.createElement($6b0cf9138ae8faa3$var$_baseNew.default, Object.assign({
        name: "SignatureIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 14H0v-1.5h16zM2.83 2.27c.62-.41 1.4-.47 2.24-.24.58.15 1.03.48 1.32.95.28.45.39.98.38 1.49-.02 1.01-.47 2.14-1.16 3.1-.33.46-.74.93-1.18 1.38q.03.03.05.06c.32.33.62.48.88.5.24.02.57-.05.99-.44.44-.4.94-1.09 1.47-2.23a.75.75 0 0 1 1.42.46v.02l-.01.08c-.01.07-.02.18-.04.31-.02.26-.03.59.01.9.05.32.14.56.25.7.09.11.23.21.55.21.83 0 1.35-.56 1.53-1.21a.75.75 0 0 1 1.47.15v-.01.02a1.1 1.1 0 0 0 .22.46c.19.23.65.6 1.78.6V11c-1.35 0-2.23-.41-2.77-.96.36-.4.61-.87.74-1.33l-.72-.21.75-.05-.75.05c-.75.05-.75.06-.75.06v.02a1 1 0 0 0 .02.13q.02.12.08.3a2.6 2.6 0 0 0 .63 1.03c-.51.56-1.25.96-2.23.96-.74 0-1.32-.28-1.71-.76a2.4 2.4 0 0 1-.38-.66c.44-.55.87-1.25 1.27-2.13l-.68-.31-.73-.15V7l-.01.03-.02.12a6 6 0 0 0-.05.4 5.6 5.6 0 0 0 .02 1.25c.04.25.1.52.2.78q-.27.33-.55.58c-.65.6-1.38.89-2.13.82-.73-.06-1.34-.45-1.82-.94l-.06-.06q-.17.15-.32.29a35 35 0 0 1-1.54 1.29l-.02.02-.01.01L1 11l-.46-.59h.01l.02-.02a24 24 0 0 0 .41-.32 34 34 0 0 0 1.51-1.33 7 7 0 0 1-.24-.51c-.57-1.33-.84-2.99-.52-4.28.16-.65.49-1.29 1.1-1.69m.79 5.35c.29-.32.56-.63.77-.93.56-.79.86-1.63.88-2.26.01-.31-.06-.52-.14-.66-.08-.12-.2-.23-.44-.3-.56-.15-.87-.06-1.04.05-.18.12-.36.36-.46.79-.21.87-.05 2.17.44 3.31" clip-rule="evenodd"/><path fill="currentcolor" d="M7.91 9.58c.44-.55.87-1.25 1.27-2.13l-.68-.31-.73-.15V7l-.01.03-.02.12a6 6 0 0 0-.05.4 5.6 5.6 0 0 0 .02 1.25c.04.25.1.52.2.78m4.32.46c.36-.4.61-.87.74-1.33l-.72-.21c-.75.05-.75.06-.75.06v.02a1 1 0 0 0 .02.13q.02.12.08.3a2.6 2.6 0 0 0 .63 1.03"/>`
    }, props));
$6b0cf9138ae8faa3$var$SignatureIcon.displayName = 'SignatureIcon';
var $6b0cf9138ae8faa3$var$_default = module.exports.default = $6b0cf9138ae8faa3$var$SignatureIcon;

});

parcelRegister("j5Jtm", function(module, exports) {
const $1c87d14600b4aeb4$export$2f5ba0d1129fe71 = (inputStr)=>{
    const htmlEntities = {
        '&nbsp;': ' ',
        '&lt;': '<',
        '&amp;': '&',
        '&quot;': '"',
        '&gt;': '>'
    };
    return Object.keys(htmlEntities).reduce((str, entity)=>{
        return str.replace(new RegExp(entity, 'g'), htmlEntities[entity]);
    }, inputStr);
};
module.exports["replaceHtmlEntities"] = $1c87d14600b4aeb4$export$2f5ba0d1129fe71;

});

parcelRegister("iwLe7", function(module, exports) {
const $d278cee22bfa7c6a$export$158516eb8829fc93 = (timestamp)=>{
    if (!timestamp) timestamp = new Date();
    const now = new Date();
    return (now.getTime() - new Date(timestamp).getTime()) / 1000;
};
module.exports["secondsSinceDate"] = $d278cee22bfa7c6a$export$158516eb8829fc93;

});

parcelRegister("akQ4J", function(module, exports) {
const $d91b88cf0ff2b3d5$export$c7b83231a41239c7 = [
    'document'
];
module.exports["SHAREPOINT_RESOURCE_TYPES"] = $d91b88cf0ff2b3d5$export$c7b83231a41239c7;

});

parcelRegister("9ohv9", function(module, exports) {
const $f137b14bb432c6ec$export$5c9d109db494cbec = [
    'message',
    'conversation',
    'video'
];
module.exports["TEAMS_RESOURCE_TYPES"] = $f137b14bb432c6ec$export$5c9d109db494cbec;

});

parcelRegister("7jUYs", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $b8cf047080ff9c5f$export$9f8e6b98f3e412c5 = (0, $aXWIB.defineMessages)({
    all: {
        id: "search-page.filter.type.all",
        defaultMessage: "All"
    },
    position: {
        id: "search-page.filter.type.position",
        defaultMessage: "Positions"
    },
    document: {
        id: "search-page.filter.type.documents",
        defaultMessage: "Documents"
    },
    spreadsheet: {
        id: "search-page.filter.type.spreadsheet",
        defaultMessage: "Spreadsheets"
    },
    presentation: {
        id: "search-page.filter.type.presentation",
        defaultMessage: "Presentations"
    },
    repository: {
        id: "search-page.filter.type.repository",
        defaultMessage: "Repositories"
    },
    'pull-request': {
        id: "search-page.filter.type.pull-request",
        defaultMessage: "Pull requests"
    },
    branch: {
        id: "search-page.filter.type.branch",
        defaultMessage: "Branches"
    },
    commit: {
        id: "search-page.filter.type.commit",
        defaultMessage: "Commits"
    },
    conversation: {
        id: "search-page.filter.type.conversation",
        defaultMessage: "Channels"
    },
    message: {
        id: "search-page.filter.type.message",
        defaultMessage: "Messages"
    },
    video: {
        id: "search-page.filter.type.video",
        defaultMessage: "Videos"
    },
    design: {
        id: "search-page.filter.type.design",
        defaultMessage: "Designs"
    },
    pageAndLiveDoc: {
        id: "search-page.filter.type.pageAndLiveDoc",
        defaultMessage: "Pages and Live Docs"
    },
    page: {
        id: "search-page.filter.type.page",
        defaultMessage: "Pages"
    },
    blogpost: {
        id: "search-page.filter.type.blogpost",
        defaultMessage: "Blog posts"
    },
    attachment: {
        id: "search-page.filter.type.attachment",
        defaultMessage: "Attachments"
    },
    space: {
        id: "search-page.filter.type.space",
        defaultMessage: "Spaces"
    },
    whiteboard: {
        id: "search-page.filter.type.whiteboard",
        defaultMessage: "Whiteboards"
    },
    slide: {
        id: "search-page.filter.type.slide",
        defaultMessage: "Slides"
    },
    issue: {
        id: "search-page.filter.type.jira-work-item",
        defaultMessage: "Work items"
    },
    project: {
        id: "search-page.filter.type.project",
        defaultMessage: "Projects"
    },
    goal: {
        id: "search-page.filter.type.goal",
        defaultMessage: "Goals"
    },
    tag: {
        id: "search-page.filter.type.tag",
        defaultMessage: "Tags"
    },
    'web-page': {
        id: "search-page.filter.type.web-page",
        defaultMessage: "Web pages"
    },
    comment: {
        id: "search-page.filter.type.comment",
        defaultMessage: "Comments"
    },
    database: {
        id: "search-page.filter.type.database",
        defaultMessage: "Databases"
    },
    embed: {
        id: "search-page.filter.type.embed",
        defaultMessage: "Smart Links"
    },
    folder: {
        id: "search-page.filter.type.folder",
        defaultMessage: "Folders"
    },
    calendar: {
        id: "search-page.filter.type.calendar",
        defaultMessage: "Calendars"
    },
    'space-calendar': {
        id: "search-page.filter.type.space-calendar",
        defaultMessage: "Space calendars"
    },
    answer: {
        id: "search-page.filter.type.answer",
        defaultMessage: "Answers"
    },
    question: {
        id: "search-page.filter.type.question",
        defaultMessage: "Questions"
    },
    component: {
        id: "search-page.filter.type.component",
        defaultMessage: "Components"
    },
    'work-item': {
        id: "search-page.filter.type.work-item",
        defaultMessage: "Tasks"
    },
    card: {
        id: "search-page.filter.type.card",
        defaultMessage: "Cards"
    },
    incident: {
        id: "search-page.filter.type.incident",
        defaultMessage: "Incidents"
    },
    'focus-area': {
        id: "search-page.filter.type.focus-area",
        defaultMessage: "Focus areas"
    },
    organization: {
        id: "search-page.filter.type.organization",
        defaultMessage: "Organizations"
    },
    ask: {
        id: "search-page.filter.type.ask",
        defaultMessage: "Asks"
    },
    risk: {
        id: "search-page.filter.type.risk",
        defaultMessage: "Risks"
    },
    dashboard: {
        id: "search-page.filter.type.dashboard",
        defaultMessage: "Dashboards"
    },
    invoice: {
        id: "search-page.filter.type.invoice",
        defaultMessage: "Invoices"
    },
    deal: {
        id: "search-page.filter.type.deal",
        defaultMessage: "Deals"
    },
    gliffy: {
        id: "search-page.filter.type.gliffy",
        defaultMessage: "Gliffy Diagrams"
    },
    'customer-contact': {
        id: "search-page.filter.type.customer-contact",
        defaultMessage: "Customer Contacts"
    },
    'customer-org': {
        id: "search-page.filter.type.customer-org",
        defaultMessage: "Customer Organizations"
    },
    board: {
        id: "search-page.filter.type.board",
        defaultMessage: "Boards"
    },
    plan: {
        id: "search-page.filter.type.plan",
        defaultMessage: "Plans"
    },
    filter: {
        id: "search-page.filter.type.filter",
        defaultMessage: "Filters"
    },
    'data-table': {
        id: "search-page.filter.type.data-table",
        defaultMessage: "Data tables"
    },
    object: {
        id: "search-page.filter.type.object",
        defaultMessage: "Objects"
    },
    schema: {
        id: "search-page.filter.type.schema",
        defaultMessage: "Schemas"
    },
    type: {
        id: "search-page.filter.type.type",
        defaultMessage: "Object types"
    },
    epic: {
        id: "search-page.filter.type.epic",
        defaultMessage: "Epic"
    },
    bug: {
        id: "search-page.filter.type.bug",
        defaultMessage: "Bug"
    },
    story: {
        id: "search-page.filter.type.Story",
        defaultMessage: "Story"
    },
    task: {
        id: "search-page.filter.type.task",
        defaultMessage: "Task"
    },
    subtask: {
        id: "search-page.filter.type.subtask",
        defaultMessage: "Subtask"
    },
    image: {
        id: "search-page.filter.type.image",
        defaultMessage: "Images"
    },
    audio: {
        id: "search-page.filter.type.audio",
        defaultMessage: "Audio"
    },
    pdf: {
        id: "search-page.filter.type.pdf",
        defaultMessage: "PDF"
    },
    shortcut: {
        id: "search-page.filter.type.shortcut",
        defaultMessage: "Shortcut"
    },
    code: {
        id: "search-page.filter.type.code",
        defaultMessage: "Code"
    },
    archive: {
        id: "search-page.filter.type.archive",
        defaultMessage: "Archive"
    },
    form: {
        id: "search-page.filter.type.form",
        defaultMessage: "Form"
    },
    notebook: {
        id: "search-page.filter.type.notebook",
        defaultMessage: "Notebook"
    },
    other: {
        id: "search-page.filter.type.other",
        defaultMessage: "Other"
    },
    article: {
        id: "search-page.filter.type.article",
        defaultMessage: "Articles"
    },
    post: {
        id: "search-page.filter.type.post",
        defaultMessage: "Posts"
    },
    ticket: {
        id: "search-page.filter.type.ticket",
        defaultMessage: "Tickets"
    },
    'devops-work-item': {
        id: "search-page.filter.type.devops-work-item",
        defaultMessage: "Issues"
    },
    campaign: {
        id: "search-page.filter.type.campaign",
        defaultMessage: "Campaigns"
    },
    case: {
        id: "search-page.filter.type.case",
        defaultMessage: "Cases"
    },
    'catalog-item': {
        id: "search-page.filter.type.catalog-item",
        defaultMessage: "Catalog items"
    },
    'requested-item': {
        id: "search-page.filter.type.requested-item",
        defaultMessage: "Requested items"
    },
    'knowledge-article': {
        id: "search-page.filter.type.knowledge-article",
        defaultMessage: "Knowledge articles"
    },
    'news-article': {
        id: "search-page.filter.type.news-article",
        defaultMessage: "News articles"
    },
    demand: {
        id: "search-page.filter.type.demand",
        defaultMessage: "Demands"
    }
});
module.exports["typeLabels"] = $b8cf047080ff9c5f$export$9f8e6b98f3e412c5;

});

parcelRegister("037Ux", function(module, exports) {

var $b4tvS = parcelRequire("b4tvS");


var $9rRKJ = parcelRequire("9rRKJ");

const $c714dd6f21c3b8da$export$a415be24ece1d149 = (params)=>{
    if (params.productToSet || params.isUniversal && // Universal Filters on Quick Find selects the primaryProduct until we do cross product search
    //https://atlassian.slack.com/archives/C050EC6FM28/p1763330594902229?thread_ts=1763092320.695409&cid=C050EC6FM28
    params.experience !== (0, $9rRKJ.SearchExperience).QUICK_FIND) return params.productToSet;
    const productToSelect = params.selectedProduct ?? params.primaryProduct ?? '';
    const safeProductKey = (0, $b4tvS.isProductKey)(productToSelect) ? productToSelect : undefined;
    return safeProductKey;
};
module.exports["getProductToSelect"] = $c714dd6f21c3b8da$export$a415be24ece1d149;

});

parcelRegister("euOzb", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $2W0qg = parcelRequire("2W0qg");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $7duAA = parcelRequire("7duAA");

const $9322f8cac61c7a30$var$ClearFilterButton = ({ text: text = (0, $7duAA.messages).clearFilterButtonLabel, xcss: xcss, ...props })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        ...props,
        xcss: [
            $9322f8cac61c7a30$var$clearFilterOptionsButtonStyles,
            xcss
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), null, formatMessage(text)));
};
var $9322f8cac61c7a30$export$2e2bcd8739ae039 = $9322f8cac61c7a30$var$ClearFilterButton;
const $9322f8cac61c7a30$var$clearFilterOptionsButtonStyles = (0, $ecnYn.xcss)({
    background: "var(--ds-background-input, #FFFFFF)",
    color: 'color.text.subtle',
    border: 'none',
    paddingLeft: 'space.250',
    font: 'inherit',
    cursor: 'pointer',
    outline: 'inherit',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '36px',
    width: '100%',
    ':hover': {
        backgroundColor: 'color.background.input.hovered'
    },
    ':disabled': {
        color: 'color.text.accent.gray',
        cursor: 'default'
    }
});
module.exports["default"] = $9322f8cac61c7a30$export$2e2bcd8739ae039;

});

parcelRegister("2ZCkf", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ghftu = parcelRequire("ghftu");


var $6f0Oj = parcelRequire("6f0Oj");

var $2W0qg = parcelRequire("2W0qg");

var $ecnYn = parcelRequire("ecnYn");


var $3gadb = parcelRequire("3gadb");


var $kP8IJ = parcelRequire("kP8IJ");


var $76naE = parcelRequire("76naE");

const $18263ad7f172659f$var$defaultFilterButtonStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.075',
    color: 'color.text.subtle',
    borderRadius: "var(--ds-radius-small, 4px)",
    paddingInline: 'space.150',
    paddingBlock: 'space.050',
    maxHeight: '32px',
    minHeight: '32px',
    backgroundColor: 'color.background.neutral.subtle',
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    whiteSpace: 'nowrap',
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    maxWidth: '280px'
});
const $18263ad7f172659f$var$wideStyles = (0, $ecnYn.xcss)({
    width: '100%' // Allow the button to take up full width
});
const $18263ad7f172659f$var$compactContentFitStyles = (0, $ecnYn.xcss)({
    // This allows us to fit Dropdown button + App Selector + 2 product filters
    maxWidth: '180px'
});
const $18263ad7f172659f$var$filterButtonSelectedStateStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.selected',
    color: 'color.text.selected',
    ':hover': {
        backgroundColor: 'color.background.selected.hovered'
    },
    border: `${"var(--ds-border-width, 1px)"} solid transparent` // Keep border consistent with non-selected state
});
const $18263ad7f172659f$var$filterButtonSelectedStateBorderStyles = (0, $ecnYn.xcss)({
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-selected, #1868DB)"}`
});
const $18263ad7f172659f$var$compactSpacingStyles = (0, $ecnYn.xcss)({
    paddingInline: 'space.050'
});
const $18263ad7f172659f$var$filterButtonContentStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flexGrow: 1,
    // Allow the content to take up available space
    textAlign: 'left'
});
const $18263ad7f172659f$var$noBorderStyles = (0, $ecnYn.xcss)({
    border: 0
});
const $18263ad7f172659f$export$fb46dd9777cc6db0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(function FilterButton({ children: children, contentFit: contentFit = 'default', iconAfter: iconAfter, iconBefore: iconBefore, isSelected: isSelected, noBorder: noBorder, tooltip: tooltip, spacing: spacing = 'default', filterOrControlId: filterOrControlId, hasChevron: hasChevron = true, isFilterInDropdown: isFilterInDropdown, xcss: xcss, ...pressableProps }, ref) {
    const filterIcon = filterOrControlId ? (0, $76naE.getIcon)({
        filterOrControlId: filterOrControlId,
        isSelected: Boolean(isSelected)
    }) : null;
    const chevronIcon = hasChevron ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
        label: "",
        color: (0, $kP8IJ.getIconColor)(isSelected),
        size: "small"
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: tooltip ?? null,
        position: "bottom"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), tooltipProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            ...pressableProps,
            xcss: [
                $18263ad7f172659f$var$defaultFilterButtonStyles,
                isSelected && $18263ad7f172659f$var$filterButtonSelectedStateStyles,
                !isFilterInDropdown && isSelected && $18263ad7f172659f$var$filterButtonSelectedStateBorderStyles,
                isFilterInDropdown && $18263ad7f172659f$var$wideStyles,
                spacing === 'compact' && $18263ad7f172659f$var$compactSpacingStyles,
                contentFit === 'compact' && $18263ad7f172659f$var$compactContentFitStyles,
                noBorder && $18263ad7f172659f$var$noBorderStyles,
                xcss
            ],
            ref: ref
        }, iconBefore, filterIcon, children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $18263ad7f172659f$var$filterButtonContentStyles
        }, children), iconAfter, chevronIcon)));
});
module.exports["FilterButton"] = $18263ad7f172659f$export$fb46dd9777cc6db0;

});

parcelRegister("coCs8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ghftu = parcelRequire("ghftu");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $2W0qg = parcelRequire("2W0qg");

var $ecnYn = parcelRequire("ecnYn");


var $5G4YB = parcelRequire("5G4YB");

const $74f0107fbd8d1ca1$var$baseStyles = (0, $ecnYn.xcss)({
    height: '32px',
    paddingInline: 'space.150',
    width: '100%',
    borderRadius: 'radius.small',
    color: 'color.text',
    backgroundColor: 'color.background.neutral',
    ':hover': {
        backgroundColor: 'color.background.neutral.hovered'
    }
});
const $74f0107fbd8d1ca1$var$selectedStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.selected',
    color: 'color.text.accent.blue',
    ':hover': {
        backgroundColor: 'color.background.selected.hovered'
    }
});
const $74f0107fbd8d1ca1$var$buttonIconStyles = (0, $ecnYn.xcss)({
    display: 'flex'
});
const $74f0107fbd8d1ca1$var$ButtonIconOld = ({ filterOrControlId: filterOrControlId, isSelected: isSelected })=>{
    const buttonIcon = (0, $5G4YB.getIcon)({
        filterOrControlId: filterOrControlId,
        isSelected: isSelected
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $74f0107fbd8d1ca1$var$buttonIconStyles
    }, buttonIcon);
};
const $74f0107fbd8d1ca1$var$buttonWrapperStyles = (0, $ecnYn.xcss)({
    maxWidth: '280px' // matches dropdown of 312px (and padding)
});
const $74f0107fbd8d1ca1$var$textStyles = (0, $ecnYn.xcss)({
    // ellipsis for overflow text
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)"
});
const $74f0107fbd8d1ca1$export$cb33ef6b55cb85ab = ({ otherProps: otherProps, isSelected: isSelected, filterOrControlId: filterOrControlId, label: label, selectionBadge: selectionBadge, onClick: onClick, onKeyDown: onKeyDown, wide: wide, testId: testId, ariaLabel: ariaLabel, iconBefore: iconBefore })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: !wide && $74f0107fbd8d1ca1$var$buttonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        onClick: onClick,
        onKeyDown: onKeyDown,
        ...otherProps,
        ...ariaLabel && {
            ['aria-label']: ariaLabel
        },
        testId: testId,
        xcss: [
            $74f0107fbd8d1ca1$var$baseStyles,
            isSelected && $74f0107fbd8d1ca1$var$selectedStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignInline: "start",
        space: "space.100",
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        alignInline: "start",
        xcss: $74f0107fbd8d1ca1$var$textStyles,
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.075"
    }, iconBefore, filterOrControlId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($74f0107fbd8d1ca1$var$ButtonIconOld, {
        filterOrControlId: filterOrControlId,
        isSelected: isSelected
    })), label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $74f0107fbd8d1ca1$var$textStyles
    }, label), selectionBadge), filterOrControlId !== 'dropdown' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
        label: "",
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)",
        size: "small"
    }))));
module.exports["FilterButtonOld"] = $74f0107fbd8d1ca1$export$cb33ef6b55cb85ab;

});

parcelRegister("kfaxy", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $lvsjl = parcelRequire("lvsjl");


var $gdv5Z = parcelRequire("gdv5Z");

const $070b6b0e166fafc9$var$boxStyles = {
    wrapperStyles: "_vchhusvi"
};
const $070b6b0e166fafc9$var$HOVER_OUT_TIMEOUT = 400; // ms
const $070b6b0e166fafc9$var$HoverOutWrapper = ({ callback: callback, children: children })=>{
    const [handleHoverChange, cancel] = (0, $lvsjl.default)((hoveringOn)=>{
        if (!hoveringOn) callback();
    }, $070b6b0e166fafc9$var$HOVER_OUT_TIMEOUT);
    // We don't want callback if the component is unmounted
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            cancel();
        };
    }, [
        cancel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        onMouseEnter: ()=>{
            cancel(); // Cancel any pending hover-out callback
            handleHoverChange(true);
        },
        onMouseLeave: ()=>handleHoverChange(false),
        xcss: $070b6b0e166fafc9$var$boxStyles.wrapperStyles
    }, children);
};
const $070b6b0e166fafc9$export$fd3814d10c81178d = ({ enabled: enabled = false, ...rest })=>{
    if (!enabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, rest.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($070b6b0e166fafc9$var$HoverOutWrapper, rest);
};
module.exports["MaybeHoverOutWrapper"] = $070b6b0e166fafc9$export$fd3814d10c81178d;

});

parcelRegister("kC3Bu", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $tvI67 = parcelRequire("tvI67");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $5iakG = parcelRequire("5iakG");


var $4EMbH = parcelRequire("4EMbH");


var $b4tvS = parcelRequire("b4tvS");
parcelRequire("1yEFx");
var $1yEFx = parcelRequire("1yEFx");


var $9d9t8 = parcelRequire("9d9t8");


var $lBO0P = parcelRequire("lBO0P");


var $jQ2up = parcelRequire("jQ2up");


var $2OtFZ = parcelRequire("2OtFZ");


var $9ZAVx = parcelRequire("9ZAVx");


var $hrMXM = parcelRequire("hrMXM");


var $YqPsE = parcelRequire("YqPsE");


var $5cssW = parcelRequire("5cssW");


var $gGFxq = parcelRequire("gGFxq");


var $j4ply = parcelRequire("j4ply");


var $djVCD = parcelRequire("djVCD");


var $8pHoH = parcelRequire("8pHoH");

const $95f217c3bcfdeef2$var$ALL_STATE_VALUE = 'all';
const $95f217c3bcfdeef2$var$getOptionLabel = (productKey, productConfig, thirdPartyConfigs)=>{
    // Edge case: This is to get the name of Confluence DC sites and Forge connectors
    const workspaceName = (0, $YqPsE.getWorkspaceNameFromProduct)(productKey, thirdPartyConfigs);
    if (workspaceName) return workspaceName;
    // For Forge connectors, productConfig will be undefined, so we can't access displayName
    if (productConfig && typeof productConfig.displayName === 'string') return productConfig.displayName;
    // In theory this we should not reach here as displayName is rendered as a string
    return '';
};
const $95f217c3bcfdeef2$var$AppSelectFilter = ({ isFilterInDropdown: isFilterInDropdown })=>{
    const [lookupInput, setLookupInput] = (0, $42omo.useState)('');
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const availableProducts = (0, $j4ply.useAvailableProducts)();
    const availableNouns = (0, $j4ply.useAvailableNouns)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const [selectedDatasource] = (0, $djVCD.useSelectedDatasource)();
    const productConfigs = (0, $1yEFx.useProductConfigs)();
    const [thirdPartyConfigs] = (0, $j4ply.useThirdPartyConfigs)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const { selectProductFilter: selectProductFilter, unselectProductFilter: unselectProductFilter, unsafe_setAtlasNouns: unsafe_setAtlasNouns } = (0, $djVCD.useSearchActions)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [filterData] = (0, $5cssW.useUniversalSelectFilter)({
        filterId: (0, $5iakG.universalTypeFilterId),
        optionsToProducts: {}
    });
    const onSelectChange = (0, $42omo.useCallback)((value)=>{
        const selectedValue = Array.isArray(value) ? value[0] : value;
        if (selectedValue.value === $95f217c3bcfdeef2$var$ALL_STATE_VALUE) {
            unselectProductFilter();
            return;
        }
        // Handle datasource selection for fanout products
        if (selectedValue.metadata?.datasource) {
            selectProductFilter(selectedValue.value, selectedValue.metadata.datasource);
            return;
        }
        // Atlas is ignored because we do not display Atlas as an app but as nouns which
        // handle handled in the next if statement.
        if ((0, $b4tvS.isProductKey)(selectedValue.value) && selectedValue.value !== (0, $b4tvS.ProductKeys).Atlas) {
            selectProductFilter(selectedValue.value);
            return;
        }
        if ((0, $4EMbH.isNounKey)(selectedValue.queryParamValue)) {
            unsafe_setAtlasNouns(selectedValue.queryParamValue);
            return;
        }
    }, [
        selectProductFilter,
        unsafe_setAtlasNouns,
        unselectProductFilter
    ]);
    const nounOptions = (0, $42omo.useMemo)(()=>{
        // When fanout flag is on, don't show AtlassianWebCrawler as a noun (it's shown as a product)
        // When fanout flag is off, show it as the original "Web pages" noun
        const shouldShowWebCrawlerAsNoun = !(0, $dh538.fg)('webcrawler-fanout-ui-sidebar-enabled');
        const nounsIncludingAtlassianWebCrawler = [
            //  We use availableProducts to determine if AtlassianWebCrawler is avaialble
            ...availableNouns.filter((noun)=>noun !== (0, $4EMbH.NounKeys).AtlassianWebCrawler),
            ...shouldShowWebCrawlerAsNoun ? [
                (0, $b4tvS.ProductKeys).AtlassianWebCrawler
            ] : []
        ];
        return Object.entries((0, $4EMbH.nouns)).flatMap(([nounKey, config])=>(0, $4EMbH.isNounKey)(nounKey) ? [
                {
                    nounKey: nounKey,
                    config: config
                }
            ] : []).filter(({ nounKey: nounKey })=>nounsIncludingAtlassianWebCrawler.includes(nounKey)).map(({ nounKey: nounKey, config: config })=>{
            const label = formatMessage(config.displayNamePlural);
            const typeFilterValue = filterData?.selectedOptions[0];
            const isNounSelected = typeFilterValue?.queryParamValue === nounKey && selectedProduct === (0, $b4tvS.ProductKeys).Atlas;
            const isWebCrawlerSelected = nounKey === selectedProduct && selectedProduct === (0, $b4tvS.ProductKeys).AtlassianWebCrawler;
            return {
                value: nounKey,
                isSelected: isNounSelected || isWebCrawlerSelected,
                label: label,
                isDefault: false,
                trackingKey: nounKey,
                queryParamValue: nounKey,
                isSuggested: false
            };
        });
    }, [
        availableNouns,
        filterData?.selectedOptions,
        formatMessage,
        selectedProduct
    ]);
    const allAppOptions = (0, $42omo.useMemo)(()=>{
        const productsOrder = (0, $hrMXM.getProductsOrderByPrimaryProduct)(primaryProduct);
        const baseAppOptions = availableProducts.filter((productKey)=>{
            // Always exclude Atlas (handled in nounOptions)
            if (productKey === (0, $b4tvS.ProductKeys).Atlas) return false;
            // When fanout is enabled, include AtlassianWebCrawler as a product
            // When fanout is disabled, exclude it (handled in nounOptions)
            if (productKey === (0, $b4tvS.ProductKeys).AtlassianWebCrawler) return Boolean(thirdPartyConfigs[(0, $b4tvS.ProductKeys).AtlassianWebCrawler]?.fanOutConnectorSources) && (0, $dh538.fg)('webcrawler-fanout-ui-sidebar-enabled');
            return true;
        }).filter((productKey)=>{
            // Don't filter out fanout products that need OAuth - let them show with OAuth warnings
            const hasFanout = (0, $b4tvS.is3pProductKey)(productKey) && thirdPartyConfigs[productKey]?.fanOutConnectorSources;
            if (hasFanout) return true; // Include fanout products regardless of OAuth status
            const { userNeedsOAuth: userNeedsOAuth } = (0, $gGFxq.isUserOAuthed)(productKey, thirdPartyConfigs);
            return !userNeedsOAuth;
        }).filter((productKey)=>{
            // Forge connectors are dynamically added and won't be in the static productConfigs map
            if ((0, $9d9t8.isForgeConnectorProductKey)(productKey) && (0, $dh538.fg)('rovo-search-dynamic-forge-config')) return true;
            // For hardcoded products, check if they exist in productConfigs
            return !!productConfigs[productKey];
        }).sort((a, b)=>(0, $9ZAVx.getProductOrder)(a, b, productsOrder));
        // Apply fanout logic to products that have it enabled
        const expandedAppOptions = [];
        baseAppOptions.forEach((productKey)=>{
            const productConfig = productConfigs[productKey];
            const hasFanout = (0, $b4tvS.is3pProductKey)(productKey) && Boolean(thirdPartyConfigs[productKey]?.fanOutConnectorSources) && (productKey !== (0, $b4tvS.ProductKeys).AtlassianWebCrawler || (0, $dh538.fg)('webcrawler-fanout-ui-sidebar-enabled'));
            if (hasFanout) {
                // For dropdown, show all datasources for fanout products when flag is on
                const datasources = thirdPartyConfigs[productKey]?.datasources || [];
                datasources.forEach((datasource)=>{
                    const isSelected = productKey === selectedProduct && datasource.datasourceId === selectedDatasource?.datasourceId;
                    expandedAppOptions.push({
                        value: productKey,
                        isSelected: isSelected,
                        label: datasource.workspaceName || datasource.workspaceUrl || $95f217c3bcfdeef2$var$getOptionLabel(productKey, productConfig, thirdPartyConfigs),
                        isDefault: false,
                        trackingKey: `${productKey}-${datasource.datasourceId}`,
                        queryParamValue: productKey,
                        isSuggested: false,
                        metadata: {
                            datasource: datasource
                        }
                    });
                });
            } else expandedAppOptions.push({
                value: productKey,
                isSelected: productKey === selectedProduct && !selectedDatasource,
                label: $95f217c3bcfdeef2$var$getOptionLabel(productKey, productConfig, thirdPartyConfigs),
                isDefault: false,
                trackingKey: productKey,
                queryParamValue: productKey,
                isSuggested: false
            });
        });
        const allOption = {
            label: formatMessage((0, $8pHoH.i18n).all),
            value: $95f217c3bcfdeef2$var$ALL_STATE_VALUE,
            isDefault: true,
            isSelected: false,
            trackingKey: '',
            queryParamValue: '',
            isSuggested: false
        };
        return [
            allOption,
            ...expandedAppOptions,
            ...nounOptions
        ];
    }, [
        availableProducts,
        formatMessage,
        nounOptions,
        productConfigs,
        selectedProduct,
        selectedDatasource,
        thirdPartyConfigs,
        primaryProduct
    ]);
    const selectedOption = (0, $42omo.useMemo)(()=>{
        const singleSelectedOption = allAppOptions.filter((option)=>option.isSelected)[0];
        return singleSelectedOption ? [
            singleSelectedOption
        ] : [];
    }, [
        allAppOptions
    ]);
    const optionIcon = (0, $42omo.useMemo)(()=>(0, $jQ2up.createOptionLabelFormatter)(({ option: option })=>{
            const optionValue = option.value;
            if (typeof optionValue === 'number') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
            if (optionValue === $95f217c3bcfdeef2$var$ALL_STATE_VALUE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                paddingInline: "space.050",
                paddingBlock: "space.025"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($tvI67))), {
                label: formatMessage((0, $8pHoH.i18n).app)
            }));
            if ((0, $4EMbH.isNounKey)(optionValue)) {
                const nounConfig = (0, $4EMbH.nouns)[optionValue];
                const NounIcon = nounConfig.Icon;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(NounIcon, {
                    size: "small"
                });
            }
            if ((0, $b4tvS.isProductKey)(optionValue)) {
                const productConfig = productConfigs[optionValue];
                // Handle Forge connectors
                if ((0, $9d9t8.isForgeConnectorProductKey)(optionValue)) {
                    const forgeIcon = (0, $9d9t8.getForgeConnectorIcon)(optionValue);
                    if (forgeIcon) return forgeIcon({
                        size: 'small'
                    });
                }
                // Handle hardcoded products
                if (productConfig?.Icon) {
                    const Icon = productConfig.Icon;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
                        size: "small"
                    });
                }
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null);
        }), [
        formatMessage,
        productConfigs
    ]);
    const serveWebPagesInTypeFilterExperiment = (0, $2OtFZ.serveWebPagesInTypeFilter)();
    const selectedStateIcon = (0, $42omo.useMemo)(()=>{
        const nounSelection = filterData?.selectedOptions[0]?.queryParamValue;
        const isANoun = nounSelection && (0, $4EMbH.isNounKey)(nounSelection);
        if (selectedProduct === (0, $b4tvS.ProductKeys).Atlas && isANoun) {
            const nounConfig = (0, $4EMbH.nouns)[nounSelection];
            const NounIcon = nounConfig.Icon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(NounIcon, {
                size: "small"
            });
        }
        // Control cohort: use special noun icon for web pages in app filter
        // Test cohort: if app is web pages, use the default app icon (app can only be web pages through the URL)
        if (!serveWebPagesInTypeFilterExperiment && selectedProduct === (0, $b4tvS.ProductKeys).AtlassianWebCrawler) {
            const nounConfig = (0, $4EMbH.nouns)[(0, $4EMbH.NounKeys).AtlassianWebCrawler];
            const NounIcon = nounConfig.Icon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(NounIcon, {
                size: "small"
            });
        }
        if ((0, $b4tvS.isProductKey)(selectedProduct) && selectedProduct !== (0, $b4tvS.ProductKeys).AtlassianWebCrawler) {
            const productConfig = productConfigs[selectedProduct];
            // Handle Forge connectors
            if ((0, $9d9t8.isForgeConnectorProductKey)(selectedProduct)) {
                const forgeIcon = (0, $9d9t8.getForgeConnectorIcon)(selectedProduct);
                if (forgeIcon) return forgeIcon({
                    size: 'small'
                });
            }
            // Handle hardcoded products
            if (productConfig?.Icon) {
                const Icon = productConfig.Icon;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
                    size: "small"
                });
            }
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($tvI67))), {
            label: formatMessage((0, $8pHoH.i18n).app)
        });
    }, [
        filterData?.selectedOptions,
        formatMessage,
        productConfigs,
        selectedProduct,
        serveWebPagesInTypeFilterExperiment
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        onDropdownClose: ()=>setLookupInput(''),
        onSearchInputChange: setLookupInput,
        onSelectChange: onSelectChange,
        options: allAppOptions,
        selectedOptions: selectedOption,
        label: selectedOption.length === 0 ? formatMessage((0, $8pHoH.i18n).app) : '',
        placeholder: formatMessage((0, $8pHoH.i18n).appSelectPlaceholder),
        isSearchable: true,
        filterOption: null,
        searchInput: lookupInput,
        formatOptionLabel: optionIcon,
        iconBefore: selectedStateIcon,
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled
    });
};
var $95f217c3bcfdeef2$export$2e2bcd8739ae039 = $95f217c3bcfdeef2$var$AppSelectFilter;
module.exports["default"] = $95f217c3bcfdeef2$export$2e2bcd8739ae039;

});

parcelRegister("c4DtA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3dgQu = parcelRequire("3dgQu");


var $1eaCj = parcelRequire("1eaCj");


var $ffbvg = parcelRequire("ffbvg");


var $j4ply = parcelRequire("j4ply");


var $fw303 = parcelRequire("fw303");


var $kdaqW = parcelRequire("kdaqW");

const $760f2c048a3236c0$var$ArchivedFilter = ({ isFilterInDropdown: isFilterInDropdown = false, showPrimaryProductIcon: showPrimaryProductIcon, onFilterChange: onFilterChange })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [state, { toggle: toggle }] = (0, $ffbvg.useBooleanFilter)({
        filterId: (0, $fw303.filter).id
    });
    if (!state) return null;
    const { value: value, autoFocus: autoFocus } = state;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCj.ToggleFilter), {
        onChange: ()=>{
            toggle();
            onFilterChange?.({
                isSelected: value
            });
        },
        isChecked: value,
        autoFocus: autoFocus,
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            primaryProduct: primaryProduct,
            showPrimaryProductIcon: showPrimaryProductIcon
        })
    }, formatMessage((0, $kdaqW.i18n).archived));
};
var $760f2c048a3236c0$export$2e2bcd8739ae039 = $760f2c048a3236c0$var$ArchivedFilter;
module.exports["default"] = $760f2c048a3236c0$export$2e2bcd8739ae039;

});

parcelRegister("5XOrc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3dgQu = parcelRequire("3dgQu");


var $1eaCj = parcelRequire("1eaCj");


var $ffbvg = parcelRequire("ffbvg");


var $j4ply = parcelRequire("j4ply");


var $k7ise = parcelRequire("k7ise");


var $2E5eb = parcelRequire("2E5eb");

const $0bc40bc1e4bf742f$var$ArchivedAndPendingComponentsFilter = ({ isFilterInDropdown: isFilterInDropdown = false, showPrimaryProductIcon: showPrimaryProductIcon, onFilterChange: onFilterChange, fit: fit })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [state, { toggle: toggle }] = (0, $ffbvg.useBooleanFilter)({
        filterId: (0, $k7ise.filter).id
    });
    if (!state) return null;
    const { value: value, autoFocus: autoFocus } = state;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCj.ToggleFilter), {
        onChange: ()=>{
            onFilterChange?.({
                isSelected: value
            });
            toggle();
        },
        isChecked: value,
        autoFocus: autoFocus,
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            primaryProduct: primaryProduct,
            showPrimaryProductIcon: showPrimaryProductIcon
        })
    }, formatMessage((0, $2E5eb.i18n).archivedAndPendingComponents));
};
var $0bc40bc1e4bf742f$export$2e2bcd8739ae039 = $0bc40bc1e4bf742f$var$ArchivedAndPendingComponentsFilter;
module.exports["default"] = $0bc40bc1e4bf742f$export$2e2bcd8739ae039;

});

parcelRegister("1a3HI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $jQ2up = parcelRequire("jQ2up");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $5X4Ay = parcelRequire("5X4Ay");


var $2Hu9k = parcelRequire("2Hu9k");

const $74770ed762a3ef0d$var$AssigneeFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $5X4Ay.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $2Hu9k.i18n).jiraFilterAssigneeLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $2Hu9k.i18n).jiraFilterAssigneeLabelUnselected),
            options: suggestedOptions
        }
    ];
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $2Hu9k.i18n).assignee);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: label,
        placeholder: formatMessage((0, $2Hu9k.i18n).jiraFilterContributorPlaceholder),
        filterOrControlId: 'assignee',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: (0, $jQ2up.formatAvatarOptionLabel),
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $5X4Ay.filter).id
            });
        },
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $74770ed762a3ef0d$export$2e2bcd8739ae039 = $74770ed762a3ef0d$var$AssigneeFilter;
module.exports["default"] = $74770ed762a3ef0d$export$2e2bcd8739ae039;

});

parcelRegister("iK2jT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $eXmBZ = parcelRequire("eXmBZ");


var $dh538 = parcelRequire("dh538");


var $jUrPw = parcelRequire("jUrPw");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $5VnRb = parcelRequire("5VnRb");


var $lixcy = parcelRequire("lixcy");

const $db3cd4572d6863e6$var$CampaignStatusFilter = (props)=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setOption: setOption, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $5VnRb.filter).id
    });
    const isRetryOnConfigLoadEnabled = (0, $dh538.fg)('rovo-fps-3p-ux-sf-retry-on-config-load');
    const isConfigLoaded = (0, $j4ply.useIsConfigLoaded)();
    // See SalesforceStageFilter for the rationale: when the retry FF is on, hold the
    // "did mount" flip until isConfigLoaded is true so the bootstrap-config race
    // cannot leave the filter permanently empty.
    const hasLoadedInitialOptions = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (hasLoadedInitialOptions.current) return;
        if (isRetryOnConfigLoadEnabled && !isConfigLoaded) return;
        hasLoadedInitialOptions.current = true;
        loadInitialOptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isRetryOnConfigLoadEnabled,
        isConfigLoaded
    ]);
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions } = filterData;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jUrPw.default), {
        ...props,
        filterId: (0, $5VnRb.filter).id,
        label: formatMessage((0, $lixcy.i18n).campaignStatusFilterLabel),
        noOptionsMessage: formatMessage((0, $lixcy.i18n).campaignStatusFilterNoOptions),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
            label: ""
        }),
        isLoading: isLoading,
        selectedOptions: selectedOptions,
        suggestedOptions: suggestedOptions,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        loadInitialOptions: loadInitialOptions,
        setOption: (option)=>setOption(option),
        clearOptions: clearOptions
    });
};
var $db3cd4572d6863e6$export$2e2bcd8739ae039 = $db3cd4572d6863e6$var$CampaignStatusFilter;
module.exports["default"] = $db3cd4572d6863e6$export$2e2bcd8739ae039;

});

parcelRegister("5rAmH", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $eXmBZ = parcelRequire("eXmBZ");


var $dh538 = parcelRequire("dh538");


var $jUrPw = parcelRequire("jUrPw");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $F3Hv6 = parcelRequire("F3Hv6");


var $iKLhF = parcelRequire("iKLhF");

const $98c68942e58b8f98$var$CaseStatusFilter = (props)=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setOption: setOption, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $F3Hv6.filter).id
    });
    const isRetryOnConfigLoadEnabled = (0, $dh538.fg)('rovo-fps-3p-ux-sf-retry-on-config-load');
    const isConfigLoaded = (0, $j4ply.useIsConfigLoaded)();
    // See SalesforceStageFilter for the rationale: when the retry FF is on, hold the
    // "did mount" flip until isConfigLoaded is true so the bootstrap-config race
    // cannot leave the filter permanently empty.
    const hasLoadedInitialOptions = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (hasLoadedInitialOptions.current) return;
        if (isRetryOnConfigLoadEnabled && !isConfigLoaded) return;
        hasLoadedInitialOptions.current = true;
        loadInitialOptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isRetryOnConfigLoadEnabled,
        isConfigLoaded
    ]);
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions } = filterData;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jUrPw.default), {
        ...props,
        filterId: (0, $F3Hv6.filter).id,
        label: formatMessage((0, $iKLhF.i18n).caseStatusFilterLabel),
        noOptionsMessage: formatMessage((0, $iKLhF.i18n).caseStatusFilterNoOptions),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
            label: ""
        }),
        isLoading: isLoading,
        selectedOptions: selectedOptions,
        suggestedOptions: suggestedOptions,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        loadInitialOptions: loadInitialOptions,
        setOption: (option)=>setOption(option),
        clearOptions: clearOptions
    });
};
var $98c68942e58b8f98$export$2e2bcd8739ae039 = $98c68942e58b8f98$var$CaseStatusFilter;
module.exports["default"] = $98c68942e58b8f98$export$2e2bcd8739ae039;

});

parcelRegister("3IsTa", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $gTpIM = parcelRequire("gTpIM");


var $3dgQu = parcelRequire("3dgQu");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $hHAPz = parcelRequire("hHAPz");


var $jf1P1 = parcelRequire("jf1P1");

const $3e2c7d743a0a4f19$var$CloseDateFilter = ({ testId: testId = 'salesforce-close-date-filter', isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { setOption: setOption, loadInitialOptions: loadInitialOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $hHAPz.filter).id
    });
    if (!filterData) return null;
    const { options: options, selectedOptions: selectedOptions, customValue: customValue } = filterData;
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $jf1P1.i18n).closeDate);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gTpIM.default), {
        contentFit: fit,
        options: options,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        label: label,
        onDropdownOpen: loadInitialOptions,
        selectedOptions: selectedOptions,
        customDateValue: customValue?.closeDateVal || '',
        testId: testId,
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $3e2c7d743a0a4f19$export$2e2bcd8739ae039 = $3e2c7d743a0a4f19$var$CloseDateFilter;
module.exports["default"] = $3e2c7d743a0a4f19$export$2e2bcd8739ae039;

});

parcelRegister("17vNL", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3dgQu = parcelRequire("3dgQu");


var $1eaCj = parcelRequire("1eaCj");


var $ffbvg = parcelRequire("ffbvg");


var $j4ply = parcelRequire("j4ply");


var $2a0ps = parcelRequire("2a0ps");


var $drVRR = parcelRequire("drVRR");

const $f85052d50a516be9$var$CommentedByMeFilter = ({ isFilterInDropdown: isFilterInDropdown = false, showPrimaryProductIcon: showPrimaryProductIcon, onFilterChange: onFilterChange })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [state, { toggle: toggle }] = (0, $ffbvg.useBooleanFilter)({
        filterId: (0, $2a0ps.filter).id
    });
    if (!state) return null;
    const { value: value, autoFocus: autoFocus } = state;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCj.ToggleFilter), {
        onChange: ()=>{
            onFilterChange?.({
                isSelected: value
            });
            toggle();
        },
        isChecked: value,
        autoFocus: autoFocus,
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            primaryProduct: primaryProduct,
            showPrimaryProductIcon: showPrimaryProductIcon
        })
    }, formatMessage((0, $drVRR.i18n).commentedByMe));
};
var $f85052d50a516be9$export$2e2bcd8739ae039 = $f85052d50a516be9$var$CommentedByMeFilter;
module.exports["default"] = $f85052d50a516be9$export$2e2bcd8739ae039;

});

parcelRegister("9wx2v", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $eG1e2 = parcelRequire("eG1e2");


var $8hhCV = parcelRequire("8hhCV");


var $b4tvS = parcelRequire("b4tvS");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $jQ2up = parcelRequire("jQ2up");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $djVCD = parcelRequire("djVCD");


var $dQXZO = parcelRequire("dQXZO");


var $dO5lX = parcelRequire("dO5lX");

const $9a55686875ae213f$var$formatContentIconOptionLabel = (0, $jQ2up.createOptionLabelFormatter)(({ option: option })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8hhCV.default), {
        label: option.label
    }));
const $9a55686875ae213f$var$formatFolderIconOptionLabel = (0, $jQ2up.createOptionLabelFormatter)(({ option: option })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eG1e2))), {
        label: option.label,
        size: "small",
        spacing: "none",
        color: "var(--ds-icon-brand, #1868DB)"
    }));
const $9a55686875ae213f$var$ContentFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const formatOptionLabel = (0, $b4tvS.is3pProductKey)(selectedProduct ?? '') ? $9a55686875ae213f$var$formatFolderIconOptionLabel : $9a55686875ae213f$var$formatContentIconOptionLabel;
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $dQXZO.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $dO5lX.i18n).confluenceFilterLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $dO5lX.i18n).confluenceFilterLabelUnselected),
            options: suggestedOptions
        }
    ];
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $dO5lX.i18n).content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        canClearFilter: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: label,
        placeholder: formatMessage((0, $dO5lX.i18n).confluenceFilterPlaceholder),
        filterOrControlId: 'content',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: formatOptionLabel,
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $dQXZO.filter).id
            });
        },
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $9a55686875ae213f$export$2e2bcd8739ae039 = $9a55686875ae213f$var$ContentFilter;
module.exports["default"] = $9a55686875ae213f$export$2e2bcd8739ae039;

});

parcelRegister("D9B8R", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $jQ2up = parcelRequire("jQ2up");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $aGXLL = parcelRequire("aGXLL");


var $2RkQg = parcelRequire("2RkQg");

const $63dd324a0edc4686$var$ContributorFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $aGXLL.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $2RkQg.i18n).confluenceFilterContributorLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $2RkQg.i18n).confluenceFilterContributorLabelUnselected),
            options: suggestedOptions
        }
    ];
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $2RkQg.i18n).contributor);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: label,
        placeholder: formatMessage((0, $2RkQg.i18n).confluenceFilterContributorPlaceholder),
        filterOrControlId: 'contributor',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: (0, $jQ2up.formatAvatarOptionLabel),
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $aGXLL.filter).id
            });
        },
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            primaryProduct: primaryProduct,
            showPrimaryProductIcon: showPrimaryProductIcon
        }),
        hideOnHoverOut: hideOnHoverOut,
        testId: "contributor-filter"
    });
};
var $63dd324a0edc4686$export$2e2bcd8739ae039 = $63dd324a0edc4686$var$ContributorFilter;
module.exports["default"] = $63dd324a0edc4686$export$2e2bcd8739ae039;

});

parcelRegister("iKcwP", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $jQ2up = parcelRequire("jQ2up");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $c5dmm = parcelRequire("c5dmm");


var $35KZ1 = parcelRequire("35KZ1");

const $fe851101f0073867$var$CreatedByFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $c5dmm.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $35KZ1.i18n).confluenceFilterCreatorLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $35KZ1.i18n).confluenceFilterCreatorLabelUnselected),
            options: suggestedOptions
        }
    ];
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $35KZ1.i18n).createdBy);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: label,
        placeholder: formatMessage((0, $35KZ1.i18n).confluenceFilterCreatorPlaceholder),
        filterOrControlId: 'createdBy',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: (0, $jQ2up.formatAvatarOptionLabel),
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $c5dmm.filter).id
            });
        },
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $fe851101f0073867$export$2e2bcd8739ae039 = $fe851101f0073867$var$CreatedByFilter;
module.exports["default"] = $fe851101f0073867$export$2e2bcd8739ae039;

});

parcelRegister("5KTta", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $2BDjU = parcelRequire("2BDjU");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $jQ2up = parcelRequire("jQ2up");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $6jSbc = parcelRequire("6jSbc");


var $hiJnb = parcelRequire("hiJnb");

const $a99e0c61526ecafe$var$formatOptionLabel = (0, $jQ2up.createOptionLabelFormatter)(({ option: option })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2BDjU.default), {
        label: option.label
    }));
const $a99e0c61526ecafe$var$FocusAreaTypeFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $6jSbc.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $hiJnb.i18n).mercuryFilterFocusAreaTypeLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $hiJnb.i18n).mercuryFilterFocusAreaTypeLabelUnselected),
            options: suggestedOptions
        }
    ];
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $hiJnb.i18n).focusAreaType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: label,
        placeholder: formatMessage((0, $hiJnb.i18n).mercuryFilterFocusAreaTypePlaceholder),
        filterOrControlId: 'focusAreaType',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $6jSbc.filter).id
            });
        },
        formatOptionLabel: $a99e0c61526ecafe$var$formatOptionLabel,
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $a99e0c61526ecafe$export$2e2bcd8739ae039 = $a99e0c61526ecafe$var$FocusAreaTypeFilter;
module.exports["default"] = $a99e0c61526ecafe$export$2e2bcd8739ae039;

});

parcelRegister("3hfXG", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $2BDjU = parcelRequire("2BDjU");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $e7L4o = parcelRequire("e7L4o");


var $1epJJ = parcelRequire("1epJJ");

const $20c6769ad7bce540$var$formatOptionLabel = (option)=>{
    const { label: label, metadata: metadata } = option;
    const type = metadata?.type || '';
    const owner = metadata?.owner || '';
    const status = metadata?.status;
    const health = metadata?.health;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.150",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2BDjU.default), {
        spacing: "spacious",
        status: status,
        health: health,
        label: label
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        maxLines: 2
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtle",
        size: "small"
    }, type, " \u2022 ", owner)));
};
const $20c6769ad7bce540$var$FocusAreaUnderFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $e7L4o.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $1epJJ.i18n).mercuryFilterFocusAreaUnderLabelLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $1epJJ.i18n).mercuryFilterFocusAreaUnderLabelUnselected),
            options: suggestedOptions
        }
    ];
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $1epJJ.i18n).mercuryFilterFocusAreaUnderLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        canClearFilter: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: label,
        placeholder: formatMessage((0, $1epJJ.i18n).mercuryFilterFocusAreaUnderLabelPlaceholder),
        filterOrControlId: 'focusAreaUnder',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: $20c6769ad7bce540$var$formatOptionLabel,
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $e7L4o.filter).id
            });
        },
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $20c6769ad7bce540$export$2e2bcd8739ae039 = $20c6769ad7bce540$var$FocusAreaUnderFilter;
module.exports["default"] = $20c6769ad7bce540$export$2e2bcd8739ae039;

});

parcelRegister("10wA9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $dh538 = parcelRequire("dh538");


var $3dgQu = parcelRequire("3dgQu");


var $1eaCj = parcelRequire("1eaCj");


var $ffbvg = parcelRequire("ffbvg");


var $j4ply = parcelRequire("j4ply");


var $lPWNq = parcelRequire("lPWNq");


var $9WvAH = parcelRequire("9WvAH");

const $b5b91c7a9661f924$var$HasAttachmentFilter = ({ isFilterInDropdown: isFilterInDropdown = false, showPrimaryProductIcon: showPrimaryProductIcon, onFilterChange: onFilterChange })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [state, { toggle: toggle }] = (0, $ffbvg.useBooleanFilter)({
        filterId: (0, $lPWNq.filter).id
    });
    if (!state || !(0, $dh538.fg)('rovo_fps_show_has_attachment_filter')) return null;
    const { value: value, autoFocus: autoFocus } = state;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCj.ToggleFilter), {
        onChange: ()=>{
            onFilterChange?.({
                isSelected: !value
            });
            toggle();
        },
        isChecked: value,
        autoFocus: autoFocus,
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            primaryProduct: primaryProduct,
            showPrimaryProductIcon: showPrimaryProductIcon
        })
    }, formatMessage((0, $9WvAH.i18n).hasAttachment));
};
var $b5b91c7a9661f924$export$2e2bcd8739ae039 = $b5b91c7a9661f924$var$HasAttachmentFilter;
module.exports["default"] = $b5b91c7a9661f924$export$2e2bcd8739ae039;

});

parcelRegister("6alnB", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $gwbWt = parcelRequire("gwbWt");


var $eDcMw = parcelRequire("eDcMw");

const $65f6ef9e8cb23703$var$LabelFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $gwbWt.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive, options: options } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $eDcMw.i18n).selectedOptionsSection),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $eDcMw.i18n).suggestedOptionsSection),
            options: suggestedOptions
        }
    ];
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $eDcMw.i18n).label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: label,
        noOptionsMessage: formatMessage((0, $eDcMw.i18n).confluenceFilterLabelsNoText),
        placeholder: formatMessage((0, $eDcMw.i18n).confluenceFilterLabelPlaceholder),
        filterOrControlId: 'label',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $gwbWt.filter).id
            });
        },
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $65f6ef9e8cb23703$export$2e2bcd8739ae039 = $65f6ef9e8cb23703$var$LabelFilter;
module.exports["default"] = $65f6ef9e8cb23703$export$2e2bcd8739ae039;

});

parcelRegister("aq7DS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $3dgQu = parcelRequire("3dgQu");


var $9PTlU = parcelRequire("9PTlU");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $djVCD = parcelRequire("djVCD");


var $1uGSo = parcelRequire("1uGSo");


var $hCRbr = parcelRequire("hCRbr");

const $414466d330b6ec26$var$LastUpdatedFilter = ({ testId: testId = 'universal-last-updated-filter', isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    // Trello only supports day/week/month/year options
    const trelloExcludedOptions = (0, $42omo.useMemo)(()=>[
            'custom',
            'yesterday'
        ], []);
    const optionsToExclude = selectedProduct === (0, $b4tvS.ProductKeys).Trello ? trelloExcludedOptions : [];
    const [filterData, { setOption: setOption, clearOptions: clearOptions, loadInitialOptions: loadInitialOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $1uGSo.filter).id,
        optionValuesToExclude: optionsToExclude
    });
    // This is a workaround to clear the options when the product is change to Trello
    // To avoid Trello query get filtered by un applicable options that might confuse the user
    // If Trello later served as indexed data that support all date options, this can be removed
    (0, $42omo.useEffect)(()=>{
        const isTrelloUnapplicableOptionsSelected = filterData?.selectedOptions && // @ts-ignore - TS7006 TypeScript 5.9.2 upgrade
        filterData?.selectedOptions.filter((option)=>trelloExcludedOptions.includes(option.value)).length > 0;
        if (selectedProduct === (0, $b4tvS.ProductKeys).Trello && isTrelloUnapplicableOptionsSelected) clearOptions();
    }, [
        clearOptions,
        filterData?.selectedOptions,
        selectedProduct,
        trelloExcludedOptions
    ]);
    if (!filterData) return null;
    const { options: options, selectedOptions: selectedOptions, customValue: customValue } = filterData;
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $hCRbr.i18n).lastUpdated);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9PTlU.default), {
        contentFit: fit,
        options: options,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        label: label,
        onDropdownOpen: loadInitialOptions,
        selectedOptions: selectedOptions,
        customDateRange: customValue || {
            from: '',
            to: ''
        },
        testId: testId,
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $414466d330b6ec26$export$2e2bcd8739ae039 = $414466d330b6ec26$var$LastUpdatedFilter;
module.exports["default"] = $414466d330b6ec26$export$2e2bcd8739ae039;

});

parcelRegister("iLJVZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $jQ2up = parcelRequire("jQ2up");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $huubg = parcelRequire("huubg");


var $mCz2w = parcelRequire("mCz2w");

const $e48d36c8a558b60d$var$LastUpdatedByFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $huubg.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $mCz2w.i18n).confluenceFilterCreatorLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $mCz2w.i18n).confluenceFilterCreatorLabelUnselected),
            options: suggestedOptions
        }
    ];
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $mCz2w.i18n).lastUpdatedBy);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: label,
        placeholder: formatMessage((0, $mCz2w.i18n).confluenceFilterCreatorPlaceholder),
        filterOrControlId: 'lastUpdatedBy',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: (0, $jQ2up.formatAvatarOptionLabel),
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $huubg.filter).id
            });
        },
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $e48d36c8a558b60d$export$2e2bcd8739ae039 = $e48d36c8a558b60d$var$LastUpdatedByFilter;
module.exports["default"] = $e48d36c8a558b60d$export$2e2bcd8739ae039;

});

parcelRegister("j8URb", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $dmbve = parcelRequire("dmbve");


var $lBO0P = parcelRequire("lBO0P");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $dFCIx = parcelRequire("dFCIx");


var $rdHwx = parcelRequire("rdHwx");

const $ce1bae4582862dab$var$OpportunityStatusFilter = ({ isFilterInDropdown: isFilterInDropdown, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setOption: setOption, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $dFCIx.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions } = filterData;
    const allOptions = [
        ...selectedOptions,
        ...suggestedOptions
    ];
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $rdHwx.i18n).opportunityStatusFilterLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        canClearFilter: true,
        onDropdownOpen: loadInitialOptions,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: allOptions,
        selectedOptions: selectedOptions,
        label: label,
        filterOrControlId: 'opportunityStatus',
        isLoading: isLoading,
        isSearchable: false,
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $dFCIx.filter).id
            });
        },
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dmbve))), {
            label: ""
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $ce1bae4582862dab$export$2e2bcd8739ae039 = $ce1bae4582862dab$var$OpportunityStatusFilter;
module.exports["default"] = $ce1bae4582862dab$export$2e2bcd8739ae039;

});

parcelRegister("d2tOF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $jQ2up = parcelRequire("jQ2up");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $5ousX = parcelRequire("5ousX");


var $ivrfM = parcelRequire("ivrfM");

const $b7439fb9901a187b$var$OwnerFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $5ousX.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $ivrfM.i18n).confluenceFilterOwnerLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $ivrfM.i18n).confluenceFilterOwnerLabelUnselected),
            options: suggestedOptions
        }
    ];
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $ivrfM.i18n).owner);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: label,
        placeholder: formatMessage((0, $ivrfM.i18n).confluenceFilterOwnerPlaceholder),
        filterOrControlId: 'owner',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: (0, $jQ2up.formatAvatarOptionLabel),
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $5ousX.filter).id
            });
        },
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $b7439fb9901a187b$export$2e2bcd8739ae039 = $b7439fb9901a187b$var$OwnerFilter;
module.exports["default"] = $b7439fb9901a187b$export$2e2bcd8739ae039;

});

parcelRegister("90exq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $1sswv = parcelRequire("1sswv");


var $6yMPR = parcelRequire("6yMPR");

const $b04368215fe9d1c2$var$PageStatusFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setOption: setOption }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $1sswv.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, selectedOptions: selectedOptions, options: options } = filterData;
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $6yMPR.i18n).pageStatus);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        onDropdownOpen: loadInitialOptions,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: options,
        selectedOptions: selectedOptions,
        label: label,
        filterOrControlId: 'pageStatus',
        isLoading: isLoading,
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $b04368215fe9d1c2$export$2e2bcd8739ae039 = $b04368215fe9d1c2$var$PageStatusFilter;
module.exports["default"] = $b04368215fe9d1c2$export$2e2bcd8739ae039;

});

parcelRegister("lBO0P", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $c4sKh = parcelRequire("c4sKh");


var $dh538 = parcelRequire("dh538");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $bbypI = parcelRequire("bbypI");

var $6Ipjn = parcelRequire("6Ipjn");


var $kIdP4 = parcelRequire("kIdP4");


var $2ZCkf = parcelRequire("2ZCkf");


var $coCs8 = parcelRequire("coCs8");


var $kfaxy = parcelRequire("kfaxy");


var $kjNCN = parcelRequire("kjNCN");


var $k5mzm = parcelRequire("k5mzm");


var $ls6iZ = parcelRequire("ls6iZ");


var $5eact = parcelRequire("5eact");

const $d42c8c4a4f54095c$var$badgeStyles = (0, $ecnYn.xcss)({
    alignItems: 'center',
    alignSelf: 'center',
    display: 'flex'
});
const $d42c8c4a4f54095c$var$SelectFilter = ({ defaultIsOpen: defaultIsOpen = false, isSearchable: isSearchable = false, isLoading: isLoading = false, canClearFilter: canClearFilter = false, checkboxIndicators: checkboxIndicators = false, formatOptionLabel: formatOptionLabel, placeholder: placeholder, searchInput: searchInput, onSearchInputChange: onSearchInputChange, onSelectChange: onSelectChange, onDropdownOpen: onDropdownOpen, onDropdownClose: onDropdownClose, options: options, selectedOptions: selectedOptions, label: label, noOptionsMessage: noOptionsMessage, filterOrControlId: filterOrControlId, getFirstSelectedLabel: getFirstSelectedLabel, onClearOptions: onClearOptions, minMenuWidth: minMenuWidth, testId: testId, iconBefore: iconBefore, isFilterInDropdown: isFilterInDropdown, isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled, hideOnHoverOut: hideOnHoverOut, matchReferenceWidth: matchReferenceWidth = isFilterInDropdown, contentFit: contentFit, filterOption: filterOptionOverride })=>{
    const numSelectedOptions = selectedOptions.length;
    const firstSelected = selectedOptions[0];
    const filterButtonRef = (0, $42omo.useRef)(null);
    // We only use this state to control the open/close of the popup when hideOnHoverOut is enabled
    // Otherwise, the open/close is controlled by PopupSelect internally
    const [isPopupOpen, setIsPopupOpen] = (0, $42omo.useState)(false);
    const debounceTimeout = (0, $42omo.useRef)(null);
    // TODO: this can be removed if we have debounce in the store when lookup
    const [currentSearchInput, setCurrentSearchInput] = (0, $42omo.useState)(searchInput);
    const customModifiers = [
        ...matchReferenceWidth ? [
            (0, $kjNCN.matchReferenceWidthModifier)
        ] : []
    ];
    const handleInputChange = (0, $42omo.useCallback)((value, action)=>{
        if (action.action !== 'input-change') return;
        setCurrentSearchInput(value);
        if (!onSearchInputChange) return;
        if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
        debounceTimeout.current = setTimeout(()=>{
            onSearchInputChange(value);
        }, 300);
    }, [
        onSearchInputChange
    ]);
    const handleChange = (0, $42omo.useCallback)((value)=>{
        onSelectChange(value);
    }, [
        onSelectChange
    ]);
    const handleClose = (0, $42omo.useCallback)(()=>{
        setIsPopupOpen(false);
        setCurrentSearchInput('');
        onDropdownClose?.();
    }, [
        onDropdownClose
    ]);
    const handleOpen = (0, $42omo.useCallback)(()=>{
        setIsPopupOpen(true);
        onDropdownOpen?.();
    }, [
        onDropdownOpen
    ]);
    const handleBlur = (0, $42omo.useCallback)((event)=>{
        if (event.relatedTarget !== filterButtonRef.current) // Unblur is not from filter button
        handleClose();
    }, [
        handleClose
    ]);
    const controlOpenStateProps = hideOnHoverOut && (0, $dh538.fg)('search_qf_close_dropdown_on_hover_off') && {
        isOpen: isPopupOpen,
        onBlur: handleBlur
    };
    // Disable react-select's default client-side filtering so server results (e.g. matched by
    // project key) are not incorrectly filtered out because their label doesn't match the input.
    // Consumers can override this by passing filterOption={null} to preserve client-side filtering
    const filterOption = filterOptionOverride !== undefined ? filterOptionOverride ?? undefined : isSearchable ? ()=>true : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kfaxy.MaybeHoverOutWrapper), {
        callback: handleClose,
        enabled: hideOnHoverOut
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6Ipjn.default), {
        ...controlOpenStateProps,
        placeholder: placeholder,
        onMenuOpen: handleOpen,
        onMenuClose: handleClose,
        minMenuWidth: minMenuWidth,
        maxMenuWidth: "22rem",
        maxMenuHeight: 400,
        menuPlacement: "bottom",
        defaultIsOpen: defaultIsOpen,
        closeMenuOnSelect: !checkboxIndicators,
        isSearchable: isSearchable,
        searchThreshold: -1,
        blurInputOnSelect: false,
        isClearable: false,
        // @ts-ignore - https://product-fabric.atlassian.net/browse/DSP-21000
        defaultOptions: false,
        isLoading: isLoading,
        inputValue: currentSearchInput,
        onInputChange: handleInputChange,
        noOptionsMessage: currentSearchInput ? undefined : ()=>noOptionsMessage,
        canClearFilter: canClearFilter,
        onChange: handleChange,
        onClearOptions: onClearOptions,
        options: options,
        isOptionSelected: (option)=>option.isSelected,
        shouldCloseMenuOnTab: false,
        label: label,
        filterOption: filterOption,
        popperProps: {
            strategy: 'fixed',
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [
                            0,
                            8
                        ]
                    }
                },
                {
                    name: 'preventOverflow',
                    enabled: false
                },
                ...customModifiers
            ]
        },
        target: ({ isOpen: isOpen, ...triggerProps })=>{
            let firstSelectedLabel = getFirstSelectedLabel ? getFirstSelectedLabel(firstSelected) : firstSelected?.label;
            let labelElement = label;
            if (typeof label === 'string') labelElement = (0, $5eact.getButtonText)({
                label: label,
                firstSelectedLabel: firstSelectedLabel,
                numSelectedOptions: numSelectedOptions
            });
            const isSelected = isOpen || numSelectedOptions > 0;
            if (isFiltersDiscoverability2Enabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2ZCkf.FilterButton), {
                ...(0, $dh538.fg)('search_qf_close_dropdown_on_hover_off') && {
                    onClick: isOpen ? handleClose : handleOpen
                },
                ...triggerProps,
                ref: (0, $kIdP4.mergeRefs)(triggerProps.ref, filterButtonRef),
                testId: testId ? `${testId}-button` : undefined,
                isSelected: isSelected,
                iconBefore: iconBefore,
                filterOrControlId: filterOrControlId,
                isFilterInDropdown: isFilterInDropdown,
                contentFit: contentFit,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, numSelectedOptions > 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                    xcss: $d42c8c4a4f54095c$var$badgeStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4sKh.default), {
                    appearance: "information"
                }, `+${numSelectedOptions - 1}`)) : undefined)
            }, labelElement);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $coCs8.FilterButtonOld), {
                ...(0, $dh538.fg)('search_qf_close_dropdown_on_hover_off') && {
                    onClick: isOpen ? handleClose : handleOpen
                },
                testId: testId ? `${testId}-button` : undefined,
                otherProps: triggerProps,
                isSelected: isSelected,
                label: labelElement,
                filterOrControlId: filterOrControlId,
                selectionBadge: numSelectedOptions > 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4sKh.default), {
                    appearance: "information"
                }, `+${numSelectedOptions - 1}`) : undefined,
                iconBefore: iconBefore
            });
        },
        // formatOptionLabel and components are Removing in Q3 FY25
        // https://hello.atlassian.net/wiki/x/oQnE8g
        formatOptionLabel: formatOptionLabel,
        components: {
            Control: $k5mzm.Control,
            MenuList: isFiltersDiscoverability2Enabled ? (0, $ls6iZ.MenuListWithoutClearFilterOptionLabel) : (0, $ls6iZ.MenuListWithClearFilterOptionLabel),
            ...checkboxIndicators ? {
                Option: (0, $bbypI.CheckboxOption)
            } : {}
        }
    }));
};
var $d42c8c4a4f54095c$export$2e2bcd8739ae039 = $d42c8c4a4f54095c$var$SelectFilter;
module.exports["default"] = $d42c8c4a4f54095c$export$2e2bcd8739ae039;

});

parcelRegister("epJdx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $2BDjU = parcelRequire("2BDjU");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $fLju9 = parcelRequire("fLju9");


var $FK90w = parcelRequire("FK90w");

const $bb9fb8a57488cc5c$var$formatOptionLabel = (option)=>{
    const { label: label, metadata: metadata } = option;
    const type = metadata?.type || '';
    const owner = metadata?.owner || '';
    const status = metadata?.status;
    const health = metadata?.health;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.150",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2BDjU.default), {
        spacing: "spacious",
        status: status,
        health: health,
        label: label
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        maxLines: 2
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtle",
        size: "small"
    }, type, " \u2022 ", owner)));
};
const $bb9fb8a57488cc5c$var$PositionFocusAreaFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $fLju9.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $FK90w.i18n).positionFilterFocusAreaLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $FK90w.i18n).positionFilterFocusAreaLabelUnselected),
            options: suggestedOptions
        }
    ];
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $FK90w.i18n).positionFilterFocusAreaLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        checkboxIndicators: true,
        canClearFilter: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: label,
        placeholder: formatMessage((0, $FK90w.i18n).positionFilterFocusAreaPlaceholder),
        filterOrControlId: 'positionFocusArea',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: $bb9fb8a57488cc5c$var$formatOptionLabel,
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $fLju9.filter).id
            });
        },
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $bb9fb8a57488cc5c$export$2e2bcd8739ae039 = $bb9fb8a57488cc5c$var$PositionFocusAreaFilter;
module.exports["default"] = $bb9fb8a57488cc5c$export$2e2bcd8739ae039;

});

parcelRegister("3xkiG", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $dXdDw = parcelRequire("dXdDw");


var $1pFlR = parcelRequire("1pFlR");

const $8dff75f96ac62ec8$var$PositionJobFamilyFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $dXdDw.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $1pFlR.i18n).positionFilterJobFamilyLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $1pFlR.i18n).positionFilterJobFamilyLabelUnselected),
            options: suggestedOptions
        }
    ];
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $1pFlR.i18n).positionFilterJobFamilyLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: label,
        placeholder: formatMessage((0, $1pFlR.i18n).positionFilterJobFamilyPlaceholder),
        filterOrControlId: 'positionJobFamily',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $dXdDw.filter).id
            });
        },
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $8dff75f96ac62ec8$export$2e2bcd8739ae039 = $8dff75f96ac62ec8$var$PositionJobFamilyFilter;
module.exports["default"] = $8dff75f96ac62ec8$export$2e2bcd8739ae039;

});

parcelRegister("1zHCN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $5eFo6 = parcelRequire("5eFo6");


var $7SF4k = parcelRequire("7SF4k");

const $5cc346db44a2bc60$var$PositionStatusFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $5eFo6.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $7SF4k.i18n).positionStatusFilterLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $7SF4k.i18n).positionStatusFilterLabelUnselected),
            options: suggestedOptions
        }
    ];
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $7SF4k.i18n).positionStatusFilterLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        canClearFilter: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: label,
        placeholder: formatMessage((0, $7SF4k.i18n).positionStatusFilterPlaceholder),
        filterOrControlId: 'positionStatus',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $5eFo6.filter).id
            });
        },
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $5cc346db44a2bc60$export$2e2bcd8739ae039 = $5cc346db44a2bc60$var$PositionStatusFilter;
module.exports["default"] = $5cc346db44a2bc60$export$2e2bcd8739ae039;

});

parcelRegister("4VBuR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $esRft = parcelRequire("esRft");


var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $aeffu = parcelRequire("aeffu");


var $7PdYY = parcelRequire("7PdYY");

const $65f732563275e7da$var$formatOptionLabel = (option)=>{
    const { label: label, avatarUrl: avatarUrl } = option;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.150",
        alignBlock: "center"
    }, avatarUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
        appearance: "circle",
        size: "xsmall",
        src: avatarUrl,
        name: label
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        maxLines: 2
    }, label));
};
const $65f732563275e7da$var$PositionTeamFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $aeffu.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $7PdYY.i18n).positionFilterTeamLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $7PdYY.i18n).positionFilterTeamLabelUnselected),
            options: suggestedOptions
        }
    ];
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $7PdYY.i18n).positionFilterTeamLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        checkboxIndicators: true,
        canClearFilter: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: label,
        placeholder: formatMessage((0, $7PdYY.i18n).positionFilterTeamPlaceholder),
        filterOrControlId: 'positionTeam',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: $65f732563275e7da$var$formatOptionLabel,
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $aeffu.filter).id
            });
        },
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $65f732563275e7da$export$2e2bcd8739ae039 = $65f732563275e7da$var$PositionTeamFilter;
module.exports["default"] = $65f732563275e7da$export$2e2bcd8739ae039;

});

parcelRegister("d8wvI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $jQ2up = parcelRequire("jQ2up");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $gHwfH = parcelRequire("gHwfH");


var $dSRVv = parcelRequire("dSRVv");

const $52ec9760f4f0950e$var$ProjectFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $gHwfH.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $dSRVv.i18n).jiraFilterSpacesLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $dSRVv.i18n).jiraFilterSpacesLabelUnselected),
            options: suggestedOptions
        }
    ];
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $dSRVv.i18n).spaces);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: label,
        placeholder: formatMessage((0, $dSRVv.i18n).jiraFilterSpacesPlaceholder),
        filterOrControlId: 'project',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: (0, $jQ2up.formatAvatarOptionLabel),
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $gHwfH.filter).id
            });
        },
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $52ec9760f4f0950e$export$2e2bcd8739ae039 = $52ec9760f4f0950e$var$ProjectFilter;
module.exports["default"] = $52ec9760f4f0950e$export$2e2bcd8739ae039;

});

parcelRegister("dHIx8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $3TPSi = parcelRequire("3TPSi");


var $kAzVs = parcelRequire("kAzVs");

const $c4896255d920ab91$var$PullRequestStatusFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setOption: setOption }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $3TPSi.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, selectedOptions: selectedOptions, options: options } = filterData;
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $kAzVs.i18n).pullRequestStatusLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        onDropdownOpen: loadInitialOptions,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: options,
        selectedOptions: selectedOptions,
        label: label,
        filterOrControlId: 'pullRequestStatus',
        isLoading: isLoading,
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        checkboxIndicators: true,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $c4896255d920ab91$export$2e2bcd8739ae039 = $c4896255d920ab91$var$PullRequestStatusFilter;
module.exports["default"] = $c4896255d920ab91$export$2e2bcd8739ae039;

});

parcelRegister("5HYjQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $jQ2up = parcelRequire("jQ2up");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $f1JPm = parcelRequire("f1JPm");


var $41YG4 = parcelRequire("41YG4");

const $caaaefd429b3fb57$var$ReporterFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $f1JPm.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $41YG4.i18n).jiraFilterReporterLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $41YG4.i18n).jiraFilterReporterLabelUnselected),
            options: suggestedOptions
        }
    ];
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $41YG4.i18n).reporter);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: label,
        placeholder: formatMessage((0, $41YG4.i18n).jiraFilterContributorPlaceholder),
        filterOrControlId: 'reporter',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: (0, $jQ2up.formatAvatarOptionLabel),
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $f1JPm.filter).id
            });
        },
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $caaaefd429b3fb57$export$2e2bcd8739ae039 = $caaaefd429b3fb57$var$ReporterFilter;
module.exports["default"] = $caaaefd429b3fb57$export$2e2bcd8739ae039;

});

parcelRegister("kvgSJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $dzNsR = parcelRequire("dzNsR");


var $bbo8Q = parcelRequire("bbo8Q");

const $56e6a0048ca7663d$var$RepositoryFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, onClearOptions: onClearOptions, hideOnHoverOut: hideOnHoverOut })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $dzNsR.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, selectedOptions: selectedOptions, options: options } = filterData;
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $bbo8Q.i18n).repositoryLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        canClearFilter: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $dzNsR.filter).id
            });
        },
        options: options,
        selectedOptions: selectedOptions,
        label: label,
        filterOrControlId: (0, $dzNsR.filter).id,
        isLoading: isLoading,
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        noOptionsMessage: formatMessage((0, $bbo8Q.i18n).noOptions),
        checkboxIndicators: true,
        isSearchable: true,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $56e6a0048ca7663d$export$2e2bcd8739ae039 = $56e6a0048ca7663d$var$RepositoryFilter;
module.exports["default"] = $56e6a0048ca7663d$export$2e2bcd8739ae039;

});

parcelRegister("dm37y", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $dh538 = parcelRequire("dh538");


var $2zuvB = parcelRequire("2zuvB");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $djVCD = parcelRequire("djVCD");


var $fJFyr = parcelRequire("fJFyr");


var $1zWkb = parcelRequire("1zWkb");

const $7564d17dfe6481a6$export$66a8c50d62eea7ce = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setOption: setOption, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $fJFyr.filter).id
    });
    // also render in the All-apps view of Jira/Confluence FPS.
    const shouldRender = !selectedProduct && (primaryProduct === (0, $b4tvS.ProductKeys).Confluence || primaryProduct === (0, $b4tvS.ProductKeys).Jira) && (0, $dh538.fg)('rovo_fps_sort_in_suggested_filters') || selectedProduct === (0, $b4tvS.ProductKeys).Confluence || selectedProduct === (0, $b4tvS.ProductKeys).Jira;
    if (!shouldRender) return null;
    if (!filterData) return null;
    const { isLoading: isLoading, selectedOptions: selectedOptions, options: options } = filterData;
    const selectedLabelKey = $7564d17dfe6481a6$var$selectedOptionToSelectedLabelKey(selectedOptions[0]);
    const label = selectedLabelKey ? formatMessage((0, $1zWkb.messages)[selectedLabelKey]) : formatMessage((0, $1zWkb.messages)[(0, $2zuvB.RESULTS_SORT_FIELDS).relevanceDESC.selectedLabelKey]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        onDropdownOpen: loadInitialOptions,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: options,
        selectedOptions: selectedOptions,
        label: label,
        filterOrControlId: (0, $fJFyr.filter).id,
        isLoading: isLoading,
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut,
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $fJFyr.filter).id
            });
        },
        getFirstSelectedLabel: ()=>''
    });
};
const $7564d17dfe6481a6$var$selectedOptionToSelectedLabelKey = (option)=>{
    switch(option?.value){
        case 'relevance':
            return (0, $2zuvB.RESULTS_SORT_FIELDS).relevanceDESC.selectedLabelKey;
        case 'updatedNewest':
            return (0, $2zuvB.RESULTS_SORT_FIELDS).latestModifiedDateDESC.selectedLabelKey;
        case 'updatedOldest':
            return (0, $2zuvB.RESULTS_SORT_FIELDS).latestModifiedDateASC.selectedLabelKey;
        case 'createdNewest':
            return (0, $2zuvB.RESULTS_SORT_FIELDS).createdDateDESC.selectedLabelKey;
        case 'createdOldest':
            return (0, $2zuvB.RESULTS_SORT_FIELDS).createdDateASC.selectedLabelKey;
    }
};
module.exports["ResultsSort"] = $7564d17dfe6481a6$export$66a8c50d62eea7ce;

});

parcelRegister("2UnmY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $9bPlJ = parcelRequire("9bPlJ");


var $dh538 = parcelRequire("dh538");


var $jUrPw = parcelRequire("jUrPw");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $720nW = parcelRequire("720nW");


var $16U2b = parcelRequire("16U2b");

const $90d4511f01f8af05$var$SalesforceStageFilter = (props)=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setOption: setOption, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $720nW.filter).id
    });
    const shouldEagerLoadOptions = (0, $dh538.fg)('rovo-fps-3p-ux-salesforce-dynamic-stage-filter');
    const isRetryOnConfigLoadEnabled = (0, $dh538.fg)('rovo-fps-3p-ux-sf-retry-on-config-load');
    const isConfigLoaded = (0, $j4ply.useIsConfigLoaded)();
    // Treat as "loaded" once we have invoked loadInitialOptions with a populated bootstrap
    // config. When the retry FF is off this guard is a permanent one-shot (preserving the
    // legacy behaviour). When the FF is on, the effect below also waits for isConfigLoaded
    // to flip true before flipping this ref, so a race against the bootstrap config load
    // can no longer poison the filter into a permanent empty state.
    const hasLoadedInitialOptions = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (!shouldEagerLoadOptions || hasLoadedInitialOptions.current) return;
        // When the retry FF is enabled, hold off until bootstrap config has loaded so
        // the store can actually resolve a datasource and fetch options. Without it,
        // fall back to the legacy fire-once-on-mount behaviour.
        if (isRetryOnConfigLoadEnabled && !isConfigLoaded) return;
        hasLoadedInitialOptions.current = true;
        loadInitialOptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        shouldEagerLoadOptions,
        isRetryOnConfigLoadEnabled,
        isConfigLoaded
    ]);
    if (!filterData || !shouldEagerLoadOptions) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions } = filterData;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jUrPw.default), {
        ...props,
        filterId: (0, $720nW.filter).id,
        label: formatMessage((0, $16U2b.i18n).salesforceStageFilterLabel),
        noOptionsMessage: formatMessage((0, $16U2b.i18n).salesforceStageFilterNoOptions),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9bPlJ))), {
            label: ""
        }),
        isLoading: isLoading,
        selectedOptions: selectedOptions,
        suggestedOptions: suggestedOptions,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        loadInitialOptions: loadInitialOptions,
        setOption: (option)=>setOption(option),
        clearOptions: clearOptions
    });
};
var $90d4511f01f8af05$export$2e2bcd8739ae039 = $90d4511f01f8af05$var$SalesforceStageFilter;
module.exports["default"] = $90d4511f01f8af05$export$2e2bcd8739ae039;

});

parcelRegister("1Ddz9", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $lBO0P = parcelRequire("lBO0P");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $iz3ta = parcelRequire("iz3ta");


var $13BpK = parcelRequire("13BpK");

const $66ea9455ebf8eb30$var$channelLabelStyles = null;
const $66ea9455ebf8eb30$var$SlackChannelFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $iz3ta.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $13BpK.i18n).label);
    const groupedOptions = [
        {
            label: formatMessage((0, $13BpK.i18n).selectedLabel),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $13BpK.i18n).suggestedLabel),
            options: suggestedOptions
        }
    ];
    return /*#__PURE__*/ $42omo.createElement((0, $lBO0P.default), {
        contentFit: fit,
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: (option)=>{
            setOption(option);
            onFilterChange?.(option);
        },
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: label,
        placeholder: formatMessage((0, $13BpK.i18n).placeholder),
        filterOrControlId: "slackChannel",
        testId: "search-dialog-slack-channel-filter",
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $iz3ta.filter).id
            });
        },
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        hideOnHoverOut: hideOnHoverOut,
        formatOptionLabel: (option)=>/*#__PURE__*/ $42omo.createElement("span", {
                className: (0, $gMc0m.default)([
                    "_1kt91ihd _is061rpy _eid3u2gc"
                ])
            }, option.label)
    });
};
var $66ea9455ebf8eb30$export$2e2bcd8739ae039 = $66ea9455ebf8eb30$var$SlackChannelFilter;
module.exports["default"] = $66ea9455ebf8eb30$export$2e2bcd8739ae039;

});

parcelRegister("6YAWs", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $dh538 = parcelRequire("dh538");


var $b4tvS = parcelRequire("b4tvS");

parcelRequire("1yEFx");
var $1yEFx = parcelRequire("1yEFx");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $jQ2up = parcelRequire("jQ2up");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $djVCD = parcelRequire("djVCD");


var $dQXZO = parcelRequire("dQXZO");


var $a97k3 = parcelRequire("a97k3");


var $8QBsF = parcelRequire("8QBsF");

const $e67ab6cca68b40e0$var$thirdPartySpaceLabels = {
    [(0, $b4tvS.ProductKeys).GoogleDrive]: {
        label: (0, $8QBsF.i18n).drive,
        placeholder: (0, $8QBsF.i18n).drivePlaceholder
    },
    [(0, $b4tvS.ProductKeys).Sharepoint]: {
        label: (0, $8QBsF.i18n).site,
        placeholder: (0, $8QBsF.i18n).sitePlaceholder
    }
};
const $e67ab6cca68b40e0$var$SpaceFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const [selectedProduct] = (0, $djVCD.useSelectedProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const products = (0, $1yEFx.useProductConfigs)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOptionForSelectFilter, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $a97k3.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const setOption = (option)=>{
        // Validate content filter when feature flag is enabled for Google Drive or SharePoint
        const shouldValidateContentFilter = selectedProduct === (0, $b4tvS.ProductKeys).GoogleDrive && (0, $dh538.fg)('rovo_fps_3p_folder_validation_on_space_change') || selectedProduct === (0, $b4tvS.ProductKeys).Sharepoint && (0, $dh538.fg)('rovo_fps_3p_folder_validation_on_space_sharepoint');
        const validateDependentFilterId = shouldValidateContentFilter ? (0, $dQXZO.filter).id : undefined;
        setOptionForSelectFilter(option, undefined, selectedProduct ?? (0, $b4tvS.ProductKeys).Confluence, validateDependentFilterId);
    };
    const groupedOptions = [
        {
            label: formatMessage((0, $8QBsF.i18n).confluenceFilterLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $8QBsF.i18n).confluenceFilterLabelUnselected),
            options: suggestedOptions
        }
    ];
    const thirdPartyLabels = selectedProduct ? $e67ab6cca68b40e0$var$thirdPartySpaceLabels[selectedProduct] : undefined;
    const spaceLabel = thirdPartyLabels ? formatMessage(thirdPartyLabels.label) : formatMessage((0, $8QBsF.i18n).space);
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : spaceLabel;
    const placeholder = thirdPartyLabels ? formatMessage(thirdPartyLabels.placeholder) : formatMessage((0, $8QBsF.i18n).confluenceFilterSpacePlaceholder);
    const isThirdPartySingleSelect = (0, $b4tvS.is3pProductKey)(selectedProduct ?? '');
    // For 3P single-select products, use the product's own icon instead of the avatar fallback
    // (which shows a person icon when avatarUrl is missing).
    const ProductIcon = isThirdPartySingleSelect && selectedProduct ? products[selectedProduct]?.Icon : undefined;
    const formatOptionLabel = ProductIcon ? (0, $jQ2up.createOptionLabelFormatter)(({ option: option })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ProductIcon, {
            label: option.label,
            size: "small"
        })) : (0, $jQ2up.formatAvatarOptionLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        canClearFilter: true,
        checkboxIndicators: !isThirdPartySingleSelect,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: (option)=>{
            setOption(option);
            onFilterChange?.(option);
        },
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: label,
        placeholder: placeholder,
        filterOrControlId: 'space',
        testId: "search-dialog-space-filter",
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: formatOptionLabel,
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $a97k3.filter).id
            });
        },
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        hideOnHoverOut: hideOnHoverOut
    });
};
var $e67ab6cca68b40e0$export$2e2bcd8739ae039 = $e67ab6cca68b40e0$var$SpaceFilter;
module.exports["default"] = $e67ab6cca68b40e0$export$2e2bcd8739ae039;

});

parcelRegister("eCrxg", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $b6IhR = parcelRequire("b6IhR");


var $6ebAl = parcelRequire("6ebAl");

const $e2fb3030ca8c5426$var$StatusFilter = ({ isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setOption: setOption }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $b6IhR.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, selectedOptions: selectedOptions, options: options } = filterData;
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $6ebAl.i18n).statusLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        onDropdownOpen: loadInitialOptions,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: options,
        selectedOptions: selectedOptions,
        label: label,
        filterOrControlId: 'statusFilter',
        isLoading: isLoading,
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        checkboxIndicators: true,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $e2fb3030ca8c5426$export$2e2bcd8739ae039 = $e2fb3030ca8c5426$var$StatusFilter;
module.exports["default"] = $e2fb3030ca8c5426$export$2e2bcd8739ae039;

});

parcelRegister("b7IiT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3dgQu = parcelRequire("3dgQu");


var $1eaCj = parcelRequire("1eaCj");


var $ffbvg = parcelRequire("ffbvg");


var $j4ply = parcelRequire("j4ply");


var $iaYRG = parcelRequire("iaYRG");


var $316RU = parcelRequire("316RU");

const $4ece80b10dab95bf$var$TitleMatchOnlyFilter = ({ isFilterInDropdown: isFilterInDropdown = false, showPrimaryProductIcon: showPrimaryProductIcon, onFilterChange: onFilterChange })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [state, { toggle: toggle }] = (0, $ffbvg.useBooleanFilter)({
        filterId: (0, $iaYRG.filter).id
    });
    if (!state) return null;
    const { value: value, autoFocus: autoFocus } = state;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCj.ToggleFilter), {
        onChange: ()=>{
            onFilterChange?.({
                isSelected: value
            });
            toggle();
        },
        isChecked: value,
        autoFocus: autoFocus,
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        })
    }, formatMessage((0, $316RU.i18n).onlyTitleMatch));
};
var $4ece80b10dab95bf$export$2e2bcd8739ae039 = $4ece80b10dab95bf$var$TitleMatchOnlyFilter;
module.exports["default"] = $4ece80b10dab95bf$export$2e2bcd8739ae039;

});

parcelRegister("23zGK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $5iakG = parcelRequire("5iakG");

parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");


var $3dgQu = parcelRequire("3dgQu");


var $lBO0P = parcelRequire("lBO0P");


var $1xk5k = parcelRequire("1xk5k");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $djVCD = parcelRequire("djVCD");


var $3JX0d = parcelRequire("3JX0d");


var $OOvdO = parcelRequire("OOvdO");

const $31ae16293dbaddfc$var$getOptionsToProducts = (typeMapping)=>{
    const optionsToProducts = {};
    (0, $3JX0d.getAllTypeFilterKeysForSearch)().forEach((type)=>{
        optionsToProducts[type] = typeMapping[type].products || [];
    });
    return optionsToProducts;
};
const $31ae16293dbaddfc$var$TypeFilter = ({ testId: testId = 'universal-type-filter', isFilterInDropdown: isFilterInDropdown, showPrimaryProductIcon: showPrimaryProductIcon, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const typeMapping = (0, $1xk5k.getTypeMapping)();
    const optionsToProducts = $31ae16293dbaddfc$var$getOptionsToProducts(typeMapping);
    const [productSelected] = (0, $djVCD.useSelectedProduct)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { setOption: setOption, loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useUniversalSelectFilter)({
        filterId: (0, $5iakG.universalTypeFilterId),
        optionsToProducts: optionsToProducts
    });
    if (!filterData) return null;
    // Do not show TypeFilter for Atlas since that is handled by Noun filters
    if (productSelected === (0, $b4tvS.ProductKeys).Atlas) return null;
    const { selectedOptions: selectedOptions, options: options, lookupInput: lookupInput } = filterData;
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $OOvdO.i18n).type);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSelectChange: (option, ...restArgs)=>{
            setOption(option, ...restArgs);
            onFilterChange?.(option);
        },
        options: options,
        selectedOptions: selectedOptions,
        label: label,
        placeholder: formatMessage((0, $OOvdO.i18n).filterTypePlaceholder),
        filterOrControlId: (0, $5iakG.universalTypeFilterId),
        searchInput: lookupInput,
        onSearchInputChange: setLookupInput,
        isSearchable: true,
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $5iakG.universalTypeFilterId)
            });
        },
        testId: testId,
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            showPrimaryProductIcon: showPrimaryProductIcon,
            primaryProduct: primaryProduct
        }),
        hideOnHoverOut: hideOnHoverOut
    });
};
var $31ae16293dbaddfc$export$2e2bcd8739ae039 = $31ae16293dbaddfc$var$TypeFilter;
module.exports["default"] = $31ae16293dbaddfc$export$2e2bcd8739ae039;

});

parcelRegister("hTSDS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3dgQu = parcelRequire("3dgQu");


var $1eaCj = parcelRequire("1eaCj");


var $ffbvg = parcelRequire("ffbvg");


var $j4ply = parcelRequire("j4ply");


var $bF9JE = parcelRequire("bF9JE");


var $iwoTl = parcelRequire("iwoTl");

const $40a9c469d3ed1fab$var$VerifiedFilter = ({ isFilterInDropdown: isFilterInDropdown = false, showPrimaryProductIcon: showPrimaryProductIcon, onFilterChange: onFilterChange })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [state, { toggle: toggle }] = (0, $ffbvg.useBooleanFilter)({
        filterId: (0, $bF9JE.filter).id
    });
    if (!state) return null;
    const { value: value, autoFocus: autoFocus } = state;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCj.ToggleFilter), {
        onChange: ()=>{
            onFilterChange?.({
                isSelected: value
            });
            toggle();
        },
        isChecked: value,
        autoFocus: autoFocus,
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            primaryProduct: primaryProduct,
            showPrimaryProductIcon: showPrimaryProductIcon
        })
    }, formatMessage((0, $iwoTl.i18n).verified));
};
var $40a9c469d3ed1fab$export$2e2bcd8739ae039 = $40a9c469d3ed1fab$var$VerifiedFilter;
module.exports["default"] = $40a9c469d3ed1fab$export$2e2bcd8739ae039;

});

parcelRegister("5773E", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3dgQu = parcelRequire("3dgQu");


var $1eaCj = parcelRequire("1eaCj");


var $ffbvg = parcelRequire("ffbvg");


var $j4ply = parcelRequire("j4ply");


var $9DkM9 = parcelRequire("9DkM9");


var $hK6k5 = parcelRequire("hK6k5");

const $2e43cb3da58d96ce$var$WatchedFilter = ({ isFilterInDropdown: isFilterInDropdown = false, showPrimaryProductIcon: showPrimaryProductIcon, onFilterChange: onFilterChange })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [primaryProduct] = (0, $j4ply.usePrimaryProduct)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [state, { toggle: toggle }] = (0, $ffbvg.useBooleanFilter)({
        filterId: (0, $9DkM9.filter).id
    });
    if (!state) return null;
    const { value: value, autoFocus: autoFocus } = state;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCj.ToggleFilter), {
        onChange: ()=>{
            onFilterChange?.({
                isSelected: value
            });
            toggle();
        },
        isChecked: value,
        autoFocus: autoFocus,
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3dgQu.FilterProductIcon), {
            primaryProduct: primaryProduct,
            showPrimaryProductIcon: showPrimaryProductIcon
        })
    }, formatMessage((0, $hK6k5.i18n).watchedByMe));
};
var $2e43cb3da58d96ce$export$2e2bcd8739ae039 = $2e43cb3da58d96ce$var$WatchedFilter;
module.exports["default"] = $2e43cb3da58d96ce$export$2e2bcd8739ae039;

});

parcelRegister("3LQ5r", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $lBO0P = parcelRequire("lBO0P");


var $5cssW = parcelRequire("5cssW");


var $j4ply = parcelRequire("j4ply");


var $3Q16G = parcelRequire("3Q16G");


var $dUX05 = parcelRequire("dUX05");

const $0f7fd57a1bdce64f$var$WorkspaceNameFilter = ({ isFilterInDropdown: isFilterInDropdown, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFiltersDiscoverability2Enabled = (0, $j4ply.useFiltersDiscoverability2Enabled)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $5cssW.useSelectFilter)({
        filterId: (0, $3Q16G.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const label = fit === 'compact' && selectedOptions.length > 0 ? '' : formatMessage((0, $dUX05.i18n).label);
    const groupedOptions = [
        {
            label: formatMessage((0, $dUX05.i18n).selectedLabel),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $dUX05.i18n).suggestedLabel),
            options: suggestedOptions
        }
    ];
    return /*#__PURE__*/ $42omo.createElement((0, $lBO0P.default), {
        contentFit: fit,
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: (option)=>{
            setOption(option);
            onFilterChange?.(option);
        },
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: label,
        placeholder: formatMessage((0, $dUX05.i18n).placeholder),
        filterOrControlId: (0, $3Q16G.filter).id,
        testId: "search-dialog-workspace-name-filter",
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: (0, $3Q16G.filter).id
            });
        },
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        hideOnHoverOut: hideOnHoverOut
    });
};
var $0f7fd57a1bdce64f$export$2e2bcd8739ae039 = $0f7fd57a1bdce64f$var$WorkspaceNameFilter;
module.exports["default"] = $0f7fd57a1bdce64f$export$2e2bcd8739ae039;

});

parcelRegister("brMqq", function(module, exports) {
// Copied from packages/search/search-dialog/src/icons/square-return-icon.tsx

var $42omo = parcelRequire("42omo");

const $4e83fd0c0cb31886$export$5427c633f31d110f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "33",
        viewBox: "0 0 32 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_2321_14935)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip1_2321_14935)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip2_2321_14935)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 8.10156C0 3.68328 3.58172 0.101562 8 0.101562H24C28.4183 0.101562 32 3.68328 32 8.10156V24.1016C32 28.5198 28.4183 32.1016 24 32.1016H8C3.58172 32.1016 0 28.5198 0 24.1016V8.10156Z",
        fill: "#FB9700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M16.5762 5.00928L19.6123 11.7729L26.9834 12.5708L27.3369 13.6597L21.8418 18.6372L23.3623 25.8931L22.4355 26.5669L16.0039 22.8784L9.57227 26.5669L8.64551 25.8931L10.165 18.6372L4.66992 13.6597L5.02441 12.5708L12.3955 11.7729L15.4316 5.00928H16.5762ZM15.9082 16.9458C14.5408 16.946 13.4326 18.0549 13.4326 19.4224V20.3267C14.1301 20.7301 14.9385 20.964 15.8008 20.9702H15.8711C16.794 20.9636 17.6552 20.696 18.3848 20.2388V19.4224C18.3848 18.0548 17.2758 16.9458 15.9082 16.9458ZM15.9082 12.4341C14.8828 12.4342 14.0519 13.2651 14.0518 14.2905C14.0518 15.3161 14.8827 16.1478 15.9082 16.1479C16.9339 16.1479 17.7656 15.3162 17.7656 14.2905C17.7655 13.265 16.9338 12.4341 15.9082 12.4341Z",
        fill: "#101214"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_2321_14935"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "white",
        transform: "translate(0 0.101562)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip1_2321_14935"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "white",
        transform: "translate(0 0.101562)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip2_2321_14935"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 8.10156C0 3.68328 3.58172 0.101562 8 0.101562H24C28.4183 0.101562 32 3.68328 32 8.10156V24.1016C32 28.5198 28.4183 32.1016 24 32.1016H8C3.58172 32.1016 0 28.5198 0 24.1016V8.10156Z",
        fill: "white"
    }))));
module.exports["TalentSearchResultIcon"] = $4e83fd0c0cb31886$export$5427c633f31d110f;

});

parcelRegister("kXY72", function(module, exports) {
const $60dfd9a904b326a0$export$64e49a0c7bd6f7a0 = (initialState, queryParamKey)=>{
    return (queryParams)=>{
        const queryParamValue = queryParams[queryParamKey];
        const booleanValue = queryParamValue?.[0] === 'true' ? true : false;
        return {
            ...initialState,
            value: booleanValue || initialState.value
        };
    };
};
module.exports["generateQueryParamsGetState"] = $60dfd9a904b326a0$export$64e49a0c7bd6f7a0;

});

parcelRegister("cOUgi", function(module, exports) {

var $k1VvQ = parcelRequire("k1VvQ");


var $8vGYx = parcelRequire("8vGYx");


var $iQfUJ = parcelRequire("iQfUJ");

const $a80a8ee27d53487e$export$b77715d04a87c12b = (initial)=>{
    const initialState = Object.freeze({
        id: initial.id,
        type: 'single-select',
        didMount: false,
        didMountPerProducts: {},
        hasSelection: false,
        alwaysVisible: initial.alwaysVisible,
        universal: initial.universal,
        queryParams: {
            isLoading: false,
            options: []
        },
        lookup: {
            isLoading: false,
            isActive: false,
            isDefined: !!initial.lookup,
            options: [],
            lookupResultOptions: [],
            input: ''
        },
        initialOptions: {
            options: [],
            isLoading: false
        },
        options: [],
        selectedOptions: [],
        value: [],
        products: initial.products
    });
    return {
        id: initial.id,
        type: initialState.type,
        queryParams: {
            key: initial.queryParams.key,
            getState: (initial.queryParams.generateQueryParamsGetState ?? (0, $8vGYx.generateQueryParamsGetState))(initialState, initial.queryParams.key)
        },
        products: initial.products,
        universal: initial.universal,
        customValueFields: initial.customValueFields,
        withState: (state, config)=>$a80a8ee27d53487e$export$767f444f15b8d660({
                initial: initial,
                state: state,
                config: config
            }),
        getInitialState: (config)=>$a80a8ee27d53487e$export$767f444f15b8d660({
                initial: initial,
                state: initialState,
                config: config
            }),
        isCompatible: (id)=>id === initial.id,
        isSupportCustomValue: false,
        isSuggestedFilter: initial.isSuggestedFilter,
        requiresTopLevel3PDatasource: initial.requiresTopLevel3PDatasource
    };
};
const $a80a8ee27d53487e$export$767f444f15b8d660 = ({ initial: initial, state: state, config: config })=>{
    const filterState = Object.freeze({
        ...state
    });
    return {
        id: initial.id,
        type: filterState.type,
        getState: (0, $k1VvQ.getState)({
            initial: initial,
            state: filterState,
            config: config
        }),
        queryParams: {
            key: initial.queryParams.key,
            get: (0, $k1VvQ.getQueryParams)({
                initial: initial,
                state: filterState,
                config: config
            }),
            set: (0, $k1VvQ.setQueryParams)({
                initial: initial,
                state: filterState,
                config: config
            })
        },
        loadInitialOptions: (0, $k1VvQ.loadInitialOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        setOption: $a80a8ee27d53487e$export$b2a7969df3fe0aa3({
            initial: initial,
            state: filterState,
            config: config
        }),
        clearOptions: (0, $k1VvQ.clearOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        setLookupInput: (0, $k1VvQ.setLookupInput)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getOptions: (0, $iQfUJ.getOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getValue: (0, $k1VvQ.getValue)({
            initial: initial,
            state: filterState,
            config: config
        }),
        clear: (0, $k1VvQ.deselectOptions)({
            initial: initial,
            state: filterState,
            config: config
        })
    };
};
const $a80a8ee27d53487e$var$updateOptionState = (props)=>(option)=>{
        if (option.isDefault) return {
            ...option,
            isSelected: false
        };
        return {
            ...option,
            isSelected: props.firstSelectedOption?.value === option.value
        };
    };
const $a80a8ee27d53487e$export$b2a7969df3fe0aa3 = ({ initial: initial, state: state, config: config })=>{
    return (option)=>{
        // Theoretically this should only ever give you one option to change
        const optionsToChange = Array.isArray(option) ? option : [
            option
        ];
        const firstSelectedOption = optionsToChange[0];
        const isOptionAlreadySelected = state.options.filter((x)=>x.isSelected).find((x)=>x.value === firstSelectedOption?.value);
        if (isOptionAlreadySelected) // do nothing
        return $a80a8ee27d53487e$export$767f444f15b8d660({
            initial: initial,
            state: state,
            config: config
        });
        const queryParamOptions = state.queryParams.options.map($a80a8ee27d53487e$var$updateOptionState({
            optionsToChange: optionsToChange,
            firstSelectedOption: firstSelectedOption
        }));
        const initialOptions = state.initialOptions.options.map($a80a8ee27d53487e$var$updateOptionState({
            optionsToChange: optionsToChange,
            firstSelectedOption: firstSelectedOption
        }));
        const lookupOptions = [
            ...state.lookup.options,
            // 'interacted' lookup options are options that a user made a lookup for and has either
            // selected or deselected an option from a lookup query
            // These 'interacted' options need to be persisted if a user wants to select them again
            ...state.lookup.lookupResultOptions.flatMap((option)=>{
                if (!optionsToChange.find((x)=>x.value === option.value)) return [];
                return [
                    option
                ];
            })
        ].map($a80a8ee27d53487e$var$updateOptionState({
            optionsToChange: optionsToChange,
            firstSelectedOption: firstSelectedOption
        }));
        return $a80a8ee27d53487e$export$767f444f15b8d660({
            initial: initial,
            state: {
                ...state,
                initialOptions: {
                    ...state.initialOptions,
                    options: initialOptions
                },
                queryParams: {
                    ...state.queryParams,
                    options: queryParamOptions
                },
                lookup: {
                    ...state.lookup,
                    options: lookupOptions
                }
            },
            config: config
        });
    };
};
module.exports["createSingleSelectFilter"] = $a80a8ee27d53487e$export$b77715d04a87c12b;
module.exports["SingleSelectFilter"] = $a80a8ee27d53487e$export$767f444f15b8d660;

});

parcelRegister("bxnmj", function(module, exports) {
// these are values for the query params
const $960a8dbfa01645b5$export$dbcc81d768a46013 = {
    RoughDraft: 'roughDraft',
    InProgress: 'inProgress',
    ReadyForReview: 'readyForReview',
    Verified: 'verified'
};
const $960a8dbfa01645b5$export$48932d85514b3629 = Object.values($960a8dbfa01645b5$export$dbcc81d768a46013);
const $960a8dbfa01645b5$export$106c1c66f1b4a23e = {
    [$960a8dbfa01645b5$export$dbcc81d768a46013.RoughDraft]: 'Rough draft',
    [$960a8dbfa01645b5$export$dbcc81d768a46013.InProgress]: 'In progress',
    [$960a8dbfa01645b5$export$dbcc81d768a46013.ReadyForReview]: 'Ready for review',
    [$960a8dbfa01645b5$export$dbcc81d768a46013.Verified]: 'Verified'
};
const $960a8dbfa01645b5$export$1b1e4f3d8ba5c6c1 = (value)=>{
    return $960a8dbfa01645b5$export$48932d85514b3629.includes(value);
};
module.exports["PageStatusFilterValueKey"] = $960a8dbfa01645b5$export$dbcc81d768a46013;
module.exports["allPageStatusFilterValueKeys"] = $960a8dbfa01645b5$export$48932d85514b3629;
module.exports["PageStatusFilterValue"] = $960a8dbfa01645b5$export$106c1c66f1b4a23e;
module.exports["isPageStatusFilterValueKey"] = $960a8dbfa01645b5$export$1b1e4f3d8ba5c6c1;

});

parcelRegister("6l1Qf", function(module, exports) {

var $9d9t8 = parcelRequire("9d9t8");


var $8l0cM = parcelRequire("8l0cM");


var $9rRKJ = parcelRequire("9rRKJ");


var $dOOW1 = parcelRequire("dOOW1");

const $7e15bd977d5402c8$export$a97e25c038594c73 = (staticFilters, filterStates)=>{
    const staticFilterValues = Array.isArray(staticFilters) ? staticFilters : Object.values(staticFilters);
    const staticFiltersRecord = Array.isArray(staticFilters) ? Object.fromEntries(staticFilters.map((staticFilter)=>[
            staticFilter.id,
            staticFilter
        ])) : staticFilters;
    const filterStateValues = Array.isArray(filterStates) ? filterStates : Object.values(filterStates).filter((0, $dOOW1.notEmpty));
    const filterStatesRecord = Array.isArray(filterStates) ? Object.fromEntries(filterStates.map((filterState)=>[
            filterState.id,
            filterState
        ])) : filterStates;
    return {
        staticFilters: staticFiltersRecord,
        staticFilterValues: staticFilterValues,
        filterStates: filterStatesRecord,
        filterStateValues: filterStateValues,
        getSelectedProducts: (queryParams)=>{
            const productKey = (0, $8l0cM.productKeySchema).safeParse(queryParams.product);
            if (productKey.success) return [
                productKey.data
            ];
            const allProductsWithSelections = staticFilterValues.filter((staticFilter)=>!staticFilter.universal) // Ignore universal filters as they are relevant to every product
            .filter((staticFilter)=>queryParams[staticFilter.queryParams.key] !== undefined).map((staticFilter)=>staticFilter.products).flat();
            const selectedProducts = Array.from(new Set(allProductsWithSelections)); // might have to sort this based on some priority
            return selectedProducts;
        },
        isMissingProductSelection: (queryParams)=>{
            const selectedProducts = $7e15bd977d5402c8$export$a97e25c038594c73(staticFilters, filterStates).getSelectedProducts(queryParams);
            const productKey = (0, $8l0cM.productKeySchema).safeParse(queryParams.product).data;
            return selectedProducts.length > 0 && !productKey;
        },
        filtersByProduct: (products, experience, primaryProduct)=>{
            const staticFiltersByProduct = staticFilterValues.filter((staticFilterValue)=>{
                if (!products.length && experience === (0, $9rRKJ.SearchExperience).SEARCH_PAGE) return(// If no apps are selected, only universal and suggested filters are relevant
                staticFilterValue.universal || staticFilterValue.isSuggestedFilter?.(primaryProduct));
                if (!products.length && experience === (0, $9rRKJ.SearchExperience).QUICK_FIND) return staticFilterValue.products.find((product)=>product === primaryProduct);
                if (!products.length) return(// If no apps are selected, only universal and suggested filters are relevant
                staticFilterValue.universal || staticFilterValue.isSuggestedFilter?.(primaryProduct));
                // Universal filters should always be included for forge connectors
                // This is needed because forge connectors are dynamically loaded and not in the static products list
                if (staticFilterValue.universal && products.some((0, $9d9t8.isForgeConnectorProductKey))) return true;
                return staticFilterValue.products.some((product)=>products.includes(product));
            });
            const staticFiltersByProductKeys = staticFiltersByProduct.map((staticFilter)=>staticFilter.id);
            const filterStatesByProduct = filterStateValues.filter((filterState)=>staticFiltersByProductKeys.includes(filterState.id));
            return $7e15bd977d5402c8$export$a97e25c038594c73(staticFiltersByProduct, filterStatesByProduct);
        },
        getFiltersWithSelection: ()=>{
            const filterIDsWithSelection = filterStateValues.filter((x)=>x.hasSelection).map((x)=>x.id);
            return filterIDsWithSelection;
        }
    };
};
module.exports["FilterUtils"] = $7e15bd977d5402c8$export$a97e25c038594c73;

});

parcelRegister("3diYj", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $gpcGZ = parcelRequire("gpcGZ");


var $khsIl = parcelRequire("khsIl");


var $a5RR2 = parcelRequire("a5RR2");

const $c573415f78fb4972$export$6702bcb53d02902a = ({ supportedProducts: supportedProducts, products: products, accessibleProducts: accessibleProducts })=>{
    if (!accessibleProducts) return [];
    const fgControlledProducts = {
        [(0, $gpcGZ.ProductKeys1P).Talent]: (0, $dh538.fg)('talent_global_search')
    };
    const disabledProducts3PFromConfig = [];
    (0, $a5RR2.ThirdPartyConfigsSync).forEach((config, productKey3P)=>{
        if (config && !config.isEnabled()) disabledProducts3PFromConfig.push(productKey3P);
    });
    const accessibleAndSupportedProducts = accessibleProducts.filter((productKey)=>!disabledProducts3PFromConfig.includes(productKey) && (productKey in fgControlledProducts ? fgControlledProducts[productKey] : true)).filter((productKey)=>{
        // Forge connectors are dynamically added and won't be in supportedProducts
        if ((0, $khsIl.isForgeConnectorProductKey)(productKey) && (0, $dh538.fg)('rovo-search-dynamic-forge-config')) return true;
        // For hardcoded products, check if they're in supportedProducts
        return supportedProducts.includes(productKey);
    });
    if (products) {
        const allowedProducts = products.filter((product)=>accessibleAndSupportedProducts.includes(product));
        return allowedProducts;
    } else {
        if (//TODO: move this logic to xpsearch aggregator before release with the correct conditions
        // eslint-disable-next-line @atlaskit/platform/no-preconditioning
        accessibleAndSupportedProducts.includes((0, $gpcGZ.ProductKeys1P).JiraServiceManagement) && (0, $dh538.fg)('assets_rovo_search_all') && // add assets as a product if JSM license is present, but this is until assets becomes a platform
        !(0, $dh538.fg)('aurum-assets-as-a-platform') // disable this when assets becomes a platform and we will start getting assets as its product
        ) return [
            ...accessibleAndSupportedProducts,
            (0, $gpcGZ.ProductKeys1P).Assets
        ];
        return accessibleAndSupportedProducts;
    }
};
module.exports["getSupportedAccessibleProducts"] = $c573415f78fb4972$export$6702bcb53d02902a;

});

parcelRegister("fHHuS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lIbf3 = parcelRequire("lIbf3");


var $lgPOO = parcelRequire("lgPOO");

const $010c68ce9602b050$export$1e8af0ff123020f2 = {
    queryParams: {},
    referrer: undefined,
    /**
   * Empty because it is falsy and then will be overridden during boostrap
   * Can't be uuid() because then won't be overridden!
   * Can't be undefined, because we want to be explicit about the fact that this should be set during bootstrap and not be optional
   */ searchSessionId: '',
    smartLinkUsage: undefined,
    smartLinkUsageAndTopApps: undefined,
    thirdPartyConfigs: undefined
};
const $010c68ce9602b050$export$6286a07f09af7d90 = ({ children: children, searchSessionId: searchSessionId, referrer: referrer, smartLinkUsage: smartLinkUsage, smartLinkUsageAndTopApps: smartLinkUsageAndTopApps, queryParams: queryParams, thirdPartyConfigs: thirdPartyConfigs })=>{
    const parsedQueryParams = (0, $42omo.useMemo)(()=>{
        return (0, $lIbf3.parseQueryParams)(queryParams || $010c68ce9602b050$export$1e8af0ff123020f2.queryParams);
    }, [
        queryParams
    ]);
    // A classic anything-updates useMemo
    const dynamicProps = (0, $42omo.useMemo)(()=>{
        return {
            queryParams: parsedQueryParams,
            searchSessionId: // Passed directly through for easy hook access in code sites
            // TODO QS-9194 should all be prop drilled later
            searchSessionId,
            referrer: referrer,
            smartLinkUsage: smartLinkUsage,
            smartLinkUsageAndTopApps: smartLinkUsageAndTopApps,
            thirdPartyConfigs: thirdPartyConfigs
        };
    }, [
        parsedQueryParams,
        referrer,
        searchSessionId,
        smartLinkUsage,
        smartLinkUsageAndTopApps,
        thirdPartyConfigs
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lgPOO.DynamicBootstrapContext).Provider, {
        value: dynamicProps
    }, children);
};
module.exports["defaultDynamicContext"] = $010c68ce9602b050$export$1e8af0ff123020f2;
module.exports["DynamicContextProvider"] = $010c68ce9602b050$export$6286a07f09af7d90;

});

parcelRegister("32Kiv", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $7f51d42f612977b1$export$38b0e736a3b4e542 = (initial)=>{
    let state = initial;
    const listeners = new Set();
    return {
        getSnapshot: ()=>state,
        setState: (next)=>{
            if (next !== state) {
                state = next;
                listeners.forEach((listener)=>listener());
            }
        },
        subscribe: (listener)=>{
            listeners.add(listener);
            return ()=>{
                listeners.delete(listener);
            };
        }
    };
};
function $7f51d42f612977b1$export$21fad0c5d7df52dc(store, selector) {
    const selectorRef = (0, $42omo.useRef)(selector);
    selectorRef.current = selector;
    const cachedRef = (0, $42omo.useRef)(null);
    const getSnapshot = (0, $42omo.useCallback)(()=>{
        const currentState = store.getSnapshot();
        // If the underlying state hasn't changed, return the cached selected value.
        // This ensures referential stability for object/array selectors.
        if (cachedRef.current !== null && cachedRef.current.state === currentState) return cachedRef.current.value;
        const newValue = selectorRef.current(currentState);
        cachedRef.current = {
            value: newValue,
            state: currentState
        };
        return newValue;
    }, [
        store
    ]);
    // Third argument (getServerSnapshot) is required for SSR compatibility.
    // We reuse getSnapshot because store.getSnapshot() has no browser dependencies —
    // it simply returns the current state, which during SSR is the default initial state.
    return (0, $42omo.useSyncExternalStore)(store.subscribe, getSnapshot, getSnapshot);
}
module.exports["createStaticBootstrapStore"] = $7f51d42f612977b1$export$38b0e736a3b4e542;
module.exports["useStaticBootstrapSelector"] = $7f51d42f612977b1$export$21fad0c5d7df52dc;

});

parcelRegister("9opb6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5d9b4 = parcelRequire("5d9b4");


var $c6GJD = parcelRequire("c6GJD");


var $gkXKl = parcelRequire("gkXKl");


var $aaNIP = parcelRequire("aaNIP");


var $5iakG = parcelRequire("5iakG");


var $b4tvS = parcelRequire("b4tvS");


var $9rRKJ = parcelRequire("9rRKJ");


var $2OtFZ = parcelRequire("2OtFZ");


var $1ikWy = parcelRequire("1ikWy");


var $c2HNo = parcelRequire("c2HNo");


var $5XpfZ = parcelRequire("5XpfZ");


var $lIbf3 = parcelRequire("lIbf3");


var $7Evbj = parcelRequire("7Evbj");


var $gSaNw = parcelRequire("gSaNw");


var $lgPOO = parcelRequire("lgPOO");


var $32Kiv = parcelRequire("32Kiv");

// Attempting to build defaultstate from the same underlying definitions to ease migration to minimise migration
// omit from initialState
const { queryParams: $2a86a6885f914460$var$_queryParams, referrer: $2a86a6885f914460$var$_referrer, searchSessionId: $2a86a6885f914460$var$_searchSessionId, thirdPartyConfigs: $2a86a6885f914460$var$_thirdPartyConfigs, prevQueryParams: $2a86a6885f914460$var$_prevQueryParams, initialSpaceARIs: $2a86a6885f914460$var$_initialSpaceARIs, ...$2a86a6885f914460$var$inheritedInitialState } = (0, $aaNIP.initialState);
const $2a86a6885f914460$export$30ed20aaeaed4b77 = {
    ...$2a86a6885f914460$var$inheritedInitialState,
    initialTextQueryParam: undefined,
    queryParamsCallback: ()=>{},
    refreshSearchSessionId: ()=>{},
    clearReferrer: ()=>{},
    setThirdPartyConfigs: ()=>{},
    onSearchCompleted: ()=>{},
    experience: (0, $9rRKJ.SearchExperience).SEARCH_PAGE,
    applicationMode: (0, $c2HNo.getApplicationMode)({
        isRovoEnabled: $2a86a6885f914460$var$inheritedInitialState.isRovoEnabled
    }),
    multiSiteSearchInRovo: (0, $2OtFZ.getMultiSiteSearchInRovo)($2a86a6885f914460$var$inheritedInitialState.experimentConfig),
    isHello: (0, $5XpfZ.isHello)($2a86a6885f914460$var$inheritedInitialState.cloudId),
    thirdPartyConfigs: {}
};
const $2a86a6885f914460$export$bc36689a336ce85c = ({ children: children, initialProps: props, queryParams: queryParams, queryParamsCallback: queryParamsCallback, refreshSearchSessionId: refreshSearchSessionId, initialText: initialText, clearReferrer: clearReferrer, initialThirdPartyConfigs: initialThirdPartyConfigs, onSearchCompleted: onSearchCompleted, onOAuthSuccess: onOAuthSuccess, experience: experience, accessibleProducts: accessibleProducts })=>{
    /**
   * Static lock version counter. The useMemo recomputes whenever this value changes.
   *
   * Version semantics:
   * - 0: Lock open (bootstrap config not yet loaded)
   * - 1: Lock closed (bootstrap config loaded, values frozen)
   * - >1: Lock was reopened post-bootstrap via setThirdPartyConfigs (the ONLY path that increments above 1)
   *
   * If isConfigLoaded is already true on first render, starts at 1 so values are immediately available
   * without an extra render cycle.
   *
   * Post-bootstrap, setThirdPartyConfigs can increment the counter above 1 to force the useMemo to
   * recompute with updated refs. This is an expensive action that should be used sparingly and only
   * in response to uncommon user actions (e.g. OAuth connect flow).
   *
   * IMPORTANT: effectiveLockVersion is the SOLE dependency of the static useMemo. Do not add other dependencies.
   * If you need the useMemo to recompute for a new value, store that value in a ref and reopen the lock by incrementing this counter.
   */ const [staticLockVersion, setStaticLockVersion] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(()=>$2a86a6885f914460$var$shouldStaticLockClose({
            isConfigLoaded: props.isConfigLoaded || false
        }) ? 1 : 0);
    /**
   * Close the static lock synchronously during render when isConfigLoaded becomes true.
   * Sets the version to exactly 1 (not an increment) so that only setThirdPartyConfigs can push the version above 1.
   */ if (staticLockVersion === 0 && $2a86a6885f914460$var$shouldStaticLockClose({
        isConfigLoaded: props.isConfigLoaded || false
    })) setStaticLockVersion(1);
    // Create a stable store instance once per component lifetime
    const storeRef = (0, $42omo.useRef)(null);
    /**
   * Derive the effective lock version synchronously from both the state counter AND props.isConfigLoaded.
   *
   * When isConfigLoaded transitions from false to true, the in-render setState above schedules a
   * state update, but staticLockVersion still reads as 0 on THIS render. Previously, the useMemo
   * (which depended solely on staticLockVersion) would not recompute until the NEXT render when
   * staticLockVersion became 1 — costing an extra render cycle (~100ms+ in a complex tree).
   *
   * effectiveLockVersion resolves this by treating the lock as closed immediately when
   * isConfigLoaded is true, even before the state update takes effect. The useMemo now depends
   * on effectiveLockVersion, so it recomputes on the same render that isConfigLoaded becomes true.
   *
   * For setThirdPartyConfigs (version > 1), the state-based counter still drives recomputation
   * as before, since isConfigLoaded is already true at that point.
   */ const effectiveLockVersion = staticLockVersion === 0 && $2a86a6885f914460$var$shouldStaticLockClose({
        isConfigLoaded: props.isConfigLoaded || false
    }) ? 1 : staticLockVersion;
    /**
   * thirdPartyConfigs is expected to be static after bootstrap, but can be overridden during OAuth workflow as a cheap "cache bust".
   *
   * Stored in a ref so that updates do not directly cause re-renders. Instead, the OAuth callback
   * (setThirdPartyConfigs) updates the ref and reopens the static lock for exactly one render,
   * allowing the useMemo to recompute with the new value.
   */ const thirdPartyConfigsRef = (0, $42omo.useRef)(initialThirdPartyConfigs || {});
    // Sync thirdPartyConfigs from props when config finishes loading (before static lock closes).
    // Uses staticLockVersion (not staticLockClosed/effectiveLockVersion) because when isConfigLoaded
    // transitions to true, effectiveLockVersion eagerly resolves to 1 on the same render. The ref
    // must be updated BEFORE the useMemo (which depends on effectiveLockVersion) recomputes, so we
    // check the underlying state which is still 0 on the transition render.
    if (staticLockVersion === 0 && props.isConfigLoaded) thirdPartyConfigsRef.current = initialThirdPartyConfigs || {};
    const setThirdPartyConfigs = (0, $42omo.useCallback)((configs)=>{
        thirdPartyConfigsRef.current = configs;
        // Reopen the static lock for exactly one render so the useMemo recomputes with the new thirdPartyConfigs
        setStaticLockVersion((v)=>v + 1);
    }, []);
    const useMemoStaticProps = (0, $42omo.useMemo)(()=>{
        const enableRovoSearchOverrides = Boolean(// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        (0, $c6GJD.default).getExperimentValue('enable-rovo_search_overrides', 'value', false));
        const parsedQueryParams = queryParams && enableRovoSearchOverrides ? (0, $lIbf3.parseQueryParams)(queryParams) : undefined;
        const isRovoEnabled = props.isRovoEnabled || $2a86a6885f914460$export$30ed20aaeaed4b77.isRovoEnabled;
        const cloudId = props.cloudId || $2a86a6885f914460$export$30ed20aaeaed4b77.cloudId;
        const primaryProduct = props.primaryProduct || $2a86a6885f914460$export$30ed20aaeaed4b77.primaryProduct;
        const primarySubProduct = props.primarySubProduct || $2a86a6885f914460$export$30ed20aaeaed4b77.primarySubProduct;
        const user = props.user || $2a86a6885f914460$export$30ed20aaeaed4b77.user;
        // Under rovo-search-remove-rss-bootstrap-fg, compute experimentConfig directly
        // via getExperimentConfig instead of receiving it through props from BootstrapStoreProvider.
        // This moves the experiment config computation into the static context where it belongs,
        // using props already available here. If a prop is explicitly provided, use it as an
        // override (supports backward compat during rollout and test scenarios).
        // Keep in sync with: bootstrap-store-provider/index.tsx
        const experimentConfig = (0, $gSaNw.serveBootstrapProviderExp)() ? props.experimentConfig || (0, $gkXKl.getExperimentConfig)({
            primaryProduct: primaryProduct,
            experimentLayers: props.experimentLayers ?? [],
            sideBySideExperiment: props.features?.sideBySide?.experiments,
            statsigLayer: undefined,
            onError: (error)=>(0, $7Evbj.logException)(error, user?.id, primaryProduct)
        }) : props.experimentConfig || $2a86a6885f914460$export$30ed20aaeaed4b77.experimentConfig;
        // This can contain duplicates from e.g. a full drive connector and a drive smartlink connector
        // Under rovo-search-remove-rss-bootstrap-fg, getAccessibleProducts is computed here
        // instead of in bootstrap-store-provider. On the old path, products is already processed.
        const products = (0, $gSaNw.serveBootstrapProviderExp)() ? $2a86a6885f914460$var$dedupProducts((0, $1ikWy.getAccessibleProducts)({
            supportedProducts: (0, $b4tvS.getAllProductKeys)(),
            products: props.products,
            accessibleProducts: accessibleProducts
        }), $2a86a6885f914460$export$30ed20aaeaed4b77.products) : $2a86a6885f914460$var$dedupProducts(props.products || [], $2a86a6885f914460$export$30ed20aaeaed4b77.products);
        return {
            // Literal constant
            allFilterExcludedProducts: (0, $5iakG.ALL_FILTER_EXCLUDED_PRODUCTS),
            // Static from internal props to BootstrapProvider
            experience: experience || $2a86a6885f914460$export$30ed20aaeaed4b77.experience,
            // Static from host product props
            cloudId: cloudId,
            isHello: (0, $5XpfZ.isHello)(cloudId),
            aggregatorHostName: props.aggregatorHostName || $2a86a6885f914460$export$30ed20aaeaed4b77.aggregatorHostName,
            aggAbsoluteUrl: props.aggAbsoluteUrl || $2a86a6885f914460$export$30ed20aaeaed4b77.aggAbsoluteUrl,
            SAINHostName: props.SAINHostName || $2a86a6885f914460$export$30ed20aaeaed4b77.SAINHostName,
            orgId: props.orgId || $2a86a6885f914460$export$30ed20aaeaed4b77.orgId,
            primaryProduct: primaryProduct,
            primarySubProduct: primarySubProduct,
            analyticsAttributes: props.analyticsAttributes || $2a86a6885f914460$export$30ed20aaeaed4b77.analyticsAttributes,
            features: props.features || $2a86a6885f914460$export$30ed20aaeaed4b77.features,
            experimentLayers: props.experimentLayers || $2a86a6885f914460$export$30ed20aaeaed4b77.experimentLayers,
            queryParamsCallback: queryParamsCallback || $2a86a6885f914460$export$30ed20aaeaed4b77.queryParamsCallback,
            onSearchCompleted: onSearchCompleted || props.onSearchCompleted || $2a86a6885f914460$export$30ed20aaeaed4b77.onSearchCompleted,
            onOAuthSuccess: onOAuthSuccess || props.onOAuthSuccess || $2a86a6885f914460$export$30ed20aaeaed4b77.onOAuthSuccess,
            user: user,
            // Extracted on first load from queryParams (host product props)
            initialTextQueryParam: initialText,
            // DYNAMIC: from bootstrap config -> isConfigLoaded
            isConfigLoaded: props.isConfigLoaded || $2a86a6885f914460$export$30ed20aaeaed4b77.isConfigLoaded,
            intercomHmac: props.intercomHmac || $2a86a6885f914460$export$30ed20aaeaed4b77.intercomHmac,
            isRovoEnabled: isRovoEnabled,
            applicationMode: (0, $c2HNo.getApplicationMode)({
                isRovoEnabled: isRovoEnabled
            }),
            nouns: props.nouns || $2a86a6885f914460$export$30ed20aaeaed4b77.nouns,
            productEdition: props.productEdition || $2a86a6885f914460$export$30ed20aaeaed4b77.productEdition,
            productDataRegions: props.productDataRegions || $2a86a6885f914460$export$30ed20aaeaed4b77.productDataRegions,
            rovoFeatures: props.rovoFeatures || $2a86a6885f914460$export$30ed20aaeaed4b77.rovoFeatures,
            linkedCloudARIs: props.linkedCloudARIs || $2a86a6885f914460$export$30ed20aaeaed4b77.linkedCloudARIs,
            isJiraIssueIndexed: props.isJiraIssueIndexed || $2a86a6885f914460$export$30ed20aaeaed4b77.isJiraIssueIndexed,
            hasEditOrViewPlanPermission: props.hasEditOrViewPlanPermission || $2a86a6885f914460$export$30ed20aaeaed4b77.hasEditOrViewPlanPermission,
            // when removing this feature flag, update the type to no longer be optional
            ...enableRovoSearchOverrides && {
                overrides: parsedQueryParams?.overrides || (0, $aaNIP.initialState).overrides
            },
            // Third party configs - static after bootstrap, mutable only via OAuth callback (read from ref)
            thirdPartyConfigs: thirdPartyConfigsRef.current,
            refreshSearchSessionId: // passed directly through from props
            refreshSearchSessionId,
            clearReferrer: clearReferrer,
            setThirdPartyConfigs: setThirdPartyConfigs,
            experimentConfig: // experimentConfig is now computed directly in this static context under
            // rovo-search-remove-rss-bootstrap-fg via getExperimentConfig, or falls back to props on the old path.
            experimentConfig,
            multiSiteSearchInRovo: (0, $2OtFZ.getMultiSiteSearchInRovo)(experimentConfig),
            products: products
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        effectiveLockVersion
    ]); // Do not expand this dependency. See effectiveLockVersion JSDoc. Reach out to #help-search-plex or #search-plex-perf-squad with any questions
    // Create or sync the external store.
    // On first render this creates the store; on subsequent renders it notifies
    // only subscribers whose selected slice actually changed.
    if (storeRef.current === null) storeRef.current = (0, $32Kiv.createStaticBootstrapStore)(useMemoStaticProps);
    else storeRef.current.setState(useMemoStaticProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lgPOO.StaticBootstrapContext).Provider, {
        value: useMemoStaticProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lgPOO.StaticBootstrapStoreContext).Provider, {
        value: storeRef.current
    }, children));
};
/**
 * Lock static context values after config is loaded to ensure they do not change during the session, as they are expected to be static after the bootstrap phase.
 * This also allows us to remove any dependencies on props that would cause unnecessary re-renders of the static context provider and all of its children
 *
 * The only values that should be here are booleans set by ASYNC behaviour that we must wait for (e.g. the config network call(s))
 * To add a new async dependency, provide a boolean e.g. myAsyncValue that is false until the async behaviour is complete, and then add it to the shouldStaticLockClose function.
 *
 * Note: This is on the search query critical performance path, any additional values added here should be carefully considered.
 * Reach out to #help-search-plex or #search-plex-perf-squad with any questions
 */ const $2a86a6885f914460$var$shouldStaticLockClose = ({ isConfigLoaded: isConfigLoaded })=>{
    return isConfigLoaded; // Set by `useFetchConfig`, supported by promise-reuse and localStorage caching
};
/**
 * The set of `products` as passed in as a prop has duplicates due to smartlinks etc (drive can appear several times!)
 * We uniq() this list for use within search
 */ const $2a86a6885f914460$var$dedupProducts = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((a, b)=>{
    return [
        ...new Set([
            ...a,
            ...b
        ])
    ];
}, (a, b)=>a.join('') + b.join(''));
module.exports["defaultStaticContext"] = $2a86a6885f914460$export$30ed20aaeaed4b77;
module.exports["StaticContextProvider"] = $2a86a6885f914460$export$bc36689a336ce85c;

});

parcelRegister("cxQs0", function(module, exports) {

var $kXY72 = parcelRequire("kXY72");

const $d05c83618c1962d4$export$2963583aeb05fcae = (initial)=>{
    const initialState = {
        ...initial,
        type: 'boolean',
        value: false,
        hasSelection: false,
        universal: initial.universal
    };
    return {
        id: initial.id,
        type: initialState.type,
        products: initial.products,
        universal: initial.universal,
        queryParams: {
            key: initialState.queryParams.key,
            getState: (initial.queryParams.generateQueryParamsGetState ?? (0, $kXY72.generateQueryParamsGetState))(initialState, initial.queryParams.key)
        },
        customValueFields: initial.customValueFields,
        withState: (state, config)=>$d05c83618c1962d4$export$cd193ee4357dee7f({
                initial: initial,
                state: state,
                config: config
            }),
        getInitialState: (config)=>$d05c83618c1962d4$export$cd193ee4357dee7f({
                initial: initial,
                state: initialState,
                config: config
            }),
        isCompatible: (id)=>id === initial.id,
        isSupportCustomValue: false,
        isSuggestedFilter: initial.isSuggestedFilter
    };
};
const $d05c83618c1962d4$export$cd193ee4357dee7f = ({ initial: initial, state: state, config: config })=>{
    const filterState = {
        ...state,
        hasSelection: state.value
    };
    return {
        ...filterState,
        setValue: $d05c83618c1962d4$var$setValue({
            initial: initial,
            state: filterState,
            config: config
        }),
        getValue: ()=>filterState.value,
        getState: ()=>filterState,
        queryParams: {
            key: initial.queryParams.key,
            get: $d05c83618c1962d4$var$getQueryParams({
                initial: initial,
                state: filterState,
                config: config
            }),
            set: $d05c83618c1962d4$var$setQueryParams({
                initial: initial,
                state: filterState,
                config: config
            })
        },
        clear: $d05c83618c1962d4$var$clear({
            initial: initial,
            state: filterState,
            config: config
        })
    };
};
const $d05c83618c1962d4$var$setValue = ({ initial: initial, state: state, config: config })=>{
    return (value)=>{
        const newState = {
            ...state,
            value: value,
            hasSelection: value
        };
        return $d05c83618c1962d4$export$cd193ee4357dee7f({
            initial: initial,
            state: newState,
            config: config
        });
    };
};
const $d05c83618c1962d4$var$getQueryParams = ({ initial: initial, state: state })=>{
    return ()=>({
            [initial.queryParams.key]: state.value === true ? [
                'true'
            ] : undefined
        });
};
const $d05c83618c1962d4$var$setQueryParams = ({ initial: initial, state: state, config: config })=>{
    return async (queryParams)=>{
        const queryParamValue = queryParams[initial.queryParams.key];
        const booleanValue = queryParamValue?.[0] === 'true' ? true : false;
        return $d05c83618c1962d4$export$cd193ee4357dee7f({
            initial: initial,
            state: {
                ...state,
                value: booleanValue,
                hasSelection: booleanValue
            },
            config: config
        });
    };
};
const $d05c83618c1962d4$var$clear = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const filter = $d05c83618c1962d4$export$cd193ee4357dee7f({
            initial: initial,
            state: state,
            config: config
        });
        return filter.setValue(false);
    };
};
module.exports["createBooleanFilter"] = $d05c83618c1962d4$export$2963583aeb05fcae;

});

parcelRegister("ewGgp", function(module, exports) {
const $43f3b865216ed187$export$6dbf555668213f9e = (primaryProduct)=>{
    // URS (User Recommendation Service) only supports 'confluence' and 'jira' as product keys.
    // Other values (e.g. 'townsquare', 'mercury') cause a 400 deserialization error.
    // Default to 'confluence' when the primary product is not one of these two.
    return primaryProduct === 'jira' || primaryProduct === 'confluence' ? primaryProduct : 'confluence';
};
module.exports["getUrsProductKey"] = $43f3b865216ed187$export$6dbf555668213f9e;

});

parcelRegister("4bHQd", function(module, exports) {

var $jwO5V = parcelRequire("jwO5V");


var $cxsgw = parcelRequire("cxsgw");


var $i8MOh = parcelRequire("i8MOh");

const $3fbd92d1a753d7ae$var$MAX_SMART_DEFAULT_OPTIONS = 5;
const $3fbd92d1a753d7ae$export$8e839a938752e935 = async (config)=>{
    const headers = (0, $jwO5V.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const initialUsersQuery = (0, $i8MOh.usersQuery)([
        ...config.userId ? [
            config.userId
        ] : []
    ], headers);
    const recommendedUserQuery = (0, $cxsgw.smartsRecommendedUserQuery)({
        aggAbsoluteUrl: config.aggAbsoluteUrl,
        variables: {
            userId: config.userId || '',
            tenantId: config.cloudId || '',
            maxNumberOfResults: $3fbd92d1a753d7ae$var$MAX_SMART_DEFAULT_OPTIONS
        },
        headers: headers
    });
    const [initialUsersReponse, smartsRecommendedUserResponse] = await Promise.all([
        initialUsersQuery,
        recommendedUserQuery
    ]);
    const recommendedUsersResults = smartsRecommendedUserResponse.data?.smarts.results ?? [];
    const allRecommendedUsers = [
        ...initialUsersReponse.data?.users ?? [],
        ...recommendedUsersResults.flatMap((recommendedUsers)=>!!recommendedUsers && !!recommendedUsers.user ? {
                id: recommendedUsers.id,
                ...recommendedUsers.user
            } : [])
    ];
    const recommendedUserOptions = allRecommendedUsers.map((user)=>({
            trackingKey: user.accountId,
            value: user.accountId,
            label: user.name,
            avatarUrl: user.picture,
            queryParamValue: user.accountId,
            product: config.product
        }));
    return recommendedUserOptions;
};
module.exports["loadRecommendedUsers"] = $3fbd92d1a753d7ae$export$8e839a938752e935;

});

parcelRegister("2zk4m", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $jXNWU = parcelRequire("jXNWU");

/**
 * Module-level cache of in-flight (or resolved) promises for
 * `getThirdPartyFilterOptions`, keyed by `${cloudId}::${datasourceId}`.
 *
 * The endpoint returns **all** custom filters for an integration in a single
 * response, so multiple filters that share the same datasource (e.g. campaign
 * status, case status, deal stage) can reuse one promise instead of each
 * issuing an independent network request.
 *
 * Cache lifetime: a typical session has at most O(connected integrations)
 * entries (usually 1–5), so no eviction strategy is needed.  The cache is
 * intentionally kept for the lifetime of the page — filter-option data is
 * static per datasource within a search session.
 *
 * Rejection handling: failed entries are removed so subsequent callers can
 * retry rather than receive a permanently-stuck rejected promise.
 *
 * Cache key: `cloudId::datasourceId::orgId` so different orgs do not share a cached response.
 * `aggAbsoluteUrl` is
 * intentionally excluded — it is constant for a given (cloudId, datasourceId) pair within a
 * session and so cannot disambiguate entries.
 */ const $b97779762a60c162$var$cache = new Map();
const $b97779762a60c162$export$92d46a4d5ee2716c = (config)=>{
    const { cloudId: cloudId } = config;
    const datasourceId = config.selectedDatasource?.datasourceId;
    // Defensive guard: do not invoke (or cache) without a complete key.
    // Callers in filter index files are expected to short-circuit before this.
    if (!cloudId || !datasourceId) return Promise.resolve(null);
    const orgId = config.orgId;
    const orgSegment = config.orgId ?? '';
    const fetchOptions = {
        cloudId: cloudId,
        datasourceId: datasourceId,
        orgId: orgId,
        aggAbsoluteUrl: config.aggAbsoluteUrl
    };
    // Feature gate: when off, every caller fetches directly (no shared state,
    // one network request per caller).  When on, callers share a single
    // in-flight promise per datasource via the cache below.
    if (!(0, $dh538.fg)('rovo-fps-3p-ux-sf-shared-custom-filters')) return (0, $jXNWU.getThirdPartyFilterOptions)(fetchOptions);
    const key = `${cloudId}::${datasourceId}::${orgSegment}`;
    let promise = $b97779762a60c162$var$cache.get(key);
    if (!promise) {
        promise = (0, $jXNWU.getThirdPartyFilterOptions)(fetchOptions);
        // Evict on failure so the next call can retry.
        promise.catch(()=>$b97779762a60c162$var$cache.delete(key));
        $b97779762a60c162$var$cache.set(key, promise);
    }
    return promise;
};
const $b97779762a60c162$export$a54b0e43665cba85 = ()=>{
    $b97779762a60c162$var$cache.clear();
};
module.exports["getCachedThirdPartyFilterOptions"] = $b97779762a60c162$export$92d46a4d5ee2716c;

});

parcelRegister("2XcAT", function(module, exports) {
const $ee40169aabdb51a7$export$dc0a6726495eccc1 = (params)=>{
    if (params.isUniversal) return 'all';
    return(// If a product is selected, the filter option will be tied to the selected product
    params.config.product ?? // If no product is selected, such as the 'all' state it will use the primary product. This is the case for suggested space filters.
    // All suggested filters are sets the primary product as the product selected after a filter option selection.
    params.config.primaryProduct ?? 'all' // config.primaryProduct should always be defined but 'all' is used as a catch-all
    );
};
module.exports["getProductForFilterOption"] = $ee40169aabdb51a7$export$dc0a6726495eccc1;

});

parcelRegister("1A1pg", function(module, exports) {
const $1640c23772407797$export$d520529b4595d46c = [
    'ati:cloud:graph:document'
];
module.exports["DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI"] = $1640c23772407797$export$d520529b4595d46c;

});

parcelRegister("7GRRM", function(module, exports) {

var $7iBhV = parcelRequire("7iBhV");


var $k1VvQ = parcelRequire("k1VvQ");


var $8vGYx = parcelRequire("8vGYx");


var $iQfUJ = parcelRequire("iQfUJ");


var $2XcAT = parcelRequire("2XcAT");

const $89c49071fea602e5$export$711b0a1d273f9525 = (initial)=>{
    const initialState = Object.freeze({
        id: initial.id,
        type: 'single-select',
        didMount: false,
        didMountPerProducts: {},
        hasSelection: false,
        alwaysVisible: initial.alwaysVisible,
        universal: initial.universal,
        queryParams: {
            isLoading: false,
            options: []
        },
        lookup: {
            isLoading: false,
            isActive: false,
            isDefined: !!initial.lookup,
            options: [],
            lookupResultOptions: [],
            input: ''
        },
        initialOptions: {
            options: [],
            isLoading: false
        },
        options: [],
        selectedOptions: [],
        value: [],
        products: initial.products
    });
    return {
        id: initial.id,
        type: initialState.type,
        queryParams: {
            key: initial.queryParams.key,
            getState: (initial.queryParams.generateQueryParamsGetState ?? (0, $8vGYx.generateQueryParamsGetState))(initialState, initial.queryParams.key)
        },
        products: initial.products,
        universal: initial.universal,
        customValueFields: initial.customValueFields,
        withState: (state, config)=>$89c49071fea602e5$export$44d389225cc01eb5({
                initial: initial,
                state: state,
                config: config
            }),
        getInitialState: (config)=>$89c49071fea602e5$export$44d389225cc01eb5({
                initial: initial,
                state: initialState,
                config: config
            }),
        isCompatible: (id)=>id === initial.id,
        isSupportCustomValue: true,
        isSuggestedFilter: initial.isSuggestedFilter,
        requiresTopLevel3PDatasource: initial.requiresTopLevel3PDatasource
    };
};
const $89c49071fea602e5$export$e2de15bbd9edf9c6 = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const options = $89c49071fea602e5$export$44d389225cc01eb5({
            initial: initial,
            state: state,
            config: config
        }).getOptions({
            isLookupActive: false
        });
        const selectedOptions = options.filter((option)=>option.isSelected);
        const queryParamValue = selectedOptions.map((option)=>option.queryParamValue);
        const isCustomOptionSelected = selectedOptions.find((option)=>option.value === (0, $7iBhV.CUSTOM_OPTION_VALUE));
        const customValueQueryParam = isCustomOptionSelected && state.customValue ? state.customValue : {};
        return {
            [initial.queryParams.key]: queryParamValue,
            ...customValueQueryParam
        };
    };
};
const $89c49071fea602e5$export$7755017099c85a0d = ({ initial: initial, state: state, config: config })=>{
    return async (queryParams, onStateChange)=>{
        const queryParamValues = queryParams[initial.queryParams.key];
        const filter = $89c49071fea602e5$export$44d389225cc01eb5({
            initial: initial,
            state: state,
            config: config
        });
        if (!queryParamValues) {
            const clearedOptions = filter.clearOptions();
            onStateChange?.(clearedOptions.getState());
            return clearedOptions;
        }
        const allCurrentOptions = filter.getOptions({
            isLookupActive: false
        });
        const allQueryParamValues = allCurrentOptions.map((option)=>option.queryParamValue);
        const queryParamsToHydrate = queryParamValues.filter((value)=>!allQueryParamValues.includes(value));
        if (queryParamsToHydrate.length === 0) {
            const newOptions = allCurrentOptions.map((option)=>({
                    isSelected: queryParamValues.includes(option.queryParamValue),
                    value: option.value
                }));
            const isCustomOptionSelected = newOptions.find((option)=>option.value === (0, $7iBhV.CUSTOM_OPTION_VALUE))?.isSelected;
            const customValueParser = initial.queryParams.customValueParser;
            let customValue;
            if (isCustomOptionSelected) {
                if (customValueParser) customValue = customValueParser(queryParams);
                else customValue = initial.customValueFields ? initial.customValueFields.reduce((acc, field)=>({
                        ...acc,
                        [field]: queryParams[field]?.[0] ?? ''
                    }), {}) : {};
            }
            const filterWithNewOptions = filter.setOption(newOptions, customValue);
            onStateChange?.(filterWithNewOptions.getState());
            return filterWithNewOptions;
        }
        // At this point we need to hydrate the filters with new options from
        // the query params
        const newQueryParamOptions = [
            ...state.queryParams.options
        ];
        const fetcher = initial.queryParams.fetcher;
        if (fetcher) {
            onStateChange?.({
                ...state,
                queryParams: {
                    ...state.queryParams,
                    isLoading: true
                }
            });
            const fetchedOptions = await fetcher(queryParamsToHydrate, config);
            fetchedOptions.forEach((option)=>{
                const mappedOption = {
                    isSelected: true,
                    trackingKey: option.trackingKey,
                    value: option.value,
                    queryParamValue: option.queryParamValue,
                    isSuggested: false,
                    isDefault: option.isDefault ?? false,
                    avatarUrl: option.avatarUrl,
                    label: option.label,
                    metadata: option.metadata,
                    product: (0, $2XcAT.getProductForFilterOption)({
                        config: config,
                        isUniversal: initial.universal
                    })
                };
                newQueryParamOptions.push(mappedOption);
            });
        }
        const selectedOptionsFromQueryParams = newQueryParamOptions.map((option)=>({
                ...option,
                isSelected: queryParamValues.includes(option.queryParamValue)
            }));
        const selectedInitialOptionsFromQueryParams = [
            ...state.initialOptions.options
        ].map((option)=>({
                ...option,
                isSelected: queryParamValues.includes(option.queryParamValue)
            }));
        let customValue;
        const isCustomOptionSelected = selectedOptionsFromQueryParams.find((option)=>option.value === (0, $7iBhV.CUSTOM_OPTION_VALUE))?.isSelected;
        if (isCustomOptionSelected) {
            const customValueParser = initial.queryParams.customValueParser;
            if (customValueParser) customValue = customValueParser(queryParams);
            else customValue = initial.customValueFields ? initial.customValueFields.reduce((acc, field)=>({
                    ...acc,
                    [field]: queryParams[field]?.[0] ?? ''
                }), {}) : {};
        }
        const hydratedQueryParams = $89c49071fea602e5$export$44d389225cc01eb5({
            initial: initial,
            state: {
                ...state,
                queryParams: {
                    ...state.queryParams,
                    options: selectedOptionsFromQueryParams,
                    isLoading: false
                },
                initialOptions: {
                    ...state.initialOptions,
                    options: selectedInitialOptionsFromQueryParams
                },
                customValue: customValue
            },
            config: config
        });
        onStateChange?.(hydratedQueryParams.getState());
        return hydratedQueryParams;
    };
};
const $89c49071fea602e5$export$44d389225cc01eb5 = ({ initial: initial, state: state, config: config })=>{
    const filterState = Object.freeze({
        ...state
    });
    return {
        id: initial.id,
        type: filterState.type,
        getState: (0, $k1VvQ.getState)({
            initial: initial,
            state: filterState,
            config: config
        }),
        queryParams: {
            key: initial.queryParams.key,
            get: $89c49071fea602e5$export$e2de15bbd9edf9c6({
                initial: initial,
                state: filterState,
                config: config
            }),
            set: $89c49071fea602e5$export$7755017099c85a0d({
                initial: initial,
                state: filterState,
                config: config
            })
        },
        loadInitialOptions: (0, $k1VvQ.loadInitialOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        setOption: $89c49071fea602e5$export$b2a7969df3fe0aa3({
            initial: initial,
            state: filterState,
            config: config
        }),
        clearOptions: (0, $k1VvQ.clearOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        setLookupInput: (0, $k1VvQ.setLookupInput)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getOptions: (0, $iQfUJ.getOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getValue: (0, $k1VvQ.getValue)({
            initial: initial,
            state: filterState,
            config: config
        }),
        clear: (0, $k1VvQ.deselectOptions)({
            initial: initial,
            state: filterState,
            config: config
        })
    };
};
const $89c49071fea602e5$var$updateOptionState = (props)=>(option)=>{
        if (option.isDefault) return {
            ...option,
            isSelected: false
        };
        return {
            ...option,
            isSelected: props.selectedOption ? props.selectedOption.value === option.value : option.isSelected
        };
    };
const $89c49071fea602e5$export$b2a7969df3fe0aa3 = ({ initial: initial, state: state, config: config })=>{
    return (option, customValue)=>{
        const optionsToChange = Array.isArray(option) ? option : [
            option
        ];
        const selectedOption = optionsToChange.filter((o)=>o.isSelected)[0];
        const queryParamOptions = state.queryParams.options.map($89c49071fea602e5$var$updateOptionState({
            selectedOption: selectedOption
        }));
        const initialOptions = state.initialOptions.options.map($89c49071fea602e5$var$updateOptionState({
            selectedOption: selectedOption
        }));
        const lookupOptions = [
            ...state.lookup.options,
            // 'interacted' lookup options are options that a user made a lookup for and has either
            // selected or deselected an option from a lookup query
            // These 'interacted' options need to be persisted if a user wants to select them again
            ...state.lookup.lookupResultOptions.flatMap((option)=>{
                if (!optionsToChange.find((x)=>x.value === option.value)) return [];
                return [
                    option
                ];
            })
        ].map($89c49071fea602e5$var$updateOptionState({
            selectedOption: selectedOption
        }));
        return $89c49071fea602e5$export$44d389225cc01eb5({
            initial: initial,
            state: {
                ...state,
                initialOptions: {
                    ...state.initialOptions,
                    options: initialOptions
                },
                queryParams: {
                    ...state.queryParams,
                    options: queryParamOptions
                },
                lookup: {
                    ...state.lookup,
                    options: lookupOptions
                },
                customValue: customValue
            },
            config: config
        });
    };
};
module.exports["createSingleWithCustomOptionSelectFilter"] = $89c49071fea602e5$export$711b0a1d273f9525;

});

parcelRegister("ILLS9", function(module, exports) {

var $dOOW1 = parcelRequire("dOOW1");

const $e86a5d8a6b7a397e$var$isIsoDate = (str)=>{
    if (!str) return false;
    if (!/\d{4}-\d{2}-\d{2}/.test(str)) return false;
    const d = new Date(str);
    return !isNaN(d.getTime());
};
const $e86a5d8a6b7a397e$export$cb0ede5f191413 = (queryParams)=>{
    const { to: to, from: from } = queryParams;
    const isToDateValid = $e86a5d8a6b7a397e$var$isIsoDate(to?.[0]);
    const isFromDateValid = $e86a5d8a6b7a397e$var$isIsoDate(from?.[0]);
    const toDate = isToDateValid && to?.[0] ? to?.[0] : '';
    const fromDate = isFromDateValid && from?.[0] ? from?.[0] : '';
    const invalidDateRange = (0, $dOOW1.getInvalidDateRange)(fromDate, toDate);
    if (!invalidDateRange) return {
        to: toDate,
        from: fromDate
    };
};
const $e86a5d8a6b7a397e$export$64e49a0c7bd6f7a0 = (initialState, queryParamKey)=>{
    return (queryParams)=>{
        const queryParamValue = queryParams[queryParamKey];
        let value;
        let customValue;
        if (Array.isArray(queryParamValue)) {
            value = queryParamValue;
            if (queryParamValue[0] === 'custom') customValue = $e86a5d8a6b7a397e$export$cb0ede5f191413(queryParams);
        }
        return {
            ...initialState,
            value: value || initialState.value,
            customValue: customValue || initialState.customValue
        };
    };
};
module.exports["customValueParser"] = $e86a5d8a6b7a397e$export$cb0ede5f191413;
module.exports["generateQueryParamsGetState"] = $e86a5d8a6b7a397e$export$64e49a0c7bd6f7a0;

});

parcelRegister("dcbm4", function(module, exports) {
// these are values for the query params
const $b6f5f787e66362db$export$d76b5866ae4061c8 = {
    Open: 'open',
    Closed: 'closed'
};
const $b6f5f787e66362db$export$ff1c9ca0ad19eecd = Object.values($b6f5f787e66362db$export$d76b5866ae4061c8);
const $b6f5f787e66362db$export$9e65f1e3288fbede = {
    [$b6f5f787e66362db$export$d76b5866ae4061c8.Open]: false,
    [$b6f5f787e66362db$export$d76b5866ae4061c8.Closed]: true
};
module.exports["allOpportunityStatusFilterValueKeys"] = $b6f5f787e66362db$export$ff1c9ca0ad19eecd;
module.exports["OpportunityStatusFilterValue"] = $b6f5f787e66362db$export$9e65f1e3288fbede;

});

parcelRegister("jreQ3", function(module, exports) {

var $bxnmj = parcelRequire("bxnmj");

const $ed4249dbaae74eea$export$64e49a0c7bd6f7a0 = (initialState, queryParamKey)=>{
    return (queryParams)=>{
        const queryParamValue = queryParams[queryParamKey];
        let value;
        if (Array.isArray(queryParamValue)) {
            if (queryParamValue[0] === 'all') value = queryParamValue;
            else if ((0, $bxnmj.isPageStatusFilterValueKey)(queryParamValue[0])) value = [
                (0, $bxnmj.PageStatusFilterValue)[queryParamValue[0]]
            ];
        }
        return {
            ...initialState,
            value: value || initialState.value
        };
    };
};
module.exports["generateQueryParamsGetState"] = $ed4249dbaae74eea$export$64e49a0c7bd6f7a0;

});

parcelRegister("cSPiD", function(module, exports) {
const $00471ffd3091ea63$export$64e49a0c7bd6f7a0 = (initialState, queryParamKey)=>{
    return (queryParams)=>{
        const queryParamValue = queryParams[queryParamKey];
        let value;
        if (Array.isArray(queryParamValue)) value = queryParamValue.map((param)=>decodeURIComponent(param));
        return {
            ...initialState,
            value: value || initialState.value
        };
    };
};
module.exports["generateQueryParamsGetState"] = $00471ffd3091ea63$export$64e49a0c7bd6f7a0;

});

parcelRegister("5jwMp", function(module, exports) {
parcelRequire("1yEFx");
var $b4tvS = parcelRequire("b4tvS");

const $7b50c742549c43d5$var$projectIdToARI = (cloudId, projectId)=>`ari:cloud:jira:${cloudId}:project/${projectId}`;
const $7b50c742549c43d5$export$64e49a0c7bd6f7a0 = (initialState, queryParamKey)=>{
    return (queryParams, cloudId)=>{
        const selectedProduct = (queryParams['product'] ?? [])[0];
        const queryParamValue = queryParams[queryParamKey] || [];
        const value = selectedProduct === (0, $b4tvS.ProductKeys).JiraDC || selectedProduct === (0, $b4tvS.ProductKeys).JsmDC ? queryParamValue : queryParamValue.map((projectId)=>$7b50c742549c43d5$var$projectIdToARI(cloudId || '', projectId));
        return {
            ...initialState,
            value: value || initialState.value
        };
    };
};
module.exports["generateQueryParamsGetState"] = $7b50c742549c43d5$export$64e49a0c7bd6f7a0;

});

parcelRegister("2GQhu", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $6Gsan = parcelRequire("6Gsan");

const $4bbfa272a18169bc$export$98613a34994a7d63 = (cloudId, primaryProduct)=>primaryProduct === (0, $6Gsan.PrimaryProductKeys).Jira && (0, $dh538.fg)('jira_site_ari_query_enabled') ? `ari:cloud:jira::site/${cloudId}` : `ari:cloud:confluence::site/${cloudId}`;
module.exports["getCloudIdARI"] = $4bbfa272a18169bc$export$98613a34994a7d63;

});

parcelRegister("5irgt", function(module, exports) {
/**
 * Generic fuzzy matching utility for filtering select filter options client-side.
 *
 * ## Normalization
 * Both the query and candidate text are normalized before comparison by:
 *   - Converting to lowercase
 *   - Stripping all non-alphanumeric characters (hyphens, underscores, spaces, punctuation, etc.)
 *
 * This means "trex" will match "t-rex", "t_rex", "T.Rex", "(T)Rex", etc.
 *
 * ## Matching strategy (applied to normalized strings)
 * 1. **Substring match** — normalized candidate contains normalized query as a contiguous substring.
 *    e.g. "flu" matches "confluence" → "confluence"
 * 2. **Subsequence match** — every character in the normalized query appears in the normalized
 *    candidate in the same relative order (but not necessarily contiguous).
 *    e.g. "cnf" matches "confluence" → "cnflue**n**ce" (c…n…f)
 *
 * An empty query matches everything.
 */ /** Strip all non-alphanumeric characters and lowercase. */ const $78f17cda00f34378$var$normalize = (text)=>text.toLowerCase().replace(/[^a-z0-9]/g, '');
/**
 * Returns true if every character in `query` appears in `text` in the same
 * relative order (subsequence match).
 */ const $78f17cda00f34378$var$isSubsequence = (text, query)=>{
    let queryIndex = 0;
    for(let i = 0; i < text.length && queryIndex < query.length; i++)if (text[i] === query[queryIndex]) queryIndex++;
    return queryIndex === query.length;
};
const $78f17cda00f34378$export$3ace64ce5180d918 = (query, candidate)=>{
    const normalizedQuery = $78f17cda00f34378$var$normalize(query);
    // Empty query matches everything
    if (!normalizedQuery) return true;
    const normalizedCandidate = $78f17cda00f34378$var$normalize(candidate);
    // Nothing left after stripping non-alphanumeric — can't match a non-empty query
    if (!normalizedCandidate) return false;
    // 1. Substring match (faster — try first)
    if (normalizedCandidate.includes(normalizedQuery)) return true;
    // 2. Subsequence match
    return $78f17cda00f34378$var$isSubsequence(normalizedCandidate, normalizedQuery);
};
const $78f17cda00f34378$export$775f9687cb3a8d8b = (query, items, getText)=>{
    if (!query) return items;
    return items.filter((item)=>$78f17cda00f34378$export$3ace64ce5180d918(query, getText(item)));
};
module.exports["fuzzyFilter"] = $78f17cda00f34378$export$775f9687cb3a8d8b;

});

parcelRegister("b12s7", function(module, exports) {
/**
 * Pure function to get 3P product keys for a given filter ID.
 * Uses pre-computed static mapping instead of ThirdPartyConfigs
 * to avoid importing React icon components.
 */ 
var $hdfeV = parcelRequire("hdfeV");

const $bf14b8f874413f2b$export$ef6dfb919b1d7267 = (filterId)=>{
    return (0, $hdfeV.thirdPartyFilterProducts)[filterId] ?? [];
};
module.exports["getProducts3PFromConfigForFilter"] = $bf14b8f874413f2b$export$ef6dfb919b1d7267;

});

parcelRegister("7duAA", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $02a110e3de96df9d$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    clearFilterButtonLabel: {
        id: "search-page.common.ui.clear-filter-button.label",
        defaultMessage: "Clear filter"
    }
});
module.exports["messages"] = $02a110e3de96df9d$export$defe85febe8b728c;

});

parcelRegister("76naE", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $226KS = parcelRequire("226KS");


var $hbYDZ = parcelRequire("hbYDZ");


var $eIlE7 = parcelRequire("eIlE7");


var $oeZjt = parcelRequire("oeZjt");


var $8DN9t = parcelRequire("8DN9t");


var $imt6g = parcelRequire("imt6g");


var $gXn1S = parcelRequire("gXn1S");


var $4AkKf = parcelRequire("4AkKf");


var $lFkSe = parcelRequire("lFkSe");


var $eG1e2 = parcelRequire("eG1e2");


var $la4Nn = parcelRequire("la4Nn");


var $cUQMr = parcelRequire("cUQMr");


var $6767u = parcelRequire("6767u");


var $l8mxb = parcelRequire("l8mxb");


var $7OYaz = parcelRequire("7OYaz");


var $dmsGX = parcelRequire("dmsGX");


var $bh5s2 = parcelRequire("bh5s2");


var $av0Vd = parcelRequire("av0Vd");


var $1dKyn = parcelRequire("1dKyn");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $2OtFZ = parcelRequire("2OtFZ");


var $kP8IJ = parcelRequire("kP8IJ");

const $8c9aa7fb9bbfda3b$export$16b26cd5e98d9100 = ({ filterOrControlId: filterOrControlId, isSelected: isSelected, label: label = '' })=>{
    const iconProps = {
        label: label,
        color: (0, $kP8IJ.getIconColor)(isSelected)
    };
    switch(filterOrControlId){
        case 'owner':
        case 'assignee':
        case 'reporter':
        case 'contributor':
        case 'createdBy':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6767u))), {
                spacing: "none",
                ...iconProps
            });
        case 'verified':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh5s2))), iconProps);
        case 'label':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($av0Vd))), {
                spacing: "none",
                ...iconProps
            });
        case 'content':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cUQMr))), {
                spacing: "none",
                ...iconProps
            });
        case 'focusAreaType':
        case 'focusAreaUnder':
        case 'positionFocusArea':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lFkSe))), {
                spacing: "none",
                ...iconProps
            });
        case 'lastUpdated':
        case 'closeDate':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8DN9t))), {
                spacing: "none",
                ...iconProps
            });
        case 'project':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hbYDZ))), {
                spacing: "none",
                ...iconProps
            });
        case 'space':
            return (0, $2OtFZ.serveConfluenceSpaceIconUpdate)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hbYDZ))), {
                spacing: "none",
                ...iconProps
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eG1e2))), {
                spacing: "none",
                ...iconProps
            });
        case 'onlyTitleMatch':
            return null;
        // Title match doesn't show an icon, only a checkbox
        case 'statusFilter':
        case 'pageStatus':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($imt6g))), {
                spacing: "none",
                ...iconProps
            });
        case 'lastUpdatedBy':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6767u))), {
                spacing: "none",
                ...iconProps
            });
        case 'universalTypeFilter':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gXn1S))), {
                spacing: "none",
                ...iconProps
            });
        case 'dropdown':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4AkKf))), {
                spacing: "none",
                ...iconProps
            });
        case 'sort':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dmsGX))), {
                spacing: "none",
                ...iconProps
            });
        case 'assetsSchema':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($226KS))), {
                spacing: "none",
                ...iconProps
            });
        case 'positionTeam':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1dKyn))), {
                spacing: "none",
                ...iconProps
            });
        case 'positionEmploymentType':
        case 'positionStatus':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l8mxb))), {
                spacing: "none",
                ...iconProps
            });
        case 'pullRequestStatus':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7OYaz))), {
                spacing: "none",
                ...iconProps
            });
        case 'repository':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eIlE7))), {
                spacing: "none",
                ...iconProps
            });
        case 'slackChannel':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($la4Nn))), {
                spacing: "none",
                ...iconProps
            });
        case 'workspaceName':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1dKyn))), {
                spacing: "none",
                ...iconProps
            });
        case 'positionJobFamily':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($oeZjt))), {
                spacing: "none",
                ...iconProps
            });
    }
};
const $8c9aa7fb9bbfda3b$export$68a752ca64f3cf84 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $8c9aa7fb9bbfda3b$var$filterButtonIconContainerStyles
    }, children);
};
const $8c9aa7fb9bbfda3b$var$filterButtonIconContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.075'
});
module.exports["getIcon"] = $8c9aa7fb9bbfda3b$export$16b26cd5e98d9100;

});

parcelRegister("5G4YB", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $226KS = parcelRequire("226KS");


var $oeZjt = parcelRequire("oeZjt");


var $8DN9t = parcelRequire("8DN9t");


var $imt6g = parcelRequire("imt6g");


var $isYda = parcelRequire("isYda");


var $gXn1S = parcelRequire("gXn1S");


var $lFkSe = parcelRequire("lFkSe");


var $5tmwS = parcelRequire("5tmwS");


var $cUQMr = parcelRequire("cUQMr");


var $6767u = parcelRequire("6767u");


var $l8mxb = parcelRequire("l8mxb");


var $bVHZY = parcelRequire("bVHZY");


var $dmsGX = parcelRequire("dmsGX");


var $bh5s2 = parcelRequire("bh5s2");


var $av0Vd = parcelRequire("av0Vd");


var $1dKyn = parcelRequire("1dKyn");

const $38da6198e137f268$export$16b26cd5e98d9100 = ({ filterOrControlId: filterOrControlId, isSelected: isSelected, label: label = '' })=>{
    switch(filterOrControlId){
        case 'owner':
        case 'assignee':
        case 'contributor':
        case 'createdBy':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6767u))), {
                spacing: "none",
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
        case 'verified':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh5s2))), {
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
        case 'label':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($av0Vd))), {
                spacing: "none",
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
        case 'content':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cUQMr))), {
                spacing: "none",
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
        case 'focusAreaType':
        case 'focusAreaUnder':
        case 'positionFocusArea':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lFkSe))), {
                spacing: "none",
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
        case 'lastUpdated':
        case 'closeDate':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8DN9t))), {
                spacing: "none",
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
        case 'project':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bVHZY))), {
                spacing: "none",
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
        case 'space':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5tmwS))), {
                spacing: "none",
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
        case 'onlyTitleMatch':
            return null;
        // Title match doesn't show an icon, only a checkbox
        case 'pageStatus':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($imt6g))), {
                spacing: "none",
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
        case 'lastUpdatedBy':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6767u))), {
                spacing: "none",
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
        case 'universalTypeFilter':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gXn1S))), {
                spacing: "none",
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
        case 'dropdown':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($isYda))), {
                spacing: "none",
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
        case 'sort':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dmsGX))), {
                spacing: "none",
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
        case 'assetsSchema':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($226KS))), {
                spacing: "none",
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
        case 'positionTeam':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1dKyn))), {
                spacing: "none",
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
        case 'positionEmploymentType':
        case 'positionStatus':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l8mxb))), {
                spacing: "none",
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
        case 'positionJobFamily':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($oeZjt))), {
                spacing: "none",
                label: label,
                color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
            });
    }
};
module.exports["getIcon"] = $38da6198e137f268$export$16b26cd5e98d9100;

});

parcelRegister("8pHoH", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $340cf9254ea9b40a$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    app: {
        id: "search-page.filters.names.app-select",
        defaultMessage: "App"
    },
    all: {
        id: "search-page.filter.app-select.all",
        defaultMessage: "All"
    },
    appSelectPlaceholder: {
        id: "search-page.filter.app-select.placeholder",
        defaultMessage: "Find app"
    },
    appSelectLabelSelected: {
        id: "search-page.filter.app-select.label.selected",
        defaultMessage: "Selected"
    },
    appSelectLabelUnselected: {
        id: "search-page.filter.app-select.label.unselected",
        defaultMessage: "Suggested"
    }
});
module.exports["i18n"] = $340cf9254ea9b40a$export$a7357cdd1f0b0168;

});

parcelRegister("1eaCj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7gpC4 = parcelRequire("7gpC4");


var $cvXh8 = parcelRequire("cvXh8");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $2ZCkf = parcelRequire("2ZCkf");

const $7bb98e88b60f66aa$var$containerStylesOld = (0, $ecnYn.xcss)({
    paddingLeft: 'space.100',
    paddingRight: 'space.150',
    paddingTop: 'space.050',
    paddingBottom: 'space.050',
    boxSizing: 'border-box',
    borderRadius: 'radius.small',
    maxHeight: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
});
const $7bb98e88b60f66aa$var$containerStyles = (0, $ecnYn.xcss)({
    paddingRight: 'space.150',
    boxSizing: 'border-box',
    borderRadius: 'radius.small',
    maxHeight: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
});
const $7bb98e88b60f66aa$var$backgroundStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral'
});
const $7bb98e88b60f66aa$var$containerCheckedStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.selected'
});
const $7bb98e88b60f66aa$var$labelStyles = (0, $ecnYn.xcss)({
    fontWeight: "var(--ds-font-weight-medium, 500)",
    color: 'color.text.subtle',
    maxHeight: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $7bb98e88b60f66aa$var$labelInDropdownStyles = (0, $ecnYn.xcss)({
    fontWeight: "var(--ds-font-weight-regular, 400)",
    color: 'color.text.subtle',
    maxHeight: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $7bb98e88b60f66aa$var$labelStylesOld = (0, $ecnYn.xcss)({
    fontWeight: "var(--ds-font-weight-medium, 500)",
    maxHeight: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $7bb98e88b60f66aa$var$labelActiveStyle = (0, $ecnYn.xcss)({
    color: 'color.text.selected'
});
const $7bb98e88b60f66aa$var$checkMarkContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    gap: 'space.075',
    alignItems: 'center'
});
const $7bb98e88b60f66aa$export$2e955e9ca7bb51ef = ({ children: children, onChange: onChange, isChecked: isChecked, autoFocus: autoFocus = false, isFilterInDropdown: isFilterInDropdown = false, isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled, iconBefore: iconBefore })=>{
    if (isFiltersDiscoverability2Enabled) return isFilterInDropdown ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $7bb98e88b60f66aa$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7gpC4.default), {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                $7bb98e88b60f66aa$var$labelInDropdownStyles,
                isChecked && $7bb98e88b60f66aa$var$labelActiveStyle
            ]
        }, children),
        onChange: onChange,
        isChecked: isChecked,
        autoFocus: autoFocus
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2ZCkf.FilterButton), {
        "aria-pressed": isChecked,
        onClick: ()=>onChange?.(),
        hasChevron: false,
        isSelected: isChecked,
        iconBefore: iconBefore
    }, isChecked && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $7bb98e88b60f66aa$var$checkMarkContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $7bb98e88b60f66aa$var$labelStyles,
            isChecked && $7bb98e88b60f66aa$var$labelActiveStyle
        ]
    }, children)), !isChecked && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7gpC4.default), {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                $7bb98e88b60f66aa$var$labelStyles,
                isChecked && $7bb98e88b60f66aa$var$labelActiveStyle
            ]
        }, children),
        onChange: onChange,
        isChecked: isChecked,
        autoFocus: autoFocus
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: [
            $7bb98e88b60f66aa$var$containerStylesOld,
            ...!isFilterInDropdown ? [
                $7bb98e88b60f66aa$var$backgroundStyles,
                isChecked && $7bb98e88b60f66aa$var$containerCheckedStyles
            ] : []
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7gpC4.default), {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                $7bb98e88b60f66aa$var$labelStylesOld,
                isChecked && $7bb98e88b60f66aa$var$labelActiveStyle
            ]
        }, children),
        onChange: onChange,
        isChecked: isChecked,
        autoFocus: autoFocus
    }));
};
module.exports["ToggleFilter"] = $7bb98e88b60f66aa$export$2e955e9ca7bb51ef;

});

parcelRegister("ffbvg", function(module, exports) {

var $djVCD = parcelRequire("djVCD");


var $037Ux = parcelRequire("037Ux");

const $2df2afcc09d5a44d$export$c97cd60200241832 = ({ filterId: filterId })=>{
    const [state, storeActions] = (0, $djVCD.useBooleanFilterStore)({
        filterId: filterId
    });
    const viewActions = {
        toggle: ()=>{
            if (!state) return;
            const productToSelect = (0, $037Ux.getProductToSelect)({
                isUniversal: state?.universal,
                primaryProduct: state?.primaryProduct ?? undefined,
                selectedProduct: state?.selectedProducts[0]
            });
            storeActions.setBooleanFilterValue({
                filterId: filterId,
                value: !state.value,
                options: {
                    setSelectedProduct: productToSelect
                }
            });
        }
    };
    if (!state) return [
        ,
        viewActions
    ];
    const viewState = {
        value: state.value,
        autoFocus: state.alwaysVisible === false
    };
    return [
        viewState,
        viewActions
    ];
};
module.exports["useBooleanFilter"] = $2df2afcc09d5a44d$export$c97cd60200241832;

});

parcelRegister("kdaqW", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $cf2c90d0c72b6c34$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    archived: {
        id: "search-page.filters.names.archived",
        defaultMessage: "Show archived content"
    }
});
module.exports["i18n"] = $cf2c90d0c72b6c34$export$a7357cdd1f0b0168;

});

parcelRegister("2E5eb", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $4138c81ffd5f567f$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    archivedAndPendingComponents: {
        id: "search-page.filters.names.archivedAndPendingComponents",
        defaultMessage: "Show archived/pending components"
    }
});
module.exports["i18n"] = $4138c81ffd5f567f$export$a7357cdd1f0b0168;

});

parcelRegister("2Hu9k", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $d91d36ccaf6ed3cb$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    assignee: {
        id: "search-page.filters.names.assignee",
        defaultMessage: "Assignee"
    },
    jiraFilterContributorPlaceholder: {
        id: "search-page.jira.filter.assignee.placeholder",
        defaultMessage: "Find people"
    },
    jiraFilterAssigneeLabelSelected: {
        id: "search-page.jira.filter.assignee.selected",
        defaultMessage: "Selected"
    },
    jiraFilterAssigneeLabelUnselected: {
        id: "search-page.jira.filter.assignee.unselected",
        defaultMessage: "Suggested"
    }
});
module.exports["i18n"] = $d91d36ccaf6ed3cb$export$a7357cdd1f0b0168;

});

parcelRegister("jUrPw", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lBO0P = parcelRequire("lBO0P");

const $abd15e16e4598c95$var$SharedSalesforceDynamicMultiSelect = ({ filterId: filterId, label: label, noOptionsMessage: noOptionsMessage, iconBefore: iconBefore, isLoading: isLoading, selectedOptions: selectedOptions, suggestedOptions: suggestedOptions, isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled, loadInitialOptions: loadInitialOptions, setOption: setOption, clearOptions: clearOptions, isFilterInDropdown: isFilterInDropdown, fit: fit = 'default', onFilterChange: onFilterChange, hideOnHoverOut: hideOnHoverOut, onClearOptions: onClearOptions })=>{
    const allOptions = [
        ...selectedOptions,
        ...suggestedOptions
    ];
    const resolvedLabel = fit === 'compact' && selectedOptions.length > 0 ? '' : label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lBO0P.default), {
        contentFit: fit,
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onSelectChange: (option)=>{
            setOption(option);
            onFilterChange?.(option);
        },
        options: allOptions,
        selectedOptions: selectedOptions,
        label: resolvedLabel,
        filterOrControlId: filterId,
        isLoading: isLoading,
        isSearchable: true,
        filterOption: null,
        noOptionsMessage: noOptionsMessage,
        onClearOptions: ()=>{
            clearOptions();
            onClearOptions?.({
                filterId: filterId
            });
        },
        isFilterInDropdown: isFilterInDropdown,
        isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled,
        iconBefore: iconBefore,
        hideOnHoverOut: hideOnHoverOut
    });
};
var $abd15e16e4598c95$export$2e2bcd8739ae039 = $abd15e16e4598c95$var$SharedSalesforceDynamicMultiSelect;
module.exports["default"] = $abd15e16e4598c95$export$2e2bcd8739ae039;

});

parcelRegister("lixcy", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $8a38628c0c60fda4$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    campaignStatusFilterLabel: {
        id: "search-page.salesforce.filter.campaignStatus",
        defaultMessage: "Campaign status"
    },
    campaignStatusFilterNoOptions: {
        id: "search-page.salesforce.filter.campaignStatus.no-options",
        defaultMessage: "No statuses available"
    }
});
module.exports["i18n"] = $8a38628c0c60fda4$export$a7357cdd1f0b0168;

});

parcelRegister("iKLhF", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $f42b5bc117eb61eb$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    caseStatusFilterLabel: {
        id: "search-page.salesforce.filter.caseStatus",
        defaultMessage: "Case status"
    },
    caseStatusFilterNoOptions: {
        id: "search-page.salesforce.filter.caseStatus.no-options",
        defaultMessage: "No statuses available"
    }
});
module.exports["i18n"] = $f42b5bc117eb61eb$export$a7357cdd1f0b0168;

});

parcelRegister("gTpIM", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");


var $c4Cbx = parcelRequire("c4Cbx");


var $dh538 = parcelRequire("dh538");


var $lGgRw = parcelRequire("lGgRw");


var $gdv5Z = parcelRequire("gdv5Z");

var $eyWa4 = parcelRequire("eyWa4");


var $7iBhV = parcelRequire("7iBhV");


var $2ZCkf = parcelRequire("2ZCkf");


var $coCs8 = parcelRequire("coCs8");


var $kfaxy = parcelRequire("kfaxy");


var $cJ4TJ = parcelRequire("cJ4TJ");


var $kjNCN = parcelRequire("kjNCN");


var $deQ0D = parcelRequire("deQ0D");

const $aa678bf4826904b9$var$styles = {
    container: "_1reoewfl _18m9ewfl _2rko12b0 _vchhusvi _1bsbixjv _bfhk1bhr _16qs130s _1pbyb4wl _nt751r31 _49pcglyw _1hvw1o36"
};
const $aa678bf4826904b9$var$PopupComponent = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        ...props,
        paddingBlock: "space.100",
        ref: ref,
        xcss: $aa678bf4826904b9$var$styles.container,
        "data-testid": undefined
    }));
const $aa678bf4826904b9$export$3ae94a2503e890a1 = (dateString, locale)=>{
    const modifiedDateString = dateString.concat('T00:00');
    return new Date(modifiedDateString).toLocaleDateString(locale);
};
const $aa678bf4826904b9$export$d397f86d22f413e8 = (isSelected, isCustomDateSelected, selectedLabel, label, locale, closeDateVal)=>{
    if (!isSelected || !selectedLabel) return label;
    const prefix = label.length > 0 ? `${label}: ` : '';
    if (isCustomDateSelected && closeDateVal) {
        const valueLabel = $aa678bf4826904b9$export$3ae94a2503e890a1(closeDateVal, locale);
        return `${prefix}${valueLabel}`;
    }
    return `${prefix}${selectedLabel}`;
};
const $aa678bf4826904b9$var$CloseDateFilterWithDatePicker = ({ options: options, onDropdownOpen: onDropdownOpen, onSelectChange: onSelectChange, selectedOptions: selectedOptions, customDateValue: customDateValue, label: label, testId: testId, isFilterInDropdown: isFilterInDropdown, isDefaultOpen: isDefaultOpen = false, isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled, iconBefore: iconBefore, hideOnHoverOut: hideOnHoverOut, matchReferenceWidth: matchReferenceWidth = isFilterInDropdown, contentFit: contentFit })=>{
    const [open, setOpen] = (0, $42omo.useState)(isDefaultOpen);
    const [customDateOpen, setCustomDateOpen] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage, locale: locale } = (0, $aXWIB.useIntl)();
    const [focusedOption, setFocusedOption] = (0, $42omo.useState)(0);
    const [mouseHovered, setMouseHovered] = (0, $42omo.useState)(false);
    const buttonRef = (0, $42omo.useRef)(null);
    const [selectedDate, setSelectedDate] = (0, $42omo.useState)(customDateValue);
    const isSelected = selectedOptions.length > 0 || open;
    const firstSelected = selectedOptions[0];
    const isCustomDateSelected = firstSelected?.value === (0, $7iBhV.CUSTOM_OPTION_VALUE);
    const customModifiers = [
        ...matchReferenceWidth ? [
            (0, $kjNCN.matchReferenceWidthModifier)
        ] : []
    ];
    const labelToDisplay = $aa678bf4826904b9$export$d397f86d22f413e8(isSelected, isCustomDateSelected, firstSelected?.label || '', label, locale, customDateValue);
    const handleOptionClick = (option)=>{
        if (option.value === (0, $7iBhV.CUSTOM_OPTION_VALUE)) setCustomDateOpen(true);
        else {
            setCustomDateOpen(false);
            onSelectChange(option, {
                closeDateVal: ''
            });
            setOpen(false);
        }
    };
    const handleDateApply = ()=>{
        if (!selectedDate) return;
        const option = options.find((o)=>o.value === (0, $7iBhV.CUSTOM_OPTION_VALUE));
        if (!option) return;
        onSelectChange(option, {
            closeDateVal: selectedDate
        });
        setOpen(false);
    };
    const handleClickDropdownBtn = ()=>{
        if (!open && onDropdownOpen) onDropdownOpen();
        setOpen(!open);
        setFocusedOption(0);
        buttonRef.current?.focus();
    };
    const handleKeyDown = (event)=>{
        if (event.key === 'ArrowDown') {
            event.preventDefault();
            setFocusedOption((prev)=>(prev + 1) % options.length);
        }
        if (event.key === 'ArrowUp') {
            event.preventDefault();
            setFocusedOption((prev)=>(prev - 1 + options.length) % options.length);
        }
        if (event.key === 'Enter' && open) {
            event.preventDefault();
            handleOptionClick(options[focusedOption]);
        }
    };
    (0, $42omo.useEffect)(()=>{
        if (isCustomDateSelected) setCustomDateOpen(true);
        else setCustomDateOpen(false);
    }, [
        isCustomDateSelected
    ]); // Get today's date in ISO format for maxDate
    const today = new Date().toISOString().split('T')[0];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kfaxy.MaybeHoverOutWrapper), {
        enabled: hideOnHoverOut,
        callback: ()=>setOpen(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        placement: "bottom-start",
        onClose: ()=>setOpen(false),
        isOpen: open,
        autoFocus: false,
        popupComponent: $aa678bf4826904b9$var$PopupComponent,
        zIndex: (0, $dh538.fg)('platform-dst-motion-uplift-popup') ? 100 : undefined,
        shouldRenderToParent: true,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                role: "menu",
                onMouseOver: ()=>setMouseHovered(true),
                onMouseOut: ()=>setMouseHovered(false)
            }, options.map((option, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cJ4TJ.default), {
                    hovered: !mouseHovered && focusedOption === index,
                    key: option.value,
                    option: option,
                    onClick: ()=>handleOptionClick(option)
                })), customDateOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                paddingInline: "space.150",
                paddingBlock: "space.075",
                testId: testId ? `${testId}-date-picker` : undefined
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
                space: "space.150"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4Cbx.default), {
                onChange: (date)=>setSelectedDate(date),
                defaultValue: customDateValue || undefined,
                placeholder: formatMessage((0, $deQ0D.i18n).closeDateFilterDatePlaceholder),
                locale: locale,
                label: formatMessage((0, $deQ0D.i18n).closeDateFilterDateLabel),
                shouldShowCalendarButton: true,
                maxDate: today
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                isDisabled: !selectedDate,
                onClick: handleDateApply
            }, formatMessage((0, $deQ0D.i18n).closeDateFilterUpdateButton)))))),
        trigger: (triggerProps)=>isFiltersDiscoverability2Enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2ZCkf.FilterButton), {
                ...triggerProps,
                contentFit: contentFit,
                testId: testId ? `${testId}-button` : undefined,
                isSelected: isSelected,
                onClick: handleClickDropdownBtn,
                onKeyDown: handleKeyDown,
                filterOrControlId: "closeDate",
                isFilterInDropdown: isFilterInDropdown,
                iconBefore: iconBefore
            }, labelToDisplay) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $coCs8.FilterButtonOld), {
                label: labelToDisplay,
                filterOrControlId: 'closeDate',
                otherProps: triggerProps,
                isSelected: isSelected,
                onClick: handleClickDropdownBtn,
                testId: testId ? `${testId}-button` : undefined,
                onKeyDown: handleKeyDown,
                wide: true,
                iconBefore: iconBefore
            }),
        modifiers: customModifiers
    }));
};
var $aa678bf4826904b9$export$2e2bcd8739ae039 = $aa678bf4826904b9$var$CloseDateFilterWithDatePicker;
module.exports["default"] = $aa678bf4826904b9$export$2e2bcd8739ae039;

});

parcelRegister("jf1P1", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $7b970749984af528$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    closeDate: {
        id: "search-page.filters.names.closeDate",
        defaultMessage: "Close date"
    }
});
module.exports["i18n"] = $7b970749984af528$export$a7357cdd1f0b0168;

});

parcelRegister("drVRR", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $3d42a851790c0721$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    commentedByMe: {
        id: "search-page.filters.names.work-commented-on",
        defaultMessage: "Work I've commented on"
    }
});
module.exports["i18n"] = $3d42a851790c0721$export$a7357cdd1f0b0168;

});

parcelRegister("dO5lX", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $f632168de68b9766$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    content: {
        id: "search-page.filters.names.content",
        defaultMessage: "Content under"
    },
    confluenceFilterPlaceholder: {
        id: "search-page.confluence.filter.content.placeholder",
        defaultMessage: "Find content"
    },
    confluenceFilterLabelSelected: {
        id: "search-page.confluence.filter.content.selected",
        defaultMessage: "Selected"
    },
    confluenceFilterLabelUnselected: {
        id: "search-page.confluence.filter.content.unselected",
        defaultMessage: "Suggested"
    }
});
module.exports["i18n"] = $f632168de68b9766$export$a7357cdd1f0b0168;

});

parcelRegister("2RkQg", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $ddb658b711162ced$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    contributor: {
        id: "search-page.filters.names.contributor",
        defaultMessage: "Contributor"
    },
    confluenceFilterContributorPlaceholder: {
        id: "search-page.confluence.filter.contributor.placeholder",
        defaultMessage: "Find people"
    },
    confluenceFilterContributorLabelSelected: {
        id: "search-page.confluence.filter.contributor.label.selected",
        defaultMessage: "Selected"
    },
    confluenceFilterContributorLabelUnselected: {
        id: "search-page.confluence.filter.contributor.label.unselected",
        defaultMessage: "Suggested"
    }
});
module.exports["i18n"] = $ddb658b711162ced$export$a7357cdd1f0b0168;

});

parcelRegister("35KZ1", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $9e4ae55be4be6ad4$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    createdBy: {
        id: "search-page.filters.names.createdBy",
        defaultMessage: "Created by"
    },
    confluenceFilterCreatorPlaceholder: {
        id: "search-page.confluence.filter.creator.placeholder",
        defaultMessage: "Find people"
    },
    confluenceFilterCreatorLabelSelected: {
        id: "search-page.confluence.filter.creator.selected",
        defaultMessage: "Selected"
    },
    confluenceFilterCreatorLabelUnselected: {
        id: "search-page.confluence.filter.creator.unselected",
        defaultMessage: "Suggested"
    }
});
module.exports["i18n"] = $9e4ae55be4be6ad4$export$a7357cdd1f0b0168;

});

parcelRegister("hiJnb", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $ea5b4e70f5f59539$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    focusAreaType: {
        id: "search-page.filters.names.focusAreaType",
        defaultMessage: "Focus area type"
    },
    mercuryFilterFocusAreaTypePlaceholder: {
        id: "search-page.mercury.filter.focusAreaType.placeholder",
        defaultMessage: "Find focus area types"
    },
    mercuryFilterFocusAreaTypeLabelSelected: {
        id: "search-page.mercury.filter.focusAreaType.label.selected",
        defaultMessage: "Selected"
    },
    mercuryFilterFocusAreaTypeLabelUnselected: {
        id: "search-page.mercury.filter.focusAreaType.label.unselected",
        defaultMessage: "Suggested"
    }
});
module.exports["i18n"] = $ea5b4e70f5f59539$export$a7357cdd1f0b0168;

});

parcelRegister("1epJJ", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $cfc139e386a03391$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    mercuryFilterFocusAreaUnderLabel: {
        id: "search-page.filters.names.focusAreaUnder",
        defaultMessage: "Focus area under"
    },
    mercuryFilterFocusAreaUnderLabelPlaceholder: {
        id: "search-page.mercury.filter.content.placeholder",
        defaultMessage: "Find focus areas"
    },
    mercuryFilterFocusAreaUnderLabelLabelSelected: {
        id: "search-page.mercury.filter.content.selected",
        defaultMessage: "Selected"
    },
    mercuryFilterFocusAreaUnderLabelUnselected: {
        id: "search-page.mercury.filter.content.unselected",
        defaultMessage: "Suggested"
    }
});
module.exports["i18n"] = $cfc139e386a03391$export$a7357cdd1f0b0168;

});

parcelRegister("9WvAH", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $756ecd841137780b$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    hasAttachment: {
        id: "search-page.filters.names.has-attachment",
        defaultMessage: "Has attachment"
    }
});
module.exports["i18n"] = $756ecd841137780b$export$a7357cdd1f0b0168;

});

parcelRegister("eDcMw", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $6f66574103527d20$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    label: {
        id: "search-page.filters.names.labels",
        defaultMessage: "Label"
    },
    confluenceFilterLabelPlaceholder: {
        id: "search-page.confluence.filter.labels.placeholder",
        defaultMessage: "Find labels"
    },
    selectedOptionsSection: {
        id: "search-page.confluence.filter.label.selected",
        defaultMessage: "Selected"
    },
    confluenceFilterLabelsNoText: {
        id: "advanced-search.labels.filter.no.text",
        defaultMessage: "Start typing to search for a label"
    },
    suggestedOptionsSection: {
        id: "search-page.filter.suggested.options.section",
        defaultMessage: "Suggested"
    }
});
module.exports["i18n"] = $6f66574103527d20$export$a7357cdd1f0b0168;

});

parcelRegister("9PTlU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $dh538 = parcelRequire("dh538");


var $lGgRw = parcelRequire("lGgRw");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $7iBhV = parcelRequire("7iBhV");


var $2ZCkf = parcelRequire("2ZCkf");


var $coCs8 = parcelRequire("coCs8");


var $kfaxy = parcelRequire("kfaxy");


var $kjNCN = parcelRequire("kjNCN");


var $cJ4TJ = parcelRequire("cJ4TJ");


var $kiOcc = parcelRequire("kiOcc");


var $kmrEb = parcelRequire("kmrEb");

const $1ff899806b26058d$var$containerStyles = (0, $ecnYn.xcss)({
    boxSizing: 'border-box',
    width: '375px',
    overflow: 'visible',
    backgroundColor: 'elevation.surface.overlay',
    ':focus': {
        outline: 'none'
    },
    borderRadius: 'radius.small',
    boxShadow: 'elevation.shadow.overlay',
    zIndex: 'card'
});
const $1ff899806b26058d$var$PopupComponent = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        ...props,
        paddingBlock: "space.100",
        ref: ref,
        xcss: $1ff899806b26058d$var$containerStyles,
        "data-testid": undefined
    }));
const $1ff899806b26058d$export$3ae94a2503e890a1 = (dateString, locale)=>{
    // to keep date string in local time, not UTC:
    // https://stackoverflow.com/questions/39223481/incorrect-date-shown-in-new-date-in-javascript
    const modifiedDateString = dateString.concat('T00:00');
    return new Date(modifiedDateString).toLocaleDateString(locale);
};
const $1ff899806b26058d$export$7405c5f2f8c0840d = (locale, afterString, beforeString, from, to)=>{
    if (from && !to) {
        const localeFromDate = $1ff899806b26058d$export$3ae94a2503e890a1(from, locale);
        return `${afterString} ${localeFromDate}`;
    }
    if (!from && to) {
        const localeToDate = $1ff899806b26058d$export$3ae94a2503e890a1(to, locale);
        return `${beforeString} ${localeToDate}`;
    }
    if (from && to) {
        const localeFromDate = $1ff899806b26058d$export$3ae94a2503e890a1(from, locale);
        const localeToDate = $1ff899806b26058d$export$3ae94a2503e890a1(to, locale);
        return `${localeFromDate} - ${localeToDate}`;
    }
};
const $1ff899806b26058d$export$d397f86d22f413e8 = (isSelected, isCustomDateSelected, selectedLabel, label, afterString, beforeString, locale, from, to)=>{
    if (!isSelected || !selectedLabel) return label;
    const prefix = label.length > 0 ? `${label}: ` : '';
    if (isCustomDateSelected && (from || to)) {
        const valueLabel = $1ff899806b26058d$export$7405c5f2f8c0840d(locale, afterString, beforeString, from, to);
        return `${prefix}${valueLabel}`;
    }
    return `${prefix}${selectedLabel}`;
};
const $1ff899806b26058d$var$DateFilterWithCustomRangePicker = ({ options: options, onDropdownOpen: onDropdownOpen, onSelectChange: onSelectChange, selectedOptions: selectedOptions, customDateRange: customDateRange, label: label, testId: testId, isFilterInDropdown: isFilterInDropdown, isDefaultOpen: isDefaultOpen = false, isFiltersDiscoverability2Enabled: isFiltersDiscoverability2Enabled, iconBefore: iconBefore, hideOnHoverOut: hideOnHoverOut, matchReferenceWidth: matchReferenceWidth = isFilterInDropdown, contentFit: contentFit })=>{
    const [open, setOpen] = (0, $42omo.useState)(isDefaultOpen);
    const [customDateOpen, setCustomDateOpen] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage, locale: locale } = (0, $aXWIB.useIntl)();
    const [focusedOption, setFocusedOption] = (0, $42omo.useState)(0);
    const [mouseHovered, setMouseHovered] = (0, $42omo.useState)(false);
    const buttonRef = (0, $42omo.useRef)(null);
    const isSelected = selectedOptions.length > 0 || open;
    const firstSelected = selectedOptions[0];
    const isCustomDateSelected = firstSelected?.value === (0, $7iBhV.CUSTOM_OPTION_VALUE);
    const customModifiers = [
        ...matchReferenceWidth ? [
            (0, $kjNCN.matchReferenceWidthModifier)
        ] : []
    ];
    const labelToDisplay = $1ff899806b26058d$export$d397f86d22f413e8(isSelected, isCustomDateSelected, firstSelected?.label || '', label, formatMessage((0, $kmrEb.i18n).dateFilterAfterLabel), formatMessage((0, $kmrEb.i18n).dateFilterBeforeLabel), locale, customDateRange.from, customDateRange.to);
    const handleOptionClick = (option)=>{
        if (option.value === (0, $7iBhV.CUSTOM_OPTION_VALUE)) setCustomDateOpen(true);
        else {
            setCustomDateOpen(false);
            onSelectChange(option, customDateRange);
            setOpen(false);
        }
    };
    const handleCustomDateRangeChange = (from, to)=>{
        const option = options.find((o)=>o.value === (0, $7iBhV.CUSTOM_OPTION_VALUE));
        if (!option) return;
        onSelectChange(option, {
            from: from,
            to: to
        });
        setOpen(false);
    };
    const handleClickDropdownBtn = ()=>{
        if (!open && onDropdownOpen) onDropdownOpen();
        setOpen(!open);
        setFocusedOption(0);
        buttonRef.current?.focus();
    };
    const handleKeyDown = (event)=>{
        // Only handle arrow keys for menu option navigation when not in DatePicker
        if (event.key === 'ArrowDown') {
            event.preventDefault();
            setFocusedOption((prev)=>(prev + 1) % options.length);
        }
        if (event.key === 'ArrowUp') {
            event.preventDefault();
            setFocusedOption((prev)=>(prev - 1 + options.length) % options.length);
        }
        if (event.key === 'Enter' && open) {
            event.preventDefault();
            handleOptionClick(options[focusedOption]);
        }
    };
    (0, $42omo.useEffect)(()=>{
        if (isCustomDateSelected) setCustomDateOpen(true);
        else setCustomDateOpen(false);
    }, [
        isCustomDateSelected
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kfaxy.MaybeHoverOutWrapper), {
        enabled: hideOnHoverOut,
        callback: ()=>setOpen(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        placement: "bottom-start",
        onClose: ()=>setOpen(false),
        isOpen: open,
        autoFocus: false,
        popupComponent: $1ff899806b26058d$var$PopupComponent,
        zIndex: (0, $dh538.fg)('platform-dst-motion-uplift-popup') ? 100 : undefined,
        shouldRenderToParent: true,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                role: "menu",
                onMouseOver: ()=>setMouseHovered(true),
                onMouseOut: ()=>setMouseHovered(false)
            }, options.map((option, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cJ4TJ.default), {
                    hovered: !mouseHovered && focusedOption === index,
                    key: option.value,
                    option: option,
                    onClick: ()=>handleOptionClick(option)
                })), customDateOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kiOcc.default), {
                onCustomDateRangeChange: handleCustomDateRangeChange,
                customDateRange: customDateRange,
                testId: testId ? `${testId}-custom-date-range-picker` : undefined
            })),
        trigger: (triggerProps)=>isFiltersDiscoverability2Enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2ZCkf.FilterButton), {
                ...triggerProps,
                contentFit: contentFit,
                testId: testId ? `${testId}-button` : undefined,
                isSelected: isSelected,
                onClick: handleClickDropdownBtn,
                onKeyDown: handleKeyDown,
                filterOrControlId: "lastUpdated",
                isFilterInDropdown: isFilterInDropdown,
                iconBefore: iconBefore
            }, labelToDisplay) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $coCs8.FilterButtonOld), {
                label: labelToDisplay,
                filterOrControlId: 'lastUpdated',
                otherProps: triggerProps,
                isSelected: isSelected,
                onClick: handleClickDropdownBtn,
                testId: testId ? `${testId}-button` : undefined,
                onKeyDown: handleKeyDown,
                wide: true,
                iconBefore: iconBefore
            }),
        modifiers: customModifiers
    }));
};
var $1ff899806b26058d$export$2e2bcd8739ae039 = $1ff899806b26058d$var$DateFilterWithCustomRangePicker;
module.exports["default"] = $1ff899806b26058d$export$2e2bcd8739ae039;

});

parcelRegister("hCRbr", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $6e59924e5f5416ed$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    lastUpdated: {
        id: "search-page.filters.names.lastUpdated",
        defaultMessage: "Last updated"
    }
});
module.exports["i18n"] = $6e59924e5f5416ed$export$a7357cdd1f0b0168;

});

parcelRegister("mCz2w", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $c609d4e7beffa18b$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    lastUpdatedBy: {
        id: "search-page.filters.names.lastUpdatedBy",
        defaultMessage: "Last updated by"
    },
    confluenceFilterCreatorPlaceholder: {
        id: "search-page.confluence.filter.creator.placeholder",
        defaultMessage: "Find people"
    },
    confluenceFilterCreatorLabelSelected: {
        id: "search-page.confluence.filter.creator.selected",
        defaultMessage: "Selected"
    },
    confluenceFilterCreatorLabelUnselected: {
        id: "search-page.confluence.filter.creator.unselected",
        defaultMessage: "Suggested"
    }
});
module.exports["i18n"] = $c609d4e7beffa18b$export$a7357cdd1f0b0168;

});

parcelRegister("rdHwx", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $b8642f7d61b5dbdc$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    opportunityStatusFilterLabel: {
        id: "search-page.salesforce.filter.dealStatus",
        defaultMessage: "Deal status"
    }
});
module.exports["i18n"] = $b8642f7d61b5dbdc$export$a7357cdd1f0b0168;

});

parcelRegister("ivrfM", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $039964b2efeb1cde$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    owner: {
        id: "search-page.filters.names.owner",
        defaultMessage: "Owner"
    },
    confluenceFilterOwnerPlaceholder: {
        id: "search-page.confluence.filter.contributor.placeholder",
        defaultMessage: "Find people"
    },
    confluenceFilterOwnerLabelSelected: {
        id: "search-page.confluence.filter.contributor.label.selected",
        defaultMessage: "Selected"
    },
    confluenceFilterOwnerLabelUnselected: {
        id: "search-page.confluence.filter.contributor.label.unselected",
        defaultMessage: "Suggested"
    }
});
module.exports["i18n"] = $039964b2efeb1cde$export$a7357cdd1f0b0168;

});

parcelRegister("6yMPR", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $5be789084c01dbcc$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    pageStatus: {
        id: "search-page.filters.names.pageStatus",
        defaultMessage: "Status"
    }
});
module.exports["i18n"] = $5be789084c01dbcc$export$a7357cdd1f0b0168;

});

parcelRegister("kjNCN", function(module, exports) {
const $746d41e27aa45b74$export$5374bb854d0e41c8 = (value)=>{
    return typeof value === 'number' && value > 0;
};
const $746d41e27aa45b74$export$a8e9b369768a413a = {
    name: 'matchReferenceWidth',
    enabled: true,
    phase: 'beforeWrite',
    fn: ({ state: state })=>{
        if ($746d41e27aa45b74$export$5374bb854d0e41c8(state?.rects?.reference?.width)) state.styles.popper.width = `${state.rects.reference.width}px`;
    }
};
module.exports["matchReferenceWidthModifier"] = $746d41e27aa45b74$export$a8e9b369768a413a;

});

parcelRegister("5eact", function(module, exports) {
const $016b627a277b33e4$var$stripHighlightMarkers = (value)=>value.replace(/@@@hl@@@/g, '').replace(/@@@endhl@@@/g, '');
const $016b627a277b33e4$export$74e4b86c77a70501 = ({ label: label, firstSelectedLabel: firstSelectedLabel = '', numSelectedOptions: numSelectedOptions })=>{
    const sanitizedFirstSelectedLabel = $016b627a277b33e4$var$stripHighlightMarkers(firstSelectedLabel);
    const colon = sanitizedFirstSelectedLabel && label ? ': ' : '';
    const comma = sanitizedFirstSelectedLabel && numSelectedOptions > 1 ? ',' : '';
    return `${label}${colon}${sanitizedFirstSelectedLabel}${comma}`;
};
module.exports["getButtonText"] = $016b627a277b33e4$export$74e4b86c77a70501;

});

parcelRegister("FK90w", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $b53f07eda24f4494$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    positionFilterFocusAreaLabel: {
        id: "search-page.filters.names.positionFocusArea",
        defaultMessage: "Focus area"
    },
    positionFilterFocusAreaPlaceholder: {
        id: "search-page.talent.filter.focus-area.content.placeholder",
        defaultMessage: "Find focus areas"
    },
    positionFilterFocusAreaLabelSelected: {
        id: "search-page.talent.filter.focus-area.content.selected",
        defaultMessage: "Selected"
    },
    positionFilterFocusAreaLabelUnselected: {
        id: "search-page.talent.filter.focus-area.content.unselected",
        defaultMessage: "Suggested"
    }
});
module.exports["i18n"] = $b53f07eda24f4494$export$a7357cdd1f0b0168;

});

parcelRegister("1pFlR", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $23ec026d911c1d6c$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    positionFilterJobFamilyLabel: {
        id: "search-page.filters.names.positionJobFamily",
        defaultMessage: "Job family"
    },
    positionFilterJobFamilyPlaceholder: {
        id: "search-page.talent.filter.position-job-family.content.placeholder",
        defaultMessage: "Find job families"
    },
    positionFilterJobFamilyLabelSelected: {
        id: "search-page.talent.filter.position-job-family.content.selected",
        defaultMessage: "Selected"
    },
    positionFilterJobFamilyLabelUnselected: {
        id: "search-page.talent.filter.position-job-family.content.unselected",
        defaultMessage: "Suggested"
    }
});
module.exports["i18n"] = $23ec026d911c1d6c$export$a7357cdd1f0b0168;

});

parcelRegister("7SF4k", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $469bdda9d8c8bfa0$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    positionStatusFilterLabel: {
        id: "search-page.filters.names.position-status-filter",
        defaultMessage: "Filled status"
    },
    positionStatusFilterPlaceholder: {
        id: "search-page.talent.filter.position-status-filter.content.placeholder",
        defaultMessage: "Find filled status"
    },
    positionStatusFilterLabelSelected: {
        id: "search-page.talent.filter.position-status-filter.content.selected",
        defaultMessage: "Selected"
    },
    positionStatusFilterLabelUnselected: {
        id: "search-page.talent.filter.position-status-filter.content.unselected",
        defaultMessage: "Suggested"
    }
});
module.exports["i18n"] = $469bdda9d8c8bfa0$export$a7357cdd1f0b0168;

});

parcelRegister("7PdYY", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $2f33d1c42b74a8be$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    positionFilterTeamLabel: {
        id: "search-page.filters.names.positionTeam",
        defaultMessage: "Team"
    },
    positionFilterTeamPlaceholder: {
        id: "search-page.talent.filter.position-team.content.placeholder",
        defaultMessage: "Find teams"
    },
    positionFilterTeamLabelSelected: {
        id: "search-page.talent.filter.position-team.content.selected",
        defaultMessage: "Selected"
    },
    positionFilterTeamLabelUnselected: {
        id: "search-page.talent.filter.position-team.content.unselected",
        defaultMessage: "Suggested"
    }
});
module.exports["i18n"] = $2f33d1c42b74a8be$export$a7357cdd1f0b0168;

});

parcelRegister("dSRVv", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $86780f5cae351dc9$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    project: {
        id: "search-page.filters.names.project",
        defaultMessage: "Project"
    },
    jiraFilterProjectPlaceholder: {
        id: "search-page.jira.filter.project.placeholder",
        defaultMessage: "Find projects"
    },
    jiraFilterProjectLabelSelected: {
        id: "search-page.jira.filter.project.selected",
        defaultMessage: "Selected"
    },
    jiraFilterProjectLabelUnselected: {
        id: "search-page.jira.filter.project.unselected",
        defaultMessage: "Suggested"
    },
    spaces: {
        id: "search-page.filters.names.spaces",
        defaultMessage: "Space"
    },
    jiraFilterSpacesPlaceholder: {
        id: "search-page.jira.filter.spaces.placeholder",
        defaultMessage: "Find spaces"
    },
    jiraFilterSpacesLabelSelected: {
        id: "search-page.jira.filter.spaces.selected",
        defaultMessage: "Selected"
    },
    jiraFilterSpacesLabelUnselected: {
        id: "search-page.jira.filter.spaces.unselected",
        defaultMessage: "Suggested"
    }
});
module.exports["i18n"] = $86780f5cae351dc9$export$a7357cdd1f0b0168;

});

parcelRegister("kAzVs", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $9bf8970e96f0ce5c$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    pullRequestStatusLabel: {
        id: "search-page.filters.names.pull-request-status",
        defaultMessage: "PR status"
    }
});
module.exports["i18n"] = $9bf8970e96f0ce5c$export$a7357cdd1f0b0168;

});

parcelRegister("41YG4", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $67dca52cd4dd7a2d$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    reporter: {
        id: "search-page.filters.names.reporter",
        defaultMessage: "Reporter"
    },
    jiraFilterContributorPlaceholder: {
        id: "search-page.jira.filter.reporter.placeholder",
        defaultMessage: "Find people"
    },
    jiraFilterReporterLabelSelected: {
        id: "search-page.jira.filter.reporter.selected",
        defaultMessage: "Selected"
    },
    jiraFilterReporterLabelUnselected: {
        id: "search-page.jira.filter.reporter.unselected",
        defaultMessage: "Suggested"
    }
});
module.exports["i18n"] = $67dca52cd4dd7a2d$export$a7357cdd1f0b0168;

});

parcelRegister("bbo8Q", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $40cd8354da07d7e9$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    repositoryLabel: {
        id: "search-page.filters.names.repository",
        defaultMessage: "Repository"
    },
    noOptions: {
        id: "search-page.filters.names.repository.no-options",
        defaultMessage: "No repositories available"
    }
});
module.exports["i18n"] = $40cd8354da07d7e9$export$a7357cdd1f0b0168;

});

parcelRegister("1zWkb", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $bda62529a18ff81f$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    relevanceDESC: {
        id: "results-sort.relevanceDESC",
        defaultMessage: "Relevance"
    },
    relevanceDESCSelected: {
        id: "results-sort.relevanceDESC.selected",
        defaultMessage: "Sort by relevance"
    },
    latestModifiedDateDESC: {
        id: "results-sort.latestModifiedDateDESC",
        defaultMessage: "Updated (newest)"
    },
    latestModifiedDateDESCSelected: {
        id: "results-sort.latestModifiedDateDESC.selected",
        defaultMessage: "Sort by updated (newest)"
    },
    latestModifiedDateASC: {
        id: "results-sort.latestModifiedDateASC",
        defaultMessage: "Updated (oldest)"
    },
    latestModifiedDateASCSelected: {
        id: "results-sort.latestModifiedDateASC.selected",
        defaultMessage: "Sort by updated (oldest)"
    },
    createdDateDESC: {
        id: "results-sort.createdDateDESC",
        defaultMessage: "Created (newest)"
    },
    createdDateDESCSelected: {
        id: "results-sort.createdDate.selected",
        defaultMessage: "Sort by created (newest)"
    },
    createdDateASC: {
        id: "results-sort.createdDateASC",
        defaultMessage: "Created (oldest)"
    },
    createdDateASCSelected: {
        id: "results-sort.createdDateASCSelected.selected",
        defaultMessage: "Sort by created (oldest)"
    },
    sortOptionsLabel: {
        id: "results-sort.sort-options.label",
        defaultMessage: "Change list sorting"
    }
});
module.exports["messages"] = $bda62529a18ff81f$export$defe85febe8b728c;

});

parcelRegister("16U2b", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $d8adca952eaf3df4$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    salesforceStageFilterLabel: {
        id: "search-page.salesforce.filter.stage",
        defaultMessage: "Deal stage"
    },
    salesforceStageFilterNoOptions: {
        id: "search-page.salesforce.filter.stage.no-options",
        defaultMessage: "No stages available"
    }
});
module.exports["i18n"] = $d8adca952eaf3df4$export$a7357cdd1f0b0168;

});

parcelRegister("13BpK", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $85b64aa75c31bec0$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    label: {
        id: "search-page-relay.filters.product-filters.slack-channel.label",
        defaultMessage: "Channel"
    },
    placeholder: {
        id: "search-page-relay.filters.product-filters.slack-channel.placeholder",
        defaultMessage: "Filter by channel"
    },
    selectedLabel: {
        id: "search-page-relay.filters.product-filters.slack-channel.selected-label",
        defaultMessage: "Selected"
    },
    suggestedLabel: {
        id: "search-page-relay.filters.product-filters.slack-channel.suggested-label",
        defaultMessage: "Channels"
    }
});
module.exports["i18n"] = $85b64aa75c31bec0$export$a7357cdd1f0b0168;

});

parcelRegister("8QBsF", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $b3b9a830e69616f9$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    space: {
        id: "search-page.filters.names.space",
        defaultMessage: "Space"
    },
    drive: {
        id: "search-page.filters.names.drive",
        defaultMessage: "Drive"
    },
    drivePlaceholder: {
        id: "search-page.google-drive.filter.drive.placeholder",
        defaultMessage: "Find drives"
    },
    site: {
        id: "search-page.filters.names.site",
        defaultMessage: "Site"
    },
    sitePlaceholder: {
        id: "search-page.sharepoint.filter.site.placeholder",
        defaultMessage: "Find sites"
    },
    confluenceFilterSpacePlaceholder: {
        id: "search-page.confluence.filter.space.placeholder",
        defaultMessage: "Find spaces"
    },
    confluenceFilterLabelSelected: {
        id: "search-page.confluence.filter.label.selected",
        defaultMessage: "Selected"
    },
    confluenceFilterLabelUnselected: {
        id: "search-page.confluence.filter.label.unselected",
        defaultMessage: "Suggested"
    },
    confluenceIconLabel: {
        id: "search-page.confluence.filter.icon.label",
        defaultMessage: "Confluence filter"
    }
});
module.exports["i18n"] = $b3b9a830e69616f9$export$a7357cdd1f0b0168;

});

parcelRegister("6ebAl", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $9d4fe03134881c57$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    statusLabel: {
        id: "search-page.filters.names.status",
        defaultMessage: "Status"
    }
});
module.exports["i18n"] = $9d4fe03134881c57$export$a7357cdd1f0b0168;

});

parcelRegister("316RU", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $75b228b7e7645094$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    onlyTitleMatch: {
        id: "search-page.filters.names.titleMatchOnly",
        defaultMessage: "Search title only"
    }
});
module.exports["i18n"] = $75b228b7e7645094$export$a7357cdd1f0b0168;

});

parcelRegister("OOvdO", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $d476884385e65d0e$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    type: {
        id: "search-page.filters.names.type",
        defaultMessage: "Type"
    },
    filterTypePlaceholder: {
        id: "search-page.filter.type.placeholder",
        defaultMessage: "Find type"
    }
});
module.exports["i18n"] = $d476884385e65d0e$export$a7357cdd1f0b0168;

});

parcelRegister("iwoTl", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $885181c38aab6da0$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    verified: {
        id: "search-page.filters.names.verified",
        defaultMessage: "Verified"
    }
});
module.exports["i18n"] = $885181c38aab6da0$export$a7357cdd1f0b0168;

});

parcelRegister("hK6k5", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $1a47a81a1360c09a$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    watchedByMe: {
        id: "search-page.filters.names.work-watching",
        defaultMessage: "Work I\u2019m watching"
    }
});
module.exports["i18n"] = $1a47a81a1360c09a$export$a7357cdd1f0b0168;

});

parcelRegister("dUX05", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $a08e0836402bc1d4$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    label: {
        id: "search-page-relay.filters.product-filters.workspace-name.label",
        defaultMessage: "Team"
    },
    placeholder: {
        id: "search-page-relay.filters.product-filters.workspace-name.placeholder",
        defaultMessage: "Filter by team"
    },
    selectedLabel: {
        id: "search-page-relay.filters.product-filters.workspace-name.selected-label",
        defaultMessage: "Selected"
    },
    suggestedLabel: {
        id: "search-page-relay.filters.product-filters.workspace-name.suggested-label",
        defaultMessage: "Teams"
    }
});
module.exports["i18n"] = $a08e0836402bc1d4$export$a7357cdd1f0b0168;

});

parcelRegister("cJ4TJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $2W0qg = parcelRequire("2W0qg");

var $ecnYn = parcelRequire("ecnYn");

const $a28365e4b08c6c91$var$itemStyles = (0, $ecnYn.xcss)({
    cursor: 'default',
    width: '100%',
    textAlign: 'left',
    borderLeftWidth: 'border.width.selected',
    borderLeftStyle: 'solid',
    borderColor: 'color.border.inverse',
    backgroundColor: 'color.background.neutral.subtle',
    ':hover': {
        borderColor: 'color.border.selected',
        backgroundColor: 'color.background.neutral.subtle.hovered'
    }
});
const $a28365e4b08c6c91$var$insideItemStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.negative.025',
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $a28365e4b08c6c91$var$itemHoveredStyles = (0, $ecnYn.xcss)({
    borderColor: 'color.border.selected',
    backgroundColor: 'color.background.neutral.subtle.hovered'
});
const $a28365e4b08c6c91$var$itemSelectedStyles = (0, $ecnYn.xcss)({
    borderColor: 'color.border.selected',
    backgroundColor: 'color.background.selected'
});
const $a28365e4b08c6c91$var$DateOption = ({ option: option, hovered: hovered, onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
        role: "menuitem",
        xcss: [
            $a28365e4b08c6c91$var$itemStyles,
            option.isSelected && $a28365e4b08c6c91$var$itemSelectedStyles,
            hovered && $a28365e4b08c6c91$var$itemHoveredStyles
        ],
        key: option.label,
        onClick: onClick,
        paddingInline: "space.150",
        paddingBlock: "space.075",
        tabIndex: -1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $a28365e4b08c6c91$var$insideItemStyles
    }, option.label));
var $a28365e4b08c6c91$export$2e2bcd8739ae039 = $a28365e4b08c6c91$var$DateOption;
module.exports["default"] = $a28365e4b08c6c91$export$2e2bcd8739ae039;

});

parcelRegister("deQ0D", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $b3781e667aa8f1e4$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    closeDateFilterLabel: {
        id: "search-page.close-date-filter.label",
        defaultMessage: "Close date"
    },
    closeDateFilterUpdateButton: {
        id: "search-page.close-date-filter.update-button",
        defaultMessage: "Apply"
    },
    closeDateFilterDateLabel: {
        id: "search-page.close-date-filter.date-label",
        defaultMessage: "Select date"
    },
    closeDateFilterDatePlaceholder: {
        id: "search-page.close-date-filter.date-placeholder",
        defaultMessage: "Select a date"
    }
});
module.exports["i18n"] = $b3781e667aa8f1e4$export$a7357cdd1f0b0168;

});

parcelRegister("kiOcc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");


var $c4Cbx = parcelRequire("c4Cbx");


var $a3fRD = parcelRequire("a3fRD");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $dOOW1 = parcelRequire("dOOW1");


var $kmrEb = parcelRequire("kmrEb");

const $2ff09c563d04787a$export$1dc6c6b3e4774b92 = {
    [(0, $dOOW1.DateRangeError).FROM_AFTER_TO_ERROR]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $kmrEb.i18n).dateFilterCustomInvalidDateAfterEnd),
    [(0, $dOOW1.DateRangeError).FROM_IN_FUTURE_ERROR]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $kmrEb.i18n).dateFilterCustomInvalidDateAfterToday),
    [(0, $dOOW1.DateRangeError).TO_IN_FUTURE_ERROR]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $kmrEb.i18n).dateFilterCustomInvalidToDateAfterToday)
};
const $2ff09c563d04787a$var$datePickerWrapper = (0, $ecnYn.xcss)({
    width: '155px'
});
const $2ff09c563d04787a$var$DateRangePicker = ({ onCustomDateRangeChange: onCustomDateRangeChange, customDateRange: customDateRange, testId: testId })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $aXWIB.useIntl)();
    const [selectedFromDate, setSelectedFromDate] = (0, $42omo.useState)(customDateRange.from);
    const [selectedToDate, setSelectedToDate] = (0, $42omo.useState)(customDateRange.to);
    const invalidDateRange = (0, $dOOW1.getInvalidDateRange)(selectedFromDate, selectedToDate);
    const handleUpdateSelectedDates = ()=>{
        if (Boolean(invalidDateRange)) return;
        onCustomDateRangeChange(selectedFromDate, selectedToDate);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        paddingInline: "space.150",
        paddingBlock: "space.075",
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignInline: "start",
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $2ff09c563d04787a$var$datePickerWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4Cbx.default), {
        onChange: (date)=>setSelectedFromDate(date),
        defaultValue: selectedFromDate,
        placeholder: formatMessage((0, $kmrEb.i18n).dateFilterFromTitle),
        isInvalid: Boolean(invalidDateRange),
        locale: locale,
        label: formatMessage((0, $kmrEb.i18n).dateFilterFromLabel),
        shouldShowCalendarButton: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, formatMessage((0, $kmrEb.i18n).dateFilterToRange)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $2ff09c563d04787a$var$datePickerWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4Cbx.default), {
        onChange: (date)=>setSelectedToDate(date),
        defaultValue: selectedToDate,
        placeholder: formatMessage((0, $kmrEb.i18n).dateFilterToTitle),
        isInvalid: invalidDateRange === (0, $dOOW1.DateRangeError).FROM_AFTER_TO_ERROR,
        locale: locale,
        label: formatMessage((0, $kmrEb.i18n).dateFilterToLabel),
        shouldShowCalendarButton: true
    }))), invalidDateRange ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        paddingBlock: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "Date range error"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        color: "color.text.danger"
    }, $2ff09c563d04787a$export$1dc6c6b3e4774b92[invalidDateRange]))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        isDisabled: Boolean(invalidDateRange),
        onClick: handleUpdateSelectedDates
    }, formatMessage((0, $kmrEb.i18n).dateFilterUpdateButton)))));
};
var $2ff09c563d04787a$export$2e2bcd8739ae039 = $2ff09c563d04787a$var$DateRangePicker;
module.exports["default"] = $2ff09c563d04787a$export$2e2bcd8739ae039;

});

parcelRegister("kmrEb", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $bb7b46309e681bed$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    dateFilterTitle: {
        id: "date.filter.title",
        defaultMessage: "Last updated"
    },
    dateFilterFromTitle: {
        id: "date.filter.from.title",
        defaultMessage: "From"
    },
    dateFilterFromLabel: {
        id: "date.filter.from.label",
        defaultMessage: "Choose start date to filter"
    },
    dateFilterToTitle: {
        id: "date.filter.to.title",
        defaultMessage: "To"
    },
    dateFilterToLabel: {
        id: "date.filter.to.label",
        defaultMessage: "Choose end date to filter"
    },
    dateFilterDateInputPlaceholder: {
        id: "date.filter.input.placeholder",
        defaultMessage: "Choose a date"
    },
    dateFilterAnyTime: {
        id: "date.filter.any.time",
        defaultMessage: "Anytime"
    },
    dateFilterToday: {
        id: "date.filter.today",
        defaultMessage: "Today"
    },
    dateFilterYesterday: {
        id: "date.filter.yesterday",
        defaultMessage: "Yesterday"
    },
    dateFilterLastWeek: {
        id: "date.filter.last.week",
        defaultMessage: "Past 7 days"
    },
    dateFilterLastMonth: {
        id: "date.filter.last.month",
        defaultMessage: "Past 30 days"
    },
    dateFilterLastYear: {
        id: "date.filter.last.year",
        defaultMessage: "Past year"
    },
    dateFilterCustom: {
        id: "date.filter.custom",
        defaultMessage: "Custom"
    },
    dateFilterCustomInvalidDateAfterToday: {
        id: "date.filter.custom.invalid.after.today",
        defaultMessage: "The From date can\u2019t be in the future"
    },
    dateFilterCustomInvalidToDateAfterToday: {
        id: "date.filter.custom.invalid.to.after.today",
        defaultMessage: "The To date can\u2019t be in the future"
    },
    dateFilterCustomInvalidDateAfterEnd: {
        id: "date.filter.custom.invalid.after.end",
        defaultMessage: "The From date has to be before the To date"
    },
    dateFilterToRange: {
        id: "date.filter.to.range",
        defaultMessage: "to"
    },
    dateFilterUpdateButton: {
        id: "date.filter.update.button",
        defaultMessage: "Update"
    },
    dateFilterBeforeLabel: {
        id: "date.filter.before.label",
        defaultMessage: "before"
    },
    dateFilterAfterLabel: {
        id: "date.filter.after.label",
        defaultMessage: "after"
    }
});
module.exports["i18n"] = $bb7b46309e681bed$export$a7357cdd1f0b0168;

});


//# sourceMappingURL=QuickFind.c6b51876.js.map
